// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-docs.js

import React from 'react';
import { highlightCode } from '../utils/syntaxHighlight';

export const stdlibCategories = [
  "Bass",
  "Bells",
  "Brass",
  "Cinematic",
  "Drums",
  "Effects",
  "Fx",
  "Keys",
  "Leads",
  "Modern",
  "Modular",
  "Orchestral",
  "Pads",
  "Retro",
  "Strings",
  "Synths",
  "Textures",
  "Utility",
  "Vocals",
  "Woodwinds",
  "World"
];

export const stdlibData = {
  "Bass": {
    "subcategories": {
      "Acid": [
        {
          "name": "acid_303_classic",
          "description": "Genre: Acid House, Techno | Character: Classic 303 with resonant filter sweep",
          "genre": "Acid House, Techno",
          "character": "Classic 303 with resonant filter sweep",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            },
            {
              "name": "cutoff",
              "default": 1200
            },
            {
              "name": "res",
              "default": 0.7
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"acid_303_classic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 1200.0)\n        .param(\"res\", 0.7)\n        .body(|freq, amp, gate, cutoff, res| {\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope for sweep (triggered on note-on)\n            let filter_env = envelope()\n                .perc(0.01, 0.4)\n                .build();\n\n            // Sawtooth oscillator\n            let osc = saw_ar(freq);\n\n            // Resonant filter with envelope modulation\n            let mod_cutoff = cutoff + (filter_env * cutoff * 4.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, res);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "acid",
          "path": "bass/acid/acid_303_classic.vibe"
        },
        {
          "name": "acid_aggressive",
          "description": "Genre: Hard Acid, Industrial | Character: Aggressive, fast sweep",
          "genre": "Hard Acid, Industrial",
          "character": "Aggressive, fast sweep",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"acid_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Sharp envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast, aggressive filter sweep\n            let filter_env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Wide, fast sweep with high resonance\n            let mod_cutoff = 300.0 + (filter_env * 4000.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.1);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "acid",
          "path": "bass/acid/acid_aggressive.vibe"
        },
        {
          "name": "acid_bubbly",
          "description": "Genre: Acid House | Character: Bubbly, playful resonance",
          "genre": "Acid House",
          "character": "Bubbly, playful resonance",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"acid_bubbly\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Bouncy envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Quick filter sweep for bubbles\n            let filter_env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Pulse wave for different timbre\n            let osc = saw_ar(freq);\n\n            // High, narrow filter sweep\n            let mod_cutoff = 1200.0 + (filter_env * 3000.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "acid",
          "path": "bass/acid/acid_bubbly.vibe"
        },
        {
          "name": "acid_detuned",
          "description": "Genre: Acid House, Techno | Character: Detuned oscillators for thickness",
          "genre": "Acid House, Techno",
          "character": "Detuned oscillators for thickness",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"acid_detuned\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Detuned sawtooths\n            let osc1 = saw_ar(freq * 0.997);\n            let osc2 = saw_ar(freq * 1.003);\n            let mix = (osc1 + osc2) * 0.5;\n\n            // Filter sweep\n            let mod_cutoff = 900.0 + (filter_env * 2500.0);\n            let filtered = rlpf_ar(mix, mod_cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "acid",
          "path": "bass/acid/acid_detuned.vibe"
        },
        {
          "name": "acid_distorted",
          "description": "Genre: Industrial, Hard Techno | Character: Distorted, aggressive acid",
          "genre": "Industrial, Hard Techno",
          "character": "Distorted, aggressive acid",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"acid_distorted\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Sawtooth with extra gain\n            let osc = saw_ar(freq) * 2.5;\n\n            // Clip for distortion\n            let distorted = clip(osc, -0.9, 0.9);\n\n            // Resonant filter\n            let mod_cutoff = 600.0 + (filter_env * 2000.0);\n            let filtered = rlpf_ar(distorted, mod_cutoff, 0.2);\n\n            filtered * env * amp * 0.5\n        })\n});",
          "category": "bass",
          "subcategory": "acid",
          "path": "bass/acid/acid_distorted.vibe"
        },
        {
          "name": "acid_filtered_square",
          "description": "Genre: Acid Techno | Character: Square wave with resonant filter",
          "genre": "Acid Techno",
          "character": "Square wave with resonant filter",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"acid_filtered_square\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.006, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.012, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Square wave (pulse with 0.5 width)\n            let osc = saw_ar(freq);\n\n            // Filter sweep\n            let mod_cutoff = 600.0 + (filter_env * 2000.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "acid",
          "path": "bass/acid/acid_filtered_square.vibe"
        },
        {
          "name": "acid_minimal",
          "description": "Genre: Minimal Techno | Character: Subtle, minimal filter movement",
          "genre": "Minimal Techno",
          "character": "Subtle, minimal filter movement",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"acid_minimal\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Clean envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Gentle filter envelope\n            let filter_env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Subtle filter movement\n            let mod_cutoff = 800.0 + (filter_env * 1200.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.5);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "acid",
          "path": "bass/acid/acid_minimal.vibe"
        },
        {
          "name": "acid_modulated",
          "description": "Genre: Techno, Experimental | Character: Frequency modulated acid",
          "genre": "Techno, Experimental",
          "character": "Frequency modulated acid",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"acid_modulated\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Pitch modulation envelope\n            let pitch_env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let pitch_mod = pitch_env * freq * 0.5;\n\n            // Modulated sawtooth\n            let osc = saw_ar(freq + pitch_mod);\n\n            // Filter sweep\n            let mod_cutoff = 700.0 + (filter_env * 2200.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "acid",
          "path": "bass/acid/acid_modulated.vibe"
        },
        {
          "name": "acid_resonant_sweep",
          "description": "Genre: Acid Techno | Character: Extreme resonance sweep",
          "genre": "Acid Techno",
          "character": "Extreme resonance sweep",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"acid_resonant_sweep\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.004, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope with extended range\n            let filter_env = envelope()\n                .asr(0.006, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Extreme resonance sweep\n            let mod_cutoff = 250.0 + (filter_env * 5000.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.08);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "acid",
          "path": "bass/acid/acid_resonant_sweep.vibe"
        },
        {
          "name": "acid_squelchy",
          "description": "Genre: Acid Techno | Character: Squelchy, high resonance",
          "genre": "Acid Techno",
          "character": "Squelchy, high resonance",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"acid_squelchy\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sharp filter envelope\n            let filter_env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // High resonance for squelch\n            let mod_cutoff = 400.0 + (filter_env * 2500.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.15);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "acid",
          "path": "bass/acid/acid_squelchy.vibe"
        }
      ],
      "Acoustic": [
        {
          "name": "bass_fingered",
          "description": "Fingerstyle electric bass",
          "genre": "Rock, Pop, R&B",
          "character": "Fingerstyle electric bass",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Rock, Pop, R&B | Character: Fingerstyle electric bass\ndefine_synthdef(\"bass_fingered\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Natural envelope\n        let env = envelope()\n            .asr(0.008, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Warm body\n        let body = sin_osc_ar(freq) * 0.5;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.22;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.1;\n\n        // Finger attack\n        let finger = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 1800.0, 0.5) * finger * 0.18;\n\n        let sig = body + harm1 + harm2 + attack;\n        lpf_ar(sig, 3500.0) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "acoustic",
          "path": "bass/acoustic/bass_fingered.vibe"
        },
        {
          "name": "bass_fretless",
          "description": "Fretless electric bass with smooth slides",
          "genre": "Jazz, Fusion, R&B",
          "character": "Fretless electric bass with smooth slides",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Jazz, Fusion, R&B | Character: Fretless electric bass with smooth slides\ndefine_synthdef(\"bass_fretless\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Smooth envelope\n        let env = envelope()\n            .asr(0.02, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Subtle vibrato\n        let vib = sin_osc_ar(5.0) * freq * 0.008;\n\n        // Warm, mwah-y tone\n        let body = sin_osc_ar(freq + vib) * 0.45;\n        let harm1 = sin_osc_ar((freq + vib) * 2.0) * 0.28;\n        let harm2 = sin_osc_ar((freq + vib) * 3.0) * 0.15;\n        let harm3 = sin_osc_ar((freq + vib) * 4.0) * 0.08;\n\n        // Mwah characteristic (filter sweep on attack)\n        let mwah = envelope()\n            .perc(0.01, 0.2)\n            .build();\n        let cutoff = 800.0 + mwah * 2000.0;\n\n        let sig = body + harm1 + harm2 + harm3;\n        lpf_ar(sig, cutoff) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "acoustic",
          "path": "bass/acoustic/bass_fretless.vibe"
        },
        {
          "name": "bass_muted",
          "description": "Palm-muted bass with short, controlled notes",
          "genre": "Funk, R&B, Pop",
          "character": "Palm-muted bass with short, controlled notes",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Funk, R&B, Pop | Character: Palm-muted bass with short, controlled notes\ndefine_synthdef(\"bass_muted\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.75)\n    .body(|freq, amp| {\n        // Very short decay\n        let amp_env = envelope()\n            .perc(0.002, 0.12)\n            .cleanup_on_finish()\n            .build();\n\n        // Muted, darker tone\n        let body = sin_osc_ar(freq) * 0.6;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.15;\n\n        // Soft attack\n        let attack_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 1500.0) * attack_env * 0.15;\n\n        let sig = body + harm1 + attack;\n        lpf_ar(sig, 1500.0) * amp_env * amp\n    });\n",
          "category": "bass",
          "subcategory": "acoustic",
          "path": "bass/acoustic/bass_muted.vibe"
        },
        {
          "name": "bass_picked",
          "description": "Picked electric bass with bright attack",
          "genre": "Rock, Punk, Metal",
          "character": "Picked electric bass with bright attack",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Rock, Punk, Metal | Character: Picked electric bass with bright attack\ndefine_synthdef(\"bass_picked\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.85)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Envelope with quick attack\n        let env = envelope()\n            .asr(0.003, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Brighter harmonic content\n        let body = sin_osc_ar(freq) * 0.4;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.28;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.18;\n        let harm3 = sin_osc_ar(freq * 4.0) * 0.08;\n\n        // Pick attack - bright and defined\n        let pick = envelope()\n            .perc(0.0001, 0.015)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 3000.0) * pick * 0.25;\n\n        let sig = body + harm1 + harm2 + harm3 + attack;\n        lpf_ar(sig, 5000.0) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "acoustic",
          "path": "bass/acoustic/bass_picked.vibe"
        },
        {
          "name": "bass_slap",
          "description": "Slap bass with percussive attack",
          "genre": "Funk, Disco, R&B",
          "character": "Slap bass with percussive attack",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Funk, Disco, R&B | Character: Slap bass with percussive attack\ndefine_synthdef(\"bass_slap\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Punchy envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Body with harmonics\n        let body = sin_osc_ar(freq) * 0.4;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.25;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.15;\n        let harm3 = sin_osc_ar(freq * 4.0) * 0.1;\n\n        // Slap transient - very prominent\n        let slap_env = envelope()\n            .perc(0.0001, 0.02)\n            .build();\n        let slap = bpf_ar(white_noise_ar(), 2500.0, 0.3) * slap_env * 0.5;\n\n        // String pop\n        let pop_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let pop = hpf_ar(white_noise_ar(), 4000.0) * pop_env * 0.3;\n\n        let sig = body + harm1 + harm2 + harm3 + slap + pop;\n        sig * amp_env * amp\n    });\n",
          "category": "bass",
          "subcategory": "acoustic",
          "path": "bass/acoustic/bass_slap.vibe"
        },
        {
          "name": "bass_upright",
          "description": "Double bass/upright bass plucked",
          "genre": "Jazz, Classical, Acoustic",
          "character": "Double bass/upright bass plucked",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Jazz, Classical, Acoustic | Character: Double bass/upright bass plucked\ndefine_synthdef(\"bass_upright\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Gate-controlled ASR envelope\n        let env = envelope()\n            .asr(0.01, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Main body with warm harmonics\n        let body = sin_osc_ar(freq) * 0.5;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.25;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.12;\n        let harm3 = sin_osc_ar(freq * 4.0) * 0.06;\n\n        // Pluck attack\n        let pluck = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 1500.0, 0.4) * pluck * 0.2;\n\n        // String buzz\n        let buzz = bpf_ar(pink_noise_ar(), freq * 5.0, 0.8) * 0.05;\n\n        let sig = body + harm1 + harm2 + harm3 + attack + buzz;\n        lpf_ar(sig, 3000.0) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "acoustic",
          "path": "bass/acoustic/bass_upright.vibe"
        },
        {
          "name": "bass_upright_arco",
          "description": "Bowed upright bass",
          "genre": "Classical, Orchestral",
          "character": "Bowed upright bass",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Classical, Orchestral | Character: Bowed upright bass\ndefine_synthdef(\"bass_upright_arco\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.7)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Slow attack for bowing\n        let env = envelope()\n            .asr(0.15, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bow pressure modulation\n        let bow_lfo = sin_osc_ar(4.5) * 0.02 + 1.0;\n\n        // Rich harmonic content from bowing\n        let body = sin_osc_ar(freq * bow_lfo) * 0.4;\n        let harm1 = sin_osc_ar(freq * 2.0 * bow_lfo) * 0.25;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.15;\n        let harm3 = sin_osc_ar(freq * 4.0) * 0.08;\n        let harm4 = sin_osc_ar(freq * 5.0) * 0.04;\n\n        // Bow noise\n        let bow_noise = bpf_ar(pink_noise_ar(), 2000.0, 0.5) * 0.08;\n\n        let sig = body + harm1 + harm2 + harm3 + harm4 + bow_noise;\n        lpf_ar(sig, 4000.0) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "acoustic",
          "path": "bass/acoustic/bass_upright_arco.vibe"
        },
        {
          "name": "bass_upright_pizz",
          "description": "Pizzicato upright bass",
          "genre": "Jazz, Classical",
          "character": "Pizzicato upright bass",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Jazz, Classical | Character: Pizzicato upright bass\ndefine_synthdef(\"bass_upright_pizz\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Pizzicato envelope - short decay\n        let amp_env = envelope()\n            .perc(0.005, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Warm body\n        let body = sin_osc_ar(freq) * 0.55;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.22;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.1;\n\n        // Finger pluck attack\n        let pluck_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let pluck = bpf_ar(white_noise_ar(), 1200.0, 0.5) * pluck_env * 0.25;\n\n        let sig = body + harm1 + harm2 + pluck;\n        lpf_ar(sig, 2500.0) * amp_env * amp\n    });\n",
          "category": "bass",
          "subcategory": "acoustic",
          "path": "bass/acoustic/bass_upright_pizz.vibe"
        }
      ],
      "Fm": [
        {
          "name": "fm_bass_aggressive",
          "description": "Genre: Neurofunk, Techno | Character: Aggressive FM bass with high modulation",
          "genre": "Neurofunk, Techno",
          "character": "Aggressive FM bass with high modulation",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "fm_amount",
              "default": 5
            },
            {
              "name": "amp",
              "default": 0.65
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"fm_bass_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"fm_amount\", 5.0)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .body(|freq, fm_amount, amp, gate| {\n\n            // Punchy envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Aggressive FM envelope\n            let fm_env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // High FM amount for aggression\n            let modulator = sin_osc_ar(freq * 2.0) * fm_env * freq * fm_amount;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Clip for extra aggression\n            let driven = clip(carrier, -0.9, 0.9);\n\n            driven * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "fm",
          "path": "bass/fm/fm_bass_aggressive.vibe"
        },
        {
          "name": "fm_bass_classic",
          "description": "Genre: Electro, Synthwave | Character: Classic FM bass with complex harmonics",
          "genre": "Electro, Synthwave",
          "character": "Classic FM bass with complex harmonics",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "fm_amount",
              "default": 2.5
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"fm_bass_classic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"fm_amount\", 2.5)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, fm_amount, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM envelope\n            let fm_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // FM modulator\n            let modulator = sin_osc_ar(freq * 1.5) * fm_env * freq * fm_amount;\n\n            // Carrier\n            let carrier = sin_osc_ar(freq + modulator);\n\n            carrier * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "fm",
          "path": "bass/fm/fm_bass_classic.vibe"
        },
        {
          "name": "fm_bass_deep",
          "description": "Genre: Dubstep, Bass Music | Character: Deep FM bass with sub presence",
          "genre": "Dubstep, Bass Music",
          "character": "Deep FM bass with sub presence",
          "params": [
            {
              "name": "freq",
              "default": 75
            },
            {
              "name": "fm_amount",
              "default": 3
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"fm_bass_deep\", |builder| {\n    builder\n        .param(\"freq\", 75.0)\n        .param(\"fm_amount\", 3.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, fm_amount, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM envelope\n            let fm_env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // FM with sub ratio\n            let modulator = sin_osc_ar(freq * 0.5) * fm_env * freq * fm_amount;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Add clean sub\n            let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n            (carrier + sub) * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "fm",
          "path": "bass/fm/fm_bass_deep.vibe"
        },
        {
          "name": "fm_bass_evolving",
          "description": "Genre: Techno, Experimental | Character: Evolving FM bass with changing timbre",
          "genre": "Techno, Experimental",
          "character": "Evolving FM bass with changing timbre",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "fm_amount",
              "default": 3.5
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"fm_bass_evolving\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"fm_amount\", 3.5)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, fm_amount, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.012, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Long FM envelope for evolution\n            let fm_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // FM synthesis\n            let modulator = sin_osc_ar(freq * 1.7) * fm_env * freq * fm_amount;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Filter envelope for additional movement\n            let filter_env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 400.0 + (filter_env * 1800.0);\n\n            let filtered = lpf_ar(carrier, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "fm",
          "path": "bass/fm/fm_bass_evolving.vibe"
        },
        {
          "name": "fm_bass_metallic",
          "description": "Genre: IDM, Experimental | Character: Metallic, inharmonic FM bass",
          "genre": "IDM, Experimental",
          "character": "Metallic, inharmonic FM bass",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "fm_amount",
              "default": 4
            },
            {
              "name": "amp",
              "default": 0.65
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"fm_bass_metallic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"fm_amount\", 4.0)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .body(|freq, fm_amount, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM envelope\n            let fm_env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Inharmonic ratio for metallic character\n            let modulator = sin_osc_ar(freq * 2.3) * fm_env * freq * fm_amount;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            carrier * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "fm",
          "path": "bass/fm/fm_bass_metallic.vibe"
        }
      ],
      "Genre": [
        {
          "name": "bass_afrobeat",
          "description": "Groovy afrobeat bass - warm and rhythmic",
          "genre": "Afrobeat, Afrobeats",
          "character": "Groovy afrobeat bass - warm and rhythmic",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Afrobeat, Afrobeats | Character: Groovy afrobeat bass - warm and rhythmic\ndefine_synthdef(\"bass_afrobeat\")\n    .param(\"freq\", 65.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Warm, organic tone\n        let body = sin_osc_ar(freq) * 0.5;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.2;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.08;\n\n        // Subtle attack\n        let attack = envelope()\n            .perc(0.005, 0.03)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 1500.0, 0.5) * attack * 0.12;\n\n        let sig = body + harm1 + harm2 + click;\n\n        lpf_ar(sig, 2500.0) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_afrobeat.vibe"
        },
        {
          "name": "bass_disco",
          "description": "Octave-jumping disco bass",
          "genre": "Disco, Nu-Disco",
          "character": "Octave-jumping disco bass",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Disco, Nu-Disco | Character: Octave-jumping disco bass\ndefine_synthdef(\"bass_disco\")\n    .param(\"freq\", 70.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.003, 1.0, 0.06)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Body with octave\n        let body = sin_osc_ar(freq) * 0.5;\n        let octave = sin_osc_ar(freq * 2.0) * 0.3;\n        let harm = sin_osc_ar(freq * 3.0) * 0.1;\n\n        // Quick attack\n        let attack = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let click = hpf_ar(white_noise_ar(), 3000.0) * attack * 0.15;\n\n        let sig = body + octave + harm + click;\n\n        lpf_ar(sig, 4000.0) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_disco.vibe"
        },
        {
          "name": "bass_drill",
          "description": "Sliding drill bass with pitch glide",
          "genre": "Drill, UK Drill",
          "character": "Sliding drill bass with pitch glide",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Drill, UK Drill | Character: Sliding drill bass with pitch glide\ndefine_synthdef(\"bass_drill\")\n    .param(\"freq\", 45.0)\n    .param(\"amp\", 0.9)\n    .param(\"gate\", 1.0)\n    .param(\"slide\", 0.3)\n    .body(|freq, amp, gate, slide| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch glide characteristic of drill\n        let glide = envelope()\n            .perc(0.01, 0.3)\n            .build();\n        let pitch = freq * (1.0 + glide * slide);\n\n        // Deep sine bass\n        let body = sin_osc_ar(pitch) * 0.7;\n        let sub = sin_osc_ar(pitch * 0.5) * 0.25;\n\n        let sig = body + sub;\n\n        lpf_ar(sig, 500.0) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_drill.vibe"
        },
        {
          "name": "bass_formant",
          "description": "Vowel/formant bass with vocal quality",
          "genre": "Experimental, EDM",
          "character": "Vowel/formant bass with vocal quality",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Experimental, EDM | Character: Vowel/formant bass with vocal quality\ndefine_synthdef(\"bass_formant\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.75)\n    .param(\"gate\", 1.0)\n    .param(\"vowel\", 0.5)\n    .body(|freq, amp, gate, vowel| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Rich harmonic source\n        let osc = saw_ar(freq) * 0.5;\n\n        // Formant frequencies (morphing between vowels)\n        let f1 = 300.0 + vowel * 500.0;  // First formant\n        let f2 = 900.0 + vowel * 1200.0; // Second formant\n\n        // Resonant bandpass filters for formants\n        let form1 = bpf_ar(osc, f1, 0.15) * 0.5;\n        let form2 = bpf_ar(osc, f2, 0.2) * 0.3;\n\n        // Sub foundation\n        let sub = sin_osc_ar(freq) * 0.4;\n\n        let sig = form1 + form2 + sub;\n\n        sig * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_formant.vibe"
        },
        {
          "name": "bass_funk",
          "description": "Funky bass with bright attack and groove",
          "genre": "Funk, Disco",
          "character": "Funky bass with bright attack and groove",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Funk, Disco | Character: Funky bass with bright attack and groove\ndefine_synthdef(\"bass_funk\")\n    .param(\"freq\", 70.0)\n    .param(\"amp\", 0.85)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope for funky attack\n        let filt_env = envelope()\n            .perc(0.005, 0.15)\n            .build();\n\n        // Punchy body with harmonics\n        let body = sin_osc_ar(freq) * 0.45;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.25;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.12;\n\n        // Attack pop\n        let pop = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 2000.0, 0.4) * pop * 0.2;\n\n        let sig = body + harm1 + harm2 + attack;\n\n        // Dynamic filter\n        let cutoff = 1000.0 + filt_env * 2500.0;\n        lpf_ar(sig, cutoff) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_funk.vibe"
        },
        {
          "name": "bass_garage",
          "description": "UK garage bass - bouncy and warm",
          "genre": "UK Garage, 2-Step",
          "character": "UK garage bass - bouncy and warm",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: UK Garage, 2-Step | Character: UK garage bass - bouncy and warm\ndefine_synthdef(\"bass_garage\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.008, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.008, 0.2)\n            .build();\n\n        // Warm sine with harmonics\n        let body = sin_osc_ar(freq) * 0.5;\n        let sub = sin_osc_ar(freq * 0.5) * 0.25;\n        let harm = sin_osc_ar(freq * 2.0) * 0.15;\n\n        let mix = body + sub + harm;\n\n        // Bouncy filter\n        let cutoff = 600.0 + filt_env * 1500.0;\n        lpf_ar(mix, cutoff) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_garage.vibe"
        },
        {
          "name": "bass_house",
          "description": "Deep house bass - warm and rolling",
          "genre": "House, Deep House",
          "character": "Deep house bass - warm and rolling",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: House, Deep House | Character: Deep house bass - warm and rolling\ndefine_synthdef(\"bass_house\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.85)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.01, 0.25)\n            .build();\n\n        // Warm saw with sub\n        let osc = saw_ar(freq) * 0.4;\n        let sub = sin_osc_ar(freq * 0.5) * 0.35;\n\n        let mix = osc + sub;\n\n        // Warm, rolling filter\n        let cutoff = 500.0 + filt_env * 1200.0;\n        rlpf_ar(mix, cutoff, 0.2) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_house.vibe"
        },
        {
          "name": "bass_karplus",
          "description": "Karplus-Strong plucked bass",
          "genre": "Experimental, IDM",
          "character": "Karplus-Strong plucked bass",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Experimental, IDM | Character: Karplus-Strong plucked bass\ndefine_synthdef(\"bass_karplus\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .param(\"decay\", 0.5)\n    .body(|freq, amp, decay| {\n        // Karplus-Strong style using comb filter\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay * 2.0)\n            .cleanup_on_finish()\n            .build();\n\n        // Excitation noise burst\n        let excite = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let noise = white_noise_ar() * excite;\n\n        // Delay time for pitch\n        let delay_time = 1.0 / freq;\n\n        // Comb filter with feedback for string-like resonance\n        let resonated = comb_c_ar(noise, 0.05, delay_time, decay * 3.0);\n\n        // Low pass for warmth\n        lpf_ar(resonated, 2000.0) * amp_env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_karplus.vibe"
        },
        {
          "name": "bass_phonk",
          "description": "Distorted phonk bass - gritty and heavy",
          "genre": "Phonk, Memphis Rap",
          "character": "Distorted phonk bass - gritty and heavy",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Phonk, Memphis Rap | Character: Distorted phonk bass - gritty and heavy\ndefine_synthdef(\"bass_phonk\")\n    .param(\"freq\", 45.0)\n    .param(\"amp\", 0.9)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Heavy, distorted bass\n        let body = sin_osc_ar(freq) * 0.6;\n        let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n        // Add grit\n        let gritty = (body * 2.0).tanh();\n\n        let sig = (gritty + sub) * 0.6;\n\n        lpf_ar(sig, 600.0) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_phonk.vibe"
        },
        {
          "name": "bass_reggae",
          "description": "Deep reggae bass with round tone",
          "genre": "Reggae, Dub",
          "character": "Deep reggae bass with round tone",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Reggae, Dub | Character: Deep reggae bass with round tone\ndefine_synthdef(\"bass_reggae\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.85)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.02, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Deep, round tone\n        let body = sin_osc_ar(freq) * 0.6;\n        let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n        // Slight warmth from second harmonic\n        let warm = sin_osc_ar(freq * 2.0) * 0.08;\n\n        let sig = body + sub + warm;\n\n        // Very warm filtering\n        lpf_ar(sig, 800.0) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_reggae.vibe"
        },
        {
          "name": "bass_talking",
          "description": "Talk box-style bass with vocal modulation",
          "genre": "Funk, Experimental",
          "character": "Talk box-style bass with vocal modulation",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Funk, Experimental | Character: Talk box-style bass with vocal modulation\ndefine_synthdef(\"bass_talking\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.75)\n    .param(\"gate\", 1.0)\n    .param(\"talk\", 0.5)\n    .body(|freq, amp, gate, talk| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // LFO for \"talking\" modulation\n        let talk_lfo = sin_osc_ar(3.0 + talk * 4.0);\n\n        // Rich source\n        let osc = saw_ar(freq) * 0.5;\n\n        // Modulated formants\n        let f1 = 400.0 + talk_lfo * 300.0;\n        let f2 = 1200.0 + talk_lfo * 600.0;\n\n        let form1 = bpf_ar(osc, f1, 0.12) * 0.5;\n        let form2 = bpf_ar(osc, f2, 0.15) * 0.3;\n\n        // Sub\n        let sub = sin_osc_ar(freq) * 0.35;\n\n        let sig = form1 + form2 + sub;\n\n        sig * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_talking.vibe"
        },
        {
          "name": "bass_techno",
          "description": "Driving techno bass - punchy and relentless",
          "genre": "Techno, Industrial",
          "character": "Driving techno bass - punchy and relentless",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Techno, Industrial | Character: Driving techno bass - punchy and relentless\ndefine_synthdef(\"bass_techno\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 0.9)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.002, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.002, 0.15)\n            .build();\n\n        // Aggressive saw\n        let osc = saw_ar(freq) * 0.5;\n        let sub = sin_osc_ar(freq) * 0.4;\n\n        let mix = osc + sub;\n\n        // Punchy filter\n        let cutoff = 300.0 + filt_env * 2000.0;\n        rlpf_ar(mix, cutoff, 0.35) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "genre",
          "path": "bass/genre/bass_techno.vibe"
        }
      ],
      "Pluck": [
        {
          "name": "bass_pluck_bell",
          "description": "Genre: Ambient, Experimental | Character: Bell-like pluck bass",
          "genre": "Ambient, Experimental",
          "character": "Bell-like pluck bass",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"bass_pluck_bell\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Medium-long envelope for bell character\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Inharmonic frequencies for bell timbre\n            let osc1 = sin_osc_ar(freq) * 0.5;\n            let osc2 = sin_osc_ar(freq * 2.3) * 0.25;\n            let osc3 = sin_osc_ar(freq * 3.7) * 0.15;\n            let osc4 = sin_osc_ar(freq * 5.1) * 0.1;\n\n            let mix = osc1 + osc2 + osc3 + osc4;\n\n            // Gentle filter\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "pluck",
          "path": "bass/pluck/pluck_bell.vibe"
        },
        {
          "name": "bass_pluck_bright",
          "description": "Genre: House, Funk | Character: Bright, cutting pluck",
          "genre": "House, Funk",
          "character": "Bright, cutting pluck",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"bass_pluck_bright\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Quick envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth with harmonics\n            let osc = saw_ar(freq);\n\n            // Wide filter sweep for brightness\n            let filter_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 3500.0);\n\n            let filtered = lpf_ar(osc, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "pluck",
          "path": "bass/pluck/pluck_bright.vibe"
        },
        {
          "name": "pluck_dark",
          "description": "Genre: Techno, Minimal | Character: Dark, muted pluck",
          "genre": "Techno, Minimal",
          "character": "Dark, muted pluck",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pluck_dark\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Medium envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sine for darker character\n            let osc = sin_osc_ar(freq);\n            let harmonic = sin_osc_ar(freq * 2.0) * 0.2;\n            let mix = osc + harmonic;\n\n            // Low filter for darkness\n            let filter_env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 300.0 + (filter_env * 800.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "pluck",
          "path": "bass/pluck/pluck_dark.vibe"
        },
        {
          "name": "pluck_elastic",
          "description": "Genre: Electro, Experimental | Character: Elastic, bouncy pluck",
          "genre": "Electro, Experimental",
          "character": "Elastic, bouncy pluck",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pluck_elastic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Bouncy envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope for elastic character\n            let pitch_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let pitch_mod = pitch_env * freq * 0.8;\n\n            // Sawtooth with pitch bend\n            let osc = saw_ar(freq + pitch_mod);\n\n            // Filter sweep\n            let filter_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 700.0 + (filter_env * 1800.0);\n\n            let filtered = lpf_ar(osc, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "pluck",
          "path": "bass/pluck/pluck_elastic.vibe"
        },
        {
          "name": "pluck_funky",
          "description": "Genre: Funk, Disco | Character: Funky, percussive pluck",
          "genre": "Funk, Disco",
          "character": "Funky, percussive pluck",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.75
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pluck_funky\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.75)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Use gate parameter to control note duration\n            let env = envelope()\n                .adsr(0.001, 0.05, 0.7, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth wave for funk character (pulse_ar not available)\n            let osc = saw_ar(freq);\n\n            // Snappy filter sweep\n            let filter_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 2000.0);\n\n            let filtered = lpf_ar(osc, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "pluck",
          "path": "bass/pluck/pluck_funky.vibe"
        },
        {
          "name": "bass_pluck_long",
          "description": "Genre: Dubstep, Bass Music | Character: Longer pluck with sustain",
          "genre": "Dubstep, Bass Music",
          "character": "Longer pluck with sustain",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"bass_pluck_long\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Medium decay\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Saw and pulse mix\n            let saw = saw_ar(freq) * 0.6;\n            let pulse = saw_ar(freq) * 0.4;\n            let mix = saw + pulse;\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 600.0 + (filter_env * 1800.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "pluck",
          "path": "bass/pluck/pluck_long.vibe"
        },
        {
          "name": "bass_pluck_muted",
          "description": "Genre: Lo-fi, Jazz | Character: Muted, soft pluck",
          "genre": "Lo-fi, Jazz",
          "character": "Muted, soft pluck",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"bass_pluck_muted\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Soft envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sine and triangle mix\n            let sine = sin_osc_ar(freq) * 0.7;\n            let triangle = (sin_osc_ar(freq) + sin_osc_ar(freq * 3.0) * 0.111) * 0.3;\n            let mix = sine + triangle;\n\n            // Very low filter\n            let filtered = lpf_ar(mix, 500.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "pluck",
          "path": "bass/pluck/pluck_muted.vibe"
        },
        {
          "name": "pluck_percussive",
          "description": "Genre: Techno, Electro | Character: Very percussive, attack-heavy",
          "genre": "Techno, Electro",
          "character": "Very percussive, attack-heavy",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pluck_percussive\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very short, percussive envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.0005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Very fast filter attack\n            let filter_env = envelope()\n                .asr(0.0005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1200.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(osc, mod_cutoff);\n\n            // Add click for percussive attack\n            let click_env = envelope()\n                .asr(0.0001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let click = white_noise_ar() * click_env * 0.15;\n            let filtered_click = lpf_ar(click, 2000.0);\n\n            (filtered + filtered_click) * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "pluck",
          "path": "bass/pluck/pluck_percussive.vibe"
        },
        {
          "name": "bass_pluck_resonant",
          "description": "Genre: Techno, House | Character: Resonant pluck with filter ring",
          "genre": "Techno, House",
          "character": "Resonant pluck with filter ring",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"bass_pluck_resonant\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Medium envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Resonant filter with sweep\n            let filter_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 2000.0);\n\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.2);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "pluck",
          "path": "bass/pluck/pluck_resonant.vibe"
        },
        {
          "name": "bass_pluck_short",
          "description": "Genre: House, Techno | Character: Short, tight pluck bass",
          "genre": "House, Techno",
          "character": "Short, tight pluck bass",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"bass_pluck_short\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very short envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth for brightness\n            let osc = saw_ar(freq);\n\n            // Quick filter envelope\n            let filter_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 2000.0);\n\n            let filtered = lpf_ar(osc, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "pluck",
          "path": "bass/pluck/pluck_short.vibe"
        }
      ],
      "Reese": [
        {
          "name": "reese_aggressive",
          "description": "Genre: Neurofunk, Techstep | Character: Aggressive, gritty Reese",
          "genre": "Neurofunk, Techstep",
          "character": "Aggressive, gritty Reese",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.65
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"reese_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Punchy envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Wide detuning for aggression\n            let saw1 = saw_ar(freq * 0.975);\n            let saw2 = saw_ar(freq * 0.988);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.012);\n            let saw5 = saw_ar(freq * 1.025);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.25;\n\n            // Clip for distortion\n            let driven = clip(mix, -0.85, 0.85);\n\n            // Aggressive filter\n            let filter_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 2000.0);\n\n            let filtered = rlpf_ar(driven, mod_cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "reese",
          "path": "bass/reese/reese_aggressive.vibe"
        },
        {
          "name": "reese_classic",
          "description": "Genre: Drum & Bass, Jungle | Character: Classic Reese bass, thick and evolving",
          "genre": "Drum & Bass, Jungle",
          "character": "Classic Reese bass, thick and evolving",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"reese_classic\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned sawtooths for Reese character\n            let saw1 = saw_ar(freq * 0.985);\n            let saw2 = saw_ar(freq * 0.992);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.008);\n            let saw5 = saw_ar(freq * 1.015);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.2;\n\n            // Filter envelope for movement\n            let filter_env = envelope()\n                .perc(0.02, 0.8)\n                .build();\n            let mod_cutoff = 400.0 + (filter_env * 1200.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "reese",
          "path": "bass/reese/reese_classic.vibe"
        },
        {
          "name": "reese_deep",
          "description": "Genre: Drum & Bass, Dubstep | Character: Deep, sub-heavy Reese",
          "genre": "Drum & Bass, Dubstep",
          "character": "Deep, sub-heavy Reese",
          "params": [
            {
              "name": "freq",
              "default": 45
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"reese_deep\", |builder| {\n    builder\n        .param(\"freq\", 45.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws\n            let saw1 = saw_ar(freq * 0.980);\n            let saw2 = saw_ar(freq * 0.990);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.010);\n            let saw5 = saw_ar(freq * 1.020);\n\n            // Add sub octave for depth\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.16 + sub;\n\n            // Dark filtering\n            let filter_env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 300.0 + (filter_env * 900.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "reese",
          "path": "bass/reese/reese_deep.vibe"
        },
        {
          "name": "reese_distorted",
          "description": "Genre: Neurofunk, Darkstep | Character: Heavily distorted Reese",
          "genre": "Neurofunk, Darkstep",
          "character": "Heavily distorted Reese",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"reese_distorted\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Aggressive envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws\n            let saw1 = saw_ar(freq * 0.983);\n            let saw2 = saw_ar(freq * 0.993);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.007);\n            let saw5 = saw_ar(freq * 1.017);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.3;\n\n            // Heavy distortion\n            let driven = clip(mix, -0.7, 0.7);\n\n            // Filter with movement\n            let filter_env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 450.0 + (filter_env * 1700.0);\n\n            let filtered = rlpf_ar(driven, mod_cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "reese",
          "path": "bass/reese/reese_distorted.vibe"
        },
        {
          "name": "reese_evolving",
          "description": "Genre: Drum & Bass | Character: Evolving Reese with phase movement",
          "genre": "Drum & Bass",
          "character": "Evolving Reese with phase movement",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"reese_evolving\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Long envelope for evolution\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Wide detuning for movement\n            let saw1 = saw_ar(freq * 0.982);\n            let saw2 = saw_ar(freq * 0.991);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.009);\n            let saw5 = saw_ar(freq * 1.018);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.2;\n\n            // Evolving filter with resonance\n            let filter_env = envelope()\n                .asr(0.04, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 350.0 + (filter_env * 1800.0);\n\n            let filtered = rlpf_ar(mix, mod_cutoff, 0.5);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "reese",
          "path": "bass/reese/reese_evolving.vibe"
        },
        {
          "name": "reese_smooth",
          "description": "Genre: Liquid DnB, Ambient DnB | Character: Smooth, rolling Reese",
          "genre": "Liquid DnB, Ambient DnB",
          "character": "Smooth, rolling Reese",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"reese_smooth\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Smooth envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Subtle detuning for smoothness\n            let saw1 = saw_ar(freq * 0.992);\n            let saw2 = saw_ar(freq * 0.996);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.004);\n            let saw5 = saw_ar(freq * 1.008);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.2;\n\n            // Gentle filter sweep\n            let filter_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 1500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "reese",
          "path": "bass/reese/reese_smooth.vibe"
        }
      ],
      "Sub": [
        {
          "name": "sub_deep",
          "description": "Very deep, chest-hitting sub",
          "genre": "Dubstep, Bass Music",
          "character": "Very deep, chest-hitting sub",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Dubstep, Bass Music | Character: Very deep, chest-hitting sub\ndefine_synthdef(\"sub_deep\")\n    .param(\"freq\", 45.0)\n    .param(\"amp\", 0.9)\n        .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n\n        // Long envelope for sustained sub\n        // Gate-controlled ASR envelope for proper note-on/note-off behavior\n        let env = envelope()\n            .asr(0.015, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Main sub frequency\n        let sig = sin_osc_ar(freq);\n\n        // Sub-octave for extreme depth\n        let deep = sin_osc_ar(freq * 0.5) * 0.4;\n\n        (sig + deep) * env * amp\n    });\n\n",
          "category": "bass",
          "subcategory": "sub",
          "path": "bass/sub/sub_deep.vibe"
        },
        {
          "name": "sub_filtered",
          "description": "Genre: House, Techno | Character: Filtered sine with slight movement",
          "genre": "House, Techno",
          "character": "Filtered sine with slight movement",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "gate",
              "default": 1
            },
            {
              "name": "cutoff",
              "default": 300
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sub_filtered\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 300.0)\n        .body(|freq, amp, gate, cutoff| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sine with slight harmonic content\n            let sig = sin_osc_ar(freq);\n            let harmonic = sin_osc_ar(freq * 2.0) * 0.15;\n            let mix = sig + harmonic;\n\n            // Gentle low-pass filter\n            let filtered = lpf_ar(mix, cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "sub",
          "path": "bass/sub/sub_filtered.vibe"
        },
        {
          "name": "sub_harmonic",
          "description": "Genre: Techno, House | Character: Sub with rich harmonic series",
          "genre": "Techno, House",
          "character": "Sub with rich harmonic series",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sub_harmonic\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Build harmonic series\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.25;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.15;\n            let harmonic4 = sin_osc_ar(freq * 4.0) * 0.1;\n            let harmonic5 = sin_osc_ar(freq * 5.0) * 0.05;\n\n            let sig = fundamental + harmonic2 + harmonic3 + harmonic4 + harmonic5;\n\n            // Filter to control brightness\n            let filtered = lpf_ar(sig, 400.0);\n\n            filtered * env * amp * 0.7\n        })\n});",
          "category": "bass",
          "subcategory": "sub",
          "path": "bass/sub/sub_harmonic.vibe"
        },
        {
          "name": "sub_modulated",
          "description": "Genre: Techno, Minimal | Character: Phase-modulated sub with movement",
          "genre": "Techno, Minimal",
          "character": "Phase-modulated sub with movement",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sub_modulated\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Modulator for subtle phase modulation\n            let mod_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let modulator = sin_osc_ar(freq * 0.5) * mod_env * 0.3;\n\n            // Carrier with modulation\n            let carrier = sin_osc_ar(freq + modulator);\n\n            carrier * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "sub",
          "path": "bass/sub/sub_modulated.vibe"
        },
        {
          "name": "sub_mono",
          "description": "Genre: All | Character: Focused mono sub for club systems",
          "genre": "All",
          "character": "Focused mono sub for club systems",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sub_mono\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Clean envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pure sine, centered\n            let sig = sin_osc_ar(freq);\n\n            sig * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "sub",
          "path": "bass/sub/sub_mono.vibe"
        },
        {
          "name": "sub_octave",
          "description": "Genre: Dubstep, Drum & Bass | Character: Layered octaves for massive sub",
          "genre": "Dubstep, Drum & Bass",
          "character": "Layered octaves for massive sub",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sub_octave\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fundamental\n            let fundamental = sin_osc_ar(freq);\n\n            // Octave down for extra depth\n            let sub = sin_osc_ar(freq * 0.5) * 0.6;\n\n            // Octave up for harmonics\n            let harmonic = sin_osc_ar(freq * 2.0) * 0.2;\n\n            let sig = fundamental + sub + harmonic;\n\n            sig * env * amp * 0.7\n        })\n});",
          "category": "bass",
          "subcategory": "sub",
          "path": "bass/sub/sub_octave.vibe"
        },
        {
          "name": "sub_pure_sine",
          "description": "Genre: Dubstep, Bass Music | Character: Pure sine wave sub, clean and deep",
          "genre": "Dubstep, Bass Music",
          "character": "Pure sine wave sub, clean and deep",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sub_pure_sine\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope with slight attack for smoothness\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pure sine wave\n            let sig = sin_osc_ar(freq);\n\n            sig * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "sub",
          "path": "bass/sub/sub_pure_sine.vibe"
        },
        {
          "name": "sub_stereo",
          "description": "Genre: Ambient, Experimental | Character: Wide stereo sub with slight detuning",
          "genre": "Ambient, Experimental",
          "character": "Wide stereo sub with slight detuning",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sub_stereo\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slightly detuned sines for width\n            let left = sin_osc_ar(freq * 0.998);\n            let right = sin_osc_ar(freq * 1.002);\n\n            // Mix for stereo width (using left + right creates subtle movement)\n            let sig = left + right;\n\n            sig * env * amp * 0.7\n        })\n});",
          "category": "bass",
          "subcategory": "sub",
          "path": "bass/sub/sub_stereo.vibe"
        },
        {
          "name": "sub_triangle",
          "description": "Genre: House, Techno | Character: Triangle wave sub with odd harmonics",
          "genre": "House, Techno",
          "character": "Triangle wave sub with odd harmonics",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sub_triangle\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Smooth envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Approximate triangle with sine and harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.111;\n            let harmonic5 = sin_osc_ar(freq * 5.0) * 0.04;\n\n            let sig = fundamental + harmonic3 + harmonic5;\n\n            sig * env * amp * 0.8\n        })\n});",
          "category": "bass",
          "subcategory": "sub",
          "path": "bass/sub/sub_triangle.vibe"
        },
        {
          "name": "sub_warm",
          "description": "Genre: House, Deep House | Character: Warm sub with gentle harmonics",
          "genre": "House, Deep House",
          "character": "Warm sub with gentle harmonics",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sub_warm\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fundamental\n            let fundamental = sin_osc_ar(freq);\n\n            // Warm harmonics\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.15;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.08;\n\n            let sig = fundamental + harmonic2 + harmonic3;\n\n            // Gentle filtering for warmth\n            let filtered = lpf_ar(sig, 250.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "sub",
          "path": "bass/sub/sub_warm.vibe"
        }
      ],
      "Synth": [
        {
          "name": "bass_101",
          "description": "Roland SH-101 bass - classic mono synth",
          "genre": "Acid, Techno, Electronic",
          "character": "Roland SH-101 bass - classic mono synth",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Acid, Techno, Electronic | Character: Roland SH-101 bass - classic mono synth\ndefine_synthdef(\"bass_101\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .param(\"cutoff\", 1000.0)\n    .body(|freq, amp, gate, cutoff| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.005, 0.2)\n            .build();\n\n        // Single saw oscillator with sub\n        let osc = saw_ar(freq);\n        let sub = pulse_ar(freq * 0.5, 0.5) * 0.5;\n\n        let mix = (osc + sub) * 0.45;\n\n        // Snappy filter\n        let mod_cutoff = cutoff + filt_env * 2000.0;\n        let filtered = rlpf_ar(mix, mod_cutoff, 0.3);\n\n        filtered * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "synth",
          "path": "bass/synth/bass_101.vibe"
        },
        {
          "name": "bass_dx7",
          "description": "DX7 FM bass - punchy and clear",
          "genre": "80s Pop, R&B, Electronic",
          "character": "DX7 FM bass - punchy and clear",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: 80s Pop, R&B, Electronic | Character: DX7 FM bass - punchy and clear\ndefine_synthdef(\"bass_dx7\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // FM index envelope\n        let mod_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n\n        // FM synthesis - carrier and modulator\n        let mod_ratio = 1.0;\n        let mod_index = 2.0 + mod_env * 5.0;\n        let modulator = sin_osc_ar(freq * mod_ratio) * mod_index * freq;\n        let carrier = sin_osc_ar(freq + modulator);\n\n        // Second operator for more harmonics\n        let mod2 = sin_osc_ar(freq * 2.0) * mod_env * freq * 0.5;\n        let carrier2 = sin_osc_ar(freq + mod2) * 0.3;\n\n        let sig = (carrier + carrier2) * 0.5;\n\n        sig * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "synth",
          "path": "bass/synth/bass_dx7.vibe"
        },
        {
          "name": "bass_granular",
          "description": "Granular bass texture",
          "genre": "Experimental, Ambient, IDM",
          "character": "Granular bass texture",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Experimental, Ambient, IDM | Character: Granular bass texture\ndefine_synthdef(\"bass_granular\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.7)\n    .param(\"gate\", 1.0)\n    .param(\"grain_rate\", 20.0)\n    .body(|freq, amp, gate, grain_rate| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Base tone\n        let base = sin_osc_ar(freq) * 0.4;\n\n        // Granular texture using multiple modulated oscillators\n        let grain_mod = sin_osc_ar(grain_rate) * 0.5 + 0.5;\n        let grain1 = sin_osc_ar(freq * 1.01) * grain_mod * 0.2;\n        let grain2 = sin_osc_ar(freq * 0.99) * (1.0 - grain_mod) * 0.2;\n\n        // Random frequency deviations\n        let dust_mod = dust_ar(grain_rate) * freq * 0.02;\n        let grain3 = sin_osc_ar(freq + dust_mod) * 0.15;\n\n        let mix = base + grain1 + grain2 + grain3;\n\n        lpf_ar(mix, 2000.0) * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "synth",
          "path": "bass/synth/bass_granular.vibe"
        },
        {
          "name": "bass_juno",
          "description": "Roland Juno-style bass - warm and punchy",
          "genre": "House, Disco, Synthwave",
          "character": "Roland Juno-style bass - warm and punchy",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: House, Disco, Synthwave | Character: Roland Juno-style bass - warm and punchy\ndefine_synthdef(\"bass_juno\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.008, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.008, 0.2)\n            .build();\n\n        // PWM oscillator characteristic of Juno\n        let pwm = sin_osc_ar(0.5) * 0.2 + 0.5;\n        let osc = pulse_ar(freq, pwm);\n\n        // Sub oscillator\n        let sub = pulse_ar(freq * 0.5, 0.5) * 0.4;\n\n        let mix = (osc + sub) * 0.45;\n\n        // Warm filter\n        let cutoff = 600.0 + filt_env * 1500.0;\n        let filtered = rlpf_ar(mix, cutoff, 0.2);\n\n        filtered * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "synth",
          "path": "bass/synth/bass_juno.vibe"
        },
        {
          "name": "bass_moog",
          "description": "Classic Minimoog bass - fat and warm",
          "genre": "Funk, Electronic, Classic",
          "character": "Classic Minimoog bass - fat and warm",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Funk, Electronic, Classic | Character: Classic Minimoog bass - fat and warm\ndefine_synthdef(\"bass_moog\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .param(\"cutoff\", 800.0)\n    .param(\"res\", 0.3)\n    .body(|freq, amp, gate, cutoff, res| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.01, 0.3)\n            .build();\n\n        // Multiple oscillators slightly detuned\n        let osc1 = saw_ar(freq);\n        let osc2 = saw_ar(freq * 1.005);\n        let osc3 = pulse_ar(freq * 0.5, 0.5) * 0.5;\n\n        let mix = (osc1 + osc2 + osc3) * 0.35;\n\n        // Moog-style ladder filter\n        let mod_cutoff = cutoff + filt_env * 1500.0;\n        let filtered = rlpf_ar(mix, mod_cutoff, res);\n\n        filtered * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "synth",
          "path": "bass/synth/bass_moog.vibe"
        },
        {
          "name": "bass_ms20",
          "description": "Korg MS-20 bass - aggressive and nasty",
          "genre": "Industrial, Techno, Experimental",
          "character": "Korg MS-20 bass - aggressive and nasty",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Industrial, Techno, Experimental | Character: Korg MS-20 bass - aggressive and nasty\ndefine_synthdef(\"bass_ms20\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .param(\"drive\", 2.0)\n    .body(|freq, amp, gate, drive| {\n        let env = envelope()\n            .asr(0.003, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.003, 0.25)\n            .build();\n\n        // Ring mod-ish oscillators\n        let osc1 = saw_ar(freq);\n        let osc2 = pulse_ar(freq * 1.01, 0.3);\n\n        let mix = (osc1 + osc2) * 0.4;\n\n        // MS-20 style high-pass then low-pass with drive\n        let hp = hpf_ar(mix, 60.0);\n        let driven = (hp * drive).tanh();\n\n        // Aggressive filter\n        let cutoff = 400.0 + filt_env * 2500.0;\n        let filtered = rlpf_ar(driven, cutoff, 0.4);\n\n        filtered * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "synth",
          "path": "bass/synth/bass_ms20.vibe"
        },
        {
          "name": "bass_prophet",
          "description": "Prophet-5 style bass - punchy and rich",
          "genre": "Synth-pop, Electronic",
          "character": "Prophet-5 style bass - punchy and rich",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Synth-pop, Electronic | Character: Prophet-5 style bass - punchy and rich\ndefine_synthdef(\"bass_prophet\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.005, 0.25)\n            .build();\n\n        // Two oscillators\n        let osc1 = saw_ar(freq);\n        let osc2 = pulse_ar(freq * 1.003, 0.4);\n\n        let mix = (osc1 + osc2) * 0.4;\n\n        // Punchy filter\n        let cutoff = 500.0 + filt_env * 2000.0;\n        let filtered = rlpf_ar(mix, cutoff, 0.25);\n\n        filtered * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "synth",
          "path": "bass/synth/bass_prophet.vibe"
        },
        {
          "name": "bass_wavetable",
          "description": "Wavetable-style bass with morphing character",
          "genre": "Modern Electronic, EDM",
          "character": "Wavetable-style bass with morphing character",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Modern Electronic, EDM | Character: Wavetable-style bass with morphing character\ndefine_synthdef(\"bass_wavetable\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .param(\"morph\", 0.5)\n    .body(|freq, amp, gate, morph| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Simulate wavetable morphing with crossfading waveforms\n        let sine = sin_osc_ar(freq);\n        let tri = lf_tri_ar(freq);\n        let saw = saw_ar(freq);\n        let pulse = pulse_ar(freq, 0.3);\n\n        // Crossfade based on morph parameter\n        let mix1 = sine * (1.0 - morph * 2.0).max(0.0);\n        let mix2 = tri * (1.0 - (morph - 0.25).abs() * 4.0).max(0.0);\n        let mix3 = saw * (1.0 - (morph - 0.5).abs() * 4.0).max(0.0);\n        let mix4 = pulse * (1.0 - (morph - 0.75).abs() * 4.0).max(0.0);\n\n        let mix = (mix1 + mix2 + mix3 + mix4) * 0.5;\n\n        // Sub layer\n        let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n        // Filter\n        let cutoff = 800.0 + morph * 2000.0;\n        let filtered = lpf_ar(mix + sub, cutoff);\n\n        filtered * env * amp\n    });\n",
          "category": "bass",
          "subcategory": "synth",
          "path": "bass/synth/bass_wavetable.vibe"
        }
      ],
      "Wobble": [
        {
          "name": "wobble_aggressive",
          "description": "Genre: Brostep, Dubstep | Character: Aggressive, distorted wobble",
          "genre": "Brostep, Dubstep",
          "character": "Aggressive, distorted wobble",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "wobble_rate",
              "default": 6
            },
            {
              "name": "amp",
              "default": 0.55
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"wobble_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"wobble_rate\", 6.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws for thickness\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq * 1.005);\n            let mix = (osc1 + osc2) * 0.7;\n\n            // Clip for distortion\n            let driven = mix; //clip(mix, -0.8, 0.8);\n\n            // Fast wobble LFO\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n            let mod_cutoff = 150.0 + (wobble_lfo * 3500.0);\n\n            // High resonance for aggression\n            let filtered = rlpf_ar(driven, mod_cutoff, 0.08);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "wobble",
          "path": "bass/wobble/wobble_aggressive.vibe"
        },
        {
          "name": "wobble_classic",
          "description": "Genre: Dubstep, Bass Music | Character: Classic wobble bass with filter modulation",
          "genre": "Dubstep, Bass Music",
          "character": "Classic wobble bass with filter modulation",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "wobble_rate",
              "default": 4
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"wobble_classic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"wobble_rate\", 4.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Saw\n\n            // Sawtooth oscillator\n            let osc = saw_ar(freq);\n\n            // Wobble LFO using sine\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n\n            // Modulate filter cutoff with wobble\n            let mod_cutoff = 200.0 + (wobble_lfo * 2500.0);\n\n            // Resonant filter for classic wobble\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.1);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "wobble",
          "path": "bass/wobble/wobble_classic.vibe"
        },
        {
          "name": "wobble_deep",
          "description": "Genre: Deep Dubstep, 140 | Character: Deep, sub-heavy wobble",
          "genre": "Deep Dubstep, 140",
          "character": "Deep, sub-heavy wobble",
          "params": [
            {
              "name": "freq",
              "default": 75
            },
            {
              "name": "wobble_rate",
              "default": 2.5
            },
            {
              "name": "amp",
              "default": 0.65
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"wobble_deep\", |builder| {\n    builder\n        .param(\"freq\", 75.0)\n        .param(\"wobble_rate\", 2.5)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Saw plus sub\n            let saw = saw_ar(freq) * 0.6;\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n            let mix = saw + sub;\n\n            // Slow, deep wobble\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n            let mod_cutoff = 150.0 + (wobble_lfo * 1200.0);\n\n            // Moderate resonance\n            let filtered = rlpf_ar(mix, mod_cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "wobble",
          "path": "bass/wobble/wobble_deep.vibe"
        },
        {
          "name": "wobble_fm",
          "description": "Genre: Experimental Dubstep | Character: FM wobble with complex harmonics",
          "genre": "Experimental Dubstep",
          "character": "FM wobble with complex harmonics",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "wobble_rate",
              "default": 5
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"wobble_fm\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"wobble_rate\", 5.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM synthesis for complex timbre\n            let modulator = sin_osc_ar(freq * 1.5) * freq * 2.0;\n            let carrier = saw_ar(freq + modulator);\n\n            // Wobble LFO\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n            let mod_cutoff = 250.0 + (wobble_lfo * 2800.0);\n\n            // Filter with resonance\n            let filtered = rlpf_ar(carrier, mod_cutoff, 0.15);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "wobble",
          "path": "bass/wobble/wobble_fm.vibe"
        },
        {
          "name": "wobble_smooth",
          "description": "Genre: Melodic Dubstep, Chillstep | Character: Smooth, liquid wobble",
          "genre": "Melodic Dubstep, Chillstep",
          "character": "Smooth, liquid wobble",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "wobble_rate",
              "default": 2
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"wobble_smooth\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"wobble_rate\", 2.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Smooth envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Saw oscillator\n            let osc = saw_ar(freq);\n\n            // Slow, smooth wobble\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n            let mod_cutoff = 400.0 + (wobble_lfo * 1800.0);\n\n            // Less resonance for smoothness\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "wobble",
          "path": "bass/wobble/wobble_smooth.vibe"
        },
        {
          "name": "wobble_squelch",
          "description": "Genre: Dubstep, Riddim | Character: Squelchy, talking wobble",
          "genre": "Dubstep, Riddim",
          "character": "Squelchy, talking wobble",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "wobble_rate",
              "default": 8
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"wobble_squelch\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"wobble_rate\", 8.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pulse wave for different timbre\n            let osc = saw_ar(freq);\n\n            // Fast wobble with extreme modulation\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n            let mod_cutoff = 100.0 + (wobble_lfo * 4000.0);\n\n            // Very high resonance for squelch\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.05);\n\n            filtered * env * amp\n        })\n});",
          "category": "bass",
          "subcategory": "wobble",
          "path": "bass/wobble/wobble_squelch.vibe"
        }
      ]
    },
    "items": []
  },
  "Bells": {
    "subcategories": {},
    "items": [
      {
        "name": "church_bell",
        "description": "Large church bell with complex inharmonic partials.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"church_bell\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Bell envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 1.0)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Very long decay\n            let decay_env = envelope()\n                .perc(0.001, 8.0)\n                .build();\n\n            // Church bell partials (very inharmonic)\n            let h1 = sin_osc_ar(freq * 0.5);  // Hum tone\n            let h2 = sin_osc_ar(freq);         // Prime\n            let h3 = sin_osc_ar(freq * 1.2);   // Minor third\n            let h4 = sin_osc_ar(freq * 1.5) * 0.8;  // Fifth\n            let h5 = sin_osc_ar(freq * 2.0) * 0.6;  // Octave\n            let h6 = sin_osc_ar(freq * 2.5) * 0.4;  // Upper partial\n            let h7 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h8 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h9 = sin_osc_ar(freq * 5.5) * 0.15;\n\n            let bell = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8 + h9;\n\n            // Clapper strike\n            let strike_env = envelope()\n                .perc(0.0001, 0.08)\n                .build();\n            let strike = white_noise_ar() * strike_env * 0.2;\n            let strike_filtered = lpf_ar(strike, 2000.0);\n\n            (bell * 0.4 + strike_filtered) * env * decay_env * amp\n        })\n});",
        "category": "bells",
        "subcategory": "",
        "path": "bells/church_bell.vibe"
      },
      {
        "name": "glockenspiel",
        "description": "Bright, high-pitched metallic bells.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 880
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"glockenspiel\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Quick attack envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium decay\n            let decay_env = envelope()\n                .perc(0.001, 1.5)\n                .build();\n\n            // Bright metallic partials\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(freq * 5.76) * 0.15; // Slightly inharmonic\n            let h6 = sin_osc_ar(freq * 7.0) * 0.1;\n\n            let bell = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Mallet attack\n            let mallet_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let mallet = sin_osc_ar(freq * 6.0) * mallet_env * 0.2;\n\n            (bell + mallet) * env * decay_env * amp * 0.5\n        })\n});",
        "category": "bells",
        "subcategory": "",
        "path": "bells/glockenspiel.vibe"
      },
      {
        "name": "marimba",
        "description": "Deep wooden marimba with resonant body.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"marimba\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Marimba envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium decay\n            let decay_env = envelope()\n                .perc(0.001, 0.6)\n                .build();\n\n            // Marimba partials (warm, strong fundamental)\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h3 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h4 = sin_osc_ar(freq * 5.0) * 0.08;\n\n            let wood = h1 + h2 + h3 + h4;\n\n            // Soft mallet attack\n            let mallet_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let mallet = white_noise_ar() * mallet_env * 0.08;\n            let mallet_filtered = lpf_ar(mallet, 3000.0);\n\n            // Body resonance\n            let body = rlpf_ar(wood, freq * 1.5, 0.3) * 0.3;\n\n            (wood + body + mallet_filtered) * env * decay_env * amp * 0.7\n        })\n});",
        "category": "bells",
        "subcategory": "",
        "path": "bells/marimba.vibe"
      },
      {
        "name": "music_box",
        "description": "Classic music box with characteristic tines.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 880
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"music_box\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Quick pluck envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay envelope\n            let decay_env = envelope()\n                .perc(0.001, 0.8)\n                .build();\n\n            // Pure sine-based tines\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n            let tine = h1 + h2 + h3 + h4;\n\n            // Tine pluck attack\n            let pluck_env = envelope()\n                .perc(0.0001, 0.008)\n                .build();\n            let pluck = sin_osc_ar(freq * 5.0) * pluck_env * 0.3;\n\n            // High pass for clarity\n            let bright = hpf_ar(tine + pluck, 500.0);\n\n            bright * env * decay_env * amp * 0.6\n        })\n});",
        "category": "bells",
        "subcategory": "",
        "path": "bells/music_box.vibe"
      },
      {
        "name": "tubular_bells",
        "description": "Orchestral tubular bells with long resonant decay.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tubular_bells\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Bell envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Long decay\n            let decay_env = envelope()\n                .perc(0.001, 4.0)\n                .build();\n\n            // Tubular bell partials (slightly inharmonic)\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 2.83) * 0.4; // Inharmonic\n            let h4 = sin_osc_ar(freq * 4.07) * 0.3;\n            let h5 = sin_osc_ar(freq * 5.12) * 0.2;\n            let h6 = sin_osc_ar(freq * 6.2) * 0.15;\n            let h7 = sin_osc_ar(freq * 8.5) * 0.1;\n\n            let bell = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Strike attack\n            let strike_env = envelope()\n                .perc(0.0001, 0.05)\n                .build();\n            let strike = white_noise_ar() * strike_env * 0.15;\n\n            (bell + strike) * env * decay_env * amp * 0.5\n        })\n});",
        "category": "bells",
        "subcategory": "",
        "path": "bells/tubular_bells.vibe"
      },
      {
        "name": "vibraphone",
        "description": "Jazz vibraphone with characteristic motor vibrato.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "vibrato_speed",
            "default": 5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"vibraphone\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"vibrato_speed\", 5.0) // Motor speed\n        .body(|freq, amp, gate, vibrato_speed| {\n            // Vibes envelope\n            let env = envelope()\n                .asr(0.005, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium-long decay\n            let decay_env = envelope()\n                .perc(0.001, 2.0)\n                .build();\n\n            // Vibraphone partials\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(freq * 4.8) * 0.1; // Slightly inharmonic\n\n            let bell = h1 + h2 + h3 + h4 + h5;\n\n            // Motor vibrato (amplitude tremolo)\n            let motor = sin_osc_ar(vibrato_speed) * 0.3 + 0.7;\n\n            // Mallet soft attack\n            let mallet_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let mallet = white_noise_ar() * mallet_env * 0.05;\n\n            (bell * motor + mallet) * env * decay_env * amp * 0.6\n        })\n});",
        "category": "bells",
        "subcategory": "",
        "path": "bells/vibraphone.vibe"
      },
      {
        "name": "xylophone",
        "description": "Wooden mallet percussion with short decay.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 880
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"xylophone\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Short percussive envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Short decay\n            let decay_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Xylophone partials (bright, woody)\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 3.0) * 0.4; // Strong 3rd harmonic\n            let h3 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 6.0) * 0.15;\n\n            let wood = h1 + h2 + h3 + h4;\n\n            // Woody mallet click\n            let click_env = envelope()\n                .perc(0.0001, 0.015)\n                .build();\n            let click = white_noise_ar() * click_env * 0.2;\n            let click_filtered = hpf_ar(click, 2000.0);\n\n            (wood + click_filtered) * env * decay_env * amp * 0.7\n        })\n});",
        "category": "bells",
        "subcategory": "",
        "path": "bells/xylophone.vibe"
      }
    ]
  },
  "Brass": {
    "subcategories": {},
    "items": [
      {
        "name": "trumpet_realistic",
        "description": "Realistic Trumpet with mute options",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 349.23
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "brightness",
            "default": 0.6
          },
          {
            "name": "lip_tension",
            "default": 0.5
          },
          {
            "name": "air_pressure",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trumpet_realistic\", |builder| {\n    builder\n        .param(\"freq\", 349.23)    // F4 - comfortable trumpet range\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.6)    // Bell brightness\n        .param(\"lip_tension\", 0.5)   // Affects attack and timbre\n        .param(\"air_pressure\", 0.7)  // Dynamics\n        .body(|freq, amp, gate, brightness, lip_tension, air_pressure| {\n            let env = envelope()\n                .asr(0.03, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Delayed vibrato (musicians add vibrato after attack)\n            let vib_delay = envelope()\n                .perc(0.2, 4.0)\n                .build();\n            let vib_rate = 5.0 + (lip_tension * 1.5);\n            let vib_depth = 0.006 + (lip_tension * 0.004);\n            let vib = sin_osc_ar(vib_rate) * vib_depth * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Trumpet harmonics - bright with strong upper partials\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.32 * brightness;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.25 * brightness;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.18 * brightness;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.12 * brightness;\n            let h9 = sin_osc_ar(mod_freq * 9.0) * 0.07 * brightness;\n            let h10 = sin_osc_ar(mod_freq * 10.0) * 0.04 * brightness;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8 + h9 + h10;\n\n            // Lip buzz attack transient\n            let lip_env = envelope()\n                .perc(0.001, 0.025)\n                .build();\n            let lip_buzz = white_noise_ar() * lip_env * lip_tension * 0.15;\n            let lip_filtered = bpf_ar(lip_buzz, mod_freq * 6.0, 0.3);\n\n            // Bell formants - characteristic trumpet brightness\n            let f1 = rlpf_ar(harmonics, 1200.0, 0.35) * 0.35;\n            let f2 = rlpf_ar(harmonics, 2500.0, 0.3) * 0.35;\n            let f3 = rlpf_ar(harmonics, 4000.0, 0.25) * 0.3 * brightness;\n\n            // Bell flare high-frequency boost\n            let bell_boost = rlpf_ar(harmonics, 6000.0, 0.4) * 0.15 * brightness;\n\n            // Dynamic brightness - louder = brighter\n            let dyn_cutoff = 3000.0 + (air_pressure * 5000.0);\n            let dynamics = lpf_ar(f1 + f2 + f3 + bell_boost, dyn_cutoff);\n\n            let tone = dynamics + lip_filtered;\n\n            hpf_ar(tone, 150.0) * env * amp * air_pressure * 0.5\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/brass_realistic.vibe"
      },
      {
        "name": "trumpet_harmon_mute",
        "description": "Harmon mute (wah-wah)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 349.23
          },
          {
            "name": "amp",
            "default": 0.55
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "stem_in",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trumpet_harmon_mute\", |builder| {\n    builder\n        .param(\"freq\", 349.23)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .param(\"stem_in\", 0.5)   // 0=stem out (bright), 1=stem in (dark)\n        .body(|freq, amp, gate, stem_in| {\n            let env = envelope()\n                .asr(0.025, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Subtle vibrato\n            let vib = sin_osc_ar(5.5) * 0.005 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Harmonics\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.38;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.28;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.2;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.14;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Harmon mute creates a nasal, buzzy quality\n            // Strong resonance around 1kHz-2kHz\n            let mute_freq = 1500.0 + ((1.0 - stem_in) * 800.0);\n            let muted = rlpf_ar(harmonics, mute_freq, 0.15);  // Very resonant\n\n            // Stem position affects high frequencies\n            let hf_cutoff = 2500.0 + ((1.0 - stem_in) * 3000.0);\n            let hf_control = lpf_ar(muted, hf_cutoff);\n\n            // Buzzy character\n            let buzz = rlpf_ar(harmonics, 3500.0, 0.2) * 0.2;\n\n            let tone = hf_control + buzz;\n\n            hpf_ar(tone, 200.0) * env * amp * 0.55\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/brass_realistic.vibe"
      },
      {
        "name": "trumpet_cup_mute",
        "description": "softer, warmer",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 349.23
          },
          {
            "name": "amp",
            "default": 0.55
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trumpet_cup_mute\", |builder| {\n    builder\n        .param(\"freq\", 349.23)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let vib = sin_osc_ar(5.2) * 0.005 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Softer harmonics\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.22;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.12;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5;\n\n            // Cup mute - warmer, less bright\n            let muted = lpf_ar(harmonics, 2500.0);\n            let warm = rlpf_ar(muted, 800.0, 0.4) * 0.3;\n\n            let tone = muted + warm;\n\n            hpf_ar(tone, 150.0) * env * amp * 0.55\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/brass_realistic.vibe"
      },
      {
        "name": "flugelhorn",
        "description": "dark, velvety brass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 349.23
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "warmth",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"flugelhorn\", |builder| {\n    builder\n        .param(\"freq\", 349.23)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"warmth\", 0.7)\n        .body(|freq, amp, gate, warmth| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slower, wider vibrato\n            let vib_delay = envelope()\n                .perc(0.25, 4.0)\n                .build();\n            let vib = sin_osc_ar(4.8) * 0.006 * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Flugelhorn - darker, fewer high harmonics\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.1;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.05;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Soft attack\n            let attack_env = envelope()\n                .perc(0.002, 0.03)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.06;\n\n            // Conical bore - warm, round\n            let f1 = rlpf_ar(harmonics, 800.0, 0.45) * 0.4;\n            let f2 = rlpf_ar(harmonics, 1600.0, 0.4) * 0.35;\n            let f3 = rlpf_ar(harmonics, 2800.0, 0.45) * 0.25 * (1.0 - warmth * 0.5);\n\n            // Extra warmth\n            let warm = rlpf_ar(harmonics, 400.0, 0.5) * warmth * 0.2;\n\n            let tone = f1 + f2 + f3 + warm + attack;\n\n            hpf_ar(tone, 120.0) * env * amp * 0.55\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/brass_realistic.vibe"
      },
      {
        "name": "trombone_realistic",
        "description": "Realistic Trombone with slide position simulation",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 174.61
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "slide_smoothness",
            "default": 0.8
          },
          {
            "name": "brightness",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trombone_realistic\", |builder| {\n    builder\n        .param(\"freq\", 174.61)    // F3\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"slide_smoothness\", 0.8)  // How smooth the pitch transitions are\n        .param(\"brightness\", 0.5)\n        .body(|freq, amp, gate, slide_smoothness, brightness| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Trombone vibrato - often jaw vibrato\n            let vib_delay = envelope()\n                .perc(0.3, 4.0)\n                .build();\n            let vib = sin_osc_ar(5.0) * 0.005 * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Rich harmonic content\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.38;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.28;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.2 * brightness;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.14 * brightness;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.1 * brightness;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Lip attack\n            let lip_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let lip = white_noise_ar() * lip_env * 0.1;\n            let lip_filtered = bpf_ar(lip, mod_freq * 4.0, 0.3);\n\n            // Cylindrical bore formants\n            let f1 = rlpf_ar(harmonics, 500.0, 0.4) * 0.4;\n            let f2 = rlpf_ar(harmonics, 1200.0, 0.35) * 0.35;\n            let f3 = rlpf_ar(harmonics, 2500.0, 0.35) * 0.25 * brightness;\n\n            // Bell flare\n            let bell = rlpf_ar(harmonics, 3500.0, 0.4) * 0.15 * brightness;\n\n            let tone = f1 + f2 + f3 + bell + lip_filtered;\n\n            hpf_ar(tone, 80.0) * env * amp * 0.55\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/brass_realistic.vibe"
      },
      {
        "name": "bass_trombone",
        "description": "deeper, more powerful",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 116.54
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"bass_trombone\", |builder| {\n    builder\n        .param(\"freq\", 116.54)   // Bb2\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let vib = sin_osc_ar(4.5) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Full bass trombone spectrum\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.45;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.32;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.22;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.15;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.1;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.001, 0.035)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.08;\n\n            // Larger bore = darker\n            let f1 = rlpf_ar(harmonics, 350.0, 0.4) * 0.45;\n            let f2 = rlpf_ar(harmonics, 900.0, 0.4) * 0.35;\n            let f3 = rlpf_ar(harmonics, 1800.0, 0.4) * 0.2;\n\n            let tone = f1 + f2 + f3 + attack;\n\n            hpf_ar(tone, 50.0) * env * amp * 0.55\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/brass_realistic.vibe"
      },
      {
        "name": "french_horn_realistic",
        "description": "noble, warm, mellow",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "stopped",
            "default": "0.0"
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"french_horn_realistic\", |builder| {\n    builder\n        .param(\"freq\", 220.0)    // A3\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"stopped\", 0.0)   // 0=open, 1=hand stopped\n        .body(|freq, amp, gate, stopped| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Horn vibrato - subtle\n            let vib = sin_osc_ar(5.0) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Horn harmonics - emphasis on odd partials (conical bore)\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.6;  // Odd emphasis\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.45;  // Odd emphasis\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.25;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.18;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.1;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Hand in bell creates warm, distant quality\n            // Stopped horn creates buzzy, metallic quality\n            let open_cutoff = 2500.0;\n            let stopped_peak = 1800.0;\n\n            let cutoff = open_cutoff * (1.0 - stopped * 0.4);\n            let resonance = 0.35 + (stopped * 0.25);\n\n            let filtered = rlpf_ar(harmonics, cutoff, resonance);\n\n            // Stopped horn boost\n            let stopped_buzz = rlpf_ar(harmonics, stopped_peak, 0.15) * stopped * 0.3;\n\n            // Noble, warm formants\n            let f1 = rlpf_ar(filtered, 350.0, 0.45) * 0.35;\n            let f2 = rlpf_ar(filtered, 800.0, 0.4) * 0.35;\n            let f3 = rlpf_ar(filtered, 1800.0, 0.4) * 0.3 * (1.0 - stopped * 0.5);\n\n            let tone = f1 + f2 + f3 + stopped_buzz;\n\n            hpf_ar(tone, 100.0) * env * amp * 0.55\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/brass_realistic.vibe"
      },
      {
        "name": "tuba_realistic",
        "description": "deep, fundamental bass brass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 58.27
          },
          {
            "name": "amp",
            "default": 0.65
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "brightness",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tuba_realistic\", |builder| {\n    builder\n        .param(\"freq\", 58.27)    // Bb1\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.4)\n        .body(|freq, amp, gate, brightness| {\n            let env = envelope()\n                .asr(0.06, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Very slow vibrato\n            let vib = sin_osc_ar(4.0) * 0.003 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Tuba - strong fundamentals\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.38;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.16;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.1;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.06;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Slow attack\n            let attack_env = envelope()\n                .perc(0.002, 0.04)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.06;\n\n            // Very large bore - dark and round\n            let f1 = rlpf_ar(harmonics, 200.0, 0.45) * 0.45;\n            let f2 = rlpf_ar(harmonics, 600.0, 0.4) * 0.35;\n            let f3 = rlpf_ar(harmonics, 1200.0, 0.4) * 0.2 * brightness;\n\n            let tone = f1 + f2 + f3 + attack;\n\n            hpf_ar(tone, 30.0) * env * amp * 0.55\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/brass_realistic.vibe"
      },
      {
        "name": "euphonium",
        "description": "warm baritone brass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 130.81
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "warmth",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"euphonium\", |builder| {\n    builder\n        .param(\"freq\", 130.81)   // C3\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"warmth\", 0.6)\n        .body(|freq, amp, gate, warmth| {\n            let env = envelope()\n                .asr(0.045, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let vib = sin_osc_ar(4.8) * 0.005 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Warm, singing tone\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.42;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.28;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.18;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.1;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.07;\n\n            // Conical bore - warm and mellow\n            let f1 = rlpf_ar(harmonics, 300.0, 0.45) * 0.4;\n            let f2 = rlpf_ar(harmonics, 850.0, 0.4) * 0.35;\n            let f3 = rlpf_ar(harmonics, 1800.0, 0.4) * 0.25 * (1.0 - warmth * 0.3);\n\n            // Extra warmth\n            let warm = rlpf_ar(harmonics, 400.0, 0.5) * warmth * 0.15;\n\n            let tone = f1 + f2 + f3 + warm + attack;\n\n            hpf_ar(tone, 60.0) * env * amp * 0.55\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/brass_realistic.vibe"
      },
      {
        "name": "brass_section_realistic",
        "description": "ensemble sound",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "width",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"brass_section_realistic\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"width\", 0.5)     // Ensemble width/detuning\n        .body(|freq, amp, gate, width| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned voices\n            let detune = 0.003 + (width * 0.005);\n\n            // Trumpet section (3 players)\n            let t1 = sin_osc_ar(freq) + sin_osc_ar(freq * 2.0) * 0.5 + sin_osc_ar(freq * 3.0) * 0.3;\n            let t2 = sin_osc_ar(freq * (1.0 + detune)) + sin_osc_ar(freq * 2.0 * (1.0 + detune)) * 0.5;\n            let t3 = sin_osc_ar(freq * (1.0 - detune)) + sin_osc_ar(freq * 2.0 * (1.0 - detune)) * 0.5;\n\n            let trumpets = (t1 + t2 + t3) * 0.15;\n\n            // Trombone section (2 players, octave lower)\n            let tb1 = sin_osc_ar(freq * 0.5) + sin_osc_ar(freq) * 0.5 + sin_osc_ar(freq * 1.5) * 0.3;\n            let tb2 = sin_osc_ar(freq * 0.5 * (1.0 + detune * 0.8)) + sin_osc_ar(freq * (1.0 + detune * 0.8)) * 0.5;\n\n            let trombones = (tb1 + tb2) * 0.12;\n\n            // Horns (2 players)\n            let h1 = sin_osc_ar(freq * 0.75) + sin_osc_ar(freq * 1.5) * 0.4 + sin_osc_ar(freq * 2.25) * 0.25;\n            let h2 = sin_osc_ar(freq * 0.75 * (1.0 - detune * 0.5)) + sin_osc_ar(freq * 1.5 * (1.0 - detune * 0.5)) * 0.4;\n\n            let horns = (h1 + h2) * 0.1;\n\n            let ensemble = trumpets + trombones + horns;\n\n            // Section formants\n            let f1 = rlpf_ar(ensemble, 600.0, 0.4) * 0.4;\n            let f2 = rlpf_ar(ensemble, 1500.0, 0.35) * 0.35;\n            let f3 = rlpf_ar(ensemble, 3000.0, 0.35) * 0.25;\n\n            let tone = f1 + f2 + f3;\n\n            hpf_ar(tone, 80.0) * env * amp * 0.5\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/brass_realistic.vibe"
      },
      {
        "name": "brass_section",
        "description": "Full brass section ensemble with rich harmonics.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"brass_section\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Brass swell envelope\n            let env = envelope()\n                .asr(0.15, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple brass voices (detuned for section)\n            let detune = 0.004;\n            let v1 = saw_ar(freq * (1.0 - detune));\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * (1.0 + detune));\n\n            // Octave layer\n            let oct_up = saw_ar(freq * 2.0) * 0.3;\n\n            let section = (v1 + v2 + v3) * 0.35 + oct_up;\n\n            // Brass filter sweep (brighter with envelope)\n            let filter_env = envelope()\n                .asr(0.075, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let filter_freq = 800.0 + filter_env * 2500.0;\n\n            let brass = rlpf_ar(section, filter_freq, 0.3);\n\n            // Slight vibrato\n            let vib = sin_osc_ar(4.5) * 0.002 + 1.0;\n\n            brass * env * amp * vib\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/brass_section.vibe"
      },
      {
        "name": "french_horn",
        "description": "French horn with characteristic mellow, round tone.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"french_horn\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Slow swell envelope\n            let env = envelope()\n                .asr(0.2, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Mellow brass tone\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.002) * 0.4;\n\n            let tone = (saw1 + saw2) * 0.5;\n\n            // French horn formants (round, warm)\n            let f1 = rlpf_ar(tone, 350.0, 0.25) * 0.8;\n            let f2 = rlpf_ar(tone, 900.0, 0.3) * 0.6;\n            let f3 = rlpf_ar(tone, 1800.0, 0.35) * 0.3;\n\n            let brass = f1 + f2 + f3;\n\n            // Strong low pass for mellow sound\n            let mellow = lpf_ar(brass, 2500.0);\n\n            // Gentle vibrato\n            let vib = sin_osc_ar(4.5) * 0.005 + 1.0;\n\n            mellow * env * amp * vib * 0.8\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/french_horn.vibe"
      },
      {
        "name": "synth_brass",
        "description": "Classic synth brass stab with detuned saw waves.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "detune",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"synth_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"detune\", 0.5) // Detune amount\n        .body(|freq, amp, gate, detune| {\n            // Fast attack envelope\n            let env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned saws for fat sound\n            let detune_amt = 0.005 + detune * 0.01;\n            let saw1 = saw_ar(freq * (1.0 - detune_amt));\n            let saw2 = saw_ar(freq * (1.0 - detune_amt * 0.5));\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * (1.0 + detune_amt * 0.5));\n            let saw5 = saw_ar(freq * (1.0 + detune_amt));\n\n            let stack = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.25;\n\n            // Filter with envelope\n            let filter_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let filter_freq = 600.0 + filter_env * 3000.0;\n\n            let brass = rlpf_ar(stack, filter_freq, 0.4);\n\n            brass * env * amp\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/synth_brass.vibe"
      },
      {
        "name": "trombone",
        "description": "Trombone with characteristic warm tone and slide capability.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "slide",
            "default": "0.0"
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trombone\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"slide\", 0.0) // Slide amount (for glissando)\n        .body(|freq, amp, gate, slide| {\n            // Smooth attack envelope\n            let env = envelope()\n                .asr(0.1, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slide modulation (portamento effect)\n            let slide_mod = 1.0 + slide * 0.1;\n            let mod_freq = freq * slide_mod;\n\n            // Rich brass tone\n            let saw1 = saw_ar(mod_freq);\n            let saw2 = saw_ar(mod_freq * 0.999) * 0.6;\n\n            let tone = (saw1 + saw2) * 0.5;\n\n            // Trombone formants (warmer than trumpet)\n            let f1 = rlpf_ar(tone, 500.0, 0.3) * 0.6;\n            let f2 = rlpf_ar(tone, 1200.0, 0.3);\n            let f3 = rlpf_ar(tone, 2000.0, 0.25) * 0.4;\n\n            let brass = f1 + f2 + f3;\n\n            // Warm low pass\n            let warm = lpf_ar(brass, 3000.0);\n\n            // Slow vibrato\n            let vib = sin_osc_ar(4.0) * 0.006 + 1.0;\n\n            warm * env * amp * vib\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/trombone.vibe"
      },
      {
        "name": "trumpet",
        "description": "Solo trumpet with characteristic brightness and vibrato.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "brightness",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trumpet\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.7) // Filter brightness\n        .body(|freq, amp, gate, brightness| {\n            // Trumpet envelope with quick attack\n            let env = envelope()\n                .asr(0.05, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright sawtooth for brass\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.001) * 0.5;\n\n            let tone = (saw1 + saw2) * 0.6;\n\n            // Trumpet formants (brightness)\n            let f1 = rlpf_ar(tone, 1200.0, 0.3);\n            let f2 = rlpf_ar(tone, 2500.0, 0.25) * 0.5;\n            let f3 = rlpf_ar(tone, 3800.0, 0.2) * 0.3 * brightness;\n\n            let brass = f1 + f2 + f3;\n\n            // Attack transient (lip buzz)\n            let attack_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let buzz = white_noise_ar() * attack_env * 0.1;\n\n            // Vibrato\n            let vib_rate = 5.5;\n            let vib = sin_osc_ar(vib_rate) * 0.008 + 1.0;\n            let mod_freq = freq * vib;\n\n            (brass + buzz) * env * amp\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/trumpet.vibe"
      },
      {
        "name": "tuba",
        "description": "Deep tuba with full, round bass tone.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tuba\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Slow attack for tuba\n            let env = envelope()\n                .asr(0.15, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep brass tone\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.001) * 0.5;\n            let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n            let tone = (saw1 + saw2) * 0.4 + sub;\n\n            // Tuba formants (very warm)\n            let f1 = rlpf_ar(tone, 250.0, 0.3) * 0.8;\n            let f2 = rlpf_ar(tone, 600.0, 0.35) * 0.5;\n            let f3 = rlpf_ar(tone, 1200.0, 0.4) * 0.2;\n\n            let brass = f1 + f2 + f3;\n\n            // Heavy low pass\n            let deep = lpf_ar(brass, 2000.0);\n\n            deep * env * amp * 0.8\n        })\n});",
        "category": "brass",
        "subcategory": "",
        "path": "brass/tuba.vibe"
      }
    ]
  },
  "Cinematic": {
    "subcategories": {},
    "items": [
      {
        "name": "braam",
        "description": "Inception-style BRAAM",
        "genre": "Trailer, Epic",
        "character": "Inception-style BRAAM",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Trailer, Epic | Character: Inception-style BRAAM\ndefine_synthdef(\"braam\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Long, powerful decay\n        let amp_env = envelope()\n            .perc(0.05, 2.0)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.05, 1.5)\n            .build();\n\n        // Massive detuned oscillators\n        let osc1 = saw_ar(freq * 0.99) * 0.2;\n        let osc2 = saw_ar(freq) * 0.25;\n        let osc3 = saw_ar(freq * 1.01) * 0.2;\n        let osc4 = saw_ar(freq * 2.0) * 0.15;\n        let osc5 = saw_ar(freq * 0.5) * 0.2;\n\n        let mix = osc1 + osc2 + osc3 + osc4 + osc5;\n\n        // Powerful filter sweep\n        let cutoff = 200.0 + filt_env * 3000.0;\n        rlpf_ar(mix, cutoff, 0.2) * amp_env * amp\n    });\n",
        "category": "cinematic",
        "subcategory": "",
        "path": "cinematic/braam.vibe"
      },
      {
        "name": "drone_tension",
        "description": "Tension drone",
        "genre": "Horror, Thriller",
        "character": "Tension drone",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Horror, Thriller | Character: Tension drone\ndefine_synthdef(\"drone_tension\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(1.0, 1.0, 1.0)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow, unsettling modulation\n        let mod1 = sin_osc_ar(0.1) * freq * 0.02;\n        let mod2 = sin_osc_ar(0.07) * freq * 0.015;\n\n        // Dissonant tones\n        let tone1 = sin_osc_ar(freq + mod1) * 0.3;\n        let tone2 = sin_osc_ar(freq * 1.05 + mod2) * 0.2;\n        let tone3 = sin_osc_ar(freq * 0.98) * 0.25;\n\n        // Rumble\n        let rumble = lpf_ar(pink_noise_ar(), 80.0) * 0.15;\n\n        let sig = tone1 + tone2 + tone3 + rumble;\n\n        lpf_ar(sig, 800.0) * env * amp\n    });\n",
        "category": "cinematic",
        "subcategory": "",
        "path": "cinematic/drone_tension.vibe"
      },
      {
        "name": "impact_cinematic",
        "description": "Massive cinematic impact hit",
        "genre": "Trailer, Film",
        "character": "Massive cinematic impact hit",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Trailer, Film | Character: Massive cinematic impact hit\ndefine_synthdef(\"impact_cinematic\")\n    .param(\"freq\", 40.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Impact envelope\n        let amp_env = envelope()\n            .perc(0.001, 1.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch drop\n        let pitch_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n        let freq_mod = pitch_env * freq * 3.0;\n\n        // Sub impact\n        let sub = sin_osc_ar(freq + freq_mod) * 0.6;\n\n        // Noise burst\n        let noise_env = envelope()\n            .perc(0.001, 0.3)\n            .build();\n        let noise = lpf_ar(white_noise_ar(), 500.0) * noise_env * 0.4;\n\n        // Metallic ring\n        let ring = sin_osc_ar(freq * 4.0) * 0.15;\n\n        (sub + noise + ring) * amp_env * amp\n    });\n",
        "category": "cinematic",
        "subcategory": "",
        "path": "cinematic/impact_cinematic.vibe"
      },
      {
        "name": "whoosh_tonal",
        "description": "Tonal whoosh/flyby",
        "genre": "Sound Design, Trailer",
        "character": "Tonal whoosh/flyby",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Sound Design, Trailer | Character: Tonal whoosh/flyby\ndefine_synthdef(\"whoosh_tonal\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.7)\n    .param(\"length\", 0.5)\n    .body(|freq, amp, length| {\n        // Whoosh envelope\n        let amp_env = envelope()\n            .perc(0.3, 0.7)\n            .time_scale(length)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch sweep\n        let pitch_env = envelope()\n            .perc(0.01, 1.0)\n            .time_scale(length)\n            .build();\n        let sweep_freq = freq * 0.5 + pitch_env * freq * 2.0;\n\n        // Tonal component\n        let tone = sin_osc_ar(sweep_freq) * 0.4;\n\n        // Noise whoosh\n        let noise = bpf_ar(white_noise_ar(), sweep_freq * 2.0, 0.3) * 0.5;\n\n        (tone + noise) * amp_env * amp\n    });\n",
        "category": "cinematic",
        "subcategory": "",
        "path": "cinematic/whoosh_tonal.vibe"
      }
    ]
  },
  "Drums": {
    "subcategories": {
      "Breakbeats": [
        {
          "name": "break_amen",
          "description": "Amen break-style kit (combined hit)",
          "genre": "Jungle, Drum & Bass",
          "character": "Amen break-style kit (combined hit)",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Jungle, Drum & Bass | Character: Amen break-style kit (combined hit)\ndefine_synthdef(\"break_amen\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.9)\n    .param(\"type\", 0.0) // 0=kick, 0.5=snare, 1.0=hat\n    .body(|freq, amp, type_param| {\n        // Different envelopes based on type\n        let decay = 0.3 - type_param * 0.15;\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay)\n            .cleanup_on_finish()\n            .build();\n\n        // Kick component (more at type=0)\n        let kick_amount = 1.0 - type_param;\n        let kick_penv = envelope()\n            .perc(0.001, 0.04)\n            .build();\n        let kick = sin_osc_ar(60.0 + kick_penv * 200.0) * kick_amount * 0.6;\n\n        // Snare component (more at type=0.5)\n        let snare_amount = 1.0 - (type_param - 0.5).abs() * 2.0;\n        let snare_nenv = envelope()\n            .perc(0.001, 0.15)\n            .build();\n        let snare_body = sin_osc_ar(freq) * snare_amount * 0.3;\n        let snare_noise = hpf_ar(white_noise_ar(), 3000.0) * snare_nenv * snare_amount * 0.4;\n\n        // Hat component (more at type=1)\n        let hat = hpf_ar(white_noise_ar(), 8000.0) * type_param * 0.4;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.15;\n\n        (kick + snare_body + snare_noise + hat + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "breakbeats",
          "path": "drums/breakbeats/break_amen.vibe"
        },
        {
          "name": "break_funky",
          "description": "Funky Drummer-style kit sound",
          "genre": "Funk, Hip-hop",
          "character": "Funky Drummer-style kit sound",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Funk, Hip-hop | Character: Funky Drummer-style kit sound\ndefine_synthdef(\"break_funky\")\n    .param(\"freq\", 190.0)\n    .param(\"amp\", 0.85)\n    .param(\"type\", 0.0) // 0=kick, 0.5=snare, 1.0=hat\n    .body(|freq, amp, type_param| {\n        // Tight decay\n        let decay = 0.25 - type_param * 0.1;\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay)\n            .cleanup_on_finish()\n            .build();\n\n        // Kick\n        let kick_amount = 1.0 - type_param;\n        let kick_penv = envelope()\n            .perc(0.001, 0.035)\n            .build();\n        let kick = sin_osc_ar(55.0 + kick_penv * 150.0) * kick_amount * 0.65;\n\n        // Snare (funky, tight)\n        let snare_amount = 1.0 - (type_param - 0.5).abs() * 2.0;\n        let snare_body = sin_osc_ar(freq) * snare_amount * 0.3;\n        let snare_nenv = envelope()\n            .perc(0.001, 0.12)\n            .build();\n        let snare_noise = bpf_ar(white_noise_ar(), 4000.0, 0.5) * snare_nenv * snare_amount * 0.4;\n\n        // Hat (crisp)\n        let hat = hpf_ar(white_noise_ar(), 9000.0) * type_param * 0.35;\n\n        (kick + snare_body + snare_noise + hat) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "breakbeats",
          "path": "drums/breakbeats/break_funky.vibe"
        }
      ],
      "Claps": [
        {
          "name": "clap_808",
          "description": "Genre: Hip-hop, Trap | Character: Classic 808 clap, short and snappy",
          "genre": "Hip-hop, Trap",
          "character": "Classic 808 clap, short and snappy",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"clap_808\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Three quick bursts for clap character\n            let burst1_env = envelope()\n                .perc(0.001, 0.025)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.012, 0.025)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.020, 0.025)\n                .cleanup_on_finish()\n                .build();\n\n            // Filtered noise\n            let noise = white_noise_ar();\n            let filtered = rlpf_ar(noise, 2500.0, 0.5);\n\n            // Combine bursts\n            let clap = filtered * (burst1_env + burst2_env * 0.8 + burst3_env * 0.6);\n\n            clap * amp\n        })\n});",
          "category": "drums",
          "subcategory": "claps",
          "path": "drums/claps/clap_808.vibe"
        },
        {
          "name": "clap_crowd",
          "description": "Genre: Pop, Funk | Character: Multiple hands clapping, crowd-like",
          "genre": "Pop, Funk",
          "character": "Multiple hands clapping, crowd-like",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"clap_crowd\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Many slightly offset bursts\n            let burst1_env = envelope()\n                .perc(0.001, 0.028)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.007, 0.028)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.013, 0.028)\n                .build();\n\n            let burst4_env = envelope()\n                .perc(0.019, 0.028)\n                .build();\n\n            let burst5_env = envelope()\n                .perc(0.025, 0.028)\n                .cleanup_on_finish()\n                .build();\n\n            // Warmer noise for natural character\n            let noise = pink_noise_ar();\n            let filtered = rlpf_ar(noise, 2200.0, 0.6);\n\n            let clap = filtered * (burst1_env + burst2_env * 0.9 + burst3_env * 0.8 +\n                                   burst4_env * 0.7 + burst5_env * 0.6);\n\n            clap * amp * 0.8\n        })\n});",
          "category": "drums",
          "subcategory": "claps",
          "path": "drums/claps/clap_crowd.vibe"
        },
        {
          "name": "clap_filtered",
          "description": "Genre: Lo-fi, Experimental | Character: Heavily filtered, muffled",
          "genre": "Lo-fi, Experimental",
          "character": "Heavily filtered, muffled",
          "params": [
            {
              "name": "amp",
              "default": 1
            },
            {
              "name": "cutoff",
              "default": 1500
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"clap_filtered\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .param(\"cutoff\", 1500.0)\n        .body(|amp, cutoff| {\n            // Three bursts\n            let burst1_env = envelope()\n                .perc(0.002, 0.028)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.015, 0.028)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.025, 0.028)\n                .cleanup_on_finish()\n                .build();\n\n            // Heavy filtering for lo-fi character\n            let noise = pink_noise_ar();\n            let filtered = lpf_ar(noise, cutoff);\n\n            let clap = filtered * (burst1_env + burst2_env * 0.8 + burst3_env * 0.6);\n\n            clap * amp\n        })\n});",
          "category": "drums",
          "subcategory": "claps",
          "path": "drums/claps/clap_filtered.vibe"
        },
        {
          "name": "clap_handclap",
          "description": "Genre: Acoustic, Folk | Character: Natural hand clap sound",
          "genre": "Acoustic, Folk",
          "character": "Natural hand clap sound",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"clap_handclap\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Two natural bursts\n            let burst1_env = envelope()\n                .perc(0.001, 0.022)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.011, 0.022)\n                .cleanup_on_finish()\n                .build();\n\n            // Natural frequency range\n            let noise = pink_noise_ar();\n            let filtered = rlpf_ar(noise, 2400.0, 0.6);\n\n            // Add body resonance\n            let body_env = envelope()\n                .perc(0.001, 0.018)\n                .build();\n            let body = sin_osc_ar(320.0) * body_env * 0.15;\n\n            let clap = filtered * (burst1_env + burst2_env * 0.8);\n\n            (clap + body) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "claps",
          "path": "drums/claps/clap_handclap.vibe"
        },
        {
          "name": "clap_layered",
          "description": "Genre: Pop, EDM | Character: Layered, big stadium clap",
          "genre": "Pop, EDM",
          "character": "Layered, big stadium clap",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"clap_layered\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Four bursts for thick character\n            let burst1_env = envelope()\n                .perc(0.001, 0.025)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.009, 0.025)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.016, 0.025)\n                .build();\n\n            let burst4_env = envelope()\n                .perc(0.022, 0.025)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple frequency bands\n            let noise = white_noise_ar();\n            let low = rlpf_ar(noise, 1200.0, 0.6) * 0.4;\n            let mid = rlpf_ar(noise, 2800.0, 0.5) * 0.7;\n            let high = hpf_ar(noise, 3500.0) * 0.5;\n\n            let mix = low + mid + high;\n            let clap = mix * (burst1_env + burst2_env * 0.85 + burst3_env * 0.7 + burst4_env * 0.55);\n\n            clap * amp * 0.7\n        })\n});",
          "category": "drums",
          "subcategory": "claps",
          "path": "drums/claps/clap_layered.vibe"
        },
        {
          "name": "clap_lofi",
          "description": "Genre: Lo-fi Hip-hop | Character: Dusty, vintage clap",
          "genre": "Lo-fi Hip-hop",
          "character": "Dusty, vintage clap",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"clap_lofi\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Soft, dusty bursts\n            let burst1_env = envelope()\n                .perc(0.003, 0.035)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.018, 0.035)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.030, 0.035)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise for warmth\n            let noise = pink_noise_ar();\n            let filtered = rlpf_ar(noise, 1800.0, 0.7);\n\n            // Add vinyl crackle\n            let crackle_env = burst1_env * 0.5;\n            let crackle = hpf_ar(white_noise_ar(), 7000.0) * crackle_env * 0.06;\n\n            let clap = filtered * (burst1_env + burst2_env * 0.8 + burst3_env * 0.65);\n\n            (clap + crackle) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "claps",
          "path": "drums/claps/clap_lofi.vibe"
        },
        {
          "name": "clap_loose",
          "description": "Genre: Funk, Soul | Character: Loose, spread out clap",
          "genre": "Funk, Soul",
          "character": "Loose, spread out clap",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"clap_loose\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Four bursts with larger timing spread\n            let burst1_env = envelope()\n                .perc(0.002, 0.032)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.018, 0.032)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.032, 0.032)\n                .build();\n\n            let burst4_env = envelope()\n                .perc(0.045, 0.032)\n                .cleanup_on_finish()\n                .build();\n\n            // Warm filtering\n            let noise = pink_noise_ar();\n            let filtered = rlpf_ar(noise, 2000.0, 0.6);\n\n            let clap = filtered * (burst1_env + burst2_env * 0.85 + burst3_env * 0.7 + burst4_env * 0.55);\n\n            clap * amp\n        })\n});",
          "category": "drums",
          "subcategory": "claps",
          "path": "drums/claps/clap_loose.vibe"
        },
        {
          "name": "clap_reverb",
          "description": "Genre: Pop, EDM | Character: Big clap with reverb tail",
          "genre": "Pop, EDM",
          "character": "Big clap with reverb tail",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"clap_reverb\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Multiple bursts\n            let burst1_env = envelope()\n                .perc(0.001, 0.022)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.010, 0.022)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.018, 0.022)\n                .cleanup_on_finish()\n                .build();\n\n            // Filtered noise\n            let noise = white_noise_ar();\n            let filtered = rlpf_ar(noise, 2800.0, 0.5);\n            let dry_clap = filtered * (burst1_env + burst2_env * 0.8 + burst3_env * 0.6);\n\n            // Reverb tail envelope\n            let reverb_env = envelope()\n                .perc(0.02, 0.35)\n                .build();\n            let reverb = lpf_ar(filtered, 4000.0) * reverb_env * 0.3;\n\n            (dry_clap + reverb) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "claps",
          "path": "drums/claps/clap_reverb.vibe"
        },
        {
          "name": "clap_short",
          "description": "Genre: Techno, House | Character: Tight, short clap",
          "genre": "Techno, House",
          "character": "Tight, short clap",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"clap_short\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Two quick bursts for tight character\n            let burst1_env = envelope()\n                .perc(0.0005, 0.018)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.008, 0.018)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright filtered noise\n            let noise = white_noise_ar();\n            let filtered = hpf_ar(noise, 1800.0);\n\n            let clap = filtered * (burst1_env + burst2_env * 0.7);\n\n            clap * amp\n        })\n});",
          "category": "drums",
          "subcategory": "claps",
          "path": "drums/claps/clap_short.vibe"
        },
        {
          "name": "clap_tight",
          "description": "Genre: Techno, Minimal | Character: Very tight, focused clap",
          "genre": "Techno, Minimal",
          "character": "Very tight, focused clap",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"clap_tight\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Just two very short bursts\n            let burst1_env = envelope()\n                .perc(0.0003, 0.012)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.006, 0.012)\n                .cleanup_on_finish()\n                .build();\n\n            // Focused filtering\n            let noise = white_noise_ar();\n            let filtered = rlpf_ar(noise, 2400.0, 0.3);\n\n            let clap = filtered * (burst1_env + burst2_env * 0.75);\n\n            clap * amp\n        })\n});",
          "category": "drums",
          "subcategory": "claps",
          "path": "drums/claps/clap_tight.vibe"
        }
      ],
      "Cymbals": [
        {
          "name": "bell_ping",
          "description": "Genre: Jazz, Experimental | Character: Ride bell or cymbal ping",
          "genre": "Jazz, Experimental",
          "character": "Ride bell or cymbal ping",
          "params": [
            {
              "name": "freq",
              "default": 880
            },
            {
              "name": "amp",
              "default": 0.7
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"bell_ping\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.7)\n        .body(|freq, amp| {\n            // Medium decay\n            let env = envelope()\n                .perc(0.001, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Clear bell tones with inharmonic partials\n            let bell1 = sin_osc_ar(freq) * 0.4;\n            let bell2 = sin_osc_ar(freq * 1.5) * 0.3;\n            let bell3 = sin_osc_ar(freq * 2.3) * 0.2;\n            let bell4 = sin_osc_ar(freq * 3.8) * 0.1;\n\n            let bells = bell1 + bell2 + bell3 + bell4;\n\n            // Metallic shimmer\n            let metal = saw_ar(freq * 4.5) * 0.15;\n\n            // Subtle attack noise\n            let attack_env = envelope()\n                .perc(0.0005, 0.008)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.1;\n\n            (bells + metal + attack) * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "cymbals",
          "path": "drums/cymbals/bell_ping.vibe"
        },
        {
          "name": "china",
          "description": "Genre: Rock, Metal | Character: Trashy china cymbal with aggressive attack",
          "genre": "Rock, Metal",
          "character": "Trashy china cymbal with aggressive attack",
          "params": [
            {
              "name": "amp",
              "default": 0.75
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"china\", |builder| {\n    builder\n        .param(\"amp\", 0.75)\n        .body(|amp| {\n            // Medium-long decay\n            let env = envelope()\n                .perc(0.001, 1.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Very inharmonic, trashy frequencies\n            let metal1 = saw_ar(421.0) * 0.20;\n            let metal2 = saw_ar(687.0) * 0.19;\n            let metal3 = saw_ar(1134.0) * 0.18;\n            let metal4 = saw_ar(1798.0) * 0.16;\n            let metal5 = saw_ar(2611.0) * 0.13;\n            let metal6 = saw_ar(3589.0) * 0.10;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5 + metal6;\n\n            // Aggressive noise component\n            let noise = white_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 3500.0, 0.4) * 0.35;\n\n            let mix = metallic + filtered_noise;\n\n            // Slight low cut\n            let clean = hpf_ar(mix, 400.0);\n\n            clean * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "cymbals",
          "path": "drums/cymbals/china.vibe"
        },
        {
          "name": "crash_bright",
          "description": "Genre: Rock, EDM | Character: Bright crash cymbal for builds and emphasis",
          "genre": "Rock, EDM",
          "character": "Bright crash cymbal for builds and emphasis",
          "params": [
            {
              "name": "amp",
              "default": 0.8
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"crash_bright\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            // Long decay for crash\n            let env = envelope()\n                .perc(0.002, 2.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic inharmonic frequencies\n            let metal1 = saw_ar(487.0) * 0.2;\n            let metal2 = saw_ar(723.0) * 0.18;\n            let metal3 = saw_ar(1156.0) * 0.16;\n            let metal4 = saw_ar(1789.0) * 0.14;\n            let metal5 = saw_ar(2473.0) * 0.12;\n            let metal6 = saw_ar(3287.0) * 0.10;\n            let metal7 = saw_ar(4231.0) * 0.08;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5 + metal6 + metal7;\n\n            // Bright noise component\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(noise, 3000.0) * 0.3;\n\n            // Mix\n            let mix = metallic + filtered_noise;\n\n            // High-pass to remove mud\n            let clean = hpf_ar(mix, 500.0);\n\n            clean * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "cymbals",
          "path": "drums/cymbals/crash_bright.vibe"
        },
        {
          "name": "crash_dark",
          "description": "Genre: Jazz, Ambient | Character: Dark, trashy crash cymbal",
          "genre": "Jazz, Ambient",
          "character": "Dark, trashy crash cymbal",
          "params": [
            {
              "name": "amp",
              "default": 0.7
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"crash_dark\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            // Long, sustained decay\n            let env = envelope()\n                .perc(0.003, 3.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Lower inharmonic frequencies for darker sound\n            let metal1 = saw_ar(312.0) * 0.22;\n            let metal2 = saw_ar(548.0) * 0.20;\n            let metal3 = saw_ar(834.0) * 0.18;\n            let metal4 = saw_ar(1211.0) * 0.16;\n            let metal5 = saw_ar(1689.0) * 0.12;\n            let metal6 = saw_ar(2278.0) * 0.08;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5 + metal6;\n\n            // Darker noise\n            let noise = pink_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 4500.0, 0.6) * 0.25;\n\n            let mix = metallic + filtered_noise;\n\n            // Less aggressive high-pass\n            let clean = hpf_ar(mix, 300.0);\n\n            clean * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "cymbals",
          "path": "drums/cymbals/crash_dark.vibe"
        },
        {
          "name": "crash_reverse",
          "description": "Genre: Cinematic, EDM | Character: Reverse crash cymbal effect",
          "genre": "Cinematic, EDM",
          "character": "Reverse crash cymbal effect",
          "params": [
            {
              "name": "amp",
              "default": 0.7
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"crash_reverse\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            // Reverse envelope (builds up)\n            let env = envelope()\n                .perc(1.5, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic components\n            let metal1 = saw_ar(523.0) * 0.18;\n            let metal2 = saw_ar(897.0) * 0.17;\n            let metal3 = saw_ar(1421.0) * 0.16;\n            let metal4 = saw_ar(2134.0) * 0.14;\n            let metal5 = saw_ar(3012.0) * 0.12;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5;\n\n            // Reverse filter sweep\n            let filter_env = envelope()\n                .perc(1.2, 0.5)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 5000.0);\n\n            let filtered = lpf_ar(metallic, mod_cutoff);\n\n            // Add noise\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(noise, 3000.0) * 0.2;\n\n            (filtered + filtered_noise) * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "cymbals",
          "path": "drums/cymbals/crash_reverse.vibe"
        },
        {
          "name": "crash_swell",
          "description": "Genre: Cinematic, Orchestral | Character: Crash with dynamic swell",
          "genre": "Cinematic, Orchestral",
          "character": "Crash with dynamic swell",
          "params": [
            {
              "name": "amp",
              "default": 0.7
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"crash_swell\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            // Build and decay envelope\n            let env = envelope()\n                .perc(0.3, 2.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic frequencies\n            let metal1 = saw_ar(456.0) * 0.18;\n            let metal2 = saw_ar(712.0) * 0.17;\n            let metal3 = saw_ar(1089.0) * 0.16;\n            let metal4 = saw_ar(1645.0) * 0.15;\n            let metal5 = saw_ar(2387.0) * 0.13;\n            let metal6 = saw_ar(3289.0) * 0.11;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5 + metal6;\n\n            // Dynamic filter for swell\n            let filter_env = envelope()\n                .perc(0.5, 2.5)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 4500.0);\n\n            let filtered = lpf_ar(metallic, mod_cutoff);\n\n            // Noise layer\n            let noise = pink_noise_ar();\n            let filtered_noise = hpf_ar(noise, 2000.0) * 0.2;\n\n            (filtered + filtered_noise) * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "cymbals",
          "path": "drums/cymbals/crash_swell.vibe"
        },
        {
          "name": "ride",
          "description": "Genre: Jazz, Rock | Character: Ride cymbal for keeping time",
          "genre": "Jazz, Rock",
          "character": "Ride cymbal for keeping time",
          "params": [
            {
              "name": "amp",
              "default": 0.6
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"ride\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Medium decay\n            let env = envelope()\n                .perc(0.002, 1.2)\n                .cleanup_on_finish()\n                .build();\n\n            // Clear bell-like frequencies\n            let bell1 = sin_osc_ar(523.0) * 0.3;\n            let bell2 = sin_osc_ar(784.0) * 0.25;\n            let bell3 = sin_osc_ar(1047.0) * 0.15;\n\n            // Metallic wash\n            let metal1 = saw_ar(1456.0) * 0.12;\n            let metal2 = saw_ar(2134.0) * 0.10;\n            let metal3 = saw_ar(2987.0) * 0.08;\n\n            let tones = bell1 + bell2 + bell3;\n            let metallic = metal1 + metal2 + metal3;\n\n            // Subtle noise\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(noise, 4000.0) * 0.15;\n\n            let mix = tones + metallic + filtered_noise;\n\n            mix * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "cymbals",
          "path": "drums/cymbals/ride.vibe"
        },
        {
          "name": "splash",
          "description": "Genre: All | Character: Small splash cymbal, quick and bright",
          "genre": "All",
          "character": "Small splash cymbal, quick and bright",
          "params": [
            {
              "name": "amp",
              "default": 0.7
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"splash\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            // Short decay\n            let env = envelope()\n                .perc(0.001, 0.5)\n                .cleanup_on_finish()\n                .build();\n\n            // High, bright metallic frequencies\n            let metal1 = saw_ar(1823.0) * 0.22;\n            let metal2 = saw_ar(2712.0) * 0.20;\n            let metal3 = saw_ar(3845.0) * 0.18;\n            let metal4 = saw_ar(5234.0) * 0.15;\n            let metal5 = saw_ar(6921.0) * 0.12;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5;\n\n            // Bright noise splash\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(noise, 5000.0) * 0.25;\n\n            let mix = metallic + filtered_noise;\n\n            mix * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "cymbals",
          "path": "drums/cymbals/splash.vibe"
        }
      ],
      "Foley": [
        {
          "name": "foley_book_drop",
          "description": "Book drop thump",
          "genre": "Experimental, Lo-fi",
          "character": "Book drop thump",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Experimental, Lo-fi | Character: Book drop thump\ndefine_synthdef(\"foley_book_drop\")\n    .param(\"freq\", 100.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Soft thump decay\n        let amp_env = envelope()\n            .perc(0.002, 0.18)\n            .cleanup_on_finish()\n            .build();\n\n        // Muffled thud\n        let pitch_env = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.2) * 0.5;\n\n        // Paper flutter\n        let paper_env = envelope()\n            .perc(0.01, 0.1)\n            .build();\n        let paper = bpf_ar(pink_noise_ar(), 2000.0, 0.8) * paper_env * 0.2;\n\n        // Impact\n        let impact_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let impact = lpf_ar(white_noise_ar(), 1500.0) * impact_env * 0.25;\n\n        (body + paper + impact) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "foley",
          "path": "drums/foley/foley_book_drop.vibe"
        },
        {
          "name": "foley_bucket",
          "description": "Plastic bucket drum",
          "genre": "Street, Experimental",
          "character": "Plastic bucket drum",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Street, Experimental | Character: Plastic bucket drum\ndefine_synthdef(\"foley_bucket\")\n    .param(\"freq\", 180.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Plastic resonance\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitched body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.5) * 0.5;\n\n        // Plastic overtones\n        let overtone1 = sin_osc_ar(freq * 2.3) * 0.2;\n        let overtone2 = sin_osc_ar(freq * 3.7) * 0.1;\n\n        // Slap attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 2500.0, 0.4) * attack_env * 0.3;\n\n        (body + overtone1 + overtone2 + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "foley",
          "path": "drums/foley/foley_bucket.vibe"
        },
        {
          "name": "foley_cardboard",
          "description": "Cardboard box as drum",
          "genre": "Experimental, Lo-fi",
          "character": "Cardboard box as drum",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Experimental, Lo-fi | Character: Cardboard box as drum\ndefine_synthdef(\"foley_cardboard\")\n    .param(\"freq\", 120.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Cardboard resonance\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Hollow body\n        let body = sin_osc_ar(freq) * 0.4;\n        let resonance = bpf_ar(white_noise_ar(), freq * 2.5, 0.3) * 0.3;\n\n        // Paper-y attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.02)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 3000.0) * attack_env * 0.35;\n\n        (body + resonance + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "foley",
          "path": "drums/foley/foley_cardboard.vibe"
        },
        {
          "name": "foley_door_slam",
          "description": "Door slam impact",
          "genre": "Experimental, Sound Design",
          "character": "Door slam impact",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Experimental, Sound Design | Character: Door slam impact\ndefine_synthdef(\"foley_door_slam\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Impact decay\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Low thud\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.6;\n\n        // Wood resonance\n        let wood = bpf_ar(white_noise_ar(), 300.0, 0.3) * 0.25;\n\n        // Impact noise\n        let impact_env = envelope()\n            .perc(0.0001, 0.03)\n            .build();\n        let impact = lpf_ar(white_noise_ar(), 2000.0) * impact_env * 0.4;\n\n        (body + wood + impact) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "foley",
          "path": "drums/foley/foley_door_slam.vibe"
        },
        {
          "name": "foley_pot_lid",
          "description": "Metal pot lid cymbal",
          "genre": "Experimental, Industrial",
          "character": "Metal pot lid cymbal",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Experimental, Industrial | Character: Metal pot lid cymbal\ndefine_synthdef(\"foley_pot_lid\")\n    .param(\"freq\", 800.0)\n    .param(\"amp\", 0.6)\n    .body(|freq, amp| {\n        // Metallic ring\n        let amp_env = envelope()\n            .perc(0.001, 0.6)\n            .cleanup_on_finish()\n            .build();\n\n        // Inharmonic metallic partials\n        let body = sin_osc_ar(freq) * 0.3;\n        let ring1 = sin_osc_ar(freq * 1.7) * 0.25;\n        let ring2 = sin_osc_ar(freq * 2.4) * 0.2;\n        let ring3 = sin_osc_ar(freq * 3.1) * 0.15;\n        let ring4 = sin_osc_ar(freq * 4.6) * 0.08;\n\n        // Hit attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 5000.0) * attack_env * 0.25;\n\n        (body + ring1 + ring2 + ring3 + ring4 + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "foley",
          "path": "drums/foley/foley_pot_lid.vibe"
        }
      ],
      "Hihats": [
        {
          "name": "hihat_808_closed",
          "description": "Classic 808 closed hihat, short and tight",
          "genre": "Hip-hop, Trap",
          "character": "Classic 808 closed hihat, short and tight",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Hip-hop, Trap | Character: Classic 808 closed hihat, short and tight\ndefine_synthdef(\"hihat_808_closed\")\n    .param(\"amp\", 1.0)\n    .body(|amp| {\n        // Very short envelope\n        let env = envelope()\n            .perc(0.0005, 0.04)\n            .cleanup_on_finish()\n            .build();\n\n        // Square wave oscillators for metallic character\n        let osc1 = saw_ar(315.0);\n        let osc2 = saw_ar(380.0);\n        let osc3 = saw_ar(445.0);\n        let osc4 = saw_ar(540.0);\n        let osc5 = saw_ar(620.0);\n        let osc6 = saw_ar(745.0);\n\n        let mix_osc = (osc1 + osc2 + osc3 + osc4 + osc5 + osc6) * 0.16;\n\n        // High-pass filter for brightness\n        let filtered = hpf_ar(mix_osc, 8000.0);\n\n        filtered * env * amp\n    });\n\n",
          "category": "drums",
          "subcategory": "hihats",
          "path": "drums/hihats/hihat_808_closed.vibe"
        },
        {
          "name": "hihat_808_open",
          "description": "Classic 808 open hihat, longer decay",
          "genre": "Hip-hop, Trap",
          "character": "Classic 808 open hihat, longer decay",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Hip-hop, Trap | Character: Classic 808 open hihat, longer decay\ndefine_synthdef(\"hihat_808_open\")\n    .param(\"amp\", 1.0)\n    .body(|amp| {\n        // Longer envelope for open character\n        let env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Square wave oscillators\n        let osc1 = saw_ar(315.0);\n        let osc2 = saw_ar(380.0);\n        let osc3 = saw_ar(445.0);\n        let osc4 = saw_ar(540.0);\n        let osc5 = saw_ar(620.0);\n        let osc6 = saw_ar(745.0);\n\n        let mix_osc = (osc1 + osc2 + osc3 + osc4 + osc5 + osc6) * 0.16;\n\n        // High-pass filter\n        let filtered = hpf_ar(mix_osc, 7000.0);\n\n        filtered * env * amp\n    });\n\n",
          "category": "drums",
          "subcategory": "hihats",
          "path": "drums/hihats/hihat_808_open.vibe"
        },
        {
          "name": "hihat_909_closed",
          "description": "Genre: House, Techno | Character: Classic 909 closed hihat, bright and crisp",
          "genre": "House, Techno",
          "character": "Classic 909 closed hihat, bright and crisp",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"hihat_909_closed\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Short, tight envelope\n            let env = envelope()\n                .perc(0.0003, 0.05)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise base\n            let noise = white_noise_ar();\n\n            // Aggressive high-pass for 909 character\n            let filtered = hpf_ar(noise, 10000.0);\n\n            // Add slight resonance\n            let resonant = rlpf_ar(filtered, 12000.0, 0.3);\n\n            resonant * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "hihats",
          "path": "drums/hihats/hihat_909_closed.vibe"
        },
        {
          "name": "hihat_909_open",
          "description": "Genre: House, Techno | Character: Classic 909 open hihat with decay",
          "genre": "House, Techno",
          "character": "Classic 909 open hihat with decay",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"hihat_909_open\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Medium-long envelope\n            let env = envelope()\n                .perc(0.001, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise\n            let noise = white_noise_ar();\n\n            // High-pass filter\n            let filtered = hpf_ar(noise, 9000.0);\n\n            // Band-pass for resonant character\n            let resonant = rlpf_ar(filtered, 11000.0, 0.4);\n\n            resonant * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "hihats",
          "path": "drums/hihats/hihat_909_open.vibe"
        },
        {
          "name": "hihat_dusty",
          "description": "Genre: Lo-fi Hip-hop | Character: Dusty, lo-fi texture",
          "genre": "Lo-fi Hip-hop",
          "character": "Dusty, lo-fi texture",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"hihat_dusty\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Soft attack and medium decay\n            let env = envelope()\n                .perc(0.003, 0.12)\n                .cleanup_on_finish()\n                .build();\n\n            // Use pink noise for warmer character\n            let noise = pink_noise_ar();\n\n            // Gentle high-pass\n            let filtered = hpf_ar(noise, 4500.0);\n\n            // Roll off highs for dusty character\n            let rolled_off = lpf_ar(filtered, 8000.0);\n\n            rolled_off * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "hihats",
          "path": "drums/hihats/hihat_dusty.vibe"
        },
        {
          "name": "hihat_filtered",
          "description": "Genre: Lo-fi, Experimental | Character: Filtered, darker hihat",
          "genre": "Lo-fi, Experimental",
          "character": "Filtered, darker hihat",
          "params": [
            {
              "name": "amp",
              "default": 1
            },
            {
              "name": "cutoff",
              "default": 5000
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"hihat_filtered\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .param(\"cutoff\", 5000.0)\n        .body(|amp, cutoff| {\n            // Medium envelope\n            let env = envelope()\n                .perc(0.001, 0.1)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise\n            let noise = white_noise_ar();\n\n            // Variable filter cutoff for darker/brighter character\n            let filtered = hpf_ar(noise, cutoff);\n\n            // Additional resonant filter\n            let resonant = rlpf_ar(filtered, cutoff * 1.5, 0.4);\n\n            resonant * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "hihats",
          "path": "drums/hihats/hihat_filtered.vibe"
        },
        {
          "name": "hihat_long",
          "description": "Genre: Ambient, Downtempo | Character: Long decay, washy",
          "genre": "Ambient, Downtempo",
          "character": "Long decay, washy",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"hihat_long\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Long envelope for washy character\n            let env = envelope()\n                .perc(0.002, 0.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix of white and pink noise for texture\n            let white = white_noise_ar() * 0.6;\n            let pink = pink_noise_ar() * 0.4;\n            let noise = white + pink;\n\n            // Moderate high-pass\n            let filtered = hpf_ar(noise, 7000.0);\n\n            // Add shimmer with resonance\n            let shimmer = rlpf_ar(filtered, 10000.0, 0.5);\n\n            shimmer * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "hihats",
          "path": "drums/hihats/hihat_long.vibe"
        },
        {
          "name": "hihat_metallic",
          "description": "Genre: Experimental, IDM | Character: Metallic, inharmonic frequencies",
          "genre": "Experimental, IDM",
          "character": "Metallic, inharmonic frequencies",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"hihat_metallic\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Medium envelope\n            let env = envelope()\n                .perc(0.0005, 0.08)\n                .cleanup_on_finish()\n                .build();\n\n            // Inharmonic frequency ratios for metallic character\n            let osc1 = saw_ar(287.0);\n            let osc2 = saw_ar(413.0);\n            let osc3 = saw_ar(571.0);\n            let osc4 = saw_ar(689.0);\n            let osc5 = saw_ar(823.0);\n            let osc6 = saw_ar(971.0);\n\n            let mix_osc = (osc1 + osc2 + osc3 + osc4 + osc5 + osc6) * 0.16;\n\n            // Band-pass for metallic ring\n            let filtered = rlpf_ar(mix_osc, 9000.0, 0.3);\n\n            filtered * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "hihats",
          "path": "drums/hihats/hihat_metallic.vibe"
        },
        {
          "name": "hihat_short",
          "description": "Genre: Techno, Minimal | Character: Very short, click-like",
          "genre": "Techno, Minimal",
          "character": "Very short, click-like",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"hihat_short\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Very short envelope\n            let env = envelope()\n                .perc(0.0002, 0.025)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise\n            let noise = white_noise_ar();\n\n            // Extreme high-pass for click character\n            let filtered = hpf_ar(noise, 12000.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "hihats",
          "path": "drums/hihats/hihat_short.vibe"
        },
        {
          "name": "hihat_splash",
          "description": "Genre: Rock, Jazz | Character: Splash cymbal, bright and long",
          "genre": "Rock, Jazz",
          "character": "Splash cymbal, bright and long",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"hihat_splash\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Long, complex envelope\n            let env = envelope()\n                .perc(0.005, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix multiple noise colors for complex texture\n            let white = white_noise_ar() * 0.5;\n            let pink = pink_noise_ar() * 0.3;\n            let noise = white + pink;\n\n            // Multiple filter bands for complex spectrum\n            let high = hpf_ar(noise, 8000.0) * 0.7;\n            let mid = rlpf_ar(noise, 6000.0, 0.6) * 0.3;\n\n            let mix = high + mid;\n\n            mix * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "hihats",
          "path": "drums/hihats/hihat_splash.vibe"
        }
      ],
      "Kicks": [
        {
          "name": "kick_808",
          "description": "Classic 808, deep sub bass with pitch decay",
          "genre": "Hip-hop, Trap",
          "character": "Classic 808, deep sub bass with pitch decay",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Hip-hop, Trap | Character: Classic 808, deep sub bass with pitch decay\ndefine_synthdef(\"kick_808\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Main amplitude envelope - 808 character (fixed at 0.5s decay)\n        let amp_env = envelope()\n            .perc(0.001, 0.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope - classic 808 pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let freq_mod = pitch_env * freq * 3.0;\n\n        // Main sine tone\n        let sig = sin_osc_ar(freq + freq_mod) * amp_env;\n\n        // Add subtle click for attack definition\n        let click_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let click = white_noise_ar() * click_env * 0.05;\n\n        (sig + click) * amp\n    });\n\n",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_808.vibe"
        },
        {
          "name": "kick_909",
          "description": "Genre: House, Techno | Character: Classic 909, tight and punchy",
          "genre": "House, Techno",
          "character": "Classic 909, tight and punchy",
          "params": [
            {
              "name": "freq",
              "default": 65
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"kick_909\", |builder| {\n    builder\n        .param(\"freq\", 65.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Tight amplitude envelope\n            let amp_env = envelope()\n                .perc(0.001, 0.25)\n                .cleanup_on_finish()\n                .build();\n\n            // Shorter pitch sweep than 808\n            let pitch_env = envelope()\n                .perc(0.001, 0.04)\n                .build();\n            let freq_mod = pitch_env * freq * 2.5;\n\n            // Main tone\n            let sig = sin_osc_ar(freq + freq_mod) * amp_env;\n\n            // More pronounced click for 909 character\n            let click_env = envelope()\n                .perc(0.0001, 0.008)\n                .build();\n            let click = white_noise_ar() * click_env * 0.15;\n\n            (sig + click) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_909.vibe"
        },
        {
          "name": "kick_acoustic",
          "description": "Genre: Jazz, Acoustic | Character: Natural-sounding, warm",
          "genre": "Jazz, Acoustic",
          "character": "Natural-sounding, warm",
          "params": [
            {
              "name": "freq",
              "default": 80
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"kick_acoustic\", |builder| {\n    builder\n        .param(\"freq\", 80.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Natural decay curve\n            let amp_env = envelope()\n                .perc(0.002, 0.4)\n                .cleanup_on_finish()\n                .build();\n\n            // Subtle pitch bend\n            let pitch_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n            let freq_mod = pitch_env * freq * 1.5;\n\n            // Mix of sine and triangle for warmth\n            let sig = sin_osc_ar(freq + freq_mod) * 0.7;\n            let harmonic = sin_osc_ar((freq + freq_mod) * 2.0) * 0.15;\n\n            // Noise component for beater attack\n            let noise_env = envelope()\n                .perc(0.001, 0.025)\n                .build();\n            let noise = white_noise_ar() * noise_env * 0.12;\n            let filtered_noise = lpf_ar(noise, 3000.0);\n\n            (sig + harmonic + filtered_noise) * amp_env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_acoustic.vibe"
        },
        {
          "name": "kick_boomy",
          "description": "Room-y acoustic kick with natural boom",
          "genre": "Rock, Acoustic, Live",
          "character": "Room-y acoustic kick with natural boom",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Rock, Acoustic, Live | Character: Room-y acoustic kick with natural boom\ndefine_synthdef(\"kick_boomy\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Long, boomy decay\n        let amp_env = envelope()\n            .perc(0.002, 0.55)\n            .cleanup_on_finish()\n            .build();\n\n        // Natural pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let freq_mod = pitch_env * freq * 1.8;\n\n        // Main body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n\n        // Room resonance\n        let room = sin_osc_ar(freq * 0.5) * 0.2;\n\n        // Beater attack\n        let attack_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 1200.0, 0.5) * attack_env * 0.25;\n\n        (body + room + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_boomy.vibe"
        },
        {
          "name": "kick_click",
          "description": "Punchy click kick for driving rhythms",
          "genre": "Tech House, Minimal",
          "character": "Punchy click kick for driving rhythms",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Tech House, Minimal | Character: Punchy click kick for driving rhythms\ndefine_synthdef(\"kick_click\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Tight decay\n        let amp_env = envelope()\n            .perc(0.001, 0.3)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.04)\n            .build();\n        let freq_mod = pitch_env * freq * 4.0;\n\n        // Body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n\n        // Prominent click\n        let click_env = envelope()\n            .perc(0.0001, 0.015)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 4000.0, 0.3) * click_env * 0.4;\n\n        (body + click) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_click.vibe"
        },
        {
          "name": "kick_distorted",
          "description": "Genre: Industrial, Hardcore | Character: Heavy distortion, aggressive",
          "genre": "Industrial, Hardcore",
          "character": "Heavy distortion, aggressive",
          "params": [
            {
              "name": "freq",
              "default": 58
            },
            {
              "name": "amp",
              "default": 1
            },
            {
              "name": "drive",
              "default": 2.5
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"kick_distorted\", |builder| {\n    builder\n        .param(\"freq\", 58.0)\n        .param(\"amp\", 1.0)\n        .param(\"drive\", 2.5)\n        .body(|freq, amp, drive| {\n            // Punchy envelope\n            let amp_env = envelope()\n                .perc(0.001, 0.28)\n                .cleanup_on_finish()\n                .build();\n\n            // Aggressive pitch sweep\n            let pitch_env = envelope()\n                .perc(0.001, 0.04)\n                .build();\n            let freq_mod = pitch_env * freq * 3.5;\n\n            // Main tone with overdrive\n            let sig = sin_osc_ar(freq + freq_mod) * drive;\n\n            // Hard clipping for distortion\n            let distorted = clip(sig, -0.6, 0.6);\n\n            // Add harmonics through filtering\n            let filtered = lpf_ar(distorted, 2000.0);\n\n            // Heavy click/noise\n            let click_env = envelope()\n                .perc(0.0001, 0.015)\n                .build();\n            let click = white_noise_ar() * click_env * 0.3;\n\n            (filtered + click) * amp_env * amp * 0.6\n        })\n});",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_distorted.vibe"
        },
        {
          "name": "kick_dnb",
          "description": "Genre: Drum & Bass, Jungle | Character: Fast, tight, sub-focused",
          "genre": "Drum & Bass, Jungle",
          "character": "Fast, tight, sub-focused",
          "params": [
            {
              "name": "freq",
              "default": 70
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"kick_dnb\", |builder| {\n    builder\n        .param(\"freq\", 70.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Very short envelope for fast BPM\n            let amp_env = envelope()\n                .perc(0.001, 0.15)\n                .cleanup_on_finish()\n                .build();\n\n            // Quick pitch sweep\n            let pitch_env = envelope()\n                .perc(0.0005, 0.025)\n                .build();\n            let freq_mod = pitch_env * freq * 2.0;\n\n            // Tight main tone\n            let sig = sin_osc_ar(freq + freq_mod);\n\n            // Sub layer for weight\n            let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.4;\n\n            // Sharp click for definition\n            let click_env = envelope()\n                .perc(0.0001, 0.006)\n                .build();\n            let click = white_noise_ar() * click_env * 0.2;\n\n            (sig + sub + click) * amp_env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_dnb.vibe"
        },
        {
          "name": "kick_fm",
          "description": "Genre: Experimental, IDM | Character: FM-style harmonics, metallic",
          "genre": "Experimental, IDM",
          "character": "FM-style harmonics, metallic",
          "params": [
            {
              "name": "freq",
              "default": 60
            },
            {
              "name": "amp",
              "default": 1
            },
            {
              "name": "fm_amount",
              "default": 3
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"kick_fm\", |builder| {\n    builder\n        .param(\"freq\", 60.0)\n        .param(\"amp\", 1.0)\n        .param(\"fm_amount\", 3.0)\n        .body(|freq, amp, fm_amount| {\n            // Medium envelope\n            let amp_env = envelope()\n                .perc(0.001, 0.35)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope\n            let pitch_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n            let freq_mod = pitch_env * freq * 2.5;\n\n            // FM modulation envelope\n            let fm_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n\n            // Carrier and modulator\n            let modulator = sin_osc_ar((freq + freq_mod) * 1.5) * fm_env * freq * fm_amount;\n            let carrier = sin_osc_ar(freq + freq_mod + modulator);\n\n            // Click\n            let click_env = envelope()\n                .perc(0.0001, 0.006)\n                .build();\n            let click = white_noise_ar() * click_env * 0.1;\n\n            (carrier + click) * amp_env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_fm.vibe"
        },
        {
          "name": "kick_gabber",
          "description": "Distorted, aggressive gabber kick",
          "genre": "Hardcore, Gabber",
          "character": "Distorted, aggressive gabber kick",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Hardcore, Gabber | Character: Distorted, aggressive gabber kick\ndefine_synthdef(\"kick_gabber\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 1.0)\n    .param(\"drive\", 4.0)\n    .body(|freq, amp, drive| {\n        // Long decay for that gabber punch\n        let amp_env = envelope()\n            .perc(0.001, 0.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Extended pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.12)\n            .build();\n        let freq_mod = pitch_env * freq * 8.0;\n\n        // Main body\n        let raw = sin_osc_ar(freq + freq_mod);\n\n        // Heavy distortion\n        let distorted = (raw * drive).tanh();\n\n        // Click\n        let click_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 3000.0, 0.5) * click_env * 0.3;\n\n        (distorted + click) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_gabber.vibe"
        },
        {
          "name": "kick_jungle",
          "description": "Pitched, punchy jungle kick",
          "genre": "Jungle, Drum & Bass",
          "character": "Pitched, punchy jungle kick",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Jungle, Drum & Bass | Character: Pitched, punchy jungle kick\ndefine_synthdef(\"kick_jungle\")\n    .param(\"freq\", 70.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Short, punchy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Sharp pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let freq_mod = pitch_env * freq * 5.0;\n\n        // Punchy body\n        let body = sin_osc_ar(freq + freq_mod) * 0.85;\n\n        // Attack transient\n        let attack_env = envelope()\n            .perc(0.0001, 0.006)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 2000.0) * attack_env * 0.2;\n\n        (body + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_jungle.vibe"
        },
        {
          "name": "kick_layered",
          "description": "Pre-layered kick stack with sub, mid, and click",
          "genre": "Modern Production",
          "character": "Pre-layered kick stack with sub, mid, and click",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Modern Production | Character: Pre-layered kick stack with sub, mid, and click\ndefine_synthdef(\"kick_layered\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 1.0)\n    .param(\"sub_level\", 0.6)\n    .param(\"click_level\", 0.5)\n    .body(|freq, amp, sub_level, click_level| {\n        // Main body envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Sub layer (long, deep)\n        let sub_env = envelope()\n            .perc(0.005, 0.5)\n            .build();\n        let sub = sin_osc_ar(freq * 0.5) * sub_env * sub_level * 0.5;\n\n        // Mid/punch layer\n        let punch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let punch_freq = freq + punch_env * freq * 4.0;\n        let punch = sin_osc_ar(punch_freq) * 0.6;\n\n        // Click layer\n        let click_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 3500.0, 0.4) * click_env * click_level * 0.4;\n\n        (sub + punch + click) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_layered.vibe"
        },
        {
          "name": "kick_lofi",
          "description": "Warm, dusty lo-fi kick",
          "genre": "Lo-fi Hip-hop, Chillhop",
          "character": "Warm, dusty lo-fi kick",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Lo-fi Hip-hop, Chillhop | Character: Warm, dusty lo-fi kick\ndefine_synthdef(\"kick_lofi\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Soft decay\n        let amp_env = envelope()\n            .perc(0.003, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Gentle pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.06)\n            .build();\n        let freq_mod = pitch_env * freq * 2.0;\n\n        // Warm body with slight saturation\n        let raw = sin_osc_ar(freq + freq_mod);\n        let body = lpf_ar((raw * 1.2).tanh(), 2000.0) * 0.8;\n\n        // Soft attack\n        let attack_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 1500.0) * attack_env * 0.12;\n\n        (body + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_lofi.vibe"
        },
        {
          "name": "kick_pitched",
          "description": "Genre: House, Melodic Techno | Character: Tonal kick with clear pitch",
          "genre": "House, Melodic Techno",
          "character": "Tonal kick with clear pitch",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"kick_pitched\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Medium decay to hear pitch\n            let amp_env = envelope()\n                .perc(0.001, 0.35)\n                .cleanup_on_finish()\n                .build();\n\n            // Minimal pitch sweep to retain tonality\n            let pitch_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let freq_mod = pitch_env * freq * 0.8;\n\n            // Main tone with harmonic\n            let sig = sin_osc_ar(freq + freq_mod);\n            let harmonic = sin_osc_ar((freq + freq_mod) * 2.0) * 0.2;\n\n            // Light click\n            let click_env = envelope()\n                .perc(0.0001, 0.005)\n                .build();\n            let click = white_noise_ar() * click_env * 0.08;\n\n            (sig + harmonic + click) * amp_env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_pitched.vibe"
        },
        {
          "name": "kick_punchy",
          "description": "Modern pop kick with controlled punch",
          "genre": "Pop, Modern",
          "character": "Modern pop kick with controlled punch",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Pop, Modern | Character: Modern pop kick with controlled punch\ndefine_synthdef(\"kick_punchy\")\n    .param(\"freq\", 52.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Controlled decay\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Tight pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.035)\n            .build();\n        let freq_mod = pitch_env * freq * 5.0;\n\n        // Punchy body\n        let body = sin_osc_ar(freq + freq_mod) * 0.85;\n\n        // Mid punch\n        let mid_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let mid = sin_osc_ar(freq * 2.5) * mid_env * 0.15;\n\n        // Click\n        let click_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 2800.0, 0.5) * click_env * 0.2;\n\n        (body + mid + click) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_punchy.vibe"
        },
        {
          "name": "kick_reggaeton",
          "description": "Tight, punchy dembow-style kick",
          "genre": "Reggaeton, Dembow",
          "character": "Tight, punchy dembow-style kick",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Reggaeton, Dembow | Character: Tight, punchy dembow-style kick\ndefine_synthdef(\"kick_reggaeton\")\n    .param(\"freq\", 58.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Short, tight decay\n        let amp_env = envelope()\n            .perc(0.001, 0.28)\n            .cleanup_on_finish()\n            .build();\n\n        // Quick pitch drop\n        let pitch_env = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let freq_mod = pitch_env * freq * 4.5;\n\n        // Punchy body\n        let body = sin_osc_ar(freq + freq_mod) * 0.85;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 3000.0, 0.4) * attack_env * 0.2;\n\n        (body + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_reggaeton.vibe"
        },
        {
          "name": "kick_soft",
          "description": "Genre: Ambient, Chillout | Character: Soft, gentle, minimal attack",
          "genre": "Ambient, Chillout",
          "character": "Soft, gentle, minimal attack",
          "params": [
            {
              "name": "freq",
              "default": 75
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"kick_soft\", |builder| {\n    builder\n        .param(\"freq\", 75.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Gentle attack and decay\n            let amp_env = envelope()\n                .perc(0.01, 0.45)\n                .cleanup_on_finish()\n                .build();\n\n            // Subtle pitch movement\n            let pitch_env = envelope()\n                .perc(0.005, 0.06)\n                .build();\n            let freq_mod = pitch_env * freq * 1.2;\n\n            // Warm sine tone\n            let sig = sin_osc_ar(freq + freq_mod);\n\n            // Add subtle warmth with low harmonic\n            let harmonic = sin_osc_ar((freq + freq_mod) * 1.5) * 0.1;\n\n            // Very soft click - barely noticeable\n            let click_env = envelope()\n                .perc(0.002, 0.008)\n                .build();\n            let click = pink_noise_ar() * click_env * 0.03;\n            let filtered_click = lpf_ar(click, 4000.0);\n\n            (sig + harmonic + filtered_click) * amp_env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_soft.vibe"
        },
        {
          "name": "kick_sub",
          "description": "Genre: Dubstep, Bass Music | Character: Pure sub bass, minimal harmonics",
          "genre": "Dubstep, Bass Music",
          "character": "Pure sub bass, minimal harmonics",
          "params": [
            {
              "name": "freq",
              "default": 40
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"kick_sub\", |builder| {\n    builder\n        .param(\"freq\", 40.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Medium-long decay for sub presence\n            let amp_env = envelope()\n                .perc(0.005, 0.55)\n                .cleanup_on_finish()\n                .build();\n\n            // Gentle pitch sweep\n            let pitch_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let freq_mod = pitch_env * freq * 2.0;\n\n            // Pure sine wave for clean sub\n            let sig = sin_osc_ar(freq + freq_mod);\n\n            // Very minimal click - just for timing reference\n            let click_env = envelope()\n                .perc(0.0001, 0.002)\n                .build();\n            let click = white_noise_ar() * click_env * 0.02;\n            let filtered_click = lpf_ar(click, 8000.0);\n\n            (sig + filtered_click) * amp_env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_sub.vibe"
        },
        {
          "name": "kick_techno_deep",
          "description": "Genre: Techno, Deep House | Character: Deep, sub-heavy, long decay",
          "genre": "Techno, Deep House",
          "character": "Deep, sub-heavy, long decay",
          "params": [
            {
              "name": "freq",
              "default": 45
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"kick_techno_deep\", |builder| {\n    builder\n        .param(\"freq\", 45.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Longer envelope for techno groove\n            let amp_env = envelope()\n                .perc(0.005, 0.6)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope\n            let pitch_env = envelope()\n                .perc(0.001, 0.06)\n                .build();\n            let freq_mod = pitch_env * freq * 2.8;\n\n            // Main tone\n            let sig = sin_osc_ar(freq + freq_mod);\n\n            // Add sub harmonic for extra depth\n            let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.3;\n\n            // Minimal click\n            let click_env = envelope()\n                .perc(0.0001, 0.003)\n                .build();\n            let click = white_noise_ar() * click_env * 0.03;\n\n            (sig + sub + click) * amp_env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_techno_deep.vibe"
        },
        {
          "name": "kick_techno_hard",
          "description": "Genre: Hard Techno, Industrial | Character: Aggressive, distorted, punchy",
          "genre": "Hard Techno, Industrial",
          "character": "Aggressive, distorted, punchy",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"kick_techno_hard\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Sharp, aggressive envelope\n            let amp_env = envelope()\n                .perc(0.001, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Aggressive pitch sweep\n            let pitch_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let freq_mod = pitch_env * freq * 4.0;\n\n            // Main tone with more drive\n            let sig = sin_osc_ar(freq + freq_mod) * 1.5;\n\n            // Clip for distortion character\n            let distorted = clip(sig, -0.8, 0.8);\n\n            // Prominent click/noise layer\n            let click_env = envelope()\n                .perc(0.0001, 0.012)\n                .build();\n            let click = white_noise_ar() * click_env * 0.25;\n\n            (distorted + click) * amp_env * amp * 0.7\n        })\n});",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_techno_hard.vibe"
        },
        {
          "name": "kick_trap",
          "description": "Genre: Trap, Hip-hop | Character: Boomy 808-style with extra low end",
          "genre": "Trap, Hip-hop",
          "character": "Boomy 808-style with extra low end",
          "params": [
            {
              "name": "freq",
              "default": 50
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"kick_trap\", |builder| {\n    builder\n        .param(\"freq\", 50.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Long, boomy envelope\n            let amp_env = envelope()\n                .perc(0.001, 0.7)\n                .cleanup_on_finish()\n                .build();\n\n            // Extended pitch sweep for trap character\n            let pitch_env = envelope()\n                .perc(0.001, 0.12)\n                .build();\n            let freq_mod = pitch_env * freq * 3.5;\n\n            // Main tone\n            let sig = sin_osc_ar(freq + freq_mod);\n\n            // Heavy sub layer\n            let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.5;\n\n            // Minimal click\n            let click_env = envelope()\n                .perc(0.0001, 0.004)\n                .build();\n            let click = white_noise_ar() * click_env * 0.04;\n\n            (sig + sub + click) * amp_env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "kicks",
          "path": "drums/kicks/kick_trap.vibe"
        }
      ],
      "Latin": [
        {
          "name": "agogo_high",
          "description": "High-pitched agogo bell",
          "genre": "Brazilian, Samba, Latin",
          "character": "High-pitched agogo bell",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Brazilian, Samba, Latin | Character: High-pitched agogo bell\ndefine_synthdef(\"agogo_high\")\n    .param(\"freq\", 900.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Metallic ring decay\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Bell harmonics\n        let body = sin_osc_ar(freq) * 0.5;\n        let ring1 = sin_osc_ar(freq * 2.4) * 0.25;\n        let ring2 = sin_osc_ar(freq * 3.8) * 0.15;\n        let ring3 = sin_osc_ar(freq * 5.2) * 0.08;\n\n        // Stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.002)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 4000.0) * attack_env * 0.2;\n\n        (body + ring1 + ring2 + ring3 + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/agogo_high.vibe"
        },
        {
          "name": "agogo_low",
          "description": "Low-pitched agogo bell",
          "genre": "Brazilian, Samba, Latin",
          "character": "Low-pitched agogo bell",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Brazilian, Samba, Latin | Character: Low-pitched agogo bell\ndefine_synthdef(\"agogo_low\")\n    .param(\"freq\", 600.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Longer metallic decay\n        let amp_env = envelope()\n            .perc(0.001, 0.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Bell harmonics\n        let body = sin_osc_ar(freq) * 0.55;\n        let ring1 = sin_osc_ar(freq * 2.3) * 0.22;\n        let ring2 = sin_osc_ar(freq * 3.6) * 0.12;\n\n        // Stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 6000.0) * attack_env * 0.18;\n\n        (body + ring1 + ring2 + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/agogo_low.vibe"
        },
        {
          "name": "berimbau",
          "description": "Musical bow with gourd resonator",
          "genre": "Brazilian, Capoeira",
          "character": "Musical bow with gourd resonator",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Brazilian, Capoeira | Character: Musical bow with gourd resonator\ndefine_synthdef(\"berimbau\")\n    .param(\"freq\", 120.0)\n    .param(\"amp\", 0.7)\n    .param(\"open\", 1.0)\n    .body(|freq, amp, open| {\n        // Decay length based on open/closed\n        let decay_time = 0.2 + (open * 0.4);\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay_time)\n            .cleanup_on_finish()\n            .build();\n\n        // Wire string with harmonics\n        let body = sin_osc_ar(freq) * 0.5;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.25;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.15;\n        let harm3 = sin_osc_ar(freq * 4.0) * 0.08;\n\n        // Gourd resonance (filter based on open/closed)\n        let cutoff = 400.0 + (open * 2000.0);\n        let resonated = lpf_ar(body + harm1 + harm2 + harm3, cutoff);\n\n        // Stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 2000.0, 0.5) * attack_env * 0.2;\n\n        (resonated + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/berimbau.vibe"
        },
        {
          "name": "bongo_high",
          "description": "Bright, crisp bongo with sharp attack",
          "genre": "Latin, Cuban, World",
          "character": "Bright, crisp bongo with sharp attack",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Cuban, World | Character: Bright, crisp bongo with sharp attack\ndefine_synthdef(\"bongo_high\")\n    .param(\"freq\", 500.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Short decay\n        let amp_env = envelope()\n            .perc(0.001, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch bend\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let freq_mod = pitch_env * freq * 3.0;\n\n        // Bright tone\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let overtone1 = sin_osc_ar((freq + freq_mod) * 2.3) * 0.25;\n        let overtone2 = sin_osc_ar((freq + freq_mod) * 3.7) * 0.1;\n\n        // Crisp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 3000.0) * attack_env * 0.15;\n\n        (body + overtone1 + overtone2 + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/bongo_high.vibe"
        },
        {
          "name": "bongo_low",
          "description": "Deeper bongo with warm tone",
          "genre": "Latin, Cuban, World",
          "character": "Deeper bongo with warm tone",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Cuban, World | Character: Deeper bongo with warm tone\ndefine_synthdef(\"bongo_low\")\n    .param(\"freq\", 350.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Medium decay\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let freq_mod = pitch_env * freq * 2.0;\n\n        // Warm body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n        let overtone = sin_osc_ar((freq + freq_mod) * 2.1) * 0.2;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.006)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 4000.0) * attack_env * 0.12;\n\n        (body + overtone + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/bongo_low.vibe"
        },
        {
          "name": "cabasa",
          "description": "Metal beads against shell texture",
          "genre": "Latin, Brazilian, Samba",
          "character": "Metal beads against shell texture",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Brazilian, Samba | Character: Metal beads against shell texture\ndefine_synthdef(\"cabasa\")\n    .param(\"freq\", 7000.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        // Short, swishing envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Bead rattle texture\n        let rattle_rate = 80.0;\n        let rattle = sin_osc_ar(rattle_rate) * 0.3 + 0.7;\n\n        // High-frequency metallic noise\n        let beads = hpf_ar(white_noise_ar(), freq);\n        let body = bpf_ar(white_noise_ar(), freq * 0.6, 0.5) * 0.4;\n\n        (beads + body) * rattle * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/cabasa.vibe"
        },
        {
          "name": "cajon",
          "description": "Wooden box drum bass tone",
          "genre": "Flamenco, Latin, Acoustic",
          "character": "Wooden box drum bass tone",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Flamenco, Latin, Acoustic | Character: Wooden box drum bass tone\ndefine_synthdef(\"cajon\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Wood resonance decay\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.04)\n            .build();\n        let freq_mod = pitch_env * freq * 1.5;\n\n        // Bass body\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.2;\n\n        // Wood character\n        let wood_env = envelope()\n            .perc(0.001, 0.1)\n            .build();\n        let wood = bpf_ar(white_noise_ar(), 400.0, 0.3) * wood_env * 0.25;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 2000.0) * attack_env * 0.2;\n\n        (body + sub + wood + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/cajon.vibe"
        },
        {
          "name": "cajon_slap",
          "description": "Cajon slap/edge hit with snare wires",
          "genre": "Flamenco, Latin, Acoustic",
          "character": "Cajon slap/edge hit with snare wires",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Flamenco, Latin, Acoustic | Character: Cajon slap/edge hit with snare wires\ndefine_synthdef(\"cajon_slap\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Short, snappy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Higher pitched slap\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.4;\n\n        // Snare wire buzz\n        let wire_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n        let wires = hpf_ar(white_noise_ar(), 3000.0) * wire_env * 0.3;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.35;\n\n        (body + wires + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/cajon_slap.vibe"
        },
        {
          "name": "conga_high",
          "description": "High-pitched conga slap with bright attack",
          "genre": "Latin, Salsa, Afro-Cuban",
          "character": "High-pitched conga slap with bright attack",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Salsa, Afro-Cuban | Character: High-pitched conga slap with bright attack\ndefine_synthdef(\"conga_high\")\n    .param(\"freq\", 350.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Main body envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope for that conga \"pop\"\n        let pitch_env = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let freq_mod = pitch_env * freq * 2.0;\n\n        // Main tone - combination of sine and resonant body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n        let overtone = sin_osc_ar((freq + freq_mod) * 2.1) * 0.2;\n        let click = sin_osc_ar((freq + freq_mod) * 3.5) * 0.1;\n\n        // Attack transient\n        let attack_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.15;\n\n        (body + overtone + click + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/conga_high.vibe"
        },
        {
          "name": "conga_low",
          "description": "Deep conga tone with warm resonance",
          "genre": "Latin, Salsa, Afro-Cuban",
          "character": "Deep conga tone with warm resonance",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Salsa, Afro-Cuban | Character: Deep conga tone with warm resonance\ndefine_synthdef(\"conga_low\")\n    .param(\"freq\", 180.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Longer decay for low conga\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 1.5;\n\n        // Warm body tone\n        let body = sin_osc_ar(freq + freq_mod) * 0.8;\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.15;\n        let overtone = sin_osc_ar((freq + freq_mod) * 2.0) * 0.1;\n\n        // Soft attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 2000.0) * attack_env * 0.1;\n\n        (body + sub + overtone + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/conga_low.vibe"
        },
        {
          "name": "conga_muted",
          "description": "Muted conga with short, dry attack",
          "genre": "Latin, Salsa, Afro-Cuban",
          "character": "Muted conga with short, dry attack",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Salsa, Afro-Cuban | Character: Muted conga with short, dry attack\ndefine_synthdef(\"conga_muted\")\n    .param(\"freq\", 260.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Very short decay for muted sound\n        let amp_env = envelope()\n            .perc(0.001, 0.08)\n            .cleanup_on_finish()\n            .build();\n\n        // Quick pitch drop\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let freq_mod = pitch_env * freq * 1.0;\n\n        // Dry, muted tone\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let click = sin_osc_ar((freq + freq_mod) * 2.5) * 0.3;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 1500.0) * attack_env * 0.2;\n\n        (body + click + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/conga_muted.vibe"
        },
        {
          "name": "cuica",
          "description": "Friction drum with squeaky voice-like quality",
          "genre": "Brazilian, Samba",
          "character": "Friction drum with squeaky voice-like quality",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Brazilian, Samba | Character: Friction drum with squeaky voice-like quality\ndefine_synthdef(\"cuica\")\n    .param(\"freq\", 400.0)\n    .param(\"amp\", 0.7)\n    .param(\"bend\", 200.0)\n    .body(|freq, amp, bend| {\n        // Envelope\n        let amp_env = envelope()\n            .perc(0.01, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch bend envelope for characteristic \"voice\"\n        let bend_env = envelope()\n            .perc(0.01, 0.2)\n            .build();\n        let pitch = freq + (bend_env * bend);\n\n        // Main tone with slight instability\n        let wobble = sin_osc_ar(8.0) * 5.0;\n        let body = sin_osc_ar(pitch + wobble) * 0.7;\n        let overtone = sin_osc_ar((pitch + wobble) * 2.0) * 0.2;\n\n        // Friction texture\n        let friction = lpf_ar(white_noise_ar(), 1500.0) * 0.1;\n\n        (body + overtone + friction) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/cuica.vibe"
        },
        {
          "name": "guiro",
          "description": "Scraped guiro with ridged texture",
          "genre": "Latin, Caribbean, World",
          "character": "Scraped guiro with ridged texture",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Caribbean, World | Character: Scraped guiro with ridged texture\ndefine_synthdef(\"guiro\")\n    .param(\"freq\", 3000.0)\n    .param(\"amp\", 0.6)\n    .param(\"length\", 0.3)\n    .body(|freq, amp, length| {\n        // Scraping duration envelope\n        let amp_env = envelope()\n            .perc(0.01, 1.0)\n            .time_scale(length)\n            .cleanup_on_finish()\n            .build();\n\n        // Ridged texture using amplitude modulation\n        let ridge_rate = 40.0;\n        let ridges = sin_osc_ar(ridge_rate) * 0.5 + 0.5;\n\n        // Filtered noise for scraping sound\n        let scrape = bpf_ar(white_noise_ar(), freq, 0.3);\n        let body = bpf_ar(white_noise_ar(), freq * 0.5, 0.5) * 0.3;\n\n        (scrape + body) * ridges * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/guiro.vibe"
        },
        {
          "name": "guiro_short",
          "description": "Short guiro accent",
          "genre": "Latin, Caribbean, World",
          "character": "Short guiro accent",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Caribbean, World | Character: Short guiro accent\ndefine_synthdef(\"guiro_short\")\n    .param(\"freq\", 3500.0)\n    .param(\"amp\", 0.6)\n    .body(|freq, amp| {\n        // Quick scrape\n        let amp_env = envelope()\n            .perc(0.005, 0.08)\n            .cleanup_on_finish()\n            .build();\n\n        // Fast ridges\n        let ridge_rate = 60.0;\n        let ridges = sin_osc_ar(ridge_rate) * 0.4 + 0.6;\n\n        // Bright scraping noise\n        let scrape = bpf_ar(white_noise_ar(), freq, 0.4);\n\n        scrape * ridges * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/guiro_short.vibe"
        },
        {
          "name": "maracas",
          "description": "Shaking maracas with seed rattle",
          "genre": "Latin, Caribbean, World",
          "character": "Shaking maracas with seed rattle",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Caribbean, World | Character: Shaking maracas with seed rattle\ndefine_synthdef(\"maracas\")\n    .param(\"freq\", 8000.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        // Quick shake envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.1)\n            .cleanup_on_finish()\n            .build();\n\n        // Seed rattle texture\n        let rattle = dust_ar(200.0) * 0.3 + 0.7;\n\n        // High-frequency noise\n        let seeds = hpf_ar(white_noise_ar(), freq);\n        let shell = bpf_ar(white_noise_ar(), 4000.0, 0.8) * 0.3;\n\n        (seeds + shell) * rattle * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/maracas.vibe"
        },
        {
          "name": "pandeiro",
          "description": "Brazilian tambourine with jingles",
          "genre": "Brazilian, Samba, Choro",
          "character": "Brazilian tambourine with jingles",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Brazilian, Samba, Choro | Character: Brazilian tambourine with jingles\ndefine_synthdef(\"pandeiro\")\n    .param(\"freq\", 300.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Medium decay\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Drum body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq) * 0.4;\n\n        // Jingles (high metallic)\n        let jingle_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n        let jingles = hpf_ar(white_noise_ar(), 6000.0) * jingle_env * 0.35;\n\n        // Attack transient\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + jingles + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/pandeiro.vibe"
        },
        {
          "name": "surdo",
          "description": "Deep bass drum with mallet attack",
          "genre": "Brazilian, Samba",
          "character": "Deep bass drum with mallet attack",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Brazilian, Samba | Character: Deep bass drum with mallet attack\ndefine_synthdef(\"surdo\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Long, boomy decay\n        let amp_env = envelope()\n            .perc(0.005, 0.6)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let freq_mod = pitch_env * freq * 1.5;\n\n        // Deep body\n        let body = sin_osc_ar(freq + freq_mod) * 0.8;\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.2;\n        let overtone = sin_osc_ar((freq + freq_mod) * 2.0) * 0.1;\n\n        // Mallet thump\n        let attack_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 800.0) * attack_env * 0.3;\n\n        (body + sub + overtone + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/surdo.vibe"
        },
        {
          "name": "timbale_high",
          "description": "Bright, ringing timbale with metallic overtones",
          "genre": "Latin, Salsa, Mambo",
          "character": "Bright, ringing timbale with metallic overtones",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Salsa, Mambo | Character: Bright, ringing timbale with metallic overtones\ndefine_synthdef(\"timbale_high\")\n    .param(\"freq\", 450.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Ringing decay\n        let amp_env = envelope()\n            .perc(0.001, 0.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.01)\n            .build();\n        let freq_mod = pitch_env * freq * 1.5;\n\n        // Metallic body with harmonics\n        let body = sin_osc_ar(freq + freq_mod) * 0.5;\n        let ring1 = sin_osc_ar((freq + freq_mod) * 2.5) * 0.25;\n        let ring2 = sin_osc_ar((freq + freq_mod) * 4.2) * 0.15;\n        let ring3 = sin_osc_ar((freq + freq_mod) * 5.8) * 0.08;\n\n        // Sharp metallic attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 5000.0) * attack_env * 0.2;\n\n        (body + ring1 + ring2 + ring3 + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/timbale_high.vibe"
        },
        {
          "name": "timbale_low",
          "description": "Deeper timbale with warm metallic ring",
          "genre": "Latin, Salsa, Mambo",
          "character": "Deeper timbale with warm metallic ring",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Salsa, Mambo | Character: Deeper timbale with warm metallic ring\ndefine_synthdef(\"timbale_low\")\n    .param(\"freq\", 280.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Long ringing decay\n        let amp_env = envelope()\n            .perc(0.001, 0.6)\n            .cleanup_on_finish()\n            .build();\n\n        // Subtle pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let freq_mod = pitch_env * freq * 1.2;\n\n        // Warm metallic body\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let ring1 = sin_osc_ar((freq + freq_mod) * 2.3) * 0.2;\n        let ring2 = sin_osc_ar((freq + freq_mod) * 3.8) * 0.1;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 6000.0) * attack_env * 0.15;\n\n        (body + ring1 + ring2 + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/timbale_low.vibe"
        },
        {
          "name": "timbale_rim",
          "description": "Cascara/rim pattern stick hit",
          "genre": "Latin, Salsa, Mambo",
          "character": "Cascara/rim pattern stick hit",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Latin, Salsa, Mambo | Character: Cascara/rim pattern stick hit\ndefine_synthdef(\"timbale_rim\")\n    .param(\"freq\", 800.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Short, tight decay\n        let amp_env = envelope()\n            .perc(0.0001, 0.12)\n            .cleanup_on_finish()\n            .build();\n\n        // High metallic ping\n        let body = sin_osc_ar(freq) * 0.4;\n        let ring1 = sin_osc_ar(freq * 2.7) * 0.3;\n        let ring2 = sin_osc_ar(freq * 4.1) * 0.2;\n\n        // Sharp stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.002)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 6000.0) * attack_env * 0.25;\n\n        (body + ring1 + ring2 + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "latin",
          "path": "drums/latin/timbale_rim.vibe"
        }
      ],
      "Machines": [
        {
          "name": "cr78_kick",
          "description": "Roland CR-78 kick - warm, muted analog",
          "genre": "Vintage, New Wave, Synthpop",
          "character": "Roland CR-78 kick - warm, muted analog",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Vintage, New Wave, Synthpop | Character: Roland CR-78 kick - warm, muted analog\ndefine_synthdef(\"cr78_kick\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Soft, warm decay\n        let amp_env = envelope()\n            .perc(0.002, 0.3)\n            .cleanup_on_finish()\n            .build();\n\n        // Gentle pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 2.5;\n\n        // Warm sine body\n        let body = sin_osc_ar(freq + freq_mod);\n\n        // Soft attack\n        let attack_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 1000.0) * attack_env * 0.1;\n\n        (body + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/cr78_kick.vibe"
        },
        {
          "name": "cr78_snare",
          "description": "Roland CR-78 snare - lo-fi, filtered",
          "genre": "Vintage, New Wave, Synthpop",
          "character": "Roland CR-78 snare - lo-fi, filtered",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Vintage, New Wave, Synthpop | Character: Roland CR-78 snare - lo-fi, filtered\ndefine_synthdef(\"cr78_snare\")\n    .param(\"freq\", 180.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Vintage decay\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Body\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.5) * 0.35;\n\n        // Filtered noise\n        let noise_env = envelope()\n            .perc(0.001, 0.18)\n            .build();\n        let noise = bpf_ar(white_noise_ar(), 4000.0, 0.4) * noise_env * 0.5;\n\n        (body + noise) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/cr78_snare.vibe"
        },
        {
          "name": "dmx_kick",
          "description": "Oberheim DMX kick - tight, punchy",
          "genre": "80s Hip-hop, Electro",
          "character": "Oberheim DMX kick - tight, punchy",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: 80s Hip-hop, Electro | Character: Oberheim DMX kick - tight, punchy\ndefine_synthdef(\"dmx_kick\")\n    .param(\"freq\", 52.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Tight decay\n        let amp_env = envelope()\n            .perc(0.001, 0.32)\n            .cleanup_on_finish()\n            .build();\n\n        // Sharp pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 5.0;\n\n        // Punchy body\n        let body = sin_osc_ar(freq + freq_mod) * 0.85;\n\n        // Crisp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.006)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 1500.0) * attack_env * 0.15;\n\n        (body + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/dmx_kick.vibe"
        },
        {
          "name": "dmx_snare",
          "description": "Oberheim DMX snare - sharp, cutting",
          "genre": "80s Hip-hop, Electro",
          "character": "Oberheim DMX snare - sharp, cutting",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: 80s Hip-hop, Electro | Character: Oberheim DMX snare - sharp, cutting\ndefine_synthdef(\"dmx_snare\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Snappy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.22)\n            .cleanup_on_finish()\n            .build();\n\n        // Punchy body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.5) * 0.4;\n\n        // Bright noise\n        let noise_env = envelope()\n            .perc(0.001, 0.18)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 3500.0) * noise_env * 0.55;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/dmx_snare.vibe"
        },
        {
          "name": "linn_kick",
          "description": "LinnDrum kick - punchy, bright attack",
          "genre": "80s Pop, R&B, Hip-hop",
          "character": "LinnDrum kick - punchy, bright attack",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: 80s Pop, R&B, Hip-hop | Character: LinnDrum kick - punchy, bright attack\ndefine_synthdef(\"linn_kick\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Tight, punchy envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.06)\n            .build();\n        let freq_mod = pitch_env * freq * 4.0;\n\n        // Main tone\n        let body = sin_osc_ar(freq + freq_mod) * 0.8;\n\n        // Bright attack click\n        let click_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 2500.0, 0.5) * click_env * 0.25;\n\n        (body + click) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/linn_kick.vibe"
        },
        {
          "name": "linn_snare",
          "description": "LinnDrum snare - bright, crisp, sampled feel",
          "genre": "80s Pop, R&B, Hip-hop",
          "character": "LinnDrum snare - bright, crisp, sampled feel",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: 80s Pop, R&B, Hip-hop | Character: LinnDrum snare - bright, crisp, sampled feel\ndefine_synthdef(\"linn_snare\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Medium decay\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Body tone\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.4;\n\n        // Snare noise\n        let noise_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 2500.0) * noise_env * 0.5;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/linn_snare.vibe"
        },
        {
          "name": "machinedrum_kick",
          "description": "Elektron Machinedrum-style kick - digital, versatile",
          "genre": "IDM, Techno, Experimental",
          "character": "Elektron Machinedrum-style kick - digital, versatile",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: IDM, Techno, Experimental | Character: Elektron Machinedrum-style kick - digital, versatile\ndefine_synthdef(\"machinedrum_kick\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 1.0)\n    .param(\"shape\", 0.5)\n    .body(|freq, amp, shape| {\n        // Adjustable decay\n        let decay = 0.3 + shape * 0.2;\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope with shape control\n        let pitch_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(0.04 + shape * 0.04)\n            .build();\n        let freq_mod = pitch_env * freq * (2.5 + shape * 3.0);\n\n        // Body with waveshaping based on shape\n        let raw = sin_osc_ar(freq + freq_mod);\n        let body = (raw * (1.0 + shape)).tanh() * 0.8;\n\n        // Digital click\n        let click_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let click = hpf_ar(white_noise_ar(), 2000.0) * click_env * shape * 0.2;\n\n        (body + click) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/machinedrum_kick.vibe"
        },
        {
          "name": "machinedrum_snare",
          "description": "Elektron Machinedrum-style snare - digital, morphable",
          "genre": "IDM, Techno, Experimental",
          "character": "Elektron Machinedrum-style snare - digital, morphable",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: IDM, Techno, Experimental | Character: Elektron Machinedrum-style snare - digital, morphable\ndefine_synthdef(\"machinedrum_snare\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.9)\n    .param(\"metallic\", 0.4)\n    .body(|freq, amp, metallic| {\n        // Decay\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.35;\n\n        // Metallic ring (morphable)\n        let ring_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n        let ring = sin_osc_ar(freq * 3.7) * ring_env * metallic * 0.25;\n\n        // Noise\n        let noise_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 3000.0) * noise_env * (0.5 - metallic * 0.2);\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + ring + noise + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/machinedrum_snare.vibe"
        },
        {
          "name": "mpc_kick",
          "description": "MPC-style kick - clean, punchy",
          "genre": "Hip-hop, R&B, Production",
          "character": "MPC-style kick - clean, punchy",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Hip-hop, R&B, Production | Character: MPC-style kick - clean, punchy\ndefine_synthdef(\"mpc_kick\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Clean, tight decay\n        let amp_env = envelope()\n            .perc(0.001, 0.38)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.06)\n            .build();\n        let freq_mod = pitch_env * freq * 4.0;\n\n        // Clean body\n        let body = sin_osc_ar(freq + freq_mod) * 0.85;\n\n        // Subtle sub\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.1;\n\n        // Click\n        let click_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 2000.0, 0.6) * click_env * 0.15;\n\n        (body + sub + click) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/mpc_kick.vibe"
        },
        {
          "name": "mpc_snare",
          "description": "MPC-style snare - versatile, balanced",
          "genre": "Hip-hop, R&B, Production",
          "character": "MPC-style snare - versatile, balanced",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Hip-hop, R&B, Production | Character: MPC-style snare - versatile, balanced\ndefine_synthdef(\"mpc_snare\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Balanced decay\n        let amp_env = envelope()\n            .perc(0.001, 0.24)\n            .cleanup_on_finish()\n            .build();\n\n        // Body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.4;\n\n        // Noise\n        let noise_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 2800.0) * noise_env * 0.5;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.15;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/mpc_snare.vibe"
        },
        {
          "name": "sp1200_kick",
          "description": "E-mu SP-1200 kick - crunchy, 12-bit warmth",
          "genre": "90s Hip-hop, Boom Bap",
          "character": "E-mu SP-1200 kick - crunchy, 12-bit warmth",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: 90s Hip-hop, Boom Bap | Character: E-mu SP-1200 kick - crunchy, 12-bit warmth\ndefine_synthdef(\"sp1200_kick\")\n    .param(\"freq\", 48.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Punchy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.07)\n            .build();\n        let freq_mod = pitch_env * freq * 3.5;\n\n        // Main body with slight saturation (12-bit character)\n        let raw = sin_osc_ar(freq + freq_mod);\n        let body = (raw * 1.2).tanh() * 0.8;\n\n        // Sub layer\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.15;\n\n        // Crunchy click\n        let click_env = envelope()\n            .perc(0.0001, 0.012)\n            .build();\n        let click = lpf_ar(white_noise_ar(), 3000.0) * click_env * 0.2;\n\n        (body + sub + click) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/sp1200_kick.vibe"
        },
        {
          "name": "sp1200_snare",
          "description": "E-mu SP-1200 snare - gritty, lo-fi",
          "genre": "90s Hip-hop, Boom Bap",
          "character": "E-mu SP-1200 snare - gritty, lo-fi",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: 90s Hip-hop, Boom Bap | Character: E-mu SP-1200 snare - gritty, lo-fi\ndefine_synthdef(\"sp1200_snare\")\n    .param(\"freq\", 190.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Medium decay\n        let amp_env = envelope()\n            .perc(0.001, 0.28)\n            .cleanup_on_finish()\n            .build();\n\n        // Body with saturation\n        let pitch_env = envelope()\n            .perc(0.001, 0.025)\n            .build();\n        let raw_body = sin_osc_ar(freq + pitch_env * freq * 2.0);\n        let body = (raw_body * 1.3).tanh() * 0.35;\n\n        // Crunchy noise\n        let noise_env = envelope()\n            .perc(0.001, 0.22)\n            .build();\n        let raw_noise = bpf_ar(white_noise_ar(), 3500.0, 0.5);\n        let noise = (raw_noise * 1.5).tanh() * noise_env * 0.5;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.18;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/sp1200_snare.vibe"
        },
        {
          "name": "tempest_kick",
          "description": "DSI Tempest-style kick - modern analog, deep",
          "genre": "Electronic, Techno",
          "character": "DSI Tempest-style kick - modern analog, deep",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Electronic, Techno | Character: DSI Tempest-style kick - modern analog, deep\ndefine_synthdef(\"tempest_kick\")\n    .param(\"freq\", 48.0)\n    .param(\"amp\", 1.0)\n    .param(\"punch\", 0.7)\n    .body(|freq, amp, punch| {\n        // Deep decay\n        let amp_env = envelope()\n            .perc(0.001, 0.45)\n            .cleanup_on_finish()\n            .build();\n\n        // Aggressive pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(0.04 + punch * 0.03)\n            .build();\n        let freq_mod = pitch_env * freq * (3.0 + punch * 3.0);\n\n        // Thick analog body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.25;\n\n        // Punch click\n        let click_env = envelope()\n            .perc(0.0001, 0.006)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 2500.0, 0.4) * click_env * punch * 0.3;\n\n        (body + sub + click) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/tempest_kick.vibe"
        },
        {
          "name": "tempest_snare",
          "description": "DSI Tempest-style snare - analog synthesis",
          "genre": "Electronic, Techno",
          "character": "DSI Tempest-style snare - analog synthesis",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Electronic, Techno | Character: DSI Tempest-style snare - analog synthesis\ndefine_synthdef(\"tempest_snare\")\n    .param(\"freq\", 210.0)\n    .param(\"amp\", 0.9)\n    .param(\"tone\", 0.5)\n    .body(|freq, amp, tone| {\n        // Snappy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Body with tone control\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.5) * (0.3 + tone * 0.2);\n\n        // Noise layer\n        let noise_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 2500.0 + tone * 2000.0) * noise_env * (0.6 - tone * 0.2);\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.18;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/tempest_snare.vibe"
        },
        {
          "name": "volca_kick",
          "description": "Korg Volca Beats style kick - analog, characterful",
          "genre": "Electronic, Lo-fi",
          "character": "Korg Volca Beats style kick - analog, characterful",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Electronic, Lo-fi | Character: Korg Volca Beats style kick - analog, characterful\ndefine_synthdef(\"volca_kick\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 1.0)\n    .param(\"click\", 0.5)\n    .body(|freq, amp, click| {\n        // Analog-style decay\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 3.0;\n\n        // Analog body with slight waveshaping\n        let raw = sin_osc_ar(freq + freq_mod);\n        let body = (raw * 1.1).tanh() * 0.85;\n\n        // Variable click\n        let click_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let click_sound = bpf_ar(white_noise_ar(), 1800.0, 0.5) * click_env * click * 0.3;\n\n        (body + click_sound) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/volca_kick.vibe"
        },
        {
          "name": "volca_snare",
          "description": "Korg Volca Beats style snare - analog, snappy",
          "genre": "Electronic, Lo-fi",
          "character": "Korg Volca Beats style snare - analog, snappy",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Electronic, Lo-fi | Character: Korg Volca Beats style snare - analog, snappy\ndefine_synthdef(\"volca_snare\")\n    .param(\"freq\", 180.0)\n    .param(\"amp\", 0.8)\n    .param(\"snappy\", 0.6)\n    .body(|freq, amp, snappy| {\n        // Decay envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.22)\n            .cleanup_on_finish()\n            .build();\n\n        // Body\n        let pitch_env = envelope()\n            .perc(0.001, 0.018)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.8) * 0.35;\n\n        // Variable snappiness\n        let noise_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(0.15 + snappy * 0.1)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 2000.0 + snappy * 2000.0) * noise_env * (0.3 + snappy * 0.3);\n\n        (body + noise) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "machines",
          "path": "drums/machines/volca_snare.vibe"
        }
      ],
      "Percussion": [
        {
          "name": "clave",
          "description": "Genre: Latin, House | Character: Wooden clave, sharp and cutting",
          "genre": "Latin, House",
          "character": "Wooden clave, sharp and cutting",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"clave\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Very short, tight envelope\n            let env = envelope()\n                .perc(0.0003, 0.025)\n                .cleanup_on_finish()\n                .build();\n\n            // High-pitched woody tones\n            let tone1 = saw_ar(2600.0) * 0.5;\n            let tone2 = saw_ar(3200.0) * 0.3;\n\n            let mix = tone1 + tone2;\n\n            // High-pass for brightness\n            let filtered = hpf_ar(mix, 2000.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "percussion",
          "path": "drums/percussion/clave.vibe"
        },
        {
          "name": "cowbell",
          "description": "Genre: House, Latin | Character: Classic cowbell, bright and cutting",
          "genre": "House, Latin",
          "character": "Classic cowbell, bright and cutting",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"cowbell\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Medium-short decay\n            let env = envelope()\n                .perc(0.001, 0.12)\n                .cleanup_on_finish()\n                .build();\n\n            // Inharmonic frequencies for metallic bell character\n            let osc1 = saw_ar(540.0) * 0.4;\n            let osc2 = saw_ar(800.0) * 0.35;\n            let osc3 = saw_ar(1060.0) * 0.25;\n\n            let mix = osc1 + osc2 + osc3;\n\n            // Band-pass for bell resonance\n            let filtered = rlpf_ar(mix, 1200.0, 0.4);\n\n            // Add attack click\n            let click_env = envelope()\n                .perc(0.0001, 0.005)\n                .build();\n            let click = white_noise_ar() * click_env * 0.2;\n\n            (filtered + click) * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "percussion",
          "path": "drums/percussion/cowbell.vibe"
        },
        {
          "name": "rim",
          "description": "Genre: All | Character: Rim click/shot, sharp and metallic",
          "genre": "All",
          "character": "Rim click/shot, sharp and metallic",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"rim\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Very short, sharp envelope\n            let env = envelope()\n                .perc(0.0002, 0.035)\n                .cleanup_on_finish()\n                .build();\n\n            // High-frequency metallic tones\n            let tone1 = sin_osc_ar(850.0) * 0.4;\n            let tone2 = sin_osc_ar(1150.0) * 0.3;\n            let tone3 = sin_osc_ar(1420.0) * 0.2;\n\n            // Click component\n            let click = white_noise_ar();\n            let filtered_click = hpf_ar(click, 5000.0) * 0.4;\n\n            (tone1 + tone2 + tone3 + filtered_click) * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "percussion",
          "path": "drums/percussion/rim.vibe"
        },
        {
          "name": "shaker",
          "description": "Genre: Pop, Latin | Character: Shaker, bright and rattling",
          "genre": "Pop, Latin",
          "character": "Shaker, bright and rattling",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"shaker\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Very short, crisp envelope\n            let env = envelope()\n                .perc(0.001, 0.05)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright filtered noise\n            let noise = white_noise_ar();\n            let filtered = hpf_ar(noise, 7000.0);\n\n            // Add resonance for rattle\n            let resonant = rlpf_ar(filtered, 10000.0, 0.4);\n\n            resonant * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "percussion",
          "path": "drums/percussion/shaker.vibe"
        },
        {
          "name": "snap",
          "description": "Finger snap, quick and sharp",
          "genre": "Pop, R&B",
          "character": "Finger snap, quick and sharp",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Pop, R&B | Character: Finger snap, quick and sharp\ndefine_synthdef(\"snap\")\n    .param(\"amp\", 1.0)\n    .body(|amp| {\n        // Very short envelope\n        let env = envelope()\n            .perc(0.0003, 0.035)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright noise component\n        let noise = white_noise_ar();\n        let filtered_noise = hpf_ar(noise, 3000.0) * 0.6;\n\n        // Tonal component for body\n        let tone = sin_osc_ar(1200.0) * 0.4;\n\n        // Very sharp attack click\n        let click_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let click = white_noise_ar() * click_env * 0.3;\n\n        (filtered_noise + tone + click) * env * amp\n    });\n\n",
          "category": "drums",
          "subcategory": "percussion",
          "path": "drums/percussion/snap.vibe"
        },
        {
          "name": "tambourine",
          "description": "Genre: Pop, Rock | Character: Tambourine jingle, bright and sustained",
          "genre": "Pop, Rock",
          "character": "Tambourine jingle, bright and sustained",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"tambourine\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Medium decay for jingle sustain\n            let env = envelope()\n                .perc(0.002, 0.18)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple metallic frequencies\n            let osc1 = saw_ar(6200.0) * 0.3;\n            let osc2 = saw_ar(7400.0) * 0.25;\n            let osc3 = saw_ar(8900.0) * 0.2;\n            let osc4 = saw_ar(10200.0) * 0.15;\n\n            let mix = osc1 + osc2 + osc3 + osc4;\n\n            // High-pass for brightness\n            let filtered = hpf_ar(mix, 5000.0);\n\n            // Add shimmer with band-pass\n            let shimmer = rlpf_ar(filtered, 9000.0, 0.5);\n\n            shimmer * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "percussion",
          "path": "drums/percussion/tambourine.vibe"
        },
        {
          "name": "tom_high",
          "description": "Genre: All | Character: High tom, resonant",
          "genre": "All",
          "character": "High tom, resonant",
          "params": [
            {
              "name": "freq",
              "default": 200
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"tom_high\", |builder| {\n    builder\n        .param(\"freq\", 200.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Medium decay\n            let amp_env = envelope()\n                .perc(0.002, 0.25)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope for tom character\n            let pitch_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let freq_mod = pitch_env * freq * 1.5;\n\n            // Main tone\n            let tone = sin_osc_ar(freq + freq_mod);\n\n            // Add harmonics\n            let harmonic = sin_osc_ar((freq + freq_mod) * 1.5) * 0.2;\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.001, 0.015)\n                .build();\n            let attack = pink_noise_ar() * attack_env * 0.15;\n            let filtered_attack = lpf_ar(attack, 3000.0);\n\n            (tone + harmonic + filtered_attack) * amp_env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "percussion",
          "path": "drums/percussion/tom_high.vibe"
        },
        {
          "name": "tom_low",
          "description": "Genre: All | Character: Low tom, deep and resonant",
          "genre": "All",
          "character": "Low tom, deep and resonant",
          "params": [
            {
              "name": "freq",
              "default": 90
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"tom_low\", |builder| {\n    builder\n        .param(\"freq\", 90.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Longer decay for low tom\n            let amp_env = envelope()\n                .perc(0.004, 0.4)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope\n            let pitch_env = envelope()\n                .perc(0.002, 0.12)\n                .build();\n            let freq_mod = pitch_env * freq * 1.8;\n\n            // Main tone\n            let tone = sin_osc_ar(freq + freq_mod);\n\n            // Rich harmonics for depth\n            let harmonic1 = sin_osc_ar((freq + freq_mod) * 1.3) * 0.3;\n            let harmonic2 = sin_osc_ar((freq + freq_mod) * 2.0) * 0.15;\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.002, 0.025)\n                .build();\n            let attack = pink_noise_ar() * attack_env * 0.2;\n            let filtered_attack = lpf_ar(attack, 2000.0);\n\n            (tone + harmonic1 + harmonic2 + filtered_attack) * amp_env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "percussion",
          "path": "drums/percussion/tom_low.vibe"
        },
        {
          "name": "tom_mid",
          "description": "Genre: All | Character: Mid tom, punchy",
          "genre": "All",
          "character": "Mid tom, punchy",
          "params": [
            {
              "name": "freq",
              "default": 140
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"tom_mid\", |builder| {\n    builder\n        .param(\"freq\", 140.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Medium decay\n            let amp_env = envelope()\n                .perc(0.003, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope\n            let pitch_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let freq_mod = pitch_env * freq * 1.6;\n\n            // Main tone\n            let tone = sin_osc_ar(freq + freq_mod);\n\n            // Harmonics for body\n            let harmonic1 = sin_osc_ar((freq + freq_mod) * 1.4) * 0.25;\n            let harmonic2 = sin_osc_ar((freq + freq_mod) * 2.1) * 0.1;\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let attack = pink_noise_ar() * attack_env * 0.18;\n            let filtered_attack = lpf_ar(attack, 2500.0);\n\n            (tone + harmonic1 + harmonic2 + filtered_attack) * amp_env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "percussion",
          "path": "drums/percussion/tom_mid.vibe"
        },
        {
          "name": "woodblock",
          "description": "Genre: Experimental, World | Character: Hollow wooden block",
          "genre": "Experimental, World",
          "character": "Hollow wooden block",
          "params": [
            {
              "name": "freq",
              "default": 800
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"woodblock\", |builder| {\n    builder\n        .param(\"freq\", 800.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Short, percussive envelope\n            let env = envelope()\n                .perc(0.0005, 0.045)\n                .cleanup_on_finish()\n                .build();\n\n            // Resonant frequencies for hollow character\n            let tone1 = sin_osc_ar(freq) * 0.5;\n            let tone2 = sin_osc_ar(freq * 1.8) * 0.3;\n            let tone3 = sin_osc_ar(freq * 2.4) * 0.2;\n\n            // Add filtered noise for wood texture\n            let noise = pink_noise_ar();\n            let filtered_noise = rlpf_ar(noise, freq * 3.0, 0.5) * 0.15;\n\n            (tone1 + tone2 + tone3 + filtered_noise) * env * amp\n        })\n});",
          "category": "drums",
          "subcategory": "percussion",
          "path": "drums/percussion/woodblock.vibe"
        }
      ],
      "Snares": [
        {
          "name": "snare_808",
          "description": "Classic 808 snare, short and snappy",
          "genre": "Hip-hop, Trap",
          "character": "Classic 808 snare, short and snappy",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Hip-hop, Trap | Character: Classic 808 snare, short and snappy\ndefine_synthdef(\"snare_808\")\n    .param(\"amp\", 1.0)\n    .body(|amp| {\n        // Noise component - short decay\n        let noise_env = envelope()\n            .perc(0.001, 0.12)\n            .cleanup_on_finish()\n            .build();\n        let noise = white_noise_ar();\n        let filtered_noise = hpf_ar(noise, 2000.0);\n        let snare_noise = filtered_noise * noise_env * 0.7;\n\n        // Tone component - metallic ring\n        let tone_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let tone = sin_osc_ar(180.0) * tone_env * 0.3;\n\n        (snare_noise + tone) * amp\n    });\n\n",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_808.vibe"
        },
        {
          "name": "snare_909",
          "description": "Genre: House, Techno | Character: Classic 909, crisp and bright",
          "genre": "House, Techno",
          "character": "Classic 909, crisp and bright",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"snare_909\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Noise component - filtered white noise\n            let noise_env = envelope()\n                .perc(0.001, 0.18)\n                .cleanup_on_finish()\n                .build();\n            let noise = white_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 3500.0, 0.5);\n            let snare_noise = filtered_noise * noise_env;\n\n            // Tone components - two frequencies for body\n            let tone_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let tone1 = sin_osc_ar(185.0) * 0.3;\n            let tone2 = sin_osc_ar(330.0) * 0.2;\n            let tones = (tone1 + tone2) * tone_env;\n\n            (snare_noise * 0.8 + tones) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_909.vibe"
        },
        {
          "name": "snare_acoustic",
          "description": "Genre: Jazz, Rock | Character: Natural acoustic snare with overtones",
          "genre": "Jazz, Rock",
          "character": "Natural acoustic snare with overtones",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"snare_acoustic\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Noise component - longer for acoustic character\n            let noise_env = envelope()\n                .perc(0.002, 0.25)\n                .cleanup_on_finish()\n                .build();\n            let noise = white_noise_ar();\n            // Less aggressive filtering for natural sound\n            let filtered_noise = rlpf_ar(noise, 5000.0, 0.6);\n            let snare_noise = filtered_noise * noise_env;\n\n            // Body tone - lower fundamental\n            let body_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n            let body = sin_osc_ar(200.0) * body_env * 0.25;\n\n            // Snare wires - higher harmonics\n            let wire_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n            let wires = (sin_osc_ar(320.0) * 0.15 + sin_osc_ar(480.0) * 0.1) * wire_env;\n\n            (snare_noise * 0.7 + body + wires) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_acoustic.vibe"
        },
        {
          "name": "snare_brush",
          "description": "Brush snare with swishing texture",
          "genre": "Jazz, Acoustic",
          "character": "Brush snare with swishing texture",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Jazz, Acoustic | Character: Brush snare with swishing texture\ndefine_synthdef(\"snare_brush\")\n    .param(\"freq\", 180.0)\n    .param(\"amp\", 0.6)\n    .body(|freq, amp| {\n        // Soft decay\n        let amp_env = envelope()\n            .perc(0.005, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Subtle body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.0) * 0.25;\n\n        // Brush swish texture\n        let swish_env = envelope()\n            .perc(0.01, 0.2)\n            .build();\n        let swish = bpf_ar(pink_noise_ar(), 4000.0, 0.6) * swish_env * 0.5;\n\n        // Wire buzz\n        let wire_env = envelope()\n            .perc(0.005, 0.15)\n            .build();\n        let wires = hpf_ar(white_noise_ar(), 5000.0) * wire_env * 0.2;\n\n        (body + swish + wires) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_brush.vibe"
        },
        {
          "name": "snare_clap_snare",
          "description": "Genre: Hip-hop, Pop | Character: Snare with clap character, layered",
          "genre": "Hip-hop, Pop",
          "character": "Snare with clap character, layered",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"snare_clap_snare\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Clap layer - multiple short bursts\n            let clap_env1 = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let clap_env2 = envelope()\n                .perc(0.015, 0.03)\n                .build();\n            let clap_env3 = envelope()\n                .perc(0.025, 0.03)\n                .cleanup_on_finish()\n                .build();\n\n            let clap_noise = white_noise_ar();\n            let clap = hpf_ar(clap_noise, 1500.0) * (clap_env1 + clap_env2 * 0.7 + clap_env3 * 0.5);\n\n            // Snare layer\n            let snare_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n            let snare_noise = rlpf_ar(white_noise_ar(), 4000.0, 0.5) * snare_env;\n\n            // Tone\n            let tone_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let tone = sin_osc_ar(190.0) * tone_env * 0.2;\n\n            (clap * 0.5 + snare_noise * 0.6 + tone) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_clap_snare.vibe"
        },
        {
          "name": "snare_filtered",
          "description": "Genre: Lo-fi, Experimental | Character: Heavily filtered, muffled",
          "genre": "Lo-fi, Experimental",
          "character": "Heavily filtered, muffled",
          "params": [
            {
              "name": "amp",
              "default": 1
            },
            {
              "name": "cutoff",
              "default": 1200
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"snare_filtered\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .param(\"cutoff\", 1200.0)\n        .body(|amp, cutoff| {\n            // Noise component with heavy filtering\n            let noise_env = envelope()\n                .perc(0.002, 0.18)\n                .cleanup_on_finish()\n                .build();\n            let noise = white_noise_ar();\n            // Heavy low-pass for muffled character\n            let filtered_noise = lpf_ar(noise, cutoff);\n            let snare_noise = filtered_noise * noise_env;\n\n            // Muted tone\n            let tone_env = envelope()\n                .perc(0.001, 0.12)\n                .build();\n            let tone = sin_osc_ar(160.0) * tone_env * 0.3;\n\n            (snare_noise * 0.8 + tone) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_filtered.vibe"
        },
        {
          "name": "snare_garage",
          "description": "Snappy UK garage snare",
          "genre": "UK Garage, 2-Step",
          "character": "Snappy UK garage snare",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: UK Garage, 2-Step | Character: Snappy UK garage snare\ndefine_synthdef(\"snare_garage\")\n    .param(\"freq\", 210.0)\n    .param(\"amp\", 0.85)\n    .body(|freq, amp| {\n        // Short, snappy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.16)\n            .cleanup_on_finish()\n            .build();\n\n        // Punchy body\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.5) * 0.4;\n\n        // Bright noise\n        let noise_env = envelope()\n            .perc(0.001, 0.12)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 4000.0) * noise_env * 0.5;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.22;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_garage.vibe"
        },
        {
          "name": "snare_gated",
          "description": "Big gated reverb snare from the 80s",
          "genre": "80s Rock, Pop",
          "character": "Big gated reverb snare from the 80s",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: 80s Rock, Pop | Character: Big gated reverb snare from the 80s\ndefine_synthdef(\"snare_gated\")\n    .param(\"freq\", 190.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Medium decay with abrupt end (gated feel)\n        let amp_env = envelope()\n            .perc(0.001, 0.3)\n            .cleanup_on_finish()\n            .build();\n\n        // Body with pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.025)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.8) * 0.4;\n\n        // Sustained noise layer\n        let noise_env = envelope()\n            .perc(0.001, 0.28)\n            .build();\n        let noise = bpf_ar(white_noise_ar(), 3000.0, 0.5) * noise_env * 0.5;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_gated.vibe"
        },
        {
          "name": "snare_jungle",
          "description": "Amen-break style snare with roll potential",
          "genre": "Jungle, Drum & Bass",
          "character": "Amen-break style snare with roll potential",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Jungle, Drum & Bass | Character: Amen-break style snare with roll potential\ndefine_synthdef(\"snare_jungle\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Tight decay\n        let amp_env = envelope()\n            .perc(0.001, 0.18)\n            .cleanup_on_finish()\n            .build();\n\n        // Body\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.5) * 0.35;\n\n        // Bright, cutting noise\n        let noise_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 3500.0) * noise_env * 0.55;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.25;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_jungle.vibe"
        },
        {
          "name": "snare_layered",
          "description": "Genre: EDM, Pop | Character: Big, layered snare with depth",
          "genre": "EDM, Pop",
          "character": "Big, layered snare with depth",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"snare_layered\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Top layer - bright noise\n            let top_env = envelope()\n                .perc(0.001, 0.15)\n                .cleanup_on_finish()\n                .build();\n            let top = hpf_ar(white_noise_ar(), 4000.0) * top_env * 0.5;\n\n            // Mid layer - body\n            let mid_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n            let mid = rlpf_ar(white_noise_ar(), 2500.0, 0.5) * mid_env * 0.6;\n\n            // Bottom layer - tone\n            let bottom_env = envelope()\n                .perc(0.001, 0.12)\n                .build();\n            let bottom = sin_osc_ar(200.0) * bottom_env * 0.4;\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.0001, 0.005)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.3;\n\n            (top + mid + bottom + attack) * amp * 0.7\n        })\n});",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_layered.vibe"
        },
        {
          "name": "snare_lofi",
          "description": "Genre: Lo-fi Hip-hop, Chillhop | Character: Dusty, lo-fi character with crackle",
          "genre": "Lo-fi Hip-hop, Chillhop",
          "character": "Dusty, lo-fi character with crackle",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"snare_lofi\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Main snare - filtered and soft\n            let snare_env = envelope()\n                .perc(0.003, 0.16)\n                .cleanup_on_finish()\n                .build();\n\n            // Use pink noise for warmer character\n            let noise = pink_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 2200.0, 0.6);\n            let snare_noise = filtered_noise * snare_env;\n\n            // Muted tone\n            let tone_env = envelope()\n                .perc(0.002, 0.11)\n                .build();\n            let tone = sin_osc_ar(175.0) * tone_env * 0.2;\n\n            // Vinyl crackle layer\n            let crackle_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let crackle = hpf_ar(white_noise_ar(), 6000.0) * crackle_env * 0.08;\n\n            (snare_noise * 0.7 + tone + crackle) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_lofi.vibe"
        },
        {
          "name": "snare_loose_acoustic",
          "description": "Genre: Rock, Blues | Character: Loose, rattling acoustic snare",
          "genre": "Rock, Blues",
          "character": "Loose, rattling acoustic snare",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"snare_loose_acoustic\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Longer decay for loose character\n            let noise_env = envelope()\n                .perc(0.003, 0.35)\n                .cleanup_on_finish()\n                .build();\n            let noise = white_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 6000.0, 0.7);\n            let snare_noise = filtered_noise * noise_env;\n\n            // Body tone\n            let body_env = envelope()\n                .perc(0.002, 0.18)\n                .build();\n            let body = sin_osc_ar(195.0) * body_env * 0.2;\n\n            // Rattling snare wires - use LFNoise for texture\n            let wire_env = envelope()\n                .perc(0.002, 0.3)\n                .build();\n            let wires = hpf_ar(white_noise_ar(), 3000.0) * wire_env * 0.15;\n\n            (snare_noise * 0.6 + body + wires) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_loose_acoustic.vibe"
        },
        {
          "name": "snare_marching",
          "description": "Tight marching snare with wire buzz",
          "genre": "Marching Band, Orchestral",
          "character": "Tight marching snare with wire buzz",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Marching Band, Orchestral | Character: Tight marching snare with wire buzz\ndefine_synthdef(\"snare_marching\")\n    .param(\"freq\", 250.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Tight, controlled decay\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // High-pitched body\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.35;\n\n        // Prominent wire buzz\n        let wire_env = envelope()\n            .perc(0.001, 0.18)\n            .build();\n        let wires = hpf_ar(white_noise_ar(), 4000.0) * wire_env * 0.5;\n\n        // Sharp stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.002)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.3;\n\n        (body + wires + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_marching.vibe"
        },
        {
          "name": "snare_noise_layer",
          "description": "Pure noise snare layer for stacking",
          "genre": "Electronic, Production",
          "character": "Pure noise snare layer for stacking",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Electronic, Production | Character: Pure noise snare layer for stacking\ndefine_synthdef(\"snare_noise_layer\")\n    .param(\"freq\", 5000.0)\n    .param(\"amp\", 0.7)\n    .param(\"decay\", 0.2)\n    .body(|freq, amp, decay| {\n        // Adjustable decay\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay)\n            .cleanup_on_finish()\n            .build();\n\n        // Pure filtered noise\n        let noise = bpf_ar(white_noise_ar(), freq, 0.5);\n\n        // Attack transient\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (noise + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_noise_layer.vibe"
        },
        {
          "name": "snare_piccolo",
          "description": "Genre: Funk, Pop | Character: High-pitched, tight piccolo snare",
          "genre": "Funk, Pop",
          "character": "High-pitched, tight piccolo snare",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"snare_piccolo\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Bright, short noise\n            let noise_env = envelope()\n                .perc(0.001, 0.08)\n                .cleanup_on_finish()\n                .build();\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(noise, 4000.0);\n            let snare_noise = filtered_noise * noise_env;\n\n            // High-pitched tone\n            let tone_env = envelope()\n                .perc(0.001, 0.06)\n                .build();\n            let tone = sin_osc_ar(280.0) * tone_env * 0.35;\n\n            // Crack/stick sound\n            let crack_env = envelope()\n                .perc(0.0005, 0.004)\n                .build();\n            let crack = white_noise_ar() * crack_env * 0.3;\n\n            (snare_noise * 0.7 + tone + crack) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_piccolo.vibe"
        },
        {
          "name": "snare_pitched",
          "description": "Tunable synth snare with tonal body",
          "genre": "Electronic, Experimental",
          "character": "Tunable synth snare with tonal body",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Electronic, Experimental | Character: Tunable synth snare with tonal body\ndefine_synthdef(\"snare_pitched\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.8)\n    .param(\"tone\", 0.6)\n    .body(|freq, amp, tone| {\n        // Decay\n        let amp_env = envelope()\n            .perc(0.001, 0.22)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitched body with tone control\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * tone * 0.5;\n\n        // Noise layer inversely proportional to tone\n        let noise_env = envelope()\n            .perc(0.001, 0.18)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 2500.0) * noise_env * (1.0 - tone * 0.5) * 0.5;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.15;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_pitched.vibe"
        },
        {
          "name": "snare_reverb",
          "description": "Genre: Ambient, Chillwave | Character: Snare with built-in reverb tail",
          "genre": "Ambient, Chillwave",
          "character": "Snare with built-in reverb tail",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"snare_reverb\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Main snare\n            let snare_env = envelope()\n                .perc(0.001, 0.13)\n                .cleanup_on_finish()\n                .build();\n            let snare_noise = rlpf_ar(white_noise_ar(), 3500.0, 0.5) * snare_env;\n            let tone = sin_osc_ar(210.0) * snare_env * 0.25;\n            let dry = snare_noise * 0.7 + tone;\n\n            // Reverb tail using delays\n            let delay1 = delay_l_ar(dry, 0.2, 0.037);\n            let delay2 = delay_l_ar(dry, 0.2, 0.041);\n            let delay3 = delay_l_ar(dry, 0.2, 0.053);\n            let delay4 = delay_l_ar(dry, 0.2, 0.067);\n\n            // Reverb envelope - longer tail\n            let reverb_env = envelope()\n                .perc(0.01, 0.4)\n                .build();\n            let reverb = (delay1 + delay2 + delay3 + delay4) * 0.15 * reverb_env;\n\n            (dry + reverb) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_reverb.vibe"
        },
        {
          "name": "snare_rimshot",
          "description": "Genre: Latin, Reggaeton | Character: Rimshot, sharp and cutting",
          "genre": "Latin, Reggaeton",
          "character": "Rimshot, sharp and cutting",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"snare_rimshot\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Very short, sharp envelope\n            let rim_env = envelope()\n                .perc(0.0003, 0.04)\n                .cleanup_on_finish()\n                .build();\n\n            // High-frequency click\n            let click = white_noise_ar();\n            let filtered_click = hpf_ar(click, 6000.0);\n\n            // Metallic tone\n            let tone1 = sin_osc_ar(800.0) * 0.4;\n            let tone2 = sin_osc_ar(1200.0) * 0.3;\n            let tones = (tone1 + tone2) * rim_env;\n\n            (filtered_click * rim_env * 0.5 + tones) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_rimshot.vibe"
        },
        {
          "name": "snare_tight_electronic",
          "description": "Genre: Electro, Techno | Character: Tight, electronic, punchy",
          "genre": "Electro, Techno",
          "character": "Tight, electronic, punchy",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"snare_tight_electronic\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Short, controlled envelope\n            let noise_env = envelope()\n                .perc(0.001, 0.11)\n                .cleanup_on_finish()\n                .build();\n\n            // Filtered noise with resonance\n            let noise = white_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 2800.0, 0.3);\n\n            // Punchy tone\n            let tone_env = envelope()\n                .perc(0.0005, 0.07)\n                .build();\n            let tone = sin_osc_ar(220.0) * tone_env * 0.4;\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.0001, 0.003)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.4;\n\n            (filtered_noise * noise_env + tone + attack) * amp\n        })\n});",
          "category": "drums",
          "subcategory": "snares",
          "path": "drums/snares/snare_tight_electronic.vibe"
        }
      ],
      "Toms": [
        {
          "name": "tom_808",
          "description": "808 tom with pitch decay",
          "genre": "Hip-hop, Trap",
          "character": "808 tom with pitch decay",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Hip-hop, Trap | Character: 808 tom with pitch decay\ndefine_synthdef(\"tom_808\")\n    .param(\"freq\", 120.0)\n    .param(\"amp\", 0.85)\n    .body(|freq, amp| {\n        // 808 tom decay\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Classic 808 pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let freq_mod = pitch_env * freq * 2.5;\n\n        // Clean sine\n        let body = sin_osc_ar(freq + freq_mod);\n\n        body * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "toms",
          "path": "drums/toms/tom_808.vibe"
        },
        {
          "name": "tom_concert",
          "description": "Concert tom with long resonance",
          "genre": "Orchestral, Cinematic",
          "character": "Concert tom with long resonance",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Orchestral, Cinematic | Character: Concert tom with long resonance\ndefine_synthdef(\"tom_concert\")\n    .param(\"freq\", 100.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Long resonant decay\n        let amp_env = envelope()\n            .perc(0.002, 0.6)\n            .cleanup_on_finish()\n            .build();\n\n        // Natural pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.04)\n            .build();\n        let freq_mod = pitch_env * freq * 1.2;\n\n        // Rich body with harmonics\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let harm1 = sin_osc_ar((freq + freq_mod) * 1.5) * 0.2;\n        let harm2 = sin_osc_ar((freq + freq_mod) * 2.0) * 0.1;\n\n        // Mallet attack\n        let attack_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 2500.0) * attack_env * 0.2;\n\n        (body + harm1 + harm2 + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "toms",
          "path": "drums/toms/tom_concert.vibe"
        },
        {
          "name": "tom_floor",
          "description": "Deep floor tom",
          "genre": "Rock, Pop",
          "character": "Deep floor tom",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Rock, Pop | Character: Deep floor tom\ndefine_synthdef(\"tom_floor\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.85)\n    .body(|freq, amp| {\n        // Deep, resonant decay\n        let amp_env = envelope()\n            .perc(0.001, 0.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 1.5;\n\n        // Deep body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.15;\n        let overtone = sin_osc_ar((freq + freq_mod) * 1.8) * 0.1;\n\n        // Stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.012)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 1500.0, 0.5) * attack_env * 0.2;\n\n        (body + sub + overtone + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "toms",
          "path": "drums/toms/tom_floor.vibe"
        },
        {
          "name": "tom_roto",
          "description": "Rototom with tunable, sustained pitch",
          "genre": "70s Rock, Prog",
          "character": "Rototom with tunable, sustained pitch",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: 70s Rock, Prog | Character: Rototom with tunable, sustained pitch\ndefine_synthdef(\"tom_roto\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Medium sustain\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Minimal pitch drop (rototom characteristic)\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let freq_mod = pitch_env * freq * 0.8;\n\n        // Clear, pitched body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n        let overtone = sin_osc_ar((freq + freq_mod) * 2.0) * 0.15;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.006)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 3000.0) * attack_env * 0.18;\n\n        (body + overtone + attack) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "toms",
          "path": "drums/toms/tom_roto.vibe"
        },
        {
          "name": "tom_synth",
          "description": "Synthetic electronic tom",
          "genre": "Electronic, Synthpop",
          "character": "Synthetic electronic tom",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Electronic, Synthpop | Character: Synthetic electronic tom\ndefine_synthdef(\"tom_synth\")\n    .param(\"freq\", 150.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Electronic decay\n        let amp_env = envelope()\n            .perc(0.001, 0.3)\n            .cleanup_on_finish()\n            .build();\n\n        // Dramatic pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.1)\n            .build();\n        let freq_mod = pitch_env * freq * 3.0;\n\n        // Pure sine body\n        let body = sin_osc_ar(freq + freq_mod);\n\n        // Subtle click\n        let click_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 2000.0, 0.5) * click_env * 0.15;\n\n        (body + click) * amp_env * amp\n    });\n",
          "category": "drums",
          "subcategory": "toms",
          "path": "drums/toms/tom_synth.vibe"
        }
      ]
    },
    "items": []
  },
  "Effects": {
    "subcategories": {
      "Delays": [
        {
          "name": "analog_delay",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 0.3
            },
            {
              "name": "feedback",
              "default": 0.5
            },
            {
              "name": "tone",
              "default": 0.4
            },
            {
              "name": "mod_depth",
              "default": 0.3
            },
            {
              "name": "mix",
              "default": 0.4
            }
          ],
          "type": "fx",
          "source": "define_fx(\"analog_delay\", |builder| {\n    builder\n        .param(\"time\", 0.3)\n        .param(\"feedback\", 0.5)\n        .param(\"tone\", 0.4)\n        .param(\"mod_depth\", 0.3)\n        .param(\"mix\", 0.4)\n        .body(|input, time, feedback, tone, mod_depth, mix| {\n            // BBD-style modulation (clock instability)\n            let mod_lfo = sin_osc_ar(0.6) * mod_depth * 0.002;\n\n            // Modulated delay time\n            let mod_time = time + mod_lfo;\n\n            // Create the delay with feedback\n            // Simulating BBD's frequency response degradation\n            let delay_l = delay_c_ar(input[0], 2.0, mod_time);\n            let delay_r = delay_c_ar(input[1], 2.0, mod_time);\n\n            // Progressive filtering (each repeat darker)\n            let cutoff = 2000.0 + tone * 6000.0;\n            let filtered_l = lpf_ar(delay_l, cutoff);\n            let filtered_r = lpf_ar(delay_r, cutoff);\n\n            // Add subtle saturation (BBD compression)\n            let saturated_l = (filtered_l * 1.3).tanh();\n            let saturated_r = (filtered_r * 1.3).tanh();\n\n            // High-pass to remove DC and rumble\n            let cleaned_l = hpf_ar(saturated_l, 60.0);\n            let cleaned_r = hpf_ar(saturated_r, 60.0);\n\n            // Feedback path with additional filtering\n            let fb_l = delay_c_ar(cleaned_l * feedback, 2.0, mod_time);\n            let fb_r = delay_c_ar(cleaned_r * feedback, 2.0, mod_time);\n\n            let wet_l = cleaned_l + lpf_ar(fb_l, cutoff * 0.8) * feedback;\n            let wet_r = cleaned_r + lpf_ar(fb_r, cutoff * 0.8) * feedback;\n\n            [\n                (1.0 - mix) * input[0] + mix * wet_l,\n                (1.0 - mix) * input[1] + mix * wet_r\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "delays",
          "path": "effects/delays/analog_delay.vibe"
        },
        {
          "name": "delay",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 0.25
            },
            {
              "name": "feedback",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"delay\", |builder| {\n    builder\n        .param(\"time\", 0.25)\n        .param(\"feedback\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, mix| {\n            // Simple stereo delay with feedback\n            let left_delayed = delay_n_ar(input[0] + (feedback * delay_n_ar(input[0], 2.0, time)), 2.0, time);\n            let right_delayed = delay_n_ar(input[1] + (feedback * delay_n_ar(input[1], 2.0, time)), 2.0, time);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * left_delayed,\n                (1.0 - mix) * input[1] + mix * right_delayed\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "delays",
          "path": "effects/delays/delay.vibe"
        },
        {
          "name": "dub_delay",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 0.375
            },
            {
              "name": "feedback",
              "default": 0.7
            },
            {
              "name": "cutoff",
              "default": 2000
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"dub_delay\", |builder| {\n    builder\n        .param(\"time\", 0.375)\n        .param(\"feedback\", 0.7)\n        .param(\"cutoff\", 2000.0)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, cutoff, mix| {\n            // Comb filter delay with filtering in feedback path\n            let delayed_left = comb_c_ar(input[0], 2.0, time, feedback * 4.0);\n            let delayed_right = comb_c_ar(input[1], 2.0, time * 1.02, feedback * 4.0);\n\n            // Filter the delayed signal (dub character)\n            let filtered_left = lpf_ar(delayed_left, cutoff);\n            let filtered_right = lpf_ar(delayed_right, cutoff);\n\n            // Add some saturation\n            let sat_left = (filtered_left * 1.2).tanh();\n            let sat_right = (filtered_right * 1.2).tanh();\n\n            [\n                (1.0 - mix) * input[0] + mix * sat_left,\n                (1.0 - mix) * input[1] + mix * sat_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "delays",
          "path": "effects/delays/dub_delay.vibe"
        },
        {
          "name": "ducking_delay",
          "description": "mix: Maximum wet level when not ducking (0.0 to 1.0)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 0.4
            },
            {
              "name": "feedback",
              "default": 0.4
            },
            {
              "name": "duck_amount",
              "default": 0.7
            },
            {
              "name": "duck_speed",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"ducking_delay\", |builder| {\n    builder\n        .param(\"time\", 0.4)\n        .param(\"feedback\", 0.4)\n        .param(\"duck_amount\", 0.7)\n        .param(\"duck_speed\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, duck_amount, duck_speed, mix| {\n            // Envelope follower for ducking\n            let mono_in = (input[0] + input[1]) * 0.5;\n            let amplitude = lag_ar(mono_in.abs(), 0.01 + (1.0 - duck_speed) * 0.1);\n\n            // Calculate duck level (more input = less delay)\n            let duck_mult = 1.0 - (amplitude * duck_amount * 4.0).min(1.0);\n\n            // Create the delays\n            let delay_l = delay_c_ar(input[0], 3.0, time);\n            let delay_r = delay_c_ar(input[1], 3.0, time);\n\n            // Feedback with filtering\n            let fb_l = delay_c_ar(delay_l * feedback, 3.0, time);\n            let fb_r = delay_c_ar(delay_r * feedback, 3.0, time);\n\n            let wet_l = delay_l + fb_l * feedback;\n            let wet_r = delay_r + fb_r * feedback;\n\n            // Apply ducking to wet signal\n            let ducked_l = wet_l * duck_mult;\n            let ducked_r = wet_r * duck_mult;\n\n            [\n                input[0] + ducked_l * mix,\n                input[1] + ducked_r * mix\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "delays",
          "path": "effects/delays/ducking_delay.vibe"
        },
        {
          "name": "granular_delay",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 0.3
            },
            {
              "name": "pitch",
              "default": 1
            },
            {
              "name": "density",
              "default": 0.7
            },
            {
              "name": "feedback",
              "default": 0.4
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"granular_delay\", |builder| {\n    builder\n        .param(\"time\", 0.3)\n        .param(\"pitch\", 1.0)\n        .param(\"density\", 0.7)\n        .param(\"feedback\", 0.4)\n        .param(\"mix\", 0.5)\n        .body(|input, time, pitch, density, feedback, mix| {\n            // Multiple delay taps with varying times for granular effect\n            let grain_size = 0.05 + (1.0 - density) * 0.1;\n\n            // Create offset delay taps\n            let tap1_left = delay_c_ar(input[0], 2.0, time);\n            let tap2_left = delay_c_ar(input[0], 2.0, time * 1.33);\n            let tap3_left = delay_c_ar(input[0], 2.0, time * 0.75);\n\n            let tap1_right = delay_c_ar(input[1], 2.0, time * 1.1);\n            let tap2_right = delay_c_ar(input[1], 2.0, time * 0.9);\n            let tap3_right = delay_c_ar(input[1], 2.0, time * 1.5);\n\n            // Mix grains with varying amplitudes\n            let grain_left = tap1_left * 0.5 + tap2_left * 0.3 + tap3_left * 0.2;\n            let grain_right = tap1_right * 0.5 + tap2_right * 0.3 + tap3_right * 0.2;\n\n            // Apply pitch variation through playback rate modulation\n            let pitch_mod = sin_osc_ar(0.1 + density * 2.0) * 0.02 * (pitch - 1.0);\n            let modulated_left = delay_c_ar(grain_left, 0.1, 0.01 + pitch_mod.abs());\n            let modulated_right = delay_c_ar(grain_right, 0.1, 0.01 + pitch_mod.abs());\n\n            // Add feedback\n            let fb_left = modulated_left * feedback;\n            let fb_right = modulated_right * feedback;\n\n            // Final mix with slight filtering for smoothness\n            let out_left = lpf_ar(modulated_left + fb_left, 10000.0);\n            let out_right = lpf_ar(modulated_right + fb_right, 10000.0);\n\n            [\n                (1.0 - mix) * input[0] + mix * out_left,\n                (1.0 - mix) * input[1] + mix * out_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "delays",
          "path": "effects/delays/granular_delay.vibe"
        },
        {
          "name": "multi_tap_delay",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 0.375
            },
            {
              "name": "feedback",
              "default": 0.4
            },
            {
              "name": "spread",
              "default": 0.7
            },
            {
              "name": "filter",
              "default": 0.6
            },
            {
              "name": "mix",
              "default": 0.4
            }
          ],
          "type": "fx",
          "source": "define_fx(\"multi_tap_delay\", |builder| {\n    builder\n        .param(\"time\", 0.375)\n        .param(\"feedback\", 0.4)\n        .param(\"spread\", 0.7)\n        .param(\"filter\", 0.6)\n        .param(\"mix\", 0.4)\n        .body(|input, time, feedback, spread, filter, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Six delay taps at musical intervals\n            let tap1 = delay_c_ar(mono, 2.0, time * 0.25) * 0.8;      // 1/4\n            let tap2 = delay_c_ar(mono, 2.0, time * 0.375) * 0.7;     // dotted 8th feel\n            let tap3 = delay_c_ar(mono, 2.0, time * 0.5) * 0.6;       // 1/2\n            let tap4 = delay_c_ar(mono, 2.0, time * 0.667) * 0.5;     // 2/3\n            let tap5 = delay_c_ar(mono, 2.0, time * 0.75) * 0.4;      // 3/4\n            let tap6 = delay_c_ar(mono, 2.0, time) * 0.5;             // full\n\n            // Distribute taps in stereo field\n            let left_taps = tap1 + tap3 * (1.0 - spread * 0.5) + tap5;\n            let right_taps = tap2 + tap4 * (1.0 - spread * 0.5) + tap6;\n\n            // Cross-feed for stereo coherence\n            let cross = 0.3 * (1.0 - spread);\n            let wet_l = left_taps + right_taps * cross;\n            let wet_r = right_taps + left_taps * cross;\n\n            // Apply feedback\n            let fb_l = delay_c_ar(wet_l * feedback, 2.0, time);\n            let fb_r = delay_c_ar(wet_r * feedback, 2.0, time);\n\n            let total_l = wet_l + fb_l * feedback;\n            let total_r = wet_r + fb_r * feedback;\n\n            // Tone control\n            let cutoff = 3000.0 + filter * 9000.0;\n            let filtered_l = lpf_ar(total_l, cutoff);\n            let filtered_r = lpf_ar(total_r, cutoff);\n\n            [\n                (1.0 - mix) * input[0] + mix * filtered_l * 0.7,\n                (1.0 - mix) * input[1] + mix * filtered_r * 0.7\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "delays",
          "path": "effects/delays/multi_tap_delay.vibe"
        },
        {
          "name": "ping_pong_delay",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 0.375
            },
            {
              "name": "feedback",
              "default": 0.6
            },
            {
              "name": "mix",
              "default": 0.4
            }
          ],
          "type": "fx",
          "source": "define_fx(\"ping_pong_delay\", |builder| {\n    builder\n        .param(\"time\", 0.375)\n        .param(\"feedback\", 0.6)\n        .param(\"mix\", 0.4)\n        .body(|input, time, feedback, mix| {\n            // Create cross-coupled delays (left feeds right, right feeds left)\n            let del_left = delay_n_ar(input[0] + (feedback * delay_n_ar(input[1], 2.0, time)), 2.0, time);\n            let del_right = delay_n_ar(input[1] + (feedback * delay_n_ar(input[0], 2.0, time)), 2.0, time);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * del_left,\n                (1.0 - mix) * input[1] + mix * del_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "delays",
          "path": "effects/delays/ping_pong_delay.vibe"
        },
        {
          "name": "reverse_delay",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 0.3
            },
            {
              "name": "feedback",
              "default": 0.4
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"reverse_delay\", |builder| {\n    builder\n        .param(\"time\", 0.3)\n        .param(\"feedback\", 0.4)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, mix| {\n            // Simulate reverse using multiple staggered delays with envelope\n            let env = sin_osc_ar(1.0 / time) * 0.5 + 0.5;\n\n            let d1_left = delay_c_ar(input[0], 1.0, time * 0.25) * (1.0 - env) * 0.3;\n            let d2_left = delay_c_ar(input[0], 1.0, time * 0.5) * env * 0.5;\n            let d3_left = delay_c_ar(input[0], 1.0, time * 0.75) * (1.0 - env) * 0.7;\n            let d4_left = delay_c_ar(input[0], 1.0, time) * env;\n\n            let d1_right = delay_c_ar(input[1], 1.0, time * 0.25) * (1.0 - env) * 0.3;\n            let d2_right = delay_c_ar(input[1], 1.0, time * 0.5) * env * 0.5;\n            let d3_right = delay_c_ar(input[1], 1.0, time * 0.75) * (1.0 - env) * 0.7;\n            let d4_right = delay_c_ar(input[1], 1.0, time) * env;\n\n            let wet_left = (d1_left + d2_left + d3_left + d4_left) * 0.4;\n            let wet_right = (d1_right + d2_right + d3_right + d4_right) * 0.4;\n\n            [\n                (1.0 - mix) * input[0] + mix * wet_left,\n                (1.0 - mix) * input[1] + mix * wet_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "delays",
          "path": "effects/delays/reverse_delay.vibe"
        },
        {
          "name": "shimmer_delay",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 0.4
            },
            {
              "name": "feedback",
              "default": 0.6
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"shimmer_delay\", |builder| {\n    builder\n        .param(\"time\", 0.4)\n        .param(\"feedback\", 0.6)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, mix| {\n            // Main delay\n            let delayed_left = comb_c_ar(input[0], 1.0, time, feedback * 3.0);\n            let delayed_right = comb_c_ar(input[1], 1.0, time * 1.01, feedback * 3.0);\n\n            // Octave up simulation using ring mod\n            let octave_left = delayed_left * sin_osc_ar(880.0) * 0.3;\n            let octave_right = delayed_right * sin_osc_ar(880.0) * 0.3;\n\n            let shimmer_left = delayed_left * 0.7 + octave_left;\n            let shimmer_right = delayed_right * 0.7 + octave_right;\n\n            [\n                (1.0 - mix) * input[0] + mix * shimmer_left,\n                (1.0 - mix) * input[1] + mix * shimmer_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "delays",
          "path": "effects/delays/shimmer_delay.vibe"
        },
        {
          "name": "slapback",
          "description": "level: Delay level (0.0 to 1.0)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 0.12
            },
            {
              "name": "level",
              "default": 0.6
            }
          ],
          "type": "fx",
          "source": "define_fx(\"slapback\", |builder| {\n    builder\n        .param(\"time\", 0.12)\n        .param(\"level\", 0.6)\n        .body(|input, time, level| {\n            // Single delay tap, no feedback\n            let delayed_left = delay_c_ar(input[0], 0.25, time);\n            let delayed_right = delay_c_ar(input[1], 0.25, time);\n\n            [\n                input[0] + delayed_left * level,\n                input[1] + delayed_right * level\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "delays",
          "path": "effects/delays/slapback.vibe"
        },
        {
          "name": "tape_delay",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 0.5
            },
            {
              "name": "feedback",
              "default": 0.5
            },
            {
              "name": "wow",
              "default": 0.3
            },
            {
              "name": "flutter",
              "default": 0.2
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"tape_delay\", |builder| {\n    builder\n        .param(\"time\", 0.5)\n        .param(\"feedback\", 0.5)\n        .param(\"wow\", 0.3)\n        .param(\"flutter\", 0.2)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, wow, flutter, mix| {\n            // Generate wow (slow LFO) and flutter (fast LFO)\n            let wow_lfo = sin_osc_ar(0.5, 0.0) * wow * 0.001;\n            let flutter_lfo = sin_osc_ar(8.0, 0.0) * flutter * 0.0005;\n\n            // Modulated delay time\n            let mod_time = time + wow_lfo + flutter_lfo;\n\n            // Create delayed signals with modulation\n            let del_left = delay_c_ar(input[0] + (feedback * delay_c_ar(input[0], 2.0, mod_time)), 2.0, mod_time);\n            let del_right = delay_c_ar(input[1] + (feedback * delay_c_ar(input[1], 2.0, mod_time)), 2.0, mod_time);\n\n            // Tape saturation (soft clipping)\n            let saturated_left = (del_left * 1.5).tanh();\n            let saturated_right = (del_right * 1.5).tanh();\n\n            // High frequency roll-off for analog character\n            let filtered_left = lpf_ar(saturated_left, 4000.0);\n            let filtered_right = lpf_ar(saturated_right, 4000.0);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "delays",
          "path": "effects/delays/tape_delay.vibe"
        }
      ],
      "Distortion": [
        {
          "name": "bitcrush",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "bits",
              "default": 8
            },
            {
              "name": "sample_rate",
              "default": 8000
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"bitcrush\", |builder| {\n    builder\n        .param(\"bits\", 8.0)\n        .param(\"sample_rate\", 8000.0)\n        .param(\"mix\", 0.5)\n        .body(|input, bits, sample_rate, mix| {\n            // Map bits (1..16) to a gentle drive factor.\n            // We avoid using a true power function here to keep the graph stable.\n            // 1.0 ≈ barely crushed, 4.0 ≈ heavy crush.\n            let drive = 1.0 + (bits / 8.0);\n\n            // Sample rate reduction using Latch\n            let rate_reduced_left = latch_ar(input[0], impulse_ar(sample_rate, 0.0));\n            let rate_reduced_right = latch_ar(input[1], impulse_ar(sample_rate, 0.0));\n\n            // Bit depth reduction (approximate) by increasing drive and soft-clipping.\n            let crushed_left = (rate_reduced_left * drive).tanh();\n            let crushed_right = (rate_reduced_right * drive).tanh();\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * crushed_left,\n                (1.0 - mix) * input[1] + mix * crushed_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "distortion",
          "path": "effects/distortion/bitcrush.vibe"
        },
        {
          "name": "distortion",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "drive",
              "default": 8
            },
            {
              "name": "tone",
              "default": 5000
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"distortion\", |builder| {\n    builder\n        .param(\"drive\", 8.0)\n        .param(\"tone\", 5000.0)\n        .param(\"mix\", 0.5)\n        .body(|input, drive, tone, mix| {\n            // Large constant boost to ensure we hit tanh saturation even on quiet signals\n            // drive=8 -> 800x boost, drive=20 -> 2000x boost\n            let boost = 1.0;\n            \n            // Remove low-end mud and boost signal for clipping\n            let driven_left = hpf_ar(input[0], 80.0) * boost * drive;\n            let driven_right = hpf_ar(input[1], 80.0) * boost * drive;\n\n            // Soft clip using tanh for amp-like behavior\n            let clipped_left = driven_left.tanh();\n            let clipped_right = driven_right.tanh();\n\n            // Tone shaping to tame fizz\n            let shaped_left = lpf_ar(clipped_left, tone);\n            let shaped_right = lpf_ar(clipped_right, tone);\n\n            // Mix dry and wet signals\n            let dry_left = input[0] * (1.0 - mix);\n            let dry_right = input[1] * (1.0 - mix);\n            let wet_left = shaped_left * mix;\n            let wet_right = shaped_right * mix;\n            \n            [\n                dry_left + wet_left,\n                dry_right + wet_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "distortion",
          "path": "effects/distortion/distortion.vibe"
        },
        {
          "name": "exciter",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = full effect)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "drive",
              "default": 0.5
            },
            {
              "name": "freq",
              "default": 3000
            },
            {
              "name": "blend",
              "default": 0.3
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"exciter\", |builder| {\n    builder\n        .param(\"drive\", 0.5)\n        .param(\"freq\", 3000.0)\n        .param(\"blend\", 0.3)\n        .param(\"mix\", 1.0)\n        .body(|input, drive, freq, blend, mix| {\n            // Extract high frequency content\n            let highs_l = hpf_ar(input[0], freq);\n            let highs_r = hpf_ar(input[1], freq);\n\n            // Generate harmonics through soft saturation\n            let saturated_l = (highs_l * (1.0 + drive * 4.0)).tanh();\n            let saturated_r = (highs_r * (1.0 + drive * 4.0)).tanh();\n\n            // Extract the generated harmonics (remove original)\n            let harmonics_l = saturated_l - highs_l;\n            let harmonics_r = saturated_r - highs_r;\n\n            // Filter harmonics to focus on upper frequencies\n            let focused_l = hpf_ar(harmonics_l, freq * 1.5);\n            let focused_r = hpf_ar(harmonics_r, freq * 1.5);\n\n            // Blend harmonics with original\n            let enhanced_l = input[0] + focused_l * blend;\n            let enhanced_r = input[1] + focused_r * blend;\n\n            [\n                (1.0 - mix) * input[0] + mix * enhanced_l,\n                (1.0 - mix) * input[1] + mix * enhanced_r\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "distortion",
          "path": "effects/distortion/exciter.vibe"
        },
        {
          "name": "fuzz",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "gain",
              "default": 10
            },
            {
              "name": "tone",
              "default": 3000
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"fuzz\", |builder| {\n    builder\n        .param(\"gain\", 10.0)\n        .param(\"tone\", 3000.0)\n        .param(\"mix\", 1.0)\n        .body(|input, gain, tone, mix| {\n            // Boost and clip\n            let fuzzed_left = (input[0] * gain).tanh();\n            let fuzzed_right = (input[1] * gain).tanh();\n\n            // Additional hard clipping for that fuzz character\n            let clipped_left = fuzzed_left.clip(-0.8, 0.8);\n            let clipped_right = fuzzed_right.clip(-0.8, 0.8);\n\n            // Tone control\n            let toned_left = lpf_ar(clipped_left, tone);\n            let toned_right = lpf_ar(clipped_right, tone);\n\n            [\n                (1.0 - mix) * input[0] + mix * toned_left,\n                (1.0 - mix) * input[1] + mix * toned_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "distortion",
          "path": "effects/distortion/fuzz.vibe"
        },
        {
          "name": "lo_fi",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "bit_depth",
              "default": 10
            },
            {
              "name": "sample_rate",
              "default": 16000
            },
            {
              "name": "noise",
              "default": 0.02
            },
            {
              "name": "filter_freq",
              "default": 3500
            },
            {
              "name": "mix",
              "default": 0.7
            }
          ],
          "type": "fx",
          "source": "define_fx(\"lo_fi\", |builder| {\n    builder\n        .param(\"bit_depth\", 10.0)\n        .param(\"sample_rate\", 16000.0)\n        .param(\"noise\", 0.02)\n        .param(\"filter_freq\", 3500.0)\n        .param(\"mix\", 0.7)\n        .body(|input, bit_depth, sample_rate, noise, filter_freq, mix| {\n            // Sample rate reduction\n            let rate_reduced_left = latch_ar(input[0], impulse_ar(sample_rate, 0.0));\n            let rate_reduced_right = latch_ar(input[1], impulse_ar(sample_rate, 0.0));\n\n            // Approximate bit depth reduction using drive + soft-clipping.\n            // Map bit_depth (4..16) to a modest drive factor.\n            let drive = 1.0 + (bit_depth / 8.0);\n            let crushed_left = (rate_reduced_left * drive).tanh();\n            let crushed_right = (rate_reduced_right * drive).tanh();\n\n            // Add noise\n            let noise_sig = pink_noise_ar() * noise;\n            let noisy_left = crushed_left + noise_sig;\n            let noisy_right = crushed_right + noise_sig;\n\n            // Low pass filter\n            let filtered_left = lpf_ar(noisy_left, filter_freq);\n            let filtered_right = lpf_ar(noisy_right, filter_freq);\n\n            // Slight distortion\n            let lofi = [\n                (filtered_left * 1.2).tanh(),\n                (filtered_right * 1.2).tanh()\n            ];\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * lofi[0],\n                (1.0 - mix) * input[1] + mix * lofi[1]\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "distortion",
          "path": "effects/distortion/lo_fi.vibe"
        },
        {
          "name": "overdrive",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "drive",
              "default": 5
            },
            {
              "name": "tone",
              "default": 3000
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"overdrive\", |builder| {\n    builder\n        .param(\"drive\", 5.0)\n        .param(\"tone\", 3000.0)\n        .param(\"mix\", 0.5)\n        .body(|input, drive, tone, mix| {\n            // Pre-emphasis (slight high pass to reduce mud)\n            let emphasized_left = hpf_ar(input[0], 80.0);\n            let emphasized_right = hpf_ar(input[1], 80.0);\n\n            // Apply drive\n            let driven_left = emphasized_left * drive;\n            let driven_right = emphasized_right * drive;\n\n            // Soft clipping\n            let clipped_left = driven_left.tanh();\n            let clipped_right = driven_right.tanh();\n\n            // Tone control (low pass filter)\n            let filtered_left = lpf_ar(clipped_left, tone);\n            let filtered_right = lpf_ar(clipped_right, tone);\n\n            // Output gain compensation\n            let overdriven = [\n                filtered_left * 0.5,\n                filtered_right * 0.5\n            ];\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * overdriven[0],\n                (1.0 - mix) * input[1] + mix * overdriven[1]\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "distortion",
          "path": "effects/distortion/overdrive.vibe"
        },
        {
          "name": "saturator",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "drive",
              "default": 3
            },
            {
              "name": "warmth",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"saturator\", |builder| {\n    builder\n        .param(\"drive\", 3.0)\n        .param(\"warmth\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, drive, warmth, mix| {\n            // Add warmth by boosting low-mids\n            let warm_freq = 200.0 + warmth * 300.0;\n            let warmed_left = input[0] + lpf_ar(input[0], warm_freq) * warmth * 0.5;\n            let warmed_right = input[1] + lpf_ar(input[1], warm_freq) * warmth * 0.5;\n\n            // Soft saturation using tanh (smooth tube-like curve)\n            let driven_left = (warmed_left * drive).tanh() / drive.sqrt();\n            let driven_right = (warmed_right * drive).tanh() / drive.sqrt();\n\n            // Add subtle even harmonics for analog character\n            let harmonic_left = sin_osc_ar(0.0) * 0.0; // placeholder for DC offset\n            let harmonic_right = sin_osc_ar(0.0) * 0.0;\n\n            let saturated_left = driven_left + harmonic_left;\n            let saturated_right = driven_right + harmonic_right;\n\n            // Mix dry and wet\n            [\n                (1.0 - mix) * input[0] + mix * saturated_left,\n                (1.0 - mix) * input[1] + mix * saturated_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "distortion",
          "path": "effects/distortion/saturator.vibe"
        },
        {
          "name": "tape_saturation",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "drive",
              "default": 0.4
            },
            {
              "name": "bias",
              "default": 0.5
            },
            {
              "name": "speed",
              "default": 0.7
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"tape_saturation\", |builder| {\n    builder\n        .param(\"drive\", 0.4)\n        .param(\"bias\", 0.5)\n        .param(\"speed\", 0.7)\n        .param(\"mix\", 0.5)\n        .body(|input, drive, bias, speed, mix| {\n            // Input gain (drive into saturation)\n            let driven_l = input[0] * (1.0 + drive * 3.0);\n            let driven_r = input[1] * (1.0 + drive * 3.0);\n\n            // Tape saturation (asymmetric soft clipping)\n            let sat_l = (driven_l * (1.0 + bias * 0.5)).tanh() + driven_l * bias * 0.1;\n            let sat_r = (driven_r * (1.0 + bias * 0.5)).tanh() + driven_r * bias * 0.1;\n\n            // Tape head bump (bass boost around 60-100Hz)\n            let bump_freq = 70.0 + speed * 50.0;\n            let bump_l = rlpf_ar(sat_l, bump_freq, 0.5) * 0.3 * (1.0 - speed * 0.5);\n            let bump_r = rlpf_ar(sat_r, bump_freq, 0.5) * 0.3 * (1.0 - speed * 0.5);\n\n            // High frequency roll-off (tape speed dependent)\n            let hf_cutoff = 8000.0 + speed * 12000.0;\n            let filtered_l = lpf_ar(sat_l, hf_cutoff);\n            let filtered_r = lpf_ar(sat_r, hf_cutoff);\n\n            // Subtle wow (very slow pitch variation)\n            let wow = sin_osc_ar(0.3) * 0.0005;\n            let final_l = delay_c_ar(filtered_l + bump_l, 0.01, 0.001 + wow);\n            let final_r = delay_c_ar(filtered_r + bump_r, 0.01, 0.001 + wow);\n\n            // Output level compensation\n            let comp = 1.0 / (1.0 + drive * 0.5);\n\n            [\n                (1.0 - mix) * input[0] + mix * final_l * comp,\n                (1.0 - mix) * input[1] + mix * final_r * comp\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "distortion",
          "path": "effects/distortion/tape_saturation.vibe"
        },
        {
          "name": "vinyl",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "crackle",
              "default": 0.05
            },
            {
              "name": "dust",
              "default": 0.02
            },
            {
              "name": "wow",
              "default": 0.3
            },
            {
              "name": "flutter",
              "default": 0.2
            },
            {
              "name": "wear",
              "default": 4000
            },
            {
              "name": "mix",
              "default": 0.8
            }
          ],
          "type": "fx",
          "source": "define_fx(\"vinyl\", |builder| {\n    builder\n        .param(\"crackle\", 0.05)\n        .param(\"dust\", 0.02)\n        .param(\"wow\", 0.3)\n        .param(\"flutter\", 0.2)\n        .param(\"wear\", 4000.0)\n        .param(\"mix\", 0.8)\n        .body(|input, crackle, dust, wow, flutter, wear, mix| {\n            // Wow (slow pitch variation)\n            let wow_lfo = sin_osc_ar(0.5, 0.0) * wow * 0.001;\n            let flutter_lfo = sin_osc_ar(10.0, 0.0) * flutter * 0.0003;\n            let pitch_var = 0.01 + wow_lfo + flutter_lfo;\n\n            // Apply pitch variation via delay\n            let warbled_left = delay_c_ar(input[0], 0.1, pitch_var);\n            let warbled_right = delay_c_ar(input[1], 0.1, pitch_var);\n\n            // Record wear (high frequency rolloff)\n            let worn_left = lpf_ar(warbled_left, wear);\n            let worn_right = lpf_ar(warbled_right, wear);\n\n            // Add crackle (filtered noise)\n            let crackle_sig = lpf_ar(dust2_ar(1000.0) * crackle, 8000.0);\n\n            // Add dust pops (random impulses)\n            let dust_sig = dust_ar(50.0) * dust;\n\n            // Combine all elements\n            let vinyl_left = worn_left + crackle_sig + dust_sig;\n            let vinyl_right = worn_right + crackle_sig + dust_sig;\n\n            // Mix dry and wet signals\n            [\n                (1.0 - mix) * input[0] + mix * vinyl_left,\n                (1.0 - mix) * input[1] + mix * vinyl_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "distortion",
          "path": "effects/distortion/vinyl.vibe"
        },
        {
          "name": "waveshaper",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "amount",
              "default": 0.5
            },
            {
              "name": "curve",
              "default": 2
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"waveshaper\", |builder| {\n    builder\n        .param(\"amount\", 0.5)\n        .param(\"curve\", 2.0)\n        .param(\"mix\", 0.5)\n        .body(|input, amount, curve, mix| {\n            // Pre-gain based on amount\n            let pre_gain = 1.0 + amount * 4.0;\n\n            // Apply polynomial waveshaping\n            let boosted_left = input[0] * pre_gain;\n            let boosted_right = input[1] * pre_gain;\n\n            // Soft clip with curve control\n            let shaped_left = (boosted_left.tanh() + boosted_left * (1.0 - amount)) * 0.5;\n            let shaped_right = (boosted_right.tanh() + boosted_right * (1.0 - amount)) * 0.5;\n\n            // Normalize output\n            let norm_left = shaped_left / pre_gain.sqrt();\n            let norm_right = shaped_right / pre_gain.sqrt();\n\n            [\n                (1.0 - mix) * input[0] + mix * norm_left,\n                (1.0 - mix) * input[1] + mix * norm_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "distortion",
          "path": "effects/distortion/waveshaper.vibe"
        }
      ],
      "Dynamics": [
        {
          "name": "amp_follower",
          "description": "scale: Output scaling factor (0.1 to 5.0)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "attack",
              "default": 0.01
            },
            {
              "name": "release",
              "default": 0.1
            },
            {
              "name": "scale",
              "default": 2
            }
          ],
          "type": "fx",
          "source": "define_fx(\"amp_follower\", |builder| {\n    builder\n        .param(\"attack\", 0.01)\n        .param(\"release\", 0.1)\n        .param(\"scale\", 2.0)\n        .body(|input, attack, release, scale| {\n            // Extract amplitude envelope\n            let env_left = amplitude_ar(input[0], attack, release);\n            let env_right = amplitude_ar(input[1], attack, release);\n\n            // Apply envelope back to signal (can create pumping effect)\n            let followed = [\n                input[0] * env_left * scale,\n                input[1] * env_right * scale\n            ];\n\n            followed\n        })\n});",
          "category": "effects",
          "subcategory": "dynamics",
          "path": "effects/dynamics/amp_follower.vibe"
        },
        {
          "name": "compressor",
          "description": "release: Release time in seconds",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "threshold",
              "default": 0.5
            },
            {
              "name": "ratio",
              "default": 4
            },
            {
              "name": "attack",
              "default": 0.01
            },
            {
              "name": "release",
              "default": 0.1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"compressor\", |builder| {\n    builder\n        .param(\"threshold\", 0.5)\n        .param(\"ratio\", 4.0)\n        .param(\"attack\", 0.01)\n        .param(\"release\", 0.1)\n        .body(|input, threshold, ratio, attack, release| {\n            // Apply compander to both channels\n            let left = compander_ar(input[0], input[0], threshold, 1.0, 1.0/ratio, attack, release);\n            let right = compander_ar(input[1], input[1], threshold, 1.0, 1.0/ratio, attack, release);\n\n            [left, right]\n        })\n});",
          "category": "effects",
          "subcategory": "dynamics",
          "path": "effects/dynamics/compressor.vibe"
        },
        {
          "name": "de_esser",
          "description": "width: Detection bandwidth (0.0 = narrow, 1.0 = wide)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "freq",
              "default": 6000
            },
            {
              "name": "threshold",
              "default": 0.5
            },
            {
              "name": "reduction",
              "default": 0.5
            },
            {
              "name": "width",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"de_esser\", |builder| {\n    builder\n        .param(\"freq\", 6000.0)\n        .param(\"threshold\", 0.5)\n        .param(\"reduction\", 0.5)\n        .param(\"width\", 0.5)\n        .body(|input, freq, threshold, reduction, width| {\n            // Extract sibilance band\n            let q = 0.5 + (1.0 - width) * 1.5;\n            let sib_l = rlpf_ar(hpf_ar(input[0], freq * 0.7), freq, q);\n            let sib_r = rlpf_ar(hpf_ar(input[1], freq * 0.7), freq, q);\n\n            // Detect sibilance level\n            let detect_l = lag_ar(sib_l.abs(), 0.002);\n            let detect_r = lag_ar(sib_r.abs(), 0.002);\n\n            // Calculate gain reduction\n            let thresh = 0.1 + threshold * 0.4;\n            let over_l = (detect_l - thresh).max(0.0);\n            let over_r = (detect_r - thresh).max(0.0);\n\n            // Smooth gain reduction\n            let gr_l = (1.0 - over_l * reduction * 10.0).max(0.2);\n            let gr_r = (1.0 - over_r * reduction * 10.0).max(0.2);\n\n            let smooth_gr_l = lag_ar(gr_l, 0.005);\n            let smooth_gr_r = lag_ar(gr_r, 0.005);\n\n            // Apply reduction only to sibilance band\n            let reduced_sib_l = sib_l * smooth_gr_l;\n            let reduced_sib_r = sib_r * smooth_gr_r;\n\n            // Subtract original sibilance, add reduced version\n            let out_l = input[0] - sib_l + reduced_sib_l;\n            let out_r = input[1] - sib_r + reduced_sib_r;\n\n            [out_l, out_r]\n        })\n});",
          "category": "effects",
          "subcategory": "dynamics",
          "path": "effects/dynamics/de_esser.vibe"
        },
        {
          "name": "ducking",
          "description": "release: Release time in seconds",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "threshold",
              "default": 0.3
            },
            {
              "name": "ratio",
              "default": 5
            },
            {
              "name": "attack",
              "default": 0.01
            },
            {
              "name": "release",
              "default": 0.1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"ducking\", |builder| {\n    builder\n        .param(\"threshold\", 0.3)\n        .param(\"ratio\", 5.0)\n        .param(\"attack\", 0.01)\n        .param(\"release\", 0.1)\n        .body(|input, threshold, ratio, attack, release| {\n            // Apply compression (ducking)\n            let ducked_left = compander_ar(input[0], input[0], threshold, 1.0, 1.0/ratio, attack, release);\n            let ducked_right = compander_ar(input[1], input[1], threshold, 1.0, 1.0/ratio, attack, release);\n\n            [ducked_left, ducked_right]\n        })\n});",
          "category": "effects",
          "subcategory": "dynamics",
          "path": "effects/dynamics/ducking.vibe"
        },
        {
          "name": "gate",
          "description": "release: Release time in seconds",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "threshold",
              "default": 0.1
            },
            {
              "name": "attack",
              "default": 0.01
            },
            {
              "name": "release",
              "default": 0.1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"gate\", |builder| {\n    builder\n        .param(\"threshold\", 0.1)\n        .param(\"attack\", 0.01)\n        .param(\"release\", 0.1)\n        .body(|input, threshold, attack, release| {\n            // Use Compander as a gate (expansion below threshold)\n            let gated_left = compander_ar(input[0], input[0], threshold, 10.0, 1.0, attack, release);\n            let gated_right = compander_ar(input[1], input[1], threshold, 10.0, 1.0, attack, release);\n\n            [gated_left, gated_right]\n        })\n});",
          "category": "effects",
          "subcategory": "dynamics",
          "path": "effects/dynamics/gate.vibe"
        },
        {
          "name": "limiter",
          "description": "lookahead: Lookahead time in seconds (0.001 to 0.1)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "level",
              "default": 0.9
            },
            {
              "name": "lookahead",
              "default": 0.01
            }
          ],
          "type": "fx",
          "source": "define_fx(\"limiter\", |builder| {\n    builder\n        .param(\"level\", 0.9)\n        .param(\"lookahead\", 0.01)\n        .body(|input, level, lookahead| {\n            // Apply limiter to both channels\n            let limited_left = limiter_ar(input[0], level, lookahead);\n            let limited_right = limiter_ar(input[1], level, lookahead);\n\n            [limited_left, limited_right]\n        })\n});",
          "category": "effects",
          "subcategory": "dynamics",
          "path": "effects/dynamics/limiter.vibe"
        },
        {
          "name": "multiband_comp",
          "description": "mix: Dry/wet mix",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "low_freq",
              "default": 200
            },
            {
              "name": "high_freq",
              "default": 3000
            },
            {
              "name": "low_thresh",
              "default": 0.5
            },
            {
              "name": "mid_thresh",
              "default": 0.4
            },
            {
              "name": "high_thresh",
              "default": 0.3
            },
            {
              "name": "ratio",
              "default": 4
            },
            {
              "name": "attack",
              "default": 0.01
            },
            {
              "name": "release",
              "default": 0.1
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"multiband_comp\", |builder| {\n    builder\n        .param(\"low_freq\", 200.0)\n        .param(\"high_freq\", 3000.0)\n        .param(\"low_thresh\", 0.5)\n        .param(\"mid_thresh\", 0.4)\n        .param(\"high_thresh\", 0.3)\n        .param(\"ratio\", 4.0)\n        .param(\"attack\", 0.01)\n        .param(\"release\", 0.1)\n        .param(\"mix\", 1.0)\n        .body(|input, low_freq, high_freq, low_thresh, mid_thresh, high_thresh, ratio, attack, release, mix| {\n            // Split into bands\n            let low_left = lpf_ar(input[0], low_freq);\n            let low_right = lpf_ar(input[1], low_freq);\n\n            let high_left = hpf_ar(input[0], high_freq);\n            let high_right = hpf_ar(input[1], high_freq);\n\n            let mid_left = hpf_ar(lpf_ar(input[0], high_freq), low_freq);\n            let mid_right = hpf_ar(lpf_ar(input[1], high_freq), low_freq);\n\n            // Compress each band\n            let comp_low_left = compander_ar(low_left, low_left, low_thresh, 1.0, 1.0/ratio, attack, release);\n            let comp_low_right = compander_ar(low_right, low_right, low_thresh, 1.0, 1.0/ratio, attack, release);\n\n            let comp_mid_left = compander_ar(mid_left, mid_left, mid_thresh, 1.0, 1.0/ratio, attack, release);\n            let comp_mid_right = compander_ar(mid_right, mid_right, mid_thresh, 1.0, 1.0/ratio, attack, release);\n\n            let comp_high_left = compander_ar(high_left, high_left, high_thresh, 1.0, 1.0/ratio, attack, release);\n            let comp_high_right = compander_ar(high_right, high_right, high_thresh, 1.0, 1.0/ratio, attack, release);\n\n            // Recombine bands\n            let processed_left = comp_low_left + comp_mid_left + comp_high_left;\n            let processed_right = comp_low_right + comp_mid_right + comp_high_right;\n\n            [\n                (1.0 - mix) * input[0] + mix * processed_left,\n                (1.0 - mix) * input[1] + mix * processed_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "dynamics",
          "path": "effects/dynamics/multiband_comp.vibe"
        },
        {
          "name": "parallel_comp",
          "description": "blend: Blend of compressed signal (0.0 to 1.0)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "ratio",
              "default": 8
            },
            {
              "name": "attack",
              "default": 0.3
            },
            {
              "name": "release",
              "default": 0.4
            },
            {
              "name": "makeup",
              "default": 1
            },
            {
              "name": "blend",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"parallel_comp\", |builder| {\n    builder\n        .param(\"ratio\", 8.0)\n        .param(\"attack\", 0.3)\n        .param(\"release\", 0.4)\n        .param(\"makeup\", 1.0)\n        .param(\"blend\", 0.5)\n        .body(|input, ratio, attack, release, makeup, blend| {\n            // Convert attack/release to time constants\n            let attack_time = 0.001 + attack * 0.05;\n            let release_time = 0.05 + release * 0.3;\n\n            // Envelope follower for compression\n            let env_l = lag_ar(input[0].abs(), attack_time);\n            let env_r = lag_ar(input[1].abs(), attack_time);\n\n            // Calculate gain reduction (ratio-based compression)\n            let threshold = 0.2;\n            let over_l = (env_l - threshold).max(0.0);\n            let over_r = (env_r - threshold).max(0.0);\n\n            // Apply ratio\n            let reduction_l = over_l * (1.0 - 1.0 / ratio);\n            let reduction_r = over_r * (1.0 - 1.0 / ratio);\n\n            // Smooth gain reduction\n            let gain_l = lag_ar(1.0 - reduction_l * 2.0, release_time).max(0.1);\n            let gain_r = lag_ar(1.0 - reduction_r * 2.0, release_time).max(0.1);\n\n            // Apply compression\n            let comp_l = input[0] * gain_l * makeup;\n            let comp_r = input[1] * gain_r * makeup;\n\n            // Parallel blend (dry + compressed)\n            let out_l = input[0] + comp_l * blend;\n            let out_r = input[1] + comp_r * blend;\n\n            // Normalize output\n            let norm = 1.0 / (1.0 + blend * 0.5);\n\n            [out_l * norm, out_r * norm]\n        })\n});",
          "category": "effects",
          "subcategory": "dynamics",
          "path": "effects/dynamics/parallel_comp.vibe"
        },
        {
          "name": "sidechain",
          "description": "amount: Effect intensity (0.0 = off, 1.0 = full pump)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "threshold",
              "default": 0.3
            },
            {
              "name": "ratio",
              "default": 8
            },
            {
              "name": "attack",
              "default": 0.001
            },
            {
              "name": "release",
              "default": 0.15
            },
            {
              "name": "amount",
              "default": 0.7
            }
          ],
          "type": "fx",
          "source": "define_fx(\"sidechain\", |builder| {\n    builder\n        .param(\"threshold\", 0.3)\n        .param(\"ratio\", 8.0)\n        .param(\"attack\", 0.001)\n        .param(\"release\", 0.15)\n        .param(\"amount\", 0.7)\n        .body(|input, threshold, ratio, attack, release, amount| {\n            // Follow the input amplitude for self-ducking\n            // In a real scenario you'd use a sidechain input\n            let left_amp = amplitude_ar(input[0], attack, release);\n            let right_amp = amplitude_ar(input[1], attack, release);\n            let env = (left_amp + right_amp) * 0.5;\n\n            // Calculate gain reduction when above threshold\n            let above_thresh = env - threshold;\n            let gain_reduction = 1.0 - (above_thresh.max(0.0) * (1.0 - 1.0/ratio) * amount);\n\n            // Apply gain reduction\n            [\n                input[0] * gain_reduction,\n                input[1] * gain_reduction\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "dynamics",
          "path": "effects/dynamics/sidechain.vibe"
        },
        {
          "name": "transient_shaper",
          "description": "output: Output gain compensation",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "attack",
              "default": "0.0"
            },
            {
              "name": "sustain",
              "default": "0.0"
            },
            {
              "name": "output",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"transient_shaper\", |builder| {\n    builder\n        .param(\"attack\", 0.0)\n        .param(\"sustain\", 0.0)\n        .param(\"output\", 1.0)\n        .body(|input, attack, sustain, output| {\n            // Fast envelope for transient detection\n            let fast_env_l = lag_ar(input[0].abs(), 0.001);\n            let fast_env_r = lag_ar(input[1].abs(), 0.001);\n\n            // Slow envelope for sustain detection\n            let slow_env_l = lag_ar(input[0].abs(), 0.1);\n            let slow_env_r = lag_ar(input[1].abs(), 0.1);\n\n            // Transient = fast - slow (positive during attacks)\n            let transient_l = (fast_env_l - slow_env_l).max(0.0);\n            let transient_r = (fast_env_r - slow_env_r).max(0.0);\n\n            // Attack gain (boost or cut transients)\n            let attack_gain = 1.0 + attack * 2.0;\n            let attack_mod_l = 1.0 + transient_l * (attack_gain - 1.0) * 10.0;\n            let attack_mod_r = 1.0 + transient_r * (attack_gain - 1.0) * 10.0;\n\n            // Sustain gain (boost or cut body)\n            let sustain_mod_l = 1.0 + slow_env_l * sustain * 2.0;\n            let sustain_mod_r = 1.0 + slow_env_r * sustain * 2.0;\n\n            // Combine attack and sustain processing\n            let out_l = input[0] * attack_mod_l * sustain_mod_l;\n            let out_r = input[1] * attack_mod_r * sustain_mod_r;\n\n            // Soft limiting to prevent clipping\n            let limited_l = (out_l * output).tanh();\n            let limited_r = (out_r * output).tanh();\n\n            [limited_l, limited_r]\n        })\n});",
          "category": "effects",
          "subcategory": "dynamics",
          "path": "effects/dynamics/transient_shaper.vibe"
        }
      ],
      "Filters": [
        {
          "name": "bandpass",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "freq",
              "default": 1000
            },
            {
              "name": "bandwidth",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"bandpass\", |builder| {\n    builder\n        .param(\"freq\", 1000.0)\n        .param(\"bandwidth\", 0.5)\n        .param(\"mix\", 1.0)\n        .body(|input, freq, bandwidth, mix| {\n            // BPF provides band pass filtering\n            let filtered_left = bpf_ar(input[0], freq, bandwidth);\n            let filtered_right = bpf_ar(input[1], freq, bandwidth);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "filters",
          "path": "effects/filters/bandpass.vibe"
        },
        {
          "name": "comb_filter",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "decay",
              "default": 2
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"comb_filter\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"decay\", 2.0)\n        .param(\"mix\", 0.5)\n        .body(|input, freq, decay, mix| {\n            // Calculate delay time from frequency\n            let delay_time = 1.0 / freq;\n\n            // Apply comb filter\n            let combed_left = comb_l_ar(input[0], 0.1, delay_time, decay);\n            let combed_right = comb_l_ar(input[1], 0.1, delay_time, decay);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * combed_left,\n                (1.0 - mix) * input[1] + mix * combed_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "filters",
          "path": "effects/filters/comb_filter.vibe"
        },
        {
          "name": "eq_three_band",
          "description": "high_freq: Mid/high crossover frequency in Hz",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "low_gain",
              "default": "0.0"
            },
            {
              "name": "mid_gain",
              "default": "0.0"
            },
            {
              "name": "high_gain",
              "default": "0.0"
            },
            {
              "name": "low_freq",
              "default": 250
            },
            {
              "name": "high_freq",
              "default": 4000
            }
          ],
          "type": "fx",
          "source": "define_fx(\"eq_three_band\", |builder| {\n    builder\n        .param(\"low_gain\", 0.0)\n        .param(\"mid_gain\", 0.0)\n        .param(\"high_gain\", 0.0)\n        .param(\"low_freq\", 250.0)\n        .param(\"high_freq\", 4000.0)\n        .body(|input, low_gain, mid_gain, high_gain, low_freq, high_freq| {\n            // Process left channel\n            let low_left = b_low_shelf_ar(input[0], low_freq, 1.0, low_gain);\n            let mid_left = b_peak_eq_ar(low_left, (low_freq + high_freq) * 0.5, 1.0, mid_gain);\n            let eq_left = b_hi_shelf_ar(mid_left, high_freq, 1.0, high_gain);\n\n            // Process right channel\n            let low_right = b_low_shelf_ar(input[1], low_freq, 1.0, low_gain);\n            let mid_right = b_peak_eq_ar(low_right, (low_freq + high_freq) * 0.5, 1.0, mid_gain);\n            let eq_right = b_hi_shelf_ar(mid_right, high_freq, 1.0, high_gain);\n\n            [eq_left, eq_right]\n        })\n});",
          "category": "effects",
          "subcategory": "filters",
          "path": "effects/filters/eq_three_band.vibe"
        },
        {
          "name": "formant_filter",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "freq",
              "default": 800
            },
            {
              "name": "attack",
              "default": 0.01
            },
            {
              "name": "decay",
              "default": 0.1
            },
            {
              "name": "mix",
              "default": 0.7
            }
          ],
          "type": "fx",
          "source": "define_fx(\"formant_filter\", |builder| {\n    builder\n        .param(\"freq\", 800.0)\n        .param(\"attack\", 0.01)\n        .param(\"decay\", 0.1)\n        .param(\"mix\", 0.7)\n        .body(|input, freq, attack, decay, mix| {\n            // Apply formant filtering\n            let formant_left = formlet_ar(input[0], freq, attack, decay);\n            let formant_right = formlet_ar(input[1], freq, attack, decay);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * formant_left,\n                (1.0 - mix) * input[1] + mix * formant_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "filters",
          "path": "effects/filters/formant_filter.vibe"
        },
        {
          "name": "highpass",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "cutoff",
              "default": 200
            },
            {
              "name": "resonance",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"highpass\", |builder| {\n    builder\n        .param(\"cutoff\", 200.0)\n        .param(\"resonance\", 0.5)\n        .param(\"mix\", 1.0)\n        .body(|input, cutoff, resonance, mix| {\n            // RHPF provides resonant high pass filtering\n            let filtered_left = rhpf_ar(input[0], cutoff, resonance);\n            let filtered_right = rhpf_ar(input[1], cutoff, resonance);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "filters",
          "path": "effects/filters/highpass.vibe"
        },
        {
          "name": "ladder_filter",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "cutoff",
              "default": 1000
            },
            {
              "name": "res",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"ladder_filter\", |builder| {\n    builder\n        .param(\"cutoff\", 1000.0)\n        .param(\"res\", 0.5)\n        .param(\"mix\", 1.0)\n        .body(|input, cutoff, res, mix| {\n            // Multi-stage lowpass for ladder characteristic\n            let stage1_left = lpf_ar(input[0], cutoff);\n            let stage2_left = lpf_ar(stage1_left, cutoff);\n            let stage3_left = lpf_ar(stage2_left, cutoff);\n            let stage4_left = lpf_ar(stage3_left, cutoff);\n\n            let stage1_right = lpf_ar(input[1], cutoff);\n            let stage2_right = lpf_ar(stage1_right, cutoff);\n            let stage3_right = lpf_ar(stage2_right, cutoff);\n            let stage4_right = lpf_ar(stage3_right, cutoff);\n\n            // Add resonance feedback\n            let feedback = res * 3.8;\n            let res_left = stage4_left + input[0] * feedback * 0.1;\n            let res_right = stage4_right + input[1] * feedback * 0.1;\n\n            [\n                (1.0 - mix) * input[0] + mix * res_left,\n                (1.0 - mix) * input[1] + mix * res_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "filters",
          "path": "effects/filters/ladder_filter.vibe"
        },
        {
          "name": "lowpass",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "cutoff",
              "default": 2000
            },
            {
              "name": "resonance",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"lowpass\", |builder| {\n    builder\n        .param(\"cutoff\", 2000.0)\n        .param(\"resonance\", 0.5)\n        .param(\"mix\", 1.0)\n        .body(|input, cutoff, resonance, mix| {\n            // RLPF provides resonant low pass filtering\n            let filtered_left = rlpf_ar(input[0], cutoff, resonance);\n            let filtered_right = rlpf_ar(input[1], cutoff, resonance);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "filters",
          "path": "effects/filters/lowpass.vibe"
        },
        {
          "name": "moog_filter",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "cutoff",
              "default": 1000
            },
            {
              "name": "resonance",
              "default": 2.5
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"moog_filter\", |builder| {\n    builder\n        .param(\"cutoff\", 1000.0)\n        .param(\"resonance\", 2.5)\n        .param(\"mix\", 1.0)\n        .body(|input, cutoff, resonance, mix| {\n            // MoogFF - the classic Moog ladder filter\n            let filtered_left = moog_ff_ar(input[0], cutoff, resonance, 0.0);\n            let filtered_right = moog_ff_ar(input[1], cutoff, resonance, 0.0);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "filters",
          "path": "effects/filters/moog_filter.vibe"
        },
        {
          "name": "resonator",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "decay",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"resonator\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"decay\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, freq, decay, mix| {\n            // Comb filter for resonance\n            let delay_time = 1.0 / freq;\n            let resonated_left = comb_c_ar(input[0], 0.05, delay_time, decay * 2.0);\n            let resonated_right = comb_c_ar(input[1], 0.05, delay_time, decay * 2.0);\n\n            [\n                (1.0 - mix) * input[0] + mix * resonated_left,\n                (1.0 - mix) * input[1] + mix * resonated_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "filters",
          "path": "effects/filters/resonator.vibe"
        }
      ],
      "Modulation": [
        {
          "name": "auto_pan",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "rate",
              "default": 0.25
            },
            {
              "name": "depth",
              "default": 0.8
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"auto_pan\", |builder| {\n    builder\n        .param(\"rate\", 0.25)\n        .param(\"depth\", 0.8)\n        .param(\"mix\", 1.0)\n        .body(|input, rate, depth, mix| {\n            // LFO for pan position\n            let lfo = sin_osc_ar(rate, 0.0);\n            let pan_pos = lfo * depth;\n\n            // Mix to mono first, then pan\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Pan the signal and split into stereo channels\n            let stereo = channels(pan2_ar(mono, pan_pos, 1.0), 2);\n\n            // Mix dry and wet signals\n            [\n                (1.0 - mix) * input[0] + mix * stereo[0],\n                (1.0 - mix) * input[1] + mix * stereo[1]\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/auto_pan.vibe"
        },
        {
          "name": "auto_wah",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "sensitivity",
              "default": 0.5
            },
            {
              "name": "depth",
              "default": 2000
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"auto_wah\", |builder| {\n    builder\n        .param(\"sensitivity\", 0.5)\n        .param(\"depth\", 2000.0)\n        .param(\"mix\", 1.0)\n        .body(|input, sensitivity, depth, mix| {\n            // Envelope follower\n            let env_left = amplitude_ar(input[0], 0.01, 0.1);\n            let env_right = amplitude_ar(input[1], 0.01, 0.1);\n\n            // Calculate filter cutoff based on envelope\n            let cutoff_left = 400.0 + env_left * sensitivity * depth;\n            let cutoff_right = 400.0 + env_right * sensitivity * depth;\n\n            // Resonant bandpass for wah character\n            let wah_left = bpf_ar(input[0], cutoff_left, 0.2);\n            let wah_right = bpf_ar(input[1], cutoff_right, 0.2);\n\n            [\n                (1.0 - mix) * input[0] + mix * wah_left,\n                (1.0 - mix) * input[1] + mix * wah_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/auto_wah.vibe"
        },
        {
          "name": "chorus",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "rate",
              "default": 0.5
            },
            {
              "name": "depth",
              "default": 0.01
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"chorus\", |builder| {\n    builder\n        .param(\"rate\", 0.5)\n        .param(\"depth\", 0.01)\n        .param(\"mix\", 0.5)\n        .body(|input, rate, depth, mix| {\n            // LFO for modulation\n            let lfo_left = sin_osc_ar(rate, 0.0);\n            let lfo_right = sin_osc_ar(rate, 1.57); // 90 degrees phase offset\n\n            // Modulated delay time\n            let delay_time_left = 0.02 + (depth * lfo_left);\n            let delay_time_right = 0.02 + (depth * lfo_right);\n\n            // Delayed signals with interpolation for smooth modulation\n            let delayed_left = delay_c_ar(input[0], 0.1, delay_time_left);\n            let delayed_right = delay_c_ar(input[1], 0.1, delay_time_right);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * delayed_left,\n                (1.0 - mix) * input[1] + mix * delayed_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/chorus.vibe"
        },
        {
          "name": "dimension_chorus",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "mode",
              "default": 0.5
            },
            {
              "name": "rate",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"dimension_chorus\", |builder| {\n    builder\n        .param(\"mode\", 0.5)\n        .param(\"rate\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, mode, rate, mix| {\n            let lfo_rate = 0.3 + rate * 1.2;\n\n            // Four BBD-style delay lines with different phases\n            let lfo1 = sin_osc_ar(lfo_rate) * mode * 0.003;\n            let lfo2 = sin_osc_ar(lfo_rate, 1.57) * mode * 0.003;  // 90 degrees\n            let lfo3 = sin_osc_ar(lfo_rate, 3.14) * mode * 0.003; // 180 degrees\n            let lfo4 = sin_osc_ar(lfo_rate, 4.71) * mode * 0.003; // 270 degrees\n\n            // Base delay times (BBD character)\n            let base_delay = 0.005 + mode * 0.005;\n\n            // Chorus voices - left channel\n            let voice1_l = delay_c_ar(input[0], 0.05, base_delay + lfo1);\n            let voice2_l = delay_c_ar(input[0], 0.05, base_delay * 1.1 + lfo3);\n\n            // Chorus voices - right channel\n            let voice1_r = delay_c_ar(input[1], 0.05, base_delay + lfo2);\n            let voice2_r = delay_c_ar(input[1], 0.05, base_delay * 1.1 + lfo4);\n\n            // Subtle high frequency roll-off (BBD character)\n            let chorus_l = lpf_ar((voice1_l + voice2_l) * 0.5, 12000.0);\n            let chorus_r = lpf_ar((voice1_r + voice2_r) * 0.5, 12000.0);\n\n            // Mix with slight cross-feed for dimension\n            let wet_l = chorus_l + chorus_r * 0.15;\n            let wet_r = chorus_r + chorus_l * 0.15;\n\n            [\n                (1.0 - mix) * input[0] + mix * wet_l,\n                (1.0 - mix) * input[1] + mix * wet_r\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/dimension_chorus.vibe"
        },
        {
          "name": "flanger",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "rate",
              "default": 0.3
            },
            {
              "name": "depth",
              "default": 0.005
            },
            {
              "name": "feedback",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"flanger\", |builder| {\n    builder\n        .param(\"rate\", 0.3)\n        .param(\"depth\", 0.005)\n        .param(\"feedback\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, rate, depth, feedback, mix| {\n            // LFO for modulation\n            let lfo = sin_osc_ar(rate, 0.0);\n\n            // Modulated delay time (shorter than chorus for flanger effect)\n            let delay_time = 0.003 + (depth * lfo);\n\n            // Create delayed signals with feedback\n            let delayed_left = delay_c_ar(input[0] + (feedback * delay_c_ar(input[0], 0.02, delay_time)), 0.02, delay_time);\n            let delayed_right = delay_c_ar(input[1] + (feedback * delay_c_ar(input[1], 0.02, delay_time)), 0.02, delay_time);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * delayed_left,\n                (1.0 - mix) * input[1] + mix * delayed_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/flanger.vibe"
        },
        {
          "name": "freq_shift",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "shift",
              "default": 5
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"freq_shift\", |builder| {\n    builder\n        .param(\"shift\", 5.0)\n        .param(\"mix\", 0.5)\n        .body(|input, shift, mix| {\n            // Ring modulation with sine wave creates frequency shifting\n            // Positive shift moves frequencies up, negative moves down\n            let mod_osc = sin_osc_ar(shift.abs());\n\n            // Apply ring modulation\n            let shifted_left = input[0] * mod_osc;\n            let shifted_right = input[1] * mod_osc;\n\n            // Filter to remove unwanted sidebands\n            let filtered_left = lpf_ar(shifted_left, 12000.0);\n            let filtered_right = lpf_ar(shifted_right, 12000.0);\n\n            // Mix dry and wet\n            [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/freq_shift.vibe"
        },
        {
          "name": "phaser",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "rate",
              "default": 0.5
            },
            {
              "name": "depth",
              "default": 1000
            },
            {
              "name": "freq",
              "default": 1000
            },
            {
              "name": "feedback",
              "default": 0.3
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"phaser\", |builder| {\n    builder\n        .param(\"rate\", 0.5)\n        .param(\"depth\", 1000.0)\n        .param(\"freq\", 1000.0)\n        .param(\"feedback\", 0.3)\n        .param(\"mix\", 0.5)\n        .body(|input, rate, depth, freq, feedback, mix| {\n            // LFO for filter modulation\n            let lfo = sin_osc_ar(rate, 0.0);\n            let mod_freq = freq + (depth * lfo);\n\n            // Chain of all-pass filters for phaser effect\n            let phased_left = input[0];\n            let phased_right = input[1];\n\n            // Apply multiple stages of all-pass filtering\n            phased_left = allpass_n_ar(phased_left, 0.02, 1.0 / mod_freq, 0.0);\n            phased_left = allpass_n_ar(phased_left, 0.02, 1.0 / (mod_freq * 1.5), 0.0);\n            phased_left = allpass_n_ar(phased_left, 0.02, 1.0 / (mod_freq * 2.0), 0.0);\n\n            phased_right = allpass_n_ar(phased_right, 0.02, 1.0 / mod_freq, 0.0);\n            phased_right = allpass_n_ar(phased_right, 0.02, 1.0 / (mod_freq * 1.5), 0.0);\n            phased_right = allpass_n_ar(phased_right, 0.02, 1.0 / (mod_freq * 2.0), 0.0);\n\n            // Add feedback\n            phased_left = phased_left + (feedback * phased_left);\n            phased_right = phased_right + (feedback * phased_right);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * phased_left,\n                (1.0 - mix) * input[1] + mix * phased_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/phaser.vibe"
        },
        {
          "name": "pitch_shift",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "ratio",
              "default": 1.5
            },
            {
              "name": "window",
              "default": 0.2
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"pitch_shift\", |builder| {\n    builder\n        .param(\"ratio\", 1.5)\n        .param(\"window\", 0.2)\n        .param(\"mix\", 0.5)\n        .body(|input, ratio, window, mix| {\n            // Apply pitch shifting to both channels\n            let shifted_left = pitch_shift_ar(input[0], window, ratio, 0.0, 0.0);\n            let shifted_right = pitch_shift_ar(input[1], window, ratio, 0.0, 0.0);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * shifted_left,\n                (1.0 - mix) * input[1] + mix * shifted_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/pitch_shift.vibe"
        },
        {
          "name": "ring_mod",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"ring_mod\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"mix\", 0.5)\n        .body(|input, freq, mix| {\n            // Generate modulator (carrier wave)\n            let modulator = sin_osc_ar(freq, 0.0);\n\n            // Ring modulation: multiply input by modulator\n            let modulated = [\n                input[0] * modulator,\n                input[1] * modulator\n            ];\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * modulated[0],\n                (1.0 - mix) * input[1] + mix * modulated[1]\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/ring_mod.vibe"
        },
        {
          "name": "rotary",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "rate",
              "default": 6
            },
            {
              "name": "depth",
              "default": 0.003
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"rotary\", |builder| {\n    builder\n        .param(\"rate\", 6.0)\n        .param(\"depth\", 0.003)\n        .param(\"mix\", 1.0)\n        .body(|input, rate, depth, mix| {\n            // Mix to mono for effect\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // LFOs for modulation (90 degrees apart for stereo)\n            let lfo_left = sin_osc_ar(rate, 0.0);\n            let lfo_right = sin_osc_ar(rate, 1.57);\n\n            // Doppler effect (pitch modulation via delay)\n            let delay_left = 0.005 + (depth * lfo_left);\n            let delay_right = 0.005 + (depth * lfo_right);\n\n            let doppler_left = delay_c_ar(mono, 0.1, delay_left);\n            let doppler_right = delay_c_ar(mono, 0.1, delay_right);\n\n            // Amplitude modulation (volume changes as speaker rotates)\n            let amp_mod_left = 0.8 + (0.2 * lfo_left);\n            let amp_mod_right = 0.8 + (0.2 * lfo_right);\n\n            // Combine effects\n            let rotated = [\n                doppler_left * amp_mod_left,\n                doppler_right * amp_mod_right\n            ];\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * rotated[0],\n                (1.0 - mix) * input[1] + mix * rotated[1]\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/rotary.vibe"
        },
        {
          "name": "tremolo",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "rate",
              "default": 4
            },
            {
              "name": "depth",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"tremolo\", |builder| {\n    builder\n        .param(\"rate\", 4.0)\n        .param(\"depth\", 0.5)\n        .param(\"mix\", 1.0)\n        .body(|input, rate, depth, mix| {\n            // LFO for amplitude modulation\n            let lfo = sin_osc_ar(rate, 0.0);\n\n            // Convert LFO from -1..1 to modulation range\n            let mod = 1.0 - (depth * 0.5 * (1.0 + lfo));\n\n            // Apply modulation to both channels\n            let modulated = [\n                input[0] * mod,\n                input[1] * mod\n            ];\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * modulated[0],\n                (1.0 - mix) * input[1] + mix * modulated[1]\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/tremolo.vibe"
        },
        {
          "name": "vibrato",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "rate",
              "default": 5
            },
            {
              "name": "depth",
              "default": 0.002
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"vibrato\", |builder| {\n    builder\n        .param(\"rate\", 5.0)\n        .param(\"depth\", 0.002)\n        .param(\"mix\", 1.0)\n        .body(|input, rate, depth, mix| {\n            // LFO for pitch modulation\n            let lfo = sin_osc_ar(rate, 0.0);\n\n            // Modulated delay time creates pitch variation\n            let delay_time = 0.01 + (depth * lfo);\n\n            // Apply modulated delay\n            let vibrato_left = delay_c_ar(input[0], 0.1, delay_time);\n            let vibrato_right = delay_c_ar(input[1], 0.1, delay_time);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * vibrato_left,\n                (1.0 - mix) * input[1] + mix * vibrato_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "modulation",
          "path": "effects/modulation/vibrato.vibe"
        }
      ],
      "Reverbs": [
        {
          "name": "gverb",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "roomsize",
              "default": 50
            },
            {
              "name": "revtime",
              "default": 3
            },
            {
              "name": "damping",
              "default": 0.5
            },
            {
              "name": "spread",
              "default": 15
            },
            {
              "name": "drylevel",
              "default": 0.7
            },
            {
              "name": "earlylevel",
              "default": 0.7
            },
            {
              "name": "taillevel",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 0.35
            }
          ],
          "type": "fx",
          "source": "define_fx(\"gverb\", |builder| {\n    builder\n        .param(\"roomsize\", 50.0)\n        .param(\"revtime\", 3.0)\n        .param(\"damping\", 0.5)\n        .param(\"spread\", 15.0)\n        .param(\"drylevel\", 0.7)\n        .param(\"earlylevel\", 0.7)\n        .param(\"taillevel\", 0.5)\n        .param(\"mix\", 0.35)\n        .body(|input, roomsize, revtime, damping, spread, drylevel, earlylevel, taillevel, mix| {\n            // Mix to mono for the reverb input\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Split the stereo outputs and apply dry/wet mix manually\n            let wet_node = g_verb_ar(mono, roomsize, revtime, damping, 0.5, spread, drylevel, earlylevel, taillevel, 300.0);\n            let wet_left = channel(wet_node, 0);\n            let wet_right = channel(wet_node, 1);\n\n            [\n                (1.0 - mix) * input[0] + mix * wet_left,\n                (1.0 - mix) * input[1] + mix * wet_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "reverbs",
          "path": "effects/reverbs/gverb.vibe"
        },
        {
          "name": "hall_reverb",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "size",
              "default": 0.7
            },
            {
              "name": "decay",
              "default": 0.6
            },
            {
              "name": "damping",
              "default": 0.4
            },
            {
              "name": "predelay",
              "default": 0.02
            },
            {
              "name": "mix",
              "default": 0.35
            }
          ],
          "type": "fx",
          "source": "define_fx(\"hall_reverb\", |builder| {\n    builder\n        .param(\"size\", 0.7)\n        .param(\"decay\", 0.6)\n        .param(\"damping\", 0.4)\n        .param(\"predelay\", 0.02)\n        .param(\"mix\", 0.35)\n        .body(|input, size, decay, damping, predelay, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Pre-delay for source separation\n            let predelayed = delay_c_ar(mono, 0.2, predelay);\n\n            // FreeVerb as core reverb engine with hall-like settings\n            let verb = free_verb_ar(predelayed, 1.0, 0.5 + size * 0.45, damping);\n\n            // Additional diffusion for hall character\n            let diff1 = allpass_c_ar(verb, 0.2, 0.067 * (1.0 + size), decay * 0.6);\n            let diff2 = allpass_c_ar(diff1, 0.2, 0.093 * (1.0 + size), decay * 0.5);\n            let diff3 = allpass_c_ar(diff2, 0.2, 0.117 * (1.0 + size), decay * 0.4);\n\n            // Late reflections\n            let late1 = delay_c_ar(diff3, 0.5, 0.13 + size * 0.15) * 0.4;\n            let late2 = delay_c_ar(diff3, 0.5, 0.19 + size * 0.12) * 0.3;\n            let late3 = delay_c_ar(diff3, 0.5, 0.27 + size * 0.1) * 0.2;\n\n            let combined = diff3 + late1 + late2 + late3;\n\n            // High frequency roll-off for natural air absorption\n            let damped = lpf_ar(combined, 8000.0 - damping * 4000.0);\n\n            // Stereo decorrelation\n            let left = damped + delay_c_ar(damped, 0.05, 0.011) * 0.3;\n            let right = damped + delay_c_ar(damped, 0.05, 0.017) * 0.3;\n\n            [\n                (1.0 - mix) * input[0] + mix * left * 0.7,\n                (1.0 - mix) * input[1] + mix * right * 0.7\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "reverbs",
          "path": "effects/reverbs/hall_reverb.vibe"
        },
        {
          "name": "plate_reverb",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "time",
              "default": 2
            },
            {
              "name": "damping",
              "default": 0.4
            },
            {
              "name": "mix",
              "default": 0.3
            }
          ],
          "type": "fx",
          "source": "define_fx(\"plate_reverb\", |builder| {\n    builder\n        .param(\"time\", 2.0)\n        .param(\"damping\", 0.4)\n        .param(\"mix\", 0.3)\n        .body(|input, time, damping, mix| {\n            // Mix to mono\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Pre-delay\n            let predelayed = delay_n_ar(mono, 0.1, 0.02);\n\n            // High frequency damping\n            let damped = lpf_ar(predelayed, 8000.0 * (1.0 - damping));\n\n            // Series of allpass filters for diffusion\n            let diffused = damped;\n            diffused = allpass_c_ar(diffused, 0.1, 0.0297, time * 0.1);\n            diffused = allpass_c_ar(diffused, 0.1, 0.0371, time * 0.1);\n            diffused = allpass_c_ar(diffused, 0.1, 0.0411, time * 0.1);\n            diffused = allpass_c_ar(diffused, 0.1, 0.0437, time * 0.1);\n\n            // Parallel comb filters for reverb tail\n            let comb1 = comb_l_ar(diffused, 0.2, 0.0297, time);\n            let comb2 = comb_l_ar(diffused, 0.2, 0.0371, time);\n            let comb3 = comb_l_ar(diffused, 0.2, 0.0411, time);\n            let comb4 = comb_l_ar(diffused, 0.2, 0.0437, time);\n\n            // Mix combs\n            let reverb = (comb1 + comb2 + comb3 + comb4) * 0.25;\n\n            // Create stereo with slight decorrelation\n            let left = reverb;\n            let right = delay_n_ar(reverb, 0.01, 0.005);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * left,\n                (1.0 - mix) * input[1] + mix * right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "reverbs",
          "path": "effects/reverbs/plate_reverb.vibe"
        },
        {
          "name": "reverb",
          "description": "Intentionally simple (“dumb”) reverb made from delays and filters so it is easy to debug.",
          "genre": "",
          "character": "",
          "params": [],
          "type": "fx",
          "source": "// Intentionally simple (“dumb”) reverb made from delays and filters so it is easy to debug.\n// This is not a studio-quality algorithm, but it makes the effect extremely obvious.\n\ndefine_fx(\"reverb\")\n    .param(\"room\", 0.6)\n    .param(\"damp\", 0.4)\n    .param(\"mix\", 0.3)\n    .body(|input, room, damp, mix| {\n        // Collapse to mono, run FreeVerb fully wet, then duplicate.\n        let mono = (input[0] + input[1]) * 0.5;\n        let wet = free_verb_ar(mono, 1.0, room, damp);\n        let stereo = dup(wet, 2);\n\n        [\n            (1.0 - mix) * input[0] + mix * stereo[0],\n            (1.0 - mix) * input[1] + mix * stereo[1]\n        ]\n    });\n",
          "category": "effects",
          "subcategory": "reverbs",
          "path": "effects/reverbs/reverb.vibe"
        },
        {
          "name": "reverb_minimal",
          "description": "damp: High-frequency damping (0.0 to 1.0)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "room",
              "default": 0.6
            },
            {
              "name": "damp",
              "default": 0.4
            }
          ],
          "type": "fx",
          "source": "define_fx(\"reverb_minimal\", |builder| {\n    builder\n        .param(\"room\", 0.6)\n        .param(\"damp\", 0.4)\n        .body(|input, room, damp| {\n            // Collapse to mono so we only need a single FreeVerb output.\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Run FreeVerb fully wet (mix=1.0) and duplicate the result to stereo.\n            let wet = free_verb_ar(mono, 1.0, room, damp);\n            let stereo = dup(wet, 2);\n\n            stereo\n        })\n});",
          "category": "effects",
          "subcategory": "reverbs",
          "path": "effects/reverbs/reverb_minimal.vibe"
        },
        {
          "name": "room_reverb",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "size",
              "default": 0.4
            },
            {
              "name": "brightness",
              "default": 0.5
            },
            {
              "name": "mix",
              "default": 0.25
            }
          ],
          "type": "fx",
          "source": "define_fx(\"room_reverb\", |builder| {\n    builder\n        .param(\"size\", 0.4)\n        .param(\"brightness\", 0.5)\n        .param(\"mix\", 0.25)\n        .body(|input, size, brightness, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Early reflections (room walls simulation)\n            let er1 = delay_c_ar(mono, 0.1, 0.007 + size * 0.01) * 0.6;\n            let er2 = delay_c_ar(mono, 0.1, 0.013 + size * 0.015) * 0.5;\n            let er3 = delay_c_ar(mono, 0.1, 0.019 + size * 0.02) * 0.4;\n            let er4 = delay_c_ar(mono, 0.1, 0.027 + size * 0.025) * 0.3;\n            let er5 = delay_c_ar(mono, 0.1, 0.037 + size * 0.03) * 0.25;\n\n            let early = er1 + er2 + er3 + er4 + er5;\n\n            // Diffuse tail\n            let room = 0.3 + size * 0.4;\n            let tail = free_verb_ar(early, 1.0, room, 0.6 - brightness * 0.4);\n\n            // Natural room tone (absorptive surfaces)\n            let cutoff = 6000.0 + brightness * 6000.0;\n            let filtered = lpf_ar(tail, cutoff);\n\n            // Create stereo from early reflections\n            let left_er = er1 + er3 * 0.7 + er5 * 0.5;\n            let right_er = er2 + er4 * 0.7 + er5 * 0.5;\n\n            let wet_left = filtered + left_er * 0.3;\n            let wet_right = filtered + right_er * 0.3;\n\n            [\n                (1.0 - mix) * input[0] + mix * wet_left * 0.8,\n                (1.0 - mix) * input[1] + mix * wet_right * 0.8\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "reverbs",
          "path": "effects/reverbs/room_reverb.vibe"
        },
        {
          "name": "shimmer_reverb",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "size",
              "default": 0.7
            },
            {
              "name": "shimmer",
              "default": 0.4
            },
            {
              "name": "pitch",
              "default": 2
            },
            {
              "name": "decay",
              "default": 0.6
            },
            {
              "name": "mix",
              "default": 0.4
            }
          ],
          "type": "fx",
          "source": "define_fx(\"shimmer_reverb\", |builder| {\n    builder\n        .param(\"size\", 0.7)\n        .param(\"shimmer\", 0.4)\n        .param(\"pitch\", 2.0)\n        .param(\"decay\", 0.6)\n        .param(\"mix\", 0.4)\n        .body(|input, size, shimmer, pitch, decay, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Main reverb\n            let verb = free_verb_ar(mono, 1.0, 0.5 + size * 0.45, 0.3);\n\n            // Pitch shifter for shimmer effect (using delay-based pitch approximation)\n            let shift_time = 0.05 / pitch;\n            let shifted = delay_c_ar(verb, 0.2, shift_time);\n\n            // Feed the shifted signal back through more reverb\n            let shimmer_verb = free_verb_ar(shifted * shimmer, 1.0, 0.7, 0.5);\n\n            // Combine layers with decay\n            let layer1 = verb;\n            let layer2 = shimmer_verb * decay * 0.6;\n            let layer3 = delay_c_ar(shimmer_verb, 0.5, 0.2) * decay * 0.4;\n\n            let combined = layer1 + layer2 + layer3;\n\n            // Smooth high frequencies for ethereal character\n            let smoothed = lpf_ar(combined, 10000.0);\n\n            // Add subtle modulation\n            let mod_lfo = sin_osc_ar(0.3) * 0.002;\n            let modulated = delay_c_ar(smoothed, 0.05, 0.02 + mod_lfo);\n\n            // Wide stereo spread\n            let left = modulated;\n            let right = delay_c_ar(modulated, 0.02, 0.007);\n\n            [\n                (1.0 - mix) * input[0] + mix * left * 0.6,\n                (1.0 - mix) * input[1] + mix * right * 0.6\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "reverbs",
          "path": "effects/reverbs/shimmer_reverb.vibe"
        },
        {
          "name": "spring_reverb",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "tension",
              "default": 0.5
            },
            {
              "name": "diffusion",
              "default": 0.6
            },
            {
              "name": "mix",
              "default": 0.35
            }
          ],
          "type": "fx",
          "source": "define_fx(\"spring_reverb\", |builder| {\n    builder\n        .param(\"tension\", 0.5)\n        .param(\"diffusion\", 0.6)\n        .param(\"mix\", 0.35)\n        .body(|input, tension, diffusion, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Spring simulation using comb filters with slightly detuned delays\n            let base_time = 0.03 + (1.0 - tension) * 0.04;\n\n            // Multiple spring modes (simulating the coils)\n            let spring1 = delay_c_ar(mono, 0.2, base_time) * 0.5;\n            let spring2 = delay_c_ar(mono, 0.2, base_time * 1.13) * 0.4;\n            let spring3 = delay_c_ar(mono, 0.2, base_time * 1.27) * 0.3;\n            let spring4 = delay_c_ar(mono, 0.2, base_time * 0.87) * 0.35;\n\n            // Combine springs\n            let springs = spring1 + spring2 + spring3 + spring4;\n\n            // Add metallic resonance (characteristic spring \"boing\")\n            let resonance = rlpf_ar(springs, 2800.0 + tension * 1000.0, 0.3);\n\n            // Diffusion through allpass filtering\n            let diffused = allpass_c_ar(resonance, 0.1, 0.05 * diffusion, 0.5 * diffusion);\n\n            // High frequency damping for natural decay\n            let damped = lpf_ar(diffused, 4500.0 - (1.0 - tension) * 1500.0);\n\n            // Add subtle modulation for organic feel\n            let mod_lfo = sin_osc_ar(0.8) * 0.001;\n            let modulated = delay_c_ar(damped, 0.05, 0.02 + mod_lfo);\n\n            // Create stereo spread\n            let left = modulated;\n            let right = delay_c_ar(modulated, 0.01, 0.003);\n\n            [\n                (1.0 - mix) * input[0] + mix * left,\n                (1.0 - mix) * input[1] + mix * right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "reverbs",
          "path": "effects/reverbs/spring_reverb.vibe"
        }
      ],
      "Spatial": [
        {
          "name": "haas",
          "description": "mix: Effect intensity (0.0 = no effect, 1.0 = maximum)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "delay_time",
              "default": 0.015
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"haas\", |builder| {\n    builder\n        .param(\"delay_time\", 0.015)\n        .param(\"mix\", 0.5)\n        .body(|input, delay_time, mix| {\n            // Mix to mono\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Delay one channel\n            let delayed = delay_n_ar(mono, 0.1, delay_time);\n\n            // Create stereo image\n            let haas_left = mono;\n            let haas_right = delayed;\n\n            // Mix with original\n            let output = [\n                (1.0 - mix) * input[0] + mix * haas_left,\n                (1.0 - mix) * input[1] + mix * haas_right\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "spatial",
          "path": "effects/spatial/haas.vibe"
        },
        {
          "name": "stereo_enhancer",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = processed)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "width",
              "default": 1.2
            },
            {
              "name": "center",
              "default": "0.0"
            },
            {
              "name": "bass_mono",
              "default": 100
            },
            {
              "name": "mix",
              "default": 1
            }
          ],
          "type": "fx",
          "source": "define_fx(\"stereo_enhancer\", |builder| {\n    builder\n        .param(\"width\", 1.2)\n        .param(\"center\", 0.0)\n        .param(\"bass_mono\", 100.0)\n        .param(\"mix\", 1.0)\n        .body(|input, width, center, bass_mono, mix| {\n            // Encode to Mid/Side\n            let mid = (input[0] + input[1]) * 0.5;\n            let side = (input[0] - input[1]) * 0.5;\n\n            // Apply width to sides\n            let wide_side = side * width;\n\n            // Apply center boost/cut\n            let center_boost = 1.0 + center * 0.5;\n            let side_cut = 1.0 - center * 0.5;\n            let processed_mid = mid * center_boost;\n            let processed_side = wide_side * side_cut;\n\n            // Decode back to L/R\n            let wide_l = processed_mid + processed_side;\n            let wide_r = processed_mid - processed_side;\n\n            // Bass mono (sum low frequencies to center)\n            let bass_l = lpf_ar(input[0], bass_mono);\n            let bass_r = lpf_ar(input[1], bass_mono);\n            let bass_mono_sig = (bass_l + bass_r) * 0.5;\n\n            // Remove bass from widened signal, add mono bass\n            let no_bass_l = hpf_ar(wide_l, bass_mono);\n            let no_bass_r = hpf_ar(wide_r, bass_mono);\n\n            let final_l = no_bass_l + bass_mono_sig;\n            let final_r = no_bass_r + bass_mono_sig;\n\n            [\n                (1.0 - mix) * input[0] + mix * final_l,\n                (1.0 - mix) * input[1] + mix * final_r\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "spatial",
          "path": "effects/spatial/stereo_enhancer.vibe"
        },
        {
          "name": "stereo_width",
          "description": "width: Stereo width (0.0 = mono, 1.0 = normal, 2.0 = maximum width)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "width",
              "default": 1.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"stereo_width\", |builder| {\n    builder\n        .param(\"width\", 1.5)\n        .body(|input, width| {\n            // Mid-side processing\n            let mid = (input[0] + input[1]) * 0.5;\n            let side = (input[0] - input[1]) * 0.5;\n\n            // Apply width to side signal\n            let side_widened = side * width;\n\n            // Convert back to left-right\n            let output = [\n                mid + side_widened,\n                mid - side_widened\n            ];\n\n            output\n        })\n});",
          "category": "effects",
          "subcategory": "spatial",
          "path": "effects/spatial/stereo_width.vibe"
        }
      ],
      "Utility": [
        {
          "name": "dc_blocker",
          "description": "coef: Filter coefficient (0.9 to 0.999, higher = more bass removed)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "coef",
              "default": 0.995
            }
          ],
          "type": "fx",
          "source": "define_fx(\"dc_blocker\", |builder| {\n    builder\n        .param(\"coef\", 0.995)\n        .body(|input, coef| {\n            // Apply DC blocking filter\n            let blocked_left = leak_dc_ar(input[0], coef);\n            let blocked_right = leak_dc_ar(input[1], coef);\n\n            [blocked_left, blocked_right]\n        })\n});",
          "category": "effects",
          "subcategory": "utility",
          "path": "effects/utility/dc_blocker.vibe"
        },
        {
          "name": "stutter",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "rate",
              "default": 8
            },
            {
              "name": "mix",
              "default": 0.5
            }
          ],
          "type": "fx",
          "source": "define_fx(\"stutter\", |builder| {\n    builder\n        .param(\"rate\", 8.0)\n        .param(\"mix\", 0.5)\n        .body(|input, rate, mix| {\n            // Buffer size based on rate\n            let buf_time = 1.0 / rate;\n\n            // Stuttered signal using comb filter technique\n            let stutter_left = comb_c_ar(input[0], 0.5, buf_time, 0.0);\n            let stutter_right = comb_c_ar(input[1], 0.5, buf_time, 0.0);\n\n            [\n                (1.0 - mix) * input[0] + mix * stutter_left,\n                (1.0 - mix) * input[1] + mix * stutter_right\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "utility",
          "path": "effects/utility/stutter.vibe"
        },
        {
          "name": "vocoder",
          "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
          "genre": "",
          "character": "",
          "params": [
            {
              "name": "bands",
              "default": 16
            },
            {
              "name": "mix",
              "default": 0.8
            }
          ],
          "type": "fx",
          "source": "define_fx(\"vocoder\", |builder| {\n    builder\n        .param(\"bands\", 16.0)\n        .param(\"mix\", 0.8)\n        .body(|input, bands, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Simplified vocoder using multiple bandpass filters\n            let band1 = bpf_ar(mono, 200.0, 0.2) * 0.2;\n            let band2 = bpf_ar(mono, 400.0, 0.2) * 0.2;\n            let band3 = bpf_ar(mono, 800.0, 0.2) * 0.2;\n            let band4 = bpf_ar(mono, 1600.0, 0.2) * 0.2;\n            let band5 = bpf_ar(mono, 3200.0, 0.2) * 0.15;\n            let band6 = bpf_ar(mono, 6400.0, 0.2) * 0.1;\n\n            let wet = band1 + band2 + band3 + band4 + band5 + band6;\n\n            [\n                (1.0 - mix) * input[0] + mix * wet,\n                (1.0 - mix) * input[1] + mix * wet\n            ]\n        })\n});",
          "category": "effects",
          "subcategory": "utility",
          "path": "effects/utility/vocoder.vibe"
        }
      ]
    },
    "items": []
  },
  "Fx": {
    "subcategories": {
      "Atmospheres": [
        {
          "name": "atmosphere_bright",
          "description": "Genre: Ambient, New Age | Character: Bright ethereal atmosphere",
          "genre": "Ambient, New Age",
          "character": "Bright ethereal atmosphere",
          "params": [
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"atmosphere_bright\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(1.5, 1.0, 1.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Shimmering high frequencies\n            let shimmer1 = sin_osc_ar(2000.0 + sin_osc_ar(0.3) * 200.0);\n            let shimmer2 = sin_osc_ar(3000.0 + sin_osc_ar(0.4) * 150.0);\n            let shimmer3 = sin_osc_ar(4500.0 + sin_osc_ar(0.5) * 100.0);\n\n            let shimmer = (shimmer1 + shimmer2 * 0.6 + shimmer3 * 0.3) * 0.1;\n\n            // Warm pad underneath\n            let pad_freq = 200.0;\n            let pad = sin_osc_ar(pad_freq) + sin_osc_ar(pad_freq * 2.0) * 0.4;\n            let pad_filtered = lpf_ar(pad, 1000.0) * 0.2;\n\n            // Air texture\n            let air = hpf_ar(pink_noise_ar(), 4000.0) * 0.08;\n\n            let mix = shimmer + pad_filtered + air;\n\n            mix * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "atmospheres",
          "path": "fx/atmospheres/atmosphere_bright.vibe"
        },
        {
          "name": "atmosphere_dark",
          "description": "Genre: Dark Ambient, Horror | Character: Dark foreboding atmosphere",
          "genre": "Dark Ambient, Horror",
          "character": "Dark foreboding atmosphere",
          "params": [
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"atmosphere_dark\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(2.0, 1.0, 2.0)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep drone\n            let drone_freq = 40.0 + sin_osc_ar(0.05) * 5.0;\n            let drone = sin_osc_ar(drone_freq) + sin_osc_ar(drone_freq * 1.5) * 0.4;\n\n            // Distant thunder-like rumble\n            let rumble = lpf_ar(pink_noise_ar(), 60.0);\n            let rumble_mod = rumble * (sin_osc_ar(0.1) * 0.5 + 0.5);\n\n            // Eerie high frequencies\n            let high = sin_osc_ar(2000.0 + sin_osc_ar(0.07) * 300.0) * 0.03;\n\n            // Subtle metallic resonance\n            let metal = rlpf_ar(pink_noise_ar(), 800.0, 0.05) * 0.1;\n\n            let mix = drone * 0.3 + rumble_mod * 0.4 + high + metal;\n\n            mix * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "atmospheres",
          "path": "fx/atmospheres/atmosphere_dark.vibe"
        },
        {
          "name": "atmosphere_pulse",
          "description": "Genre: Electronic, Techno | Character: Pulsing rhythmic atmosphere",
          "genre": "Electronic, Techno",
          "character": "Pulsing rhythmic atmosphere",
          "params": [
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "rate",
              "default": 2
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"atmosphere_pulse\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .param(\"rate\", 2.0)\n        .param(\"gate\", 1.0)\n        .body(|amp, rate, gate| {\n            let env = envelope()\n                .asr(0.5, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pulsing LFO\n            let pulse_lfo = sin_osc_ar(rate) * 0.5 + 0.5;\n\n            // Sub pulse\n            let sub = sin_osc_ar(50.0) * pulse_lfo * 0.4;\n\n            // Mid-range pulse\n            let mid = saw_ar(100.0) + saw_ar(100.5);\n            let mid_filtered = lpf_ar(mid, 400.0) * pulse_lfo * 0.2;\n\n            // High shimmer\n            let high = hpf_ar(white_noise_ar(), 6000.0) * pulse_lfo * 0.1;\n\n            let mix = sub + mid_filtered + high;\n\n            mix * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "atmospheres",
          "path": "fx/atmospheres/atmosphere_pulse.vibe"
        },
        {
          "name": "atmosphere_tension",
          "description": "Genre: Cinematic, Horror | Character: Tense building atmosphere",
          "genre": "Cinematic, Horror",
          "character": "Tense building atmosphere",
          "params": [
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"atmosphere_tension\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(1.0, 1.0, 1.0)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Dissonant cluster\n            let freq = 100.0;\n            let tone1 = sin_osc_ar(freq);\n            let tone2 = sin_osc_ar(freq * 1.06);  // Minor 2nd\n            let tone3 = sin_osc_ar(freq * 1.41);  // Tritone\n            let tone4 = sin_osc_ar(freq * 1.89);  // Minor 7th\n\n            let cluster = (tone1 + tone2 * 0.7 + tone3 * 0.5 + tone4 * 0.4) * 0.2;\n\n            // Slow tremolo for unease\n            let trem = sin_osc_ar(0.5) * 0.3 + 0.7;\n\n            // High drone\n            let high = sin_osc_ar(3000.0 + sin_osc_ar(0.1) * 500.0) * 0.05;\n\n            // Low rumble\n            let rumble = lpf_ar(pink_noise_ar(), 80.0) * 0.3;\n\n            let mix = cluster * trem + high + rumble;\n\n            mix * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "atmospheres",
          "path": "fx/atmospheres/atmosphere_tension.vibe"
        },
        {
          "name": "atmosphere_wind",
          "description": "Genre: Ambient, Cinematic | Character: Wind/outdoor atmosphere",
          "genre": "Ambient, Cinematic",
          "character": "Wind/outdoor atmosphere",
          "params": [
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"atmosphere_wind\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(1.0, 1.0, 1.0)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Base wind noise\n            let wind = pink_noise_ar();\n\n            // Slow modulation for gusts\n            let gust1 = sin_osc_ar(0.15) * 0.4 + 0.6;\n            let gust2 = sin_osc_ar(0.23) * 0.3 + 0.7;\n\n            // Multiple filtered bands\n            let low_wind = lpf_ar(wind, 300.0) * gust1 * 0.5;\n            let mid_wind = lpf_ar(hpf_ar(wind, 200.0), 2000.0) * gust2 * 0.4;\n            let high_wind = hpf_ar(wind, 3000.0) * gust1 * gust2 * 0.2;\n\n            // Whistling (occasional high resonance)\n            let whistle = rlpf_ar(wind, 1500.0 + sin_osc_ar(0.1) * 500.0, 0.05) * 0.15;\n\n            let mix = low_wind + mid_wind + high_wind + whistle;\n\n            mix * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "atmospheres",
          "path": "fx/atmospheres/atmosphere_wind.vibe"
        }
      ],
      "Downers": [
        {
          "name": "downer_filtered",
          "description": "Genre: House, Techno | Character: Resonant filter downlifter",
          "genre": "House, Techno",
          "character": "Resonant filter downlifter",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 2.5
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"downer_filtered\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 2.5)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.05, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            let down_env = 1.0 - env;\n\n            // Rich source\n            let source = saw_ar(100.0) + pulse_ar(100.0, 0.3) * 0.5;\n\n            // Highly resonant falling filter\n            let cutoff = 300.0 + down_env * 8000.0;\n            let filtered = rlpf_ar(source, cutoff, 0.15);\n\n            // Second resonant peak\n            let peak2 = rlpf_ar(source, cutoff * 0.5, 0.2) * 0.4;\n\n            (filtered + peak2) * env * amp * 0.7\n        })\n});",
          "category": "fx",
          "subcategory": "downers",
          "path": "fx/downers/downer_filtered.vibe"
        },
        {
          "name": "downer_noise",
          "description": "Genre: EDM, House | Character: Noise-based downlifter",
          "genre": "EDM, House",
          "character": "Noise-based downlifter",
          "params": [
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "duration",
              "default": 2
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"downer_noise\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .param(\"duration\", 2.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.01, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Inverted envelope for downward motion\n            let down_env = 1.0 - env;\n\n            // Falling filter on noise\n            let noise = white_noise_ar();\n            let cutoff = 200.0 + down_env * 10000.0;\n            let filtered = lpf_ar(noise, cutoff);\n\n            // Resonant sweep\n            let res = rlpf_ar(noise, cutoff * 0.8, 0.25) * 0.5;\n\n            (filtered + res) * env * amp * 0.7\n        })\n});",
          "category": "fx",
          "subcategory": "downers",
          "path": "fx/downers/downer_noise.vibe"
        },
        {
          "name": "downer_pitch",
          "description": "Genre: EDM, Dubstep | Character: Pitch-falling downlifter",
          "genre": "EDM, Dubstep",
          "character": "Pitch-falling downlifter",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 2
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"downer_pitch\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 2.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.01, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Falling pitch\n            let down_env = 1.0 - env;\n            let freq = 60.0 + down_env * 800.0;\n\n            // Multiple oscillators for thickness\n            let osc1 = sin_osc_ar(freq);\n            let osc2 = sin_osc_ar(freq * 1.01);\n            let osc3 = sin_osc_ar(freq * 0.99);\n            let osc4 = saw_ar(freq * 0.5) * 0.3;\n\n            let combined = (osc1 + osc2 + osc3) * 0.3 + osc4;\n\n            // Add filtered noise\n            let noise = lpf_ar(white_noise_ar(), freq * 2.0) * 0.2;\n\n            (combined + noise) * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "downers",
          "path": "fx/downers/downer_pitch.vibe"
        },
        {
          "name": "downer_slow",
          "description": "Genre: Ambient, Cinematic | Character: Slow atmospheric downer",
          "genre": "Ambient, Cinematic",
          "character": "Slow atmospheric downer",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 6
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"downer_slow\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 6.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.5, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            let down_env = 1.0 - env;\n\n            // Slowly falling pad-like tone\n            let freq = 80.0 + down_env * 300.0;\n            let pad1 = sin_osc_ar(freq);\n            let pad2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let pad3 = sin_osc_ar(freq * 3.0) * 0.2;\n\n            // Slow modulation\n            let mod_lfo = sin_osc_ar(0.2) * 0.1 + 0.9;\n            let pad = (pad1 + pad2 + pad3) * mod_lfo * 0.4;\n\n            // Descending noise texture\n            let noise = pink_noise_ar();\n            let noise_filtered = lpf_ar(noise, 500.0 + down_env * 3000.0) * 0.2;\n\n            (pad + noise_filtered) * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "downers",
          "path": "fx/downers/downer_slow.vibe"
        },
        {
          "name": "downer_synth",
          "description": "Genre: Trance, Progressive | Character: Synth-based downlifter",
          "genre": "Trance, Progressive",
          "character": "Synth-based downlifter",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 3
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"downer_synth\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 3.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.1, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            let down_env = 1.0 - env;\n\n            // Falling supersaw\n            let freq = 100.0 + down_env * 600.0;\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.005);\n            let saw3 = saw_ar(freq * 0.995);\n            let saw4 = saw_ar(freq * 1.01);\n            let saw5 = saw_ar(freq * 0.99);\n\n            let supersaw = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.15;\n\n            // Closing filter\n            let cutoff = 500.0 + down_env * 6000.0;\n            let filtered = rlpf_ar(supersaw, cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "downers",
          "path": "fx/downers/downer_synth.vibe"
        }
      ],
      "Impacts": [
        {
          "name": "impact_bass_drop",
          "description": "Genre: Dubstep, EDM | Character: Bass drop impact",
          "genre": "Dubstep, EDM",
          "character": "Bass drop impact",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"impact_bass_drop\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch-dropping sine\n            let pitch_e = envelope()\n                .perc(0.001, 0.3)\n                .build();\n            let freq = 200.0 - pitch_e * 160.0;\n            let drop = sin_osc_ar(freq);\n\n            // Sub layer\n            let sub_e = envelope()\n                .perc(0.01, 1.2)\n                .build();\n            let sub = sin_osc_ar(35.0) * sub_e * 0.8;\n\n            // Distorted layer for aggression\n            let dist = (drop * 4.0).tanh() * 0.4;\n\n            // Click transient\n            let click = white_noise_ar();\n            let click_e = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let click_filtered = lpf_ar(click, 5000.0) * click_e * 0.3;\n\n            let mix = drop * env * 0.5 + sub + dist * env + click_filtered;\n\n            mix * amp * 0.6\n        })\n});",
          "category": "fx",
          "subcategory": "impacts",
          "path": "fx/impacts/impact_bass_drop.vibe"
        },
        {
          "name": "impact_hard",
          "description": "Genre: EDM, Cinematic | Character: Hard, aggressive impact",
          "genre": "EDM, Cinematic",
          "character": "Hard, aggressive impact",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"impact_hard\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Quick attack, medium decay\n            let env = envelope()\n                .perc(0.001, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Low frequency punch\n            let sub = sin_osc_ar(50.0) * 0.6;\n\n            // Noise component for impact\n            let noise = white_noise_ar();\n            let filtered_noise = lpf_ar(noise, 2000.0) * 0.4;\n\n            // Metallic component\n            let metal = (sin_osc_ar(180.0) + sin_osc_ar(320.0) + sin_osc_ar(580.0)) * 0.2;\n\n            let mix = sub + filtered_noise + metal;\n\n            mix * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "impacts",
          "path": "fx/impacts/impact_hard.vibe"
        },
        {
          "name": "impact_industrial",
          "description": "Genre: Industrial, Dark Techno | Character: Harsh industrial impact",
          "genre": "Industrial, Dark Techno",
          "character": "Harsh industrial impact",
          "params": [
            {
              "name": "amp",
              "default": 0.8
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"impact_industrial\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic resonance\n            let metal1 = sin_osc_ar(230.0);\n            let metal2 = sin_osc_ar(470.0);\n            let metal3 = sin_osc_ar(890.0);\n            let metal4 = sin_osc_ar(1340.0);\n            let metal = metal1 + metal2 * 0.7 + metal3 * 0.5 + metal4 * 0.3;\n            let metal_e = envelope()\n                .perc(0.001, 0.5)\n                .build();\n\n            // Distorted body\n            let body = saw_ar(60.0) + pulse_ar(90.0, 0.2);\n            let body_dist = (body * 5.0).tanh();\n            let body_e = envelope()\n                .perc(0.001, 0.4)\n                .build();\n\n            // Noise burst with resonance\n            let noise = white_noise_ar();\n            let noise_filtered = rlpf_ar(noise, 2000.0, 0.15);\n            let noise_e = envelope()\n                .perc(0.001, 0.1)\n                .build();\n\n            let mix = metal * metal_e * 0.3 + body_dist * body_e * 0.4 + noise_filtered * noise_e * 0.4;\n\n            mix * env * amp * 0.7\n        })\n});",
          "category": "fx",
          "subcategory": "impacts",
          "path": "fx/impacts/impact_industrial.vibe"
        },
        {
          "name": "impact_metallic",
          "description": "Genre: Industrial, Experimental | Character: Metallic, resonant impact",
          "genre": "Industrial, Experimental",
          "character": "Metallic, resonant impact",
          "params": [
            {
              "name": "amp",
              "default": 0.8
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"impact_metallic\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            // Sharp attack, long resonance\n            let env = envelope()\n                .perc(0.001, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Inharmonic metallic frequencies\n            let metal1 = sin_osc_ar(280.0) * 0.3;\n            let metal2 = sin_osc_ar(470.0) * 0.25;\n            let metal3 = sin_osc_ar(710.0) * 0.2;\n            let metal4 = sin_osc_ar(980.0) * 0.15;\n            let metal5 = sin_osc_ar(1350.0) * 0.1;\n\n            let mix = metal1 + metal2 + metal3 + metal4 + metal5;\n\n            // Add noise burst\n            let noise_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let noise = white_noise_ar() * noise_env * 0.3;\n            let filtered_noise = hpf_ar(noise, 3000.0);\n\n            (mix + filtered_noise) * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "impacts",
          "path": "fx/impacts/impact_metallic.vibe"
        },
        {
          "name": "impact_noise",
          "description": "Genre: All | Character: Noise-based impact, versatile",
          "genre": "All",
          "character": "Noise-based impact, versatile",
          "params": [
            {
              "name": "amp",
              "default": 0.8
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"impact_noise\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            // Quick decay\n            let env = envelope()\n                .perc(0.002, 0.6)\n                .cleanup_on_finish()\n                .build();\n\n            // Layered noise for fullness\n            let low_noise = lpf_ar(pink_noise_ar(), 800.0) * 0.5;\n            let mid_noise = rlpf_ar(white_noise_ar(), 2500.0, 0.5) * 0.3;\n            let high_noise = hpf_ar(white_noise_ar(), 4000.0) * 0.2;\n\n            let mix = low_noise + mid_noise + high_noise;\n\n            mix * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "impacts",
          "path": "fx/impacts/impact_noise.vibe"
        },
        {
          "name": "impact_orchestral",
          "description": "Genre: Orchestral, Classical | Character: Orchestra tutti hit",
          "genre": "Orchestral, Classical",
          "character": "Orchestra tutti hit",
          "params": [
            {
              "name": "amp",
              "default": 0.9
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"impact_orchestral\", |builder| {\n    builder\n        .param(\"amp\", 0.9)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.02, 2.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Brass section\n            let brass1 = saw_ar(130.0);\n            let brass2 = saw_ar(196.0);\n            let brass3 = saw_ar(262.0);\n            let brass = (brass1 + brass2 * 0.8 + brass3 * 0.6) * 0.2;\n            let brass_filtered = lpf_ar(brass, 1200.0);\n            let brass_e = envelope()\n                .perc(0.02, 1.5)\n                .build();\n\n            // String section\n            let str1 = sin_osc_ar(262.0);\n            let str2 = sin_osc_ar(392.0);\n            let str3 = sin_osc_ar(523.0);\n            let strings = (str1 + str2 * 0.7 + str3 * 0.5) * 0.25;\n            let str_e = envelope()\n                .perc(0.05, 2.0)\n                .build();\n\n            // Timpani-like bass\n            let timp = sin_osc_ar(65.0) + sin_osc_ar(130.0) * 0.4;\n            let timp_e = envelope()\n                .perc(0.001, 0.8)\n                .build();\n\n            // Cymbal crash\n            let cymbal = hpf_ar(white_noise_ar(), 6000.0);\n            let cym_e = envelope()\n                .perc(0.01, 1.5)\n                .build();\n\n            let mix = brass_filtered * brass_e + strings * str_e + timp * timp_e * 0.5 + cymbal * cym_e * 0.15;\n\n            mix * amp * 0.5\n        })\n});",
          "category": "fx",
          "subcategory": "impacts",
          "path": "fx/impacts/impact_orchestral.vibe"
        },
        {
          "name": "impact_soft",
          "description": "Genre: Ambient, Cinematic | Character: Soft, subtle impact",
          "genre": "Ambient, Cinematic",
          "character": "Soft, subtle impact",
          "params": [
            {
              "name": "amp",
              "default": 0.8
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"impact_soft\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            // Gentle envelope\n            let env = envelope()\n                .perc(0.005, 1.2)\n                .cleanup_on_finish()\n                .build();\n\n            // Low frequency body\n            let sub = sin_osc_ar(80.0) * 0.5;\n\n            // Filtered noise\n            let noise = pink_noise_ar();\n            let filtered_noise = lpf_ar(noise, 1500.0) * 0.3;\n\n            // Warm tone\n            let tone = sin_osc_ar(150.0) * 0.2;\n\n            let mix = sub + filtered_noise + tone;\n\n            mix * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "impacts",
          "path": "fx/impacts/impact_soft.vibe"
        },
        {
          "name": "impact_sub",
          "description": "Genre: Dubstep, Bass Music | Character: Deep sub impact",
          "genre": "Dubstep, Bass Music",
          "character": "Deep sub impact",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"impact_sub\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Medium decay\n            let env = envelope()\n                .perc(0.002, 1.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Very low frequencies\n            let sub1 = sin_osc_ar(35.0) * 0.6;\n            let sub2 = sin_osc_ar(70.0) * 0.3;\n\n            // Minimal noise for definition\n            let noise_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n            let noise = pink_noise_ar() * noise_env * 0.1;\n            let filtered_noise = lpf_ar(noise, 300.0);\n\n            let mix = sub1 + sub2 + filtered_noise;\n\n            mix * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "impacts",
          "path": "fx/impacts/impact_sub.vibe"
        },
        {
          "name": "impact_trailer",
          "description": "Genre: Trailer, Action | Character: Massive trailer hit",
          "genre": "Trailer, Action",
          "character": "Massive trailer hit",
          "params": [
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"impact_trailer\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 3.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple sub harmonics for weight\n            let sub1 = sin_osc_ar(30.0) * 0.6;\n            let sub2 = sin_osc_ar(45.0) * 0.4;\n            let sub3 = sin_osc_ar(60.0) * 0.3;\n            let sub_e = envelope()\n                .perc(0.001, 2.0)\n                .build();\n            let subs = (sub1 + sub2 + sub3) * sub_e;\n\n            // Distorted mid-range punch\n            let mid = saw_ar(100.0) + saw_ar(150.0) * 0.5;\n            let mid_dist = (mid * 3.0).tanh();\n            let mid_e = envelope()\n                .perc(0.001, 0.5)\n                .build();\n            let mid_filtered = lpf_ar(mid_dist, 800.0) * mid_e * 0.4;\n\n            // High-end crack\n            let crack = white_noise_ar();\n            let crack_e = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let crack_filtered = hpf_ar(crack, 2000.0) * crack_e * 0.5;\n\n            // Resonant tail\n            let tail_freq = 80.0 + env * 40.0;\n            let tail = rlpf_ar(pink_noise_ar(), tail_freq, 0.1) * env * 0.2;\n\n            let mix = subs + mid_filtered + crack_filtered + tail;\n\n            mix * amp * 0.5\n        })\n});",
          "category": "fx",
          "subcategory": "impacts",
          "path": "fx/impacts/impact_trailer.vibe"
        }
      ],
      "Risers": [
        {
          "name": "riser_cinematic",
          "description": "Genre: Trailer, Film Score | Character: Epic cinematic riser",
          "genre": "Trailer, Film Score",
          "character": "Epic cinematic riser",
          "params": [
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "duration",
              "default": 5
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"riser_cinematic\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .param(\"duration\", 5.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.5, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep brass-like foundation\n            let brass_freq = 60.0 + env * 100.0;\n            let brass = saw_ar(brass_freq) + saw_ar(brass_freq * 1.5) * 0.5;\n            let brass_filtered = lpf_ar(brass, 800.0 + env * 2000.0) * 0.3;\n\n            // String-like shimmer layer\n            let string_freq = 220.0 + env * 440.0;\n            let strings = sin_osc_ar(string_freq) + sin_osc_ar(string_freq * 2.01) * 0.5;\n            let string_vib = sin_osc_ar(5.0) * 0.01 + 1.0;\n            let strings_mod = strings * string_vib * env * 0.3;\n\n            // Noise texture\n            let noise = pink_noise_ar();\n            let noise_filtered = hpf_ar(lpf_ar(noise, 4000.0 + env * 8000.0), 200.0) * 0.2;\n\n            // Sub layer\n            let sub = sin_osc_ar(40.0 + env * 20.0) * 0.4;\n\n            // Combine all layers\n            let mix = brass_filtered + strings_mod + noise_filtered * env + sub;\n\n            mix * env * amp * 0.5\n        })\n});",
          "category": "fx",
          "subcategory": "risers",
          "path": "fx/risers/riser_cinematic.vibe"
        },
        {
          "name": "riser_filtered",
          "description": "Genre: Techno, Trance | Character: Resonant filtered riser",
          "genre": "Techno, Trance",
          "character": "Resonant filtered riser",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"riser_filtered\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .body(|amp| {\n            // Rise envelope\n            let env = envelope()\n                .perc(0.02, 2.8)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise\n            let noise = white_noise_ar();\n\n            // Aggressive filter sweep with high resonance\n            let filter_env = envelope()\n                .perc(0.4, 2.6)\n                .build();\n            let mod_cutoff = 300.0 + (filter_env * 10000.0);\n\n            let filtered = rlpf_ar(noise, mod_cutoff, 0.15);\n\n            filtered * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "risers",
          "path": "fx/risers/riser_filtered.vibe"
        },
        {
          "name": "riser_pink_noise",
          "description": "Genre: House, Techno | Character: Pink noise riser, warmer than white",
          "genre": "House, Techno",
          "character": "Pink noise riser, warmer than white",
          "params": [
            {
              "name": "amp",
              "default": 0.6
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"riser_pink_noise\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Long rise\n            let env = envelope()\n                .perc(0.02, 3.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise for warmth\n            let noise = pink_noise_ar();\n\n            // Filter sweep\n            let filter_env = envelope()\n                .perc(0.6, 3.2)\n                .build();\n            let mod_cutoff = 150.0 + (filter_env * 6000.0);\n\n            let filtered = lpf_ar(noise, mod_cutoff);\n\n            // High-pass for clarity\n            let clean = hpf_ar(filtered, 80.0);\n\n            clean * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "risers",
          "path": "fx/risers/riser_pink_noise.vibe"
        },
        {
          "name": "riser_pitch",
          "description": "Genre: Trance, EDM | Character: Pitch-rising synth",
          "genre": "Trance, EDM",
          "character": "Pitch-rising synth",
          "params": [
            {
              "name": "start_freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.5
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"riser_pitch\", |builder| {\n    builder\n        .param(\"start_freq\", 55.0)\n        .param(\"amp\", 0.5)\n        .body(|start_freq, amp| {\n            // Rise envelope\n            let env = envelope()\n                .perc(0.02, 3.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch sweep envelope\n            let pitch_env = envelope()\n                .perc(0.5, 2.8)\n                .build();\n            let freq = start_freq + (pitch_env * start_freq * 8.0);\n\n            // Multiple detuned oscillators\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.005);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Filter\n            let filtered = lpf_ar(mix, 4000.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "risers",
          "path": "fx/risers/riser_pitch.vibe"
        },
        {
          "name": "riser_reverse",
          "description": "Genre: Experimental, IDM | Character: Reverse-style riser effect",
          "genre": "Experimental, IDM",
          "character": "Reverse-style riser effect",
          "params": [
            {
              "name": "amp",
              "default": 0.6
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"riser_reverse\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Reverse envelope (starts high, fades slightly, then rises)\n            let env = envelope()\n                .perc(1.5, 2.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise\n            let noise = pink_noise_ar();\n\n            // Filter sweeps backwards then forwards\n            let filter_env = envelope()\n                .perc(1.2, 1.8)\n                .build();\n            let mod_cutoff = 5000.0 + (filter_env * 5000.0);\n\n            let filtered = lpf_ar(noise, mod_cutoff);\n\n            // Resonance\n            let resonant = rlpf_ar(filtered, mod_cutoff * 0.7, 0.4);\n\n            resonant * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "risers",
          "path": "fx/risers/riser_reverse.vibe"
        },
        {
          "name": "riser_shepard",
          "description": "Genre: Electronic, Cinematic | Character: Shepard tone illusion riser",
          "genre": "Electronic, Cinematic",
          "character": "Shepard tone illusion riser",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 6
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"riser_shepard\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 6.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.1, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Shepard tone: multiple octaves fading in/out\n            let base_freq = 110.0;\n            let rise = env * 2.0; // Rise two octaves over duration\n\n            // Calculate frequencies for each octave layer\n            let f1 = base_freq * (1.0 + rise);\n            let f2 = f1 * 2.0;\n            let f3 = f1 * 4.0;\n            let f4 = f1 * 0.5;\n\n            // Amplitude curves (gaussian-like) centered on mid frequencies\n            let a1 = (1.0 - (f1 / 880.0 - 1.0).abs()).max(0.0);\n            let a2 = (1.0 - (f2 / 880.0 - 1.0).abs()).max(0.0);\n            let a3 = (1.0 - (f3 / 880.0 - 1.0).abs()).max(0.0);\n            let a4 = (1.0 - (f4 / 880.0 - 1.0).abs()).max(0.0);\n\n            // Generate tones\n            let tone1 = sin_osc_ar(f1) * a1;\n            let tone2 = sin_osc_ar(f2) * a2;\n            let tone3 = sin_osc_ar(f3) * a3;\n            let tone4 = sin_osc_ar(f4) * a4;\n\n            let combined = (tone1 + tone2 + tone3 + tone4) * 0.25;\n\n            combined * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "risers",
          "path": "fx/risers/riser_shepard.vibe"
        },
        {
          "name": "riser_synth",
          "description": "Genre: Trance, Progressive | Character: Synth-based melodic riser",
          "genre": "Trance, Progressive",
          "character": "Synth-based melodic riser",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 4
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"riser_synth\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 4.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.1, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Rising pitch from low to high\n            let pitch = 80.0 + env * 800.0;\n\n            // Supersaw-style riser\n            let saw1 = saw_ar(pitch);\n            let saw2 = saw_ar(pitch * 1.005);\n            let saw3 = saw_ar(pitch * 0.995);\n            let saw4 = saw_ar(pitch * 1.01);\n            let saw5 = saw_ar(pitch * 0.99);\n\n            let supersaw = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.15;\n\n            // Filter opening with rise\n            let cutoff = 500.0 + env * 8000.0;\n            let filtered = rlpf_ar(supersaw, cutoff, 0.4);\n\n            // Add shimmer\n            let shimmer = sin_osc_ar(pitch * 4.0) * env * 0.1;\n\n            (filtered + shimmer) * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "risers",
          "path": "fx/risers/riser_synth.vibe"
        },
        {
          "name": "riser_tension",
          "description": "Genre: Cinematic, EDM | Character: Building tension riser",
          "genre": "Cinematic, EDM",
          "character": "Building tension riser",
          "params": [
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "duration",
              "default": 4
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"riser_tension\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .param(\"duration\", 4.0)\n        .body(|amp, duration| {\n            // Main envelope\n            let env = envelope()\n                .perc(0.01, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned oscillators for tension\n            let freq_env = env * env * 400.0 + 60.0;  // Accelerating pitch rise\n            let osc1 = sin_osc_ar(freq_env);\n            let osc2 = sin_osc_ar(freq_env * 1.01);\n            let osc3 = sin_osc_ar(freq_env * 0.99);\n            let osc4 = saw_ar(freq_env * 2.0) * 0.3;\n\n            let combined = (osc1 + osc2 + osc3) * 0.3 + osc4;\n\n            // Rising noise layer\n            let noise = white_noise_ar() * env * 0.3;\n            let filtered_noise = hpf_ar(noise, 2000.0 + env * 6000.0);\n\n            // Combine\n            let mix = combined + filtered_noise;\n\n            // Add resonant peak for drama\n            let resonant = rlpf_ar(mix, 1000.0 + env * 4000.0, 0.2);\n\n            resonant * env * amp * 0.6\n        })\n});",
          "category": "fx",
          "subcategory": "risers",
          "path": "fx/risers/riser_tension.vibe"
        },
        {
          "name": "riser_vocal",
          "description": "Genre: Future Bass, Pop | Character: Vocal formant riser",
          "genre": "Future Bass, Pop",
          "character": "Vocal formant riser",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 3
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"riser_vocal\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 3.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.2, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Rising pitch\n            let pitch = 150.0 + env * 400.0;\n\n            // Rich harmonic source\n            let source = saw_ar(pitch) + pulse_ar(pitch, 0.3) * 0.5;\n\n            // Morphing formants (ah -> ee transition)\n            let f1_start = 800.0;\n            let f1_end = 400.0;\n            let f2_start = 1200.0;\n            let f2_end = 2200.0;\n\n            let f1 = f1_start + env * (f1_end - f1_start);\n            let f2 = f2_start + env * (f2_end - f2_start);\n\n            // Apply formant filters\n            let formant1 = rlpf_ar(source, f1, 0.1);\n            let formant2 = rlpf_ar(source, f2, 0.15);\n            let formant3 = rlpf_ar(source, 2600.0, 0.2);\n\n            let vocal = formant1 * 0.5 + formant2 * 0.3 + formant3 * 0.2;\n\n            // Add breathiness\n            let breath = hpf_ar(pink_noise_ar(), 3000.0) * env * 0.15;\n\n            (vocal + breath) * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "risers",
          "path": "fx/risers/riser_vocal.vibe"
        },
        {
          "name": "riser_white_noise",
          "description": "Genre: EDM, Trap | Character: White noise riser with filter sweep",
          "genre": "EDM, Trap",
          "character": "White noise riser with filter sweep",
          "params": [
            {
              "name": "amp",
              "default": 0.6
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"riser_white_noise\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Long rise envelope\n            let env = envelope()\n                .perc(0.01, 3.0)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise source\n            let noise = white_noise_ar();\n\n            // Rising filter sweep\n            let filter_env = envelope()\n                .perc(0.5, 2.8)\n                .build();\n            let mod_cutoff = 200.0 + (filter_env * 8000.0);\n\n            let filtered = lpf_ar(noise, mod_cutoff);\n\n            // Resonance for emphasis\n            let resonant = rlpf_ar(filtered, mod_cutoff * 0.8, 0.3);\n\n            resonant * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "risers",
          "path": "fx/risers/riser_white_noise.vibe"
        }
      ],
      "Stingers": [
        {
          "name": "stinger_brass",
          "description": "Genre: Trailer, Cinematic | Character: Brass stinger hit",
          "genre": "Trailer, Cinematic",
          "character": "Brass stinger hit",
          "params": [
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "note",
              "default": 60
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stinger_brass\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .param(\"note\", 60.0)\n        .body(|amp, note| {\n            let env = envelope()\n                .perc(0.01, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            let freq = 440.0 * (2.0.pow((note - 69.0) / 12.0));\n\n            // Brass-like tone\n            let brass1 = saw_ar(freq);\n            let brass2 = saw_ar(freq * 1.5) * 0.5;\n            let brass3 = saw_ar(freq * 2.0) * 0.3;\n\n            let brass = brass1 + brass2 + brass3;\n\n            // Opening filter for brass attack\n            let filter_e = envelope()\n                .perc(0.01, 0.2)\n                .build();\n            let cutoff = 500.0 + filter_e * 2500.0;\n            let filtered = lpf_ar(brass, cutoff);\n\n            filtered * env * amp * 0.4\n        })\n});",
          "category": "fx",
          "subcategory": "stingers",
          "path": "fx/stingers/stinger_brass.vibe"
        },
        {
          "name": "stinger_bright",
          "description": "Genre: Pop, Commercial | Character: Bright positive stinger",
          "genre": "Pop, Commercial",
          "character": "Bright positive stinger",
          "params": [
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "note",
              "default": 72
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stinger_bright\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .param(\"note\", 72.0)\n        .body(|amp, note| {\n            let env = envelope()\n                .perc(0.001, 0.5)\n                .cleanup_on_finish()\n                .build();\n\n            let freq = 440.0 * (2.0.pow((note - 69.0) / 12.0));\n\n            // Bright bell-like tone\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.4;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n\n            let bell = h1 + h2 + h3 + h4 + h5;\n\n            // Add shimmer\n            let shimmer = sin_osc_ar(freq * 6.0) * 0.1;\n            let shimmer_mod = shimmer * sin_osc_ar(10.0);\n\n            let mix = bell + shimmer_mod;\n\n            mix * env * amp * 0.4\n        })\n});",
          "category": "fx",
          "subcategory": "stingers",
          "path": "fx/stingers/stinger_bright.vibe"
        },
        {
          "name": "stinger_dark",
          "description": "Genre: Horror, Dark Ambient | Character: Dark ominous stinger",
          "genre": "Horror, Dark Ambient",
          "character": "Dark ominous stinger",
          "params": [
            {
              "name": "amp",
              "default": 0.7
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stinger_dark\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Dissonant cluster\n            let freq = 80.0;\n            let tone1 = sin_osc_ar(freq);\n            let tone2 = sin_osc_ar(freq * 1.06);  // Minor second\n            let tone3 = sin_osc_ar(freq * 1.41);  // Tritone\n            let tone4 = sin_osc_ar(freq * 0.5);   // Sub\n\n            let cluster = tone1 + tone2 * 0.7 + tone3 * 0.5 + tone4 * 0.6;\n\n            // Add metallic resonance\n            let metal = sin_osc_ar(300.0) * sin_osc_ar(450.0);\n            let metal_e = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Noise burst\n            let noise = lpf_ar(white_noise_ar(), 2000.0);\n            let noise_e = envelope()\n                .perc(0.001, 0.1)\n                .build();\n\n            let mix = cluster * 0.3 + metal * metal_e * 0.2 + noise * noise_e * 0.3;\n\n            mix * env * amp * 0.6\n        })\n});",
          "category": "fx",
          "subcategory": "stingers",
          "path": "fx/stingers/stinger_dark.vibe"
        },
        {
          "name": "stinger_orchestral",
          "description": "Genre: Film Score, Classical | Character: Orchestral tutti stinger",
          "genre": "Film Score, Classical",
          "character": "Orchestral tutti stinger",
          "params": [
            {
              "name": "amp",
              "default": 0.8
            },
            {
              "name": "note",
              "default": 48
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stinger_orchestral\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .param(\"note\", 48.0)\n        .body(|amp, note| {\n            let env = envelope()\n                .perc(0.02, 1.2)\n                .cleanup_on_finish()\n                .build();\n\n            let freq = 440.0 * (2.0.pow((note - 69.0) / 12.0));\n\n            // Strings\n            let str1 = sin_osc_ar(freq);\n            let str2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let strings = (str1 + str2) * 0.3;\n\n            // Brass\n            let brass = saw_ar(freq) + saw_ar(freq * 1.5) * 0.4;\n            let brass_e = envelope()\n                .perc(0.02, 0.6)\n                .build();\n            let brass_filtered = lpf_ar(brass, 1500.0) * brass_e * 0.25;\n\n            // Low end\n            let bass = sin_osc_ar(freq * 0.5) * 0.4;\n\n            // Combine\n            let mix = strings + brass_filtered + bass;\n\n            mix * env * amp * 0.5\n        })\n});",
          "category": "fx",
          "subcategory": "stingers",
          "path": "fx/stingers/stinger_orchestral.vibe"
        },
        {
          "name": "stinger_synth",
          "description": "Genre: EDM, Electronic | Character: Synth stab stinger",
          "genre": "EDM, Electronic",
          "character": "Synth stab stinger",
          "params": [
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "note",
              "default": 60
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stinger_synth\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .param(\"note\", 60.0)\n        .body(|amp, note| {\n            let env = envelope()\n                .perc(0.001, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            let freq = 440.0 * (2.0.pow((note - 69.0) / 12.0));\n\n            // Punchy synth\n            let osc1 = saw_ar(freq);\n            let osc2 = pulse_ar(freq, 0.5) * 0.6;\n            let osc3 = saw_ar(freq * 2.0) * 0.3;\n\n            let combined = osc1 + osc2 + osc3;\n\n            // Snappy filter\n            let filter_e = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let cutoff = 800.0 + filter_e * 4000.0;\n            let filtered = rlpf_ar(combined, cutoff, 0.3);\n\n            filtered * env * amp * 0.5\n        })\n});",
          "category": "fx",
          "subcategory": "stingers",
          "path": "fx/stingers/stinger_synth.vibe"
        }
      ],
      "Subdrops": [
        {
          "name": "subdrop_cinematic",
          "description": "Genre: Trailer, Film | Character: Cinematic sub boom",
          "genre": "Trailer, Film",
          "character": "Cinematic sub boom",
          "params": [
            {
              "name": "amp",
              "default": 0.9
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"subdrop_cinematic\", |builder| {\n    builder\n        .param(\"amp\", 0.9)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.02, 3.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep sub with slow pitch descent\n            let pitch_e = envelope()\n                .perc(0.02, 2.0)\n                .build();\n            let freq = 50.0 - pitch_e * 20.0;\n            let sub = sin_osc_ar(freq);\n\n            // Second sub layer\n            let sub2 = sin_osc_ar(freq * 0.5) * 0.5;\n\n            // Mid-range punch\n            let punch = sin_osc_ar(100.0) + sin_osc_ar(150.0) * 0.5;\n            let punch_e = envelope()\n                .perc(0.01, 0.5)\n                .build();\n            let punch_filtered = lpf_ar(punch, 300.0) * punch_e * 0.3;\n\n            // Reverberant tail simulation\n            let tail = sin_osc_ar(40.0) * env * 0.4;\n\n            let mix = sub * 0.6 + sub2 + punch_filtered + tail;\n\n            mix * env * amp * 0.6\n        })\n});",
          "category": "fx",
          "subcategory": "subdrops",
          "path": "fx/subdrops/subdrop_cinematic.vibe"
        },
        {
          "name": "subdrop_classic",
          "description": "Genre: Dubstep, Bass Music | Character: Classic sub drop for emphasis",
          "genre": "Dubstep, Bass Music",
          "character": "Classic sub drop for emphasis",
          "params": [
            {
              "name": "freq",
              "default": 50
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"subdrop_classic\", |builder| {\n    builder\n        .param(\"freq\", 50.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Quick attack, medium decay\n            let env = envelope()\n                .perc(0.01, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch drop envelope\n            let pitch_env = envelope()\n                .perc(0.01, 0.15)\n                .build();\n            let freq_mod = pitch_env * freq * 4.0;\n\n            // Sub sine\n            let sub = sin_osc_ar(freq + freq_mod);\n\n            sub * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "subdrops",
          "path": "fx/subdrops/subdrop_classic.vibe"
        },
        {
          "name": "subdrop_click",
          "description": "Genre: Dubstep, Trap | Character: Sub drop with click attack",
          "genre": "Dubstep, Trap",
          "character": "Sub drop with click attack",
          "params": [
            {
              "name": "freq",
              "default": 50
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"subdrop_click\", |builder| {\n    builder\n        .param(\"freq\", 50.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Envelope\n            let env = envelope()\n                .perc(0.01, 0.7)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch drop\n            let pitch_env = envelope()\n                .perc(0.01, 0.12)\n                .build();\n            let freq_mod = pitch_env * freq * 3.5;\n\n            // Sub\n            let sub = sin_osc_ar(freq + freq_mod);\n\n            // Click for attack definition\n            let click_env = envelope()\n                .perc(0.001, 0.008)\n                .build();\n            let click = white_noise_ar() * click_env * 0.3;\n            let filtered_click = lpf_ar(click, 2000.0);\n\n            (sub + filtered_click) * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "subdrops",
          "path": "fx/subdrops/subdrop_click.vibe"
        },
        {
          "name": "subdrop_deep",
          "description": "Genre: Deep Dubstep | Character: Very deep, chest-hitting sub drop",
          "genre": "Deep Dubstep",
          "character": "Very deep, chest-hitting sub drop",
          "params": [
            {
              "name": "freq",
              "default": 35
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"subdrop_deep\", |builder| {\n    builder\n        .param(\"freq\", 35.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Longer decay for depth\n            let env = envelope()\n                .perc(0.015, 1.2)\n                .cleanup_on_finish()\n                .build();\n\n            // Extended pitch drop\n            let pitch_env = envelope()\n                .perc(0.015, 0.25)\n                .build();\n            let freq_mod = pitch_env * freq * 5.0;\n\n            // Pure sine for maximum sub\n            let sub = sin_osc_ar(freq + freq_mod);\n\n            sub * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "subdrops",
          "path": "fx/subdrops/subdrop_deep.vibe"
        },
        {
          "name": "subdrop_distorted",
          "description": "Genre: Brostep, Heavy Dubstep | Character: Distorted sub drop with grit",
          "genre": "Brostep, Heavy Dubstep",
          "character": "Distorted sub drop with grit",
          "params": [
            {
              "name": "freq",
              "default": 45
            },
            {
              "name": "amp",
              "default": 0.9
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"subdrop_distorted\", |builder| {\n    builder\n        .param(\"freq\", 45.0)\n        .param(\"amp\", 0.9)\n        .body(|freq, amp| {\n            // Envelope\n            let env = envelope()\n                .perc(0.008, 0.9)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch drop\n            let pitch_env = envelope()\n                .perc(0.008, 0.18)\n                .build();\n            let freq_mod = pitch_env * freq * 4.5;\n\n            // Sub with distortion\n            let sub = sin_osc_ar(freq + freq_mod) * 1.8;\n            let driven = clip(sub, -0.9, 0.9);\n\n            driven * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "subdrops",
          "path": "fx/subdrops/subdrop_distorted.vibe"
        },
        {
          "name": "subdrop_long",
          "description": "Genre: Bass Music, Experimental | Character: Long, sustained sub drop",
          "genre": "Bass Music, Experimental",
          "character": "Long, sustained sub drop",
          "params": [
            {
              "name": "freq",
              "default": 50
            },
            {
              "name": "amp",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"subdrop_long\", |builder| {\n    builder\n        .param(\"freq\", 50.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Long decay\n            let env = envelope()\n                .perc(0.02, 2.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Extended pitch drop\n            let pitch_env = envelope()\n                .perc(0.02, 0.4)\n                .build();\n            let freq_mod = pitch_env * freq * 5.0;\n\n            // Sub sine\n            let sub = sin_osc_ar(freq + freq_mod);\n\n            sub * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "subdrops",
          "path": "fx/subdrops/subdrop_long.vibe"
        },
        {
          "name": "subdrop_tight",
          "description": "Genre: Techno, Minimal | Character: Tight controlled sub",
          "genre": "Techno, Minimal",
          "character": "Tight controlled sub",
          "params": [
            {
              "name": "amp",
              "default": 0.8
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"subdrop_tight\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 0.6)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast pitch drop\n            let pitch_e = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let freq = 80.0 - pitch_e * 40.0;\n\n            // Clean sine sub\n            let sub = sin_osc_ar(freq);\n\n            // Subtle click\n            let click = white_noise_ar();\n            let click_e = envelope()\n                .perc(0.001, 0.005)\n                .build();\n            let click_filtered = lpf_ar(click, 8000.0) * click_e * 0.15;\n\n            (sub + click_filtered) * env * amp * 0.8\n        })\n});",
          "category": "fx",
          "subcategory": "subdrops",
          "path": "fx/subdrops/subdrop_tight.vibe"
        },
        {
          "name": "subdrop_wobble",
          "description": "Genre: Dubstep, Bass Music | Character: Wobbling sub drop",
          "genre": "Dubstep, Bass Music",
          "character": "Wobbling sub drop",
          "params": [
            {
              "name": "amp",
              "default": 0.8
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"subdrop_wobble\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch drop\n            let pitch_e = envelope()\n                .perc(0.001, 0.2)\n                .build();\n            let freq = 100.0 - pitch_e * 60.0;\n\n            // Main sub with wobble\n            let wobble_speed = 6.0 + (1.0 - env) * 10.0;  // Speeds up as it decays\n            let wobble = sin_osc_ar(wobble_speed) * 0.5 + 0.5;\n            let sub = sin_osc_ar(freq) * wobble;\n\n            // Second harmonic wobbling\n            let h2 = sin_osc_ar(freq * 2.0) * wobble * 0.3;\n\n            // Click transient\n            let click = white_noise_ar();\n            let click_e = envelope()\n                .perc(0.001, 0.01)\n                .build();\n\n            let mix = sub + h2 + click * click_e * 0.2;\n\n            mix * env * amp * 0.7\n        })\n});",
          "category": "fx",
          "subcategory": "subdrops",
          "path": "fx/subdrops/subdrop_wobble.vibe"
        }
      ],
      "Sweeps": [
        {
          "name": "sweep_cinematic",
          "description": "Genre: Cinematic, Trailer | Character: Epic cinematic sweep",
          "genre": "Cinematic, Trailer",
          "character": "Epic cinematic sweep",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 3
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sweep_cinematic\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 3.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.3, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Rising strings-like layer\n            let string_freq = 200.0 + env * 600.0;\n            let strings = sin_osc_ar(string_freq) + sin_osc_ar(string_freq * 2.0) * 0.5;\n\n            // Brass swell\n            let brass_freq = 100.0 + env * 200.0;\n            let brass = saw_ar(brass_freq) * 0.3;\n            let brass_filtered = lpf_ar(brass, 600.0 + env * 1500.0);\n\n            // Wind/air texture\n            let wind = pink_noise_ar();\n            let wind_filtered = lpf_ar(hpf_ar(wind, 500.0 + env * 2000.0), 4000.0 + env * 6000.0);\n\n            let mix = strings * 0.3 + brass_filtered + wind_filtered * 0.4;\n\n            mix * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "sweeps",
          "path": "fx/sweeps/sweep_cinematic.vibe"
        },
        {
          "name": "sweep_filter_down",
          "description": "Genre: House, Techno | Character: Downward filter sweep",
          "genre": "House, Techno",
          "character": "Downward filter sweep",
          "params": [
            {
              "name": "amp",
              "default": 0.6
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sweep_filter_down\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Sweep envelope\n            let env = envelope()\n                .perc(0.01, 2.0)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise source\n            let noise = white_noise_ar();\n\n            // Downward filter sweep (inverted envelope)\n            let filter_env = envelope()\n                .perc(0.01, 0.2)\n                .build();\n            let mod_cutoff = 8000.0 - (filter_env * 7000.0);\n\n            let filtered = rlpf_ar(noise, mod_cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "sweeps",
          "path": "fx/sweeps/sweep_filter_down.vibe"
        },
        {
          "name": "sweep_filter_up",
          "description": "Genre: House, Techno | Character: Upward filter sweep",
          "genre": "House, Techno",
          "character": "Upward filter sweep",
          "params": [
            {
              "name": "amp",
              "default": 0.6
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sweep_filter_up\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Sweep envelope\n            let env = envelope()\n                .perc(0.01, 2.0)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise source\n            let noise = white_noise_ar();\n\n            // Upward filter sweep\n            let filter_env = envelope()\n                .perc(0.05, 1.8)\n                .build();\n            let mod_cutoff = 200.0 + (filter_env * 8000.0);\n\n            let filtered = rlpf_ar(noise, mod_cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "sweeps",
          "path": "fx/sweeps/sweep_filter_up.vibe"
        },
        {
          "name": "sweep_laser",
          "description": "Genre: Sci-Fi, Electronic | Character: Laser-style sweep",
          "genre": "Sci-Fi, Electronic",
          "character": "Laser-style sweep",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 0.5
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sweep_laser\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 0.5)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Rapidly falling pitch\n            let freq = 4000.0 - env * 3800.0;\n            let laser = sin_osc_ar(freq);\n\n            // Add harmonics for richness\n            let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.15;\n\n            // Resonant filter sweep\n            let combined = laser + h2 + h3;\n            let filtered = rlpf_ar(combined, freq, 0.2);\n\n            filtered * env * amp * 0.7\n        })\n});",
          "category": "fx",
          "subcategory": "sweeps",
          "path": "fx/sweeps/sweep_laser.vibe"
        },
        {
          "name": "sweep_pitch",
          "description": "Genre: EDM, Trance | Character: Pitch sweep effect",
          "genre": "EDM, Trance",
          "character": "Pitch sweep effect",
          "params": [
            {
              "name": "start_freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.5
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sweep_pitch\", |builder| {\n    builder\n        .param(\"start_freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .body(|start_freq, amp| {\n            // Sweep envelope\n            let env = envelope()\n                .perc(0.02, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch sweep\n            let pitch_env = envelope()\n                .perc(0.05, 1.3)\n                .build();\n            let freq = start_freq + (pitch_env * start_freq * 6.0);\n\n            // Detuned oscillators\n            let osc1 = saw_ar(freq * 0.997);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.003);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Filter\n            let filtered = lpf_ar(mix, 5000.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "sweeps",
          "path": "fx/sweeps/sweep_pitch.vibe"
        },
        {
          "name": "sweep_release",
          "description": "Genre: EDM, House | Character: Release sweep (post-drop)",
          "genre": "EDM, House",
          "character": "Release sweep (post-drop)",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 2
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sweep_release\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 2.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // High starting point, sweeping down\n            let sweep_env = 1.0 - env;  // Inverse of main envelope\n\n            // Filtered noise sweeping down\n            let noise = white_noise_ar();\n            let cutoff = 12000.0 * sweep_env + 200.0;\n            let filtered = lpf_ar(noise, cutoff);\n\n            // Resonant peak following sweep\n            let res = rlpf_ar(filtered, cutoff * 0.5, 0.2) * 0.5;\n\n            // Pitched component falling\n            let freq = 1000.0 * sweep_env + 100.0;\n            let tone = sin_osc_ar(freq) * 0.3;\n\n            (filtered * 0.5 + res + tone) * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "sweeps",
          "path": "fx/sweeps/sweep_release.vibe"
        },
        {
          "name": "sweep_reverse",
          "description": "Genre: Experimental, IDM | Character: Reverse sweep effect",
          "genre": "Experimental, IDM",
          "character": "Reverse sweep effect",
          "params": [
            {
              "name": "amp",
              "default": 0.6
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sweep_reverse\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Reverse-style envelope (builds up)\n            let env = envelope()\n                .perc(0.8, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise\n            let noise = white_noise_ar();\n\n            // Reverse filter sweep (starts high, goes low, then back up)\n            let filter_env = envelope()\n                .perc(1.0, 1.2)\n                .build();\n            let mod_cutoff = 6000.0 - (filter_env * 4000.0);\n\n            let filtered = rlpf_ar(noise, mod_cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "sweeps",
          "path": "fx/sweeps/sweep_reverse.vibe"
        },
        {
          "name": "sweep_tension",
          "description": "Genre: Horror, Thriller | Character: Tension-building sweep",
          "genre": "Horror, Thriller",
          "character": "Tension-building sweep",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 4
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sweep_tension\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 4.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(1.0, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Dissonant cluster that slowly rises\n            let base = 150.0 + env * 200.0;\n            let tone1 = sin_osc_ar(base);\n            let tone2 = sin_osc_ar(base * 1.06);  // Minor second\n            let tone3 = sin_osc_ar(base * 1.12);  // Augmented\n            let tone4 = sin_osc_ar(base * 0.94);\n\n            let cluster = (tone1 + tone2 + tone3 + tone4) * 0.2;\n\n            // Tremolo for unease\n            let trem = sin_osc_ar(4.0 + env * 8.0) * 0.3 + 0.7;\n            let tremmed = cluster * trem;\n\n            // High-pitched drone\n            let high = sin_osc_ar(2000.0 + env * 3000.0) * env * 0.1;\n\n            // Low rumble\n            let rumble = lpf_ar(pink_noise_ar(), 100.0) * 0.3;\n\n            (tremmed + high + rumble) * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "sweeps",
          "path": "fx/sweeps/sweep_tension.vibe"
        },
        {
          "name": "sweep_whoosh",
          "description": "Genre: Cinematic, Trailer | Character: Whoosh/wind sweep",
          "genre": "Cinematic, Trailer",
          "character": "Whoosh/wind sweep",
          "params": [
            {
              "name": "amp",
              "default": 0.7
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"sweep_whoosh\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            // Quick whoosh envelope\n            let env = envelope()\n                .perc(0.005, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise for natural wind character\n            let noise = pink_noise_ar();\n\n            // Fast filter sweep for whoosh\n            let filter_env = envelope()\n                .perc(0.01, 0.6)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 6000.0);\n\n            let filtered = rlpf_ar(noise, mod_cutoff, 0.4);\n\n            // High-pass for air\n            let clean = hpf_ar(filtered, 200.0);\n\n            clean * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "sweeps",
          "path": "fx/sweeps/sweep_whoosh.vibe"
        }
      ],
      "Transitions": [
        {
          "name": "transition_glitch",
          "description": "Genre: Electronic, Experimental | Character: Glitchy digital transition",
          "genre": "Electronic, Experimental",
          "character": "Glitchy digital transition",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 0.5
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"transition_glitch\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 0.5)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.01, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Digital noise bursts\n            let noise = white_noise_ar();\n\n            // Rapid gate for glitch effect\n            let gate_lfo = pulse_ar(20.0 + env * 60.0, 0.3);\n            let gated = noise * gate_lfo;\n\n            // Bitcrushed character (simulated)\n            let crushed = (gated * 8.0).floor() / 8.0;\n\n            // Pitched glitch element\n            let glitch_freq = 200.0 + env * 2000.0;\n            let glitch_tone = pulse_ar(glitch_freq, 0.1) * 0.3;\n\n            // High-pass for digital character\n            let mix = hpf_ar(crushed + glitch_tone, 500.0);\n\n            mix * env * amp * 0.6\n        })\n});",
          "category": "fx",
          "subcategory": "transitions",
          "path": "fx/transitions/transition_glitch.vibe"
        },
        {
          "name": "transition_reverse",
          "description": "Genre: All genres | Character: Reverse cymbal-like transition",
          "genre": "All genres",
          "character": "Reverse cymbal-like transition",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"transition_reverse\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .body(|amp| {\n            // Reverse envelope (builds up)\n            let env = envelope()\n                .perc(0.9, 0.05)\n                .cleanup_on_finish()\n                .build();\n\n            // Cymbal-like noise\n            let noise = white_noise_ar();\n            let filtered = hpf_ar(noise, 3000.0);\n\n            // Add metallic resonance\n            let metal1 = sin_osc_ar(2500.0) * 0.1;\n            let metal2 = sin_osc_ar(4200.0) * 0.08;\n            let metal3 = sin_osc_ar(6800.0) * 0.05;\n\n            let cymbal = filtered + metal1 + metal2 + metal3;\n\n            // Filter opens as it builds\n            let cutoff = 2000.0 + env * 10000.0;\n            let final_filter = lpf_ar(cymbal, cutoff);\n\n            final_filter * env * amp * 0.5\n        })\n});",
          "category": "fx",
          "subcategory": "transitions",
          "path": "fx/transitions/transition_reverse.vibe"
        },
        {
          "name": "transition_sweep",
          "description": "Genre: EDM, House | Character: Tonal transition sweep",
          "genre": "EDM, House",
          "character": "Tonal transition sweep",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"transition_sweep\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 1.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.05, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch sweep\n            let sweep = env * (1.0 - env) * 4.0;\n            let freq = 200.0 + sweep * 2000.0;\n\n            // Synth tone\n            let tone = saw_ar(freq) + saw_ar(freq * 1.01) + saw_ar(freq * 0.99);\n\n            // Filter following pitch\n            let filtered = lpf_ar(tone, freq * 3.0) * 0.3;\n\n            // Add noise texture\n            let noise = lpf_ar(white_noise_ar(), freq * 2.0) * 0.2;\n\n            (filtered + noise) * env * amp\n        })\n});",
          "category": "fx",
          "subcategory": "transitions",
          "path": "fx/transitions/transition_sweep.vibe"
        },
        {
          "name": "whoosh_fast",
          "description": "Genre: All genres | Character: Fast whoosh transition",
          "genre": "All genres",
          "character": "Fast whoosh transition",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"whoosh_fast\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.01, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast filter sweep on noise\n            let noise = white_noise_ar();\n\n            // Sweep from high to low quickly\n            let sweep_e = envelope()\n                .perc(0.01, 0.25)\n                .build();\n            let cutoff = 500.0 + sweep_e * 10000.0;\n\n            let filtered = lpf_ar(noise, cutoff);\n\n            // Add resonance at sweep point\n            let res = rlpf_ar(noise, cutoff * 0.8, 0.2) * 0.4;\n\n            (filtered + res) * env * amp * 0.7\n        })\n});",
          "category": "fx",
          "subcategory": "transitions",
          "path": "fx/transitions/whoosh_fast.vibe"
        },
        {
          "name": "whoosh_slow",
          "description": "Genre: Cinematic, Ambient | Character: Slow atmospheric whoosh",
          "genre": "Cinematic, Ambient",
          "character": "Slow atmospheric whoosh",
          "params": [
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "duration",
              "default": 1.5
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"whoosh_slow\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 1.5)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.3, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            let noise = pink_noise_ar();\n\n            // Slow rise and fall\n            let sweep = env * (1.0 - env) * 4.0;  // Peak in middle\n            let cutoff = 300.0 + sweep * 6000.0;\n\n            let filtered = lpf_ar(noise, cutoff);\n\n            // Add wind-like character\n            let mod_lfo = sin_osc_ar(3.0) * 0.2 + 0.8;\n            let wind = filtered * mod_lfo;\n\n            wind * env * amp * 0.8\n        })\n});",
          "category": "fx",
          "subcategory": "transitions",
          "path": "fx/transitions/whoosh_slow.vibe"
        }
      ]
    },
    "items": []
  },
  "Keys": {
    "subcategories": {},
    "items": [
      {
        "name": "accordion_keys",
        "description": "Reedy, bright",
        "genre": "",
        "character": "Reedy, bright",
        "params": [],
        "type": "synthdef",
        "source": "// Folk instrument | Character: Reedy, bright\ndefine_synthdef(\"accordion_keys\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Reed vibration\n        let tremolo = sin_osc_ar(6.0) * 0.15 + 1.0;\n\n        // Detuned reeds\n        let reed1 = saw_ar(freq * 0.998) * 0.35;\n        let reed2 = saw_ar(freq * 1.002) * 0.35;\n\n        let mix = (reed1 + reed2) * tremolo;\n\n        // Reedy character\n        let filtered = bpf_ar(mix, 1500.0, 0.4) + mix * 0.4;\n\n        filtered * env * amp\n    });\n",
        "category": "keys",
        "subcategory": "",
        "path": "keys/accordion_keys.vibe"
      },
      {
        "name": "celeste",
        "description": "Celeste/celesta keyboard with bell-like, sparkling tone.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 880
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"celeste\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Bell-like envelope\n            let env = envelope()\n                .asr(0.002, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay for bell character\n            let decay_env = envelope()\n                .perc(0.001, 0.8)\n                .build();\n\n            // Metallic bell harmonics\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.17) * 0.2; // Inharmonic for bell character\n            let h5 = sin_osc_ar(freq * 5.43) * 0.15;\n            let h6 = sin_osc_ar(freq * 6.8) * 0.1;\n\n            let bell = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Soft hammer attack\n            let attack_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n            let attack = sin_osc_ar(freq * 8.0) * attack_env * 0.2;\n\n            let celeste = bell + attack;\n\n            celeste * env * decay_env * amp * 0.5\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/celeste.vibe"
      },
      {
        "name": "clavinet",
        "description": "percussive attack and bright, plucky tone.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "brightness",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"clavinet\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.7) // Filter brightness\n        .body(|freq, amp, gate, brightness| {\n            // Percussive envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay envelope for string character\n            let decay_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Plucked string-like waveform (rich in harmonics)\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.001);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Hammer/pick attack transient\n            let pick_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let pick = white_noise_ar() * pick_env * 0.3;\n\n            // Filter with envelope for pluck character\n            let filter_freq = 1000.0 + brightness * 4000.0 + decay_env * 3000.0;\n            let filtered = rlpf_ar(source + pick, filter_freq, 0.3);\n\n            // Emphasize fundamental\n            let fundamental = sin_osc_ar(freq) * 0.3;\n\n            (filtered + fundamental) * env * decay_env * amp * 0.8\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/clavinet.vibe"
      },
      {
        "name": "electric_piano",
        "description": "and warm decay.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "brightness",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"electric_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.5) // Tine brightness\n        .body(|freq, amp, gate, brightness| {\n            // Gate-controlled envelope with classic EP decay\n            let env = envelope()\n                .asr(0.005, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast attack envelope for bell character\n            let bell_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            // Fundamental with harmonics (tine + tone bar)\n            let fundamental = sin_osc_ar(freq);\n            let second = sin_osc_ar(freq * 2.0) * 0.5;\n            let third = sin_osc_ar(freq * 3.0) * 0.25;\n            let fourth = sin_osc_ar(freq * 4.0) * 0.15;\n            let fifth = sin_osc_ar(freq * 5.0) * 0.1;\n\n            // Bell/tine component (higher partials with fast decay)\n            let bell = sin_osc_ar(freq * 6.0) * bell_env * 0.2 * brightness;\n            let bell2 = sin_osc_ar(freq * 7.0) * bell_env * 0.1 * brightness;\n\n            let tone = fundamental + second + third + fourth + fifth + bell + bell2;\n\n            // Slight chorus/detuning for thickness\n            let detuned = sin_osc_ar(freq * 1.002) * 0.2;\n\n            // Low pass to tame highs\n            let filtered = lpf_ar(tone + detuned, 3000.0 + brightness * 3000.0);\n\n            filtered * env * amp * 0.6\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/electric_piano.vibe"
      },
      {
        "name": "grand_piano",
        "description": "velocity-sensitive with full harmonic content",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "velocity",
            "default": 0.7
          },
          {
            "name": "brightness",
            "default": 0.5
          },
          {
            "name": "resonance",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"grand_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"velocity\", 0.7)     // 0-1: affects brightness and attack\n        .param(\"brightness\", 0.5)   // Tonal character\n        .param(\"resonance\", 0.4)    // Sympathetic string resonance amount\n        .body(|freq, amp, gate, velocity, brightness, resonance| {\n            // Main amplitude envelope - piano has sharp attack, long decay\n            let decay_time = 2.0 + (1.0 / (freq / 100.0));  // Lower notes decay longer\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Hammer strike envelope - very fast, creates initial \"thunk\"\n            let hammer_env = envelope()\n                .perc(0.0005, 0.008)\n                .build();\n\n            // Velocity affects brightness - harder hit = more harmonics\n            let vel_brightness = 0.3 + (velocity * 0.7);\n            let cutoff_base = 800.0 + (vel_brightness * brightness * 8000.0);\n\n            // String harmonics - piano has inharmonic partials due to string stiffness\n            // Inharmonicity factor increases with partial number\n            let inharm = 1.0 + (freq / 20000.0);  // Subtle inharmonicity\n\n            // Fundamental and harmonics with proper amplitude rolloff\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0 * inharm) * 0.7;\n            let h3 = sin_osc_ar(freq * 3.0 * inharm * inharm) * 0.45;\n            let h4 = sin_osc_ar(freq * 4.0 * inharm * inharm * inharm) * 0.28;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.18;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.12;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.08;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.05;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Hammer noise - creates the initial attack character\n            let hammer_noise = white_noise_ar() * hammer_env * velocity * 0.15;\n            let hammer_filtered = bpf_ar(hammer_noise, freq * 8.0, 0.5);\n\n            // Dynamic low-pass filter - simulates hammer felt softening\n            let filter_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n            let dyn_cutoff = cutoff_base + (filter_env * 4000.0 * velocity);\n            let filtered_tone = lpf_ar(string_tone, dyn_cutoff);\n\n            // Soundboard resonance - adds body and warmth\n            let board_freq1 = 120.0;\n            let board_freq2 = 280.0;\n            let board_res1 = rlpf_ar(filtered_tone, board_freq1, 0.4) * 0.15;\n            let board_res2 = rlpf_ar(filtered_tone, board_freq2, 0.5) * 0.1;\n\n            // Sympathetic string resonance (other strings vibrating)\n            let symp1 = sin_osc_ar(freq * 2.0) * 0.02 * resonance;\n            let symp2 = sin_osc_ar(freq * 3.0) * 0.015 * resonance;\n            let symp_env = envelope()\n                .perc(0.1, 1.2)\n                .time_scale(decay_time)\n                .build();\n            let sympathetic = (symp1 + symp2) * symp_env;\n\n            // High frequency damping over time (strings lose brightness as they decay)\n            let hf_damp_env = envelope()\n                .perc(0.001, 0.5)\n                .time_scale(decay_time)\n                .build();\n            let hf_cutoff = 2000.0 + (hf_damp_env * 6000.0);\n\n            let main_tone = filtered_tone + board_res1 + board_res2 + hammer_filtered;\n            let damped = lpf_ar(main_tone, hf_cutoff);\n\n            // Final mix with slight compression via soft clipping\n            let output = (damped + sympathetic) * env * amp * 0.5;\n            output.softclip() * 0.9\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/grand_piano.vibe"
      },
      {
        "name": "grand_piano_bright",
        "description": "more upper harmonics, concert hall character",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "velocity",
            "default": 0.8
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"grand_piano_bright\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"velocity\", 0.8)\n        .body(|freq, amp, gate, velocity| {\n            let decay_time = 2.5 + (1.0 / (freq / 80.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Brighter harmonic content\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.75;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.3;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.22;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.15;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.1;\n            let h9 = sin_osc_ar(freq * 9.0) * 0.07;\n            let h10 = sin_osc_ar(freq * 10.0) * 0.05;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8 + h9 + h10;\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.0003, 0.015)\n                .build();\n            let attack = white_noise_ar() * attack_env * velocity * 0.12;\n            let attack_filtered = bpf_ar(attack, freq * 6.0, 0.4);\n\n            // Higher cutoff for brightness\n            let cutoff = 3000.0 + (velocity * 8000.0);\n            let filtered = lpf_ar(tone + attack_filtered, cutoff);\n\n            // Subtle detuning for richness (like multiple strings per note)\n            let detune1 = sin_osc_ar(freq * 0.9995) * 0.1;\n            let detune2 = sin_osc_ar(freq * 1.0005) * 0.1;\n\n            let output = (filtered + detune1 + detune2) * env * amp * 0.45;\n            output.softclip() * 0.9\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/grand_piano.vibe"
      },
      {
        "name": "grand_piano_warm",
        "description": "darker, more intimate character",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "velocity",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"grand_piano_warm\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"velocity\", 0.6)\n        .body(|freq, amp, gate, velocity| {\n            let decay_time = 3.0 + (1.0 / (freq / 60.0));\n            let env = envelope()\n                .perc(0.002, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Warmer harmonic content - less upper partials\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.1;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.05;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Softer attack\n            let attack_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let attack = white_noise_ar() * attack_env * velocity * 0.05;\n\n            // Lower cutoff for warmth\n            let cutoff = 1500.0 + (velocity * 3000.0);\n            let filtered = lpf_ar(tone + attack, cutoff);\n\n            // Extra low-end body\n            let body = rlpf_ar(filtered, 200.0, 0.5) * 0.2;\n\n            let output = (filtered + body) * env * amp * 0.5;\n            output\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/grand_piano.vibe"
      },
      {
        "name": "upright_piano",
        "description": "different character from grand",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "velocity",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"upright_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"velocity\", 0.7)\n        .body(|freq, amp, gate, velocity| {\n            let decay_time = 1.8 + (1.0 / (freq / 120.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Upright has more \"honky\" character - emphasized odd harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.55;  // Emphasized\n            let h4 = sin_osc_ar(freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.3;   // Emphasized\n            let h6 = sin_osc_ar(freq * 6.0) * 0.15;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.12;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Mechanical noise (felt hammers, action)\n            let mech_env = envelope()\n                .perc(0.0005, 0.012)\n                .build();\n            let mech = white_noise_ar() * mech_env * velocity * 0.08;\n\n            // Smaller soundboard resonance\n            let cutoff = 2000.0 + (velocity * 4000.0);\n            let filtered = lpf_ar(tone + mech, cutoff);\n\n            // Box-like resonance of upright cabinet\n            let cabinet = rlpf_ar(filtered, 350.0, 0.6) * 0.15;\n\n            let output = (filtered + cabinet) * env * amp * 0.5;\n            output.softclip() * 0.9\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/grand_piano.vibe"
      },
      {
        "name": "tack_piano",
        "description": "prepared piano with tacks on hammers",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "velocity",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tack_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"velocity\", 0.7)\n        .body(|freq, amp, gate, velocity| {\n            let decay_time = 1.2;\n            let env = envelope()\n                .perc(0.001, decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Very bright attack from tacks\n            let attack_env = envelope()\n                .perc(0.0002, 0.005)\n                .build();\n            let tack_hit = white_noise_ar() * attack_env * 0.4;\n            let tack_filtered = hpf_ar(tack_hit, 3000.0);\n\n            // Bright harmonics\n            let h1 = sin_osc_ar(freq) * 0.8;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.35;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.3;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.25;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.2;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // High cutoff - very bright character\n            let filtered = lpf_ar(tone, 8000.0 + (velocity * 4000.0));\n\n            let output = (filtered + tack_filtered) * env * amp * 0.4;\n            output.softclip()\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/grand_piano.vibe"
      },
      {
        "name": "hammond_organ",
        "description": "Uses additive synthesis to simulate drawbar settings.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "percussion",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"hammond_organ\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"percussion\", 0.5) // Percussion amount\n        .body(|freq, amp, gate, percussion| {\n            // Instant attack organ envelope\n            let env = envelope()\n                .asr(0.003, 1.0, 0.01)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Drawbar harmonics (typical jazz setting: 888000000)\n            // Sub-octave (16')\n            let d1 = sin_osc_ar(freq * 0.5) * 0.8;\n            // Fundamental (8')\n            let d2 = sin_osc_ar(freq) * 0.8;\n            // Fifth (5 1/3')\n            let d3 = sin_osc_ar(freq * 1.5) * 0.8;\n            // Octave (4')\n            let d4 = sin_osc_ar(freq * 2.0) * 0.6;\n            // 12th (2 2/3')\n            let d5 = sin_osc_ar(freq * 3.0) * 0.4;\n            // 15th (2')\n            let d6 = sin_osc_ar(freq * 4.0) * 0.3;\n            // 17th (1 3/5')\n            let d7 = sin_osc_ar(freq * 5.0) * 0.2;\n            // 19th (1 1/3')\n            let d8 = sin_osc_ar(freq * 6.0) * 0.1;\n            // 22nd (1')\n            let d9 = sin_osc_ar(freq * 8.0) * 0.05;\n\n            let drawbars = d1 + d2 + d3 + d4 + d5 + d6 + d7 + d8 + d9;\n\n            // Percussion envelope (fast decay click)\n            let perc_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let perc = sin_osc_ar(freq * 3.0) * perc_env * percussion * 0.4;\n\n            // Key click\n            let click_env = envelope()\n                .perc(0.0001, 0.003)\n                .build();\n            let click = white_noise_ar() * click_env * 0.1;\n\n            let organ = drawbars * 0.4 + perc + click;\n\n            organ * env * amp\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/hammond_organ.vibe"
      },
      {
        "name": "harpsichord",
        "description": "Plucked string, bright",
        "genre": "",
        "character": "Plucked string, bright",
        "params": [],
        "type": "synthdef",
        "source": "// Baroque keyboard | Character: Plucked string, bright\ndefine_synthdef(\"harpsichord\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.05)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pluck attack\n        let pluck_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 3000.0) * pluck_env * 0.4;\n\n        // Bright string resonance\n        let str1 = pulse_ar(freq, 0.5) * 0.35;\n        let str2 = pulse_ar(freq * 2.0, 0.5) * 0.2;\n        let str3 = sin_osc_ar(freq * 3.0) * 0.1;\n\n        let sig = str1 + str2 + str3 + attack;\n\n        // Bright character\n        let filtered = hpf_ar(sig, 300.0);\n\n        filtered * env * amp\n    });\n",
        "category": "keys",
        "subcategory": "",
        "path": "keys/harpsichord.vibe"
      },
      {
        "name": "honky_tonk",
        "description": "Slightly detuned piano with characteristic \"tack\" attack.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "detune",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"honky_tonk\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"detune\", 0.5) // Detune amount\n        .body(|freq, amp, gate, detune| {\n            // Piano-like envelope\n            let env = envelope()\n                .asr(0.005, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay envelope for sustain\n            let decay_env = envelope()\n                .perc(0.001, 1.0)\n                .build();\n\n            // Detuned strings (honky-tonk character)\n            let detune_amt = 0.002 + detune * 0.008;\n            let str1 = sin_osc_ar(freq * (1.0 - detune_amt));\n            let str2 = sin_osc_ar(freq);\n            let str3 = sin_osc_ar(freq * (1.0 + detune_amt));\n\n            // Harmonics\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n            let strings = (str1 + str2 + str3) * 0.4 + h2 + h3 + h4;\n\n            // Tack piano hammer sound\n            let tack_env = envelope()\n                .perc(0.0001, 0.02)\n                .build();\n            let tack = white_noise_ar() * tack_env * 0.25;\n\n            let piano = strings + tack;\n\n            // Bright filtering\n            let filtered = lpf_ar(piano, 6000.0);\n\n            filtered * env * decay_env * amp * 0.6\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/honky_tonk.vibe"
      },
      {
        "name": "crotales",
        "description": "very high, pure",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 2093
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"crotales\", |builder| {\n    builder\n        .param(\"freq\", 2093.0)   // C7\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let decay_time = 3.0;\n            let env = envelope()\n                .perc(0.001, decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Light strike\n            let strike_env = envelope()\n                .perc(0.0001, 0.001)\n                .build();\n            let strike = white_noise_ar() * strike_env * 0.1;\n\n            // Very pure, bell-like\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n            let h3 = sin_osc_ar(freq * 3.17) * 0.15;\n\n            let tone = h1 + h2 + h3 + strike;\n\n            hpf_ar(tone, 1000.0) * env * amp * 0.5\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/mallet_instruments.vibe"
      },
      {
        "name": "celesta",
        "description": "keyboard glockenspiel",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 1046.5
          },
          {
            "name": "amp",
            "default": 0.45
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"celesta\", |builder| {\n    builder\n        .param(\"freq\", 1046.5)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let decay_time = 1.8;\n            let env = envelope()\n                .perc(0.001, decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Felt hammer - softer than glockenspiel\n            let strike_env = envelope()\n                .perc(0.001, 0.006)\n                .build();\n            let strike = white_noise_ar() * strike_env * 0.08;\n\n            // Steel bars with resonators - warmer than glockenspiel\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.76) * 0.35;\n            let h3 = sin_osc_ar(freq * 5.4) * 0.18;\n            let h4 = sin_osc_ar(freq * 8.9) * 0.08;\n\n            let bar_tone = h1 + h2 + h3 + h4;\n\n            // Wooden resonator adds warmth\n            let resonator = rlpf_ar(bar_tone, freq * 1.5, 0.4) * 0.25;\n\n            // High freq decay\n            let hf_env = envelope()\n                .perc(0.001, 0.4)\n                .time_scale(decay_time)\n                .build();\n\n            let tone = h1 + (h2 + h3 + h4) * hf_env + resonator + strike;\n\n            hpf_ar(tone, 300.0) * env * amp * 0.5\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/mallet_instruments.vibe"
      },
      {
        "name": "mellotron_choir",
        "description": "Classic mellotron choir",
        "genre": "",
        "character": "Classic mellotron choir",
        "params": [],
        "type": "synthdef",
        "source": "// Sampler-style | Character: Classic mellotron choir\ndefine_synthdef(\"mellotron_choir\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Tape warble\n        let warble = sin_osc_ar(4.0) * freq * 0.005;\n\n        // Choir-like source\n        let source = saw_ar(freq + warble) * 0.4;\n\n        // Choir formants\n        let f1 = bpf_ar(source, 600.0, 0.15) * 0.4;\n        let f2 = bpf_ar(source, 1200.0, 0.18) * 0.3;\n        let f3 = bpf_ar(source, 2400.0, 0.2) * 0.15;\n\n        let sig = f1 + f2 + f3;\n\n        // Tape lo-fi character\n        let filtered = lpf_ar(sig, 5000.0);\n\n        filtered * env * amp\n    });\n",
        "category": "keys",
        "subcategory": "",
        "path": "keys/mellotron_choir.vibe"
      },
      {
        "name": "mellotron_flute",
        "description": "Classic mellotron flute sound",
        "genre": "",
        "character": "Classic mellotron flute sound",
        "params": [],
        "type": "synthdef",
        "source": "// Sampler-style | Character: Classic mellotron flute sound\ndefine_synthdef(\"mellotron_flute\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Tape warble\n        let warble = sin_osc_ar(3.5) * freq * 0.004;\n\n        // Flute-like tone\n        let pure = sin_osc_ar(freq + warble) * 0.5;\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.0, 0.2) * 0.15;\n        let second_harmonic = sin_osc_ar(freq * 2.0 + warble) * 0.15;\n\n        let sig = pure + breath + second_harmonic;\n\n        // Tape character - slight filtering\n        let filtered = lpf_ar(sig, 4000.0);\n\n        filtered * env * amp\n    });\n",
        "category": "keys",
        "subcategory": "",
        "path": "keys/mellotron_flute.vibe"
      },
      {
        "name": "mellotron_strings",
        "description": "Mellotron string sound",
        "genre": "Progressive Rock, Psychedelic",
        "character": "Mellotron string sound",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Progressive Rock, Psychedelic | Character: Mellotron string sound\ndefine_synthdef(\"mellotron_strings\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slightly detuned for tape character\n        let wow = sin_osc_ar(0.5) * freq * 0.004;\n\n        let osc1 = saw_ar(freq + wow) * 0.3;\n        let osc2 = saw_ar(freq * 1.002) * 0.25;\n        let osc3 = saw_ar(freq * 0.998 + wow * 0.5) * 0.25;\n\n        let mix = osc1 + osc2 + osc3;\n\n        // Tape-like filtering\n        let filtered = lpf_ar(mix, 3500.0);\n\n        // Add noise for tape hiss\n        let hiss = hpf_ar(white_noise_ar(), 6000.0) * 0.02;\n\n        (filtered + hiss) * env * amp\n    });\n",
        "category": "keys",
        "subcategory": "",
        "path": "keys/mellotron_strings.vibe"
      },
      {
        "name": "organ_b3",
        "description": "Hammond B3 organ with drawbars",
        "genre": "Gospel, Jazz, Rock",
        "character": "Hammond B3 organ with drawbars",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Gospel, Jazz, Rock | Character: Hammond B3 organ with drawbars\ndefine_synthdef(\"organ_b3\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.05)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Tonewheel harmonics (simplified drawbar settings)\n        let h1 = sin_osc_ar(freq * 0.5) * 0.15;    // 16'\n        let h2 = sin_osc_ar(freq * 0.75) * 0.08;   // 5 1/3'\n        let h3 = sin_osc_ar(freq) * 0.4;           // 8'\n        let h4 = sin_osc_ar(freq * 2.0) * 0.25;    // 4'\n        let h5 = sin_osc_ar(freq * 3.0) * 0.1;     // 2 2/3'\n        let h6 = sin_osc_ar(freq * 4.0) * 0.15;    // 2'\n        let h7 = sin_osc_ar(freq * 6.0) * 0.05;    // 1 1/3'\n\n        let mix = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n        // Key click\n        let click = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let key_click = white_noise_ar() * click * 0.08;\n\n        (mix + key_click) * env * amp\n    });\n",
        "category": "keys",
        "subcategory": "",
        "path": "keys/organ_b3.vibe"
      },
      {
        "name": "piano_felt",
        "description": "Felt piano - soft and muted",
        "genre": "Ambient, Cinematic",
        "character": "Felt piano - soft and muted",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Ambient, Cinematic | Character: Felt piano - soft and muted\ndefine_synthdef(\"piano_felt\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Piano-like harmonics\n        let h1 = sin_osc_ar(freq) * 0.5;\n        let h2 = sin_osc_ar(freq * 2.0) * 0.15;\n        let h3 = sin_osc_ar(freq * 3.0) * 0.08;\n\n        // Soft hammer attack\n        let attack = envelope()\n            .perc(0.005, 0.03)\n            .build();\n        let hammer = lpf_ar(white_noise_ar(), 800.0) * attack * 0.1;\n\n        let mix = h1 + h2 + h3 + hammer;\n\n        // Heavy felt damping\n        lpf_ar(mix, 1500.0) * env * amp\n    });\n",
        "category": "keys",
        "subcategory": "",
        "path": "keys/piano_felt.vibe"
      },
      {
        "name": "piano_toy",
        "description": "Toy piano - bright and metallic",
        "genre": "Lo-fi, Indie",
        "character": "Toy piano - bright and metallic",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Lo-fi, Indie | Character: Toy piano - bright and metallic\ndefine_synthdef(\"piano_toy\")\n    .param(\"freq\", 880.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        // Short, metallic decay\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Metallic harmonics\n        let h1 = sin_osc_ar(freq) * 0.4;\n        let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n        let h3 = sin_osc_ar(freq * 2.8) * 0.2;\n        let h4 = sin_osc_ar(freq * 4.2) * 0.12;\n\n        // Hammer click\n        let click = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let hammer = hpf_ar(white_noise_ar(), 4000.0) * click * 0.15;\n\n        let sig = h1 + h2 + h3 + h4 + hammer;\n\n        sig * amp_env * amp\n    });\n",
        "category": "keys",
        "subcategory": "",
        "path": "keys/piano_toy.vibe"
      },
      {
        "name": "pipe_organ",
        "description": "Majestic, sustained",
        "genre": "",
        "character": "Majestic, sustained",
        "params": [],
        "type": "synthdef",
        "source": "// Church instrument | Character: Majestic, sustained\ndefine_synthdef(\"pipe_organ\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.15, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Multiple pipes at different footages\n        let pipe8 = sin_osc_ar(freq) * 0.4;\n        let pipe4 = sin_osc_ar(freq * 2.0) * 0.25;\n        let pipe2 = sin_osc_ar(freq * 4.0) * 0.15;\n        let pipe16 = sin_osc_ar(freq * 0.5) * 0.3;\n\n        // Wind noise\n        let wind = lpf_ar(pink_noise_ar(), 500.0) * 0.05;\n\n        let sig = pipe8 + pipe4 + pipe2 + pipe16 + wind;\n\n        sig * env * amp\n    });\n",
        "category": "keys",
        "subcategory": "",
        "path": "keys/pipe_organ.vibe"
      },
      {
        "name": "rhodes_bright",
        "description": "Bright Rhodes electric piano",
        "genre": "Jazz, R&B, Soul",
        "character": "Bright Rhodes electric piano",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Jazz, R&B, Soul | Character: Bright Rhodes electric piano\ndefine_synthdef(\"rhodes_bright\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // FM synthesis for bell-like Rhodes tone\n        let mod_env = envelope()\n            .perc(0.001, 0.5)\n            .build();\n\n        let mod_index = 2.0 + mod_env * 4.0;\n        let modulator = sin_osc_ar(freq * 2.0) * mod_index * freq;\n        let carrier = sin_osc_ar(freq + modulator);\n\n        // Bark (attack transient)\n        let bark = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = sin_osc_ar(freq * 8.0) * bark * 0.15;\n\n        let sig = carrier * 0.6 + attack;\n\n        sig * env * amp\n    });\n",
        "category": "keys",
        "subcategory": "",
        "path": "keys/rhodes_bright.vibe"
      },
      {
        "name": "rhodes_dark",
        "description": "Dark, mellow Rhodes",
        "genre": "Jazz, Neo-Soul",
        "character": "Dark, mellow Rhodes",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Jazz, Neo-Soul | Character: Dark, mellow Rhodes\ndefine_synthdef(\"rhodes_dark\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.008, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Less FM for darker tone\n        let mod_env = envelope()\n            .perc(0.001, 0.4)\n            .build();\n\n        let mod_index = 1.0 + mod_env * 2.0;\n        let modulator = sin_osc_ar(freq * 2.0) * mod_index * freq;\n        let carrier = sin_osc_ar(freq + modulator);\n\n        // Warmer filtering\n        let sig = lpf_ar(carrier, 2500.0);\n\n        sig * env * amp\n    });\n",
        "category": "keys",
        "subcategory": "",
        "path": "keys/rhodes_dark.vibe"
      },
      {
        "name": "wurlitzer",
        "description": "Wurlitzer-style EP with characteristic bark and reed-like tone.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "drive",
            "default": 0.3
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"wurlitzer\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"drive\", 0.3) // Overdrive amount\n        .body(|freq, amp, gate, drive| {\n            // Envelope with punchy attack\n            let env = envelope()\n                .asr(0.003, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Reed-like oscillators\n            let fund = sin_osc_ar(freq);\n            let odd2 = sin_osc_ar(freq * 3.0) * 0.4;\n            let odd3 = sin_osc_ar(freq * 5.0) * 0.2;\n            let odd4 = sin_osc_ar(freq * 7.0) * 0.1;\n\n            // Characteristic wurli bark\n            let bark_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let bark = white_noise_ar() * bark_env * 0.15;\n\n            let tone = fund + odd2 + odd3 + odd4 + bark;\n\n            // Soft overdrive for warmth\n            let driven = (tone * (1.0 + drive * 3.0)).tanh();\n\n            // Bandpass for wurli character\n            let filtered = lpf_ar(hpf_ar(driven, 200.0), 4000.0);\n\n            filtered * env * amp * 0.5\n        })\n});",
        "category": "keys",
        "subcategory": "",
        "path": "keys/wurlitzer.vibe"
      }
    ]
  },
  "Leads": {
    "subcategories": {
      "Classic": [
        {
          "name": "lead_arp",
          "description": "ARP Odyssey-style lead - bright and buzzy",
          "genre": "Progressive Rock, Electronic",
          "character": "ARP Odyssey-style lead - bright and buzzy",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Progressive Rock, Electronic | Character: ARP Odyssey-style lead - bright and buzzy\ndefine_synthdef(\"lead_arp\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.005, 0.3)\n            .build();\n\n        // Two oscillators with hard sync feel\n        let osc1 = saw_ar(freq);\n        let osc2 = pulse_ar(freq * 1.01, 0.4);\n\n        // Ring mod option\n        let ring = osc1 * osc2 * 0.3;\n\n        let mix = (osc1 + osc2 + ring) * 0.3;\n\n        // Bright filter\n        let cutoff = 1500.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.3) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "classic",
          "path": "leads/classic/lead_arp.vibe"
        },
        {
          "name": "lead_cs80",
          "description": "Yamaha CS-80 brass lead - expressive and lush",
          "genre": "Cinematic, Synthwave",
          "character": "Yamaha CS-80 brass lead - expressive and lush",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Cinematic, Synthwave | Character: Yamaha CS-80 brass lead - expressive and lush\ndefine_synthdef(\"lead_cs80\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.02, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope with slow attack\n        let filt_env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .build();\n\n        // Multiple detuned oscillators for thickness\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n        let osc4 = saw_ar(freq * 1.006);\n\n        let mix = (osc1 + osc2 + osc3 + osc4) * 0.22;\n\n        // Expressive filter\n        let cutoff = 800.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "classic",
          "path": "leads/classic/lead_cs80.vibe"
        },
        {
          "name": "lead_dx7",
          "description": "DX7 FM lead - bell-like and cutting",
          "genre": "80s Pop, R&B",
          "character": "DX7 FM lead - bell-like and cutting",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: 80s Pop, R&B | Character: DX7 FM lead - bell-like and cutting\ndefine_synthdef(\"lead_dx7\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // FM index envelope\n        let mod_env = envelope()\n            .perc(0.001, 0.3)\n            .build();\n\n        // 2-operator FM\n        let mod_ratio = 2.0;\n        let mod_index = 3.0 + mod_env * 8.0;\n        let modulator = sin_osc_ar(freq * mod_ratio) * mod_index * freq;\n        let carrier = sin_osc_ar(freq + modulator);\n\n        // Second carrier for brightness\n        let mod2 = sin_osc_ar(freq * 3.0) * mod_env * freq * 2.0;\n        let carrier2 = sin_osc_ar(freq + mod2) * 0.4;\n\n        let sig = (carrier + carrier2) * 0.5;\n\n        sig * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "classic",
          "path": "leads/classic/lead_dx7.vibe"
        },
        {
          "name": "lead_juno_hoover",
          "description": "Hoover/Mentasm sound - aggressive and iconic",
          "genre": "Rave, Hardcore, Jungle",
          "character": "Hoover/Mentasm sound - aggressive and iconic",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Rave, Hardcore, Jungle | Character: Hoover/Mentasm sound - aggressive and iconic\ndefine_synthdef(\"lead_juno_hoover\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch LFO for characteristic wobble\n        let pitch_lfo = sin_osc_ar(6.0) * freq * 0.02;\n\n        // Multiple heavily detuned saws\n        let osc1 = saw_ar(freq * 0.97 + pitch_lfo);\n        let osc2 = saw_ar(freq * 0.99);\n        let osc3 = saw_ar(freq);\n        let osc4 = saw_ar(freq * 1.01);\n        let osc5 = saw_ar(freq * 1.03 + pitch_lfo * 0.5);\n\n        let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.18;\n\n        // PWM layer\n        let pwm = sin_osc_ar(0.3) * 0.3 + 0.5;\n        let pulse_layer = pulse_ar(freq * 0.5, pwm) * 0.3;\n\n        let sig = mix + pulse_layer;\n\n        // Aggressive filter\n        rlpf_ar(sig, 3000.0, 0.4) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "classic",
          "path": "leads/classic/lead_juno_hoover.vibe"
        },
        {
          "name": "lead_moog",
          "description": "Classic Minimoog lead - fat and expressive",
          "genre": "Funk, Progressive Rock",
          "character": "Classic Minimoog lead - fat and expressive",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Funk, Progressive Rock | Character: Classic Minimoog lead - fat and expressive\ndefine_synthdef(\"lead_moog\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .param(\"cutoff\", 2000.0)\n    .body(|freq, amp, gate, cutoff| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.01, 0.4)\n            .build();\n\n        // Three oscillators slightly detuned\n        let osc1 = saw_ar(freq);\n        let osc2 = saw_ar(freq * 1.005);\n        let osc3 = saw_ar(freq * 0.5); // Sub octave\n\n        let mix = (osc1 + osc2 + osc3 * 0.5) * 0.35;\n\n        // Classic Moog filter\n        let mod_cutoff = cutoff + filt_env * 3000.0;\n        let filtered = rlpf_ar(mix, mod_cutoff, 0.25);\n\n        filtered * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "classic",
          "path": "leads/classic/lead_moog.vibe"
        },
        {
          "name": "lead_ms20",
          "description": "Korg MS-20 lead - screaming and aggressive",
          "genre": "Industrial, Experimental",
          "character": "Korg MS-20 lead - screaming and aggressive",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Industrial, Experimental | Character: Korg MS-20 lead - screaming and aggressive\ndefine_synthdef(\"lead_ms20\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .param(\"drive\", 1.5)\n    .body(|freq, amp, gate, drive| {\n        let env = envelope()\n            .asr(0.002, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.002, 0.35)\n            .build();\n\n        // Dual oscillators\n        let osc1 = saw_ar(freq);\n        let osc2 = pulse_ar(freq * 1.005, 0.3);\n\n        let mix = (osc1 + osc2) * 0.4;\n\n        // MS-20 style - HP then LP with drive\n        let hp = hpf_ar(mix, 100.0);\n        let driven = (hp * drive).tanh();\n\n        // Aggressive resonant filter\n        let cutoff = 800.0 + filt_env * 5000.0;\n        rlpf_ar(driven, cutoff, 0.5) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "classic",
          "path": "leads/classic/lead_ms20.vibe"
        },
        {
          "name": "lead_prophet",
          "description": "Prophet-5 lead - lush and expressive",
          "genre": "Synthpop, New Wave",
          "character": "Prophet-5 lead - lush and expressive",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Synthpop, New Wave | Character: Prophet-5 lead - lush and expressive\ndefine_synthdef(\"lead_prophet\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.008, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.008, 0.35)\n            .build();\n\n        // Two oscillators detuned\n        let osc1 = saw_ar(freq);\n        let osc2 = saw_ar(freq * 1.008);\n        let pulse_osc = pulse_ar(freq, 0.45) * 0.5;\n\n        let mix = (osc1 + osc2 + pulse_osc) * 0.3;\n\n        // Lush filter\n        let cutoff = 1200.0 + filt_env * 3000.0;\n        rlpf_ar(mix, cutoff, 0.2) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "classic",
          "path": "leads/classic/lead_prophet.vibe"
        },
        {
          "name": "lead_sh101",
          "description": "Roland SH-101 lead - clean and versatile",
          "genre": "Acid, Techno, Synthpop",
          "character": "Roland SH-101 lead - clean and versatile",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Acid, Techno, Synthpop | Character: Roland SH-101 lead - clean and versatile\ndefine_synthdef(\"lead_sh101\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .param(\"pw\", 0.5)\n    .body(|freq, amp, gate, pw| {\n        let env = envelope()\n            .asr(0.003, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.003, 0.25)\n            .build();\n\n        // Single oscillator with selectable wave\n        let osc = pulse_ar(freq, pw);\n        let sub = pulse_ar(freq * 0.5, 0.5) * 0.3;\n\n        let mix = (osc + sub) * 0.45;\n\n        // Classic 101 filter\n        let cutoff = 1000.0 + filt_env * 3500.0;\n        rlpf_ar(mix, cutoff, 0.35) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "classic",
          "path": "leads/classic/lead_sh101.vibe"
        }
      ],
      "Modern": [
        {
          "name": "lead_complextro",
          "description": "Complextro lead - glitchy and dynamic",
          "genre": "Complextro, Electro House",
          "character": "Complextro lead - glitchy and dynamic",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Complextro, Electro House | Character: Complextro lead - glitchy and dynamic\ndefine_synthdef(\"lead_complextro\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.05)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n\n        // Multiple waveforms\n        let saw = saw_ar(freq) * 0.4;\n        let pulse = pulse_ar(freq, 0.3) * 0.3;\n        let square = pulse_ar(freq, 0.5) * 0.2;\n\n        // Bit reduction effect\n        let mix = saw + pulse + square;\n        let crushed = (mix * 8.0).floor() / 8.0 * 0.3;\n\n        let sig = mix * 0.7 + crushed;\n\n        // Sharp, punchy filter\n        let cutoff = 1000.0 + filt_env * 5000.0;\n        rlpf_ar(sig, cutoff, 0.4) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "modern",
          "path": "leads/modern/lead_complextro.vibe"
        },
        {
          "name": "lead_future_bass",
          "description": "Future bass lead - bright and wobbly",
          "genre": "Future Bass, Kawaii",
          "character": "Future bass lead - bright and wobbly",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Future Bass, Kawaii | Character: Future bass lead - bright and wobbly\ndefine_synthdef(\"lead_future_bass\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Wobble LFO\n        let wobble = sin_osc_ar(6.0) * 0.5 + 0.5;\n\n        // Bright supersaws\n        let saw1 = saw_ar(freq * 0.995);\n        let saw2 = saw_ar(freq);\n        let saw3 = saw_ar(freq * 1.005);\n        let saw4 = saw_ar(freq * 2.0) * 0.3; // Octave\n\n        let mix = (saw1 + saw2 + saw3 + saw4) * 0.25;\n\n        // Wobbling filter\n        let cutoff = 2000.0 + wobble * 4000.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "modern",
          "path": "leads/modern/lead_future_bass.vibe"
        },
        {
          "name": "lead_hardstyle",
          "description": "Hardstyle screech lead",
          "genre": "Hardstyle, Hardcore",
          "character": "Hardstyle screech lead",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Hardstyle, Hardcore | Character: Hardstyle screech lead\ndefine_synthdef(\"lead_hardstyle\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope for screech\n        let filt_env = envelope()\n            .perc(0.001, 0.4)\n            .build();\n\n        // Detuned saws\n        let osc1 = saw_ar(freq * 0.99);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.01);\n\n        let mix = (osc1 + osc2 + osc3) * 0.35;\n\n        // Aggressive resonant filter (the screech)\n        let cutoff = 1000.0 + filt_env * 6000.0;\n        let filtered = rlpf_ar(mix, cutoff, 0.6);\n\n        // Distortion\n        (filtered * 2.0).tanh() * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "modern",
          "path": "leads/modern/lead_hardstyle.vibe"
        },
        {
          "name": "lead_neuro",
          "description": "Neurofunk lead - aggressive and morphing",
          "genre": "Neurofunk, Drum & Bass",
          "character": "Neurofunk lead - aggressive and morphing",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Neurofunk, Drum & Bass | Character: Neurofunk lead - aggressive and morphing\ndefine_synthdef(\"lead_neuro\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .param(\"morph\", 0.5)\n    .body(|freq, amp, gate, morph| {\n        let env = envelope()\n            .asr(0.002, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // LFO for morphing\n        let morph_lfo = sin_osc_ar(4.0 + morph * 8.0) * 0.5 + 0.5;\n\n        // FM modulation\n        let mod_amount = morph_lfo * morph * 10.0;\n        let modulator = sin_osc_ar(freq * 2.0) * mod_amount * freq;\n        let carrier = saw_ar(freq + modulator);\n\n        // Ring mod layer\n        let ring = carrier * sin_osc_ar(freq * 1.5) * morph;\n\n        let mix = (carrier + ring) * 0.4;\n\n        // Aggressive filtered\n        let cutoff = 500.0 + morph_lfo * 4000.0;\n        let filtered = rlpf_ar(mix, cutoff, 0.4 + morph * 0.3);\n\n        (filtered * 1.5).tanh() * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "modern",
          "path": "leads/modern/lead_neuro.vibe"
        },
        {
          "name": "lead_progressive",
          "description": "Progressive lead - smooth and evolving",
          "genre": "Progressive House, Melodic Techno",
          "character": "Progressive lead - smooth and evolving",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Progressive House, Melodic Techno | Character: Progressive lead - smooth and evolving\ndefine_synthdef(\"lead_progressive\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.03, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow filter envelope\n        let filt_env = envelope()\n            .asr(0.2, 1.0, 0.3)\n            .gate(gate)\n            .build();\n\n        // Slightly detuned for width\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n\n        let mix = (osc1 + osc2 + osc3) * 0.3;\n\n        // Smooth, evolving filter\n        let cutoff = 800.0 + filt_env * 3000.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "modern",
          "path": "leads/modern/lead_progressive.vibe"
        },
        {
          "name": "lead_psytrance",
          "description": "Psytrance acid lead - hypnotic and squelchy",
          "genre": "Psytrance, Goa",
          "character": "Psytrance acid lead - hypnotic and squelchy",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Psytrance, Goa | Character: Psytrance acid lead - hypnotic and squelchy\ndefine_synthdef(\"lead_psytrance\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .param(\"acid\", 0.7)\n    .body(|freq, amp, gate, acid| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Accent/filter envelope\n        let filt_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n\n        // Saw oscillator\n        let osc = saw_ar(freq);\n\n        // Sub for power\n        let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n        let mix = (osc + sub) * 0.5;\n\n        // Acid filter with high resonance\n        let cutoff = 400.0 + filt_env * acid * 5000.0;\n        let res = 0.3 + acid * 0.4;\n        rlpf_ar(mix, cutoff, res) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "modern",
          "path": "leads/modern/lead_psytrance.vibe"
        },
        {
          "name": "lead_trance",
          "description": "Trance supersaw lead - massive and euphoric",
          "genre": "Trance, Progressive",
          "character": "Trance supersaw lead - massive and euphoric",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Trance, Progressive | Character: Trance supersaw lead - massive and euphoric\ndefine_synthdef(\"lead_trance\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.015, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .asr(0.05, 1.0, 0.15)\n            .gate(gate)\n            .build();\n\n        // 7 detuned oscillators for supersaw\n        let osc1 = saw_ar(freq * 0.985);\n        let osc2 = saw_ar(freq * 0.992);\n        let osc3 = saw_ar(freq * 0.998);\n        let osc4 = saw_ar(freq);\n        let osc5 = saw_ar(freq * 1.002);\n        let osc6 = saw_ar(freq * 1.008);\n        let osc7 = saw_ar(freq * 1.015);\n\n        let mix = (osc1 + osc2 + osc3 + osc4 + osc5 + osc6 + osc7) * 0.14;\n\n        // Euphoric filter\n        let cutoff = 1500.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.12) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "modern",
          "path": "leads/modern/lead_trance.vibe"
        }
      ],
      "Organic": [
        {
          "name": "lead_bitcrushed",
          "description": "Bitcrushed lo-fi lead",
          "genre": "Chiptune, Lo-fi",
          "character": "Bitcrushed lo-fi lead",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Chiptune, Lo-fi | Character: Bitcrushed lo-fi lead\ndefine_synthdef(\"lead_bitcrushed\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .param(\"bits\", 8.0)\n    .body(|freq, amp, gate, bits| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Source oscillator\n        let osc = saw_ar(freq);\n\n        // Bit reduction\n        let levels = (2.0).pow(bits);\n        let crushed = (osc * levels).floor() / levels;\n\n        crushed * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "organic",
          "path": "leads/organic/lead_bitcrushed.vibe"
        },
        {
          "name": "lead_flute",
          "description": "Synth flute - breathy and soft",
          "genre": "Ambient, World, Electronic",
          "character": "Synth flute - breathy and soft",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Ambient, World, Electronic | Character: Synth flute - breathy and soft\ndefine_synthdef(\"lead_flute\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.08, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.0) * freq * 0.01;\n\n        // Main tone with harmonics\n        let body = sin_osc_ar(freq + vib) * 0.5;\n        let harm1 = sin_osc_ar((freq + vib) * 2.0) * 0.2;\n        let harm2 = sin_osc_ar((freq + vib) * 3.0) * 0.08;\n\n        // Breath noise\n        let breath_e = envelope()\n            .asr(0.1, 0.6, 0.15)\n            .gate(gate)\n            .build();\n        let breath = bpf_ar(pink_noise_ar(), freq * 1.5, 0.8) * breath_e * 0.2;\n\n        let sig = body + harm1 + harm2 + breath;\n\n        sig * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "organic",
          "path": "leads/organic/lead_flute.vibe"
        },
        {
          "name": "lead_granular",
          "description": "Granular lead texture",
          "genre": "Ambient, Experimental",
          "character": "Granular lead texture",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Ambient, Experimental | Character: Granular lead texture\ndefine_synthdef(\"lead_granular\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .param(\"density\", 0.5)\n    .body(|freq, amp, gate, density| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Base tone\n        let base = sin_osc_ar(freq) * 0.4;\n\n        // Grain-like modulations\n        let grain_rate = 10.0 + density * 40.0;\n        let grain_mod = sin_osc_ar(grain_rate) * 0.5 + 0.5;\n\n        let grain1 = sin_osc_ar(freq * 1.002) * grain_mod * 0.2;\n        let grain2 = sin_osc_ar(freq * 0.998) * (1.0 - grain_mod) * 0.2;\n\n        // Random pitch deviations\n        let dust_mod = dust_ar(grain_rate * 2.0) * freq * 0.01;\n        let grain3 = sin_osc_ar(freq + dust_mod) * 0.15;\n\n        let sig = base + grain1 + grain2 + grain3;\n\n        sig * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "organic",
          "path": "leads/organic/lead_granular.vibe"
        },
        {
          "name": "lead_tape",
          "description": "Tape-saturated warm lead",
          "genre": "Lo-fi, Synthwave",
          "character": "Tape-saturated warm lead",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Lo-fi, Synthwave | Character: Tape-saturated warm lead\ndefine_synthdef(\"lead_tape\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Tape wow/flutter\n        let wow = sin_osc_ar(0.4) * freq * 0.003;\n        let flutter = sin_osc_ar(6.0) * freq * 0.001;\n\n        // Slightly detuned oscillators\n        let osc1 = saw_ar(freq + wow + flutter);\n        let osc2 = saw_ar(freq * 1.003 + wow);\n\n        let mix = (osc1 + osc2) * 0.4;\n\n        // Tape saturation\n        let saturated = (mix * 1.5).tanh();\n\n        // Warm filtering (rolled off highs)\n        lpf_ar(saturated, 4000.0) * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "organic",
          "path": "leads/organic/lead_tape.vibe"
        },
        {
          "name": "lead_theremin",
          "description": "Theremin emulation - eerie and wavering",
          "genre": "Experimental, Soundtrack",
          "character": "Theremin emulation - eerie and wavering",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Experimental, Soundtrack | Character: Theremin emulation - eerie and wavering\ndefine_synthdef(\"lead_theremin\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Characteristic wavering vibrato\n        let vib1 = sin_osc_ar(6.0) * freq * 0.015;\n        let vib2 = sin_osc_ar(0.5) * freq * 0.008;\n\n        // Pure sine tone\n        let body = sin_osc_ar(freq + vib1 + vib2);\n\n        body * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "organic",
          "path": "leads/organic/lead_theremin.vibe"
        },
        {
          "name": "lead_vocal",
          "description": "Vocal synth lead - human-like formants",
          "genre": "Electronic, Synthpop",
          "character": "Vocal synth lead - human-like formants",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Electronic, Synthpop | Character: Vocal synth lead - human-like formants\ndefine_synthdef(\"lead_vocal\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .param(\"vowel\", 0.5)\n    .body(|freq, amp, gate, vowel| {\n        let env = envelope()\n            .asr(0.02, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.008;\n\n        // Rich harmonic source\n        let osc = saw_ar(freq + vib) * 0.5;\n\n        // Formant frequencies based on vowel\n        let f1 = 400.0 + vowel * 400.0;\n        let f2 = 1000.0 + vowel * 1000.0;\n        let f3 = 2500.0 + vowel * 500.0;\n\n        // Formant filters\n        let form1 = bpf_ar(osc, f1, 0.12) * 0.5;\n        let form2 = bpf_ar(osc, f2, 0.15) * 0.3;\n        let form3 = bpf_ar(osc, f3, 0.2) * 0.15;\n\n        let sig = form1 + form2 + form3;\n\n        sig * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "organic",
          "path": "leads/organic/lead_vocal.vibe"
        },
        {
          "name": "lead_whistle",
          "description": "Synth whistle - pure and expressive",
          "genre": "Electronic, World",
          "character": "Synth whistle - pure and expressive",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Electronic, World | Character: Synth whistle - pure and expressive\ndefine_synthdef(\"lead_whistle\")\n    .param(\"freq\", 880.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slight vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.012;\n\n        // Pure sine with breath noise\n        let body = sin_osc_ar(freq + vib) * 0.7;\n\n        // Breath component\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.0, 0.5) * 0.15;\n\n        let sig = body + breath;\n\n        sig * env * amp\n    });\n",
          "category": "leads",
          "subcategory": "organic",
          "path": "leads/organic/lead_whistle.vibe"
        }
      ],
      "Pluck": [
        {
          "name": "lead_pluck_bell",
          "description": "Genre: Ambient, Experimental | Character: Bell-like with inharmonic overtones",
          "genre": "Ambient, Experimental",
          "character": "Bell-like with inharmonic overtones",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_pluck_bell\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Bell envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Inharmonic partials for bell character\n            let partial1 = sin_osc_ar(freq) * 0.6;\n            let partial2 = sin_osc_ar(freq * 2.4) * 0.3;\n            let partial3 = sin_osc_ar(freq * 3.8) * 0.15;\n            let partial4 = sin_osc_ar(freq * 5.3) * 0.08;\n\n            let mix = partial1 + partial2 + partial3 + partial4;\n\n            // Gentle filter\n            let filtered = lpf_ar(mix, 4000.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "pluck",
          "path": "leads/pluck/pluck_bell.vibe"
        },
        {
          "name": "lead_pluck_bright",
          "description": "Genre: House, Pop | Character: Bright, shimmering pluck lead",
          "genre": "House, Pop",
          "character": "Bright, shimmering pluck lead",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_pluck_bright\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Quick attack, medium decay\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let harmonic4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n            let mix = fundamental + harmonic2 + harmonic3 + harmonic4;\n\n            // Filter sweep\n            let filter_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 2000.0 + (filter_env * 5000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "pluck",
          "path": "leads/pluck/pluck_bright.vibe"
        },
        {
          "name": "pluck_harp",
          "description": "Genre: Ambient, Classical | Character: Harp-like pluck",
          "genre": "Ambient, Classical",
          "character": "Harp-like pluck",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pluck_harp\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Harp envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Rich harmonic series\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.25;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.125;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.08;\n\n            let mix = h1 + h2 + h3 + h4 + h5;\n\n            // Pluck attack\n            let attack_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let attack = pink_noise_ar() * attack_env * 0.12;\n            let filtered_attack = lpf_ar(attack, 3000.0);\n\n            (mix + filtered_attack) * env * amp * 0.7\n        })\n});",
          "category": "leads",
          "subcategory": "pluck",
          "path": "leads/pluck/pluck_harp.vibe"
        },
        {
          "name": "pluck_kalimba",
          "description": "Genre: World, Ambient | Character: Kalimba/thumb piano sound",
          "genre": "World, Ambient",
          "character": "Kalimba/thumb piano sound",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pluck_kalimba\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Quick attack, medium decay\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 3.0) * 0.3;\n            let harmonic3 = sin_osc_ar(freq * 6.0) * 0.15;\n\n            // Add subtle noise for pluck attack\n            let attack_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let attack = pink_noise_ar() * attack_env * 0.08;\n            let filtered_attack = hpf_ar(attack, 2000.0);\n\n            let mix = fundamental + harmonic2 + harmonic3 + filtered_attack;\n\n            mix * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "pluck",
          "path": "leads/pluck/pluck_kalimba.vibe"
        },
        {
          "name": "lead_pluck_long",
          "description": "Genre: Ambient, Chillout | Character: Long, sustained pluck",
          "genre": "Ambient, Chillout",
          "character": "Long, sustained pluck",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_pluck_long\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Long sustain\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Rich harmonics\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.35;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.12;\n\n            let mix = h1 + h2 + h3 + h4;\n\n            // Slow filter evolution\n            let filter_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1200.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "pluck",
          "path": "leads/pluck/pluck_long.vibe"
        },
        {
          "name": "pluck_marimba",
          "description": "Genre: World, Ambient | Character: Marimba-like, wooden timbre",
          "genre": "World, Ambient",
          "character": "Marimba-like, wooden timbre",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pluck_marimba\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Marimba envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Woody timbre with specific harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 4.0) * 0.25;\n            let harmonic3 = sin_osc_ar(freq * 5.4) * 0.15;\n\n            let mix = fundamental + harmonic2 + harmonic3;\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "pluck",
          "path": "leads/pluck/pluck_marimba.vibe"
        },
        {
          "name": "lead_pluck_muted",
          "description": "Genre: Lo-fi, Jazz | Character: Muted, soft pluck",
          "genre": "Lo-fi, Jazz",
          "character": "Muted, soft pluck",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_pluck_muted\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Soft envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Warm harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.2;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.1;\n\n            let mix = fundamental + harmonic2 + harmonic3;\n\n            // Low filter for muted character\n            let filtered = lpf_ar(mix, 1200.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "pluck",
          "path": "leads/pluck/pluck_muted.vibe"
        },
        {
          "name": "pluck_piano",
          "description": "Genre: All | Character: Piano-like pluck",
          "genre": "All",
          "character": "Piano-like pluck",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pluck_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Piano envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Complex harmonic structure\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.25;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.1;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.05;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Hammer attack\n            let attack_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let hammer = white_noise_ar() * attack_env * 0.15;\n            let filtered_hammer = lpf_ar(hammer, 4000.0);\n\n            (harmonics + filtered_hammer) * env * amp * 0.7\n        })\n});",
          "category": "leads",
          "subcategory": "pluck",
          "path": "leads/pluck/pluck_piano.vibe"
        },
        {
          "name": "lead_pluck_resonant",
          "description": "Genre: Techno, House | Character: Resonant pluck with filter character",
          "genre": "Techno, House",
          "character": "Resonant pluck with filter character",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_pluck_resonant\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Medium envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth for resonant filtering\n            let osc = saw_ar(freq);\n\n            // Resonant filter sweep\n            let filter_env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 3500.0);\n\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "pluck",
          "path": "leads/pluck/pluck_resonant.vibe"
        },
        {
          "name": "lead_pluck_short",
          "description": "Genre: Minimal, House | Character: Very short, staccato pluck",
          "genre": "Minimal, House",
          "character": "Very short, staccato pluck",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_pluck_short\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very short envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simple harmonics for clarity\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.3;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.15;\n\n            let mix = fundamental + harmonic2 + harmonic3;\n\n            // Fast filter sweep\n            let filter_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 3500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "pluck",
          "path": "leads/pluck/pluck_short.vibe"
        }
      ],
      "Stabs": [
        {
          "name": "stab_brass",
          "description": "Genre: House, Funk | Character: Brass-like stab",
          "genre": "House, Funk",
          "character": "Brass-like stab",
          "params": [
            {
              "name": "freq",
              "default": 330
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stab_brass\", |builder| {\n    builder\n        .param(\"freq\", 330.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Brass-like envelope with bite\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chord with harmonics\n            let root = saw_ar(freq);\n            let third = saw_ar(freq * 1.25);\n            let fifth = saw_ar(freq * 1.5);\n            let seventh = saw_ar(freq * 1.75);\n\n            let chord = (root + third * 0.7 + fifth * 0.6 + seventh * 0.4) * 0.35;\n\n            // Brass-like filter\n            let filter_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1200.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "stabs",
          "path": "leads/stabs/stab_brass.vibe"
        },
        {
          "name": "stab_bright",
          "description": "Genre: House, Techno | Character: Bright synth stab for emphasis",
          "genre": "House, Techno",
          "character": "Bright synth stab for emphasis",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stab_bright\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Sharp, quick envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chord (root, fifth, octave)\n            let root = saw_ar(freq);\n            let fifth = saw_ar(freq * 1.5);\n            let octave = saw_ar(freq * 2.0);\n\n            let chord = (root + fifth * 0.8 + octave * 0.6) * 0.4;\n\n            // Filter sweep\n            let filter_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 2000.0 + (filter_env * 4000.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "stabs",
          "path": "leads/stabs/stab_bright.vibe"
        },
        {
          "name": "stab_dark",
          "description": "Genre: Techno, Industrial | Character: Dark, aggressive stab",
          "genre": "Techno, Industrial",
          "character": "Dark, aggressive stab",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stab_dark\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Quick envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Minor chord (root, minor third, fifth)\n            let root = saw_ar(freq);\n            let minor_third = saw_ar(freq * 1.2);\n            let fifth = saw_ar(freq * 1.5);\n\n            let chord = (root + minor_third * 0.8 + fifth * 0.6) * 0.4;\n\n            // Dark filter\n            let filter_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 600.0 + (filter_env * 1500.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "stabs",
          "path": "leads/stabs/stab_dark.vibe"
        },
        {
          "name": "stab_distorted",
          "description": "Genre: Industrial, Hard Techno | Character: Distorted, aggressive stab",
          "genre": "Industrial, Hard Techno",
          "character": "Distorted, aggressive stab",
          "params": [
            {
              "name": "freq",
              "default": 330
            },
            {
              "name": "amp",
              "default": 0.65
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stab_distorted\", |builder| {\n    builder\n        .param(\"freq\", 330.0)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Aggressive envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chord\n            let root = saw_ar(freq);\n            let fifth = saw_ar(freq * 1.5);\n            let octave = saw_ar(freq * 2.0);\n\n            let chord = (root + fifth * 0.8 + octave * 0.6) * 0.6;\n\n            // Distortion\n            let driven = clip(chord, -0.8, 0.8);\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1000.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(driven, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "stabs",
          "path": "leads/stabs/stab_distorted.vibe"
        },
        {
          "name": "stab_orchestral",
          "description": "Genre: Cinematic, Orchestral | Character: Orchestral string stab",
          "genre": "Cinematic, Orchestral",
          "character": "Orchestral string stab",
          "params": [
            {
              "name": "freq",
              "default": 330
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stab_orchestral\", |builder| {\n    builder\n        .param(\"freq\", 330.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // String-like envelope with bow attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Rich chord\n            let root = saw_ar(freq);\n            let third = saw_ar(freq * 1.25);\n            let fifth = saw_ar(freq * 1.5);\n            let octave = saw_ar(freq * 2.0);\n\n            let chord = (root + third * 0.8 + fifth * 0.7 + octave * 0.5) * 0.35;\n\n            // String-like filter\n            let filter_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1200.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            // Remove mud\n            let clean = hpf_ar(filtered, 150.0);\n\n            clean * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "stabs",
          "path": "leads/stabs/stab_orchestral.vibe"
        },
        {
          "name": "stab_piano",
          "description": "Genre: House, Garage | Character: Piano-like chord stab",
          "genre": "House, Garage",
          "character": "Piano-like chord stab",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.7
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stab_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Piano-like envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chord with harmonics\n            let r1 = sin_osc_ar(freq);\n            let r2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let r3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let root = r1 + r2 + r3;\n\n            let f1 = sin_osc_ar(freq * 1.5);\n            let f2 = sin_osc_ar(freq * 3.0) * 0.3;\n            let fifth = f1 + f2;\n\n            let chord = (root + fifth * 0.7) * 0.45;\n\n            // Attack transient\n            let attack_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.12;\n            let filtered_attack = lpf_ar(attack, 4000.0);\n\n            (chord + filtered_attack) * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "stabs",
          "path": "leads/stabs/stab_piano.vibe"
        },
        {
          "name": "stab_short",
          "description": "Genre: Techno, Minimal | Character: Very short, percussive stab",
          "genre": "Techno, Minimal",
          "character": "Very short, percussive stab",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.75
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stab_short\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.75)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very short envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.0005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simple chord\n            let root = saw_ar(freq);\n            let fifth = saw_ar(freq * 1.5);\n\n            let chord = (root + fifth * 0.7) * 0.5;\n\n            // Fast filter sweep\n            let filter_env = envelope()\n                .asr(0.0005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 3500.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "stabs",
          "path": "leads/stabs/stab_short.vibe"
        },
        {
          "name": "stab_super",
          "description": "Genre: Trance, EDM | Character: Supersaw stab, wide and powerful",
          "genre": "Trance, EDM",
          "character": "Supersaw stab, wide and powerful",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"stab_super\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Punchy envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned chord for width\n            let r1 = saw_ar(freq * 0.995);\n            let r2 = saw_ar(freq * 1.005);\n            let f1 = saw_ar(freq * 1.495);\n            let f2 = saw_ar(freq * 1.505);\n            let o1 = saw_ar(freq * 1.995);\n            let o2 = saw_ar(freq * 2.005);\n\n            let chord = (r1 + r2 + f1 * 0.7 + f2 * 0.7 + o1 * 0.5 + o2 * 0.5) * 0.25;\n\n            // Bright filter sweep\n            let filter_env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 4500.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "stabs",
          "path": "leads/stabs/stab_super.vibe"
        }
      ],
      "Synth": [
        {
          "name": "lead_aggressive",
          "description": "Genre: Hard Techno, Industrial | Character: Aggressive, distorted lead",
          "genre": "Hard Techno, Industrial",
          "character": "Aggressive, distorted lead",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Aggressive envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Overdriven saws\n            let saw1 = saw_ar(freq * 0.995) * 1.8;\n            let saw2 = saw_ar(freq * 1.005) * 1.8;\n            let mix = (saw1 + saw2) * 0.5;\n\n            // Clip for distortion\n            let distorted = clip(mix, -0.8, 0.8);\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 3500.0);\n\n            let filtered = lpf_ar(distorted, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "synth",
          "path": "leads/synth/lead_aggressive.vibe"
        },
        {
          "name": "lead_bright",
          "description": "Bright, energetic lead",
          "genre": "Trance, Progressive",
          "character": "Bright, energetic lead",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Trance, Progressive | Character: Bright, energetic lead\ndefine_synthdef(\"lead_bright\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n\n        // Envelope\n        // Gate-controlled ASR envelope for proper note-on/note-off behavior\n        let env = envelope()\n            .asr(0.01, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright sawtooth mix\n        let saw = saw_ar(freq);\n        let harmonic = saw_ar(freq * 2.0) * 0.3;\n        let mix = saw + harmonic;\n\n        // High-pass for extra brightness\n        let hp = hpf_ar(mix, 200.0);\n\n        // Filter\n        let filter_env = envelope()\n            .asr(0.03, 1.0, 0.1)\n            .gate(gate)\n            .build();\n        let mod_cutoff = 2000.0 + (filter_env * 4000.0);\n\n        let filtered = lpf_ar(hp, mod_cutoff);\n\n        filtered * env * amp\n    });\n\n",
          "category": "leads",
          "subcategory": "synth",
          "path": "leads/synth/lead_bright.vibe"
        },
        {
          "name": "lead_dark",
          "description": "Genre: Techno, Industrial | Character: Dark, moody lead",
          "genre": "Techno, Industrial",
          "character": "Dark, moody lead",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.6
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_dark\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix of saw and pulse for darker timbre\n            let saw = saw_ar(freq) * 0.5;\n            let pulse = saw_ar(freq) * 0.5;\n            let mix = saw + pulse;\n\n            // Dark filter range\n            let filter_env = envelope()\n                .asr(0.15, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 400.0 + (filter_env * 1500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "synth",
          "path": "leads/synth/lead_dark.vibe"
        },
        {
          "name": "lead_detuned",
          "description": "Genre: House, Techno | Character: Detuned lead with chorus effect",
          "genre": "House, Techno",
          "character": "Detuned lead with chorus effect",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_detuned\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Wide detuning for chorus\n            let osc1 = saw_ar(freq * 0.985);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.015);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1400.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "synth",
          "path": "leads/synth/lead_detuned.vibe"
        },
        {
          "name": "lead_filtered",
          "description": "Genre: Techno, Minimal | Character: Heavily filtered lead",
          "genre": "Techno, Minimal",
          "character": "Heavily filtered lead",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_filtered\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Resonant filter with sweep\n            let filter_env = envelope()\n                .asr(0.1, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 600.0 + (filter_env * 2500.0);\n\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "synth",
          "path": "leads/synth/lead_filtered.vibe"
        },
        {
          "name": "lead_pwm",
          "description": "Genre: Synthwave, Electro | Character: Pulse width modulation lead",
          "genre": "Synthwave, Electro",
          "character": "Pulse width modulation lead",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_pwm\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // PWM envelope - modulate pulse width\n            let pwm_env = envelope()\n                .asr(0.1, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let width = 0.2 + (pwm_env * 0.6);\n\n            // Pulse wave with width as f64 constant (approximation)\n            // Using two pulses with different widths for movement\n            let pulse1 = saw_ar(freq);\n            let pulse2 = saw_ar(freq);\n            let mix = (pulse1 + pulse2) * 0.5;\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1300.0 + (filter_env * 2800.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "synth",
          "path": "leads/synth/lead_pwm.vibe"
        },
        {
          "name": "lead_saw",
          "description": "Genre: Trance, House | Character: Classic saw lead, bright and cutting",
          "genre": "Trance, House",
          "character": "Classic saw lead, bright and cutting",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_saw\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Lead envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slightly detuned saws\n            let saw1 = saw_ar(freq * 0.998);\n            let saw2 = saw_ar(freq * 1.002);\n            let mix = (saw1 + saw2) * 0.5;\n\n            // Filter envelope for movement\n            let filter_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1200.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "synth",
          "path": "leads/synth/lead_saw.vibe"
        },
        {
          "name": "lead_smooth",
          "description": "Genre: Ambient, Chillout | Character: Smooth, gentle lead",
          "genre": "Ambient, Chillout",
          "character": "Smooth, gentle lead",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_smooth\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Soft envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sine with subtle harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.15;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.08;\n\n            let mix = fundamental + harmonic2 + harmonic3;\n\n            // Gentle filter\n            let filtered = lpf_ar(mix, 3000.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "synth",
          "path": "leads/synth/lead_smooth.vibe"
        },
        {
          "name": "lead_square",
          "description": "Genre: Electro, Synthwave | Character: Square wave lead, hollow and vintage",
          "genre": "Electro, Synthwave",
          "character": "Square wave lead, hollow and vintage",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.5
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_square\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Square waves (pulse with 0.5 width)\n            let square1 = saw_ar(freq * 0.999);\n            let square2 = saw_ar(freq * 1.001);\n            let mix = (square1 + square2) * 0.5;\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "synth",
          "path": "leads/synth/lead_square.vibe"
        },
        {
          "name": "lead_supersaw",
          "description": "Genre: Trance, EDM | Character: Massive supersaw, wide and powerful",
          "genre": "Trance, EDM",
          "character": "Massive supersaw, wide and powerful",
          "params": [
            {
              "name": "freq",
              "default": 440
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"lead_supersaw\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned saws\n            let saw1 = saw_ar(freq * 0.990);\n            let saw2 = saw_ar(freq * 0.996);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.004);\n            let saw5 = saw_ar(freq * 1.010);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.2;\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.1, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1000.0 + (filter_env * 4000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "leads",
          "subcategory": "synth",
          "path": "leads/synth/lead_supersaw.vibe"
        }
      ]
    },
    "items": []
  },
  "Modern": {
    "subcategories": {},
    "items": [
      {
        "name": "dubstep_wobble",
        "description": "Classic LFO wobble",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 55
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "rate",
            "default": 4
          },
          {
            "name": "intensity",
            "default": 0.8
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"dubstep_wobble\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"rate\", 4.0) // Wobble rate\n        .param(\"intensity\", 0.8)\n        .body(|freq, amp, gate, rate, intensity| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bass oscillator\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.005);\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let mix = (saw1 + saw2) * 0.4 + sub;\n\n            // LFO for wobble\n            let lfo = sin_osc_ar(rate);\n            let filter_freq = 200.0 + (lfo * 0.5 + 0.5) * intensity * 3000.0;\n\n            // Resonant filter sweep\n            let filtered = rlpf_ar(mix, filter_freq, 0.25);\n\n            // Add some grit\n            let grit = (filtered * 1.5).tanh();\n\n            grit * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/dubstep.vibe"
      },
      {
        "name": "dubstep_growl",
        "description": "Aggressive FM growl",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 55
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "aggression",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"dubstep_growl\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"aggression\", 0.7)\n        .body(|freq, amp, gate, aggression| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM growl synthesis\n            let mod_depth = aggression * 5.0;\n            let modulator1 = sin_osc_ar(freq * 2.0) * mod_depth;\n            let modulator2 = sin_osc_ar(freq * 3.0) * mod_depth * 0.5;\n\n            let carrier = sin_osc_ar(freq + modulator1 + modulator2);\n\n            // Sub layer\n            let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n            let growl = carrier + sub;\n\n            // Heavy distortion\n            let dist = (growl * (2.0 + aggression * 3.0)).tanh();\n\n            // Filter for tone shaping\n            let filtered = lpf_ar(dist, 4000.0);\n\n            filtered * env * amp * 0.7\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/dubstep.vibe"
      },
      {
        "name": "dubstep_riddim",
        "description": "Minimal riddim bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 55
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"dubstep_riddim\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Short filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n\n            // Simple saw bass\n            let saw = saw_ar(freq);\n            let sub = sin_osc_ar(freq * 0.5) * 0.5;\n\n            let mix = saw * 0.6 + sub;\n\n            // Sharp filter sweep\n            let cutoff = 150.0 + filt_env * 2500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.3);\n\n            // Distortion\n            let dist = (filtered * 2.0).tanh();\n\n            dist * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/dubstep.vibe"
      },
      {
        "name": "dubstep_snare",
        "description": "Heavy layered snare",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 180
          },
          {
            "name": "amp",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"dubstep_snare\", |builder| {\n    builder\n        .param(\"freq\", 180.0)\n        .param(\"amp\", 0.7)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.25)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch sweep\n            let pitch_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n\n            // Body\n            let body = sin_osc_ar(freq + pitch_env * 100.0);\n\n            // Noise layer\n            let noise = white_noise_ar();\n            let filtered_noise = lpf_ar(hpf_ar(noise, 1500.0), 8000.0);\n\n            // Distorted mix\n            let mix = body * 0.4 + filtered_noise * 0.6;\n            let dist = (mix * 2.0).tanh();\n\n            dist * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/dubstep.vibe"
      },
      {
        "name": "dubstep_chord",
        "description": "Massive saw chord",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"dubstep_chord\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Massive detuned stack\n            let spread = 0.02;\n            let v1 = saw_ar(freq * (1.0 - spread * 2.0));\n            let v2 = saw_ar(freq * (1.0 - spread));\n            let v3 = saw_ar(freq);\n            let v4 = saw_ar(freq * (1.0 + spread));\n            let v5 = saw_ar(freq * (1.0 + spread * 2.0));\n\n            let mix = (v1 + v2 + v3 + v4 + v5) * 0.22;\n\n            // Aggressive filter\n            let filtered = rlpf_ar(mix, 5000.0, 0.35);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/dubstep.vibe"
      },
      {
        "name": "future_chord",
        "description": "Iconic supersaws",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "width",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"future_chord\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"width\", 0.6)\n        .body(|freq, amp, gate, width| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Supersaw stack\n            let spread = width * 0.025;\n            let v1 = saw_ar(freq * (1.0 - spread * 2.0));\n            let v2 = saw_ar(freq * (1.0 - spread));\n            let v3 = saw_ar(freq);\n            let v4 = saw_ar(freq * (1.0 + spread));\n            let v5 = saw_ar(freq * (1.0 + spread * 2.0));\n\n            let saws = (v1 + v2 + v3 + v4 + v5) * 0.22;\n\n            // Subtle sub layer\n            let sub = sin_osc_ar(freq * 0.5) * 0.15;\n\n            // High pass for clarity\n            let clean = hpf_ar(saws, 200.0);\n\n            (clean + sub) * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/future_bass.vibe"
      },
      {
        "name": "future_lead",
        "description": "Bright lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 880
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"future_lead\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Clean saw with slight detune\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.003);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Bright filtering\n            let filtered = lpf_ar(source, 8000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/future_bass.vibe"
      },
      {
        "name": "future_wobble",
        "description": "Sidechain-style pump",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "rate",
            "default": 4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"future_wobble\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"rate\", 4.0)\n        .body(|freq, amp, gate, rate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chord-like oscillators\n            let v1 = saw_ar(freq * 0.995);\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * 1.005);\n\n            let chord = (v1 + v2 + v3) * 0.35;\n\n            // Pump LFO (simulates sidechain)\n            let pump = sin_osc_ar(rate) * 0.4 + 0.6;\n\n            let filtered = lpf_ar(chord, 4000.0);\n\n            filtered * env * amp * pump\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/future_bass.vibe"
      },
      {
        "name": "future_pad",
        "description": "Soft atmospheric pad",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.3
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"future_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.5, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Soft detuned voices\n            let v1 = saw_ar(freq * 0.997);\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * 1.003);\n            let v4 = sin_osc_ar(freq * 0.5) * 0.3;\n\n            let mix = (v1 + v2 + v3) * 0.25 + v4;\n\n            // Very soft filtering\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/future_bass.vibe"
      },
      {
        "name": "future_pluck",
        "description": "Short melodic pluck",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"future_pluck\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let decay_env = envelope()\n                .perc(0.001, 0.25)\n                .build();\n\n            // Bright saw pluck\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.002);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Filter sweep\n            let cutoff = 800.0 + decay_env * 5000.0;\n            let filtered = rlpf_ar(source, cutoff, 0.35);\n\n            filtered * env * decay_env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/future_bass.vibe"
      },
      {
        "name": "hyperpop_lead",
        "description": "Bright processed lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 880
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "crunch",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"hyperpop_lead\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"crunch\", 0.5)\n        .body(|freq, amp, gate, crunch| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright saw\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.005);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Bitcrushed layer\n            let crushed = (source * (4.0 + crunch * 8.0)).tanh();\n\n            // Very bright\n            let bright = hpf_ar(crushed, 500.0);\n\n            bright * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/hyperpop.vibe"
      },
      {
        "name": "hyperpop_chord",
        "description": "Processed chord stab",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"hyperpop_chord\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Stacked supersaws\n            let spread = 0.015;\n            let v1 = saw_ar(freq * (1.0 - spread));\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * (1.0 + spread));\n\n            let mix = (v1 + v2 + v3) * 0.35;\n\n            // Crunchy processing\n            let crunched = (mix * 3.0).tanh();\n\n            // Bright filter\n            let filtered = hpf_ar(crunched, 300.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/hyperpop.vibe"
      },
      {
        "name": "hyperpop_bass",
        "description": "Distorted glitchy bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"hyperpop_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.003, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n\n            // Aggressive bass\n            let saw = saw_ar(freq);\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let mix = saw * 0.6 + sub;\n\n            // Heavy distortion\n            let dist = (mix * 4.0).tanh();\n\n            // Filter sweep\n            let cutoff = 200.0 + filt_env * 3000.0;\n            let filtered = rlpf_ar(dist, cutoff, 0.35);\n\n            filtered * env * amp * 0.7\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/hyperpop.vibe"
      },
      {
        "name": "hyperpop_synth",
        "description": "Metallic processed synth",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"hyperpop_synth\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM for metallic character\n            let mod_depth = 2.0;\n            let modulator = sin_osc_ar(freq * 3.5) * mod_depth;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Second layer\n            let saw = saw_ar(freq) * 0.3;\n\n            let mix = carrier + saw;\n\n            // Extreme processing\n            let processed = (mix * 3.0).tanh();\n\n            processed * env * amp * 0.6\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/hyperpop.vibe"
      },
      {
        "name": "hyperpop_hat",
        "description": "Crushed digital hat",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 12000
          },
          {
            "name": "amp",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"hyperpop_hat\", |builder| {\n    builder\n        .param(\"freq\", 12000.0)\n        .param(\"amp\", 0.4)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.04)\n                .cleanup_on_finish()\n                .build();\n\n            // Noise-based hat\n            let noise = white_noise_ar();\n\n            // Extreme high pass\n            let filtered = hpf_ar(noise, freq);\n\n            // Digital crunch\n            let crunched = (filtered * 5.0).tanh();\n\n            crunched * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/hyperpop.vibe"
      },
      {
        "name": "lofi_keys",
        "description": "Warm dusty keys",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "dusty",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"lofi_keys\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"dusty\", 0.5) // Amount of degradation\n        .body(|freq, amp, gate, dusty| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Rhodes-like tone\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n            let clean = h1 + h2 + h3 + h4;\n\n            // Add vinyl warmth\n            let noise = white_noise_ar() * dusty * 0.02;\n            let warped = clean + noise;\n\n            // Lo-fi filtering (roll off highs)\n            let lofi = lpf_ar(warped, 3000.0 - dusty * 1500.0);\n\n            lofi * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/lofi.vibe"
      },
      {
        "name": "lofi_piano",
        "description": "Dusty sampled feel",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"lofi_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let decay_env = envelope()\n                .perc(0.001, 1.2)\n                .build();\n\n            // Piano harmonics\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.08;\n\n            let piano = h1 + h2 + h3 + h4 + h5;\n\n            // Lo-fi character\n            let lofi = lpf_ar(piano, 2500.0);\n\n            // Slight detuning for worn tape feel\n            let warble = sin_osc_ar(0.5) * 0.002 + 1.0;\n\n            lofi * env * decay_env * amp * warble * 0.6\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/lofi.vibe"
      },
      {
        "name": "lofi_bass",
        "description": "Warm rounded bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"lofi_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Soft bass tone\n            let fund = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n\n            let bass = fund + h2;\n\n            // Warm filtering\n            let warm = lpf_ar(bass, 800.0);\n\n            warm * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/lofi.vibe"
      },
      {
        "name": "lofi_pad",
        "description": "Atmospheric background",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.3
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"lofi_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.8, 1.0, 0.8)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Soft detuned voices\n            let v1 = sin_osc_ar(freq * 0.998);\n            let v2 = sin_osc_ar(freq);\n            let v3 = sin_osc_ar(freq * 1.002);\n\n            let mix = (v1 + v2 + v3) * 0.35;\n\n            // Very lo-fi\n            let lofi = lpf_ar(mix, 1500.0);\n\n            // Tape warble\n            let warble = sin_osc_ar(0.3) * 0.005 + 1.0;\n\n            lofi * env * amp * warble\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/lofi.vibe"
      },
      {
        "name": "lofi_crackle",
        "description": "Background texture",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "amp",
            "default": 0.15
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "density",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"lofi_crackle\", |builder| {\n    builder\n        .param(\"amp\", 0.15)\n        .param(\"gate\", 1.0)\n        .param(\"density\", 0.5)\n        .body(|amp, gate, density| {\n            let env = envelope()\n                .asr(0.1, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Random impulses for crackle\n            let crackle = dust_ar(5.0 + density * 20.0);\n            let filtered_crackle = hpf_ar(crackle, 1000.0);\n\n            // Background hiss\n            let hiss = white_noise_ar() * 0.02;\n            let filtered_hiss = lpf_ar(hpf_ar(hiss, 500.0), 4000.0);\n\n            (filtered_crackle * 0.3 + filtered_hiss) * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/lofi.vibe"
      },
      {
        "name": "serum_growl",
        "description": "The dubstep staple",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "growl_rate",
            "default": 8
          },
          {
            "name": "intensity",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"serum_growl\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"growl_rate\", 8.0) // LFO rate for growl\n        .param(\"intensity\", 0.7)\n        .body(|freq, amp, gate, growl_rate, intensity| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM modulation for growl character\n            let lfo = sin_osc_ar(growl_rate);\n            let mod_depth = lfo * intensity * 0.3 + 0.3;\n\n            let modulator = sin_osc_ar(freq * 2.0) * mod_depth * freq;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Second layer for thickness\n            let mod2 = sin_osc_ar(freq * 3.0) * mod_depth * freq * 0.5;\n            let carrier2 = sin_osc_ar(freq * 0.5 + mod2) * 0.6;\n\n            let growl = carrier * 0.5 + carrier2;\n\n            // Distortion for edge\n            let dist = (growl * 2.0).tanh();\n\n            // Filter sweep\n            let filter_mod = lfo * 1000.0 + 2000.0;\n            let filtered = rlpf_ar(dist, filter_mod, 0.4);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/serum_style.vibe"
      },
      {
        "name": "serum_reese",
        "description": "Modern reese",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 55
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "detune",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"serum_reese\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"detune\", 0.5)\n        .body(|freq, amp, gate, detune| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned saws for modern reese\n            let spread = detune * 0.02;\n            let v1 = saw_ar(freq * (1.0 - spread * 2.0));\n            let v2 = saw_ar(freq * (1.0 - spread));\n            let v3 = saw_ar(freq);\n            let v4 = saw_ar(freq * (1.0 + spread));\n            let v5 = saw_ar(freq * (1.0 + spread * 2.0));\n\n            let mix = (v1 + v2 + v3 + v4 + v5) * 0.22;\n\n            // Subtle modulation\n            let mod_lfo = sin_osc_ar(0.2) * 0.002 + 1.0;\n\n            // Bass boost\n            let boosted = mix + lpf_ar(mix, 100.0) * 0.5;\n\n            boosted * env * amp * mod_lfo\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/serum_style.vibe"
      },
      {
        "name": "serum_supersaw",
        "description": "Ultra-wide lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "width",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"serum_supersaw\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"width\", 0.7)\n        .body(|freq, amp, gate, width| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // 7 voices with varying detune\n            let spread = width * 0.04;\n            let v1 = saw_ar(freq * (1.0 - spread * 3.0));\n            let v2 = saw_ar(freq * (1.0 - spread * 2.0));\n            let v3 = saw_ar(freq * (1.0 - spread));\n            let v4 = saw_ar(freq);\n            let v5 = saw_ar(freq * (1.0 + spread));\n            let v6 = saw_ar(freq * (1.0 + spread * 2.0));\n            let v7 = saw_ar(freq * (1.0 + spread * 3.0));\n\n            let mix = (v1 + v2 + v3 + v4 + v5 + v6 + v7) * 0.17;\n\n            // Bright filter\n            let filtered = lpf_ar(mix, 10000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/serum_style.vibe"
      },
      {
        "name": "serum_pluck",
        "description": "Modern pluck lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"serum_pluck\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast decay envelope\n            let decay_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Saw with filter sweep\n            let saw = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.005);\n\n            let source = (saw + saw2) * 0.5;\n\n            // Filter pluck\n            let cutoff = 500.0 + decay_env * 6000.0;\n            let filtered = rlpf_ar(source, cutoff, 0.3);\n\n            filtered * env * decay_env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/serum_style.vibe"
      },
      {
        "name": "serum_hoover",
        "description": "Classic rave hoover updated",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"serum_hoover\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned oscillators with movement\n            let lfo = sin_osc_ar(0.5) * 0.01 + 1.0;\n            let v1 = saw_ar(freq * 0.99 * lfo);\n            let v2 = saw_ar(freq * lfo);\n            let v3 = saw_ar(freq * 1.01 * lfo);\n\n            // Sync-like harmonics\n            let sync_osc = saw_ar(freq * 2.5) * 0.3;\n\n            let mix = (v1 + v2 + v3) * 0.35 + sync_osc;\n\n            // Resonant sweep\n            let filter_lfo = sin_osc_ar(0.3) * 500.0 + 2000.0;\n            let filtered = rlpf_ar(mix, filter_lfo, 0.4);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/serum_style.vibe"
      },
      {
        "name": "synthwave_bass",
        "description": "Pulsing retro bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"synthwave_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            // Fat saw bass\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.003);\n            let sub = sin_osc_ar(freq * 0.5) * 0.5;\n\n            let mix = (saw1 + saw2) * 0.4 + sub;\n\n            // Punchy filter\n            let cutoff = 300.0 + filt_env * 2000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/synthwave.vibe"
      },
      {
        "name": "synthwave_lead",
        "description": "Soaring lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"synthwave_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws\n            let saw1 = saw_ar(freq * 0.998);\n            let saw2 = saw_ar(freq);\n            let saw3 = saw_ar(freq * 1.002);\n\n            let mix = (saw1 + saw2 + saw3) * 0.35;\n\n            // Bright with slight resonance\n            let filtered = rlpf_ar(mix, 5000.0, 0.4);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/synthwave.vibe"
      },
      {
        "name": "synthwave_pad",
        "description": "Lush retro pad",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"synthwave_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Juno-like chorus\n            let lfo1 = sin_osc_ar(0.5) * 0.006;\n            let lfo2 = sin_osc_ar(0.6) * 0.006;\n\n            let v1 = saw_ar(freq * (1.0 + lfo1));\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * (1.0 + lfo2));\n\n            let mix = (v1 + v2 + v3) * 0.35;\n\n            // Warm filtering\n            let filtered = lpf_ar(mix, 3000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/synthwave.vibe"
      },
      {
        "name": "synthwave_arp",
        "description": "Arpeggiated lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"synthwave_arp\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Clean saw with slight detune\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.002);\n\n            let mix = (saw1 + saw2) * 0.5;\n\n            // Bright plucky filter\n            let filt_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let cutoff = 1000.0 + filt_env * 4000.0;\n\n            let filtered = rlpf_ar(mix, cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/synthwave.vibe"
      },
      {
        "name": "synthwave_snare",
        "description": "Gated reverb snare character",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 200
          },
          {
            "name": "amp",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"synthwave_snare\", |builder| {\n    builder\n        .param(\"freq\", 200.0)\n        .param(\"amp\", 0.6)\n        .body(|freq, amp| {\n            // 80s snare envelope\n            let env = envelope()\n                .perc(0.001, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Snare body\n            let body = sin_osc_ar(freq);\n\n            // Noise\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(lpf_ar(noise, 8000.0), 2000.0);\n\n            // Mix\n            let snare = body * 0.4 + filtered_noise * 0.6;\n\n            snare * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/synthwave.vibe"
      },
      {
        "name": "trap_808_long",
        "description": "Extended 808 bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 40
          },
          {
            "name": "amp",
            "default": 0.8
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "decay",
            "default": 2
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trap_808_long\", |builder| {\n    builder\n        .param(\"freq\", 40.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .param(\"decay\", 2.0) // Long decay time\n        .body(|freq, amp, gate, decay| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Long decay envelope\n            let decay_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay)\n                .build();\n\n            // Pitch envelope for 808 character\n            let pitch_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let freq_mod = pitch_env * freq * 3.0;\n\n            // Pure sine 808\n            let osc = sin_osc_ar(freq + freq_mod);\n\n            // Slight saturation for presence\n            let sat = (osc * 1.5).tanh() * 0.8;\n\n            sat * env * decay_env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/trap.vibe"
      },
      {
        "name": "trap_808_dist",
        "description": "Heavy distorted 808",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 40
          },
          {
            "name": "amp",
            "default": 0.7
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "drive",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trap_808_dist\", |builder| {\n    builder\n        .param(\"freq\", 40.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .param(\"drive\", 0.6)\n        .body(|freq, amp, gate, drive| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let decay_env = envelope()\n                .perc(0.001, 1.5)\n                .build();\n\n            // Pitch envelope\n            let pitch_env = envelope()\n                .perc(0.001, 0.06)\n                .build();\n            let freq_mod = pitch_env * freq * 4.0;\n\n            // 808 oscillator\n            let osc = sin_osc_ar(freq + freq_mod);\n\n            // Heavy distortion\n            let dist_amount = 2.0 + drive * 6.0;\n            let dist = (osc * dist_amount).tanh();\n\n            // Low pass to control harshness\n            let filtered = lpf_ar(dist, 3000.0);\n\n            filtered * env * decay_env * amp * 0.7\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/trap.vibe"
      },
      {
        "name": "trap_hat",
        "description": "Fast trap hats",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 8000
          },
          {
            "name": "amp",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trap_hat\", |builder| {\n    builder\n        .param(\"freq\", 8000.0)\n        .param(\"amp\", 0.4)\n        .body(|freq, amp| {\n            // Very short envelope\n            let env = envelope()\n                .perc(0.001, 0.05)\n                .cleanup_on_finish()\n                .build();\n\n            // High-passed noise\n            let noise = white_noise_ar();\n            let filtered = hpf_ar(noise, freq);\n\n            // Metallic resonance\n            let metal = rlpf_ar(noise, freq * 1.2, 0.1) * 0.5;\n\n            (filtered + metal) * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/trap.vibe"
      },
      {
        "name": "trap_hat_roll",
        "description": "Rapid-fire hats",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 9000
          },
          {
            "name": "amp",
            "default": 0.3
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trap_hat_roll\", |builder| {\n    builder\n        .param(\"freq\", 9000.0)\n        .param(\"amp\", 0.3)\n        .body(|freq, amp| {\n            // Extra short for rolls\n            let env = envelope()\n                .perc(0.0001, 0.02)\n                .cleanup_on_finish()\n                .build();\n\n            // Tight filtered noise\n            let noise = white_noise_ar();\n            let filtered = hpf_ar(noise, freq);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/trap.vibe"
      },
      {
        "name": "trap_lead",
        "description": "Dark melodic lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trap_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Dark detuned saw\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.004);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Dark filter\n            let filtered = lpf_ar(source, 2500.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/trap.vibe"
      },
      {
        "name": "trap_bell",
        "description": "Melodic bell lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 880
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"trap_bell\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let decay_env = envelope()\n                .perc(0.001, 0.8)\n                .build();\n\n            // Simple FM bell\n            let mod_depth = decay_env * 2.0;\n            let modulator = sin_osc_ar(freq * 2.0) * mod_depth;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Harmonics\n            let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.15;\n\n            let bell = carrier + h2 + h3;\n\n            bell * env * decay_env * amp * 0.5\n        })\n});",
        "category": "modern",
        "subcategory": "",
        "path": "modern/trap.vibe"
      }
    ]
  },
  "Modular": {
    "subcategories": {},
    "items": [
      {
        "name": "mod_lfo",
        "description": "LFO module (as audio rate for AM effects)",
        "genre": "Modular, Experimental",
        "character": "LFO module (as audio rate for AM effects)",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Modular, Experimental | Character: LFO module (as audio rate for AM effects)\ndefine_synthdef(\"mod_lfo\")\n    .param(\"freq\", 5.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .param(\"wave\", 0.0) // 0=sine, 0.5=triangle, 1.0=saw\n    .body(|freq, amp, gate, wave| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Crossfade LFO shapes\n        let sine_wave = sin_osc_ar(freq) * (1.0 - wave * 2.0).max(0.0);\n        let tri_wave = lf_tri_ar(freq) * (1.0 - (wave - 0.5).abs() * 2.0).max(0.0);\n        let saw_wave = saw_ar(freq) * ((wave - 0.5) * 2.0).max(0.0);\n\n        let mix = (sine_wave + tri_wave + saw_wave) * 0.5 + 0.5;\n\n        mix * env * amp\n    });\n",
        "category": "modular",
        "subcategory": "",
        "path": "modular/mod_lfo.vibe"
      },
      {
        "name": "mod_noise",
        "description": "Noise source module",
        "genre": "Modular, Experimental",
        "character": "Noise source module",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Modular, Experimental | Character: Noise source module\ndefine_synthdef(\"mod_noise\")\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .param(\"color\", 0.5) // 0=white, 1=pink\n    .body(|amp, gate, color| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.001)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Crossfade white to pink\n        let white = white_noise_ar() * (1.0 - color);\n        let pink = pink_noise_ar() * color;\n\n        (white + pink) * env * amp\n    });\n",
        "category": "modular",
        "subcategory": "",
        "path": "modular/mod_noise.vibe"
      },
      {
        "name": "mod_vco",
        "description": "Basic VCO module",
        "genre": "Modular, Experimental",
        "character": "Basic VCO module",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Modular, Experimental | Character: Basic VCO module\ndefine_synthdef(\"mod_vco\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.7)\n    .param(\"gate\", 1.0)\n    .param(\"wave\", 0.0) // 0=saw, 0.5=pulse, 1.0=sine\n    .body(|freq, amp, gate, wave| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.001)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Crossfade between waveforms\n        let saw_wave = saw_ar(freq) * (1.0 - wave * 2.0).max(0.0);\n        let pulse_wave = pulse_ar(freq, 0.5) * (1.0 - (wave - 0.5).abs() * 2.0).max(0.0);\n        let sine_wave = sin_osc_ar(freq) * ((wave - 0.5) * 2.0).max(0.0);\n\n        let mix = saw_wave + pulse_wave + sine_wave;\n\n        mix * env * amp\n    });\n",
        "category": "modular",
        "subcategory": "",
        "path": "modular/mod_vco.vibe"
      }
    ]
  },
  "Orchestral": {
    "subcategories": {},
    "items": [
      {
        "name": "brass_stab",
        "description": "Punchy brass stab",
        "genre": "Orchestral, Cinematic",
        "character": "Punchy brass stab",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Orchestral, Cinematic | Character: Punchy brass stab\ndefine_synthdef(\"brass_stab\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Punchy brass envelope\n        let amp_env = envelope()\n            .perc(0.01, 0.3)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.01, 0.2)\n            .build();\n\n        // Brass section\n        let osc1 = saw_ar(freq * 0.998) * 0.3;\n        let osc2 = saw_ar(freq) * 0.35;\n        let osc3 = saw_ar(freq * 1.002) * 0.3;\n\n        let mix = osc1 + osc2 + osc3;\n\n        // Brass filter character\n        let cutoff = 1000.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.2) * amp_env * amp\n    });\n",
        "category": "orchestral",
        "subcategory": "",
        "path": "orchestral/brass_stab.vibe"
      },
      {
        "name": "strings_legato",
        "description": "Smooth legato string section",
        "genre": "Orchestral, Cinematic",
        "character": "Smooth legato string section",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Orchestral, Cinematic | Character: Smooth legato string section\ndefine_synthdef(\"strings_legato\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Smooth legato envelope\n        let env = envelope()\n            .asr(0.15, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.006;\n\n        // String section\n        let v1 = saw_ar(freq * 0.997 + vib) * 0.22;\n        let v2 = saw_ar(freq + vib * 0.8) * 0.25;\n        let v3 = saw_ar(freq * 1.003 + vib * 1.1) * 0.22;\n        let v4 = saw_ar(freq * 1.006) * 0.18;\n\n        let mix = v1 + v2 + v3 + v4;\n\n        lpf_ar(mix, 5000.0) * env * amp\n    });\n",
        "category": "orchestral",
        "subcategory": "",
        "path": "orchestral/strings_legato.vibe"
      },
      {
        "name": "strings_staccato",
        "description": "Short staccato string section",
        "genre": "Orchestral, Cinematic",
        "character": "Short staccato string section",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Orchestral, Cinematic | Character: Short staccato string section\ndefine_synthdef(\"strings_staccato\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .body(|freq, amp| {\n        // Short staccato envelope\n        let amp_env = envelope()\n            .perc(0.01, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Multiple detuned oscillators for section\n        let v1 = saw_ar(freq * 0.998) * 0.25;\n        let v2 = saw_ar(freq) * 0.25;\n        let v3 = saw_ar(freq * 1.002) * 0.25;\n        let v4 = saw_ar(freq * 1.005) * 0.2;\n\n        let mix = v1 + v2 + v3 + v4;\n\n        // Warm filtering\n        lpf_ar(mix, 4000.0) * amp_env * amp\n    });\n",
        "category": "orchestral",
        "subcategory": "",
        "path": "orchestral/strings_staccato.vibe"
      },
      {
        "name": "timpani",
        "description": "Timpani drum with resonant tone",
        "genre": "Orchestral, Cinematic",
        "character": "Timpani drum with resonant tone",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Orchestral, Cinematic | Character: Timpani drum with resonant tone\ndefine_synthdef(\"timpani\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Long resonant decay\n        let amp_env = envelope()\n            .perc(0.002, 1.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 0.8;\n\n        // Main body\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let harm1 = sin_osc_ar((freq + freq_mod) * 1.5) * 0.2;\n        let harm2 = sin_osc_ar((freq + freq_mod) * 2.0) * 0.1;\n\n        // Mallet attack\n        let attack_env = envelope()\n            .perc(0.001, 0.025)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 2000.0) * attack_env * 0.3;\n\n        (body + harm1 + harm2 + attack) * amp_env * amp\n    });\n",
        "category": "orchestral",
        "subcategory": "",
        "path": "orchestral/timpani.vibe"
      },
      {
        "name": "wind_chimes",
        "description": "Metal wind chimes",
        "genre": "Orchestral, Ambient",
        "character": "Metal wind chimes",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Orchestral, Ambient | Character: Metal wind chimes\ndefine_synthdef(\"wind_chimes\")\n    .param(\"freq\", 2000.0)\n    .param(\"amp\", 0.4)\n    .param(\"density\", 0.5)\n    .body(|freq, amp, density| {\n        // Overall envelope\n        let amp_env = envelope()\n            .perc(0.001, 2.0)\n            .cleanup_on_finish()\n            .build();\n\n        // Multiple resonant frequencies\n        let chime1 = sin_osc_ar(freq) * dust_ar(density * 10.0) * 0.2;\n        let chime2 = sin_osc_ar(freq * 1.2) * dust_ar(density * 8.0) * 0.18;\n        let chime3 = sin_osc_ar(freq * 1.5) * dust_ar(density * 12.0) * 0.15;\n        let chime4 = sin_osc_ar(freq * 0.8) * dust_ar(density * 6.0) * 0.15;\n        let chime5 = sin_osc_ar(freq * 1.8) * dust_ar(density * 10.0) * 0.12;\n\n        let mix = chime1 + chime2 + chime3 + chime4 + chime5;\n\n        mix * amp_env * amp\n    });\n",
        "category": "orchestral",
        "subcategory": "",
        "path": "orchestral/wind_chimes.vibe"
      }
    ]
  },
  "Pads": {
    "subcategories": {
      "Ambient": [
        {
          "name": "pad_bright",
          "description": "Genre: Ambient, Chillout | Character: Bright, airy pad",
          "genre": "Ambient, Chillout",
          "character": "Bright, airy pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_bright\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow attack, long release\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.4, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright oscillators with wide detuning\n            let osc1 = saw_ar(freq * 0.990);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.010);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Bright filtering\n            let filtered = lpf_ar(mix, 3000.0);\n\n            // High-pass to remove mud\n            let clean = hpf_ar(filtered, 150.0);\n\n            clean * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "ambient",
          "path": "pads/ambient/pad_bright.vibe"
        },
        {
          "name": "pad_cold",
          "description": "Genre: Ambient, Drone | Character: Cold, digital pad",
          "genre": "Ambient, Drone",
          "character": "Cold, digital pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_cold\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.4, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pulse waves for digital character\n            let pulse1 = saw_ar(freq * 0.997);\n            let pulse2 = saw_ar(freq);\n            let pulse3 = saw_ar(freq * 1.003);\n\n            let mix = (pulse1 + pulse2 + pulse3) * 0.33;\n\n            // Cold filtering - remove lows\n            let hp = hpf_ar(mix, 300.0);\n            let filtered = lpf_ar(hp, 2500.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "ambient",
          "path": "pads/ambient/pad_cold.vibe"
        },
        {
          "name": "pad_dark",
          "description": "Genre: Ambient, Dark Ambient | Character: Dark, brooding pad",
          "genre": "Ambient, Dark Ambient",
          "character": "Dark, brooding pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_dark\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow attack, long release\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.3, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Low, dark oscillators\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.005);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Dark filtering\n            let filtered = lpf_ar(mix, 800.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "ambient",
          "path": "pads/ambient/pad_dark.vibe"
        },
        {
          "name": "pad_dense",
          "description": "Genre: Ambient, Drone | Character: Dense, thick pad",
          "genre": "Ambient, Drone",
          "character": "Dense, thick pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.35
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_dense\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.35)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Moderate attack, long sustain\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.3, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Many detuned oscillators for thickness\n            let osc1 = saw_ar(freq * 0.988);\n            let osc2 = saw_ar(freq * 0.994);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.006);\n            let osc5 = saw_ar(freq * 1.012);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Warm filtering\n            let filtered = lpf_ar(mix, 1800.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "ambient",
          "path": "pads/ambient/pad_dense.vibe"
        },
        {
          "name": "pad_evolving",
          "description": "Genre: Ambient, Experimental | Character: Evolving pad with filter movement",
          "genre": "Ambient, Experimental",
          "character": "Evolving pad with filter movement",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_evolving\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Long attack and release\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.5, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned oscillators\n            let osc1 = saw_ar(freq * 0.993);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.007);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Filter evolves over time\n            let filter_env = envelope()\n                .asr(1.0, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 600.0 + (filter_env * 2000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "ambient",
          "path": "pads/ambient/pad_evolving.vibe"
        },
        {
          "name": "pad_filtered",
          "description": "Genre: Ambient, Techno | Character: Heavily filtered pad with resonance",
          "genre": "Ambient, Techno",
          "character": "Heavily filtered pad with resonance",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_filtered\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.4, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.005);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Resonant filter\n            let filter_env = envelope()\n                .asr(0.8, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 1500.0);\n\n            let filtered = rlpf_ar(mix, mod_cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "ambient",
          "path": "pads/ambient/pad_filtered.vibe"
        },
        {
          "name": "pad_shimmer",
          "description": "Genre: Ambient, Post-Rock | Character: Shimmering pad with high harmonics",
          "genre": "Ambient, Post-Rock",
          "character": "Shimmering pad with high harmonics",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_shimmer\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Long attack for shimmer\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.5, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fundamental and high harmonics\n            let fundamental = saw_ar(freq) * 0.4;\n            let harmonic2 = saw_ar(freq * 2.0) * 0.25;\n            let harmonic3 = saw_ar(freq * 3.0) * 0.15;\n            let harmonic4 = saw_ar(freq * 4.0) * 0.1;\n\n            let mix = fundamental + harmonic2 + harmonic3 + harmonic4;\n\n            // Bright filter\n            let filtered = lpf_ar(mix, 4000.0);\n\n            // High-pass for air\n            let clean = hpf_ar(filtered, 200.0);\n\n            clean * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "ambient",
          "path": "pads/ambient/pad_shimmer.vibe"
        },
        {
          "name": "pad_space",
          "description": "Genre: Ambient, Space Music | Character: Spacious, atmospheric pad",
          "genre": "Ambient, Space Music",
          "character": "Spacious, atmospheric pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.35
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_space\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.35)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very long attack and release\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.8, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Wide detuning for space\n            let osc1 = saw_ar(freq * 0.985);\n            let osc2 = saw_ar(freq * 0.995);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.005);\n            let osc5 = saw_ar(freq * 1.015);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Filter movement for evolution\n            let filter_env = envelope()\n                .asr(1.5, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            // Remove mud\n            let clean = hpf_ar(filtered, 120.0);\n\n            clean * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "ambient",
          "path": "pads/ambient/pad_space.vibe"
        },
        {
          "name": "pad_sparse",
          "description": "Genre: Ambient, Minimal | Character: Sparse, minimal pad",
          "genre": "Ambient, Minimal",
          "character": "Sparse, minimal pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.45
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_sparse\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very slow attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.6, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Just two oscillators, subtle detuning\n            let osc1 = sin_osc_ar(freq * 0.998);\n            let osc2 = sin_osc_ar(freq * 1.002);\n\n            let mix = (osc1 + osc2) * 0.5;\n\n            // Minimal filtering\n            let filtered = lpf_ar(mix, 2000.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "ambient",
          "path": "pads/ambient/pad_sparse.vibe"
        },
        {
          "name": "pad_warm",
          "description": "Genre: Ambient, Chillout | Character: Warm, comforting pad",
          "genre": "Ambient, Chillout",
          "character": "Warm, comforting pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_warm\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Gentle attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.35, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix of sine and saw for warmth\n            let sine = sin_osc_ar(freq);\n            let saw1 = saw_ar(freq * 0.997) * 0.3;\n            let saw2 = saw_ar(freq * 1.003) * 0.3;\n\n            let mix = sine * 0.6 + (saw1 + saw2);\n\n            // Warm filtering\n            let filtered = lpf_ar(mix, 2000.0);\n\n            filtered * env * amp * 0.8\n        })\n});",
          "category": "pads",
          "subcategory": "ambient",
          "path": "pads/ambient/pad_warm.vibe"
        }
      ],
      "Analog": [
        {
          "name": "pad_cs80",
          "description": "Yamaha CS-80 pad - expressive and cinematic",
          "genre": "Cinematic, Synthwave",
          "character": "Yamaha CS-80 pad - expressive and cinematic",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Cinematic, Synthwave | Character: Yamaha CS-80 pad - expressive and cinematic\ndefine_synthdef(\"pad_cs80\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.25, 1.0, 0.35)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow filter envelope\n        let filt_env = envelope()\n            .asr(0.4, 1.0, 0.4)\n            .gate(gate)\n            .build();\n\n        // Rich detuned oscillators\n        let osc1 = saw_ar(freq * 0.994);\n        let osc2 = saw_ar(freq * 0.998);\n        let osc3 = saw_ar(freq);\n        let osc4 = saw_ar(freq * 1.002);\n        let osc5 = saw_ar(freq * 1.006);\n\n        let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.18;\n\n        // Expressive filter\n        let cutoff = 500.0 + filt_env * 2500.0;\n        rlpf_ar(mix, cutoff, 0.12) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "analog",
          "path": "pads/analog/pad_cs80.vibe"
        },
        {
          "name": "pad_juno",
          "description": "Roland Juno chorus pad - lush and warm",
          "genre": "House, Synthwave",
          "character": "Roland Juno chorus pad - lush and warm",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: House, Synthwave | Character: Roland Juno chorus pad - lush and warm\ndefine_synthdef(\"pad_juno\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // PWM characteristic of Juno\n        let pwm = sin_osc_ar(0.3) * 0.25 + 0.5;\n        let osc1 = pulse_ar(freq, pwm);\n        let osc2 = pulse_ar(freq * 1.005, pwm);\n\n        // Sub layer\n        let sub = pulse_ar(freq * 0.5, 0.5) * 0.3;\n\n        let mix = (osc1 + osc2 + sub) * 0.3;\n\n        // Juno-style chorus simulation\n        let chorus_lfo = sin_osc_ar(0.5);\n        let delayed = delay_c_ar(mix, 0.03, 0.015 + chorus_lfo * 0.005);\n        let chorused = (mix + delayed) * 0.5;\n\n        lpf_ar(chorused, 3000.0) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "analog",
          "path": "pads/analog/pad_juno.vibe"
        },
        {
          "name": "pad_jupiter",
          "description": "Roland Jupiter-8 pad - bright and wide",
          "genre": "Electronic, Synthpop",
          "character": "Roland Jupiter-8 pad - bright and wide",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Electronic, Synthpop | Character: Roland Jupiter-8 pad - bright and wide\ndefine_synthdef(\"pad_jupiter\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.18, 1.0, 0.28)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .asr(0.25, 1.0, 0.3)\n            .gate(gate)\n            .build();\n\n        // Detuned saws with pulse\n        let saw1 = saw_ar(freq * 0.997);\n        let saw2 = saw_ar(freq);\n        let saw3 = saw_ar(freq * 1.003);\n        let pulse = pulse_ar(freq, 0.45) * 0.4;\n\n        let mix = (saw1 + saw2 + saw3 + pulse) * 0.25;\n\n        // Bright but smooth filter\n        let cutoff = 1000.0 + filt_env * 3500.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "analog",
          "path": "pads/analog/pad_jupiter.vibe"
        },
        {
          "name": "pad_oberheim",
          "description": "Oberheim brass pad - thick and powerful",
          "genre": "80s, Synthpop",
          "character": "Oberheim brass pad - thick and powerful",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: 80s, Synthpop | Character: Oberheim brass pad - thick and powerful\ndefine_synthdef(\"pad_oberheim\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .asr(0.15, 1.0, 0.25)\n            .gate(gate)\n            .build();\n\n        // Multiple saws for thickness\n        let osc1 = saw_ar(freq * 0.995);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.005);\n        let pulse_osc = pulse_ar(freq, 0.4) * 0.5;\n\n        let mix = (osc1 + osc2 + osc3 + pulse_osc) * 0.25;\n\n        // Powerful filter sweep\n        let cutoff = 600.0 + filt_env * 3000.0;\n        rlpf_ar(mix, cutoff, 0.2) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "analog",
          "path": "pads/analog/pad_oberheim.vibe"
        },
        {
          "name": "pad_prophet",
          "description": "Prophet-5 strings pad",
          "genre": "Synthpop, New Wave",
          "character": "Prophet-5 strings pad",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Synthpop, New Wave | Character: Prophet-5 strings pad\ndefine_synthdef(\"pad_prophet\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.15, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .asr(0.3, 1.0, 0.3)\n            .gate(gate)\n            .build();\n\n        // Detuned saws\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n        let osc4 = saw_ar(freq * 1.006);\n\n        let mix = (osc1 + osc2 + osc3 + osc4) * 0.22;\n\n        // Warm filter\n        let cutoff = 800.0 + filt_env * 2000.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "analog",
          "path": "pads/analog/pad_prophet.vibe"
        }
      ],
      "Cinematic": [
        {
          "name": "pad_epic",
          "description": "Epic orchestral pad - massive and powerful",
          "genre": "Epic, Trailer",
          "character": "Epic orchestral pad - massive and powerful",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Epic, Trailer | Character: Epic orchestral pad - massive and powerful\ndefine_synthdef(\"pad_epic\")\n    .param(\"freq\", 110.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.4, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope for power\n        let filt_env = envelope()\n            .asr(0.5, 1.0, 0.4)\n            .gate(gate)\n            .build();\n\n        // Multiple octaves for size\n        let low = saw_ar(freq) * 0.3;\n        let mid1 = saw_ar(freq * 2.0 * 0.998) * 0.2;\n        let mid2 = saw_ar(freq * 2.0) * 0.2;\n        let mid3 = saw_ar(freq * 2.0 * 1.002) * 0.2;\n        let high = saw_ar(freq * 4.0) * 0.1;\n\n        let mix = low + mid1 + mid2 + mid3 + high;\n\n        // Powerful filter sweep\n        let cutoff = 400.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "cinematic",
          "path": "pads/cinematic/pad_epic.vibe"
        },
        {
          "name": "pad_horror",
          "description": "Horror pad - dark and unsettling",
          "genre": "Horror, Dark Ambient",
          "character": "Horror pad - dark and unsettling",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Horror, Dark Ambient | Character: Horror pad - dark and unsettling\ndefine_synthdef(\"pad_horror\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.6, 1.0, 0.5)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow detuning for unease\n        let detune = sin_osc_ar(0.1) * freq * 0.03;\n\n        // Dark oscillators\n        let osc1 = saw_ar(freq + detune) * 0.3;\n        let osc2 = saw_ar(freq * 1.5 - detune) * 0.2;\n        let sub = sin_osc_ar(freq * 0.5) * 0.25;\n\n        // Noise texture\n        let noise = lpf_ar(pink_noise_ar(), 400.0) * 0.1;\n\n        let mix = osc1 + osc2 + sub + noise;\n\n        // Dark filtering\n        lpf_ar(mix, 600.0) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "cinematic",
          "path": "pads/cinematic/pad_horror.vibe"
        },
        {
          "name": "pad_mysterious",
          "description": "Mysterious pad - enigmatic and suspenseful",
          "genre": "Mystery, Thriller",
          "character": "Mysterious pad - enigmatic and suspenseful",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Mystery, Thriller | Character: Mysterious pad - enigmatic and suspenseful\ndefine_synthdef(\"pad_mysterious\")\n    .param(\"freq\", 165.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.45, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow, mysterious modulation\n        let mod1 = sin_osc_ar(0.2) * freq * 0.015;\n        let mod2 = sin_osc_ar(0.13) * freq * 0.01;\n\n        // Layered tones\n        let tone1 = sin_osc_ar(freq + mod1) * 0.4;\n        let tone2 = sin_osc_ar(freq * 1.5 + mod2) * 0.2;\n        let tone3 = lf_tri_ar(freq * 2.0) * 0.15;\n\n        // Subtle texture\n        let texture = bpf_ar(pink_noise_ar(), freq * 4.0, 0.5) * 0.08;\n\n        let mix = tone1 + tone2 + tone3 + texture;\n\n        lpf_ar(mix, 2500.0) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "cinematic",
          "path": "pads/cinematic/pad_mysterious.vibe"
        },
        {
          "name": "pad_scifi",
          "description": "Sci-fi pad - futuristic and alien",
          "genre": "Sci-Fi, Electronic",
          "character": "Sci-fi pad - futuristic and alien",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Sci-Fi, Electronic | Character: Sci-fi pad - futuristic and alien\ndefine_synthdef(\"pad_scifi\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.3, 1.0, 0.35)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // FM modulation for sci-fi texture\n        let mod_lfo = sin_osc_ar(0.3) * 3.0 + 5.0;\n        let modulator = sin_osc_ar(freq * 2.0) * mod_lfo * freq;\n        let carrier = sin_osc_ar(freq + modulator) * 0.4;\n\n        // Metallic ring\n        let ring = sin_osc_ar(freq * 3.14) * 0.15;\n\n        // Sub tone\n        let sub = sin_osc_ar(freq * 0.5) * 0.2;\n\n        let mix = carrier + ring + sub;\n\n        // Sweeping filter\n        let sweep = sin_osc_ar(0.2) * 1500.0 + 2500.0;\n        lpf_ar(mix, sweep) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "cinematic",
          "path": "pads/cinematic/pad_scifi.vibe"
        },
        {
          "name": "pad_tension",
          "description": "Tension-building pad",
          "genre": "Film Score, Horror",
          "character": "Tension-building pad",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Film Score, Horror | Character: Tension-building pad\ndefine_synthdef(\"pad_tension\")\n    .param(\"freq\", 110.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.5, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Dissonant cluster\n        let osc1 = sin_osc_ar(freq) * 0.35;\n        let osc2 = sin_osc_ar(freq * 1.06) * 0.25; // Minor 2nd\n        let osc3 = sin_osc_ar(freq * 1.12) * 0.2;  // Augmented\n\n        // Low rumble\n        let rumble = lpf_ar(pink_noise_ar(), 100.0) * 0.15;\n\n        // Slow rising filter\n        let filt_env = envelope()\n            .asr(1.0, 1.0, 0.5)\n            .gate(gate)\n            .build();\n\n        let mix = osc1 + osc2 + osc3 + rumble;\n        let cutoff = 200.0 + filt_env * 1500.0;\n\n        lpf_ar(mix, cutoff) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "cinematic",
          "path": "pads/cinematic/pad_tension.vibe"
        }
      ],
      "Lush": [
        {
          "name": "pad_aggressive",
          "description": "Genre: Techno, Industrial | Character: Aggressive, driven pad",
          "genre": "Techno, Industrial",
          "character": "Aggressive, driven pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.35
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.35)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Sharper attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws with more energy\n            let osc1 = saw_ar(freq * 0.993);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.007);\n\n            let mix = (osc1 + osc2 + osc3) * 0.4;\n\n            // Clip for aggression\n            let driven = clip(mix, -0.9, 0.9);\n\n            // Filtering\n            let filtered = lpf_ar(driven, 2800.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "lush",
          "path": "pads/lush/pad_aggressive.vibe"
        },
        {
          "name": "pad_chorus",
          "description": "Genre: Synthwave, Pop | Character: Chorused pad with movement",
          "genre": "Synthwave, Pop",
          "character": "Chorused pad with movement",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_chorus\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Pad envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.3, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned oscillators simulating chorus\n            let osc1 = saw_ar(freq * 0.992);\n            let osc2 = saw_ar(freq * 0.996);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.004);\n            let osc5 = saw_ar(freq * 1.008);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Filtering\n            let filtered = lpf_ar(mix, 3000.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "lush",
          "path": "pads/lush/pad_chorus.vibe"
        },
        {
          "name": "pad_detuned",
          "description": "Genre: Trance, EDM | Character: Heavily detuned, wide and lush",
          "genre": "Trance, EDM",
          "character": "Heavily detuned, wide and lush",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.35
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_detuned\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.35)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow attack for pad character\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.25, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Many detuned oscillators for width\n            let osc1 = saw_ar(freq * 0.980);\n            let osc2 = saw_ar(freq * 0.990);\n            let osc3 = saw_ar(freq * 0.998);\n            let osc4 = saw_ar(freq);\n            let osc5 = saw_ar(freq * 1.002);\n            let osc6 = saw_ar(freq * 1.010);\n            let osc7 = saw_ar(freq * 1.020);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5 + osc6 + osc7) * 0.14;\n\n            // Lush filtering\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "lush",
          "path": "pads/lush/pad_detuned.vibe"
        },
        {
          "name": "pad_morphing",
          "description": "Genre: Ambient, Experimental | Character: Morphing, evolving lush pad",
          "genre": "Ambient, Experimental",
          "character": "Morphing, evolving lush pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_morphing\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Long evolution\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.6, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned oscillators\n            let osc1 = saw_ar(freq * 0.991);\n            let osc2 = saw_ar(freq * 0.998);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.002);\n            let osc5 = saw_ar(freq * 1.009);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Evolving filter\n            let filter_env = envelope()\n                .asr(1.2, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            // Resonance evolves too\n            let resonant = rlpf_ar(filtered, mod_cutoff * 0.8, 0.5);\n\n            resonant * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "lush",
          "path": "pads/lush/pad_morphing.vibe"
        },
        {
          "name": "pad_narrow",
          "description": "Genre: Minimal, House | Character: Narrow, focused lush pad",
          "genre": "Minimal, House",
          "character": "Narrow, focused lush pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.45
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_narrow\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Pad envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.3, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Subtle detuning\n            let osc1 = saw_ar(freq * 0.998);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.002);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Filtering\n            let filtered = lpf_ar(mix, 2200.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "lush",
          "path": "pads/lush/pad_narrow.vibe"
        },
        {
          "name": "pad_organ",
          "description": "Genre: Gospel, Jazz | Character: Organ-like pad with drawbars",
          "genre": "Gospel, Jazz",
          "character": "Organ-like pad with drawbars",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_organ\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Quick attack like organ\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Organ drawbars (harmonic series)\n            let h1 = sin_osc_ar(freq) * 0.5;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.1;\n\n            let mix = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Gentle filtering\n            let filtered = lpf_ar(mix, 3500.0);\n\n            filtered * env * amp * 0.6\n        })\n});",
          "category": "pads",
          "subcategory": "lush",
          "path": "pads/lush/pad_organ.vibe"
        },
        {
          "name": "pad_soft",
          "description": "Genre: Ambient, Chillout | Character: Soft, gentle lush pad",
          "genre": "Ambient, Chillout",
          "character": "Soft, gentle lush pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.45
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_soft\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very soft attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.5, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix of sine and detuned saws for softness\n            let sine1 = sin_osc_ar(freq * 0.997);\n            let sine2 = sin_osc_ar(freq);\n            let sine3 = sin_osc_ar(freq * 1.003);\n            let saw = saw_ar(freq) * 0.2;\n\n            let mix = (sine1 + sine2 + sine3) * 0.3 + saw;\n\n            // Soft filtering\n            let filtered = lpf_ar(mix, 2000.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "lush",
          "path": "pads/lush/pad_soft.vibe"
        },
        {
          "name": "pad_string",
          "description": "Genre: Orchestral, Cinematic | Character: String-like pad",
          "genre": "Orchestral, Cinematic",
          "character": "String-like pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_string\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // String-like envelope with bow attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.15, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple sawtooths for string character\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.005);\n\n            // Add harmonics\n            let harmonic = saw_ar(freq * 2.0) * 0.15;\n\n            let mix = (osc1 + osc2 + osc3) * 0.33 + harmonic;\n\n            // String-like filtering\n            let filtered = lpf_ar(mix, 2500.0);\n\n            // Remove mud\n            let clean = hpf_ar(filtered, 150.0);\n\n            clean * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "lush",
          "path": "pads/lush/pad_string.vibe"
        },
        {
          "name": "pad_voice",
          "description": "Genre: Ambient, Choral | Character: Voice-like pad with formants",
          "genre": "Ambient, Choral",
          "character": "Voice-like pad with formants",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_voice\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Choir-like envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.35, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned oscillators\n            let osc1 = saw_ar(freq * 0.994);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.006);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Voice-like formant filtering (simplified)\n            let formant1 = rlpf_ar(mix, 800.0, 0.5) * 0.4;\n            let formant2 = rlpf_ar(mix, 1200.0, 0.6) * 0.35;\n            let formant3 = rlpf_ar(mix, 2400.0, 0.7) * 0.25;\n\n            let voiced = formant1 + formant2 + formant3;\n\n            voiced * env * amp * 0.8\n        })\n});",
          "category": "pads",
          "subcategory": "lush",
          "path": "pads/lush/pad_voice.vibe"
        },
        {
          "name": "pad_wide",
          "description": "Genre: Ambient, Chillout | Character: Very wide stereo pad",
          "genre": "Ambient, Chillout",
          "character": "Very wide stereo pad",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.35
            },
            {
              "name": "gate",
              "default": 1
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"pad_wide\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.35)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.4, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Extreme detuning for width\n            let left1 = saw_ar(freq * 0.975);\n            let left2 = saw_ar(freq * 0.990);\n            let center = saw_ar(freq);\n            let right1 = saw_ar(freq * 1.010);\n            let right2 = saw_ar(freq * 1.025);\n\n            let mix = (left1 + left2 + center + right1 + right2) * 0.2;\n\n            // Filtering\n            let filtered = lpf_ar(mix, 2800.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "pads",
          "subcategory": "lush",
          "path": "pads/lush/pad_wide.vibe"
        }
      ],
      "Movement": [
        {
          "name": "pad_arp",
          "description": "Arpeggiated pad texture",
          "genre": "Ambient, Electronic",
          "character": "Arpeggiated pad texture",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Ambient, Electronic | Character: Arpeggiated pad texture\ndefine_synthdef(\"pad_arp\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .param(\"rate\", 8.0)\n    .body(|freq, amp, gate, rate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Arp-like amplitude modulation\n        let arp_lfo = sin_osc_ar(rate);\n        let arp_env = arp_lfo * 0.5 + 0.5;\n\n        // Different pitches modulated\n        let osc1 = sin_osc_ar(freq) * arp_env;\n        let osc2 = sin_osc_ar(freq * 1.5) * (1.0 - arp_env) * 0.5;\n        let osc3 = sin_osc_ar(freq * 2.0) * arp_env * 0.3;\n\n        // Pad bed\n        let bed = saw_ar(freq * 0.5) * 0.15;\n\n        let mix = osc1 + osc2 + osc3 + bed;\n\n        lpf_ar(mix, 4000.0) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "movement",
          "path": "pads/movement/pad_arp.vibe"
        },
        {
          "name": "pad_gate",
          "description": "Gated/sidechain pad effect",
          "genre": "Trance, EDM",
          "character": "Gated/sidechain pad effect",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Trance, EDM | Character: Gated/sidechain pad effect\ndefine_synthdef(\"pad_gate\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .param(\"rate\", 4.0)\n    .body(|freq, amp, gate, rate| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Gate LFO (sharp on/off)\n        let gate_lfo = pulse_ar(rate, 0.5) * 0.8 + 0.2;\n\n        // Pad oscillators\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n\n        let mix = (osc1 + osc2 + osc3) * 0.3;\n\n        lpf_ar(mix, 3000.0) * gate_lfo * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "movement",
          "path": "pads/movement/pad_gate.vibe"
        },
        {
          "name": "pad_pulsing",
          "description": "Rhythmic pulsing pad",
          "genre": "Electronic, Trance",
          "character": "Rhythmic pulsing pad",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Electronic, Trance | Character: Rhythmic pulsing pad\ndefine_synthdef(\"pad_pulsing\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .param(\"rate\", 4.0)\n    .body(|freq, amp, gate, rate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pulse LFO\n        let pulse_lfo = sin_osc_ar(rate) * 0.4 + 0.6;\n\n        // Pad sound\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n\n        let mix = (osc1 + osc2 + osc3) * 0.3;\n\n        // Filter with pulse\n        let cutoff = 800.0 + pulse_lfo * 2000.0;\n        rlpf_ar(mix, cutoff, 0.15) * pulse_lfo * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "movement",
          "path": "pads/movement/pad_pulsing.vibe"
        },
        {
          "name": "pad_random",
          "description": "Random modulation pad",
          "genre": "Experimental, Ambient",
          "character": "Random modulation pad",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Experimental, Ambient | Character: Random modulation pad\ndefine_synthdef(\"pad_random\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Random modulations\n        let rand1 = lf_noise1_ar(2.0) * freq * 0.01;\n        let rand2 = lf_noise1_ar(3.0) * freq * 0.008;\n        let rand_amp = lf_noise1_ar(1.0) * 0.2 + 0.8;\n\n        // Oscillators with random pitch\n        let osc1 = sin_osc_ar(freq + rand1) * 0.4;\n        let osc2 = sin_osc_ar(freq * 2.0 + rand2) * 0.2;\n        let osc3 = saw_ar(freq + rand1 * 0.5) * 0.25;\n\n        let mix = (osc1 + osc2 + osc3) * rand_amp;\n\n        // Random filter\n        let rand_cutoff = lf_noise1_ar(0.5) * 1500.0 + 2000.0;\n        lpf_ar(mix, rand_cutoff) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "movement",
          "path": "pads/movement/pad_random.vibe"
        },
        {
          "name": "pad_swelling",
          "description": "Slowly swelling pad",
          "genre": "Cinematic, Ambient",
          "character": "Slowly swelling pad",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Cinematic, Ambient | Character: Slowly swelling pad\ndefine_synthdef(\"pad_swelling\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Very slow attack\n        let env = envelope()\n            .asr(2.0, 1.0, 0.5)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter swell envelope\n        let filt_env = envelope()\n            .asr(2.5, 1.0, 0.5)\n            .gate(gate)\n            .build();\n\n        // Rich detuned oscillators\n        let osc1 = saw_ar(freq * 0.996);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.004);\n\n        let mix = (osc1 + osc2 + osc3) * 0.3;\n\n        // Swelling filter\n        let cutoff = 300.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.12) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "movement",
          "path": "pads/movement/pad_swelling.vibe"
        }
      ],
      "Textural": [
        {
          "name": "pad_breath",
          "description": "Breathy pad - soft and airy",
          "genre": "Ambient, New Age",
          "character": "Breathy pad - soft and airy",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Ambient, New Age | Character: Breathy pad - soft and airy\ndefine_synthdef(\"pad_breath\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.4, 1.0, 0.5)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Soft tone\n        let body = sin_osc_ar(freq) * 0.4;\n        let harm = sin_osc_ar(freq * 2.0) * 0.15;\n\n        // Breath noise component\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.0, 0.5) * 0.25;\n\n        // Air movement\n        let air_lfo = sin_osc_ar(0.2) * 0.3 + 0.7;\n        let air = bpf_ar(pink_noise_ar(), 3000.0, 0.8) * air_lfo * 0.12;\n\n        let sig = body + harm + breath + air;\n\n        lpf_ar(sig, 4000.0) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "textural",
          "path": "pads/textural/pad_breath.vibe"
        },
        {
          "name": "pad_choir",
          "description": "Choir pad - ethereal voices",
          "genre": "Cinematic, Ambient",
          "character": "Choir pad - ethereal voices",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Cinematic, Ambient | Character: Choir pad - ethereal voices\ndefine_synthdef(\"pad_choir\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.35, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.0) * freq * 0.008;\n\n        // Multiple voices with formants\n        let voice1 = saw_ar(freq + vib) * 0.3;\n        let voice2 = saw_ar(freq * 1.002 + vib * 0.8) * 0.25;\n        let voice3 = saw_ar(freq * 0.998 + vib * 1.2) * 0.25;\n\n        let mix = voice1 + voice2 + voice3;\n\n        // Vowel formants (aaah)\n        let f1 = bpf_ar(mix, 700.0, 0.12) * 0.5;\n        let f2 = bpf_ar(mix, 1200.0, 0.15) * 0.3;\n        let f3 = bpf_ar(mix, 2500.0, 0.2) * 0.15;\n\n        let sig = f1 + f2 + f3;\n\n        sig * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "textural",
          "path": "pads/textural/pad_choir.vibe"
        },
        {
          "name": "pad_ghostly",
          "description": "Ghostly pad - eerie and unsettling",
          "genre": "Horror, Dark Ambient",
          "character": "Ghostly pad - eerie and unsettling",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Horror, Dark Ambient | Character: Ghostly pad - eerie and unsettling\ndefine_synthdef(\"pad_ghostly\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.5, 1.0, 0.6)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow, eerie modulation\n        let mod1 = sin_osc_ar(0.15) * freq * 0.02;\n        let mod2 = sin_osc_ar(0.23) * freq * 0.015;\n\n        // Detuned, wavering tones\n        let tone1 = sin_osc_ar(freq + mod1) * 0.35;\n        let tone2 = sin_osc_ar(freq * 1.01 + mod2) * 0.25;\n        let tone3 = sin_osc_ar(freq * 0.99 - mod1) * 0.25;\n\n        // Spectral component\n        let spectral = bpf_ar(pink_noise_ar(), freq * 3.0, 0.3) * 0.1;\n\n        let sig = tone1 + tone2 + tone3 + spectral;\n\n        lpf_ar(sig, 2500.0) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "textural",
          "path": "pads/textural/pad_ghostly.vibe"
        },
        {
          "name": "pad_glass",
          "description": "Glass/crystalline pad - bright and delicate",
          "genre": "Ambient, Cinematic",
          "character": "Glass/crystalline pad - bright and delicate",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Ambient, Cinematic | Character: Glass/crystalline pad - bright and delicate\ndefine_synthdef(\"pad_glass\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.3, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright sine harmonics\n        let h1 = sin_osc_ar(freq) * 0.4;\n        let h2 = sin_osc_ar(freq * 2.0) * 0.25;\n        let h3 = sin_osc_ar(freq * 3.0) * 0.15;\n        let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n        let h5 = sin_osc_ar(freq * 5.0) * 0.06;\n\n        // Slight shimmer\n        let shimmer_lfo = sin_osc_ar(4.0) * 0.02 + 1.0;\n        let shimmer = sin_osc_ar(freq * 6.0 * shimmer_lfo) * 0.04;\n\n        let sig = h1 + h2 + h3 + h4 + h5 + shimmer;\n\n        sig * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "textural",
          "path": "pads/textural/pad_glass.vibe"
        },
        {
          "name": "pad_metallic",
          "description": "Metallic pad - cold and resonant",
          "genre": "Industrial, Ambient",
          "character": "Metallic pad - cold and resonant",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Industrial, Ambient | Character: Metallic pad - cold and resonant\ndefine_synthdef(\"pad_metallic\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.35)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Inharmonic metallic partials\n        let p1 = sin_osc_ar(freq) * 0.35;\n        let p2 = sin_osc_ar(freq * 1.7) * 0.2;\n        let p3 = sin_osc_ar(freq * 2.4) * 0.15;\n        let p4 = sin_osc_ar(freq * 3.1) * 0.12;\n        let p5 = sin_osc_ar(freq * 4.6) * 0.08;\n\n        // FM metallic texture\n        let mod_freq = sin_osc_ar(freq * 1.5) * freq * 0.5;\n        let fm_metal = sin_osc_ar(freq + mod_freq) * 0.15;\n\n        let sig = p1 + p2 + p3 + p4 + p5 + fm_metal;\n\n        sig * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "textural",
          "path": "pads/textural/pad_metallic.vibe"
        },
        {
          "name": "pad_underwater",
          "description": "Underwater pad - muffled and deep",
          "genre": "Ambient, Soundscape",
          "character": "Underwater pad - muffled and deep",
          "params": [],
          "type": "synthdef",
          "source": "// Genre: Ambient, Soundscape | Character: Underwater pad - muffled and deep\ndefine_synthdef(\"pad_underwater\")\n    .param(\"freq\", 110.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.4, 1.0, 0.5)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow movement\n        let wobble = sin_osc_ar(0.3) * freq * 0.01;\n\n        // Deep tones\n        let deep1 = sin_osc_ar(freq + wobble) * 0.5;\n        let deep2 = sin_osc_ar(freq * 2.0 + wobble * 0.5) * 0.2;\n\n        // Bubble-like texture\n        let bubble_rate = 3.0;\n        let bubbles = sin_osc_ar(freq * 4.0) * dust_ar(bubble_rate) * 0.1;\n\n        let sig = deep1 + deep2 + bubbles;\n\n        // Heavy low-pass for underwater muffled effect\n        lpf_ar(sig, 800.0) * env * amp\n    });\n",
          "category": "pads",
          "subcategory": "textural",
          "path": "pads/textural/pad_underwater.vibe"
        }
      ]
    },
    "items": []
  },
  "Retro": {
    "subcategories": {},
    "items": [
      {
        "name": "chip_noise",
        "description": "Chip noise channel for drums/sfx",
        "genre": "Chiptune, 8-bit",
        "character": "Chip noise channel for drums/sfx",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Chiptune, 8-bit | Character: Chip noise channel for drums/sfx\ndefine_synthdef(\"chip_noise\")\n    .param(\"freq\", 8000.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        let amp_env = envelope()\n            .perc(0.001, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Filtered noise (simulating chip noise)\n        let noise = hpf_ar(white_noise_ar(), freq);\n\n        noise * amp_env * amp\n    });\n",
        "category": "retro",
        "subcategory": "",
        "path": "retro/chip_noise.vibe"
      },
      {
        "name": "chip_pulse",
        "description": "Classic pulse wave with variable duty",
        "genre": "Chiptune, 8-bit",
        "character": "Classic pulse wave with variable duty",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Chiptune, 8-bit | Character: Classic pulse wave with variable duty\ndefine_synthdef(\"chip_pulse\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .param(\"duty\", 0.5)\n    .body(|freq, amp, gate, duty| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pure pulse wave (chip-style)\n        let osc = pulse_ar(freq, duty);\n\n        osc * env * amp\n    });\n",
        "category": "retro",
        "subcategory": "",
        "path": "retro/chip_pulse.vibe"
      },
      {
        "name": "chip_triangle",
        "description": "NES-style triangle wave bass",
        "genre": "Chiptune, 8-bit",
        "character": "NES-style triangle wave bass",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Chiptune, 8-bit | Character: NES-style triangle wave bass\ndefine_synthdef(\"chip_triangle\")\n    .param(\"freq\", 110.0)\n    .param(\"amp\", 0.7)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pure triangle wave\n        let osc = lf_tri_ar(freq);\n\n        osc * env * amp\n    });\n",
        "category": "retro",
        "subcategory": "",
        "path": "retro/chip_triangle.vibe"
      },
      {
        "name": "sfx_coin",
        "description": "Coin collect sound effect",
        "genre": "Video Game, Chiptune",
        "character": "Coin collect sound effect",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Video Game, Chiptune | Character: Coin collect sound effect\ndefine_synthdef(\"sfx_coin\")\n    .param(\"freq\", 1200.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        let amp_env = envelope()\n            .perc(0.001, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Two-tone coin sound\n        let tone1 = sin_osc_ar(freq) * 0.5;\n        let tone2_e = envelope()\n            .perc(0.05, 0.1)\n            .build();\n        let tone2 = sin_osc_ar(freq * 1.5) * tone2_e * 0.5;\n\n        (tone1 + tone2) * amp_env * amp\n    });\n",
        "category": "retro",
        "subcategory": "",
        "path": "retro/sfx_coin.vibe"
      },
      {
        "name": "sfx_jump",
        "description": "Jump sound effect",
        "genre": "Video Game, Chiptune",
        "character": "Jump sound effect",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Video Game, Chiptune | Character: Jump sound effect\ndefine_synthdef(\"sfx_jump\")\n    .param(\"freq\", 150.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        let amp_env = envelope()\n            .perc(0.001, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Quick pitch up then down\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let sweep_freq = freq + pitch_env * freq * 3.0;\n\n        // Triangle wave\n        let osc = lf_tri_ar(sweep_freq);\n\n        osc * amp_env * amp\n    });\n",
        "category": "retro",
        "subcategory": "",
        "path": "retro/sfx_jump.vibe"
      },
      {
        "name": "sfx_laser",
        "description": "Laser/shoot sound effect",
        "genre": "Video Game, Chiptune",
        "character": "Laser/shoot sound effect",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Video Game, Chiptune | Character: Laser/shoot sound effect\ndefine_synthdef(\"sfx_laser\")\n    .param(\"freq\", 800.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        let amp_env = envelope()\n            .perc(0.001, 0.1)\n            .cleanup_on_finish()\n            .build();\n\n        // Descending pitch\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let sweep_freq = freq * (1.0 + pitch_env * 2.0);\n\n        // Square wave\n        let osc = pulse_ar(sweep_freq, 0.5);\n\n        // Add noise burst\n        let noise_e = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 5000.0) * noise_e * 0.3;\n\n        (osc + noise) * amp_env * amp\n    });\n",
        "category": "retro",
        "subcategory": "",
        "path": "retro/sfx_laser.vibe"
      },
      {
        "name": "sfx_powerup",
        "description": "Power-up ascending sound",
        "genre": "Video Game, Chiptune",
        "character": "Power-up ascending sound",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Video Game, Chiptune | Character: Power-up ascending sound\ndefine_synthdef(\"sfx_powerup\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Ascending pitch\n        let pitch_env = envelope()\n            .perc(0.001, 0.35)\n            .build();\n        let sweep_freq = freq + pitch_env * freq * 4.0;\n\n        // Pulse wave for chip sound\n        let osc = pulse_ar(sweep_freq, 0.5);\n\n        osc * amp_env * amp\n    });\n",
        "category": "retro",
        "subcategory": "",
        "path": "retro/sfx_powerup.vibe"
      },
      {
        "name": "synth_80s_brass",
        "description": "Classic 80s brass stab",
        "genre": "Synthwave, 80s",
        "character": "Classic 80s brass stab",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Synthwave, 80s | Character: Classic 80s brass stab\ndefine_synthdef(\"synth_80s_brass\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.02, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.02, 0.3)\n            .build();\n\n        // Detuned saws\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n\n        let mix = (osc1 + osc2 + osc3) * 0.35;\n\n        // Bright filter sweep\n        let cutoff = 1000.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.2) * env * amp\n    });\n",
        "category": "retro",
        "subcategory": "",
        "path": "retro/synth_80s_brass.vibe"
      }
    ]
  },
  "Strings": {
    "subcategories": {},
    "items": [
      {
        "name": "acoustic_guitar",
        "description": "steel string dreadnought style",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "position",
            "default": 0.5
          },
          {
            "name": "pluck_hard",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"acoustic_guitar\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"position\", 0.5)     // 0=bridge (bright), 1=neck (mellow)\n        .param(\"pluck_hard\", 0.6)   // Pluck hardness\n        .body(|freq, amp, gate, position, pluck_hard| {\n            // String decay time - lower notes ring longer\n            let decay_time = 1.5 + (1.0 / (freq / 80.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Pluck excitation - filtered noise burst\n            let excite_env = envelope()\n                .perc(0.0003, 1.0)\n                .time_scale(0.003 + ((1.0 - pluck_hard) * 0.004))\n                .build();\n            let excite_noise = white_noise_ar() * excite_env;\n\n            // Filter excitation based on pluck position\n            // Near bridge = brighter (higher cutoff)\n            let excite_cutoff = 2000.0 + ((1.0 - position) * 6000.0 * pluck_hard);\n            let excite = lpf_ar(excite_noise, excite_cutoff) * 0.8;\n\n            // String harmonics - guitar has rich harmonic content\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.25;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.18;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.12;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.08;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Pluck position affects harmonic emphasis\n            // Node at position suppresses harmonics that have nodes there\n            let pos_filter = 1500.0 + (position * 3000.0);\n            let string_filtered = rlpf_ar(string_tone, pos_filter, 0.5);\n\n            // Body resonance - acoustic guitar body frequencies\n            // Main air resonance around 100Hz (sound hole)\n            let body1 = rlpf_ar(string_filtered + excite, 98.0, 0.3) * 0.35;\n            // Top plate resonance\n            let body2 = rlpf_ar(string_filtered + excite, 200.0, 0.4) * 0.25;\n            // Back plate\n            let body3 = rlpf_ar(string_filtered + excite, 380.0, 0.35) * 0.2;\n            // Higher body modes\n            let body4 = rlpf_ar(string_filtered, 580.0, 0.4) * 0.15;\n\n            // High frequency damping over time\n            let hf_env = envelope()\n                .perc(0.001, 0.4)\n                .time_scale(decay_time)\n                .build();\n            let hf_cutoff = 1500.0 + (hf_env * 5000.0);\n\n            let tone = string_filtered + body1 + body2 + body3 + body4;\n            let damped = lpf_ar(tone, hf_cutoff);\n\n            let output = (damped + excite * 0.3) * env * amp * 0.45;\n            output.softclip()\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/acoustic_guitar.vibe"
      },
      {
        "name": "classical_guitar",
        "description": "Nylon String Classical Guitar",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "position",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"classical_guitar\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"position\", 0.6)\n        .body(|freq, amp, gate, position| {\n            let decay_time = 2.0 + (1.0 / (freq / 60.0));\n            let env = envelope()\n                .perc(0.002, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Softer pluck for nylon strings\n            let excite_env = envelope()\n                .perc(0.001, 0.008)\n                .build();\n            let excite = lpf_ar(white_noise_ar() * excite_env, 2500.0) * 0.5;\n\n            // Nylon has fewer high harmonics, rounder tone\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.12;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.06;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Classical guitar body - different resonances\n            let body1 = rlpf_ar(string_tone + excite, 95.0, 0.35) * 0.4;\n            let body2 = rlpf_ar(string_tone + excite, 185.0, 0.4) * 0.3;\n            let body3 = rlpf_ar(string_tone, 350.0, 0.35) * 0.2;\n\n            // Warmer overall - lower cutoff\n            let cutoff = 2500.0 + (position * 1500.0);\n            let filtered = lpf_ar(string_tone + body1 + body2 + body3, cutoff);\n\n            let output = (filtered + excite * 0.2) * env * amp * 0.5;\n            output\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/acoustic_guitar.vibe"
      },
      {
        "name": "fingerpick_guitar",
        "description": "optimized for fingerstyle",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.55
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "nail",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"fingerpick_guitar\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .param(\"nail\", 0.4)  // Amount of fingernail vs flesh\n        .body(|freq, amp, gate, nail| {\n            let decay_time = 1.8 + (1.0 / (freq / 90.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Finger pluck - softer than pick\n            let excite_env = envelope()\n                .perc(0.0005, 0.006)\n                .build();\n            let excite_cutoff = 1800.0 + (nail * 4000.0);\n            let excite = lpf_ar(white_noise_ar() * excite_env, excite_cutoff) * 0.6;\n\n            // Warm string tone\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.4;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.28;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.18;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.1;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.05;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Body resonance\n            let body1 = rlpf_ar(string_tone + excite, 100.0, 0.35) * 0.35;\n            let body2 = rlpf_ar(string_tone + excite, 210.0, 0.4) * 0.25;\n            let body3 = rlpf_ar(string_tone, 400.0, 0.35) * 0.18;\n\n            let tone = string_tone + body1 + body2 + body3;\n\n            // Overall warmth\n            let filtered = lpf_ar(tone, 4000.0 + (nail * 2000.0));\n\n            let output = (filtered + excite * 0.25) * env * amp * 0.5;\n            output.softclip()\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/acoustic_guitar.vibe"
      },
      {
        "name": "twelve_string_guitar",
        "description": "double strings create chorus effect",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.55
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "detune",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"twelve_string_guitar\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .param(\"detune\", 0.5)\n        .body(|freq, amp, gate, detune| {\n            let decay_time = 1.6 + (1.0 / (freq / 100.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Pluck excitation\n            let excite_env = envelope()\n                .perc(0.0003, 0.004)\n                .build();\n            let excite = lpf_ar(white_noise_ar() * excite_env, 5000.0) * 0.6;\n\n            // Main string\n            let detune_amt = 0.002 + (detune * 0.004);\n            let h1a = sin_osc_ar(freq) * 0.5;\n            let h1b = sin_osc_ar(freq * (1.0 + detune_amt)) * 0.5;  // Paired string\n\n            // Lower strings have octave pair\n            let octave_mix = 0.4;\n            let h1c = sin_osc_ar(freq * 2.0) * octave_mix * 0.4;  // Octave string\n            let h1d = sin_osc_ar(freq * 2.0 * (1.0 - detune_amt * 0.5)) * octave_mix * 0.4;\n\n            let h2a = sin_osc_ar(freq * 2.0) * 0.35;\n            let h2b = sin_osc_ar(freq * 2.0 * (1.0 + detune_amt)) * 0.35;\n\n            let h3a = sin_osc_ar(freq * 3.0) * 0.25;\n            let h3b = sin_osc_ar(freq * 3.0 * (1.0 + detune_amt)) * 0.25;\n\n            let h4a = sin_osc_ar(freq * 4.0) * 0.15;\n            let h4b = sin_osc_ar(freq * 4.0 * (1.0 + detune_amt)) * 0.15;\n\n            let string_tone = h1a + h1b + h1c + h1d + h2a + h2b + h3a + h3b + h4a + h4b;\n\n            // Body\n            let body1 = rlpf_ar(string_tone + excite, 100.0, 0.35) * 0.3;\n            let body2 = rlpf_ar(string_tone + excite, 220.0, 0.4) * 0.22;\n\n            let tone = string_tone + body1 + body2;\n            let filtered = lpf_ar(tone, 6000.0);\n\n            let output = (filtered + excite * 0.2) * env * amp * 0.35;\n            output.softclip()\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/acoustic_guitar.vibe"
      },
      {
        "name": "guitar_harmonic",
        "description": "natural harmonic sound",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"guitar_harmonic\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let decay_time = 3.0;\n            let env = envelope()\n                .perc(0.001, decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Harmonics are pure - very few other partials\n            let main = sin_osc_ar(freq) * 1.0;\n            let slight_2nd = sin_osc_ar(freq * 2.0) * 0.08;\n\n            // Bell-like attack\n            let attack_env = envelope()\n                .perc(0.0002, 0.002)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.1;\n\n            let tone = main + slight_2nd;\n\n            // Very clean, high passed\n            let clean = hpf_ar(tone, 200.0);\n\n            let output = (clean + attack) * env * amp * 0.6;\n            output\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/acoustic_guitar.vibe"
      },
      {
        "name": "guitar_muted",
        "description": "Muted/Palm Muted Guitar",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "mute_amount",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"guitar_muted\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"mute_amount\", 0.7)\n        .body(|freq, amp, gate, mute_amount| {\n            // Very short decay when muted\n            let decay_time = 0.15 + ((1.0 - mute_amount) * 0.6);\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Punchy attack\n            let attack_env = envelope()\n                .perc(0.0003, 0.008)\n                .build();\n            let attack = lpf_ar(white_noise_ar() * attack_env, 3000.0) * 0.5;\n\n            // Muted string - suppressed high harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5 * (1.0 - mute_amount * 0.5);\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3 * (1.0 - mute_amount * 0.7);\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15 * (1.0 - mute_amount * 0.9);\n\n            let string_tone = h1 + h2 + h3 + h4;\n\n            // Heavy low-pass for muted character\n            let cutoff = 800.0 + ((1.0 - mute_amount) * 2000.0);\n            let filtered = lpf_ar(string_tone, cutoff);\n\n            let output = (filtered + attack) * env * amp * 0.6;\n            output.softclip()\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/acoustic_guitar.vibe"
      },
      {
        "name": "upright_bass",
        "description": "Acoustic pizzicato (plucked)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 82.41
          },
          {
            "name": "amp",
            "default": 0.65
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "position",
            "default": 0.5
          },
          {
            "name": "finger_noise",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"upright_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)    // E2\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"position\", 0.5)     // Playing position (0=bridge, 1=fingerboard)\n        .param(\"finger_noise\", 0.4)\n        .body(|freq, amp, gate, position, finger_noise| {\n            // Pizzicato envelope\n            let decay_time = 1.2 + (1.0 / (freq / 40.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Finger pluck transient\n            let pluck_env = envelope()\n                .perc(0.0005, 0.008)\n                .build();\n            let pluck = white_noise_ar() * pluck_env * 0.3;\n            let pluck_filtered = lpf_ar(pluck, 1500.0 + ((1.0 - position) * 2000.0));\n\n            // String harmonics - thick gut/steel string\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.22;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.14;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.08;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Position affects brightness\n            let pos_cutoff = 800.0 + ((1.0 - position) * 1500.0);\n            let positioned = lpf_ar(string_tone, pos_cutoff);\n\n            // Large body resonance\n            let body1 = rlpf_ar(positioned + pluck_filtered, 60.0, 0.35) * 0.5;   // Bass resonance\n            let body2 = rlpf_ar(positioned, 200.0, 0.4) * 0.35;  // Body mode\n            let body3 = rlpf_ar(positioned, 450.0, 0.4) * 0.25;  // Top plate\n\n            // Finger noise on release\n            let noise = white_noise_ar() * finger_noise * 0.04;\n            let noise_filtered = bpf_ar(noise, 1200.0, 0.5);\n\n            let tone = positioned + body1 + body2 + body3 + pluck_filtered + noise_filtered;\n\n            hpf_ar(tone, 35.0) * env * amp * 0.5\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/bass_instruments.vibe"
      },
      {
        "name": "upright_bass_bowed",
        "description": "Arco (bowed)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 82.41
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "bow_pressure",
            "default": 0.6
          },
          {
            "name": "bow_position",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"upright_bass_bowed\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"bow_pressure\", 0.6)\n        .param(\"bow_position\", 0.5)\n        .body(|freq, amp, gate, bow_pressure, bow_position| {\n            let env = envelope()\n                .asr(0.12, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slow vibrato\n            let vib_delay = envelope()\n                .perc(0.4, 4.0)\n                .build();\n            let vib = sin_osc_ar(5.0) * 0.004 * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Bowed string - sawtooth-like with bow noise\n            let h1 = saw_ar(mod_freq) * 0.4;\n            let h2 = saw_ar(mod_freq * 1.001) * 0.3;  // Slight chorus\n\n            let string_tone = h1 + h2;\n\n            // Bow noise - rosin scratching\n            let bow_noise = white_noise_ar() * bow_pressure * 0.06;\n            let bow_filtered = bpf_ar(bow_noise, mod_freq * 3.0, 0.4);\n\n            // Position affects tone\n            let pos_cutoff = 600.0 + ((1.0 - bow_position) * 1200.0);\n            let positioned = lpf_ar(string_tone, pos_cutoff);\n\n            // Body resonance\n            let body1 = rlpf_ar(positioned, 65.0, 0.35) * 0.45;\n            let body2 = rlpf_ar(positioned, 220.0, 0.4) * 0.35;\n            let body3 = rlpf_ar(positioned, 500.0, 0.4) * 0.2;\n\n            let tone = positioned + body1 + body2 + body3 + bow_filtered;\n\n            hpf_ar(tone, 35.0) * env * amp * 0.55\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/bass_instruments.vibe"
      },
      {
        "name": "electric_bass",
        "description": "Precision Bass style (split coil)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 82.41
          },
          {
            "name": "amp",
            "default": 0.65
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "tone",
            "default": 0.6
          },
          {
            "name": "attack_style",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"electric_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"tone\", 0.6)          // Tone knob\n        .param(\"attack_style\", 0.5)  // 0=finger, 1=pick\n        .body(|freq, amp, gate, tone, attack_style| {\n            let decay_time = 2.0 + (1.0 / (freq / 50.0));\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sustain envelope\n            let sus_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .build();\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.0003, 1.0)\n                .time_scale(0.004 + ((1.0 - attack_style) * 0.006))\n                .build();\n            let attack_cutoff = 2000.0 + (attack_style * 3000.0);\n            let attack = lpf_ar(white_noise_ar() * attack_env, attack_cutoff) * 0.25;\n\n            // String harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.4;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.08;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // P-Bass pickup - warm, punchy\n            let pickup = rlpf_ar(string_tone, 1000.0, 0.4);\n\n            // Tone control\n            let tone_cutoff = 500.0 + (tone * 3000.0);\n            let toned = lpf_ar(pickup, tone_cutoff);\n\n            // Amp simulation - slight warmth\n            let amped = (toned * 1.1).softclip();\n\n            let output = (amped + attack) * env * sus_env * amp * 0.5;\n            hpf_ar(output, 30.0)\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/bass_instruments.vibe"
      },
      {
        "name": "jazz_bass",
        "description": "Jazz Bass style (dual single coil)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 82.41
          },
          {
            "name": "amp",
            "default": 0.65
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "neck_pickup",
            "default": 0.7
          },
          {
            "name": "bridge_pickup",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"jazz_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"neck_pickup\", 0.7)\n        .param(\"bridge_pickup\", 0.5)\n        .body(|freq, amp, gate, neck_pickup, bridge_pickup| {\n            let decay_time = 2.5 + (1.0 / (freq / 50.0));\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let sus_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .build();\n\n            // Finger attack\n            let attack_env = envelope()\n                .perc(0.0005, 0.008)\n                .build();\n            let attack = lpf_ar(white_noise_ar() * attack_env, 2500.0) * 0.2;\n\n            // String tone\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.38;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.24;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.09;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.05;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Neck pickup - warm\n            let neck = rlpf_ar(string_tone, 800.0, 0.4) * neck_pickup;\n\n            // Bridge pickup - bright, growly\n            let bridge = rlpf_ar(string_tone, 2000.0, 0.35) * bridge_pickup;\n\n            // Mix pickups - J-Bass has characteristic mid scoop when both on\n            let mix = neck * 0.6 + bridge * 0.4;\n\n            // J-Bass has more mid growl\n            let growl = rlpf_ar(string_tone, 700.0, 0.3) * 0.2;\n\n            let output = (mix + growl + attack) * env * sus_env * amp * 0.5;\n            hpf_ar(output, 30.0)\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/bass_instruments.vibe"
      },
      {
        "name": "fretless_bass",
        "description": "Fretless Electric Bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 82.41
          },
          {
            "name": "amp",
            "default": 0.65
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "mwah",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"fretless_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"mwah\", 0.6)     // Characteristic fretless \"mwah\"\n        .body(|freq, amp, gate, mwah| {\n            let decay_time = 2.0 + (1.0 / (freq / 50.0));\n            let env = envelope()\n                .asr(0.005, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let sus_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .build();\n\n            // Soft finger attack\n            let attack_env = envelope()\n                .perc(0.001, 0.012)\n                .build();\n            let attack = lpf_ar(white_noise_ar() * attack_env, 1500.0) * 0.15;\n\n            // String harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.22;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.14;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5;\n\n            // \"Mwah\" effect - resonant harmonic at string/finger contact\n            // This is the singing quality of fretless\n            let mwah_freq = freq * 3.0;  // Third harmonic\n            let mwah_env = envelope()\n                .perc(0.01, 0.3)\n                .build();\n            let mwah_tone = rlpf_ar(string_tone, mwah_freq, 0.1) * mwah * mwah_env * 0.4;\n\n            // Smooth, singing tone\n            let smooth = lpf_ar(string_tone, 2500.0);\n\n            let output = (smooth + mwah_tone + attack) * env * sus_env * amp * 0.5;\n            hpf_ar(output, 30.0)\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/bass_instruments.vibe"
      },
      {
        "name": "slap_bass",
        "description": "Slap Bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 82.41
          },
          {
            "name": "amp",
            "default": 0.65
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "slap_pop",
            "default": "0.0"
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"slap_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"slap_pop\", 0.0)  // 0=slap (thumb), 1=pop (finger)\n        .body(|freq, amp, gate, slap_pop| {\n            let decay_time = 0.8;\n            let env = envelope()\n                .perc(0.001, decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Slap attack - thumb hitting string against fretboard\n            let slap_env = envelope()\n                .perc(0.0001, 0.003)\n                .build();\n            let slap_noise = white_noise_ar() * slap_env * (1.0 - slap_pop) * 0.4;\n            let slap_filtered = bpf_ar(slap_noise, 1500.0, 0.3);\n\n            // Pop attack - string snapping against fretboard\n            let pop_env = envelope()\n                .perc(0.0001, 0.002)\n                .build();\n            let pop_noise = white_noise_ar() * pop_env * slap_pop * 0.5;\n            let pop_filtered = hpf_ar(pop_noise, 3000.0);\n\n            // Bright, aggressive harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.3;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.22;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.15;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.1;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Bright pickup for slap\n            let bright = rlpf_ar(string_tone, 3000.0, 0.3);\n\n            // Compression effect\n            let compressed = (bright * 1.5).softclip();\n\n            let output = (compressed + slap_filtered + pop_filtered) * env * amp * 0.45;\n            hpf_ar(output, 35.0)\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/bass_instruments.vibe"
      },
      {
        "name": "synth_bass_moog",
        "description": "Moog-style",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 55
          },
          {
            "name": "amp",
            "default": 0.7
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "cutoff",
            "default": 800
          },
          {
            "name": "resonance",
            "default": 0.5
          },
          {
            "name": "filter_env",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"synth_bass_moog\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 800.0)\n        .param(\"resonance\", 0.5)\n        .param(\"filter_env\", 0.6)\n        .body(|freq, amp, gate, cutoff, resonance, filter_env| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Classic Moog oscillators - saw + square sub\n            let saw1 = saw_ar(freq) * 0.5;\n            let saw2 = saw_ar(freq * 1.005) * 0.4;  // Slight detune\n            let sub = pulse_ar(freq * 0.5, 0.5) * 0.4;  // Sub oscillator\n\n            let osc_mix = saw1 + saw2 + sub;\n\n            // Moog ladder filter\n            let mod_cutoff = cutoff + (filt_env * filter_env * cutoff * 4.0);\n            let res_val = resonance * 3.5;  // Moog resonance goes to self-oscillation\n            let filtered = moog_ff_ar(osc_mix, mod_cutoff, res_val, 0.0);\n\n            // Slight saturation\n            let warm = (filtered * 1.2).tanh();\n\n            warm * env * amp * 0.5\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/bass_instruments.vibe"
      },
      {
        "name": "acid_bass",
        "description": "303 Acid style",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 55
          },
          {
            "name": "amp",
            "default": 0.7
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "cutoff",
            "default": 400
          },
          {
            "name": "resonance",
            "default": 0.7
          },
          {
            "name": "env_mod",
            "default": 0.8
          },
          {
            "name": "accent",
            "default": "0.0"
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"acid_bass\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 400.0)\n        .param(\"resonance\", 0.7)\n        .param(\"env_mod\", 0.8)\n        .param(\"accent\", 0.0)\n        .body(|freq, amp, gate, cutoff, resonance, env_mod, accent| {\n            let env = envelope()\n                .perc(0.001, 0.2)\n                .cleanup_on_finish()\n                .build();\n\n            // 303 filter envelope - very snappy\n            let filt_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            // 303 oscillator - saw or square\n            let osc = saw_ar(freq);\n\n            // Classic 303 filter - resonant sweep\n            let accent_boost = 1.0 + (accent * 2.0);\n            let mod_cutoff = cutoff + (filt_env * env_mod * cutoff * 6.0 * accent_boost);\n            let res = 0.1 / (resonance * 0.9 + 0.1);  // Convert to rq\n\n            let filtered = rlpf_ar(osc, mod_cutoff, res);\n\n            // 303 distortion\n            let dist = (filtered * (1.5 + accent)).tanh();\n\n            dist * env * amp * 0.5\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/bass_instruments.vibe"
      },
      {
        "name": "picked_bass",
        "description": "Rock/Metal style",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 82.41
          },
          {
            "name": "amp",
            "default": 0.65
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "pick_attack",
            "default": 0.8
          },
          {
            "name": "drive",
            "default": 0.3
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"picked_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"pick_attack\", 0.8)\n        .param(\"drive\", 0.3)\n        .body(|freq, amp, gate, pick_attack, drive| {\n            let decay_time = 1.5;\n            let env = envelope()\n                .asr(0.001, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let sus_env = envelope()\n                .perc(0.001, decay_time)\n                .build();\n\n            // Hard pick attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.002)\n                .build();\n            let attack = hpf_ar(white_noise_ar() * attack_env, 2500.0) * pick_attack * 0.35;\n\n            // Aggressive harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.25;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.18;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.12;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Bridge pickup - aggressive\n            let pickup = rlpf_ar(string_tone, 1500.0, 0.35);\n\n            // Amp drive\n            let driven = (pickup * (1.0 + drive * 2.0)).tanh();\n\n            // Bright EQ\n            let bright = hpf_ar(driven, 60.0);\n\n            let output = (bright + attack) * env * sus_env * amp * 0.5;\n            output.softclip()\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/bass_instruments.vibe"
      },
      {
        "name": "electric_guitar_clean",
        "description": "Fender-style single coil",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "pickup_pos",
            "default": 0.5
          },
          {
            "name": "tone",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"electric_guitar_clean\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"pickup_pos\", 0.5)    // 0=bridge, 1=neck\n        .param(\"tone\", 0.6)          // Tone knob\n        .body(|freq, amp, gate, pickup_pos, tone| {\n            let decay_time = 2.5 + (1.0 / (freq / 80.0));\n            let env = envelope()\n                .asr(0.001, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pick attack\n            let attack_env = envelope()\n                .perc(0.0002, 0.004)\n                .build();\n            let attack = lpf_ar(white_noise_ar() * attack_env, 4000.0) * 0.3;\n\n            // Electric guitar string - sawtooth-like with harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.28;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.2;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.15;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.1;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Single coil pickup characteristics\n            // Bridge pickup = brighter, more bite\n            // Neck pickup = warmer, fuller\n            let pickup_cutoff = 2500.0 + ((1.0 - pickup_pos) * 4000.0);\n            let pickup_resonance = 0.3 + (pickup_pos * 0.2);\n\n            // Pickup frequency response - single coils have characteristic resonant peak\n            let pickup_peak = 3000.0 + ((1.0 - pickup_pos) * 2000.0);\n            let pickup = rlpf_ar(string_tone, pickup_peak, pickup_resonance);\n\n            // Tone control (passive LP filter)\n            let tone_cutoff = 1000.0 + (tone * 6000.0);\n            let toned = lpf_ar(pickup, tone_cutoff);\n\n            // Clean amp - slight warmth\n            let amped = toned * 1.2;\n            let warm = lpf_ar(amped, 8000.0);\n\n            // Sustain envelope for body decay\n            let sus_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .build();\n\n            let output = (warm + attack) * env * sus_env * amp * 0.5;\n            output\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/electric_guitar.vibe"
      },
      {
        "name": "electric_guitar_crunch",
        "description": "Edge of breakup",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "gain",
            "default": 0.5
          },
          {
            "name": "tone",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"electric_guitar_crunch\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"gain\", 0.5)\n        .param(\"tone\", 0.6)\n        .body(|freq, amp, gate, gain, tone| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Harder pick attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.003)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.25;\n\n            // Humbucker-style darker tone\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.3;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.22;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.15;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Pre-gain EQ boost\n            let boosted = rlpf_ar(string_tone, 800.0, 0.5) * 0.4 + string_tone;\n\n            // Tube-style soft clipping\n            let drive = 1.0 + (gain * 3.0);\n            let driven = (boosted * drive).tanh();\n\n            // Post-distortion EQ\n            let tone_cutoff = 2000.0 + (tone * 4000.0);\n            let toned = lpf_ar(driven, tone_cutoff);\n\n            // Cabinet simulation - remove harsh highs\n            let cabinet = lpf_ar(toned, 5000.0);\n            let cab_body = rlpf_ar(cabinet, 400.0, 0.6) * 0.2;\n\n            let output = (cabinet + cab_body + attack) * env * amp * 0.5;\n            output.softclip()\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/electric_guitar.vibe"
      },
      {
        "name": "electric_guitar_distorted",
        "description": "Metal/Rock distortion",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "gain",
            "default": 0.8
          },
          {
            "name": "tone",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"electric_guitar_distorted\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"gain\", 0.8)\n        .param(\"tone\", 0.5)\n        .body(|freq, amp, gate, gain, tone| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Aggressive pick attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.002)\n                .build();\n            let attack = hpf_ar(white_noise_ar() * attack_env, 1000.0) * 0.2;\n\n            // Thick humbucker tone\n            let h1 = saw_ar(freq) * 0.5;\n            let h2 = saw_ar(freq * 0.999) * 0.3;  // Slight detune for thickness\n            let h3 = saw_ar(freq * 1.001) * 0.3;\n\n            let raw = h1 + h2 + h3;\n\n            // Tight low-end before distortion\n            let tight = hpf_ar(raw, 80.0);\n\n            // Multi-stage gain (tube amp simulation)\n            let drive1 = 2.0 + (gain * 4.0);\n            let stage1 = (tight * drive1).tanh();\n\n            // Inter-stage EQ\n            let mid_boost = rlpf_ar(stage1, 1000.0, 0.4) * 0.3;\n            let stage1_eq = stage1 + mid_boost;\n\n            // Second gain stage\n            let drive2 = 1.5 + (gain * 2.0);\n            let stage2 = (stage1_eq * drive2).tanh();\n\n            // Post-distortion tone shaping\n            let high_cut = 3000.0 + (tone * 3000.0);\n            let low_cut = 80.0 + ((1.0 - tone) * 60.0);\n\n            let shaped = lpf_ar(hpf_ar(stage2, low_cut), high_cut);\n\n            // Cabinet simulation - 4x12 style\n            let cab1 = rlpf_ar(shaped, 2500.0, 0.5) * 0.6;\n            let cab2 = rlpf_ar(shaped, 500.0, 0.6) * 0.4;\n            let cab3 = lpf_ar(shaped, 4500.0);\n\n            let cabinet = (cab1 + cab2 + cab3) * 0.4;\n\n            // Noise gate effect - clean silence\n            let output = (cabinet + attack) * env * amp * 0.5;\n            output.softclip()\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/electric_guitar.vibe"
      },
      {
        "name": "electric_guitar_jazz",
        "description": "Warm, round tone",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "warmth",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"electric_guitar_jazz\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"warmth\", 0.7)\n        .body(|freq, amp, gate, warmth| {\n            let decay_time = 2.0 + (1.0 / (freq / 100.0));\n            let env = envelope()\n                .asr(0.002, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Soft thumb/finger attack\n            let attack_env = envelope()\n                .perc(0.001, 0.01)\n                .build();\n            let attack = lpf_ar(white_noise_ar() * attack_env, 1500.0) * 0.15;\n\n            // Hollow body guitar tone - fewer high harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.08;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5;\n\n            // Neck humbucker - very warm\n            let pickup = lpf_ar(string_tone, 2500.0);\n\n            // Rolled off tone knob\n            let tone_cutoff = 1200.0 + ((1.0 - warmth) * 2000.0);\n            let toned = lpf_ar(pickup, tone_cutoff);\n\n            // Hollow body resonance\n            let body_res = rlpf_ar(toned, 180.0, 0.5) * 0.25;\n\n            // Clean amp with slight warmth\n            let amped = (toned + body_res) * 1.1;\n\n            // Sustain\n            let sus_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .build();\n\n            let output = (amped + attack) * env * sus_env * amp * 0.5;\n            output\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/electric_guitar.vibe"
      },
      {
        "name": "electric_guitar_funk",
        "description": "Bright, percussive",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"electric_guitar_funk\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Short, percussive envelope\n            let env = envelope()\n                .perc(0.001, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Sharp attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.002)\n                .build();\n            let attack = hpf_ar(white_noise_ar() * attack_env, 2000.0) * 0.3;\n\n            // Bright single coil\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.3;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.22;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.15;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.1;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Bridge pickup - bright and snappy\n            let pickup = rlpf_ar(string_tone, 4000.0, 0.3);\n\n            // Bright tone\n            let bright = hpf_ar(pickup, 200.0);\n\n            // Compression effect (soft clip)\n            let compressed = (bright * 1.5).softclip();\n\n            let output = (compressed + attack) * env * amp * 0.5;\n            output\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/electric_guitar.vibe"
      },
      {
        "name": "power_chord",
        "description": "Thick rhythm guitar",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 82.41
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "gain",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"power_chord\", |builder| {\n    builder\n        .param(\"freq\", 82.41)   // Low E default\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"gain\", 0.7)\n        .body(|freq, amp, gate, gain| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Root note\n            let root1 = saw_ar(freq) * 0.4;\n            let root2 = saw_ar(freq * 1.002) * 0.4;\n\n            // Fifth (7 semitones up = freq * 1.498)\n            let fifth_freq = freq * 1.498;\n            let fifth1 = saw_ar(fifth_freq) * 0.35;\n            let fifth2 = saw_ar(fifth_freq * 0.998) * 0.35;\n\n            // Octave\n            let oct = saw_ar(freq * 2.0) * 0.25;\n\n            let chord = root1 + root2 + fifth1 + fifth2 + oct;\n\n            // Tight low end\n            let tight = hpf_ar(chord, 60.0);\n\n            // Distortion\n            let drive = 2.0 + (gain * 4.0);\n            let dist = (tight * drive).tanh();\n\n            // Tone shaping\n            let shaped = lpf_ar(hpf_ar(dist, 80.0), 4000.0);\n\n            // Cabinet\n            let cab = rlpf_ar(shaped, 2000.0, 0.5);\n\n            let output = cab * env * amp * 0.4;\n            output.softclip()\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/electric_guitar.vibe"
      },
      {
        "name": "electric_guitar_wah",
        "description": "with auto-wah effect",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "wah_rate",
            "default": 2
          },
          {
            "name": "wah_depth",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"electric_guitar_wah\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"wah_rate\", 2.0)\n        .param(\"wah_depth\", 0.7)\n        .body(|freq, amp, gate, wah_rate, wah_depth| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // String tone\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.45;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.3;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.2;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.12;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Wah LFO\n            let wah_lfo = sin_osc_ar(wah_rate) * 0.5 + 0.5;  // 0 to 1\n\n            // Wah filter sweep\n            let wah_low = 400.0;\n            let wah_high = 2500.0;\n            let wah_freq = wah_low + (wah_lfo * wah_depth * (wah_high - wah_low));\n\n            let wah = rlpf_ar(string_tone, wah_freq, 0.15);\n\n            // Slight overdrive\n            let driven = (wah * 1.5).softclip();\n\n            let output = driven * env * amp * 0.5;\n            output\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/electric_guitar.vibe"
      },
      {
        "name": "harp",
        "description": "Concert harp with characteristic resonant pluck.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"harp\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Harp envelope\n            let env = envelope()\n                .asr(0.003, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Long decay\n            let decay_env = envelope()\n                .perc(0.001, 2.0)\n                .build();\n\n            // Harp string harmonics\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.05;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5;\n\n            // Pluck attack\n            let pluck_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let pluck = white_noise_ar() * pluck_env * 0.15;\n\n            // Body resonance\n            let body = rlpf_ar(harmonics, 1800.0, 0.2);\n            let bright = hpf_ar(body, 100.0);\n\n            (bright + pluck) * env * decay_env * amp * 0.7\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/harp.vibe"
      },
      {
        "name": "pizzicato",
        "description": "Plucked string sound for pizzicato passages.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"pizzicato\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Short pluck envelope (gate-controlled for poly)\n            let env = envelope()\n                .asr(0.001, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast decay envelope\n            let decay_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Plucked string (bright attack, fast decay)\n            let fund = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.08;\n\n            let harmonics = fund + h2 + h3 + h4 + h5;\n\n            // Pluck transient\n            let pluck_env = envelope()\n                .perc(0.0001, 0.02)\n                .build();\n            let pluck = white_noise_ar() * pluck_env * 0.2;\n\n            // Filter sweep for pluck character\n            let filter_freq = 1500.0 + decay_env * 3000.0;\n            let filtered = lpf_ar(harmonics + pluck, filter_freq);\n\n            filtered * env * decay_env * amp\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/pizzicato.vibe"
      },
      {
        "name": "solo_cello",
        "description": "Deep cello-like sound with expressive vibrato.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "vibrato",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"solo_cello\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"vibrato\", 0.5) // Vibrato amount\n        .body(|freq, amp, gate, vibrato| {\n            // Smooth bowing envelope\n            let env = envelope()\n                .asr(0.15, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slower, deeper vibrato than violin\n            let vib_freq = 4.5;\n            let vib_depth = vibrato * 0.012;\n            let vib = sin_osc_ar(vib_freq) * vib_depth + 1.0;\n            let mod_freq = freq * vib;\n\n            // Rich bowed tone\n            let osc1 = saw_ar(mod_freq);\n            let osc2 = saw_ar(mod_freq * 0.999) * 0.6;\n            let sub = sin_osc_ar(mod_freq * 0.5) * 0.3;\n\n            let string = (osc1 + osc2) * 0.5 + sub;\n\n            // Cello body resonance (lower formants)\n            let body1 = rlpf_ar(string, 400.0, 0.3) * 0.5;\n            let body2 = rlpf_ar(string, 1200.0, 0.3) * 0.3;\n            let body3 = rlpf_ar(string, 2000.0, 0.4) * 0.2;\n\n            let cello = body1 + body2 + body3;\n\n            // Warm low pass\n            let warm = lpf_ar(cello, 3000.0);\n\n            warm * env * amp * 0.8\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/solo_cello.vibe"
      },
      {
        "name": "solo_violin",
        "description": "Solo violin-like sound with vibrato and bow noise.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "vibrato",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"solo_violin\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"vibrato\", 0.6) // Vibrato amount\n        .body(|freq, amp, gate, vibrato| {\n            // Bowed string envelope\n            let env = envelope()\n                .asr(0.1, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib_freq = 5.5;\n            let vib_depth = vibrato * 0.015;\n            let vib = sin_osc_ar(vib_freq) * vib_depth + 1.0;\n            let mod_freq = freq * vib;\n\n            // Sawtooth-like bowed string\n            let osc1 = saw_ar(mod_freq);\n            let osc2 = saw_ar(mod_freq * 1.002) * 0.5;\n\n            let string = (osc1 + osc2) * 0.6;\n\n            // Bow noise (subtle)\n            let bow_noise = white_noise_ar() * 0.02;\n            let bow_filtered = hpf_ar(lpf_ar(bow_noise, 4000.0), 1000.0);\n\n            // Resonant body filtering\n            let body = rlpf_ar(string, 2500.0, 0.3);\n            let body2 = rlpf_ar(string, 800.0, 0.4) * 0.3;\n\n            let violin = body + body2 + bow_filtered;\n\n            // High pass to remove mud\n            let clean = hpf_ar(violin, 200.0);\n\n            clean * env * amp\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/solo_violin.vibe"
      },
      {
        "name": "string_ensemble",
        "description": "for a lush, cinematic sound.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"string_ensemble\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Slow swell envelope\n            let env = envelope()\n                .asr(0.3, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned voices for ensemble\n            let detune = 0.005;\n            let v1 = saw_ar(freq * (1.0 - detune * 2.0));\n            let v2 = saw_ar(freq * (1.0 - detune));\n            let v3 = saw_ar(freq);\n            let v4 = saw_ar(freq * (1.0 + detune));\n            let v5 = saw_ar(freq * (1.0 + detune * 2.0));\n\n            // Octave layer for depth\n            let oct_down = saw_ar(freq * 0.5) * 0.4;\n\n            let voices = (v1 + v2 + v3 + v4 + v5) * 0.25 + oct_down;\n\n            // String-like filtering\n            let filtered = lpf_ar(voices, 3500.0);\n\n            // Subtle vibrato\n            let vib_rate = 5.0;\n            let vib = sin_osc_ar(vib_rate) * 0.003 + 1.0;\n\n            filtered * env * amp * vib\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/string_ensemble.vibe"
      },
      {
        "name": "tremolo_strings",
        "description": "Rapidly bowed tremolo strings for dramatic passages.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "speed",
            "default": 8
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tremolo_strings\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"speed\", 8.0) // Tremolo speed in Hz\n        .body(|freq, amp, gate, speed| {\n            // String envelope\n            let env = envelope()\n                .asr(0.1, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned voices\n            let v1 = saw_ar(freq * 0.998);\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * 1.002);\n\n            let strings = (v1 + v2 + v3) * 0.4;\n\n            // Tremolo modulation\n            let trem = sin_osc_ar(speed) * 0.4 + 0.6;\n\n            // String body\n            let body = lpf_ar(strings, 3000.0);\n\n            // Slight vibrato\n            let vib = sin_osc_ar(5.0) * 0.002 + 1.0;\n\n            body * trem * env * amp * vib\n        })\n});",
        "category": "strings",
        "subcategory": "",
        "path": "strings/tremolo_strings.vibe"
      }
    ]
  },
  "Synths": {
    "subcategories": {},
    "items": [
      {
        "name": "arp_2600_lead",
        "description": "Classic modular lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "filter_freq",
            "default": 3000
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"arp_2600_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 3000.0)\n        .body(|freq, amp, gate, filter_freq| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Three VCOs\n            let vco1 = saw_ar(freq);\n            let vco2 = saw_ar(freq * 2.0) * 0.5; // Octave up\n            let vco3 = saw_ar(freq * 0.5) * 0.3; // Octave down\n\n            let mix = (vco1 + vco2 + vco3) * 0.4;\n\n            // 4-pole ladder filter\n            let filtered = rlpf_ar(mix, filter_freq, 0.35);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/arp.vibe"
      },
      {
        "name": "arp_odyssey_bass",
        "description": "Punchy duophonic bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"arp_odyssey_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n\n            // Two oscillators\n            let vco1 = saw_ar(freq);\n            let vco2 = saw_ar(freq * 0.5); // Sub\n\n            let mix = (vco1 * 0.6 + vco2 * 0.4);\n\n            // ARP filter character\n            let cutoff = 400.0 + filt_env * 2000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/arp.vibe"
      },
      {
        "name": "arp_strings",
        "description": "Classic string machine",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"arp_strings\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.2, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple oscillators for ensemble\n            let v1 = saw_ar(freq * 0.995);\n            let v2 = saw_ar(freq * 0.998);\n            let v3 = saw_ar(freq * 1.002);\n            let v4 = saw_ar(freq * 1.005);\n\n            let mix = (v1 + v2 + v3 + v4) * 0.28;\n\n            // String machine filtering\n            let filtered = lpf_ar(hpf_ar(mix, 200.0), 4000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/arp.vibe"
      },
      {
        "name": "arp_solina",
        "description": "The string ensemble sound",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"arp_solina\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.15, 1.0, 0.25)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Divide-down style ensemble\n            let v1 = saw_ar(freq * 0.994);\n            let v2 = saw_ar(freq * 0.997);\n            let v3 = saw_ar(freq);\n            let v4 = saw_ar(freq * 1.003);\n            let v5 = saw_ar(freq * 1.006);\n\n            let mix = (v1 + v2 + v3 + v4 + v5) * 0.22;\n\n            // Phaser-like modulation\n            let mod_osc = sin_osc_ar(0.3) * 0.003 + 1.0;\n\n            // Bandpass for string character\n            let filtered = lpf_ar(hpf_ar(mix, 300.0), 5000.0);\n\n            filtered * env * amp * mod_osc\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/arp.vibe"
      },
      {
        "name": "cs80_lead",
        "description": "Expressive lead with vibrato",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "vibrato",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"cs80_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"vibrato\", 0.5)\n        .body(|freq, amp, gate, vibrato| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Characteristic vibrato\n            let vib = sin_osc_ar(5.0) * freq * 0.015 * vibrato;\n            let mod_freq = freq + vib;\n\n            // Dual layers - saw and ring mod\n            let osc1 = saw_ar(mod_freq) * 0.4;\n            let osc2 = saw_ar(mod_freq * 1.003) * 0.4;\n            let ring = sin_osc_ar(mod_freq * 2.0) * 0.2;\n\n            let mix = osc1 + osc2 + ring;\n\n            // Warm filtering\n            let filtered = lpf_ar(mix, 3500.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/cs80.vibe"
      },
      {
        "name": "cs80_brass",
        "description": "Famous brass sound (Blade Runner)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.55
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"cs80_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.25)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.1, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // Dual oscillators with detune\n            let osc1 = saw_ar(freq * 0.998);\n            let osc2 = saw_ar(freq * 1.002);\n            let sub = saw_ar(freq * 0.5) * 0.3;\n\n            let mix = (osc1 + osc2) * 0.4 + sub;\n\n            // Resonant filter sweep\n            let cutoff = 800.0 + filt_env * 2500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.7);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/cs80.vibe"
      },
      {
        "name": "cs80_strings",
        "description": "Lush string pad",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.45
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"cs80_strings\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.3, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chorus-like detuning\n            let lfo = sin_osc_ar(0.3) * 0.003;\n            let osc1 = saw_ar(freq * (0.997 + lfo));\n            let osc2 = saw_ar(freq * (1.0 - lfo));\n            let osc3 = saw_ar(freq * (1.003 + lfo));\n\n            let mix = (osc1 + osc2 + osc3) * 0.35;\n\n            // Warm string filtering\n            let filtered = lpf_ar(mix, 3000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/cs80.vibe"
      },
      {
        "name": "dx7_epiano",
        "description": "The sound of the 80s",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "brightness",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"dx7_epiano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.6)\n        .body(|freq, amp, gate, brightness| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM modulation envelope (fast attack, medium decay)\n            let mod_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // 2-operator FM synthesis\n            let mod_depth = brightness * 3.0 * mod_env + 0.5;\n            let modulator = sin_osc_ar(freq * 14.0) * mod_depth;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Second partial for richness\n            let mod2 = sin_osc_ar(freq * 7.0) * (brightness * 1.5 * mod_env);\n            let carrier2 = sin_osc_ar(freq * 2.0 + mod2) * 0.4;\n\n            // Third partial\n            let carrier3 = sin_osc_ar(freq * 3.0) * mod_env * 0.2;\n\n            let fm = carrier + carrier2 + carrier3;\n\n            fm * env * amp * 0.5\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/dx7.vibe"
      },
      {
        "name": "dx7_bass",
        "description": "Punchy FM bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"dx7_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sharp FM modulation envelope\n            let mod_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            // FM with ratio for bass punch\n            let mod_depth = mod_env * 4.0 + 0.3;\n            let modulator = sin_osc_ar(freq * 1.0) * mod_depth * freq;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Sub for weight\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            (carrier * 0.7 + sub) * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/dx7.vibe"
      },
      {
        "name": "dx7_bells",
        "description": "Classic FM bells",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 880
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"dx7_bells\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Long decay for bell\n            let decay_env = envelope()\n                .perc(0.001, 2.0)\n                .build();\n\n            // Inharmonic FM ratios for bell character\n            let mod1 = sin_osc_ar(freq * 3.5) * decay_env * 2.0;\n            let carrier1 = sin_osc_ar(freq + mod1);\n\n            let mod2 = sin_osc_ar(freq * 7.1) * decay_env * 1.5;\n            let carrier2 = sin_osc_ar(freq * 2.0 + mod2) * 0.5;\n\n            let mod3 = sin_osc_ar(freq * 11.0) * decay_env * 0.8;\n            let carrier3 = sin_osc_ar(freq * 4.0 + mod3) * 0.3;\n\n            let bell = carrier1 + carrier2 + carrier3;\n\n            bell * env * decay_env * amp * 0.5\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/dx7.vibe"
      },
      {
        "name": "dx7_brass",
        "description": "Punchy FM brass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"dx7_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Brass-like FM modulation\n            let mod_env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            let mod_depth = mod_env * 2.5 + 0.5;\n            let modulator = sin_osc_ar(freq * 1.0) * mod_depth;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Higher harmonic\n            let mod2 = sin_osc_ar(freq * 3.0) * mod_env * 1.5;\n            let carrier2 = sin_osc_ar(freq * 2.0 + mod2) * 0.4;\n\n            let brass = carrier + carrier2;\n\n            brass * env * amp * 0.6\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/dx7.vibe"
      },
      {
        "name": "dx7_marimba",
        "description": "Classic FM marimba",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"dx7_marimba\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast decay for mallet sound\n            let decay_env = envelope()\n                .perc(0.001, 0.5)\n                .build();\n\n            // FM for woody attack\n            let mod_depth = decay_env * 3.0;\n            let modulator = sin_osc_ar(freq * 4.0) * mod_depth;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Fundamental\n            let fundamental = sin_osc_ar(freq) * 0.6;\n\n            (carrier * 0.5 + fundamental) * env * decay_env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/dx7.vibe"
      },
      {
        "name": "juno_pad",
        "description": "The iconic lush pad",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "chorus",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"juno_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"chorus\", 0.7) // Chorus depth\n        .body(|freq, amp, gate, chorus| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Single DCO with sub oscillator\n            let saw = saw_ar(freq);\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let source = saw * 0.7 + sub;\n\n            // Juno-style chorus (stereo detune)\n            let lfo1 = sin_osc_ar(0.5) * chorus * 0.008;\n            let lfo2 = sin_osc_ar(0.6) * chorus * 0.008;\n\n            let voice1 = saw_ar(freq * (1.0 + lfo1));\n            let voice2 = saw_ar(freq * (1.0 + lfo2));\n\n            let chorused = (source + voice1 + voice2) * 0.35;\n\n            // Warm resonant filter\n            let filtered = rlpf_ar(chorused, 2000.0, 0.4);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/juno.vibe"
      },
      {
        "name": "juno_brass",
        "description": "Classic synth brass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"juno_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope for brass attack\n            let filt_env = envelope()\n                .asr(0.03, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            // Saw waves with PWM character\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.003);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Filter sweep\n            let cutoff = 600.0 + filt_env * 3000.0;\n            let filtered = rlpf_ar(source, cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/juno.vibe"
      },
      {
        "name": "juno_bass",
        "description": "Punchy analog bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"juno_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Saw + sub\n            let saw = saw_ar(freq);\n            let sub = sin_osc_ar(freq * 0.5) * 0.5;\n\n            let source = saw * 0.6 + sub;\n\n            // Punchy filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n            let cutoff = 400.0 + filt_env * 2000.0;\n\n            let filtered = rlpf_ar(source, cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/juno.vibe"
      },
      {
        "name": "juno_strings",
        "description": "Classic polysynth strings",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"juno_strings\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.3, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned voices\n            let v1 = saw_ar(freq * 0.996);\n            let v2 = saw_ar(freq * 0.999);\n            let v3 = saw_ar(freq * 1.001);\n            let v4 = saw_ar(freq * 1.004);\n\n            let voices = (v1 + v2 + v3 + v4) * 0.3;\n\n            // Smooth filtering\n            let filtered = lpf_ar(voices, 3500.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/juno.vibe"
      },
      {
        "name": "jupiter_pad",
        "description": "Massive warm pad",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "spread",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"jupiter_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"spread\", 0.6)\n        .body(|freq, amp, gate, spread| {\n            let env = envelope()\n                .asr(0.5, 1.0, 0.6)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Two VCOs with cross-modulation\n            let detune = spread * 0.012;\n            let vco1 = saw_ar(freq * (1.0 - detune));\n            let vco2 = saw_ar(freq * (1.0 + detune));\n\n            // Sub oscillator\n            let sub = sin_osc_ar(freq * 0.5) * 0.35;\n\n            let mix = (vco1 + vco2) * 0.4 + sub;\n\n            // HPF for clarity then LPF for warmth\n            let filtered = lpf_ar(hpf_ar(mix, 60.0), 3000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/jupiter.vibe"
      },
      {
        "name": "jupiter_supersaw",
        "description": "The trance staple",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "detune",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"jupiter_supersaw\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"detune\", 0.5)\n        .body(|freq, amp, gate, detune| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // 7 detuned sawtooth oscillators\n            let spread = detune * 0.03;\n            let v1 = saw_ar(freq * (1.0 - spread * 3.0));\n            let v2 = saw_ar(freq * (1.0 - spread * 2.0));\n            let v3 = saw_ar(freq * (1.0 - spread));\n            let v4 = saw_ar(freq);\n            let v5 = saw_ar(freq * (1.0 + spread));\n            let v6 = saw_ar(freq * (1.0 + spread * 2.0));\n            let v7 = saw_ar(freq * (1.0 + spread * 3.0));\n\n            let stack = (v1 + v2 + v3 + v4 + v5 + v6 + v7) * 0.18;\n\n            // Bright filter\n            let filtered = lpf_ar(stack, 8000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/jupiter.vibe"
      },
      {
        "name": "jupiter_brass",
        "description": "Thick brass stab",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"jupiter_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .asr(0.02, 1.0, 0.12)\n                .gate(gate)\n                .build();\n\n            // Thick detuned oscillators\n            let v1 = saw_ar(freq * 0.995);\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * 1.005);\n\n            let mix = (v1 + v2 + v3) * 0.4;\n\n            // Brass filter sweep\n            let cutoff = 400.0 + filt_env * 4000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/jupiter.vibe"
      },
      {
        "name": "jupiter_bass",
        "description": "Deep punchy bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"jupiter_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n\n            // Two oscillators plus sub\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.002);\n            let sub = sin_osc_ar(freq * 0.5) * 0.5;\n\n            let mix = (saw1 + saw2) * 0.4 + sub;\n\n            // Punchy filter\n            let cutoff = 300.0 + filt_env * 2500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/jupiter.vibe"
      },
      {
        "name": "memorymoog_pad",
        "description": "Lush poly pad",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.45
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"memorymoog_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Six voice unison simulation\n            let detune = 0.003;\n            let osc1 = saw_ar(freq * (1.0 - detune * 2.0)) * 0.2;\n            let osc2 = saw_ar(freq * (1.0 - detune)) * 0.2;\n            let osc3 = saw_ar(freq) * 0.2;\n            let osc4 = saw_ar(freq * (1.0 + detune)) * 0.2;\n            let osc5 = saw_ar(freq * (1.0 + detune * 2.0)) * 0.2;\n            let sub = sin_osc_ar(freq * 0.5) * 0.15;\n\n            let mix = osc1 + osc2 + osc3 + osc4 + osc5 + sub;\n\n            // Warm Moog ladder filter\n            let filtered = lpf_ar(mix, 2800.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/memorymoog.vibe"
      },
      {
        "name": "memorymoog_brass",
        "description": "Poly brass section",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"memorymoog_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.1, 1.0, 0.25)\n                .gate(gate)\n                .build();\n\n            // Rich detuned oscillators\n            let osc1 = saw_ar(freq * 0.997);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.003);\n\n            let mix = (osc1 + osc2 + osc3) * 0.4;\n\n            let cutoff = 600.0 + filt_env * 3000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.65);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/memorymoog.vibe"
      },
      {
        "name": "memorymoog_lead",
        "description": "Fat poly lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"memorymoog_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.02, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // Three oscillators\n            let osc1 = saw_ar(freq);\n            let osc2 = saw_ar(freq * 1.004) * 0.8;\n            let osc3 = pulse_ar(freq * 2.0, 0.3) * 0.3;\n\n            let mix = (osc1 + osc2 + osc3) * 0.4;\n\n            let cutoff = 2000.0 + filt_env * 4000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.6);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/memorymoog.vibe"
      },
      {
        "name": "minimoog_bass",
        "description": "Classic fat bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "filter_freq",
            "default": 800
          },
          {
            "name": "resonance",
            "default": 0.3
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"minimoog_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 800.0)\n        .param(\"resonance\", 0.3)\n        .body(|freq, amp, gate, filter_freq, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            // Three detuned oscillators (classic Moog)\n            let osc1 = saw_ar(freq);\n            let osc2 = saw_ar(freq * 0.995) * 0.8;  // Slightly detuned\n            let osc3 = saw_ar(freq * 0.5) * 0.6;   // Sub octave\n\n            let mix = (osc1 + osc2 + osc3) * 0.4;\n\n            // Ladder filter emulation (resonant lowpass)\n            let cutoff = filter_freq + filt_env * 2000.0;\n            let filtered = rlpf_ar(mix, cutoff, 1.0 - resonance * 0.9);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/minimoog.vibe"
      },
      {
        "name": "minimoog_lead",
        "description": "Screaming mono lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "filter_freq",
            "default": 2000
          },
          {
            "name": "resonance",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"minimoog_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 2000.0)\n        .param(\"resonance\", 0.4)\n        .body(|freq, amp, gate, filter_freq, resonance| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // Three oscillators - mix of saw and pulse\n            let osc1 = saw_ar(freq);\n            let osc2 = saw_ar(freq * 1.005);  // Detuned up\n            let osc3 = saw_ar(freq * 2.0) * 0.3; // Octave up\n\n            let mix = (osc1 + osc2 + osc3) * 0.4;\n\n            // Resonant filter sweep\n            let cutoff = filter_freq + filt_env * 4000.0;\n            let filtered = rlpf_ar(mix, cutoff, 1.0 - resonance * 0.85);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/minimoog.vibe"
      },
      {
        "name": "minimoog_pad",
        "description": "Warm analog pad",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"minimoog_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.5, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Warm detuned oscillators\n            let osc1 = saw_ar(freq * 0.998);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.002);\n            let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n            let mix = (osc1 + osc2 + osc3) * 0.3 + sub;\n\n            // Warm filtering\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/minimoog.vibe"
      },
      {
        "name": "ms20_bass",
        "description": "Aggressive filter bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "filter_freq",
            "default": 600
          },
          {
            "name": "resonance",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"ms20_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 600.0)\n        .param(\"resonance\", 0.5)\n        .body(|freq, amp, gate, filter_freq, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            // Dual oscillator - MS-20 style\n            let osc1 = saw_ar(freq);\n            let osc2 = pulse_ar(freq * 0.5, 0.4) * 0.7;\n\n            let mix = (osc1 + osc2) * 0.5;\n\n            // MS-20's aggressive high-pass then low-pass\n            let hp = hpf_ar(mix, 80.0);\n            let cutoff = filter_freq + filt_env * 1500.0;\n            let filtered = rlpf_ar(hp, cutoff, 1.0 - resonance * 0.95);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/ms20.vibe"
      },
      {
        "name": "ms20_lead",
        "description": "Screaming acid lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "filter_freq",
            "default": 1500
          },
          {
            "name": "resonance",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"ms20_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 1500.0)\n        .param(\"resonance\", 0.6)\n        .body(|freq, amp, gate, filter_freq, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // Ring mod style cross modulation\n            let osc1 = saw_ar(freq);\n            let osc2 = pulse_ar(freq * 1.002, 0.3);\n            let ring = osc1 * sin_osc_ar(freq * 2.0) * 0.3;\n\n            let mix = (osc1 + osc2 * 0.5 + ring) * 0.4;\n\n            let cutoff = filter_freq + filt_env * 3000.0;\n            let filtered = rlpf_ar(mix, cutoff, 1.0 - resonance * 0.9);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/ms20.vibe"
      },
      {
        "name": "ms20_sync",
        "description": "Oscillator sync sound",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "sync_ratio",
            "default": 2.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"ms20_sync\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"sync_ratio\", 2.5)\n        .body(|freq, amp, gate, sync_ratio| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simulated sync with multiple harmonics\n            let fund = saw_ar(freq) * 0.4;\n            let sync_freq = freq * sync_ratio;\n            let sync1 = saw_ar(sync_freq) * 0.3;\n            let sync2 = sin_osc_ar(sync_freq * 2.0) * 0.15;\n\n            let mix = fund + sync1 + sync2;\n            let filtered = lpf_ar(mix, 4000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/ms20.vibe"
      },
      {
        "name": "oberheim_pad",
        "description": "Ultra-lush pad",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"oberheim_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Two VCOs per voice, slightly detuned\n            let vco1a = saw_ar(freq * 0.996);\n            let vco1b = saw_ar(freq * 0.998);\n            let vco2a = saw_ar(freq * 1.002);\n            let vco2b = saw_ar(freq * 1.004);\n\n            let mix = (vco1a + vco1b + vco2a + vco2b) * 0.28;\n\n            // Warm SEM-style filter\n            let filtered = lpf_ar(mix, 2800.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/oberheim.vibe"
      },
      {
        "name": "oberheim_brass",
        "description": "The \"Jump\" brass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"oberheim_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .asr(0.015, 1.0, 0.12)\n                .gate(gate)\n                .build();\n\n            // Fat oscillators\n            let vco1 = saw_ar(freq * 0.998);\n            let vco2 = saw_ar(freq * 1.002);\n\n            let mix = (vco1 + vco2) * 0.5;\n\n            // Aggressive filter sweep\n            let cutoff = 300.0 + filt_env * 5000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/oberheim.vibe"
      },
      {
        "name": "oberheim_lead",
        "description": "Screaming lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"oberheim_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Two saw VCOs\n            let vco1 = saw_ar(freq);\n            let vco2 = saw_ar(freq * 1.008);\n\n            let mix = (vco1 + vco2) * 0.5;\n\n            // Bright resonant filter\n            let filtered = rlpf_ar(mix, 4000.0, 0.4);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/oberheim.vibe"
      },
      {
        "name": "oberheim_bass",
        "description": "Fat bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"oberheim_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.008, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.25)\n                .build();\n\n            // Fat oscillators with sub\n            let vco1 = saw_ar(freq);\n            let vco2 = saw_ar(freq * 1.003);\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let mix = (vco1 + vco2) * 0.4 + sub;\n\n            // Punchy filter\n            let cutoff = 250.0 + filt_env * 3000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/oberheim.vibe"
      },
      {
        "name": "odyssey_bass",
        "description": "Fat duophonic bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "filter_freq",
            "default": 700
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"odyssey_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 700.0)\n        .body(|freq, amp, gate, filter_freq| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .build();\n\n            // Dual oscillators with sync option\n            let osc1 = saw_ar(freq);\n            let osc2 = pulse_ar(freq * 0.5, 0.5) * 0.6;\n\n            let mix = (osc1 + osc2) * 0.5;\n\n            let cutoff = filter_freq + filt_env * 1800.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.55);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/odyssey.vibe"
      },
      {
        "name": "odyssey_lead",
        "description": "Biting mono lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "resonance",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"odyssey_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"resonance\", 0.5)\n        .body(|freq, amp, gate, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // Ring mod character\n            let osc1 = saw_ar(freq);\n            let osc2 = saw_ar(freq * 1.005);\n            let ring = osc1 * sin_osc_ar(freq * 1.5) * 0.2;\n\n            let mix = (osc1 + osc2) * 0.4 + ring;\n\n            let cutoff = 1200.0 + filt_env * 4000.0;\n            let filtered = rlpf_ar(mix, cutoff, 1.0 - resonance * 0.9);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/odyssey.vibe"
      },
      {
        "name": "odyssey_sh",
        "description": "Random stepped modulation",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.45
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "rate",
            "default": 8
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"odyssey_sh\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .param(\"rate\", 8.0)\n        .body(|freq, amp, gate, rate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // S&H style random modulation\n            let sh = dust_ar(rate) * 100.0;\n            let mod_freq = freq + sh;\n\n            let osc1 = saw_ar(mod_freq);\n            let osc2 = pulse_ar(freq, 0.5) * 0.5;\n\n            let mix = (osc1 + osc2) * 0.45;\n\n            let filtered = rlpf_ar(mix, 2500.0, 0.6);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/odyssey.vibe"
      },
      {
        "name": "polysix_pad",
        "description": "Warm chorus pad",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.45
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"polysix_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Single oscillator with sub\n            let osc = saw_ar(freq);\n            let sub = pulse_ar(freq * 0.5, 0.5) * 0.3;\n\n            // Built-in ensemble effect simulation\n            let lfo1 = sin_osc_ar(0.5) * 0.003;\n            let lfo2 = sin_osc_ar(0.7) * 0.003;\n            let chorus1 = saw_ar(freq * (1.0 + lfo1)) * 0.3;\n            let chorus2 = saw_ar(freq * (1.0 + lfo2)) * 0.3;\n\n            let mix = osc * 0.4 + sub + chorus1 + chorus2;\n\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/polysix.vibe"
      },
      {
        "name": "polysix_strings",
        "description": "Classic string machine sound",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"polysix_strings\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.25, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Ensemble detuning\n            let lfo = sin_osc_ar(6.0) * 0.004;\n            let osc1 = saw_ar(freq * (0.998 + lfo));\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * (1.002 - lfo));\n\n            let mix = (osc1 + osc2 + osc3) * 0.35;\n\n            let filtered = lpf_ar(mix, 3500.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/polysix.vibe"
      },
      {
        "name": "polysix_bass",
        "description": "Punchy poly bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.55
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"polysix_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            let osc = saw_ar(freq);\n            let sub = pulse_ar(freq * 0.5, 0.5) * 0.5;\n\n            let mix = (osc + sub) * 0.5;\n\n            let cutoff = 500.0 + filt_env * 1500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.6);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/polysix.vibe"
      },
      {
        "name": "ppg_pad",
        "description": "Digital wavetable pad",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.45
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "table_pos",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"ppg_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .param(\"table_pos\", 0.5)\n        .body(|freq, amp, gate, table_pos| {\n            let env = envelope()\n                .asr(0.3, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simulated wavetable scanning with multiple waveforms\n            let saw_amt = table_pos;\n            let pulse_amt = 1.0 - table_pos;\n            let pw = table_pos * 0.4 + 0.1;\n\n            let osc1 = saw_ar(freq) * saw_amt;\n            let osc2 = pulse_ar(freq, pw) * pulse_amt;\n            let osc3 = sin_osc_ar(freq * 2.0) * 0.2;\n\n            let mix = (osc1 + osc2 + osc3) * 0.5;\n\n            // Digital-ish filtering\n            let filtered = lpf_ar(mix, 4000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/ppg_wave.vibe"
      },
      {
        "name": "ppg_lead",
        "description": "Digital metallic lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"ppg_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic digital character\n            let osc1 = pulse_ar(freq, 0.3) * 0.4;\n            let osc2 = saw_ar(freq * 2.003) * 0.25;\n            let osc3 = sin_osc_ar(freq * 3.0) * 0.15;\n\n            let mix = osc1 + osc2 + osc3;\n\n            let filtered = lpf_ar(mix, 6000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/ppg_wave.vibe"
      },
      {
        "name": "ppg_bass",
        "description": "Digital bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.55
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"ppg_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .build();\n\n            // Wavetable-style with harmonics\n            let osc1 = saw_ar(freq) * 0.5;\n            let osc2 = pulse_ar(freq, 0.25) * 0.3;\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let mix = osc1 + osc2 + sub;\n\n            let cutoff = 600.0 + filt_env * 1500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.5);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/ppg_wave.vibe"
      },
      {
        "name": "pro_one_bass",
        "description": "Punchy mono bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "filter_freq",
            "default": 800
          },
          {
            "name": "resonance",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"pro_one_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 800.0)\n        .param(\"resonance\", 0.4)\n        .body(|freq, amp, gate, filter_freq, resonance| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.005, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            // Dual oscillators\n            let osc1 = saw_ar(freq);\n            let osc2 = pulse_ar(freq * 0.5, 0.3) * 0.7;\n\n            let mix = (osc1 + osc2) * 0.5;\n\n            let cutoff = filter_freq + filt_env * 2000.0;\n            let filtered = rlpf_ar(mix, cutoff, 1.0 - resonance * 0.9);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/pro_one.vibe"
      },
      {
        "name": "pro_one_lead",
        "description": "Aggressive lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "pw",
            "default": 0.3
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"pro_one_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"pw\", 0.3)\n        .body(|freq, amp, gate, pw| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // PWM lead\n            let pwm = sin_osc_ar(3.0) * 0.2 + pw;\n            let osc1 = pulse_ar(freq, pwm);\n            let osc2 = saw_ar(freq * 1.003) * 0.5;\n\n            let mix = (osc1 + osc2) * 0.45;\n\n            let cutoff = 1500.0 + filt_env * 3500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.65);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/pro_one.vibe"
      },
      {
        "name": "pro_one_sync",
        "description": "Hard sync lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "sync_ratio",
            "default": 2
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"pro_one_sync\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"sync_ratio\", 2.0)\n        .body(|freq, amp, gate, sync_ratio| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simulated hard sync\n            let master = saw_ar(freq);\n            let slave_freq = freq * sync_ratio;\n            let slave = saw_ar(slave_freq) * 0.6;\n            let harmonics = sin_osc_ar(slave_freq * 2.0) * 0.2;\n\n            let mix = (master + slave + harmonics) * 0.4;\n\n            let filtered = lpf_ar(mix, 5000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/pro_one.vibe"
      },
      {
        "name": "prophet_pad",
        "description": "Lush analog pad",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "spread",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"prophet_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"spread\", 0.5)\n        .body(|freq, amp, gate, spread| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Two oscillators with spread\n            let detune = spread * 0.01;\n            let osc_a = saw_ar(freq * (1.0 - detune));\n            let osc_b = saw_ar(freq * (1.0 + detune));\n\n            // Sub oscillator\n            let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n            let mix = (osc_a + osc_b) * 0.4 + sub;\n\n            // Warm lowpass\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/prophet.vibe"
      },
      {
        "name": "prophet_brass",
        "description": "Classic synth brass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"prophet_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.06, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .asr(0.03, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            // Two saw oscillators\n            let osc_a = saw_ar(freq);\n            let osc_b = saw_ar(freq * 1.005);\n\n            let mix = (osc_a + osc_b) * 0.5;\n\n            // Bright filter sweep\n            let cutoff = 500.0 + filt_env * 4000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/prophet.vibe"
      },
      {
        "name": "prophet_lead",
        "description": "Screaming lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "resonance",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"prophet_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"resonance\", 0.4)\n        .body(|freq, amp, gate, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Poly-mod style oscillator sync simulation\n            let osc_a = saw_ar(freq);\n            let osc_b = saw_ar(freq * 2.01); // Slight detune for richness\n\n            let mix = (osc_a + osc_b * 0.5) * 0.6;\n\n            // Resonant filter\n            let filtered = rlpf_ar(mix, 3000.0, 1.0 - resonance * 0.8);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/prophet.vibe"
      },
      {
        "name": "prophet_strings",
        "description": "Warm polysynth strings",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"prophet_strings\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.25, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Ensemble-style detuning\n            let v1 = saw_ar(freq * 0.997);\n            let v2 = saw_ar(freq * 0.999);\n            let v3 = saw_ar(freq * 1.001);\n            let v4 = saw_ar(freq * 1.003);\n\n            let voices = (v1 + v2 + v3 + v4) * 0.3;\n\n            // Warm filter\n            let filtered = lpf_ar(voices, 3000.0);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/prophet.vibe"
      },
      {
        "name": "sh101_bass",
        "description": "Clean punchy bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "filter_env",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"sh101_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"filter_env\", 0.6)\n        .body(|freq, amp, gate, filter_env| {\n            let env = envelope()\n                .asr(0.003, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            // Single VCO with sub\n            let saw = saw_ar(freq);\n            let sub = saw_ar(freq * 0.5) * 0.5;\n\n            let mix = saw * 0.6 + sub;\n\n            // 101 filter character\n            let cutoff = 300.0 + filt_env * filter_env * 3000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/sh101.vibe"
      },
      {
        "name": "sh101_lead",
        "description": "Classic mono lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "resonance",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"sh101_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"resonance\", 0.4)\n        .body(|freq, amp, gate, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Single oscillator\n            let saw = saw_ar(freq);\n\n            // Resonant filter\n            let filtered = rlpf_ar(saw, 3500.0, 1.0 - resonance * 0.8);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/sh101.vibe"
      },
      {
        "name": "sh101_sync",
        "description": "Hard sync lead",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "sync_ratio",
            "default": 2.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"sh101_sync\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"sync_ratio\", 2.5)\n        .body(|freq, amp, gate, sync_ratio| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simulated sync with harmonic content\n            let master = saw_ar(freq);\n            let slave = saw_ar(freq * sync_ratio) * 0.4;\n            let sync_harmonic = sin_osc_ar(freq * sync_ratio) * 0.3;\n\n            let mix = master + slave + sync_harmonic;\n\n            // Bright filter\n            let filtered = lpf_ar(mix, 6000.0);\n\n            filtered * env * amp * 0.5\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/sh101.vibe"
      },
      {
        "name": "sh101_acid",
        "description": "For acid house",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "resonance",
            "default": 0.7
          },
          {
            "name": "env_mod",
            "default": 0.8
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"sh101_acid\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"resonance\", 0.7)\n        .param(\"env_mod\", 0.8)\n        .body(|freq, amp, gate, resonance, env_mod| {\n            let env = envelope()\n                .asr(0.002, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sharp filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n\n            // Saw oscillator\n            let saw = saw_ar(freq);\n\n            // Squelchy acid filter\n            let cutoff = 200.0 + filt_env * env_mod * 4000.0;\n            let filtered = rlpf_ar(saw, cutoff, 1.0 - resonance * 0.9);\n\n            filtered * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/sh101.vibe"
      },
      {
        "name": "tb303_bass",
        "description": "Classic acid bass",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "cutoff",
            "default": 1000
          },
          {
            "name": "resonance",
            "default": 0.7
          },
          {
            "name": "env_mod",
            "default": 0.5
          },
          {
            "name": "decay",
            "default": 0.3
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tb303_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 1000.0)\n        .param(\"resonance\", 0.7)\n        .param(\"env_mod\", 0.5)\n        .param(\"decay\", 0.3)\n        .body(|freq, amp, gate, cutoff, resonance, env_mod, decay| {\n            let env = envelope()\n                .asr(0.003, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope - key to 303 sound\n            // Use env_perc with base time of 1.0, then scale by decay parameter\n            let filt_env = envelope()\n                .perc(0.003, 1.0)\n                .time_scale(decay)\n                .build();\n\n            // Single saw oscillator\n            let osc = saw_ar(freq);\n\n            // Characteristic resonant filter\n            let mod_cutoff = cutoff + filt_env * env_mod * 8000.0;\n            let filtered = rlpf_ar(osc, mod_cutoff, 1.0 - resonance * 0.95);\n\n            // Slight overdrive\n            let driven = (filtered * 1.5).tanh() * 0.7;\n\n            driven * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/tb303.vibe"
      },
      {
        "name": "tb303_slide",
        "description": "Portamento acid line",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "cutoff",
            "default": 800
          },
          {
            "name": "resonance",
            "default": 0.75
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tb303_slide\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 800.0)\n        .param(\"resonance\", 0.75)\n        .body(|freq, amp, gate, cutoff, resonance| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n\n            let osc = saw_ar(freq);\n\n            let mod_cutoff = cutoff + filt_env * 6000.0;\n            let filtered = rlpf_ar(osc, mod_cutoff, 1.0 - resonance * 0.97);\n\n            let driven = (filtered * 1.8).tanh() * 0.65;\n\n            driven * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/tb303.vibe"
      },
      {
        "name": "tb303_accent",
        "description": "Accented acid hit",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.7
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tb303_accent\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.06)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            let osc = saw_ar(freq);\n\n            // High resonance, big envelope sweep\n            let mod_cutoff = 400.0 + filt_env * 10000.0;\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.08);\n\n            let driven = (filtered * 2.0).tanh() * 0.6;\n\n            driven * env * amp\n        })\n});",
        "category": "synths",
        "subcategory": "",
        "path": "synths/tb303.vibe"
      }
    ]
  },
  "Textures": {
    "subcategories": {
      "Ambient": [
        {
          "name": "texture_field",
          "description": "Genre: Ambient, Field Recording | Character: Field recording style ambient",
          "genre": "Ambient, Field Recording",
          "character": "Field recording style ambient",
          "params": [
            {
              "name": "amp",
              "default": 0.35
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"texture_field\", |builder| {\n    builder\n        .param(\"amp\", 0.35)\n        .body(|amp| {\n            // Very long sustain\n            let env = envelope()\n                .perc(2.0, 15.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix of noise colors\n            let pink = pink_noise_ar() * 0.5;\n            let brown = pink_noise_ar() * 0.3;\n            let white = white_noise_ar() * 0.2;\n\n            let noise_mix = pink + brown + white;\n\n            // Natural filtering\n            let filtered = rlpf_ar(noise_mix, 2500.0, 0.7);\n\n            // Gentle evolution\n            let filter_env = envelope()\n                .perc(4.0, 12.0)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 1500.0);\n\n            let evolved = lpf_ar(filtered, mod_cutoff);\n\n            evolved * env * amp\n        })\n});",
          "category": "textures",
          "subcategory": "ambient",
          "path": "textures/ambient/texture_field.vibe"
        },
        {
          "name": "texture_granular",
          "description": "Genre: Ambient, Experimental | Character: Granular-style texture",
          "genre": "Ambient, Experimental",
          "character": "Granular-style texture",
          "params": [
            {
              "name": "freq",
              "default": 220
            },
            {
              "name": "amp",
              "default": 0.4
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"texture_granular\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .body(|freq, amp| {\n            // Long envelope\n            let env = envelope()\n                .perc(1.5, 9.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned oscillators for grain-like character\n            let osc1 = saw_ar(freq * 0.983);\n            let osc2 = saw_ar(freq * 0.991);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.009);\n            let osc5 = saw_ar(freq * 1.017);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Heavy filtering for smoothness\n            let filtered = lpf_ar(mix, 1500.0);\n\n            // Additional resonant layer\n            let resonant = rlpf_ar(filtered, 2000.0, 0.6) * 0.5;\n\n            (filtered + resonant) * env * amp * 0.6\n        })\n});",
          "category": "textures",
          "subcategory": "ambient",
          "path": "textures/ambient/texture_granular.vibe"
        },
        {
          "name": "texture_rain",
          "description": "Genre: Ambient, Nature | Character: Rain-like texture",
          "genre": "Ambient, Nature",
          "character": "Rain-like texture",
          "params": [
            {
              "name": "amp",
              "default": 0.4
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"texture_rain\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .body(|amp| {\n            // Long sustain\n            let env = envelope()\n                .perc(0.5, 10.0)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise for rain character\n            let noise = white_noise_ar();\n\n            // Mid-range filtering\n            let filtered = rlpf_ar(noise, 3500.0, 0.6);\n\n            // High-pass to remove lows\n            let clean = hpf_ar(filtered, 400.0);\n\n            clean * env * amp * 0.7\n        })\n});",
          "category": "textures",
          "subcategory": "ambient",
          "path": "textures/ambient/texture_rain.vibe"
        },
        {
          "name": "texture_space",
          "description": "Genre: Ambient, Sci-Fi | Character: Spacious, ethereal texture",
          "genre": "Ambient, Sci-Fi",
          "character": "Spacious, ethereal texture",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.35
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"texture_space\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.35)\n        .body(|freq, amp| {\n            // Very long envelope\n            let env = envelope()\n                .perc(2.0, 12.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple slow oscillators\n            let osc1 = sin_osc_ar(freq * 0.5);\n            let osc2 = sin_osc_ar(freq * 0.75);\n            let osc3 = sin_osc_ar(freq);\n            let osc4 = sin_osc_ar(freq * 1.5);\n\n            // Mix with harmonics\n            let mix = (osc1 * 0.3 + osc2 * 0.25 + osc3 * 0.25 + osc4 * 0.2);\n\n            // Evolving filter\n            let filter_env = envelope()\n                .perc(3.0, 10.0)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "textures",
          "subcategory": "ambient",
          "path": "textures/ambient/texture_space.vibe"
        },
        {
          "name": "texture_wind",
          "description": "Genre: Ambient, Field Recording | Character: Wind-like texture",
          "genre": "Ambient, Field Recording",
          "character": "Wind-like texture",
          "params": [
            {
              "name": "amp",
              "default": 0.4
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"texture_wind\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .body(|amp| {\n            // Long, sustained envelope\n            let env = envelope()\n                .perc(1.0, 8.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise for natural wind\n            let noise = pink_noise_ar();\n\n            // Slow filter modulation for movement\n            let filter_env = envelope()\n                .perc(2.0, 7.0)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 2000.0);\n\n            let filtered = lpf_ar(noise, mod_cutoff);\n\n            // High-pass to remove rumble\n            let clean = hpf_ar(filtered, 150.0);\n\n            clean * env * amp\n        })\n});",
          "category": "textures",
          "subcategory": "ambient",
          "path": "textures/ambient/texture_wind.vibe"
        }
      ],
      "Drone": [
        {
          "name": "drone_dark",
          "description": "Genre: Dark Ambient, Drone | Character: Dark, ominous drone",
          "genre": "Dark Ambient, Drone",
          "character": "Dark, ominous drone",
          "params": [
            {
              "name": "freq",
              "default": 55
            },
            {
              "name": "amp",
              "default": 0.4
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"drone_dark\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.4)\n        .body(|freq, amp| {\n            // Very long sustain\n            let env = envelope()\n                .perc(3.0, 20.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Low, detuned oscillators\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.005);\n            let osc4 = saw_ar(freq * 0.5);\n\n            let mix = (osc1 + osc2 + osc3) * 0.25 + (osc4 * 0.25);\n\n            // Dark filtering\n            let filtered = lpf_ar(mix, 600.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "textures",
          "subcategory": "drone",
          "path": "textures/drone/drone_dark.vibe"
        },
        {
          "name": "drone_evolving",
          "description": "Genre: Ambient, Drone | Character: Slowly evolving drone",
          "genre": "Ambient, Drone",
          "character": "Slowly evolving drone",
          "params": [
            {
              "name": "freq",
              "default": 82
            },
            {
              "name": "amp",
              "default": 0.35
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"drone_evolving\", |builder| {\n    builder\n        .param(\"freq\", 82.0)\n        .param(\"amp\", 0.35)\n        .body(|freq, amp| {\n            // Very long sustain\n            let env = envelope()\n                .perc(4.0, 25.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Wide detuning\n            let osc1 = saw_ar(freq * 0.980);\n            let osc2 = saw_ar(freq * 0.990);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.010);\n            let osc5 = saw_ar(freq * 1.020);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Slowly evolving filter\n            let filter_env = envelope()\n                .perc(8.0, 20.0)\n                .build();\n            let mod_cutoff = 400.0 + (filter_env * 2000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            // Additional resonance layer\n            let resonant = rlpf_ar(filtered, mod_cutoff * 0.8, 0.5) * 0.5;\n\n            (filtered + resonant) * env * amp * 0.7\n        })\n});",
          "category": "textures",
          "subcategory": "drone",
          "path": "textures/drone/drone_evolving.vibe"
        },
        {
          "name": "drone_harmonic",
          "description": "Genre: Ambient, Drone | Character: Harmonic, spectral drone",
          "genre": "Ambient, Drone",
          "character": "Harmonic, spectral drone",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.35
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"drone_harmonic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.35)\n        .body(|freq, amp| {\n            // Long sustain\n            let env = envelope()\n                .perc(2.5, 18.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Harmonic series\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.33;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.2;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.16;\n\n            let mix = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Gentle filtering\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp * 0.5\n        })\n});",
          "category": "textures",
          "subcategory": "drone",
          "path": "textures/drone/drone_harmonic.vibe"
        },
        {
          "name": "drone_noise",
          "description": "Genre: Experimental, Noise | Character: Noise-based drone",
          "genre": "Experimental, Noise",
          "character": "Noise-based drone",
          "params": [
            {
              "name": "amp",
              "default": 0.35
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"drone_noise\", |builder| {\n    builder\n        .param(\"amp\", 0.35)\n        .body(|amp| {\n            // Long sustain\n            let env = envelope()\n                .perc(2.0, 15.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise base\n            let noise = pink_noise_ar();\n\n            // Multiple resonant filters for drone character\n            let res1 = rlpf_ar(noise, 200.0, 0.1) * 0.4;\n            let res2 = rlpf_ar(noise, 450.0, 0.15) * 0.3;\n            let res3 = rlpf_ar(noise, 800.0, 0.2) * 0.3;\n\n            let mix = res1 + res2 + res3;\n\n            // Evolving filtering\n            let filter_env = envelope()\n                .perc(4.0, 12.0)\n                .build();\n            let mod_cutoff = 1000.0 + (filter_env * 1500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
          "category": "textures",
          "subcategory": "drone",
          "path": "textures/drone/drone_noise.vibe"
        },
        {
          "name": "drone_resonant",
          "description": "Genre: Ambient, Experimental | Character: Resonant, metallic drone",
          "genre": "Ambient, Experimental",
          "character": "Resonant, metallic drone",
          "params": [
            {
              "name": "freq",
              "default": 110
            },
            {
              "name": "amp",
              "default": 0.35
            }
          ],
          "type": "synthdef",
          "source": "define_synthdef(\"drone_resonant\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.35)\n        .body(|freq, amp| {\n            // Long sustain\n            let env = envelope()\n                .perc(2.5, 18.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth source\n            let osc = saw_ar(freq);\n\n            // Multiple resonant filters at different frequencies\n            let res1 = rlpf_ar(osc, freq * 2.0, 0.1) * 0.35;\n            let res2 = rlpf_ar(osc, freq * 3.0, 0.15) * 0.3;\n            let res3 = rlpf_ar(osc, freq * 5.0, 0.2) * 0.25;\n            let res4 = rlpf_ar(osc, freq * 7.0, 0.25) * 0.1;\n\n            let mix = res1 + res2 + res3 + res4;\n\n            // Overall filtering\n            let filtered = lpf_ar(mix, 3000.0);\n\n            filtered * env * amp\n        })\n});",
          "category": "textures",
          "subcategory": "drone",
          "path": "textures/drone/drone_resonant.vibe"
        }
      ]
    },
    "items": []
  },
  "Utility": {
    "subcategories": {},
    "items": [
      {
        "name": "click_high",
        "description": "Utility: Click track for timing reference",
        "genre": "",
        "character": "",
        "params": [],
        "type": "synthdef",
        "source": "// Utility: Click track for timing reference\n\n// Click high - Downbeat marker\ndefine_synthdef(\"click_high\")\n    .param(\"amp\", 0.6)\n    .body(|amp| {        let env = envelope()\n            .perc(0.001, 0.03)\n            .cleanup_on_finish()\n            .build();\n\n        sin_osc_ar(1500.0) * env * amp\n    });\n\n// Click low - Off-beat marker\ndefine_synthdef(\"click_low\")\n    .param(\"amp\", 0.5)\n    .body(|amp| {        let env = envelope()\n            .perc(0.001, 0.025)\n            .cleanup_on_finish()\n            .build();\n\n        sin_osc_ar(1000.0) * env * amp\n    });\n\n// Click wood - Natural sounding click\ndefine_synthdef(\"click_wood\")\n    .param(\"amp\", 0.55)\n    .body(|amp| {        let env = envelope()\n            .perc(0.001, 0.02)\n            .cleanup_on_finish()\n            .build();\n\n        let noise = hpf_ar(white_noise_ar(), 2000.0);\n        let body = sin_osc_ar(800.0) * 0.3;\n\n        (noise * 0.7 + body) * env * amp\n    });\n",
        "category": "utility",
        "subcategory": "",
        "path": "utility/click_track.vibe"
      },
      {
        "name": "lfo_sine",
        "description": "Sine LFO",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 1
          },
          {
            "name": "amp",
            "default": 1
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"lfo_sine\", |builder| {\n    builder\n        .param(\"freq\", 1.0)\n        .param(\"amp\", 1.0)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.001)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            sin_osc_ar(freq) * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/lfo.vibe"
      },
      {
        "name": "lfo_triangle",
        "description": "Triangle LFO (approximated)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 1
          },
          {
            "name": "amp",
            "default": 1
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"lfo_triangle\", |builder| {\n    builder\n        .param(\"freq\", 1.0)\n        .param(\"amp\", 1.0)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.001)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Use sine as approximation\n            let tri = sin_osc_ar(freq);\n            tri * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/lfo.vibe"
      },
      {
        "name": "lfo_saw",
        "description": "Sawtooth LFO",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 1
          },
          {
            "name": "amp",
            "default": 1
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"lfo_saw\", |builder| {\n    builder\n        .param(\"freq\", 1.0)\n        .param(\"amp\", 1.0)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.001)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            saw_ar(freq) * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/lfo.vibe"
      },
      {
        "name": "lfo_random",
        "description": "Random/Sample & Hold LFO (stepped random)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 4
          },
          {
            "name": "amp",
            "default": 1
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"lfo_random\", |builder| {\n    builder\n        .param(\"freq\", 4.0)\n        .param(\"amp\", 1.0)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.001)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Use noise filtered for stepped random effect\n            let noise = white_noise_ar();\n            let stepped = lpf_ar(noise, freq);\n\n            stepped * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/lfo.vibe"
      },
      {
        "name": "metronome",
        "description": "Metronome Click",
        "genre": "",
        "character": "",
        "params": [],
        "type": "synthdef",
        "source": "// Metronome Click\n// Utility | Character: Sharp, precise click\n//\n// Simple metronome click for timing reference.\n\ndefine_synthdef(\"metronome\")\n    .param(\"freq\", 1000.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        // Very short click envelope\n        let env = envelope()\n            .perc(0.0001, 0.03)\n            .cleanup_on_finish()\n            .build();\n\n        // Sharp click tone\n        let click = sin_osc_ar(freq);\n\n        // High frequency transient for clarity\n        let tick_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let tick = sin_osc_ar(freq * 4.0) * tick_env;\n\n        (click + tick * 0.5) * env * amp\n    });\n\n// Accented metronome click (for downbeats)\ndefine_synthdef(\"metronome_accent\")\n    .param(\"freq\", 1500.0)\n    .param(\"amp\", 0.6)\n    .body(|freq, amp| {\n        // Short click envelope\n        let env = envelope()\n            .perc(0.0001, 0.04)\n            .cleanup_on_finish()\n            .build();\n\n        // Higher pitched accent\n        let click = sin_osc_ar(freq);\n        let click2 = sin_osc_ar(freq * 2.0) * 0.3;\n\n        (click + click2) * env * amp\n    });\n",
        "category": "utility",
        "subcategory": "",
        "path": "utility/metronome.vibe"
      },
      {
        "name": "white_noise_gen",
        "description": "White Noise (all frequencies, flat spectrum)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "amp",
            "default": 0.3
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"white_noise_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            white_noise_ar() * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/noise_generators.vibe"
      },
      {
        "name": "pink_noise_gen",
        "description": "Pink Noise (1/f spectrum, equal energy per octave)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "amp",
            "default": 0.3
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"pink_noise_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Approximate pink noise by filtering white noise\n            let white = white_noise_ar();\n            let pink = lpf_ar(white, 10000.0);\n\n            pink * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/noise_generators.vibe"
      },
      {
        "name": "brown_noise_gen",
        "description": "Brown/Red Noise (1/f^2 spectrum, deeper)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "amp",
            "default": 0.3
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"brown_noise_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Heavy low pass for brown noise character\n            let white = white_noise_ar();\n            let brown = lpf_ar(lpf_ar(white, 800.0), 400.0);\n\n            brown * env * amp * 2.0\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/noise_generators.vibe"
      },
      {
        "name": "hiss_gen",
        "description": "High-passed Noise (hiss, bright)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "amp",
            "default": 0.2
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "freq",
            "default": 4000
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"hiss_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.2)\n        .param(\"gate\", 1.0)\n        .param(\"freq\", 4000.0) // High pass frequency\n        .body(|amp, gate, freq| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let white = white_noise_ar();\n            let hiss = hpf_ar(white, freq);\n\n            hiss * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/noise_generators.vibe"
      },
      {
        "name": "filtered_noise_gen",
        "description": "Filtered Noise (bandpass, focused)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "amp",
            "default": 0.3
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "freq",
            "default": 1000
          },
          {
            "name": "rq",
            "default": 0.2
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"filtered_noise_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .param(\"freq\", 1000.0) // Center frequency\n        .param(\"rq\", 0.2) // Resonance (lower = more resonant)\n        .body(|amp, gate, freq, rq| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let white = white_noise_ar();\n            let filtered = rlpf_ar(white, freq, rq);\n\n            filtered * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/noise_generators.vibe"
      },
      {
        "name": "crackle_gen",
        "description": "Crackle (random impulses)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "amp",
            "default": 0.2
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "density",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"crackle_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.2)\n        .param(\"gate\", 1.0)\n        .param(\"density\", 0.5) // Crackle density\n        .body(|amp, gate, density| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Use dust for random impulses\n            let impulses = dust_ar(10.0 + density * 100.0);\n            let crackle = hpf_ar(impulses, 1000.0);\n\n            crackle * env * amp * 3.0\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/noise_generators.vibe"
      },
      {
        "name": "noise_pink",
        "description": "Utility: Pure pink noise generator",
        "genre": "",
        "character": "",
        "params": [],
        "type": "synthdef",
        "source": "// Utility: Pure pink noise generator\ndefine_synthdef(\"noise_pink\")\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        pink_noise_ar() * env * amp\n    });\n",
        "category": "utility",
        "subcategory": "",
        "path": "utility/noise_pink.vibe"
      },
      {
        "name": "noise_white",
        "description": "Utility: Pure white noise generator",
        "genre": "",
        "character": "",
        "params": [],
        "type": "synthdef",
        "source": "// Utility: Pure white noise generator\ndefine_synthdef(\"noise_white\")\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        white_noise_ar() * env * amp\n    });\n",
        "category": "utility",
        "subcategory": "",
        "path": "utility/noise_white.vibe"
      },
      {
        "name": "sweep_tone",
        "description": "Utility: Oscilloscope calibration and test tones",
        "genre": "",
        "character": "",
        "params": [],
        "type": "synthdef",
        "source": "// Utility: Oscilloscope calibration and test tones\n\n// Sweep tone - Frequency sweep for testing\ndefine_synthdef(\"sweep_tone\")\n    .param(\"amp\", 0.4)\n    .param(\"gate\", 1.0)\n    .param(\"rate\", 0.5)\n    .body(|amp, gate, rate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // LFO sweeping from 100Hz to 5000Hz\n        let lfo = sin_osc_ar(rate) * 0.5 + 0.5;\n        let freq = 100.0 + lfo * 4900.0;\n\n        sin_osc_ar(freq) * env * amp\n    });\n\n// Square test - Square wave test tone\ndefine_synthdef(\"square_test\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.35)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        pulse_ar(freq, 0.5) * env * amp\n    });\n\n// Saw test - Sawtooth test tone\ndefine_synthdef(\"saw_test\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.35)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        saw_ar(freq) * env * amp\n    });\n\n// Triangle test - Triangle wave test tone\ndefine_synthdef(\"tri_test\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.4)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        lf_tri_ar(freq) * env * amp\n    });\n",
        "category": "utility",
        "subcategory": "",
        "path": "utility/oscilloscope_tones.vibe"
      },
      {
        "name": "silence",
        "description": "Utility: Silent placeholder for routing",
        "genre": "",
        "character": "",
        "params": [],
        "type": "synthdef",
        "source": "// Utility: Silent placeholder for routing\n\n// Silence - Output nothing (useful for bus routing setup)\ndefine_synthdef(\"silence\")\n    .param(\"amp\", 0.0)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.0, 1.0, 0.0)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        dc_ar(0.0) * env * amp\n    });\n",
        "category": "utility",
        "subcategory": "",
        "path": "utility/silence.vibe"
      },
      {
        "name": "test_sine",
        "description": "Pure sine wave test tone",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.3
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"test_sine\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.01)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            sin_osc_ar(freq) * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/test_tones.vibe"
      },
      {
        "name": "test_saw",
        "description": "Sawtooth test tone (rich harmonics)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.2
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"test_saw\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.2)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.01)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            saw_ar(freq) * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/test_tones.vibe"
      },
      {
        "name": "a440",
        "description": "A440 Reference tone",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "amp",
            "default": 0.3
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"a440\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.01)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            sin_osc_ar(440.0) * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/test_tones.vibe"
      },
      {
        "name": "test_1k",
        "description": "1kHz Reference tone (common audio test frequency)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "amp",
            "default": 0.3
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"test_1k\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.01)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            sin_osc_ar(1000.0) * env * amp\n        })\n});",
        "category": "utility",
        "subcategory": "",
        "path": "utility/test_tones.vibe"
      },
      {
        "name": "tuner_a440",
        "description": "Utility: Tuning reference tones",
        "genre": "",
        "character": "",
        "params": [],
        "type": "synthdef",
        "source": "// Utility: Tuning reference tones\n\n// A440 - Standard concert pitch\ndefine_synthdef(\"tuner_a440\")\n    .param(\"amp\", 0.3)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        sin_osc_ar(440.0) * env * amp\n    });\n\n// A432 - Alternative tuning reference\ndefine_synthdef(\"tuner_a432\")\n    .param(\"amp\", 0.3)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        sin_osc_ar(432.0) * env * amp\n    });\n\n// E Standard - Guitar low E\ndefine_synthdef(\"tuner_e_low\")\n    .param(\"amp\", 0.35)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // 82.41 Hz - Low E\n        sin_osc_ar(82.41) * env * amp\n    });\n",
        "category": "utility",
        "subcategory": "",
        "path": "utility/tuner.vibe"
      }
    ]
  },
  "Vocals": {
    "subcategories": {},
    "items": [
      {
        "name": "choir_pad",
        "description": "with formant filtering for vocal character.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "spread",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"choir_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"spread\", 0.5) // Stereo width and detune\n        .body(|freq, amp, gate, spread| {\n            // Slow attack for choir swell\n            let env = envelope()\n                .asr(0.8, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple \"voices\" with slight detuning\n            let detune = 0.002 + spread * 0.006;\n            let v1 = saw_ar(freq * (1.0 - detune));\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * (1.0 + detune));\n            let v4 = saw_ar(freq * (1.0 - detune * 2.0));\n            let v5 = saw_ar(freq * (1.0 + detune * 2.0));\n\n            // Octave doubling for richness\n            let octave = saw_ar(freq * 2.0) * 0.3;\n\n            let voices = (v1 + v2 + v3 + v4 + v5) * 0.25 + octave;\n\n            // Choir formant filtering (vowel blend)\n            let formant1 = rlpf_ar(voices, 600.0, 0.15);\n            let formant2 = rlpf_ar(voices, 1200.0, 0.1) * 0.5;\n            let formant3 = rlpf_ar(voices, 2400.0, 0.08) * 0.25;\n\n            let filtered = formant1 + formant2 + formant3;\n\n            // Subtle vibrato for life\n            let vib = sin_osc_ar(5.5) * 0.003;\n            let vibrato_mod = 1.0 + vib;\n\n            // Overall shaping\n            let shaped = lpf_ar(filtered, 4000.0);\n\n            shaped * env * amp * vibrato_mod\n        })\n});",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/choir_pad.vibe"
      },
      {
        "name": "formant_synth",
        "description": "Can produce \"aah\", \"eeh\", \"ooh\" type sounds.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "formant",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"formant_synth\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"formant\", 0.5) // 0=a, 0.5=e, 1.0=o\n        .body(|freq, amp, gate, formant| {\n            // Gate-controlled envelope\n            let env = envelope()\n                .asr(0.1, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Rich source oscillator with harmonics\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.003);\n            let pulse = saw_ar(freq * 0.5) * 0.5;\n            let source = (saw1 + saw2 + pulse) * 0.4;\n\n            // Formant frequencies for vowels\n            // A: 800, 1150, 2900 Hz\n            // E: 400, 1600, 2700 Hz\n            // O: 450, 800, 2830 Hz\n            let f1 = 400.0 + formant * 400.0;\n            let f2 = 800.0 + (1.0 - formant) * 800.0;\n            let f3 = 2700.0 + formant * 200.0;\n\n            // Apply resonant bandpass filters at formant frequencies\n            let bp1 = rlpf_ar(source, f1, 0.1) * 1.0;\n            let bp2 = rlpf_ar(source, f2, 0.1) * 0.7;\n            let bp3 = rlpf_ar(source, f3, 0.05) * 0.3;\n\n            let formants = bp1 + bp2 + bp3;\n\n            formants * env * amp\n        })\n});",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/formant_synth.vibe"
      },
      {
        "name": "vocal_aaah",
        "description": "\"Aaah\" choir voice",
        "genre": "Ambient, Cinematic",
        "character": "\"Aaah\" choir voice",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Ambient, Cinematic | Character: \"Aaah\" choir voice\ndefine_synthdef(\"vocal_aaah\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.008;\n\n        // Vocal source\n        let source = saw_ar(freq + vib) * 0.4;\n\n        // \"Aaah\" formants\n        let f1 = bpf_ar(source, 700.0, 0.12) * 0.5;\n        let f2 = bpf_ar(source, 1200.0, 0.15) * 0.3;\n        let f3 = bpf_ar(source, 2500.0, 0.2) * 0.15;\n\n        let sig = f1 + f2 + f3;\n\n        sig * env * amp\n    });\n",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/vocal_aaah.vibe"
      },
      {
        "name": "vocal_breathy",
        "description": "Breathy vocal texture",
        "genre": "Pop, R&B",
        "character": "Breathy vocal texture",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Pop, R&B | Character: Breathy vocal texture\ndefine_synthdef(\"vocal_breathy\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.15, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Soft vibrato\n        let vib = sin_osc_ar(4.5) * freq * 0.005;\n\n        // Pitched component\n        let pitched = saw_ar(freq + vib) * 0.25;\n\n        // Breath noise\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.0, 0.3) * 0.35;\n\n        // Formants\n        let mix = pitched + breath;\n        let f1 = bpf_ar(mix, 600.0, 0.12) * 0.4;\n        let f2 = bpf_ar(mix, 1200.0, 0.15) * 0.3;\n\n        let sig = f1 + f2;\n\n        sig * env * amp\n    });\n",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/vocal_breathy.vibe"
      },
      {
        "name": "vocal_chop",
        "description": "Perfect for vocal chop style leads.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "vowel",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"vocal_chop\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"vowel\", 0.5) // Vowel type\n        .body(|freq, amp, gate, vowel| {\n            // Short percussive envelope for chops\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright harmonically rich source\n            let saw = saw_ar(freq);\n            let pulse = saw_ar(freq * 1.001);\n            let source = (saw + pulse) * 0.5;\n\n            // Vowel formants (simplified)\n            let f1 = 300.0 + vowel * 500.0;\n            let f2 = 900.0 + (1.0 - vowel) * 700.0;\n\n            let formant1 = rlpf_ar(source, f1, 0.12);\n            let formant2 = rlpf_ar(source, f2, 0.1) * 0.6;\n\n            let vocal = formant1 + formant2;\n\n            // Slight pitch envelope for attack character\n            let pitch_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n            let pitched = sin_osc_ar(freq * (1.0 + pitch_env * 0.05)) * 0.1;\n\n            (vocal + pitched) * env * amp\n        })\n});",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/vocal_chop.vibe"
      },
      {
        "name": "vocal_eee",
        "description": "\"Eee\" vowel sound",
        "genre": "Pop, Electronic",
        "character": "\"Eee\" vowel sound",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Pop, Electronic | Character: \"Eee\" vowel sound\ndefine_synthdef(\"vocal_eee\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.15, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.008;\n\n        // Vocal source\n        let source = saw_ar(freq + vib) * 0.4;\n\n        // \"Eee\" formants (high front vowel)\n        let f1 = bpf_ar(source, 270.0, 0.08) * 0.35;\n        let f2 = bpf_ar(source, 2300.0, 0.15) * 0.45;\n        let f3 = bpf_ar(source, 3000.0, 0.2) * 0.15;\n\n        let sig = f1 + f2 + f3;\n\n        sig * env * amp\n    });\n",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/vocal_eee.vibe"
      },
      {
        "name": "vocal_falsetto",
        "description": "Light falsetto voice",
        "genre": "Soul, Pop",
        "character": "Light falsetto voice",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Soul, Pop | Character: Light falsetto voice\ndefine_synthdef(\"vocal_falsetto\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Light vibrato\n        let vib = sin_osc_ar(6.0) * freq * 0.01;\n\n        // Pure tone with slight breathiness\n        let pure = sin_osc_ar(freq + vib) * 0.5;\n        let breath = bpf_ar(pink_noise_ar(), freq * 3.0, 0.25) * 0.15;\n\n        // Light formants\n        let mix = pure + breath;\n        let f1 = bpf_ar(mix, 800.0, 0.15) * 0.35;\n        let f2 = bpf_ar(mix, 1800.0, 0.18) * 0.25;\n\n        let sig = f1 + f2 + pure * 0.3;\n\n        sig * env * amp\n    });\n",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/vocal_falsetto.vibe"
      },
      {
        "name": "vocal_mmm",
        "description": "Humming \"Mmm\" sound",
        "genre": "Ambient, Soul",
        "character": "Humming \"Mmm\" sound",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Ambient, Soul | Character: Humming \"Mmm\" sound\ndefine_synthdef(\"vocal_mmm\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.0) * freq * 0.006;\n\n        // Nasal resonance source\n        let source = saw_ar(freq + vib) * 0.35;\n\n        // Humming formants (nasal, closed mouth)\n        let f1 = bpf_ar(source, 250.0, 0.05) * 0.4;\n        let f2 = bpf_ar(source, 1000.0, 0.1) * 0.2;\n        let nasal = bpf_ar(source, 2500.0, 0.15) * 0.15;\n\n        let sig = f1 + f2 + nasal;\n\n        // Slight low pass for warmth\n        let filtered = lpf_ar(sig, 3000.0);\n\n        filtered * env * amp\n    });\n",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/vocal_mmm.vibe"
      },
      {
        "name": "vocal_oooh",
        "description": "\"Oooh\" choir voice",
        "genre": "Ambient, R&B",
        "character": "\"Oooh\" choir voice",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Ambient, R&B | Character: \"Oooh\" choir voice\ndefine_synthdef(\"vocal_oooh\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.008;\n\n        // Vocal source\n        let source = saw_ar(freq + vib) * 0.4;\n\n        // \"Oooh\" formants (lower formants)\n        let f1 = bpf_ar(source, 350.0, 0.1) * 0.5;\n        let f2 = bpf_ar(source, 700.0, 0.12) * 0.3;\n        let f3 = bpf_ar(source, 2200.0, 0.2) * 0.1;\n\n        let sig = f1 + f2 + f3;\n\n        sig * env * amp\n    });\n",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/vocal_oooh.vibe"
      },
      {
        "name": "vocal_operatic",
        "description": "Operatic voice",
        "genre": "Classical, Cinematic",
        "character": "Operatic voice",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Classical, Cinematic | Character: Operatic voice\ndefine_synthdef(\"vocal_operatic\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.25, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Strong vibrato\n        let vib = sin_osc_ar(6.0) * freq * 0.02;\n\n        // Rich harmonic source\n        let source = saw_ar(freq + vib) * 0.5;\n\n        // Operatic formants - strong singer's formant\n        let f1 = bpf_ar(source, 700.0, 0.1) * 0.35;\n        let f2 = bpf_ar(source, 1500.0, 0.12) * 0.3;\n        let f3 = bpf_ar(source, 2500.0, 0.15) * 0.25;\n        let singers_formant = bpf_ar(source, 3000.0, 0.1) * 0.35;\n\n        let sig = f1 + f2 + f3 + singers_formant;\n\n        sig * env * amp\n    });\n",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/vocal_operatic.vibe"
      },
      {
        "name": "vocal_robot",
        "description": "Robot voice effect",
        "genre": "Electronic, Experimental",
        "character": "Robot voice effect",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Electronic, Experimental | Character: Robot voice effect\ndefine_synthdef(\"vocal_robot\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Metallic carrier\n        let carrier = pulse_ar(freq, 0.5) * 0.3;\n\n        // Ring modulation for robot effect\n        let ring_freq = 200.0;\n        let ring = carrier * sin_osc_ar(ring_freq);\n\n        // Formant-like filtering\n        let f1 = bpf_ar(ring, 800.0, 0.2) * 0.5;\n        let f2 = bpf_ar(ring, 2000.0, 0.25) * 0.35;\n\n        let sig = f1 + f2;\n\n        sig * env * amp\n    });\n",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/vocal_robot.vibe"
      },
      {
        "name": "voice_drone",
        "description": "Dark, evolving voice-like drone with slow modulation.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "darkness",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"voice_drone\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"darkness\", 0.5) // Filter darkness\n        .body(|freq, amp, gate, darkness| {\n            // Very slow attack for drone\n            let env = envelope()\n                .asr(2.0, 1.0, 1.0)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep oscillator base\n            let osc1 = saw_ar(freq);\n            let osc2 = saw_ar(freq * 0.998);\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let source = (osc1 + osc2) * 0.5 + sub;\n\n            // Slow modulating formant\n            let mod_speed = 0.1;\n            let formant_mod = sin_osc_ar(mod_speed) * 0.5 + 0.5;\n            let formant_freq = 300.0 + formant_mod * 400.0;\n\n            // Apply formant with modulation\n            let formant = rlpf_ar(source, formant_freq, 0.2);\n\n            // Darkness control\n            let cutoff = 2000.0 - darkness * 1500.0;\n            let dark = lpf_ar(formant, cutoff);\n\n            // Add breath noise\n            let breath_mod = sin_osc_ar(0.15) * 0.5 + 0.5;\n            let breath = white_noise_ar() * 0.02 * breath_mod;\n            let breath_filtered = lpf_ar(hpf_ar(breath, 1000.0), 4000.0);\n\n            (dark + breath_filtered) * env * amp\n        })\n});",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/voice_drone.vibe"
      },
      {
        "name": "whisper",
        "description": "Creates whisper-like textures with filtered noise.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "breathiness",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"whisper\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"breathiness\", 0.7) // Noise amount\n        .body(|freq, amp, gate, breathiness| {\n            // Soft envelope\n            let env = envelope()\n                .asr(0.1, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Mostly noise with hint of pitch\n            let noise = white_noise_ar();\n            let pitched = sin_osc_ar(freq) * 0.2;\n\n            // Formant filtering on noise for whisper character\n            let whisper_band1 = rlpf_ar(noise, freq * 2.0, 0.2);\n            let whisper_band2 = rlpf_ar(noise, freq * 4.0, 0.15) * 0.5;\n\n            let whisper = whisper_band1 + whisper_band2;\n\n            // Mix pitched and noise based on breathiness\n            let mix = pitched * (1.0 - breathiness) + whisper * breathiness;\n\n            // Shape the output\n            let shaped = lpf_ar(mix, 6000.0);\n\n            shaped * env * amp\n        })\n});",
        "category": "vocals",
        "subcategory": "",
        "path": "vocals/whisper.vibe"
      }
    ]
  },
  "Woodwinds": {
    "subcategories": {},
    "items": [
      {
        "name": "bassoon",
        "description": "The bassoon with its distinctive dark, reedy tone.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"bassoon\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.06, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.0) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Complex harmonic structure\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.25;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.15;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Reed buzz\n            let reed = white_noise_ar() * 0.01;\n            let reed_filtered = lpf_ar(hpf_ar(reed, 800.0), 2500.0);\n\n            // Dark body resonance\n            let body = rlpf_ar(tone + reed_filtered, 1500.0, 0.3);\n\n            body * env * amp * 0.6\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/bassoon.vibe"
      },
      {
        "name": "contrabassoon",
        "description": "Contrabassoon",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"contrabassoon\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.1, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slow vibrato\n            let vib = sin_osc_ar(4.0) * 0.003 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Very dark harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.4;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.15;\n\n            let tone = h1 + h2 + h3 + h4 + h5;\n\n            // Very dark filtering\n            let body = lpf_ar(tone, 1200.0);\n\n            body * env * amp * 0.7\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/bassoon.vibe"
      },
      {
        "name": "clarinet",
        "description": "and bright upper register.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"clarinet\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.0) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Clarinet has strong odd harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.6;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.3;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.15;\n            let h9 = sin_osc_ar(mod_freq * 9.0) * 0.08;\n\n            let tone = h1 + h3 + h5 + h7 + h9;\n\n            // Reed buzz (very subtle)\n            let reed_env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .build();\n            let reed = white_noise_ar() * reed_env * 0.02;\n            let reed_filtered = lpf_ar(hpf_ar(reed, 1000.0), 4000.0);\n\n            // Body resonance\n            let body = rlpf_ar(tone + reed_filtered, 2500.0, 0.35);\n\n            body * env * amp * 0.6\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/clarinet.vibe"
      },
      {
        "name": "bass_clarinet",
        "description": "Bass Clarinet",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 220
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"bass_clarinet\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slow vibrato\n            let vib = sin_osc_ar(4.5) * 0.003 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Dark odd harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.25;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.1;\n\n            let tone = h1 + h3 + h5 + h7;\n\n            // Warm filtering\n            let body = lpf_ar(tone, 2000.0);\n\n            body * env * amp * 0.7\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/clarinet.vibe"
      },
      {
        "name": "flute",
        "description": "pure, silvery tone and breathy character.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 880
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "breath",
            "default": 0.3
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"flute\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"breath\", 0.3)\n        .body(|freq, amp, gate, breath| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.5) * 0.006 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Pure tone with weak harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.2;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.05;\n\n            let tone = h1 + h2 + h3;\n\n            // Breath noise\n            let noise = white_noise_ar() * breath * 0.1;\n            let breath_filtered = lpf_ar(hpf_ar(noise, 2000.0), 8000.0);\n\n            let mix = tone + breath_filtered;\n\n            // Subtle body resonance\n            let body = rlpf_ar(mix, mod_freq * 2.0, 0.5);\n\n            body * env * amp * 0.7\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/flute.vibe"
      },
      {
        "name": "piccolo",
        "description": "Piccolo",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 1760
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"piccolo\", |builder| {\n    builder\n        .param(\"freq\", 1760.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(6.0) * 0.005 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Very pure, bright tone\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.15;\n\n            let tone = h1 + h2;\n\n            // Light breath\n            let noise = white_noise_ar() * 0.03;\n            let breath = hpf_ar(noise, 4000.0);\n\n            (tone + breath) * env * amp * 0.6\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/flute.vibe"
      },
      {
        "name": "oboe",
        "description": "and expressive vibrato.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"oboe\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.5) * 0.006 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Rich harmonic content\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.2;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.12;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Nasal formant (characteristic oboe resonance)\n            let nasal = rlpf_ar(tone, 1500.0, 0.25);\n            let bright = rlpf_ar(tone, 3500.0, 0.3) * 0.4;\n\n            let body = nasal + bright;\n\n            body * env * amp * 0.5\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/oboe.vibe"
      },
      {
        "name": "alto_sax",
        "description": "Alto Saxophone",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "growl",
            "default": "0.0"
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"alto_sax\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"growl\", 0.0) // Growl/subtone amount\n        .body(|freq, amp, gate, growl| {\n            let env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.5) * 0.008 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Saxophone harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.4;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.15;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.1;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Growl (low frequency modulation)\n            let growl_mod = sin_osc_ar(30.0) * growl * 0.3 + 1.0;\n\n            // Bright sax formant\n            let body = rlpf_ar(tone * growl_mod, 2000.0, 0.3);\n            let bright = rlpf_ar(tone, 4000.0, 0.4) * 0.3;\n\n            (body + bright) * env * amp * 0.5\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/saxophone.vibe"
      },
      {
        "name": "tenor_sax",
        "description": "Tenor Saxophone",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 330
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tenor_sax\", |builder| {\n    builder\n        .param(\"freq\", 330.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.0) * 0.007 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Warmer than alto\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.12;\n\n            let tone = h1 + h2 + h3 + h4 + h5;\n\n            // Warm formant\n            let body = rlpf_ar(tone, 1800.0, 0.35);\n\n            body * env * amp * 0.6\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/saxophone.vibe"
      },
      {
        "name": "soprano_sax",
        "description": "Soprano Saxophone",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 660
          },
          {
            "name": "amp",
            "default": 0.4
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"soprano_sax\", |builder| {\n    builder\n        .param(\"freq\", 660.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(6.0) * 0.006 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Brighter than alto\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.2;\n\n            let tone = h1 + h2 + h3 + h4;\n\n            // Bright formant\n            let body = rlpf_ar(tone, 2500.0, 0.3);\n\n            body * env * amp * 0.6\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/saxophone.vibe"
      },
      {
        "name": "bari_sax",
        "description": "Baritone Saxophone",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 165
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"bari_sax\", |builder| {\n    builder\n        .param(\"freq\", 165.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.06, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slow vibrato\n            let vib = sin_osc_ar(4.5) * 0.005 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Full, dark harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.1;\n\n            let tone = h1 + h2 + h3 + h4 + h5;\n\n            // Deep, warm formant\n            let body = rlpf_ar(tone, 1200.0, 0.35);\n\n            body * env * amp * 0.6\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/saxophone.vibe"
      },
      {
        "name": "clarinet_realistic",
        "description": "Realistic Clarinet with register breaks and chalumeau character",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 261.63
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "reed_stiffness",
            "default": 0.5
          },
          {
            "name": "embouchure",
            "default": 0.5
          },
          {
            "name": "breath",
            "default": 0.3
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"clarinet_realistic\", |builder| {\n    builder\n        .param(\"freq\", 261.63)    // Middle C default\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"reed_stiffness\", 0.5)   // Softer reed = warmer\n        .param(\"embouchure\", 0.5)       // Lip pressure\n        .param(\"breath\", 0.3)           // Breath noise amount\n        .body(|freq, amp, gate, reed_stiffness, embouchure, breath| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Delayed vibrato (starts after initial attack)\n            let vib_delay = envelope()\n                .perc(0.3, 5.0)\n                .build();\n            let vib_depth = 0.004 + (embouchure * 0.003);\n            let vib = sin_osc_ar(5.5) * vib_depth * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Clarinet's cylindrical bore produces strong odd harmonics\n            // The relative strength depends on register\n            let register_factor = freq / 261.63;  // Relative to middle C\n            let odd_emphasis = 1.0 / (1.0 + (register_factor * 0.3));\n\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.65 * odd_emphasis;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.4 * odd_emphasis;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.22 * odd_emphasis;\n            let h9 = sin_osc_ar(mod_freq * 9.0) * 0.12 * odd_emphasis;\n            let h11 = sin_osc_ar(mod_freq * 11.0) * 0.06 * odd_emphasis;\n\n            // Even harmonics (weaker, add warmth)\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.15 * reed_stiffness;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.08 * reed_stiffness;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h7 + h9 + h11;\n\n            // Reed buzz/chiff on attack\n            let chiff_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let chiff = white_noise_ar() * chiff_env * reed_stiffness * 0.15;\n            let chiff_filtered = bpf_ar(chiff, mod_freq * 3.0, 0.3);\n\n            // Continuous breath noise\n            let breath_noise = white_noise_ar() * breath * 0.08;\n            let breath_filtered = bpf_ar(breath_noise, mod_freq * 2.5, 0.5);\n\n            // Bore resonance formants\n            let f1 = rlpf_ar(harmonics, 1500.0, 0.4) * 0.7;\n            let f2 = rlpf_ar(harmonics, 2800.0, 0.35) * 0.3;\n\n            // Bell flare effect (brightens low notes)\n            let bell_effect = rlpf_ar(harmonics, 4000.0, 0.5) * 0.15 * (1.0 / register_factor);\n\n            let tone = f1 + f2 + bell_effect + chiff_filtered + breath_filtered;\n\n            // Remove subsonic content\n            let clean = hpf_ar(tone, 80.0);\n\n            clean * env * amp * 0.55\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/woodwinds_realistic.vibe"
      },
      {
        "name": "alto_sax_realistic",
        "description": "Realistic Alto Saxophone with growl and subtone capabilities",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 370
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "embouchure",
            "default": 0.5
          },
          {
            "name": "growl",
            "default": "0.0"
          },
          {
            "name": "subtone",
            "default": "0.0"
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"alto_sax_realistic\", |builder| {\n    builder\n        .param(\"freq\", 370.0)     // F#4 - comfortable alto range\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"embouchure\", 0.5)    // Affects timbre brightness\n        .param(\"growl\", 0.0)         // Throat growl amount\n        .param(\"subtone\", 0.0)       // Airy subtone amount\n        .body(|freq, amp, gate, embouchure, growl, subtone| {\n            let env = envelope()\n                .asr(0.025, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Jazz vibrato - wider and more expressive\n            let vib_delay = envelope()\n                .perc(0.2, 4.0)\n                .build();\n            let vib_depth = 0.006 + (embouchure * 0.004);\n            let vib_rate = 5.0 + (embouchure * 1.0);\n            let vib = sin_osc_ar(vib_rate) * vib_depth * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Saxophone's conical bore - full harmonic series\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.45;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.3;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.2;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.14;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.09;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.05;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Growl effect - vocal fold modulation\n            let growl_freq = 25.0 + (embouchure * 10.0);\n            let growl_mod = sin_osc_ar(growl_freq) * growl * 0.35 + 1.0;\n\n            // Subtone - breathy, airy quality\n            let sub_noise = pink_noise_ar() * subtone * 0.25;\n            let sub_filtered = bpf_ar(sub_noise, mod_freq, 0.3);\n\n            // Reed attack transient\n            let attack_env = envelope()\n                .perc(0.001, 0.015)\n                .build();\n            let attack_noise = white_noise_ar() * attack_env * 0.12;\n            let attack_filtered = bpf_ar(attack_noise, mod_freq * 4.0, 0.4);\n\n            // Sax body formants (characteristic of alto)\n            let f1 = rlpf_ar(harmonics * growl_mod, 650.0, 0.4) * 0.4;  // Low resonance\n            let f2 = rlpf_ar(harmonics * growl_mod, 1400.0, 0.35) * 0.35;  // Mid\n            let f3 = rlpf_ar(harmonics * growl_mod, 2800.0, 0.3) * 0.25 * embouchure;  // High brightness\n\n            // Bell resonance\n            let bell = rlpf_ar(harmonics, 4200.0, 0.5) * 0.12;\n\n            let tone = f1 + f2 + f3 + bell + sub_filtered + attack_filtered;\n\n            hpf_ar(tone, 100.0) * env * amp * 0.5\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/woodwinds_realistic.vibe"
      },
      {
        "name": "tenor_sax_realistic",
        "description": "warmer, bigger sound",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 277.18
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "warmth",
            "default": 0.6
          },
          {
            "name": "growl",
            "default": "0.0"
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tenor_sax_realistic\", |builder| {\n    builder\n        .param(\"freq\", 277.18)   // C#4\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"warmth\", 0.6)\n        .param(\"growl\", 0.0)\n        .body(|freq, amp, gate, warmth, growl| {\n            let env = envelope()\n                .asr(0.035, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slower, wider vibrato for tenor\n            let vib_delay = envelope()\n                .perc(0.25, 4.0)\n                .build();\n            let vib = sin_osc_ar(4.8) * 0.007 * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Richer harmonics for bigger sound\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.42;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.28;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.18;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.12;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.07;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Growl\n            let growl_mod = sin_osc_ar(22.0) * growl * 0.35 + 1.0;\n\n            // Tenor formants - lower than alto\n            let f1 = rlpf_ar(harmonics * growl_mod, 550.0, 0.4) * 0.45;\n            let f2 = rlpf_ar(harmonics * growl_mod, 1200.0, 0.35) * 0.35;\n            let f3 = rlpf_ar(harmonics * growl_mod, 2400.0, 0.35) * 0.2 * (1.0 - warmth * 0.5);\n\n            // Warmth control - adds low-mid body\n            let warm_res = rlpf_ar(harmonics, 400.0, 0.5) * warmth * 0.25;\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.001, 0.018)\n                .build();\n            let attack = bpf_ar(white_noise_ar() * attack_env * 0.1, mod_freq * 3.0, 0.4);\n\n            let tone = f1 + f2 + f3 + warm_res + attack;\n\n            hpf_ar(tone, 80.0) * env * amp * 0.55\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/woodwinds_realistic.vibe"
      },
      {
        "name": "flute_realistic",
        "description": "Realistic Flute with air jet modeling",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 523.25
          },
          {
            "name": "amp",
            "default": 0.55
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "breath",
            "default": 0.35
          },
          {
            "name": "air_speed",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"flute_realistic\", |builder| {\n    builder\n        .param(\"freq\", 523.25)   // C5\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .param(\"breath\", 0.35)      // Breath noise amount\n        .param(\"air_speed\", 0.5)    // Embouchure tightness\n        .body(|freq, amp, gate, breath, air_speed| {\n            let env = envelope()\n                .asr(0.06, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Flute vibrato - gentle, sine-like\n            let vib_delay = envelope()\n                .perc(0.4, 5.0)\n                .build();\n            let vib = sin_osc_ar(5.8) * 0.005 * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Flute has weak harmonics - mostly fundamental\n            // Higher air speed = more harmonics (brighter)\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.25 * air_speed;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.1 * air_speed;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.04 * air_speed;\n\n            let harmonics = h1 + h2 + h3 + h4;\n\n            // Air jet noise - characteristic of flute\n            let jet_noise = white_noise_ar() * breath;\n            let jet_filtered = bpf_ar(jet_noise, mod_freq * 2.0, 0.4) * 0.3;\n\n            // Edge tone noise (the hiss)\n            let edge_noise = hpf_ar(white_noise_ar() * breath * 0.15, 4000.0);\n\n            // Attack breath burst\n            let attack_env = envelope()\n                .perc(0.005, 0.04)\n                .build();\n            let attack_breath = white_noise_ar() * attack_env * breath * 0.4;\n            let attack_filtered = lpf_ar(attack_breath, 6000.0);\n\n            // Tube resonance\n            let resonance = rlpf_ar(harmonics, mod_freq * 2.0, 0.6) * 0.2;\n\n            let tone = harmonics + jet_filtered + edge_noise + attack_filtered + resonance;\n\n            // Clean, silvery character\n            let clean = lpf_ar(hpf_ar(tone, 150.0), 12000.0);\n\n            clean * env * amp * 0.55\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/woodwinds_realistic.vibe"
      },
      {
        "name": "oboe_realistic",
        "description": "nasal, penetrating",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.55
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "reed_pressure",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"oboe_realistic\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .param(\"reed_pressure\", 0.6)\n        .body(|freq, amp, gate, reed_pressure| {\n            let env = envelope()\n                .asr(0.03, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Oboe vibrato - subtle\n            let vib = sin_osc_ar(5.5) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Oboe has ALL harmonics, creating nasal quality\n            // Double reed produces rich spectrum\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.3;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.22;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.16;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.11;\n            let h9 = sin_osc_ar(mod_freq * 9.0) * 0.07;\n            let h10 = sin_osc_ar(mod_freq * 10.0) * 0.04;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8 + h9 + h10;\n\n            // Double reed \"crow\" on attack\n            let crow_env = envelope()\n                .perc(0.001, 0.01)\n                .build();\n            let crow = white_noise_ar() * crow_env * reed_pressure * 0.15;\n            let crow_filtered = bpf_ar(crow, mod_freq * 5.0, 0.3);\n\n            // Nasal formants characteristic of oboe\n            let f1 = rlpf_ar(harmonics, 1400.0, 0.25) * 0.4;  // Nasal peak\n            let f2 = rlpf_ar(harmonics, 2800.0, 0.3) * 0.35;\n            let f3 = rlpf_ar(harmonics, 4200.0, 0.35) * 0.25 * reed_pressure;\n\n            let tone = f1 + f2 + f3 + crow_filtered;\n\n            hpf_ar(tone, 200.0) * env * amp * 0.5\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/woodwinds_realistic.vibe"
      },
      {
        "name": "english_horn",
        "description": "deeper, more melancholic",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 311.13
          },
          {
            "name": "amp",
            "default": 0.55
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"english_horn\", |builder| {\n    builder\n        .param(\"freq\", 311.13)   // Eb4\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Gentle vibrato\n            let vib = sin_osc_ar(5.0) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Similar to oboe but darker\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.45;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.32;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.22;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.15;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.1;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Lower, darker formants\n            let f1 = rlpf_ar(harmonics, 1100.0, 0.3) * 0.45;\n            let f2 = rlpf_ar(harmonics, 2200.0, 0.35) * 0.35;\n            let f3 = rlpf_ar(harmonics, 3500.0, 0.4) * 0.2;\n\n            let tone = f1 + f2 + f3;\n\n            hpf_ar(tone, 150.0) * env * amp * 0.55\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/woodwinds_realistic.vibe"
      },
      {
        "name": "bassoon_realistic",
        "description": "rich, woody bass woodwind",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 130.81
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "reed_buzz",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"bassoon_realistic\", |builder| {\n    builder\n        .param(\"freq\", 130.81)   // C3\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"reed_buzz\", 0.4)\n        .body(|freq, amp, gate, reed_buzz| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slow vibrato\n            let vib = sin_osc_ar(4.5) * 0.003 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Bassoon has rich harmonic spectrum\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.38;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.28;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.2;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.14;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.09;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Reed buzz character\n            let buzz = white_noise_ar() * reed_buzz * 0.04;\n            let buzz_filtered = bpf_ar(buzz, mod_freq * 4.0, 0.4);\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.001, 0.025)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.08;\n\n            // Wooden body formants\n            let f1 = rlpf_ar(harmonics, 440.0, 0.4) * 0.4;\n            let f2 = rlpf_ar(harmonics, 1200.0, 0.35) * 0.35;\n            let f3 = rlpf_ar(harmonics, 2200.0, 0.35) * 0.25;\n\n            let tone = f1 + f2 + f3 + buzz_filtered + attack;\n\n            hpf_ar(tone, 60.0) * env * amp * 0.55\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/woodwinds_realistic.vibe"
      },
      {
        "name": "recorder",
        "description": "Medieval/Renaissance woodwind",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 523.25
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "breath",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"recorder\", |builder| {\n    builder\n        .param(\"freq\", 523.25)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"breath\", 0.4)\n        .body(|freq, amp, gate, breath| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simple vibrato\n            let vib = sin_osc_ar(5.5) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Recorder - fairly pure with some harmonics\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.35;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.15;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.06;\n\n            let harmonics = h1 + h2 + h3 + h4;\n\n            // Breathy attack and sustain\n            let breath_noise = white_noise_ar() * breath * 0.12;\n            let breath_filtered = bpf_ar(breath_noise, mod_freq * 2.0, 0.5);\n\n            let tone = harmonics + breath_filtered;\n\n            hpf_ar(tone, 200.0) * env * amp * 0.55\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/woodwinds_realistic.vibe"
      },
      {
        "name": "pan_flute",
        "description": "breathy, ethereal",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "breath",
            "default": 0.5
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"pan_flute\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"breath\", 0.5)\n        .body(|freq, amp, gate, breath| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Gentle vibrato\n            let vib = sin_osc_ar(5.0) * 0.006 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Very pure - almost sine\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.15;\n\n            let harmonics = h1 + h2;\n\n            // Lots of breath/wind noise\n            let breath_noise = white_noise_ar() * breath * 0.2;\n            let breath_filtered = lpf_ar(hpf_ar(breath_noise, 1000.0), 6000.0);\n\n            // Breathy attack\n            let attack_env = envelope()\n                .perc(0.01, 0.08)\n                .build();\n            let attack = white_noise_ar() * attack_env * breath * 0.3;\n\n            let tone = harmonics + breath_filtered + attack;\n\n            hpf_ar(tone, 150.0) * env * amp * 0.5\n        })\n});",
        "category": "woodwinds",
        "subcategory": "",
        "path": "woodwinds/woodwinds_realistic.vibe"
      }
    ]
  },
  "World": {
    "subcategories": {},
    "items": [
      {
        "name": "accordion",
        "description": "Accordion/melodeon",
        "genre": "Folk, Tango, Zydeco",
        "character": "Accordion/melodeon",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Folk, Tango, Zydeco | Character: Accordion/melodeon\ndefine_synthdef(\"accordion\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.03, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Reed-like tone\n        let osc1 = pulse_ar(freq, 0.4) * 0.3;\n        let osc2 = pulse_ar(freq * 1.003, 0.45) * 0.25;\n\n        // Upper harmonics\n        let harm = sin_osc_ar(freq * 2.0) * 0.15;\n\n        let mix = osc1 + osc2 + harm;\n\n        // Bellows variation\n        let bellows = sin_osc_ar(0.3) * 0.1 + 0.9;\n\n        lpf_ar(mix, 4000.0) * bellows * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/accordion.vibe"
      },
      {
        "name": "bagpipe",
        "description": "Scottish bagpipe chanter",
        "genre": "Celtic, Scottish",
        "character": "Scottish bagpipe chanter",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Celtic, Scottish | Character: Scottish bagpipe chanter\ndefine_synthdef(\"bagpipe\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.05)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright, reedy tone\n        let body = saw_ar(freq) * 0.3;\n        let harm1 = saw_ar(freq * 2.0) * 0.2;\n        let harm2 = saw_ar(freq * 3.0) * 0.15;\n\n        // Drone (constant)\n        let drone = sin_osc_ar(freq * 0.5) * 0.2;\n\n        let mix = body + harm1 + harm2 + drone;\n\n        // Nasal filtering\n        bpf_ar(mix, 1500.0, 0.3) * 2.0 * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/bagpipe.vibe"
      },
      {
        "name": "balalaika",
        "description": "Triangular stringed instrument",
        "genre": "",
        "character": "Triangular stringed instrument",
        "params": [],
        "type": "synthdef",
        "source": "// Region: Russian | Character: Triangular stringed instrument\ndefine_synthdef(\"balalaika\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Plucked string excitation\n        let pluck_env = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let exciter = lpf_ar(white_noise_ar(), 3000.0) * pluck_env * 0.8;\n\n        // Bright triangular body resonance\n        let body1 = sin_osc_ar(freq) * 0.5;\n        let body2 = sin_osc_ar(freq * 2.0) * 0.3;\n        let body3 = sin_osc_ar(freq * 3.0) * 0.15;\n        let body4 = sin_osc_ar(freq * 4.0) * 0.08;\n\n        let sig = body1 + body2 + body3 + body4 + exciter;\n\n        // Bright character\n        let filtered = hpf_ar(sig, 200.0);\n\n        filtered * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/balalaika.vibe"
      },
      {
        "name": "banjo",
        "description": "Bright, twangy plucked string",
        "genre": "",
        "character": "Bright, twangy plucked string",
        "params": [],
        "type": "synthdef",
        "source": "// Region: American | Character: Bright, twangy plucked string\ndefine_synthdef(\"banjo\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright plucked excitation\n        let pluck_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let exciter = hpf_ar(white_noise_ar(), 2000.0) * pluck_env * 0.5;\n\n        // Bright string resonance\n        let str1 = pulse_ar(freq, 0.4) * 0.4;\n        let str2 = sin_osc_ar(freq * 2.0) * 0.25;\n        let str3 = sin_osc_ar(freq * 3.0) * 0.15;\n        let str4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n        let sig = str1 + str2 + str3 + str4 + exciter;\n\n        // Drum head resonance - characteristic twang\n        let drum_res = bpf_ar(sig, 800.0, 0.2) * 0.4;\n        let output = sig + drum_res;\n\n        // Bright, cutting through\n        let filtered = hpf_ar(output, 300.0);\n\n        filtered * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/banjo.vibe"
      },
      {
        "name": "bouzouki",
        "description": "Long-necked lute with metallic tone",
        "genre": "",
        "character": "Long-necked lute with metallic tone",
        "params": [],
        "type": "synthdef",
        "source": "// Region: Greek | Character: Long-necked lute with metallic tone\ndefine_synthdef(\"bouzouki\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Double string courses - slight detuning\n        let detune = 1.003;\n        let str1 = saw_ar(freq) * 0.3;\n        let str2 = saw_ar(freq * detune) * 0.3;\n\n        // Metallic overtones\n        let metal1 = sin_osc_ar(freq * 2.0) * 0.2;\n        let metal2 = sin_osc_ar(freq * 3.0) * 0.12;\n        let metal3 = sin_osc_ar(freq * 5.0) * 0.05;\n\n        let sig = str1 + str2 + metal1 + metal2 + metal3;\n\n        // Resonant metallic filter\n        let filtered = bpf_ar(sig, 2000.0, 0.3) + sig * 0.5;\n\n        filtered * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/bouzouki.vibe"
      },
      {
        "name": "darbuka",
        "description": "Darbuka/doumbek hand drum",
        "genre": "Middle Eastern, Arabic",
        "character": "Darbuka/doumbek hand drum",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Middle Eastern, Arabic | Character: Darbuka/doumbek hand drum\ndefine_synthdef(\"darbuka\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.8)\n    .param(\"type\", 0.0) // 0=doum, 0.5=tek, 1.0=ka\n    .body(|freq, amp, type_param| {\n        // Decay based on type\n        let decay = 0.3 - type_param * 0.2;\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch based on type\n        let pitch = freq * (1.0 + type_param * 2.0);\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n\n        // Body\n        let body = sin_osc_ar(pitch + pitch_env * pitch * (1.0 - type_param)) * (1.0 - type_param * 0.5);\n\n        // High slap for tek/ka\n        let slap = hpf_ar(white_noise_ar(), 3000.0 + type_param * 3000.0) * type_param * 0.4;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + slap + attack) * amp_env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/darbuka.vibe"
      },
      {
        "name": "didgeridoo",
        "description": "Deep drone instrument",
        "genre": "",
        "character": "Deep drone instrument",
        "params": [],
        "type": "synthdef",
        "source": "// Region: Australian | Character: Deep drone instrument\ndefine_synthdef(\"didgeridoo\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Fundamental drone\n        let fundamental = saw_ar(freq) * 0.4;\n\n        // Overtones with slight variations\n        let lfo = sin_osc_ar(0.3) * 1.5;\n        let ot1 = saw_ar(freq * 2.0 + lfo) * 0.2;\n        let ot2 = pulse_ar(freq * 3.0, 0.3) * 0.1;\n\n        // Breath noise\n        let breath = lpf_ar(pink_noise_ar(), 300.0) * 0.15;\n\n        let sig = fundamental + ot1 + ot2 + breath;\n\n        // Resonant filter for tubular character\n        let filtered = rlpf_ar(sig, 200.0, 0.3);\n\n        filtered * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/didgeridoo.vibe"
      },
      {
        "name": "djembe_bass",
        "description": "Djembe Bass (center hit)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 80
          },
          {
            "name": "amp",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"djembe_bass\", |builder| {\n    builder\n        .param(\"freq\", 80.0)\n        .param(\"amp\", 0.7)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.35)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep body tone\n            let body = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n\n            let tone = body + h2;\n\n            // Soft attack\n            let attack_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.1;\n\n            (tone + lpf_ar(attack, 800.0)) * env * amp\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/djembe.vibe"
      },
      {
        "name": "djembe_tone",
        "description": "Djembe Tone (edge hit)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 200
          },
          {
            "name": "amp",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"djembe_tone\", |builder| {\n    builder\n        .param(\"freq\", 200.0)\n        .param(\"amp\", 0.6)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.2)\n                .cleanup_on_finish()\n                .build();\n\n            // Mid-range tone\n            let tone = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.2) * 0.35; // Slightly inharmonic\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n\n            let mix = tone + h2 + h3;\n\n            // Edge attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.015)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.15;\n\n            (mix + hpf_ar(attack, 1500.0)) * env * amp\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/djembe.vibe"
      },
      {
        "name": "djembe_slap",
        "description": "Djembe Slap (sharp rim hit)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 400
          },
          {
            "name": "amp",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"djembe_slap\", |builder| {\n    builder\n        .param(\"freq\", 400.0)\n        .param(\"amp\", 0.6)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.0001, 0.1)\n                .cleanup_on_finish()\n                .build();\n\n            // Sharp high tone\n            let tone = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n\n            let mix = tone + h2;\n\n            // Sharp attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.3;\n\n            (mix + hpf_ar(attack, 3000.0)) * env * amp\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/djembe.vibe"
      },
      {
        "name": "erhu",
        "description": "Erhu - Chinese bowed string",
        "genre": "Chinese Traditional",
        "character": "Erhu - Chinese bowed string",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Chinese Traditional | Character: Erhu - Chinese bowed string\ndefine_synthdef(\"erhu\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.08, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Expressive vibrato\n        let vib = sin_osc_ar(6.0) * freq * 0.015;\n\n        // Bowed string harmonics\n        let h1 = sin_osc_ar(freq + vib) * 0.4;\n        let h2 = sin_osc_ar((freq + vib) * 2.0) * 0.25;\n        let h3 = sin_osc_ar((freq + vib) * 3.0) * 0.15;\n        let h4 = sin_osc_ar((freq + vib) * 4.0) * 0.08;\n\n        // Bow noise\n        let bow = bpf_ar(pink_noise_ar(), 2500.0, 0.5) * 0.1;\n\n        let sig = h1 + h2 + h3 + h4 + bow;\n\n        lpf_ar(sig, 5000.0) * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/erhu.vibe"
      },
      {
        "name": "gamelan_gong",
        "description": "Gamelan Gong",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 110
          },
          {
            "name": "amp",
            "default": 0.6
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"gamelan_gong\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Very long decay for gong\n            let decay_env = envelope()\n                .perc(0.001, 4.0)\n                .build();\n\n            // Complex inharmonic partials\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.3) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.1) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.7) * 0.25;\n            let h5 = sin_osc_ar(freq * 6.2) * 0.15;\n\n            let gong = h1 + h2 + h3 + h4 + h5;\n\n            // Strike\n            let strike_env = envelope()\n                .perc(0.0001, 0.05)\n                .build();\n            let strike = white_noise_ar() * strike_env * 0.15;\n\n            (gong + lpf_ar(strike, 2000.0)) * env * decay_env * amp * 0.5\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/gamelan.vibe"
      },
      {
        "name": "gamelan_metal",
        "description": "Gamelan Metallophone (Saron/Gender)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"gamelan_metal\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium decay\n            let decay_env = envelope()\n                .perc(0.001, 1.5)\n                .build();\n\n            // Metallic partials\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.8) * 0.3; // Inharmonic\n            let h4 = sin_osc_ar(freq * 5.1) * 0.2;\n\n            let metal = h1 + h2 + h3 + h4;\n\n            // Mallet strike\n            let strike_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let strike = sin_osc_ar(freq * 7.0) * strike_env * 0.15;\n\n            (metal + strike) * env * decay_env * amp * 0.5\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/gamelan.vibe"
      },
      {
        "name": "hang_drum",
        "description": "Handpan with bell-like, ethereal tones",
        "genre": "",
        "character": "Handpan with bell-like, ethereal tones",
        "params": [],
        "type": "synthdef",
        "source": "// Region: Swiss | Character: Handpan with bell-like, ethereal tones\ndefine_synthdef(\"hang_drum\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.8)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bell-like attack\n        let attack_env = envelope()\n            .perc(0.001, 0.1)\n            .build();\n        let attack = sin_osc_ar(freq * 4.0) * attack_env * 0.3;\n\n        // Main tone with detuned partials\n        let main = sin_osc_ar(freq) * 0.5;\n        let partial1 = sin_osc_ar(freq * 2.01) * 0.25;\n        let partial2 = sin_osc_ar(freq * 3.0) * 0.15;\n        let partial3 = sin_osc_ar(freq * 4.02) * 0.1;\n\n        // Subtle beating for ethereal quality\n        let beat = sin_osc_ar(freq * 1.002) * 0.2;\n\n        let sig = main + partial1 + partial2 + partial3 + beat + attack;\n\n        sig * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/hang_drum.vibe"
      },
      {
        "name": "kalimba",
        "description": "distinctive bright, resonant tone.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 880
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"kalimba\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium decay\n            let decay_env = envelope()\n                .perc(0.001, 0.8)\n                .build();\n\n            // Metallic tine sound\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 5.2) * 0.15; // Slightly inharmonic\n\n            let tine = h1 + h2 + h3 + h4;\n\n            // Pluck attack\n            let pluck_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let pluck = sin_osc_ar(freq * 8.0) * pluck_env * 0.2;\n\n            // Body resonance\n            let body = rlpf_ar(tine, 2500.0, 0.3);\n\n            (body + pluck) * env * decay_env * amp * 0.6\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/kalimba.vibe"
      },
      {
        "name": "kora",
        "description": "Kora - African harp-like instrument",
        "genre": "West African",
        "character": "Kora - African harp-like instrument",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: West African | Character: Kora - African harp-like instrument\ndefine_synthdef(\"kora\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.65)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.003, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright, harp-like harmonics\n        let h1 = sin_osc_ar(freq) * 0.4;\n        let h2 = sin_osc_ar(freq * 2.0) * 0.28;\n        let h3 = sin_osc_ar(freq * 3.0) * 0.18;\n        let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n        // Pluck attack\n        let pluck = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 3000.0) * pluck * 0.15;\n\n        let sig = h1 + h2 + h3 + h4 + attack;\n\n        sig * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/kora.vibe"
      },
      {
        "name": "koto",
        "description": "its distinctive bright, resonant tone.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"koto\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay for pluck\n            let decay_env = envelope()\n                .perc(0.001, 1.2)\n                .build();\n\n            // String harmonics\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.25;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.1;\n\n            let string = h1 + h2 + h3 + h4 + h5;\n\n            // Pluck attack\n            let pluck_env = envelope()\n                .perc(0.0001, 0.015)\n                .build();\n            let pluck = white_noise_ar() * pluck_env * 0.15;\n\n            // Bridge resonance\n            let body = rlpf_ar(string, 3000.0, 0.25);\n\n            (body + pluck) * env * decay_env * amp * 0.6\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/koto.vibe"
      },
      {
        "name": "mbira",
        "description": "Thumb piano with buzzing resonance",
        "genre": "",
        "character": "Thumb piano with buzzing resonance",
        "params": [],
        "type": "synthdef",
        "source": "// Region: Zimbabwe | Character: Thumb piano with buzzing resonance\ndefine_synthdef(\"mbira\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Metal tine pluck\n        let pluck_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let exciter = hpf_ar(white_noise_ar(), 3000.0) * pluck_env * 0.4;\n\n        // Main tone with inharmonic partials\n        let main = sin_osc_ar(freq) * 0.45;\n        let partial1 = sin_osc_ar(freq * 2.3) * 0.2;\n        let partial2 = sin_osc_ar(freq * 3.7) * 0.12;\n        let partial3 = sin_osc_ar(freq * 5.1) * 0.08;\n\n        // Characteristic buzz/rattle\n        let buzz = pulse_ar(freq * 0.5, 0.1) * 0.05;\n\n        let sig = main + partial1 + partial2 + partial3 + buzz + exciter;\n\n        sig * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/mbira.vibe"
      },
      {
        "name": "ney",
        "description": "Ney flute - breathy and haunting",
        "genre": "Middle Eastern, Sufi",
        "character": "Ney flute - breathy and haunting",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Middle Eastern, Sufi | Character: Ney flute - breathy and haunting\ndefine_synthdef(\"ney\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.012;\n\n        // Main tone with breath\n        let body = sin_osc_ar(freq + vib) * 0.5;\n        let harm = sin_osc_ar((freq + vib) * 2.0) * 0.15;\n\n        // Breath component\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.5, 0.6) * 0.25;\n\n        let sig = body + harm + breath;\n\n        sig * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/ney.vibe"
      },
      {
        "name": "oud",
        "description": "Arabic oud - warm, plucked string",
        "genre": "Middle Eastern, Arabic",
        "character": "Arabic oud - warm, plucked string",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Middle Eastern, Arabic | Character: Arabic oud - warm, plucked string\ndefine_synthdef(\"oud\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.7)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Rich harmonics from plucked string\n        let h1 = sin_osc_ar(freq) * 0.4;\n        let h2 = sin_osc_ar(freq * 2.0) * 0.25;\n        let h3 = sin_osc_ar(freq * 3.0) * 0.15;\n        let h4 = sin_osc_ar(freq * 4.0) * 0.08;\n        let h5 = sin_osc_ar(freq * 5.0) * 0.04;\n\n        // Pluck attack\n        let pluck = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 1500.0, 0.5) * pluck * 0.2;\n\n        let sig = h1 + h2 + h3 + h4 + h5 + attack;\n\n        lpf_ar(sig, 4000.0) * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/oud.vibe"
      },
      {
        "name": "santoor",
        "description": "Hammered dulcimer with shimmering tone",
        "genre": "",
        "character": "Hammered dulcimer with shimmering tone",
        "params": [],
        "type": "synthdef",
        "source": "// Region: Persian/Indian | Character: Hammered dulcimer with shimmering tone\ndefine_synthdef(\"santoor\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Hammer strike\n        let strike_env = envelope()\n            .perc(0.001, 0.01)\n            .build();\n        let strike = hpf_ar(white_noise_ar(), 4000.0) * strike_env * 0.3;\n\n        // Multiple courses - slight detuning for shimmer\n        let str1 = sin_osc_ar(freq) * 0.35;\n        let str2 = sin_osc_ar(freq * 1.002) * 0.35;\n        let str3 = sin_osc_ar(freq * 0.998) * 0.35;\n\n        // Bright harmonics\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.2;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.1;\n\n        let sig = str1 + str2 + str3 + harm1 + harm2 + strike;\n\n        sig * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/santoor.vibe"
      },
      {
        "name": "shakuhachi",
        "description": "distinctive breathy, meditative sound.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "breath",
            "default": 0.4
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"shakuhachi\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"breath\", 0.4) // Breath noise amount\n        .body(|freq, amp, gate, breath| {\n            let env = envelope()\n                .asr(0.15, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Gentle vibrato\n            let vib = sin_osc_ar(5.0) * 0.008 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Breathy tone\n            let tone = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.3;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.1;\n\n            let flute = tone + h2 + h3;\n\n            // Breath noise\n            let noise = white_noise_ar() * breath * 0.15;\n            let breath_filtered = lpf_ar(hpf_ar(noise, 1000.0), 5000.0);\n\n            let mix = flute + breath_filtered;\n\n            // Body resonance\n            let body = rlpf_ar(mix, mod_freq * 2.0, 0.4);\n\n            body * env * amp * 0.7\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/shakuhachi.vibe"
      },
      {
        "name": "sitar",
        "description": "buzzing resonance and sympathetic string harmonics.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          },
          {
            "name": "buzz",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"sitar\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"buzz\", 0.6) // Buzz/Jivari amount\n        .body(|freq, amp, gate, buzz| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay envelope for pluck\n            let decay_env = envelope()\n                .perc(0.001, 1.5)\n                .build();\n\n            // Main string\n            let fundamental = sin_osc_ar(freq);\n\n            // Harmonics (characteristic of sitar)\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n\n            // Sympathetic strings (slightly detuned)\n            let symp1 = sin_osc_ar(freq * 2.01) * 0.1;\n            let symp2 = sin_osc_ar(freq * 3.02) * 0.08;\n\n            let strings = fundamental + h2 + h3 + h4 + h5 + symp1 + symp2;\n\n            // Buzz/Jivari effect (adds characteristic sitar buzz)\n            let buzz_osc = sin_osc_ar(freq * 0.5) * buzz * 0.1;\n            let buzzy = strings + buzz_osc;\n\n            // Resonant filtering for body\n            let body = rlpf_ar(buzzy, 2000.0, 0.3);\n\n            body * env * decay_env * amp * 0.6\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/sitar.vibe"
      },
      {
        "name": "steel_drum",
        "description": "bright, metallic tone.",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 440
          },
          {
            "name": "amp",
            "default": 0.5
          },
          {
            "name": "gate",
            "default": 1
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"steel_drum\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium decay\n            let decay_env = envelope()\n                .perc(0.001, 0.6)\n                .build();\n\n            // Metallic partials (slightly inharmonic for steel character)\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 2.95) * 0.4; // Slightly flat\n            let h4 = sin_osc_ar(freq * 4.05) * 0.25; // Slightly sharp\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n            let h6 = sin_osc_ar(freq * 6.1) * 0.1;\n\n            let metal = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Mallet attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.02)\n                .build();\n            let attack = sin_osc_ar(freq * 6.0) * attack_env * 0.2;\n\n            (metal + attack) * env * decay_env * amp * 0.5\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/steel_drum.vibe"
      },
      {
        "name": "tabla_bayan",
        "description": "Tabla Bayan (bass drum)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 80
          },
          {
            "name": "amp",
            "default": 0.7
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tabla_bayan\", |builder| {\n    builder\n        .param(\"freq\", 80.0)\n        .param(\"amp\", 0.7)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.4)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch bend envelope\n            let pitch_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let freq_mod = freq + pitch_env * freq * 0.5;\n\n            // Body tone\n            let body = sin_osc_ar(freq_mod);\n            let h2 = sin_osc_ar(freq_mod * 2.0) * 0.3;\n\n            // Membrane sound\n            let membrane = body + h2;\n\n            // Add some thump\n            let thump_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let thump = white_noise_ar() * thump_env * 0.2;\n\n            (membrane + lpf_ar(thump, 500.0)) * env * amp\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/tabla.vibe"
      },
      {
        "name": "tabla_dayan",
        "description": "Tabla Dayan (treble drum)",
        "genre": "",
        "character": "",
        "params": [
          {
            "name": "freq",
            "default": 300
          },
          {
            "name": "amp",
            "default": 0.6
          }
        ],
        "type": "synthdef",
        "source": "define_synthdef(\"tabla_dayan\", |builder| {\n    builder\n        .param(\"freq\", 300.0)\n        .param(\"amp\", 0.6)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.25)\n                .cleanup_on_finish()\n                .build();\n\n            // Characteristic tabla pitch\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.14) * 0.4; // Slightly inharmonic\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n\n            let tone = h1 + h2 + h3;\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.15;\n\n            (tone + hpf_ar(attack, 2000.0)) * env * amp\n        })\n});",
        "category": "world",
        "subcategory": "",
        "path": "world/tabla.vibe"
      },
      {
        "name": "tin_whistle",
        "description": "Irish tin whistle",
        "genre": "Celtic, Irish",
        "character": "Irish tin whistle",
        "params": [],
        "type": "synthdef",
        "source": "// Genre: Celtic, Irish | Character: Irish tin whistle\ndefine_synthdef(\"tin_whistle\")\n    .param(\"freq\", 880.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.02, 1.0, 0.05)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Light vibrato\n        let vib = sin_osc_ar(5.0) * freq * 0.008;\n\n        // Pure tone with slight harmonics\n        let body = sin_osc_ar(freq + vib) * 0.6;\n        let harm = sin_osc_ar((freq + vib) * 2.0) * 0.15;\n\n        // Breath\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.0, 0.6) * 0.15;\n\n        let sig = body + harm + breath;\n\n        sig * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/tin_whistle.vibe"
      },
      {
        "name": "ukulele",
        "description": "Small, bright, cheerful plucked string",
        "genre": "",
        "character": "Small, bright, cheerful plucked string",
        "params": [],
        "type": "synthdef",
        "source": "// Region: Hawaiian | Character: Small, bright, cheerful plucked string\ndefine_synthdef(\"ukulele\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Nylon string character - softer attack\n        let pluck_env = envelope()\n            .perc(0.002, 0.04)\n            .build();\n        let exciter = lpf_ar(pink_noise_ar(), 4000.0) * pluck_env * 0.3;\n\n        // Warm harmonics\n        let str1 = sin_osc_ar(freq) * 0.5;\n        let str2 = sin_osc_ar(freq * 2.0) * 0.25;\n        let str3 = sin_osc_ar(freq * 3.0) * 0.1;\n\n        let sig = str1 + str2 + str3 + exciter;\n\n        // Small body resonance - warm and bright\n        let body = bpf_ar(sig, 500.0, 0.2) * 0.3;\n        let output = sig + body;\n\n        output * env * amp\n    });\n",
        "category": "world",
        "subcategory": "",
        "path": "world/ukulele.vibe"
      }
    ]
  }
};

export const stdlibAllItems = [
  {
    "name": "acid_303_classic",
    "description": "Genre: Acid House, Techno | Character: Classic 303 with resonant filter sweep",
    "genre": "Acid House, Techno",
    "character": "Classic 303 with resonant filter sweep",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "cutoff",
        "default": 1200
      },
      {
        "name": "res",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acid_303_classic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 1200.0)\n        .param(\"res\", 0.7)\n        .body(|freq, amp, gate, cutoff, res| {\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope for sweep (triggered on note-on)\n            let filter_env = envelope()\n                .perc(0.01, 0.4)\n                .build();\n\n            // Sawtooth oscillator\n            let osc = saw_ar(freq);\n\n            // Resonant filter with envelope modulation\n            let mod_cutoff = cutoff + (filter_env * cutoff * 4.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, res);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "acid",
    "path": "bass/acid/acid_303_classic.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acid"
  },
  {
    "name": "acid_aggressive",
    "description": "Genre: Hard Acid, Industrial | Character: Aggressive, fast sweep",
    "genre": "Hard Acid, Industrial",
    "character": "Aggressive, fast sweep",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acid_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Sharp envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast, aggressive filter sweep\n            let filter_env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Wide, fast sweep with high resonance\n            let mod_cutoff = 300.0 + (filter_env * 4000.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.1);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "acid",
    "path": "bass/acid/acid_aggressive.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acid"
  },
  {
    "name": "acid_bubbly",
    "description": "Genre: Acid House | Character: Bubbly, playful resonance",
    "genre": "Acid House",
    "character": "Bubbly, playful resonance",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acid_bubbly\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Bouncy envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Quick filter sweep for bubbles\n            let filter_env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Pulse wave for different timbre\n            let osc = saw_ar(freq);\n\n            // High, narrow filter sweep\n            let mod_cutoff = 1200.0 + (filter_env * 3000.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "acid",
    "path": "bass/acid/acid_bubbly.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acid"
  },
  {
    "name": "acid_detuned",
    "description": "Genre: Acid House, Techno | Character: Detuned oscillators for thickness",
    "genre": "Acid House, Techno",
    "character": "Detuned oscillators for thickness",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acid_detuned\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Detuned sawtooths\n            let osc1 = saw_ar(freq * 0.997);\n            let osc2 = saw_ar(freq * 1.003);\n            let mix = (osc1 + osc2) * 0.5;\n\n            // Filter sweep\n            let mod_cutoff = 900.0 + (filter_env * 2500.0);\n            let filtered = rlpf_ar(mix, mod_cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "acid",
    "path": "bass/acid/acid_detuned.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acid"
  },
  {
    "name": "acid_distorted",
    "description": "Genre: Industrial, Hard Techno | Character: Distorted, aggressive acid",
    "genre": "Industrial, Hard Techno",
    "character": "Distorted, aggressive acid",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acid_distorted\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Sawtooth with extra gain\n            let osc = saw_ar(freq) * 2.5;\n\n            // Clip for distortion\n            let distorted = clip(osc, -0.9, 0.9);\n\n            // Resonant filter\n            let mod_cutoff = 600.0 + (filter_env * 2000.0);\n            let filtered = rlpf_ar(distorted, mod_cutoff, 0.2);\n\n            filtered * env * amp * 0.5\n        })\n});",
    "category": "bass",
    "subcategory": "acid",
    "path": "bass/acid/acid_distorted.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acid"
  },
  {
    "name": "acid_filtered_square",
    "description": "Genre: Acid Techno | Character: Square wave with resonant filter",
    "genre": "Acid Techno",
    "character": "Square wave with resonant filter",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acid_filtered_square\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.006, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.012, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Square wave (pulse with 0.5 width)\n            let osc = saw_ar(freq);\n\n            // Filter sweep\n            let mod_cutoff = 600.0 + (filter_env * 2000.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "acid",
    "path": "bass/acid/acid_filtered_square.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acid"
  },
  {
    "name": "acid_minimal",
    "description": "Genre: Minimal Techno | Character: Subtle, minimal filter movement",
    "genre": "Minimal Techno",
    "character": "Subtle, minimal filter movement",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acid_minimal\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Clean envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Gentle filter envelope\n            let filter_env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Subtle filter movement\n            let mod_cutoff = 800.0 + (filter_env * 1200.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.5);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "acid",
    "path": "bass/acid/acid_minimal.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acid"
  },
  {
    "name": "acid_modulated",
    "description": "Genre: Techno, Experimental | Character: Frequency modulated acid",
    "genre": "Techno, Experimental",
    "character": "Frequency modulated acid",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acid_modulated\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Pitch modulation envelope\n            let pitch_env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let pitch_mod = pitch_env * freq * 0.5;\n\n            // Modulated sawtooth\n            let osc = saw_ar(freq + pitch_mod);\n\n            // Filter sweep\n            let mod_cutoff = 700.0 + (filter_env * 2200.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "acid",
    "path": "bass/acid/acid_modulated.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acid"
  },
  {
    "name": "acid_resonant_sweep",
    "description": "Genre: Acid Techno | Character: Extreme resonance sweep",
    "genre": "Acid Techno",
    "character": "Extreme resonance sweep",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acid_resonant_sweep\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.004, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope with extended range\n            let filter_env = envelope()\n                .asr(0.006, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Extreme resonance sweep\n            let mod_cutoff = 250.0 + (filter_env * 5000.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.08);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "acid",
    "path": "bass/acid/acid_resonant_sweep.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acid"
  },
  {
    "name": "acid_squelchy",
    "description": "Genre: Acid Techno | Character: Squelchy, high resonance",
    "genre": "Acid Techno",
    "character": "Squelchy, high resonance",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acid_squelchy\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sharp filter envelope\n            let filter_env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // High resonance for squelch\n            let mod_cutoff = 400.0 + (filter_env * 2500.0);\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.15);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "acid",
    "path": "bass/acid/acid_squelchy.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acid"
  },
  {
    "name": "bass_fingered",
    "description": "Fingerstyle electric bass",
    "genre": "Rock, Pop, R&B",
    "character": "Fingerstyle electric bass",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Rock, Pop, R&B | Character: Fingerstyle electric bass\ndefine_synthdef(\"bass_fingered\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Natural envelope\n        let env = envelope()\n            .asr(0.008, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Warm body\n        let body = sin_osc_ar(freq) * 0.5;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.22;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.1;\n\n        // Finger attack\n        let finger = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 1800.0, 0.5) * finger * 0.18;\n\n        let sig = body + harm1 + harm2 + attack;\n        lpf_ar(sig, 3500.0) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "acoustic",
    "path": "bass/acoustic/bass_fingered.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acoustic"
  },
  {
    "name": "bass_fretless",
    "description": "Fretless electric bass with smooth slides",
    "genre": "Jazz, Fusion, R&B",
    "character": "Fretless electric bass with smooth slides",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Jazz, Fusion, R&B | Character: Fretless electric bass with smooth slides\ndefine_synthdef(\"bass_fretless\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Smooth envelope\n        let env = envelope()\n            .asr(0.02, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Subtle vibrato\n        let vib = sin_osc_ar(5.0) * freq * 0.008;\n\n        // Warm, mwah-y tone\n        let body = sin_osc_ar(freq + vib) * 0.45;\n        let harm1 = sin_osc_ar((freq + vib) * 2.0) * 0.28;\n        let harm2 = sin_osc_ar((freq + vib) * 3.0) * 0.15;\n        let harm3 = sin_osc_ar((freq + vib) * 4.0) * 0.08;\n\n        // Mwah characteristic (filter sweep on attack)\n        let mwah = envelope()\n            .perc(0.01, 0.2)\n            .build();\n        let cutoff = 800.0 + mwah * 2000.0;\n\n        let sig = body + harm1 + harm2 + harm3;\n        lpf_ar(sig, cutoff) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "acoustic",
    "path": "bass/acoustic/bass_fretless.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acoustic"
  },
  {
    "name": "bass_muted",
    "description": "Palm-muted bass with short, controlled notes",
    "genre": "Funk, R&B, Pop",
    "character": "Palm-muted bass with short, controlled notes",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Funk, R&B, Pop | Character: Palm-muted bass with short, controlled notes\ndefine_synthdef(\"bass_muted\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.75)\n    .body(|freq, amp| {\n        // Very short decay\n        let amp_env = envelope()\n            .perc(0.002, 0.12)\n            .cleanup_on_finish()\n            .build();\n\n        // Muted, darker tone\n        let body = sin_osc_ar(freq) * 0.6;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.15;\n\n        // Soft attack\n        let attack_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 1500.0) * attack_env * 0.15;\n\n        let sig = body + harm1 + attack;\n        lpf_ar(sig, 1500.0) * amp_env * amp\n    });\n",
    "category": "bass",
    "subcategory": "acoustic",
    "path": "bass/acoustic/bass_muted.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acoustic"
  },
  {
    "name": "bass_picked",
    "description": "Picked electric bass with bright attack",
    "genre": "Rock, Punk, Metal",
    "character": "Picked electric bass with bright attack",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Rock, Punk, Metal | Character: Picked electric bass with bright attack\ndefine_synthdef(\"bass_picked\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.85)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Envelope with quick attack\n        let env = envelope()\n            .asr(0.003, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Brighter harmonic content\n        let body = sin_osc_ar(freq) * 0.4;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.28;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.18;\n        let harm3 = sin_osc_ar(freq * 4.0) * 0.08;\n\n        // Pick attack - bright and defined\n        let pick = envelope()\n            .perc(0.0001, 0.015)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 3000.0) * pick * 0.25;\n\n        let sig = body + harm1 + harm2 + harm3 + attack;\n        lpf_ar(sig, 5000.0) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "acoustic",
    "path": "bass/acoustic/bass_picked.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acoustic"
  },
  {
    "name": "bass_slap",
    "description": "Slap bass with percussive attack",
    "genre": "Funk, Disco, R&B",
    "character": "Slap bass with percussive attack",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Funk, Disco, R&B | Character: Slap bass with percussive attack\ndefine_synthdef(\"bass_slap\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Punchy envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Body with harmonics\n        let body = sin_osc_ar(freq) * 0.4;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.25;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.15;\n        let harm3 = sin_osc_ar(freq * 4.0) * 0.1;\n\n        // Slap transient - very prominent\n        let slap_env = envelope()\n            .perc(0.0001, 0.02)\n            .build();\n        let slap = bpf_ar(white_noise_ar(), 2500.0, 0.3) * slap_env * 0.5;\n\n        // String pop\n        let pop_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let pop = hpf_ar(white_noise_ar(), 4000.0) * pop_env * 0.3;\n\n        let sig = body + harm1 + harm2 + harm3 + slap + pop;\n        sig * amp_env * amp\n    });\n",
    "category": "bass",
    "subcategory": "acoustic",
    "path": "bass/acoustic/bass_slap.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acoustic"
  },
  {
    "name": "bass_upright",
    "description": "Double bass/upright bass plucked",
    "genre": "Jazz, Classical, Acoustic",
    "character": "Double bass/upright bass plucked",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Jazz, Classical, Acoustic | Character: Double bass/upright bass plucked\ndefine_synthdef(\"bass_upright\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Gate-controlled ASR envelope\n        let env = envelope()\n            .asr(0.01, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Main body with warm harmonics\n        let body = sin_osc_ar(freq) * 0.5;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.25;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.12;\n        let harm3 = sin_osc_ar(freq * 4.0) * 0.06;\n\n        // Pluck attack\n        let pluck = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 1500.0, 0.4) * pluck * 0.2;\n\n        // String buzz\n        let buzz = bpf_ar(pink_noise_ar(), freq * 5.0, 0.8) * 0.05;\n\n        let sig = body + harm1 + harm2 + harm3 + attack + buzz;\n        lpf_ar(sig, 3000.0) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "acoustic",
    "path": "bass/acoustic/bass_upright.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acoustic"
  },
  {
    "name": "bass_upright_arco",
    "description": "Bowed upright bass",
    "genre": "Classical, Orchestral",
    "character": "Bowed upright bass",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Classical, Orchestral | Character: Bowed upright bass\ndefine_synthdef(\"bass_upright_arco\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.7)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Slow attack for bowing\n        let env = envelope()\n            .asr(0.15, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bow pressure modulation\n        let bow_lfo = sin_osc_ar(4.5) * 0.02 + 1.0;\n\n        // Rich harmonic content from bowing\n        let body = sin_osc_ar(freq * bow_lfo) * 0.4;\n        let harm1 = sin_osc_ar(freq * 2.0 * bow_lfo) * 0.25;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.15;\n        let harm3 = sin_osc_ar(freq * 4.0) * 0.08;\n        let harm4 = sin_osc_ar(freq * 5.0) * 0.04;\n\n        // Bow noise\n        let bow_noise = bpf_ar(pink_noise_ar(), 2000.0, 0.5) * 0.08;\n\n        let sig = body + harm1 + harm2 + harm3 + harm4 + bow_noise;\n        lpf_ar(sig, 4000.0) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "acoustic",
    "path": "bass/acoustic/bass_upright_arco.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acoustic"
  },
  {
    "name": "bass_upright_pizz",
    "description": "Pizzicato upright bass",
    "genre": "Jazz, Classical",
    "character": "Pizzicato upright bass",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Jazz, Classical | Character: Pizzicato upright bass\ndefine_synthdef(\"bass_upright_pizz\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Pizzicato envelope - short decay\n        let amp_env = envelope()\n            .perc(0.005, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Warm body\n        let body = sin_osc_ar(freq) * 0.55;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.22;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.1;\n\n        // Finger pluck attack\n        let pluck_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let pluck = bpf_ar(white_noise_ar(), 1200.0, 0.5) * pluck_env * 0.25;\n\n        let sig = body + harm1 + harm2 + pluck;\n        lpf_ar(sig, 2500.0) * amp_env * amp\n    });\n",
    "category": "bass",
    "subcategory": "acoustic",
    "path": "bass/acoustic/bass_upright_pizz.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Acoustic"
  },
  {
    "name": "fm_bass_aggressive",
    "description": "Genre: Neurofunk, Techno | Character: Aggressive FM bass with high modulation",
    "genre": "Neurofunk, Techno",
    "character": "Aggressive FM bass with high modulation",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "fm_amount",
        "default": 5
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"fm_bass_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"fm_amount\", 5.0)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .body(|freq, fm_amount, amp, gate| {\n\n            // Punchy envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Aggressive FM envelope\n            let fm_env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // High FM amount for aggression\n            let modulator = sin_osc_ar(freq * 2.0) * fm_env * freq * fm_amount;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Clip for extra aggression\n            let driven = clip(carrier, -0.9, 0.9);\n\n            driven * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "fm",
    "path": "bass/fm/fm_bass_aggressive.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Fm"
  },
  {
    "name": "fm_bass_classic",
    "description": "Genre: Electro, Synthwave | Character: Classic FM bass with complex harmonics",
    "genre": "Electro, Synthwave",
    "character": "Classic FM bass with complex harmonics",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "fm_amount",
        "default": 2.5
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"fm_bass_classic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"fm_amount\", 2.5)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, fm_amount, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM envelope\n            let fm_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // FM modulator\n            let modulator = sin_osc_ar(freq * 1.5) * fm_env * freq * fm_amount;\n\n            // Carrier\n            let carrier = sin_osc_ar(freq + modulator);\n\n            carrier * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "fm",
    "path": "bass/fm/fm_bass_classic.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Fm"
  },
  {
    "name": "fm_bass_deep",
    "description": "Genre: Dubstep, Bass Music | Character: Deep FM bass with sub presence",
    "genre": "Dubstep, Bass Music",
    "character": "Deep FM bass with sub presence",
    "params": [
      {
        "name": "freq",
        "default": 75
      },
      {
        "name": "fm_amount",
        "default": 3
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"fm_bass_deep\", |builder| {\n    builder\n        .param(\"freq\", 75.0)\n        .param(\"fm_amount\", 3.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, fm_amount, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM envelope\n            let fm_env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // FM with sub ratio\n            let modulator = sin_osc_ar(freq * 0.5) * fm_env * freq * fm_amount;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Add clean sub\n            let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n            (carrier + sub) * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "fm",
    "path": "bass/fm/fm_bass_deep.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Fm"
  },
  {
    "name": "fm_bass_evolving",
    "description": "Genre: Techno, Experimental | Character: Evolving FM bass with changing timbre",
    "genre": "Techno, Experimental",
    "character": "Evolving FM bass with changing timbre",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "fm_amount",
        "default": 3.5
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"fm_bass_evolving\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"fm_amount\", 3.5)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, fm_amount, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.012, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Long FM envelope for evolution\n            let fm_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // FM synthesis\n            let modulator = sin_osc_ar(freq * 1.7) * fm_env * freq * fm_amount;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Filter envelope for additional movement\n            let filter_env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 400.0 + (filter_env * 1800.0);\n\n            let filtered = lpf_ar(carrier, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "fm",
    "path": "bass/fm/fm_bass_evolving.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Fm"
  },
  {
    "name": "fm_bass_metallic",
    "description": "Genre: IDM, Experimental | Character: Metallic, inharmonic FM bass",
    "genre": "IDM, Experimental",
    "character": "Metallic, inharmonic FM bass",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "fm_amount",
        "default": 4
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"fm_bass_metallic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"fm_amount\", 4.0)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .body(|freq, fm_amount, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM envelope\n            let fm_env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .build();\n\n            // Inharmonic ratio for metallic character\n            let modulator = sin_osc_ar(freq * 2.3) * fm_env * freq * fm_amount;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            carrier * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "fm",
    "path": "bass/fm/fm_bass_metallic.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Fm"
  },
  {
    "name": "bass_afrobeat",
    "description": "Groovy afrobeat bass - warm and rhythmic",
    "genre": "Afrobeat, Afrobeats",
    "character": "Groovy afrobeat bass - warm and rhythmic",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Afrobeat, Afrobeats | Character: Groovy afrobeat bass - warm and rhythmic\ndefine_synthdef(\"bass_afrobeat\")\n    .param(\"freq\", 65.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Warm, organic tone\n        let body = sin_osc_ar(freq) * 0.5;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.2;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.08;\n\n        // Subtle attack\n        let attack = envelope()\n            .perc(0.005, 0.03)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 1500.0, 0.5) * attack * 0.12;\n\n        let sig = body + harm1 + harm2 + click;\n\n        lpf_ar(sig, 2500.0) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_afrobeat.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_disco",
    "description": "Octave-jumping disco bass",
    "genre": "Disco, Nu-Disco",
    "character": "Octave-jumping disco bass",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Disco, Nu-Disco | Character: Octave-jumping disco bass\ndefine_synthdef(\"bass_disco\")\n    .param(\"freq\", 70.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.003, 1.0, 0.06)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Body with octave\n        let body = sin_osc_ar(freq) * 0.5;\n        let octave = sin_osc_ar(freq * 2.0) * 0.3;\n        let harm = sin_osc_ar(freq * 3.0) * 0.1;\n\n        // Quick attack\n        let attack = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let click = hpf_ar(white_noise_ar(), 3000.0) * attack * 0.15;\n\n        let sig = body + octave + harm + click;\n\n        lpf_ar(sig, 4000.0) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_disco.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_drill",
    "description": "Sliding drill bass with pitch glide",
    "genre": "Drill, UK Drill",
    "character": "Sliding drill bass with pitch glide",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Drill, UK Drill | Character: Sliding drill bass with pitch glide\ndefine_synthdef(\"bass_drill\")\n    .param(\"freq\", 45.0)\n    .param(\"amp\", 0.9)\n    .param(\"gate\", 1.0)\n    .param(\"slide\", 0.3)\n    .body(|freq, amp, gate, slide| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch glide characteristic of drill\n        let glide = envelope()\n            .perc(0.01, 0.3)\n            .build();\n        let pitch = freq * (1.0 + glide * slide);\n\n        // Deep sine bass\n        let body = sin_osc_ar(pitch) * 0.7;\n        let sub = sin_osc_ar(pitch * 0.5) * 0.25;\n\n        let sig = body + sub;\n\n        lpf_ar(sig, 500.0) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_drill.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_formant",
    "description": "Vowel/formant bass with vocal quality",
    "genre": "Experimental, EDM",
    "character": "Vowel/formant bass with vocal quality",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Experimental, EDM | Character: Vowel/formant bass with vocal quality\ndefine_synthdef(\"bass_formant\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.75)\n    .param(\"gate\", 1.0)\n    .param(\"vowel\", 0.5)\n    .body(|freq, amp, gate, vowel| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Rich harmonic source\n        let osc = saw_ar(freq) * 0.5;\n\n        // Formant frequencies (morphing between vowels)\n        let f1 = 300.0 + vowel * 500.0;  // First formant\n        let f2 = 900.0 + vowel * 1200.0; // Second formant\n\n        // Resonant bandpass filters for formants\n        let form1 = bpf_ar(osc, f1, 0.15) * 0.5;\n        let form2 = bpf_ar(osc, f2, 0.2) * 0.3;\n\n        // Sub foundation\n        let sub = sin_osc_ar(freq) * 0.4;\n\n        let sig = form1 + form2 + sub;\n\n        sig * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_formant.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_funk",
    "description": "Funky bass with bright attack and groove",
    "genre": "Funk, Disco",
    "character": "Funky bass with bright attack and groove",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Funk, Disco | Character: Funky bass with bright attack and groove\ndefine_synthdef(\"bass_funk\")\n    .param(\"freq\", 70.0)\n    .param(\"amp\", 0.85)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope for funky attack\n        let filt_env = envelope()\n            .perc(0.005, 0.15)\n            .build();\n\n        // Punchy body with harmonics\n        let body = sin_osc_ar(freq) * 0.45;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.25;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.12;\n\n        // Attack pop\n        let pop = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 2000.0, 0.4) * pop * 0.2;\n\n        let sig = body + harm1 + harm2 + attack;\n\n        // Dynamic filter\n        let cutoff = 1000.0 + filt_env * 2500.0;\n        lpf_ar(sig, cutoff) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_funk.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_garage",
    "description": "UK garage bass - bouncy and warm",
    "genre": "UK Garage, 2-Step",
    "character": "UK garage bass - bouncy and warm",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: UK Garage, 2-Step | Character: UK garage bass - bouncy and warm\ndefine_synthdef(\"bass_garage\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.008, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.008, 0.2)\n            .build();\n\n        // Warm sine with harmonics\n        let body = sin_osc_ar(freq) * 0.5;\n        let sub = sin_osc_ar(freq * 0.5) * 0.25;\n        let harm = sin_osc_ar(freq * 2.0) * 0.15;\n\n        let mix = body + sub + harm;\n\n        // Bouncy filter\n        let cutoff = 600.0 + filt_env * 1500.0;\n        lpf_ar(mix, cutoff) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_garage.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_house",
    "description": "Deep house bass - warm and rolling",
    "genre": "House, Deep House",
    "character": "Deep house bass - warm and rolling",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: House, Deep House | Character: Deep house bass - warm and rolling\ndefine_synthdef(\"bass_house\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.85)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.01, 0.25)\n            .build();\n\n        // Warm saw with sub\n        let osc = saw_ar(freq) * 0.4;\n        let sub = sin_osc_ar(freq * 0.5) * 0.35;\n\n        let mix = osc + sub;\n\n        // Warm, rolling filter\n        let cutoff = 500.0 + filt_env * 1200.0;\n        rlpf_ar(mix, cutoff, 0.2) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_house.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_karplus",
    "description": "Karplus-Strong plucked bass",
    "genre": "Experimental, IDM",
    "character": "Karplus-Strong plucked bass",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Experimental, IDM | Character: Karplus-Strong plucked bass\ndefine_synthdef(\"bass_karplus\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .param(\"decay\", 0.5)\n    .body(|freq, amp, decay| {\n        // Karplus-Strong style using comb filter\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay * 2.0)\n            .cleanup_on_finish()\n            .build();\n\n        // Excitation noise burst\n        let excite = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let noise = white_noise_ar() * excite;\n\n        // Delay time for pitch\n        let delay_time = 1.0 / freq;\n\n        // Comb filter with feedback for string-like resonance\n        let resonated = comb_c_ar(noise, 0.05, delay_time, decay * 3.0);\n\n        // Low pass for warmth\n        lpf_ar(resonated, 2000.0) * amp_env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_karplus.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_phonk",
    "description": "Distorted phonk bass - gritty and heavy",
    "genre": "Phonk, Memphis Rap",
    "character": "Distorted phonk bass - gritty and heavy",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Phonk, Memphis Rap | Character: Distorted phonk bass - gritty and heavy\ndefine_synthdef(\"bass_phonk\")\n    .param(\"freq\", 45.0)\n    .param(\"amp\", 0.9)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Heavy, distorted bass\n        let body = sin_osc_ar(freq) * 0.6;\n        let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n        // Add grit\n        let gritty = (body * 2.0).tanh();\n\n        let sig = (gritty + sub) * 0.6;\n\n        lpf_ar(sig, 600.0) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_phonk.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_reggae",
    "description": "Deep reggae bass with round tone",
    "genre": "Reggae, Dub",
    "character": "Deep reggae bass with round tone",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Reggae, Dub | Character: Deep reggae bass with round tone\ndefine_synthdef(\"bass_reggae\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.85)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.02, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Deep, round tone\n        let body = sin_osc_ar(freq) * 0.6;\n        let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n        // Slight warmth from second harmonic\n        let warm = sin_osc_ar(freq * 2.0) * 0.08;\n\n        let sig = body + sub + warm;\n\n        // Very warm filtering\n        lpf_ar(sig, 800.0) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_reggae.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_talking",
    "description": "Talk box-style bass with vocal modulation",
    "genre": "Funk, Experimental",
    "character": "Talk box-style bass with vocal modulation",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Funk, Experimental | Character: Talk box-style bass with vocal modulation\ndefine_synthdef(\"bass_talking\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.75)\n    .param(\"gate\", 1.0)\n    .param(\"talk\", 0.5)\n    .body(|freq, amp, gate, talk| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // LFO for \"talking\" modulation\n        let talk_lfo = sin_osc_ar(3.0 + talk * 4.0);\n\n        // Rich source\n        let osc = saw_ar(freq) * 0.5;\n\n        // Modulated formants\n        let f1 = 400.0 + talk_lfo * 300.0;\n        let f2 = 1200.0 + talk_lfo * 600.0;\n\n        let form1 = bpf_ar(osc, f1, 0.12) * 0.5;\n        let form2 = bpf_ar(osc, f2, 0.15) * 0.3;\n\n        // Sub\n        let sub = sin_osc_ar(freq) * 0.35;\n\n        let sig = form1 + form2 + sub;\n\n        sig * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_talking.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_techno",
    "description": "Driving techno bass - punchy and relentless",
    "genre": "Techno, Industrial",
    "character": "Driving techno bass - punchy and relentless",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Techno, Industrial | Character: Driving techno bass - punchy and relentless\ndefine_synthdef(\"bass_techno\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 0.9)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.002, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.002, 0.15)\n            .build();\n\n        // Aggressive saw\n        let osc = saw_ar(freq) * 0.5;\n        let sub = sin_osc_ar(freq) * 0.4;\n\n        let mix = osc + sub;\n\n        // Punchy filter\n        let cutoff = 300.0 + filt_env * 2000.0;\n        rlpf_ar(mix, cutoff, 0.35) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "genre",
    "path": "bass/genre/bass_techno.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Genre"
  },
  {
    "name": "bass_pluck_bell",
    "description": "Genre: Ambient, Experimental | Character: Bell-like pluck bass",
    "genre": "Ambient, Experimental",
    "character": "Bell-like pluck bass",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bass_pluck_bell\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Medium-long envelope for bell character\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Inharmonic frequencies for bell timbre\n            let osc1 = sin_osc_ar(freq) * 0.5;\n            let osc2 = sin_osc_ar(freq * 2.3) * 0.25;\n            let osc3 = sin_osc_ar(freq * 3.7) * 0.15;\n            let osc4 = sin_osc_ar(freq * 5.1) * 0.1;\n\n            let mix = osc1 + osc2 + osc3 + osc4;\n\n            // Gentle filter\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "pluck",
    "path": "bass/pluck/pluck_bell.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Pluck"
  },
  {
    "name": "bass_pluck_bright",
    "description": "Genre: House, Funk | Character: Bright, cutting pluck",
    "genre": "House, Funk",
    "character": "Bright, cutting pluck",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bass_pluck_bright\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Quick envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth with harmonics\n            let osc = saw_ar(freq);\n\n            // Wide filter sweep for brightness\n            let filter_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 3500.0);\n\n            let filtered = lpf_ar(osc, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "pluck",
    "path": "bass/pluck/pluck_bright.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Pluck"
  },
  {
    "name": "pluck_dark",
    "description": "Genre: Techno, Minimal | Character: Dark, muted pluck",
    "genre": "Techno, Minimal",
    "character": "Dark, muted pluck",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pluck_dark\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Medium envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sine for darker character\n            let osc = sin_osc_ar(freq);\n            let harmonic = sin_osc_ar(freq * 2.0) * 0.2;\n            let mix = osc + harmonic;\n\n            // Low filter for darkness\n            let filter_env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 300.0 + (filter_env * 800.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "pluck",
    "path": "bass/pluck/pluck_dark.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Pluck"
  },
  {
    "name": "pluck_elastic",
    "description": "Genre: Electro, Experimental | Character: Elastic, bouncy pluck",
    "genre": "Electro, Experimental",
    "character": "Elastic, bouncy pluck",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pluck_elastic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Bouncy envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope for elastic character\n            let pitch_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let pitch_mod = pitch_env * freq * 0.8;\n\n            // Sawtooth with pitch bend\n            let osc = saw_ar(freq + pitch_mod);\n\n            // Filter sweep\n            let filter_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 700.0 + (filter_env * 1800.0);\n\n            let filtered = lpf_ar(osc, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "pluck",
    "path": "bass/pluck/pluck_elastic.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Pluck"
  },
  {
    "name": "pluck_funky",
    "description": "Genre: Funk, Disco | Character: Funky, percussive pluck",
    "genre": "Funk, Disco",
    "character": "Funky, percussive pluck",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.75
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pluck_funky\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.75)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Use gate parameter to control note duration\n            let env = envelope()\n                .adsr(0.001, 0.05, 0.7, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth wave for funk character (pulse_ar not available)\n            let osc = saw_ar(freq);\n\n            // Snappy filter sweep\n            let filter_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 2000.0);\n\n            let filtered = lpf_ar(osc, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "pluck",
    "path": "bass/pluck/pluck_funky.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Pluck"
  },
  {
    "name": "bass_pluck_long",
    "description": "Genre: Dubstep, Bass Music | Character: Longer pluck with sustain",
    "genre": "Dubstep, Bass Music",
    "character": "Longer pluck with sustain",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bass_pluck_long\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Medium decay\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Saw and pulse mix\n            let saw = saw_ar(freq) * 0.6;\n            let pulse = saw_ar(freq) * 0.4;\n            let mix = saw + pulse;\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 600.0 + (filter_env * 1800.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "pluck",
    "path": "bass/pluck/pluck_long.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Pluck"
  },
  {
    "name": "bass_pluck_muted",
    "description": "Genre: Lo-fi, Jazz | Character: Muted, soft pluck",
    "genre": "Lo-fi, Jazz",
    "character": "Muted, soft pluck",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bass_pluck_muted\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Soft envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sine and triangle mix\n            let sine = sin_osc_ar(freq) * 0.7;\n            let triangle = (sin_osc_ar(freq) + sin_osc_ar(freq * 3.0) * 0.111) * 0.3;\n            let mix = sine + triangle;\n\n            // Very low filter\n            let filtered = lpf_ar(mix, 500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "pluck",
    "path": "bass/pluck/pluck_muted.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Pluck"
  },
  {
    "name": "pluck_percussive",
    "description": "Genre: Techno, Electro | Character: Very percussive, attack-heavy",
    "genre": "Techno, Electro",
    "character": "Very percussive, attack-heavy",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pluck_percussive\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very short, percussive envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.0005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Very fast filter attack\n            let filter_env = envelope()\n                .asr(0.0005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1200.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(osc, mod_cutoff);\n\n            // Add click for percussive attack\n            let click_env = envelope()\n                .asr(0.0001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let click = white_noise_ar() * click_env * 0.15;\n            let filtered_click = lpf_ar(click, 2000.0);\n\n            (filtered + filtered_click) * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "pluck",
    "path": "bass/pluck/pluck_percussive.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Pluck"
  },
  {
    "name": "bass_pluck_resonant",
    "description": "Genre: Techno, House | Character: Resonant pluck with filter ring",
    "genre": "Techno, House",
    "character": "Resonant pluck with filter ring",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bass_pluck_resonant\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Medium envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Resonant filter with sweep\n            let filter_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 2000.0);\n\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.2);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "pluck",
    "path": "bass/pluck/pluck_resonant.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Pluck"
  },
  {
    "name": "bass_pluck_short",
    "description": "Genre: House, Techno | Character: Short, tight pluck bass",
    "genre": "House, Techno",
    "character": "Short, tight pluck bass",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bass_pluck_short\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very short envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth for brightness\n            let osc = saw_ar(freq);\n\n            // Quick filter envelope\n            let filter_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 2000.0);\n\n            let filtered = lpf_ar(osc, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "pluck",
    "path": "bass/pluck/pluck_short.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Pluck"
  },
  {
    "name": "reese_aggressive",
    "description": "Genre: Neurofunk, Techstep | Character: Aggressive, gritty Reese",
    "genre": "Neurofunk, Techstep",
    "character": "Aggressive, gritty Reese",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"reese_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Punchy envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Wide detuning for aggression\n            let saw1 = saw_ar(freq * 0.975);\n            let saw2 = saw_ar(freq * 0.988);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.012);\n            let saw5 = saw_ar(freq * 1.025);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.25;\n\n            // Clip for distortion\n            let driven = clip(mix, -0.85, 0.85);\n\n            // Aggressive filter\n            let filter_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 2000.0);\n\n            let filtered = rlpf_ar(driven, mod_cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "reese",
    "path": "bass/reese/reese_aggressive.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Reese"
  },
  {
    "name": "reese_classic",
    "description": "Genre: Drum & Bass, Jungle | Character: Classic Reese bass, thick and evolving",
    "genre": "Drum & Bass, Jungle",
    "character": "Classic Reese bass, thick and evolving",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"reese_classic\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned sawtooths for Reese character\n            let saw1 = saw_ar(freq * 0.985);\n            let saw2 = saw_ar(freq * 0.992);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.008);\n            let saw5 = saw_ar(freq * 1.015);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.2;\n\n            // Filter envelope for movement\n            let filter_env = envelope()\n                .perc(0.02, 0.8)\n                .build();\n            let mod_cutoff = 400.0 + (filter_env * 1200.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "reese",
    "path": "bass/reese/reese_classic.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Reese"
  },
  {
    "name": "reese_deep",
    "description": "Genre: Drum & Bass, Dubstep | Character: Deep, sub-heavy Reese",
    "genre": "Drum & Bass, Dubstep",
    "character": "Deep, sub-heavy Reese",
    "params": [
      {
        "name": "freq",
        "default": 45
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"reese_deep\", |builder| {\n    builder\n        .param(\"freq\", 45.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws\n            let saw1 = saw_ar(freq * 0.980);\n            let saw2 = saw_ar(freq * 0.990);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.010);\n            let saw5 = saw_ar(freq * 1.020);\n\n            // Add sub octave for depth\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.16 + sub;\n\n            // Dark filtering\n            let filter_env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 300.0 + (filter_env * 900.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "reese",
    "path": "bass/reese/reese_deep.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Reese"
  },
  {
    "name": "reese_distorted",
    "description": "Genre: Neurofunk, Darkstep | Character: Heavily distorted Reese",
    "genre": "Neurofunk, Darkstep",
    "character": "Heavily distorted Reese",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"reese_distorted\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Aggressive envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws\n            let saw1 = saw_ar(freq * 0.983);\n            let saw2 = saw_ar(freq * 0.993);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.007);\n            let saw5 = saw_ar(freq * 1.017);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.3;\n\n            // Heavy distortion\n            let driven = clip(mix, -0.7, 0.7);\n\n            // Filter with movement\n            let filter_env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 450.0 + (filter_env * 1700.0);\n\n            let filtered = rlpf_ar(driven, mod_cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "reese",
    "path": "bass/reese/reese_distorted.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Reese"
  },
  {
    "name": "reese_evolving",
    "description": "Genre: Drum & Bass | Character: Evolving Reese with phase movement",
    "genre": "Drum & Bass",
    "character": "Evolving Reese with phase movement",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"reese_evolving\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Long envelope for evolution\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Wide detuning for movement\n            let saw1 = saw_ar(freq * 0.982);\n            let saw2 = saw_ar(freq * 0.991);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.009);\n            let saw5 = saw_ar(freq * 1.018);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.2;\n\n            // Evolving filter with resonance\n            let filter_env = envelope()\n                .asr(0.04, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 350.0 + (filter_env * 1800.0);\n\n            let filtered = rlpf_ar(mix, mod_cutoff, 0.5);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "reese",
    "path": "bass/reese/reese_evolving.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Reese"
  },
  {
    "name": "reese_smooth",
    "description": "Genre: Liquid DnB, Ambient DnB | Character: Smooth, rolling Reese",
    "genre": "Liquid DnB, Ambient DnB",
    "character": "Smooth, rolling Reese",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"reese_smooth\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Smooth envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Subtle detuning for smoothness\n            let saw1 = saw_ar(freq * 0.992);\n            let saw2 = saw_ar(freq * 0.996);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.004);\n            let saw5 = saw_ar(freq * 1.008);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.2;\n\n            // Gentle filter sweep\n            let filter_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 1500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "reese",
    "path": "bass/reese/reese_smooth.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Reese"
  },
  {
    "name": "sub_deep",
    "description": "Very deep, chest-hitting sub",
    "genre": "Dubstep, Bass Music",
    "character": "Very deep, chest-hitting sub",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Dubstep, Bass Music | Character: Very deep, chest-hitting sub\ndefine_synthdef(\"sub_deep\")\n    .param(\"freq\", 45.0)\n    .param(\"amp\", 0.9)\n        .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n\n        // Long envelope for sustained sub\n        // Gate-controlled ASR envelope for proper note-on/note-off behavior\n        let env = envelope()\n            .asr(0.015, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Main sub frequency\n        let sig = sin_osc_ar(freq);\n\n        // Sub-octave for extreme depth\n        let deep = sin_osc_ar(freq * 0.5) * 0.4;\n\n        (sig + deep) * env * amp\n    });\n\n",
    "category": "bass",
    "subcategory": "sub",
    "path": "bass/sub/sub_deep.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Sub"
  },
  {
    "name": "sub_filtered",
    "description": "Genre: House, Techno | Character: Filtered sine with slight movement",
    "genre": "House, Techno",
    "character": "Filtered sine with slight movement",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "cutoff",
        "default": 300
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sub_filtered\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 300.0)\n        .body(|freq, amp, gate, cutoff| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sine with slight harmonic content\n            let sig = sin_osc_ar(freq);\n            let harmonic = sin_osc_ar(freq * 2.0) * 0.15;\n            let mix = sig + harmonic;\n\n            // Gentle low-pass filter\n            let filtered = lpf_ar(mix, cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "sub",
    "path": "bass/sub/sub_filtered.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Sub"
  },
  {
    "name": "sub_harmonic",
    "description": "Genre: Techno, House | Character: Sub with rich harmonic series",
    "genre": "Techno, House",
    "character": "Sub with rich harmonic series",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sub_harmonic\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Build harmonic series\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.25;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.15;\n            let harmonic4 = sin_osc_ar(freq * 4.0) * 0.1;\n            let harmonic5 = sin_osc_ar(freq * 5.0) * 0.05;\n\n            let sig = fundamental + harmonic2 + harmonic3 + harmonic4 + harmonic5;\n\n            // Filter to control brightness\n            let filtered = lpf_ar(sig, 400.0);\n\n            filtered * env * amp * 0.7\n        })\n});",
    "category": "bass",
    "subcategory": "sub",
    "path": "bass/sub/sub_harmonic.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Sub"
  },
  {
    "name": "sub_modulated",
    "description": "Genre: Techno, Minimal | Character: Phase-modulated sub with movement",
    "genre": "Techno, Minimal",
    "character": "Phase-modulated sub with movement",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sub_modulated\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Modulator for subtle phase modulation\n            let mod_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let modulator = sin_osc_ar(freq * 0.5) * mod_env * 0.3;\n\n            // Carrier with modulation\n            let carrier = sin_osc_ar(freq + modulator);\n\n            carrier * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "sub",
    "path": "bass/sub/sub_modulated.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Sub"
  },
  {
    "name": "sub_mono",
    "description": "Genre: All | Character: Focused mono sub for club systems",
    "genre": "All",
    "character": "Focused mono sub for club systems",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sub_mono\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Clean envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pure sine, centered\n            let sig = sin_osc_ar(freq);\n\n            sig * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "sub",
    "path": "bass/sub/sub_mono.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Sub"
  },
  {
    "name": "sub_octave",
    "description": "Genre: Dubstep, Drum & Bass | Character: Layered octaves for massive sub",
    "genre": "Dubstep, Drum & Bass",
    "character": "Layered octaves for massive sub",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sub_octave\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fundamental\n            let fundamental = sin_osc_ar(freq);\n\n            // Octave down for extra depth\n            let sub = sin_osc_ar(freq * 0.5) * 0.6;\n\n            // Octave up for harmonics\n            let harmonic = sin_osc_ar(freq * 2.0) * 0.2;\n\n            let sig = fundamental + sub + harmonic;\n\n            sig * env * amp * 0.7\n        })\n});",
    "category": "bass",
    "subcategory": "sub",
    "path": "bass/sub/sub_octave.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Sub"
  },
  {
    "name": "sub_pure_sine",
    "description": "Genre: Dubstep, Bass Music | Character: Pure sine wave sub, clean and deep",
    "genre": "Dubstep, Bass Music",
    "character": "Pure sine wave sub, clean and deep",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sub_pure_sine\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope with slight attack for smoothness\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pure sine wave\n            let sig = sin_osc_ar(freq);\n\n            sig * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "sub",
    "path": "bass/sub/sub_pure_sine.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Sub"
  },
  {
    "name": "sub_stereo",
    "description": "Genre: Ambient, Experimental | Character: Wide stereo sub with slight detuning",
    "genre": "Ambient, Experimental",
    "character": "Wide stereo sub with slight detuning",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sub_stereo\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slightly detuned sines for width\n            let left = sin_osc_ar(freq * 0.998);\n            let right = sin_osc_ar(freq * 1.002);\n\n            // Mix for stereo width (using left + right creates subtle movement)\n            let sig = left + right;\n\n            sig * env * amp * 0.7\n        })\n});",
    "category": "bass",
    "subcategory": "sub",
    "path": "bass/sub/sub_stereo.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Sub"
  },
  {
    "name": "sub_triangle",
    "description": "Genre: House, Techno | Character: Triangle wave sub with odd harmonics",
    "genre": "House, Techno",
    "character": "Triangle wave sub with odd harmonics",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sub_triangle\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Smooth envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Approximate triangle with sine and harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.111;\n            let harmonic5 = sin_osc_ar(freq * 5.0) * 0.04;\n\n            let sig = fundamental + harmonic3 + harmonic5;\n\n            sig * env * amp * 0.8\n        })\n});",
    "category": "bass",
    "subcategory": "sub",
    "path": "bass/sub/sub_triangle.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Sub"
  },
  {
    "name": "sub_warm",
    "description": "Genre: House, Deep House | Character: Warm sub with gentle harmonics",
    "genre": "House, Deep House",
    "character": "Warm sub with gentle harmonics",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sub_warm\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fundamental\n            let fundamental = sin_osc_ar(freq);\n\n            // Warm harmonics\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.15;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.08;\n\n            let sig = fundamental + harmonic2 + harmonic3;\n\n            // Gentle filtering for warmth\n            let filtered = lpf_ar(sig, 250.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "sub",
    "path": "bass/sub/sub_warm.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Sub"
  },
  {
    "name": "bass_101",
    "description": "Roland SH-101 bass - classic mono synth",
    "genre": "Acid, Techno, Electronic",
    "character": "Roland SH-101 bass - classic mono synth",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Acid, Techno, Electronic | Character: Roland SH-101 bass - classic mono synth\ndefine_synthdef(\"bass_101\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .param(\"cutoff\", 1000.0)\n    .body(|freq, amp, gate, cutoff| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.005, 0.2)\n            .build();\n\n        // Single saw oscillator with sub\n        let osc = saw_ar(freq);\n        let sub = pulse_ar(freq * 0.5, 0.5) * 0.5;\n\n        let mix = (osc + sub) * 0.45;\n\n        // Snappy filter\n        let mod_cutoff = cutoff + filt_env * 2000.0;\n        let filtered = rlpf_ar(mix, mod_cutoff, 0.3);\n\n        filtered * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "synth",
    "path": "bass/synth/bass_101.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Synth"
  },
  {
    "name": "bass_dx7",
    "description": "DX7 FM bass - punchy and clear",
    "genre": "80s Pop, R&B, Electronic",
    "character": "DX7 FM bass - punchy and clear",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: 80s Pop, R&B, Electronic | Character: DX7 FM bass - punchy and clear\ndefine_synthdef(\"bass_dx7\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // FM index envelope\n        let mod_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n\n        // FM synthesis - carrier and modulator\n        let mod_ratio = 1.0;\n        let mod_index = 2.0 + mod_env * 5.0;\n        let modulator = sin_osc_ar(freq * mod_ratio) * mod_index * freq;\n        let carrier = sin_osc_ar(freq + modulator);\n\n        // Second operator for more harmonics\n        let mod2 = sin_osc_ar(freq * 2.0) * mod_env * freq * 0.5;\n        let carrier2 = sin_osc_ar(freq + mod2) * 0.3;\n\n        let sig = (carrier + carrier2) * 0.5;\n\n        sig * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "synth",
    "path": "bass/synth/bass_dx7.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Synth"
  },
  {
    "name": "bass_granular",
    "description": "Granular bass texture",
    "genre": "Experimental, Ambient, IDM",
    "character": "Granular bass texture",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Experimental, Ambient, IDM | Character: Granular bass texture\ndefine_synthdef(\"bass_granular\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.7)\n    .param(\"gate\", 1.0)\n    .param(\"grain_rate\", 20.0)\n    .body(|freq, amp, gate, grain_rate| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Base tone\n        let base = sin_osc_ar(freq) * 0.4;\n\n        // Granular texture using multiple modulated oscillators\n        let grain_mod = sin_osc_ar(grain_rate) * 0.5 + 0.5;\n        let grain1 = sin_osc_ar(freq * 1.01) * grain_mod * 0.2;\n        let grain2 = sin_osc_ar(freq * 0.99) * (1.0 - grain_mod) * 0.2;\n\n        // Random frequency deviations\n        let dust_mod = dust_ar(grain_rate) * freq * 0.02;\n        let grain3 = sin_osc_ar(freq + dust_mod) * 0.15;\n\n        let mix = base + grain1 + grain2 + grain3;\n\n        lpf_ar(mix, 2000.0) * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "synth",
    "path": "bass/synth/bass_granular.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Synth"
  },
  {
    "name": "bass_juno",
    "description": "Roland Juno-style bass - warm and punchy",
    "genre": "House, Disco, Synthwave",
    "character": "Roland Juno-style bass - warm and punchy",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: House, Disco, Synthwave | Character: Roland Juno-style bass - warm and punchy\ndefine_synthdef(\"bass_juno\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.008, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.008, 0.2)\n            .build();\n\n        // PWM oscillator characteristic of Juno\n        let pwm = sin_osc_ar(0.5) * 0.2 + 0.5;\n        let osc = pulse_ar(freq, pwm);\n\n        // Sub oscillator\n        let sub = pulse_ar(freq * 0.5, 0.5) * 0.4;\n\n        let mix = (osc + sub) * 0.45;\n\n        // Warm filter\n        let cutoff = 600.0 + filt_env * 1500.0;\n        let filtered = rlpf_ar(mix, cutoff, 0.2);\n\n        filtered * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "synth",
    "path": "bass/synth/bass_juno.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Synth"
  },
  {
    "name": "bass_moog",
    "description": "Classic Minimoog bass - fat and warm",
    "genre": "Funk, Electronic, Classic",
    "character": "Classic Minimoog bass - fat and warm",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Funk, Electronic, Classic | Character: Classic Minimoog bass - fat and warm\ndefine_synthdef(\"bass_moog\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .param(\"cutoff\", 800.0)\n    .param(\"res\", 0.3)\n    .body(|freq, amp, gate, cutoff, res| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.01, 0.3)\n            .build();\n\n        // Multiple oscillators slightly detuned\n        let osc1 = saw_ar(freq);\n        let osc2 = saw_ar(freq * 1.005);\n        let osc3 = pulse_ar(freq * 0.5, 0.5) * 0.5;\n\n        let mix = (osc1 + osc2 + osc3) * 0.35;\n\n        // Moog-style ladder filter\n        let mod_cutoff = cutoff + filt_env * 1500.0;\n        let filtered = rlpf_ar(mix, mod_cutoff, res);\n\n        filtered * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "synth",
    "path": "bass/synth/bass_moog.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Synth"
  },
  {
    "name": "bass_ms20",
    "description": "Korg MS-20 bass - aggressive and nasty",
    "genre": "Industrial, Techno, Experimental",
    "character": "Korg MS-20 bass - aggressive and nasty",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Industrial, Techno, Experimental | Character: Korg MS-20 bass - aggressive and nasty\ndefine_synthdef(\"bass_ms20\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .param(\"drive\", 2.0)\n    .body(|freq, amp, gate, drive| {\n        let env = envelope()\n            .asr(0.003, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.003, 0.25)\n            .build();\n\n        // Ring mod-ish oscillators\n        let osc1 = saw_ar(freq);\n        let osc2 = pulse_ar(freq * 1.01, 0.3);\n\n        let mix = (osc1 + osc2) * 0.4;\n\n        // MS-20 style high-pass then low-pass with drive\n        let hp = hpf_ar(mix, 60.0);\n        let driven = (hp * drive).tanh();\n\n        // Aggressive filter\n        let cutoff = 400.0 + filt_env * 2500.0;\n        let filtered = rlpf_ar(driven, cutoff, 0.4);\n\n        filtered * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "synth",
    "path": "bass/synth/bass_ms20.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Synth"
  },
  {
    "name": "bass_prophet",
    "description": "Prophet-5 style bass - punchy and rich",
    "genre": "Synth-pop, Electronic",
    "character": "Prophet-5 style bass - punchy and rich",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Synth-pop, Electronic | Character: Prophet-5 style bass - punchy and rich\ndefine_synthdef(\"bass_prophet\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.005, 0.25)\n            .build();\n\n        // Two oscillators\n        let osc1 = saw_ar(freq);\n        let osc2 = pulse_ar(freq * 1.003, 0.4);\n\n        let mix = (osc1 + osc2) * 0.4;\n\n        // Punchy filter\n        let cutoff = 500.0 + filt_env * 2000.0;\n        let filtered = rlpf_ar(mix, cutoff, 0.25);\n\n        filtered * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "synth",
    "path": "bass/synth/bass_prophet.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Synth"
  },
  {
    "name": "bass_wavetable",
    "description": "Wavetable-style bass with morphing character",
    "genre": "Modern Electronic, EDM",
    "character": "Wavetable-style bass with morphing character",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Modern Electronic, EDM | Character: Wavetable-style bass with morphing character\ndefine_synthdef(\"bass_wavetable\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.8)\n    .param(\"gate\", 1.0)\n    .param(\"morph\", 0.5)\n    .body(|freq, amp, gate, morph| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Simulate wavetable morphing with crossfading waveforms\n        let sine = sin_osc_ar(freq);\n        let tri = lf_tri_ar(freq);\n        let saw = saw_ar(freq);\n        let pulse = pulse_ar(freq, 0.3);\n\n        // Crossfade based on morph parameter\n        let mix1 = sine * (1.0 - morph * 2.0).max(0.0);\n        let mix2 = tri * (1.0 - (morph - 0.25).abs() * 4.0).max(0.0);\n        let mix3 = saw * (1.0 - (morph - 0.5).abs() * 4.0).max(0.0);\n        let mix4 = pulse * (1.0 - (morph - 0.75).abs() * 4.0).max(0.0);\n\n        let mix = (mix1 + mix2 + mix3 + mix4) * 0.5;\n\n        // Sub layer\n        let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n        // Filter\n        let cutoff = 800.0 + morph * 2000.0;\n        let filtered = lpf_ar(mix + sub, cutoff);\n\n        filtered * env * amp\n    });\n",
    "category": "bass",
    "subcategory": "synth",
    "path": "bass/synth/bass_wavetable.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Synth"
  },
  {
    "name": "wobble_aggressive",
    "description": "Genre: Brostep, Dubstep | Character: Aggressive, distorted wobble",
    "genre": "Brostep, Dubstep",
    "character": "Aggressive, distorted wobble",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "wobble_rate",
        "default": 6
      },
      {
        "name": "amp",
        "default": 0.55
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"wobble_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"wobble_rate\", 6.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws for thickness\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq * 1.005);\n            let mix = (osc1 + osc2) * 0.7;\n\n            // Clip for distortion\n            let driven = mix; //clip(mix, -0.8, 0.8);\n\n            // Fast wobble LFO\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n            let mod_cutoff = 150.0 + (wobble_lfo * 3500.0);\n\n            // High resonance for aggression\n            let filtered = rlpf_ar(driven, mod_cutoff, 0.08);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "wobble",
    "path": "bass/wobble/wobble_aggressive.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Wobble"
  },
  {
    "name": "wobble_classic",
    "description": "Genre: Dubstep, Bass Music | Character: Classic wobble bass with filter modulation",
    "genre": "Dubstep, Bass Music",
    "character": "Classic wobble bass with filter modulation",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "wobble_rate",
        "default": 4
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"wobble_classic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"wobble_rate\", 4.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Saw\n\n            // Sawtooth oscillator\n            let osc = saw_ar(freq);\n\n            // Wobble LFO using sine\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n\n            // Modulate filter cutoff with wobble\n            let mod_cutoff = 200.0 + (wobble_lfo * 2500.0);\n\n            // Resonant filter for classic wobble\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.1);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "wobble",
    "path": "bass/wobble/wobble_classic.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Wobble"
  },
  {
    "name": "wobble_deep",
    "description": "Genre: Deep Dubstep, 140 | Character: Deep, sub-heavy wobble",
    "genre": "Deep Dubstep, 140",
    "character": "Deep, sub-heavy wobble",
    "params": [
      {
        "name": "freq",
        "default": 75
      },
      {
        "name": "wobble_rate",
        "default": 2.5
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"wobble_deep\", |builder| {\n    builder\n        .param(\"freq\", 75.0)\n        .param(\"wobble_rate\", 2.5)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Saw plus sub\n            let saw = saw_ar(freq) * 0.6;\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n            let mix = saw + sub;\n\n            // Slow, deep wobble\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n            let mod_cutoff = 150.0 + (wobble_lfo * 1200.0);\n\n            // Moderate resonance\n            let filtered = rlpf_ar(mix, mod_cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "wobble",
    "path": "bass/wobble/wobble_deep.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Wobble"
  },
  {
    "name": "wobble_fm",
    "description": "Genre: Experimental Dubstep | Character: FM wobble with complex harmonics",
    "genre": "Experimental Dubstep",
    "character": "FM wobble with complex harmonics",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "wobble_rate",
        "default": 5
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"wobble_fm\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"wobble_rate\", 5.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM synthesis for complex timbre\n            let modulator = sin_osc_ar(freq * 1.5) * freq * 2.0;\n            let carrier = saw_ar(freq + modulator);\n\n            // Wobble LFO\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n            let mod_cutoff = 250.0 + (wobble_lfo * 2800.0);\n\n            // Filter with resonance\n            let filtered = rlpf_ar(carrier, mod_cutoff, 0.15);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "wobble",
    "path": "bass/wobble/wobble_fm.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Wobble"
  },
  {
    "name": "wobble_smooth",
    "description": "Genre: Melodic Dubstep, Chillstep | Character: Smooth, liquid wobble",
    "genre": "Melodic Dubstep, Chillstep",
    "character": "Smooth, liquid wobble",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "wobble_rate",
        "default": 2
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"wobble_smooth\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"wobble_rate\", 2.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Smooth envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Saw oscillator\n            let osc = saw_ar(freq);\n\n            // Slow, smooth wobble\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n            let mod_cutoff = 400.0 + (wobble_lfo * 1800.0);\n\n            // Less resonance for smoothness\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "wobble",
    "path": "bass/wobble/wobble_smooth.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Wobble"
  },
  {
    "name": "wobble_squelch",
    "description": "Genre: Dubstep, Riddim | Character: Squelchy, talking wobble",
    "genre": "Dubstep, Riddim",
    "character": "Squelchy, talking wobble",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "wobble_rate",
        "default": 8
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"wobble_squelch\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"wobble_rate\", 8.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, wobble_rate, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pulse wave for different timbre\n            let osc = saw_ar(freq);\n\n            // Fast wobble with extreme modulation\n            let wobble_lfo = sin_osc_ar(wobble_rate) * 0.5 + 0.5;\n            let mod_cutoff = 100.0 + (wobble_lfo * 4000.0);\n\n            // Very high resonance for squelch\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.05);\n\n            filtered * env * amp\n        })\n});",
    "category": "bass",
    "subcategory": "wobble",
    "path": "bass/wobble/wobble_squelch.vibe",
    "categoryName": "Bass",
    "subcategoryName": "Wobble"
  },
  {
    "name": "church_bell",
    "description": "Large church bell with complex inharmonic partials.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"church_bell\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Bell envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 1.0)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Very long decay\n            let decay_env = envelope()\n                .perc(0.001, 8.0)\n                .build();\n\n            // Church bell partials (very inharmonic)\n            let h1 = sin_osc_ar(freq * 0.5);  // Hum tone\n            let h2 = sin_osc_ar(freq);         // Prime\n            let h3 = sin_osc_ar(freq * 1.2);   // Minor third\n            let h4 = sin_osc_ar(freq * 1.5) * 0.8;  // Fifth\n            let h5 = sin_osc_ar(freq * 2.0) * 0.6;  // Octave\n            let h6 = sin_osc_ar(freq * 2.5) * 0.4;  // Upper partial\n            let h7 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h8 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h9 = sin_osc_ar(freq * 5.5) * 0.15;\n\n            let bell = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8 + h9;\n\n            // Clapper strike\n            let strike_env = envelope()\n                .perc(0.0001, 0.08)\n                .build();\n            let strike = white_noise_ar() * strike_env * 0.2;\n            let strike_filtered = lpf_ar(strike, 2000.0);\n\n            (bell * 0.4 + strike_filtered) * env * decay_env * amp\n        })\n});",
    "category": "bells",
    "subcategory": "",
    "path": "bells/church_bell.vibe",
    "categoryName": "Bells"
  },
  {
    "name": "glockenspiel",
    "description": "Bright, high-pitched metallic bells.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 880
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"glockenspiel\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Quick attack envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium decay\n            let decay_env = envelope()\n                .perc(0.001, 1.5)\n                .build();\n\n            // Bright metallic partials\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(freq * 5.76) * 0.15; // Slightly inharmonic\n            let h6 = sin_osc_ar(freq * 7.0) * 0.1;\n\n            let bell = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Mallet attack\n            let mallet_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let mallet = sin_osc_ar(freq * 6.0) * mallet_env * 0.2;\n\n            (bell + mallet) * env * decay_env * amp * 0.5\n        })\n});",
    "category": "bells",
    "subcategory": "",
    "path": "bells/glockenspiel.vibe",
    "categoryName": "Bells"
  },
  {
    "name": "marimba",
    "description": "Deep wooden marimba with resonant body.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"marimba\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Marimba envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium decay\n            let decay_env = envelope()\n                .perc(0.001, 0.6)\n                .build();\n\n            // Marimba partials (warm, strong fundamental)\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h3 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h4 = sin_osc_ar(freq * 5.0) * 0.08;\n\n            let wood = h1 + h2 + h3 + h4;\n\n            // Soft mallet attack\n            let mallet_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let mallet = white_noise_ar() * mallet_env * 0.08;\n            let mallet_filtered = lpf_ar(mallet, 3000.0);\n\n            // Body resonance\n            let body = rlpf_ar(wood, freq * 1.5, 0.3) * 0.3;\n\n            (wood + body + mallet_filtered) * env * decay_env * amp * 0.7\n        })\n});",
    "category": "bells",
    "subcategory": "",
    "path": "bells/marimba.vibe",
    "categoryName": "Bells"
  },
  {
    "name": "music_box",
    "description": "Classic music box with characteristic tines.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 880
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"music_box\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Quick pluck envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay envelope\n            let decay_env = envelope()\n                .perc(0.001, 0.8)\n                .build();\n\n            // Pure sine-based tines\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n            let tine = h1 + h2 + h3 + h4;\n\n            // Tine pluck attack\n            let pluck_env = envelope()\n                .perc(0.0001, 0.008)\n                .build();\n            let pluck = sin_osc_ar(freq * 5.0) * pluck_env * 0.3;\n\n            // High pass for clarity\n            let bright = hpf_ar(tine + pluck, 500.0);\n\n            bright * env * decay_env * amp * 0.6\n        })\n});",
    "category": "bells",
    "subcategory": "",
    "path": "bells/music_box.vibe",
    "categoryName": "Bells"
  },
  {
    "name": "tubular_bells",
    "description": "Orchestral tubular bells with long resonant decay.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tubular_bells\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Bell envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Long decay\n            let decay_env = envelope()\n                .perc(0.001, 4.0)\n                .build();\n\n            // Tubular bell partials (slightly inharmonic)\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 2.83) * 0.4; // Inharmonic\n            let h4 = sin_osc_ar(freq * 4.07) * 0.3;\n            let h5 = sin_osc_ar(freq * 5.12) * 0.2;\n            let h6 = sin_osc_ar(freq * 6.2) * 0.15;\n            let h7 = sin_osc_ar(freq * 8.5) * 0.1;\n\n            let bell = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Strike attack\n            let strike_env = envelope()\n                .perc(0.0001, 0.05)\n                .build();\n            let strike = white_noise_ar() * strike_env * 0.15;\n\n            (bell + strike) * env * decay_env * amp * 0.5\n        })\n});",
    "category": "bells",
    "subcategory": "",
    "path": "bells/tubular_bells.vibe",
    "categoryName": "Bells"
  },
  {
    "name": "vibraphone",
    "description": "Jazz vibraphone with characteristic motor vibrato.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "vibrato_speed",
        "default": 5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"vibraphone\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"vibrato_speed\", 5.0) // Motor speed\n        .body(|freq, amp, gate, vibrato_speed| {\n            // Vibes envelope\n            let env = envelope()\n                .asr(0.005, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium-long decay\n            let decay_env = envelope()\n                .perc(0.001, 2.0)\n                .build();\n\n            // Vibraphone partials\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(freq * 4.8) * 0.1; // Slightly inharmonic\n\n            let bell = h1 + h2 + h3 + h4 + h5;\n\n            // Motor vibrato (amplitude tremolo)\n            let motor = sin_osc_ar(vibrato_speed) * 0.3 + 0.7;\n\n            // Mallet soft attack\n            let mallet_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let mallet = white_noise_ar() * mallet_env * 0.05;\n\n            (bell * motor + mallet) * env * decay_env * amp * 0.6\n        })\n});",
    "category": "bells",
    "subcategory": "",
    "path": "bells/vibraphone.vibe",
    "categoryName": "Bells"
  },
  {
    "name": "xylophone",
    "description": "Wooden mallet percussion with short decay.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 880
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"xylophone\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Short percussive envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Short decay\n            let decay_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Xylophone partials (bright, woody)\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 3.0) * 0.4; // Strong 3rd harmonic\n            let h3 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 6.0) * 0.15;\n\n            let wood = h1 + h2 + h3 + h4;\n\n            // Woody mallet click\n            let click_env = envelope()\n                .perc(0.0001, 0.015)\n                .build();\n            let click = white_noise_ar() * click_env * 0.2;\n            let click_filtered = hpf_ar(click, 2000.0);\n\n            (wood + click_filtered) * env * decay_env * amp * 0.7\n        })\n});",
    "category": "bells",
    "subcategory": "",
    "path": "bells/xylophone.vibe",
    "categoryName": "Bells"
  },
  {
    "name": "trumpet_realistic",
    "description": "Realistic Trumpet with mute options",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 349.23
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "brightness",
        "default": 0.6
      },
      {
        "name": "lip_tension",
        "default": 0.5
      },
      {
        "name": "air_pressure",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trumpet_realistic\", |builder| {\n    builder\n        .param(\"freq\", 349.23)    // F4 - comfortable trumpet range\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.6)    // Bell brightness\n        .param(\"lip_tension\", 0.5)   // Affects attack and timbre\n        .param(\"air_pressure\", 0.7)  // Dynamics\n        .body(|freq, amp, gate, brightness, lip_tension, air_pressure| {\n            let env = envelope()\n                .asr(0.03, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Delayed vibrato (musicians add vibrato after attack)\n            let vib_delay = envelope()\n                .perc(0.2, 4.0)\n                .build();\n            let vib_rate = 5.0 + (lip_tension * 1.5);\n            let vib_depth = 0.006 + (lip_tension * 0.004);\n            let vib = sin_osc_ar(vib_rate) * vib_depth * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Trumpet harmonics - bright with strong upper partials\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.32 * brightness;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.25 * brightness;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.18 * brightness;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.12 * brightness;\n            let h9 = sin_osc_ar(mod_freq * 9.0) * 0.07 * brightness;\n            let h10 = sin_osc_ar(mod_freq * 10.0) * 0.04 * brightness;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8 + h9 + h10;\n\n            // Lip buzz attack transient\n            let lip_env = envelope()\n                .perc(0.001, 0.025)\n                .build();\n            let lip_buzz = white_noise_ar() * lip_env * lip_tension * 0.15;\n            let lip_filtered = bpf_ar(lip_buzz, mod_freq * 6.0, 0.3);\n\n            // Bell formants - characteristic trumpet brightness\n            let f1 = rlpf_ar(harmonics, 1200.0, 0.35) * 0.35;\n            let f2 = rlpf_ar(harmonics, 2500.0, 0.3) * 0.35;\n            let f3 = rlpf_ar(harmonics, 4000.0, 0.25) * 0.3 * brightness;\n\n            // Bell flare high-frequency boost\n            let bell_boost = rlpf_ar(harmonics, 6000.0, 0.4) * 0.15 * brightness;\n\n            // Dynamic brightness - louder = brighter\n            let dyn_cutoff = 3000.0 + (air_pressure * 5000.0);\n            let dynamics = lpf_ar(f1 + f2 + f3 + bell_boost, dyn_cutoff);\n\n            let tone = dynamics + lip_filtered;\n\n            hpf_ar(tone, 150.0) * env * amp * air_pressure * 0.5\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/brass_realistic.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "trumpet_harmon_mute",
    "description": "Harmon mute (wah-wah)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 349.23
      },
      {
        "name": "amp",
        "default": 0.55
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "stem_in",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trumpet_harmon_mute\", |builder| {\n    builder\n        .param(\"freq\", 349.23)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .param(\"stem_in\", 0.5)   // 0=stem out (bright), 1=stem in (dark)\n        .body(|freq, amp, gate, stem_in| {\n            let env = envelope()\n                .asr(0.025, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Subtle vibrato\n            let vib = sin_osc_ar(5.5) * 0.005 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Harmonics\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.38;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.28;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.2;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.14;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Harmon mute creates a nasal, buzzy quality\n            // Strong resonance around 1kHz-2kHz\n            let mute_freq = 1500.0 + ((1.0 - stem_in) * 800.0);\n            let muted = rlpf_ar(harmonics, mute_freq, 0.15);  // Very resonant\n\n            // Stem position affects high frequencies\n            let hf_cutoff = 2500.0 + ((1.0 - stem_in) * 3000.0);\n            let hf_control = lpf_ar(muted, hf_cutoff);\n\n            // Buzzy character\n            let buzz = rlpf_ar(harmonics, 3500.0, 0.2) * 0.2;\n\n            let tone = hf_control + buzz;\n\n            hpf_ar(tone, 200.0) * env * amp * 0.55\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/brass_realistic.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "trumpet_cup_mute",
    "description": "softer, warmer",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 349.23
      },
      {
        "name": "amp",
        "default": 0.55
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trumpet_cup_mute\", |builder| {\n    builder\n        .param(\"freq\", 349.23)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let vib = sin_osc_ar(5.2) * 0.005 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Softer harmonics\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.22;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.12;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5;\n\n            // Cup mute - warmer, less bright\n            let muted = lpf_ar(harmonics, 2500.0);\n            let warm = rlpf_ar(muted, 800.0, 0.4) * 0.3;\n\n            let tone = muted + warm;\n\n            hpf_ar(tone, 150.0) * env * amp * 0.55\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/brass_realistic.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "flugelhorn",
    "description": "dark, velvety brass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 349.23
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "warmth",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"flugelhorn\", |builder| {\n    builder\n        .param(\"freq\", 349.23)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"warmth\", 0.7)\n        .body(|freq, amp, gate, warmth| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slower, wider vibrato\n            let vib_delay = envelope()\n                .perc(0.25, 4.0)\n                .build();\n            let vib = sin_osc_ar(4.8) * 0.006 * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Flugelhorn - darker, fewer high harmonics\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.1;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.05;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Soft attack\n            let attack_env = envelope()\n                .perc(0.002, 0.03)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.06;\n\n            // Conical bore - warm, round\n            let f1 = rlpf_ar(harmonics, 800.0, 0.45) * 0.4;\n            let f2 = rlpf_ar(harmonics, 1600.0, 0.4) * 0.35;\n            let f3 = rlpf_ar(harmonics, 2800.0, 0.45) * 0.25 * (1.0 - warmth * 0.5);\n\n            // Extra warmth\n            let warm = rlpf_ar(harmonics, 400.0, 0.5) * warmth * 0.2;\n\n            let tone = f1 + f2 + f3 + warm + attack;\n\n            hpf_ar(tone, 120.0) * env * amp * 0.55\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/brass_realistic.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "trombone_realistic",
    "description": "Realistic Trombone with slide position simulation",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 174.61
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "slide_smoothness",
        "default": 0.8
      },
      {
        "name": "brightness",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trombone_realistic\", |builder| {\n    builder\n        .param(\"freq\", 174.61)    // F3\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"slide_smoothness\", 0.8)  // How smooth the pitch transitions are\n        .param(\"brightness\", 0.5)\n        .body(|freq, amp, gate, slide_smoothness, brightness| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Trombone vibrato - often jaw vibrato\n            let vib_delay = envelope()\n                .perc(0.3, 4.0)\n                .build();\n            let vib = sin_osc_ar(5.0) * 0.005 * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Rich harmonic content\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.38;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.28;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.2 * brightness;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.14 * brightness;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.1 * brightness;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Lip attack\n            let lip_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let lip = white_noise_ar() * lip_env * 0.1;\n            let lip_filtered = bpf_ar(lip, mod_freq * 4.0, 0.3);\n\n            // Cylindrical bore formants\n            let f1 = rlpf_ar(harmonics, 500.0, 0.4) * 0.4;\n            let f2 = rlpf_ar(harmonics, 1200.0, 0.35) * 0.35;\n            let f3 = rlpf_ar(harmonics, 2500.0, 0.35) * 0.25 * brightness;\n\n            // Bell flare\n            let bell = rlpf_ar(harmonics, 3500.0, 0.4) * 0.15 * brightness;\n\n            let tone = f1 + f2 + f3 + bell + lip_filtered;\n\n            hpf_ar(tone, 80.0) * env * amp * 0.55\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/brass_realistic.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "bass_trombone",
    "description": "deeper, more powerful",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 116.54
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bass_trombone\", |builder| {\n    builder\n        .param(\"freq\", 116.54)   // Bb2\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let vib = sin_osc_ar(4.5) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Full bass trombone spectrum\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.45;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.32;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.22;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.15;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.1;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.001, 0.035)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.08;\n\n            // Larger bore = darker\n            let f1 = rlpf_ar(harmonics, 350.0, 0.4) * 0.45;\n            let f2 = rlpf_ar(harmonics, 900.0, 0.4) * 0.35;\n            let f3 = rlpf_ar(harmonics, 1800.0, 0.4) * 0.2;\n\n            let tone = f1 + f2 + f3 + attack;\n\n            hpf_ar(tone, 50.0) * env * amp * 0.55\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/brass_realistic.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "french_horn_realistic",
    "description": "noble, warm, mellow",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "stopped",
        "default": "0.0"
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"french_horn_realistic\", |builder| {\n    builder\n        .param(\"freq\", 220.0)    // A3\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"stopped\", 0.0)   // 0=open, 1=hand stopped\n        .body(|freq, amp, gate, stopped| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Horn vibrato - subtle\n            let vib = sin_osc_ar(5.0) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Horn harmonics - emphasis on odd partials (conical bore)\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.6;  // Odd emphasis\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.45;  // Odd emphasis\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.25;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.18;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.1;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Hand in bell creates warm, distant quality\n            // Stopped horn creates buzzy, metallic quality\n            let open_cutoff = 2500.0;\n            let stopped_peak = 1800.0;\n\n            let cutoff = open_cutoff * (1.0 - stopped * 0.4);\n            let resonance = 0.35 + (stopped * 0.25);\n\n            let filtered = rlpf_ar(harmonics, cutoff, resonance);\n\n            // Stopped horn boost\n            let stopped_buzz = rlpf_ar(harmonics, stopped_peak, 0.15) * stopped * 0.3;\n\n            // Noble, warm formants\n            let f1 = rlpf_ar(filtered, 350.0, 0.45) * 0.35;\n            let f2 = rlpf_ar(filtered, 800.0, 0.4) * 0.35;\n            let f3 = rlpf_ar(filtered, 1800.0, 0.4) * 0.3 * (1.0 - stopped * 0.5);\n\n            let tone = f1 + f2 + f3 + stopped_buzz;\n\n            hpf_ar(tone, 100.0) * env * amp * 0.55\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/brass_realistic.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "tuba_realistic",
    "description": "deep, fundamental bass brass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 58.27
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "brightness",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tuba_realistic\", |builder| {\n    builder\n        .param(\"freq\", 58.27)    // Bb1\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.4)\n        .body(|freq, amp, gate, brightness| {\n            let env = envelope()\n                .asr(0.06, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Very slow vibrato\n            let vib = sin_osc_ar(4.0) * 0.003 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Tuba - strong fundamentals\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.38;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.16;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.1;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.06;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Slow attack\n            let attack_env = envelope()\n                .perc(0.002, 0.04)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.06;\n\n            // Very large bore - dark and round\n            let f1 = rlpf_ar(harmonics, 200.0, 0.45) * 0.45;\n            let f2 = rlpf_ar(harmonics, 600.0, 0.4) * 0.35;\n            let f3 = rlpf_ar(harmonics, 1200.0, 0.4) * 0.2 * brightness;\n\n            let tone = f1 + f2 + f3 + attack;\n\n            hpf_ar(tone, 30.0) * env * amp * 0.55\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/brass_realistic.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "euphonium",
    "description": "warm baritone brass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 130.81
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "warmth",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"euphonium\", |builder| {\n    builder\n        .param(\"freq\", 130.81)   // C3\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"warmth\", 0.6)\n        .body(|freq, amp, gate, warmth| {\n            let env = envelope()\n                .asr(0.045, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let vib = sin_osc_ar(4.8) * 0.005 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Warm, singing tone\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.42;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.28;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.18;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.1;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.07;\n\n            // Conical bore - warm and mellow\n            let f1 = rlpf_ar(harmonics, 300.0, 0.45) * 0.4;\n            let f2 = rlpf_ar(harmonics, 850.0, 0.4) * 0.35;\n            let f3 = rlpf_ar(harmonics, 1800.0, 0.4) * 0.25 * (1.0 - warmth * 0.3);\n\n            // Extra warmth\n            let warm = rlpf_ar(harmonics, 400.0, 0.5) * warmth * 0.15;\n\n            let tone = f1 + f2 + f3 + warm + attack;\n\n            hpf_ar(tone, 60.0) * env * amp * 0.55\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/brass_realistic.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "brass_section_realistic",
    "description": "ensemble sound",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "width",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"brass_section_realistic\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"width\", 0.5)     // Ensemble width/detuning\n        .body(|freq, amp, gate, width| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned voices\n            let detune = 0.003 + (width * 0.005);\n\n            // Trumpet section (3 players)\n            let t1 = sin_osc_ar(freq) + sin_osc_ar(freq * 2.0) * 0.5 + sin_osc_ar(freq * 3.0) * 0.3;\n            let t2 = sin_osc_ar(freq * (1.0 + detune)) + sin_osc_ar(freq * 2.0 * (1.0 + detune)) * 0.5;\n            let t3 = sin_osc_ar(freq * (1.0 - detune)) + sin_osc_ar(freq * 2.0 * (1.0 - detune)) * 0.5;\n\n            let trumpets = (t1 + t2 + t3) * 0.15;\n\n            // Trombone section (2 players, octave lower)\n            let tb1 = sin_osc_ar(freq * 0.5) + sin_osc_ar(freq) * 0.5 + sin_osc_ar(freq * 1.5) * 0.3;\n            let tb2 = sin_osc_ar(freq * 0.5 * (1.0 + detune * 0.8)) + sin_osc_ar(freq * (1.0 + detune * 0.8)) * 0.5;\n\n            let trombones = (tb1 + tb2) * 0.12;\n\n            // Horns (2 players)\n            let h1 = sin_osc_ar(freq * 0.75) + sin_osc_ar(freq * 1.5) * 0.4 + sin_osc_ar(freq * 2.25) * 0.25;\n            let h2 = sin_osc_ar(freq * 0.75 * (1.0 - detune * 0.5)) + sin_osc_ar(freq * 1.5 * (1.0 - detune * 0.5)) * 0.4;\n\n            let horns = (h1 + h2) * 0.1;\n\n            let ensemble = trumpets + trombones + horns;\n\n            // Section formants\n            let f1 = rlpf_ar(ensemble, 600.0, 0.4) * 0.4;\n            let f2 = rlpf_ar(ensemble, 1500.0, 0.35) * 0.35;\n            let f3 = rlpf_ar(ensemble, 3000.0, 0.35) * 0.25;\n\n            let tone = f1 + f2 + f3;\n\n            hpf_ar(tone, 80.0) * env * amp * 0.5\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/brass_realistic.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "brass_section",
    "description": "Full brass section ensemble with rich harmonics.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"brass_section\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Brass swell envelope\n            let env = envelope()\n                .asr(0.15, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple brass voices (detuned for section)\n            let detune = 0.004;\n            let v1 = saw_ar(freq * (1.0 - detune));\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * (1.0 + detune));\n\n            // Octave layer\n            let oct_up = saw_ar(freq * 2.0) * 0.3;\n\n            let section = (v1 + v2 + v3) * 0.35 + oct_up;\n\n            // Brass filter sweep (brighter with envelope)\n            let filter_env = envelope()\n                .asr(0.075, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let filter_freq = 800.0 + filter_env * 2500.0;\n\n            let brass = rlpf_ar(section, filter_freq, 0.3);\n\n            // Slight vibrato\n            let vib = sin_osc_ar(4.5) * 0.002 + 1.0;\n\n            brass * env * amp * vib\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/brass_section.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "french_horn",
    "description": "French horn with characteristic mellow, round tone.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"french_horn\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Slow swell envelope\n            let env = envelope()\n                .asr(0.2, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Mellow brass tone\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.002) * 0.4;\n\n            let tone = (saw1 + saw2) * 0.5;\n\n            // French horn formants (round, warm)\n            let f1 = rlpf_ar(tone, 350.0, 0.25) * 0.8;\n            let f2 = rlpf_ar(tone, 900.0, 0.3) * 0.6;\n            let f3 = rlpf_ar(tone, 1800.0, 0.35) * 0.3;\n\n            let brass = f1 + f2 + f3;\n\n            // Strong low pass for mellow sound\n            let mellow = lpf_ar(brass, 2500.0);\n\n            // Gentle vibrato\n            let vib = sin_osc_ar(4.5) * 0.005 + 1.0;\n\n            mellow * env * amp * vib * 0.8\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/french_horn.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "synth_brass",
    "description": "Classic synth brass stab with detuned saw waves.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "detune",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"synth_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"detune\", 0.5) // Detune amount\n        .body(|freq, amp, gate, detune| {\n            // Fast attack envelope\n            let env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned saws for fat sound\n            let detune_amt = 0.005 + detune * 0.01;\n            let saw1 = saw_ar(freq * (1.0 - detune_amt));\n            let saw2 = saw_ar(freq * (1.0 - detune_amt * 0.5));\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * (1.0 + detune_amt * 0.5));\n            let saw5 = saw_ar(freq * (1.0 + detune_amt));\n\n            let stack = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.25;\n\n            // Filter with envelope\n            let filter_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let filter_freq = 600.0 + filter_env * 3000.0;\n\n            let brass = rlpf_ar(stack, filter_freq, 0.4);\n\n            brass * env * amp\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/synth_brass.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "trombone",
    "description": "Trombone with characteristic warm tone and slide capability.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "slide",
        "default": "0.0"
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trombone\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"slide\", 0.0) // Slide amount (for glissando)\n        .body(|freq, amp, gate, slide| {\n            // Smooth attack envelope\n            let env = envelope()\n                .asr(0.1, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slide modulation (portamento effect)\n            let slide_mod = 1.0 + slide * 0.1;\n            let mod_freq = freq * slide_mod;\n\n            // Rich brass tone\n            let saw1 = saw_ar(mod_freq);\n            let saw2 = saw_ar(mod_freq * 0.999) * 0.6;\n\n            let tone = (saw1 + saw2) * 0.5;\n\n            // Trombone formants (warmer than trumpet)\n            let f1 = rlpf_ar(tone, 500.0, 0.3) * 0.6;\n            let f2 = rlpf_ar(tone, 1200.0, 0.3);\n            let f3 = rlpf_ar(tone, 2000.0, 0.25) * 0.4;\n\n            let brass = f1 + f2 + f3;\n\n            // Warm low pass\n            let warm = lpf_ar(brass, 3000.0);\n\n            // Slow vibrato\n            let vib = sin_osc_ar(4.0) * 0.006 + 1.0;\n\n            warm * env * amp * vib\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/trombone.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "trumpet",
    "description": "Solo trumpet with characteristic brightness and vibrato.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "brightness",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trumpet\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.7) // Filter brightness\n        .body(|freq, amp, gate, brightness| {\n            // Trumpet envelope with quick attack\n            let env = envelope()\n                .asr(0.05, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright sawtooth for brass\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.001) * 0.5;\n\n            let tone = (saw1 + saw2) * 0.6;\n\n            // Trumpet formants (brightness)\n            let f1 = rlpf_ar(tone, 1200.0, 0.3);\n            let f2 = rlpf_ar(tone, 2500.0, 0.25) * 0.5;\n            let f3 = rlpf_ar(tone, 3800.0, 0.2) * 0.3 * brightness;\n\n            let brass = f1 + f2 + f3;\n\n            // Attack transient (lip buzz)\n            let attack_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let buzz = white_noise_ar() * attack_env * 0.1;\n\n            // Vibrato\n            let vib_rate = 5.5;\n            let vib = sin_osc_ar(vib_rate) * 0.008 + 1.0;\n            let mod_freq = freq * vib;\n\n            (brass + buzz) * env * amp\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/trumpet.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "tuba",
    "description": "Deep tuba with full, round bass tone.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tuba\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Slow attack for tuba\n            let env = envelope()\n                .asr(0.15, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep brass tone\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.001) * 0.5;\n            let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n            let tone = (saw1 + saw2) * 0.4 + sub;\n\n            // Tuba formants (very warm)\n            let f1 = rlpf_ar(tone, 250.0, 0.3) * 0.8;\n            let f2 = rlpf_ar(tone, 600.0, 0.35) * 0.5;\n            let f3 = rlpf_ar(tone, 1200.0, 0.4) * 0.2;\n\n            let brass = f1 + f2 + f3;\n\n            // Heavy low pass\n            let deep = lpf_ar(brass, 2000.0);\n\n            deep * env * amp * 0.8\n        })\n});",
    "category": "brass",
    "subcategory": "",
    "path": "brass/tuba.vibe",
    "categoryName": "Brass"
  },
  {
    "name": "braam",
    "description": "Inception-style BRAAM",
    "genre": "Trailer, Epic",
    "character": "Inception-style BRAAM",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Trailer, Epic | Character: Inception-style BRAAM\ndefine_synthdef(\"braam\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Long, powerful decay\n        let amp_env = envelope()\n            .perc(0.05, 2.0)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.05, 1.5)\n            .build();\n\n        // Massive detuned oscillators\n        let osc1 = saw_ar(freq * 0.99) * 0.2;\n        let osc2 = saw_ar(freq) * 0.25;\n        let osc3 = saw_ar(freq * 1.01) * 0.2;\n        let osc4 = saw_ar(freq * 2.0) * 0.15;\n        let osc5 = saw_ar(freq * 0.5) * 0.2;\n\n        let mix = osc1 + osc2 + osc3 + osc4 + osc5;\n\n        // Powerful filter sweep\n        let cutoff = 200.0 + filt_env * 3000.0;\n        rlpf_ar(mix, cutoff, 0.2) * amp_env * amp\n    });\n",
    "category": "cinematic",
    "subcategory": "",
    "path": "cinematic/braam.vibe",
    "categoryName": "Cinematic"
  },
  {
    "name": "drone_tension",
    "description": "Tension drone",
    "genre": "Horror, Thriller",
    "character": "Tension drone",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Horror, Thriller | Character: Tension drone\ndefine_synthdef(\"drone_tension\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(1.0, 1.0, 1.0)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow, unsettling modulation\n        let mod1 = sin_osc_ar(0.1) * freq * 0.02;\n        let mod2 = sin_osc_ar(0.07) * freq * 0.015;\n\n        // Dissonant tones\n        let tone1 = sin_osc_ar(freq + mod1) * 0.3;\n        let tone2 = sin_osc_ar(freq * 1.05 + mod2) * 0.2;\n        let tone3 = sin_osc_ar(freq * 0.98) * 0.25;\n\n        // Rumble\n        let rumble = lpf_ar(pink_noise_ar(), 80.0) * 0.15;\n\n        let sig = tone1 + tone2 + tone3 + rumble;\n\n        lpf_ar(sig, 800.0) * env * amp\n    });\n",
    "category": "cinematic",
    "subcategory": "",
    "path": "cinematic/drone_tension.vibe",
    "categoryName": "Cinematic"
  },
  {
    "name": "impact_cinematic",
    "description": "Massive cinematic impact hit",
    "genre": "Trailer, Film",
    "character": "Massive cinematic impact hit",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Trailer, Film | Character: Massive cinematic impact hit\ndefine_synthdef(\"impact_cinematic\")\n    .param(\"freq\", 40.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Impact envelope\n        let amp_env = envelope()\n            .perc(0.001, 1.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch drop\n        let pitch_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n        let freq_mod = pitch_env * freq * 3.0;\n\n        // Sub impact\n        let sub = sin_osc_ar(freq + freq_mod) * 0.6;\n\n        // Noise burst\n        let noise_env = envelope()\n            .perc(0.001, 0.3)\n            .build();\n        let noise = lpf_ar(white_noise_ar(), 500.0) * noise_env * 0.4;\n\n        // Metallic ring\n        let ring = sin_osc_ar(freq * 4.0) * 0.15;\n\n        (sub + noise + ring) * amp_env * amp\n    });\n",
    "category": "cinematic",
    "subcategory": "",
    "path": "cinematic/impact_cinematic.vibe",
    "categoryName": "Cinematic"
  },
  {
    "name": "whoosh_tonal",
    "description": "Tonal whoosh/flyby",
    "genre": "Sound Design, Trailer",
    "character": "Tonal whoosh/flyby",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Sound Design, Trailer | Character: Tonal whoosh/flyby\ndefine_synthdef(\"whoosh_tonal\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.7)\n    .param(\"length\", 0.5)\n    .body(|freq, amp, length| {\n        // Whoosh envelope\n        let amp_env = envelope()\n            .perc(0.3, 0.7)\n            .time_scale(length)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch sweep\n        let pitch_env = envelope()\n            .perc(0.01, 1.0)\n            .time_scale(length)\n            .build();\n        let sweep_freq = freq * 0.5 + pitch_env * freq * 2.0;\n\n        // Tonal component\n        let tone = sin_osc_ar(sweep_freq) * 0.4;\n\n        // Noise whoosh\n        let noise = bpf_ar(white_noise_ar(), sweep_freq * 2.0, 0.3) * 0.5;\n\n        (tone + noise) * amp_env * amp\n    });\n",
    "category": "cinematic",
    "subcategory": "",
    "path": "cinematic/whoosh_tonal.vibe",
    "categoryName": "Cinematic"
  },
  {
    "name": "break_amen",
    "description": "Amen break-style kit (combined hit)",
    "genre": "Jungle, Drum & Bass",
    "character": "Amen break-style kit (combined hit)",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Jungle, Drum & Bass | Character: Amen break-style kit (combined hit)\ndefine_synthdef(\"break_amen\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.9)\n    .param(\"type\", 0.0) // 0=kick, 0.5=snare, 1.0=hat\n    .body(|freq, amp, type_param| {\n        // Different envelopes based on type\n        let decay = 0.3 - type_param * 0.15;\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay)\n            .cleanup_on_finish()\n            .build();\n\n        // Kick component (more at type=0)\n        let kick_amount = 1.0 - type_param;\n        let kick_penv = envelope()\n            .perc(0.001, 0.04)\n            .build();\n        let kick = sin_osc_ar(60.0 + kick_penv * 200.0) * kick_amount * 0.6;\n\n        // Snare component (more at type=0.5)\n        let snare_amount = 1.0 - (type_param - 0.5).abs() * 2.0;\n        let snare_nenv = envelope()\n            .perc(0.001, 0.15)\n            .build();\n        let snare_body = sin_osc_ar(freq) * snare_amount * 0.3;\n        let snare_noise = hpf_ar(white_noise_ar(), 3000.0) * snare_nenv * snare_amount * 0.4;\n\n        // Hat component (more at type=1)\n        let hat = hpf_ar(white_noise_ar(), 8000.0) * type_param * 0.4;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.15;\n\n        (kick + snare_body + snare_noise + hat + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "breakbeats",
    "path": "drums/breakbeats/break_amen.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Breakbeats"
  },
  {
    "name": "break_funky",
    "description": "Funky Drummer-style kit sound",
    "genre": "Funk, Hip-hop",
    "character": "Funky Drummer-style kit sound",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Funk, Hip-hop | Character: Funky Drummer-style kit sound\ndefine_synthdef(\"break_funky\")\n    .param(\"freq\", 190.0)\n    .param(\"amp\", 0.85)\n    .param(\"type\", 0.0) // 0=kick, 0.5=snare, 1.0=hat\n    .body(|freq, amp, type_param| {\n        // Tight decay\n        let decay = 0.25 - type_param * 0.1;\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay)\n            .cleanup_on_finish()\n            .build();\n\n        // Kick\n        let kick_amount = 1.0 - type_param;\n        let kick_penv = envelope()\n            .perc(0.001, 0.035)\n            .build();\n        let kick = sin_osc_ar(55.0 + kick_penv * 150.0) * kick_amount * 0.65;\n\n        // Snare (funky, tight)\n        let snare_amount = 1.0 - (type_param - 0.5).abs() * 2.0;\n        let snare_body = sin_osc_ar(freq) * snare_amount * 0.3;\n        let snare_nenv = envelope()\n            .perc(0.001, 0.12)\n            .build();\n        let snare_noise = bpf_ar(white_noise_ar(), 4000.0, 0.5) * snare_nenv * snare_amount * 0.4;\n\n        // Hat (crisp)\n        let hat = hpf_ar(white_noise_ar(), 9000.0) * type_param * 0.35;\n\n        (kick + snare_body + snare_noise + hat) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "breakbeats",
    "path": "drums/breakbeats/break_funky.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Breakbeats"
  },
  {
    "name": "clap_808",
    "description": "Genre: Hip-hop, Trap | Character: Classic 808 clap, short and snappy",
    "genre": "Hip-hop, Trap",
    "character": "Classic 808 clap, short and snappy",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clap_808\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Three quick bursts for clap character\n            let burst1_env = envelope()\n                .perc(0.001, 0.025)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.012, 0.025)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.020, 0.025)\n                .cleanup_on_finish()\n                .build();\n\n            // Filtered noise\n            let noise = white_noise_ar();\n            let filtered = rlpf_ar(noise, 2500.0, 0.5);\n\n            // Combine bursts\n            let clap = filtered * (burst1_env + burst2_env * 0.8 + burst3_env * 0.6);\n\n            clap * amp\n        })\n});",
    "category": "drums",
    "subcategory": "claps",
    "path": "drums/claps/clap_808.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Claps"
  },
  {
    "name": "clap_crowd",
    "description": "Genre: Pop, Funk | Character: Multiple hands clapping, crowd-like",
    "genre": "Pop, Funk",
    "character": "Multiple hands clapping, crowd-like",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clap_crowd\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Many slightly offset bursts\n            let burst1_env = envelope()\n                .perc(0.001, 0.028)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.007, 0.028)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.013, 0.028)\n                .build();\n\n            let burst4_env = envelope()\n                .perc(0.019, 0.028)\n                .build();\n\n            let burst5_env = envelope()\n                .perc(0.025, 0.028)\n                .cleanup_on_finish()\n                .build();\n\n            // Warmer noise for natural character\n            let noise = pink_noise_ar();\n            let filtered = rlpf_ar(noise, 2200.0, 0.6);\n\n            let clap = filtered * (burst1_env + burst2_env * 0.9 + burst3_env * 0.8 +\n                                   burst4_env * 0.7 + burst5_env * 0.6);\n\n            clap * amp * 0.8\n        })\n});",
    "category": "drums",
    "subcategory": "claps",
    "path": "drums/claps/clap_crowd.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Claps"
  },
  {
    "name": "clap_filtered",
    "description": "Genre: Lo-fi, Experimental | Character: Heavily filtered, muffled",
    "genre": "Lo-fi, Experimental",
    "character": "Heavily filtered, muffled",
    "params": [
      {
        "name": "amp",
        "default": 1
      },
      {
        "name": "cutoff",
        "default": 1500
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clap_filtered\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .param(\"cutoff\", 1500.0)\n        .body(|amp, cutoff| {\n            // Three bursts\n            let burst1_env = envelope()\n                .perc(0.002, 0.028)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.015, 0.028)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.025, 0.028)\n                .cleanup_on_finish()\n                .build();\n\n            // Heavy filtering for lo-fi character\n            let noise = pink_noise_ar();\n            let filtered = lpf_ar(noise, cutoff);\n\n            let clap = filtered * (burst1_env + burst2_env * 0.8 + burst3_env * 0.6);\n\n            clap * amp\n        })\n});",
    "category": "drums",
    "subcategory": "claps",
    "path": "drums/claps/clap_filtered.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Claps"
  },
  {
    "name": "clap_handclap",
    "description": "Genre: Acoustic, Folk | Character: Natural hand clap sound",
    "genre": "Acoustic, Folk",
    "character": "Natural hand clap sound",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clap_handclap\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Two natural bursts\n            let burst1_env = envelope()\n                .perc(0.001, 0.022)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.011, 0.022)\n                .cleanup_on_finish()\n                .build();\n\n            // Natural frequency range\n            let noise = pink_noise_ar();\n            let filtered = rlpf_ar(noise, 2400.0, 0.6);\n\n            // Add body resonance\n            let body_env = envelope()\n                .perc(0.001, 0.018)\n                .build();\n            let body = sin_osc_ar(320.0) * body_env * 0.15;\n\n            let clap = filtered * (burst1_env + burst2_env * 0.8);\n\n            (clap + body) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "claps",
    "path": "drums/claps/clap_handclap.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Claps"
  },
  {
    "name": "clap_layered",
    "description": "Genre: Pop, EDM | Character: Layered, big stadium clap",
    "genre": "Pop, EDM",
    "character": "Layered, big stadium clap",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clap_layered\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Four bursts for thick character\n            let burst1_env = envelope()\n                .perc(0.001, 0.025)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.009, 0.025)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.016, 0.025)\n                .build();\n\n            let burst4_env = envelope()\n                .perc(0.022, 0.025)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple frequency bands\n            let noise = white_noise_ar();\n            let low = rlpf_ar(noise, 1200.0, 0.6) * 0.4;\n            let mid = rlpf_ar(noise, 2800.0, 0.5) * 0.7;\n            let high = hpf_ar(noise, 3500.0) * 0.5;\n\n            let mix = low + mid + high;\n            let clap = mix * (burst1_env + burst2_env * 0.85 + burst3_env * 0.7 + burst4_env * 0.55);\n\n            clap * amp * 0.7\n        })\n});",
    "category": "drums",
    "subcategory": "claps",
    "path": "drums/claps/clap_layered.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Claps"
  },
  {
    "name": "clap_lofi",
    "description": "Genre: Lo-fi Hip-hop | Character: Dusty, vintage clap",
    "genre": "Lo-fi Hip-hop",
    "character": "Dusty, vintage clap",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clap_lofi\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Soft, dusty bursts\n            let burst1_env = envelope()\n                .perc(0.003, 0.035)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.018, 0.035)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.030, 0.035)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise for warmth\n            let noise = pink_noise_ar();\n            let filtered = rlpf_ar(noise, 1800.0, 0.7);\n\n            // Add vinyl crackle\n            let crackle_env = burst1_env * 0.5;\n            let crackle = hpf_ar(white_noise_ar(), 7000.0) * crackle_env * 0.06;\n\n            let clap = filtered * (burst1_env + burst2_env * 0.8 + burst3_env * 0.65);\n\n            (clap + crackle) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "claps",
    "path": "drums/claps/clap_lofi.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Claps"
  },
  {
    "name": "clap_loose",
    "description": "Genre: Funk, Soul | Character: Loose, spread out clap",
    "genre": "Funk, Soul",
    "character": "Loose, spread out clap",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clap_loose\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Four bursts with larger timing spread\n            let burst1_env = envelope()\n                .perc(0.002, 0.032)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.018, 0.032)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.032, 0.032)\n                .build();\n\n            let burst4_env = envelope()\n                .perc(0.045, 0.032)\n                .cleanup_on_finish()\n                .build();\n\n            // Warm filtering\n            let noise = pink_noise_ar();\n            let filtered = rlpf_ar(noise, 2000.0, 0.6);\n\n            let clap = filtered * (burst1_env + burst2_env * 0.85 + burst3_env * 0.7 + burst4_env * 0.55);\n\n            clap * amp\n        })\n});",
    "category": "drums",
    "subcategory": "claps",
    "path": "drums/claps/clap_loose.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Claps"
  },
  {
    "name": "clap_reverb",
    "description": "Genre: Pop, EDM | Character: Big clap with reverb tail",
    "genre": "Pop, EDM",
    "character": "Big clap with reverb tail",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clap_reverb\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Multiple bursts\n            let burst1_env = envelope()\n                .perc(0.001, 0.022)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.010, 0.022)\n                .build();\n\n            let burst3_env = envelope()\n                .perc(0.018, 0.022)\n                .cleanup_on_finish()\n                .build();\n\n            // Filtered noise\n            let noise = white_noise_ar();\n            let filtered = rlpf_ar(noise, 2800.0, 0.5);\n            let dry_clap = filtered * (burst1_env + burst2_env * 0.8 + burst3_env * 0.6);\n\n            // Reverb tail envelope\n            let reverb_env = envelope()\n                .perc(0.02, 0.35)\n                .build();\n            let reverb = lpf_ar(filtered, 4000.0) * reverb_env * 0.3;\n\n            (dry_clap + reverb) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "claps",
    "path": "drums/claps/clap_reverb.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Claps"
  },
  {
    "name": "clap_short",
    "description": "Genre: Techno, House | Character: Tight, short clap",
    "genre": "Techno, House",
    "character": "Tight, short clap",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clap_short\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Two quick bursts for tight character\n            let burst1_env = envelope()\n                .perc(0.0005, 0.018)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.008, 0.018)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright filtered noise\n            let noise = white_noise_ar();\n            let filtered = hpf_ar(noise, 1800.0);\n\n            let clap = filtered * (burst1_env + burst2_env * 0.7);\n\n            clap * amp\n        })\n});",
    "category": "drums",
    "subcategory": "claps",
    "path": "drums/claps/clap_short.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Claps"
  },
  {
    "name": "clap_tight",
    "description": "Genre: Techno, Minimal | Character: Very tight, focused clap",
    "genre": "Techno, Minimal",
    "character": "Very tight, focused clap",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clap_tight\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Just two very short bursts\n            let burst1_env = envelope()\n                .perc(0.0003, 0.012)\n                .build();\n\n            let burst2_env = envelope()\n                .perc(0.006, 0.012)\n                .cleanup_on_finish()\n                .build();\n\n            // Focused filtering\n            let noise = white_noise_ar();\n            let filtered = rlpf_ar(noise, 2400.0, 0.3);\n\n            let clap = filtered * (burst1_env + burst2_env * 0.75);\n\n            clap * amp\n        })\n});",
    "category": "drums",
    "subcategory": "claps",
    "path": "drums/claps/clap_tight.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Claps"
  },
  {
    "name": "bell_ping",
    "description": "Genre: Jazz, Experimental | Character: Ride bell or cymbal ping",
    "genre": "Jazz, Experimental",
    "character": "Ride bell or cymbal ping",
    "params": [
      {
        "name": "freq",
        "default": 880
      },
      {
        "name": "amp",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bell_ping\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.7)\n        .body(|freq, amp| {\n            // Medium decay\n            let env = envelope()\n                .perc(0.001, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Clear bell tones with inharmonic partials\n            let bell1 = sin_osc_ar(freq) * 0.4;\n            let bell2 = sin_osc_ar(freq * 1.5) * 0.3;\n            let bell3 = sin_osc_ar(freq * 2.3) * 0.2;\n            let bell4 = sin_osc_ar(freq * 3.8) * 0.1;\n\n            let bells = bell1 + bell2 + bell3 + bell4;\n\n            // Metallic shimmer\n            let metal = saw_ar(freq * 4.5) * 0.15;\n\n            // Subtle attack noise\n            let attack_env = envelope()\n                .perc(0.0005, 0.008)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.1;\n\n            (bells + metal + attack) * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "cymbals",
    "path": "drums/cymbals/bell_ping.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Cymbals"
  },
  {
    "name": "china",
    "description": "Genre: Rock, Metal | Character: Trashy china cymbal with aggressive attack",
    "genre": "Rock, Metal",
    "character": "Trashy china cymbal with aggressive attack",
    "params": [
      {
        "name": "amp",
        "default": 0.75
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"china\", |builder| {\n    builder\n        .param(\"amp\", 0.75)\n        .body(|amp| {\n            // Medium-long decay\n            let env = envelope()\n                .perc(0.001, 1.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Very inharmonic, trashy frequencies\n            let metal1 = saw_ar(421.0) * 0.20;\n            let metal2 = saw_ar(687.0) * 0.19;\n            let metal3 = saw_ar(1134.0) * 0.18;\n            let metal4 = saw_ar(1798.0) * 0.16;\n            let metal5 = saw_ar(2611.0) * 0.13;\n            let metal6 = saw_ar(3589.0) * 0.10;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5 + metal6;\n\n            // Aggressive noise component\n            let noise = white_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 3500.0, 0.4) * 0.35;\n\n            let mix = metallic + filtered_noise;\n\n            // Slight low cut\n            let clean = hpf_ar(mix, 400.0);\n\n            clean * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "cymbals",
    "path": "drums/cymbals/china.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Cymbals"
  },
  {
    "name": "crash_bright",
    "description": "Genre: Rock, EDM | Character: Bright crash cymbal for builds and emphasis",
    "genre": "Rock, EDM",
    "character": "Bright crash cymbal for builds and emphasis",
    "params": [
      {
        "name": "amp",
        "default": 0.8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"crash_bright\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            // Long decay for crash\n            let env = envelope()\n                .perc(0.002, 2.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic inharmonic frequencies\n            let metal1 = saw_ar(487.0) * 0.2;\n            let metal2 = saw_ar(723.0) * 0.18;\n            let metal3 = saw_ar(1156.0) * 0.16;\n            let metal4 = saw_ar(1789.0) * 0.14;\n            let metal5 = saw_ar(2473.0) * 0.12;\n            let metal6 = saw_ar(3287.0) * 0.10;\n            let metal7 = saw_ar(4231.0) * 0.08;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5 + metal6 + metal7;\n\n            // Bright noise component\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(noise, 3000.0) * 0.3;\n\n            // Mix\n            let mix = metallic + filtered_noise;\n\n            // High-pass to remove mud\n            let clean = hpf_ar(mix, 500.0);\n\n            clean * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "cymbals",
    "path": "drums/cymbals/crash_bright.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Cymbals"
  },
  {
    "name": "crash_dark",
    "description": "Genre: Jazz, Ambient | Character: Dark, trashy crash cymbal",
    "genre": "Jazz, Ambient",
    "character": "Dark, trashy crash cymbal",
    "params": [
      {
        "name": "amp",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"crash_dark\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            // Long, sustained decay\n            let env = envelope()\n                .perc(0.003, 3.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Lower inharmonic frequencies for darker sound\n            let metal1 = saw_ar(312.0) * 0.22;\n            let metal2 = saw_ar(548.0) * 0.20;\n            let metal3 = saw_ar(834.0) * 0.18;\n            let metal4 = saw_ar(1211.0) * 0.16;\n            let metal5 = saw_ar(1689.0) * 0.12;\n            let metal6 = saw_ar(2278.0) * 0.08;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5 + metal6;\n\n            // Darker noise\n            let noise = pink_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 4500.0, 0.6) * 0.25;\n\n            let mix = metallic + filtered_noise;\n\n            // Less aggressive high-pass\n            let clean = hpf_ar(mix, 300.0);\n\n            clean * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "cymbals",
    "path": "drums/cymbals/crash_dark.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Cymbals"
  },
  {
    "name": "crash_reverse",
    "description": "Genre: Cinematic, EDM | Character: Reverse crash cymbal effect",
    "genre": "Cinematic, EDM",
    "character": "Reverse crash cymbal effect",
    "params": [
      {
        "name": "amp",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"crash_reverse\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            // Reverse envelope (builds up)\n            let env = envelope()\n                .perc(1.5, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic components\n            let metal1 = saw_ar(523.0) * 0.18;\n            let metal2 = saw_ar(897.0) * 0.17;\n            let metal3 = saw_ar(1421.0) * 0.16;\n            let metal4 = saw_ar(2134.0) * 0.14;\n            let metal5 = saw_ar(3012.0) * 0.12;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5;\n\n            // Reverse filter sweep\n            let filter_env = envelope()\n                .perc(1.2, 0.5)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 5000.0);\n\n            let filtered = lpf_ar(metallic, mod_cutoff);\n\n            // Add noise\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(noise, 3000.0) * 0.2;\n\n            (filtered + filtered_noise) * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "cymbals",
    "path": "drums/cymbals/crash_reverse.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Cymbals"
  },
  {
    "name": "crash_swell",
    "description": "Genre: Cinematic, Orchestral | Character: Crash with dynamic swell",
    "genre": "Cinematic, Orchestral",
    "character": "Crash with dynamic swell",
    "params": [
      {
        "name": "amp",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"crash_swell\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            // Build and decay envelope\n            let env = envelope()\n                .perc(0.3, 2.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic frequencies\n            let metal1 = saw_ar(456.0) * 0.18;\n            let metal2 = saw_ar(712.0) * 0.17;\n            let metal3 = saw_ar(1089.0) * 0.16;\n            let metal4 = saw_ar(1645.0) * 0.15;\n            let metal5 = saw_ar(2387.0) * 0.13;\n            let metal6 = saw_ar(3289.0) * 0.11;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5 + metal6;\n\n            // Dynamic filter for swell\n            let filter_env = envelope()\n                .perc(0.5, 2.5)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 4500.0);\n\n            let filtered = lpf_ar(metallic, mod_cutoff);\n\n            // Noise layer\n            let noise = pink_noise_ar();\n            let filtered_noise = hpf_ar(noise, 2000.0) * 0.2;\n\n            (filtered + filtered_noise) * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "cymbals",
    "path": "drums/cymbals/crash_swell.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Cymbals"
  },
  {
    "name": "ride",
    "description": "Genre: Jazz, Rock | Character: Ride cymbal for keeping time",
    "genre": "Jazz, Rock",
    "character": "Ride cymbal for keeping time",
    "params": [
      {
        "name": "amp",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"ride\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Medium decay\n            let env = envelope()\n                .perc(0.002, 1.2)\n                .cleanup_on_finish()\n                .build();\n\n            // Clear bell-like frequencies\n            let bell1 = sin_osc_ar(523.0) * 0.3;\n            let bell2 = sin_osc_ar(784.0) * 0.25;\n            let bell3 = sin_osc_ar(1047.0) * 0.15;\n\n            // Metallic wash\n            let metal1 = saw_ar(1456.0) * 0.12;\n            let metal2 = saw_ar(2134.0) * 0.10;\n            let metal3 = saw_ar(2987.0) * 0.08;\n\n            let tones = bell1 + bell2 + bell3;\n            let metallic = metal1 + metal2 + metal3;\n\n            // Subtle noise\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(noise, 4000.0) * 0.15;\n\n            let mix = tones + metallic + filtered_noise;\n\n            mix * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "cymbals",
    "path": "drums/cymbals/ride.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Cymbals"
  },
  {
    "name": "splash",
    "description": "Genre: All | Character: Small splash cymbal, quick and bright",
    "genre": "All",
    "character": "Small splash cymbal, quick and bright",
    "params": [
      {
        "name": "amp",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"splash\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            // Short decay\n            let env = envelope()\n                .perc(0.001, 0.5)\n                .cleanup_on_finish()\n                .build();\n\n            // High, bright metallic frequencies\n            let metal1 = saw_ar(1823.0) * 0.22;\n            let metal2 = saw_ar(2712.0) * 0.20;\n            let metal3 = saw_ar(3845.0) * 0.18;\n            let metal4 = saw_ar(5234.0) * 0.15;\n            let metal5 = saw_ar(6921.0) * 0.12;\n\n            let metallic = metal1 + metal2 + metal3 + metal4 + metal5;\n\n            // Bright noise splash\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(noise, 5000.0) * 0.25;\n\n            let mix = metallic + filtered_noise;\n\n            mix * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "cymbals",
    "path": "drums/cymbals/splash.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Cymbals"
  },
  {
    "name": "foley_book_drop",
    "description": "Book drop thump",
    "genre": "Experimental, Lo-fi",
    "character": "Book drop thump",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Experimental, Lo-fi | Character: Book drop thump\ndefine_synthdef(\"foley_book_drop\")\n    .param(\"freq\", 100.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Soft thump decay\n        let amp_env = envelope()\n            .perc(0.002, 0.18)\n            .cleanup_on_finish()\n            .build();\n\n        // Muffled thud\n        let pitch_env = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.2) * 0.5;\n\n        // Paper flutter\n        let paper_env = envelope()\n            .perc(0.01, 0.1)\n            .build();\n        let paper = bpf_ar(pink_noise_ar(), 2000.0, 0.8) * paper_env * 0.2;\n\n        // Impact\n        let impact_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let impact = lpf_ar(white_noise_ar(), 1500.0) * impact_env * 0.25;\n\n        (body + paper + impact) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "foley",
    "path": "drums/foley/foley_book_drop.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Foley"
  },
  {
    "name": "foley_bucket",
    "description": "Plastic bucket drum",
    "genre": "Street, Experimental",
    "character": "Plastic bucket drum",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Street, Experimental | Character: Plastic bucket drum\ndefine_synthdef(\"foley_bucket\")\n    .param(\"freq\", 180.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Plastic resonance\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitched body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.5) * 0.5;\n\n        // Plastic overtones\n        let overtone1 = sin_osc_ar(freq * 2.3) * 0.2;\n        let overtone2 = sin_osc_ar(freq * 3.7) * 0.1;\n\n        // Slap attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 2500.0, 0.4) * attack_env * 0.3;\n\n        (body + overtone1 + overtone2 + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "foley",
    "path": "drums/foley/foley_bucket.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Foley"
  },
  {
    "name": "foley_cardboard",
    "description": "Cardboard box as drum",
    "genre": "Experimental, Lo-fi",
    "character": "Cardboard box as drum",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Experimental, Lo-fi | Character: Cardboard box as drum\ndefine_synthdef(\"foley_cardboard\")\n    .param(\"freq\", 120.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Cardboard resonance\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Hollow body\n        let body = sin_osc_ar(freq) * 0.4;\n        let resonance = bpf_ar(white_noise_ar(), freq * 2.5, 0.3) * 0.3;\n\n        // Paper-y attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.02)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 3000.0) * attack_env * 0.35;\n\n        (body + resonance + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "foley",
    "path": "drums/foley/foley_cardboard.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Foley"
  },
  {
    "name": "foley_door_slam",
    "description": "Door slam impact",
    "genre": "Experimental, Sound Design",
    "character": "Door slam impact",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Experimental, Sound Design | Character: Door slam impact\ndefine_synthdef(\"foley_door_slam\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Impact decay\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Low thud\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.6;\n\n        // Wood resonance\n        let wood = bpf_ar(white_noise_ar(), 300.0, 0.3) * 0.25;\n\n        // Impact noise\n        let impact_env = envelope()\n            .perc(0.0001, 0.03)\n            .build();\n        let impact = lpf_ar(white_noise_ar(), 2000.0) * impact_env * 0.4;\n\n        (body + wood + impact) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "foley",
    "path": "drums/foley/foley_door_slam.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Foley"
  },
  {
    "name": "foley_pot_lid",
    "description": "Metal pot lid cymbal",
    "genre": "Experimental, Industrial",
    "character": "Metal pot lid cymbal",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Experimental, Industrial | Character: Metal pot lid cymbal\ndefine_synthdef(\"foley_pot_lid\")\n    .param(\"freq\", 800.0)\n    .param(\"amp\", 0.6)\n    .body(|freq, amp| {\n        // Metallic ring\n        let amp_env = envelope()\n            .perc(0.001, 0.6)\n            .cleanup_on_finish()\n            .build();\n\n        // Inharmonic metallic partials\n        let body = sin_osc_ar(freq) * 0.3;\n        let ring1 = sin_osc_ar(freq * 1.7) * 0.25;\n        let ring2 = sin_osc_ar(freq * 2.4) * 0.2;\n        let ring3 = sin_osc_ar(freq * 3.1) * 0.15;\n        let ring4 = sin_osc_ar(freq * 4.6) * 0.08;\n\n        // Hit attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 5000.0) * attack_env * 0.25;\n\n        (body + ring1 + ring2 + ring3 + ring4 + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "foley",
    "path": "drums/foley/foley_pot_lid.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Foley"
  },
  {
    "name": "hihat_808_closed",
    "description": "Classic 808 closed hihat, short and tight",
    "genre": "Hip-hop, Trap",
    "character": "Classic 808 closed hihat, short and tight",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Hip-hop, Trap | Character: Classic 808 closed hihat, short and tight\ndefine_synthdef(\"hihat_808_closed\")\n    .param(\"amp\", 1.0)\n    .body(|amp| {\n        // Very short envelope\n        let env = envelope()\n            .perc(0.0005, 0.04)\n            .cleanup_on_finish()\n            .build();\n\n        // Square wave oscillators for metallic character\n        let osc1 = saw_ar(315.0);\n        let osc2 = saw_ar(380.0);\n        let osc3 = saw_ar(445.0);\n        let osc4 = saw_ar(540.0);\n        let osc5 = saw_ar(620.0);\n        let osc6 = saw_ar(745.0);\n\n        let mix_osc = (osc1 + osc2 + osc3 + osc4 + osc5 + osc6) * 0.16;\n\n        // High-pass filter for brightness\n        let filtered = hpf_ar(mix_osc, 8000.0);\n\n        filtered * env * amp\n    });\n\n",
    "category": "drums",
    "subcategory": "hihats",
    "path": "drums/hihats/hihat_808_closed.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Hihats"
  },
  {
    "name": "hihat_808_open",
    "description": "Classic 808 open hihat, longer decay",
    "genre": "Hip-hop, Trap",
    "character": "Classic 808 open hihat, longer decay",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Hip-hop, Trap | Character: Classic 808 open hihat, longer decay\ndefine_synthdef(\"hihat_808_open\")\n    .param(\"amp\", 1.0)\n    .body(|amp| {\n        // Longer envelope for open character\n        let env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Square wave oscillators\n        let osc1 = saw_ar(315.0);\n        let osc2 = saw_ar(380.0);\n        let osc3 = saw_ar(445.0);\n        let osc4 = saw_ar(540.0);\n        let osc5 = saw_ar(620.0);\n        let osc6 = saw_ar(745.0);\n\n        let mix_osc = (osc1 + osc2 + osc3 + osc4 + osc5 + osc6) * 0.16;\n\n        // High-pass filter\n        let filtered = hpf_ar(mix_osc, 7000.0);\n\n        filtered * env * amp\n    });\n\n",
    "category": "drums",
    "subcategory": "hihats",
    "path": "drums/hihats/hihat_808_open.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Hihats"
  },
  {
    "name": "hihat_909_closed",
    "description": "Genre: House, Techno | Character: Classic 909 closed hihat, bright and crisp",
    "genre": "House, Techno",
    "character": "Classic 909 closed hihat, bright and crisp",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hihat_909_closed\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Short, tight envelope\n            let env = envelope()\n                .perc(0.0003, 0.05)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise base\n            let noise = white_noise_ar();\n\n            // Aggressive high-pass for 909 character\n            let filtered = hpf_ar(noise, 10000.0);\n\n            // Add slight resonance\n            let resonant = rlpf_ar(filtered, 12000.0, 0.3);\n\n            resonant * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "hihats",
    "path": "drums/hihats/hihat_909_closed.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Hihats"
  },
  {
    "name": "hihat_909_open",
    "description": "Genre: House, Techno | Character: Classic 909 open hihat with decay",
    "genre": "House, Techno",
    "character": "Classic 909 open hihat with decay",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hihat_909_open\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Medium-long envelope\n            let env = envelope()\n                .perc(0.001, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise\n            let noise = white_noise_ar();\n\n            // High-pass filter\n            let filtered = hpf_ar(noise, 9000.0);\n\n            // Band-pass for resonant character\n            let resonant = rlpf_ar(filtered, 11000.0, 0.4);\n\n            resonant * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "hihats",
    "path": "drums/hihats/hihat_909_open.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Hihats"
  },
  {
    "name": "hihat_dusty",
    "description": "Genre: Lo-fi Hip-hop | Character: Dusty, lo-fi texture",
    "genre": "Lo-fi Hip-hop",
    "character": "Dusty, lo-fi texture",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hihat_dusty\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Soft attack and medium decay\n            let env = envelope()\n                .perc(0.003, 0.12)\n                .cleanup_on_finish()\n                .build();\n\n            // Use pink noise for warmer character\n            let noise = pink_noise_ar();\n\n            // Gentle high-pass\n            let filtered = hpf_ar(noise, 4500.0);\n\n            // Roll off highs for dusty character\n            let rolled_off = lpf_ar(filtered, 8000.0);\n\n            rolled_off * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "hihats",
    "path": "drums/hihats/hihat_dusty.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Hihats"
  },
  {
    "name": "hihat_filtered",
    "description": "Genre: Lo-fi, Experimental | Character: Filtered, darker hihat",
    "genre": "Lo-fi, Experimental",
    "character": "Filtered, darker hihat",
    "params": [
      {
        "name": "amp",
        "default": 1
      },
      {
        "name": "cutoff",
        "default": 5000
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hihat_filtered\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .param(\"cutoff\", 5000.0)\n        .body(|amp, cutoff| {\n            // Medium envelope\n            let env = envelope()\n                .perc(0.001, 0.1)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise\n            let noise = white_noise_ar();\n\n            // Variable filter cutoff for darker/brighter character\n            let filtered = hpf_ar(noise, cutoff);\n\n            // Additional resonant filter\n            let resonant = rlpf_ar(filtered, cutoff * 1.5, 0.4);\n\n            resonant * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "hihats",
    "path": "drums/hihats/hihat_filtered.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Hihats"
  },
  {
    "name": "hihat_long",
    "description": "Genre: Ambient, Downtempo | Character: Long decay, washy",
    "genre": "Ambient, Downtempo",
    "character": "Long decay, washy",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hihat_long\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Long envelope for washy character\n            let env = envelope()\n                .perc(0.002, 0.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix of white and pink noise for texture\n            let white = white_noise_ar() * 0.6;\n            let pink = pink_noise_ar() * 0.4;\n            let noise = white + pink;\n\n            // Moderate high-pass\n            let filtered = hpf_ar(noise, 7000.0);\n\n            // Add shimmer with resonance\n            let shimmer = rlpf_ar(filtered, 10000.0, 0.5);\n\n            shimmer * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "hihats",
    "path": "drums/hihats/hihat_long.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Hihats"
  },
  {
    "name": "hihat_metallic",
    "description": "Genre: Experimental, IDM | Character: Metallic, inharmonic frequencies",
    "genre": "Experimental, IDM",
    "character": "Metallic, inharmonic frequencies",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hihat_metallic\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Medium envelope\n            let env = envelope()\n                .perc(0.0005, 0.08)\n                .cleanup_on_finish()\n                .build();\n\n            // Inharmonic frequency ratios for metallic character\n            let osc1 = saw_ar(287.0);\n            let osc2 = saw_ar(413.0);\n            let osc3 = saw_ar(571.0);\n            let osc4 = saw_ar(689.0);\n            let osc5 = saw_ar(823.0);\n            let osc6 = saw_ar(971.0);\n\n            let mix_osc = (osc1 + osc2 + osc3 + osc4 + osc5 + osc6) * 0.16;\n\n            // Band-pass for metallic ring\n            let filtered = rlpf_ar(mix_osc, 9000.0, 0.3);\n\n            filtered * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "hihats",
    "path": "drums/hihats/hihat_metallic.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Hihats"
  },
  {
    "name": "hihat_short",
    "description": "Genre: Techno, Minimal | Character: Very short, click-like",
    "genre": "Techno, Minimal",
    "character": "Very short, click-like",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hihat_short\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Very short envelope\n            let env = envelope()\n                .perc(0.0002, 0.025)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise\n            let noise = white_noise_ar();\n\n            // Extreme high-pass for click character\n            let filtered = hpf_ar(noise, 12000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "hihats",
    "path": "drums/hihats/hihat_short.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Hihats"
  },
  {
    "name": "hihat_splash",
    "description": "Genre: Rock, Jazz | Character: Splash cymbal, bright and long",
    "genre": "Rock, Jazz",
    "character": "Splash cymbal, bright and long",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hihat_splash\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Long, complex envelope\n            let env = envelope()\n                .perc(0.005, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix multiple noise colors for complex texture\n            let white = white_noise_ar() * 0.5;\n            let pink = pink_noise_ar() * 0.3;\n            let noise = white + pink;\n\n            // Multiple filter bands for complex spectrum\n            let high = hpf_ar(noise, 8000.0) * 0.7;\n            let mid = rlpf_ar(noise, 6000.0, 0.6) * 0.3;\n\n            let mix = high + mid;\n\n            mix * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "hihats",
    "path": "drums/hihats/hihat_splash.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Hihats"
  },
  {
    "name": "kick_808",
    "description": "Classic 808, deep sub bass with pitch decay",
    "genre": "Hip-hop, Trap",
    "character": "Classic 808, deep sub bass with pitch decay",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Hip-hop, Trap | Character: Classic 808, deep sub bass with pitch decay\ndefine_synthdef(\"kick_808\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Main amplitude envelope - 808 character (fixed at 0.5s decay)\n        let amp_env = envelope()\n            .perc(0.001, 0.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope - classic 808 pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let freq_mod = pitch_env * freq * 3.0;\n\n        // Main sine tone\n        let sig = sin_osc_ar(freq + freq_mod) * amp_env;\n\n        // Add subtle click for attack definition\n        let click_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let click = white_noise_ar() * click_env * 0.05;\n\n        (sig + click) * amp\n    });\n\n",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_808.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_909",
    "description": "Genre: House, Techno | Character: Classic 909, tight and punchy",
    "genre": "House, Techno",
    "character": "Classic 909, tight and punchy",
    "params": [
      {
        "name": "freq",
        "default": 65
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kick_909\", |builder| {\n    builder\n        .param(\"freq\", 65.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Tight amplitude envelope\n            let amp_env = envelope()\n                .perc(0.001, 0.25)\n                .cleanup_on_finish()\n                .build();\n\n            // Shorter pitch sweep than 808\n            let pitch_env = envelope()\n                .perc(0.001, 0.04)\n                .build();\n            let freq_mod = pitch_env * freq * 2.5;\n\n            // Main tone\n            let sig = sin_osc_ar(freq + freq_mod) * amp_env;\n\n            // More pronounced click for 909 character\n            let click_env = envelope()\n                .perc(0.0001, 0.008)\n                .build();\n            let click = white_noise_ar() * click_env * 0.15;\n\n            (sig + click) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_909.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_acoustic",
    "description": "Genre: Jazz, Acoustic | Character: Natural-sounding, warm",
    "genre": "Jazz, Acoustic",
    "character": "Natural-sounding, warm",
    "params": [
      {
        "name": "freq",
        "default": 80
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kick_acoustic\", |builder| {\n    builder\n        .param(\"freq\", 80.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Natural decay curve\n            let amp_env = envelope()\n                .perc(0.002, 0.4)\n                .cleanup_on_finish()\n                .build();\n\n            // Subtle pitch bend\n            let pitch_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n            let freq_mod = pitch_env * freq * 1.5;\n\n            // Mix of sine and triangle for warmth\n            let sig = sin_osc_ar(freq + freq_mod) * 0.7;\n            let harmonic = sin_osc_ar((freq + freq_mod) * 2.0) * 0.15;\n\n            // Noise component for beater attack\n            let noise_env = envelope()\n                .perc(0.001, 0.025)\n                .build();\n            let noise = white_noise_ar() * noise_env * 0.12;\n            let filtered_noise = lpf_ar(noise, 3000.0);\n\n            (sig + harmonic + filtered_noise) * amp_env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_acoustic.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_boomy",
    "description": "Room-y acoustic kick with natural boom",
    "genre": "Rock, Acoustic, Live",
    "character": "Room-y acoustic kick with natural boom",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Rock, Acoustic, Live | Character: Room-y acoustic kick with natural boom\ndefine_synthdef(\"kick_boomy\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Long, boomy decay\n        let amp_env = envelope()\n            .perc(0.002, 0.55)\n            .cleanup_on_finish()\n            .build();\n\n        // Natural pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let freq_mod = pitch_env * freq * 1.8;\n\n        // Main body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n\n        // Room resonance\n        let room = sin_osc_ar(freq * 0.5) * 0.2;\n\n        // Beater attack\n        let attack_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 1200.0, 0.5) * attack_env * 0.25;\n\n        (body + room + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_boomy.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_click",
    "description": "Punchy click kick for driving rhythms",
    "genre": "Tech House, Minimal",
    "character": "Punchy click kick for driving rhythms",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Tech House, Minimal | Character: Punchy click kick for driving rhythms\ndefine_synthdef(\"kick_click\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Tight decay\n        let amp_env = envelope()\n            .perc(0.001, 0.3)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.04)\n            .build();\n        let freq_mod = pitch_env * freq * 4.0;\n\n        // Body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n\n        // Prominent click\n        let click_env = envelope()\n            .perc(0.0001, 0.015)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 4000.0, 0.3) * click_env * 0.4;\n\n        (body + click) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_click.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_distorted",
    "description": "Genre: Industrial, Hardcore | Character: Heavy distortion, aggressive",
    "genre": "Industrial, Hardcore",
    "character": "Heavy distortion, aggressive",
    "params": [
      {
        "name": "freq",
        "default": 58
      },
      {
        "name": "amp",
        "default": 1
      },
      {
        "name": "drive",
        "default": 2.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kick_distorted\", |builder| {\n    builder\n        .param(\"freq\", 58.0)\n        .param(\"amp\", 1.0)\n        .param(\"drive\", 2.5)\n        .body(|freq, amp, drive| {\n            // Punchy envelope\n            let amp_env = envelope()\n                .perc(0.001, 0.28)\n                .cleanup_on_finish()\n                .build();\n\n            // Aggressive pitch sweep\n            let pitch_env = envelope()\n                .perc(0.001, 0.04)\n                .build();\n            let freq_mod = pitch_env * freq * 3.5;\n\n            // Main tone with overdrive\n            let sig = sin_osc_ar(freq + freq_mod) * drive;\n\n            // Hard clipping for distortion\n            let distorted = clip(sig, -0.6, 0.6);\n\n            // Add harmonics through filtering\n            let filtered = lpf_ar(distorted, 2000.0);\n\n            // Heavy click/noise\n            let click_env = envelope()\n                .perc(0.0001, 0.015)\n                .build();\n            let click = white_noise_ar() * click_env * 0.3;\n\n            (filtered + click) * amp_env * amp * 0.6\n        })\n});",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_distorted.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_dnb",
    "description": "Genre: Drum & Bass, Jungle | Character: Fast, tight, sub-focused",
    "genre": "Drum & Bass, Jungle",
    "character": "Fast, tight, sub-focused",
    "params": [
      {
        "name": "freq",
        "default": 70
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kick_dnb\", |builder| {\n    builder\n        .param(\"freq\", 70.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Very short envelope for fast BPM\n            let amp_env = envelope()\n                .perc(0.001, 0.15)\n                .cleanup_on_finish()\n                .build();\n\n            // Quick pitch sweep\n            let pitch_env = envelope()\n                .perc(0.0005, 0.025)\n                .build();\n            let freq_mod = pitch_env * freq * 2.0;\n\n            // Tight main tone\n            let sig = sin_osc_ar(freq + freq_mod);\n\n            // Sub layer for weight\n            let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.4;\n\n            // Sharp click for definition\n            let click_env = envelope()\n                .perc(0.0001, 0.006)\n                .build();\n            let click = white_noise_ar() * click_env * 0.2;\n\n            (sig + sub + click) * amp_env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_dnb.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_fm",
    "description": "Genre: Experimental, IDM | Character: FM-style harmonics, metallic",
    "genre": "Experimental, IDM",
    "character": "FM-style harmonics, metallic",
    "params": [
      {
        "name": "freq",
        "default": 60
      },
      {
        "name": "amp",
        "default": 1
      },
      {
        "name": "fm_amount",
        "default": 3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kick_fm\", |builder| {\n    builder\n        .param(\"freq\", 60.0)\n        .param(\"amp\", 1.0)\n        .param(\"fm_amount\", 3.0)\n        .body(|freq, amp, fm_amount| {\n            // Medium envelope\n            let amp_env = envelope()\n                .perc(0.001, 0.35)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope\n            let pitch_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n            let freq_mod = pitch_env * freq * 2.5;\n\n            // FM modulation envelope\n            let fm_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n\n            // Carrier and modulator\n            let modulator = sin_osc_ar((freq + freq_mod) * 1.5) * fm_env * freq * fm_amount;\n            let carrier = sin_osc_ar(freq + freq_mod + modulator);\n\n            // Click\n            let click_env = envelope()\n                .perc(0.0001, 0.006)\n                .build();\n            let click = white_noise_ar() * click_env * 0.1;\n\n            (carrier + click) * amp_env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_fm.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_gabber",
    "description": "Distorted, aggressive gabber kick",
    "genre": "Hardcore, Gabber",
    "character": "Distorted, aggressive gabber kick",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Hardcore, Gabber | Character: Distorted, aggressive gabber kick\ndefine_synthdef(\"kick_gabber\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 1.0)\n    .param(\"drive\", 4.0)\n    .body(|freq, amp, drive| {\n        // Long decay for that gabber punch\n        let amp_env = envelope()\n            .perc(0.001, 0.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Extended pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.12)\n            .build();\n        let freq_mod = pitch_env * freq * 8.0;\n\n        // Main body\n        let raw = sin_osc_ar(freq + freq_mod);\n\n        // Heavy distortion\n        let distorted = (raw * drive).tanh();\n\n        // Click\n        let click_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 3000.0, 0.5) * click_env * 0.3;\n\n        (distorted + click) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_gabber.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_jungle",
    "description": "Pitched, punchy jungle kick",
    "genre": "Jungle, Drum & Bass",
    "character": "Pitched, punchy jungle kick",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Jungle, Drum & Bass | Character: Pitched, punchy jungle kick\ndefine_synthdef(\"kick_jungle\")\n    .param(\"freq\", 70.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Short, punchy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Sharp pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let freq_mod = pitch_env * freq * 5.0;\n\n        // Punchy body\n        let body = sin_osc_ar(freq + freq_mod) * 0.85;\n\n        // Attack transient\n        let attack_env = envelope()\n            .perc(0.0001, 0.006)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 2000.0) * attack_env * 0.2;\n\n        (body + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_jungle.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_layered",
    "description": "Pre-layered kick stack with sub, mid, and click",
    "genre": "Modern Production",
    "character": "Pre-layered kick stack with sub, mid, and click",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Modern Production | Character: Pre-layered kick stack with sub, mid, and click\ndefine_synthdef(\"kick_layered\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 1.0)\n    .param(\"sub_level\", 0.6)\n    .param(\"click_level\", 0.5)\n    .body(|freq, amp, sub_level, click_level| {\n        // Main body envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Sub layer (long, deep)\n        let sub_env = envelope()\n            .perc(0.005, 0.5)\n            .build();\n        let sub = sin_osc_ar(freq * 0.5) * sub_env * sub_level * 0.5;\n\n        // Mid/punch layer\n        let punch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let punch_freq = freq + punch_env * freq * 4.0;\n        let punch = sin_osc_ar(punch_freq) * 0.6;\n\n        // Click layer\n        let click_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 3500.0, 0.4) * click_env * click_level * 0.4;\n\n        (sub + punch + click) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_layered.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_lofi",
    "description": "Warm, dusty lo-fi kick",
    "genre": "Lo-fi Hip-hop, Chillhop",
    "character": "Warm, dusty lo-fi kick",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Lo-fi Hip-hop, Chillhop | Character: Warm, dusty lo-fi kick\ndefine_synthdef(\"kick_lofi\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Soft decay\n        let amp_env = envelope()\n            .perc(0.003, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Gentle pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.06)\n            .build();\n        let freq_mod = pitch_env * freq * 2.0;\n\n        // Warm body with slight saturation\n        let raw = sin_osc_ar(freq + freq_mod);\n        let body = lpf_ar((raw * 1.2).tanh(), 2000.0) * 0.8;\n\n        // Soft attack\n        let attack_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 1500.0) * attack_env * 0.12;\n\n        (body + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_lofi.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_pitched",
    "description": "Genre: House, Melodic Techno | Character: Tonal kick with clear pitch",
    "genre": "House, Melodic Techno",
    "character": "Tonal kick with clear pitch",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kick_pitched\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Medium decay to hear pitch\n            let amp_env = envelope()\n                .perc(0.001, 0.35)\n                .cleanup_on_finish()\n                .build();\n\n            // Minimal pitch sweep to retain tonality\n            let pitch_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let freq_mod = pitch_env * freq * 0.8;\n\n            // Main tone with harmonic\n            let sig = sin_osc_ar(freq + freq_mod);\n            let harmonic = sin_osc_ar((freq + freq_mod) * 2.0) * 0.2;\n\n            // Light click\n            let click_env = envelope()\n                .perc(0.0001, 0.005)\n                .build();\n            let click = white_noise_ar() * click_env * 0.08;\n\n            (sig + harmonic + click) * amp_env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_pitched.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_punchy",
    "description": "Modern pop kick with controlled punch",
    "genre": "Pop, Modern",
    "character": "Modern pop kick with controlled punch",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Pop, Modern | Character: Modern pop kick with controlled punch\ndefine_synthdef(\"kick_punchy\")\n    .param(\"freq\", 52.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Controlled decay\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Tight pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.035)\n            .build();\n        let freq_mod = pitch_env * freq * 5.0;\n\n        // Punchy body\n        let body = sin_osc_ar(freq + freq_mod) * 0.85;\n\n        // Mid punch\n        let mid_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let mid = sin_osc_ar(freq * 2.5) * mid_env * 0.15;\n\n        // Click\n        let click_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 2800.0, 0.5) * click_env * 0.2;\n\n        (body + mid + click) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_punchy.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_reggaeton",
    "description": "Tight, punchy dembow-style kick",
    "genre": "Reggaeton, Dembow",
    "character": "Tight, punchy dembow-style kick",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Reggaeton, Dembow | Character: Tight, punchy dembow-style kick\ndefine_synthdef(\"kick_reggaeton\")\n    .param(\"freq\", 58.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Short, tight decay\n        let amp_env = envelope()\n            .perc(0.001, 0.28)\n            .cleanup_on_finish()\n            .build();\n\n        // Quick pitch drop\n        let pitch_env = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let freq_mod = pitch_env * freq * 4.5;\n\n        // Punchy body\n        let body = sin_osc_ar(freq + freq_mod) * 0.85;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 3000.0, 0.4) * attack_env * 0.2;\n\n        (body + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_reggaeton.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_soft",
    "description": "Genre: Ambient, Chillout | Character: Soft, gentle, minimal attack",
    "genre": "Ambient, Chillout",
    "character": "Soft, gentle, minimal attack",
    "params": [
      {
        "name": "freq",
        "default": 75
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kick_soft\", |builder| {\n    builder\n        .param(\"freq\", 75.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Gentle attack and decay\n            let amp_env = envelope()\n                .perc(0.01, 0.45)\n                .cleanup_on_finish()\n                .build();\n\n            // Subtle pitch movement\n            let pitch_env = envelope()\n                .perc(0.005, 0.06)\n                .build();\n            let freq_mod = pitch_env * freq * 1.2;\n\n            // Warm sine tone\n            let sig = sin_osc_ar(freq + freq_mod);\n\n            // Add subtle warmth with low harmonic\n            let harmonic = sin_osc_ar((freq + freq_mod) * 1.5) * 0.1;\n\n            // Very soft click - barely noticeable\n            let click_env = envelope()\n                .perc(0.002, 0.008)\n                .build();\n            let click = pink_noise_ar() * click_env * 0.03;\n            let filtered_click = lpf_ar(click, 4000.0);\n\n            (sig + harmonic + filtered_click) * amp_env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_soft.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_sub",
    "description": "Genre: Dubstep, Bass Music | Character: Pure sub bass, minimal harmonics",
    "genre": "Dubstep, Bass Music",
    "character": "Pure sub bass, minimal harmonics",
    "params": [
      {
        "name": "freq",
        "default": 40
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kick_sub\", |builder| {\n    builder\n        .param(\"freq\", 40.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Medium-long decay for sub presence\n            let amp_env = envelope()\n                .perc(0.005, 0.55)\n                .cleanup_on_finish()\n                .build();\n\n            // Gentle pitch sweep\n            let pitch_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let freq_mod = pitch_env * freq * 2.0;\n\n            // Pure sine wave for clean sub\n            let sig = sin_osc_ar(freq + freq_mod);\n\n            // Very minimal click - just for timing reference\n            let click_env = envelope()\n                .perc(0.0001, 0.002)\n                .build();\n            let click = white_noise_ar() * click_env * 0.02;\n            let filtered_click = lpf_ar(click, 8000.0);\n\n            (sig + filtered_click) * amp_env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_sub.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_techno_deep",
    "description": "Genre: Techno, Deep House | Character: Deep, sub-heavy, long decay",
    "genre": "Techno, Deep House",
    "character": "Deep, sub-heavy, long decay",
    "params": [
      {
        "name": "freq",
        "default": 45
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kick_techno_deep\", |builder| {\n    builder\n        .param(\"freq\", 45.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Longer envelope for techno groove\n            let amp_env = envelope()\n                .perc(0.005, 0.6)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope\n            let pitch_env = envelope()\n                .perc(0.001, 0.06)\n                .build();\n            let freq_mod = pitch_env * freq * 2.8;\n\n            // Main tone\n            let sig = sin_osc_ar(freq + freq_mod);\n\n            // Add sub harmonic for extra depth\n            let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.3;\n\n            // Minimal click\n            let click_env = envelope()\n                .perc(0.0001, 0.003)\n                .build();\n            let click = white_noise_ar() * click_env * 0.03;\n\n            (sig + sub + click) * amp_env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_techno_deep.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_techno_hard",
    "description": "Genre: Hard Techno, Industrial | Character: Aggressive, distorted, punchy",
    "genre": "Hard Techno, Industrial",
    "character": "Aggressive, distorted, punchy",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kick_techno_hard\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Sharp, aggressive envelope\n            let amp_env = envelope()\n                .perc(0.001, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Aggressive pitch sweep\n            let pitch_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let freq_mod = pitch_env * freq * 4.0;\n\n            // Main tone with more drive\n            let sig = sin_osc_ar(freq + freq_mod) * 1.5;\n\n            // Clip for distortion character\n            let distorted = clip(sig, -0.8, 0.8);\n\n            // Prominent click/noise layer\n            let click_env = envelope()\n                .perc(0.0001, 0.012)\n                .build();\n            let click = white_noise_ar() * click_env * 0.25;\n\n            (distorted + click) * amp_env * amp * 0.7\n        })\n});",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_techno_hard.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "kick_trap",
    "description": "Genre: Trap, Hip-hop | Character: Boomy 808-style with extra low end",
    "genre": "Trap, Hip-hop",
    "character": "Boomy 808-style with extra low end",
    "params": [
      {
        "name": "freq",
        "default": 50
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kick_trap\", |builder| {\n    builder\n        .param(\"freq\", 50.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Long, boomy envelope\n            let amp_env = envelope()\n                .perc(0.001, 0.7)\n                .cleanup_on_finish()\n                .build();\n\n            // Extended pitch sweep for trap character\n            let pitch_env = envelope()\n                .perc(0.001, 0.12)\n                .build();\n            let freq_mod = pitch_env * freq * 3.5;\n\n            // Main tone\n            let sig = sin_osc_ar(freq + freq_mod);\n\n            // Heavy sub layer\n            let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.5;\n\n            // Minimal click\n            let click_env = envelope()\n                .perc(0.0001, 0.004)\n                .build();\n            let click = white_noise_ar() * click_env * 0.04;\n\n            (sig + sub + click) * amp_env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "kicks",
    "path": "drums/kicks/kick_trap.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Kicks"
  },
  {
    "name": "agogo_high",
    "description": "High-pitched agogo bell",
    "genre": "Brazilian, Samba, Latin",
    "character": "High-pitched agogo bell",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Brazilian, Samba, Latin | Character: High-pitched agogo bell\ndefine_synthdef(\"agogo_high\")\n    .param(\"freq\", 900.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Metallic ring decay\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Bell harmonics\n        let body = sin_osc_ar(freq) * 0.5;\n        let ring1 = sin_osc_ar(freq * 2.4) * 0.25;\n        let ring2 = sin_osc_ar(freq * 3.8) * 0.15;\n        let ring3 = sin_osc_ar(freq * 5.2) * 0.08;\n\n        // Stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.002)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 4000.0) * attack_env * 0.2;\n\n        (body + ring1 + ring2 + ring3 + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/agogo_high.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "agogo_low",
    "description": "Low-pitched agogo bell",
    "genre": "Brazilian, Samba, Latin",
    "character": "Low-pitched agogo bell",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Brazilian, Samba, Latin | Character: Low-pitched agogo bell\ndefine_synthdef(\"agogo_low\")\n    .param(\"freq\", 600.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Longer metallic decay\n        let amp_env = envelope()\n            .perc(0.001, 0.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Bell harmonics\n        let body = sin_osc_ar(freq) * 0.55;\n        let ring1 = sin_osc_ar(freq * 2.3) * 0.22;\n        let ring2 = sin_osc_ar(freq * 3.6) * 0.12;\n\n        // Stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 6000.0) * attack_env * 0.18;\n\n        (body + ring1 + ring2 + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/agogo_low.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "berimbau",
    "description": "Musical bow with gourd resonator",
    "genre": "Brazilian, Capoeira",
    "character": "Musical bow with gourd resonator",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Brazilian, Capoeira | Character: Musical bow with gourd resonator\ndefine_synthdef(\"berimbau\")\n    .param(\"freq\", 120.0)\n    .param(\"amp\", 0.7)\n    .param(\"open\", 1.0)\n    .body(|freq, amp, open| {\n        // Decay length based on open/closed\n        let decay_time = 0.2 + (open * 0.4);\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay_time)\n            .cleanup_on_finish()\n            .build();\n\n        // Wire string with harmonics\n        let body = sin_osc_ar(freq) * 0.5;\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.25;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.15;\n        let harm3 = sin_osc_ar(freq * 4.0) * 0.08;\n\n        // Gourd resonance (filter based on open/closed)\n        let cutoff = 400.0 + (open * 2000.0);\n        let resonated = lpf_ar(body + harm1 + harm2 + harm3, cutoff);\n\n        // Stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 2000.0, 0.5) * attack_env * 0.2;\n\n        (resonated + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/berimbau.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "bongo_high",
    "description": "Bright, crisp bongo with sharp attack",
    "genre": "Latin, Cuban, World",
    "character": "Bright, crisp bongo with sharp attack",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Cuban, World | Character: Bright, crisp bongo with sharp attack\ndefine_synthdef(\"bongo_high\")\n    .param(\"freq\", 500.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Short decay\n        let amp_env = envelope()\n            .perc(0.001, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch bend\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let freq_mod = pitch_env * freq * 3.0;\n\n        // Bright tone\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let overtone1 = sin_osc_ar((freq + freq_mod) * 2.3) * 0.25;\n        let overtone2 = sin_osc_ar((freq + freq_mod) * 3.7) * 0.1;\n\n        // Crisp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 3000.0) * attack_env * 0.15;\n\n        (body + overtone1 + overtone2 + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/bongo_high.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "bongo_low",
    "description": "Deeper bongo with warm tone",
    "genre": "Latin, Cuban, World",
    "character": "Deeper bongo with warm tone",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Cuban, World | Character: Deeper bongo with warm tone\ndefine_synthdef(\"bongo_low\")\n    .param(\"freq\", 350.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Medium decay\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let freq_mod = pitch_env * freq * 2.0;\n\n        // Warm body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n        let overtone = sin_osc_ar((freq + freq_mod) * 2.1) * 0.2;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.006)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 4000.0) * attack_env * 0.12;\n\n        (body + overtone + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/bongo_low.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "cabasa",
    "description": "Metal beads against shell texture",
    "genre": "Latin, Brazilian, Samba",
    "character": "Metal beads against shell texture",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Brazilian, Samba | Character: Metal beads against shell texture\ndefine_synthdef(\"cabasa\")\n    .param(\"freq\", 7000.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        // Short, swishing envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Bead rattle texture\n        let rattle_rate = 80.0;\n        let rattle = sin_osc_ar(rattle_rate) * 0.3 + 0.7;\n\n        // High-frequency metallic noise\n        let beads = hpf_ar(white_noise_ar(), freq);\n        let body = bpf_ar(white_noise_ar(), freq * 0.6, 0.5) * 0.4;\n\n        (beads + body) * rattle * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/cabasa.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "cajon",
    "description": "Wooden box drum bass tone",
    "genre": "Flamenco, Latin, Acoustic",
    "character": "Wooden box drum bass tone",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Flamenco, Latin, Acoustic | Character: Wooden box drum bass tone\ndefine_synthdef(\"cajon\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Wood resonance decay\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.04)\n            .build();\n        let freq_mod = pitch_env * freq * 1.5;\n\n        // Bass body\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.2;\n\n        // Wood character\n        let wood_env = envelope()\n            .perc(0.001, 0.1)\n            .build();\n        let wood = bpf_ar(white_noise_ar(), 400.0, 0.3) * wood_env * 0.25;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 2000.0) * attack_env * 0.2;\n\n        (body + sub + wood + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/cajon.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "cajon_slap",
    "description": "Cajon slap/edge hit with snare wires",
    "genre": "Flamenco, Latin, Acoustic",
    "character": "Cajon slap/edge hit with snare wires",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Flamenco, Latin, Acoustic | Character: Cajon slap/edge hit with snare wires\ndefine_synthdef(\"cajon_slap\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Short, snappy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Higher pitched slap\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.4;\n\n        // Snare wire buzz\n        let wire_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n        let wires = hpf_ar(white_noise_ar(), 3000.0) * wire_env * 0.3;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.35;\n\n        (body + wires + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/cajon_slap.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "conga_high",
    "description": "High-pitched conga slap with bright attack",
    "genre": "Latin, Salsa, Afro-Cuban",
    "character": "High-pitched conga slap with bright attack",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Salsa, Afro-Cuban | Character: High-pitched conga slap with bright attack\ndefine_synthdef(\"conga_high\")\n    .param(\"freq\", 350.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Main body envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope for that conga \"pop\"\n        let pitch_env = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let freq_mod = pitch_env * freq * 2.0;\n\n        // Main tone - combination of sine and resonant body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n        let overtone = sin_osc_ar((freq + freq_mod) * 2.1) * 0.2;\n        let click = sin_osc_ar((freq + freq_mod) * 3.5) * 0.1;\n\n        // Attack transient\n        let attack_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.15;\n\n        (body + overtone + click + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/conga_high.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "conga_low",
    "description": "Deep conga tone with warm resonance",
    "genre": "Latin, Salsa, Afro-Cuban",
    "character": "Deep conga tone with warm resonance",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Salsa, Afro-Cuban | Character: Deep conga tone with warm resonance\ndefine_synthdef(\"conga_low\")\n    .param(\"freq\", 180.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Longer decay for low conga\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 1.5;\n\n        // Warm body tone\n        let body = sin_osc_ar(freq + freq_mod) * 0.8;\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.15;\n        let overtone = sin_osc_ar((freq + freq_mod) * 2.0) * 0.1;\n\n        // Soft attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 2000.0) * attack_env * 0.1;\n\n        (body + sub + overtone + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/conga_low.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "conga_muted",
    "description": "Muted conga with short, dry attack",
    "genre": "Latin, Salsa, Afro-Cuban",
    "character": "Muted conga with short, dry attack",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Salsa, Afro-Cuban | Character: Muted conga with short, dry attack\ndefine_synthdef(\"conga_muted\")\n    .param(\"freq\", 260.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Very short decay for muted sound\n        let amp_env = envelope()\n            .perc(0.001, 0.08)\n            .cleanup_on_finish()\n            .build();\n\n        // Quick pitch drop\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let freq_mod = pitch_env * freq * 1.0;\n\n        // Dry, muted tone\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let click = sin_osc_ar((freq + freq_mod) * 2.5) * 0.3;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 1500.0) * attack_env * 0.2;\n\n        (body + click + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/conga_muted.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "cuica",
    "description": "Friction drum with squeaky voice-like quality",
    "genre": "Brazilian, Samba",
    "character": "Friction drum with squeaky voice-like quality",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Brazilian, Samba | Character: Friction drum with squeaky voice-like quality\ndefine_synthdef(\"cuica\")\n    .param(\"freq\", 400.0)\n    .param(\"amp\", 0.7)\n    .param(\"bend\", 200.0)\n    .body(|freq, amp, bend| {\n        // Envelope\n        let amp_env = envelope()\n            .perc(0.01, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch bend envelope for characteristic \"voice\"\n        let bend_env = envelope()\n            .perc(0.01, 0.2)\n            .build();\n        let pitch = freq + (bend_env * bend);\n\n        // Main tone with slight instability\n        let wobble = sin_osc_ar(8.0) * 5.0;\n        let body = sin_osc_ar(pitch + wobble) * 0.7;\n        let overtone = sin_osc_ar((pitch + wobble) * 2.0) * 0.2;\n\n        // Friction texture\n        let friction = lpf_ar(white_noise_ar(), 1500.0) * 0.1;\n\n        (body + overtone + friction) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/cuica.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "guiro",
    "description": "Scraped guiro with ridged texture",
    "genre": "Latin, Caribbean, World",
    "character": "Scraped guiro with ridged texture",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Caribbean, World | Character: Scraped guiro with ridged texture\ndefine_synthdef(\"guiro\")\n    .param(\"freq\", 3000.0)\n    .param(\"amp\", 0.6)\n    .param(\"length\", 0.3)\n    .body(|freq, amp, length| {\n        // Scraping duration envelope\n        let amp_env = envelope()\n            .perc(0.01, 1.0)\n            .time_scale(length)\n            .cleanup_on_finish()\n            .build();\n\n        // Ridged texture using amplitude modulation\n        let ridge_rate = 40.0;\n        let ridges = sin_osc_ar(ridge_rate) * 0.5 + 0.5;\n\n        // Filtered noise for scraping sound\n        let scrape = bpf_ar(white_noise_ar(), freq, 0.3);\n        let body = bpf_ar(white_noise_ar(), freq * 0.5, 0.5) * 0.3;\n\n        (scrape + body) * ridges * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/guiro.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "guiro_short",
    "description": "Short guiro accent",
    "genre": "Latin, Caribbean, World",
    "character": "Short guiro accent",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Caribbean, World | Character: Short guiro accent\ndefine_synthdef(\"guiro_short\")\n    .param(\"freq\", 3500.0)\n    .param(\"amp\", 0.6)\n    .body(|freq, amp| {\n        // Quick scrape\n        let amp_env = envelope()\n            .perc(0.005, 0.08)\n            .cleanup_on_finish()\n            .build();\n\n        // Fast ridges\n        let ridge_rate = 60.0;\n        let ridges = sin_osc_ar(ridge_rate) * 0.4 + 0.6;\n\n        // Bright scraping noise\n        let scrape = bpf_ar(white_noise_ar(), freq, 0.4);\n\n        scrape * ridges * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/guiro_short.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "maracas",
    "description": "Shaking maracas with seed rattle",
    "genre": "Latin, Caribbean, World",
    "character": "Shaking maracas with seed rattle",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Caribbean, World | Character: Shaking maracas with seed rattle\ndefine_synthdef(\"maracas\")\n    .param(\"freq\", 8000.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        // Quick shake envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.1)\n            .cleanup_on_finish()\n            .build();\n\n        // Seed rattle texture\n        let rattle = dust_ar(200.0) * 0.3 + 0.7;\n\n        // High-frequency noise\n        let seeds = hpf_ar(white_noise_ar(), freq);\n        let shell = bpf_ar(white_noise_ar(), 4000.0, 0.8) * 0.3;\n\n        (seeds + shell) * rattle * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/maracas.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "pandeiro",
    "description": "Brazilian tambourine with jingles",
    "genre": "Brazilian, Samba, Choro",
    "character": "Brazilian tambourine with jingles",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Brazilian, Samba, Choro | Character: Brazilian tambourine with jingles\ndefine_synthdef(\"pandeiro\")\n    .param(\"freq\", 300.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Medium decay\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Drum body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq) * 0.4;\n\n        // Jingles (high metallic)\n        let jingle_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n        let jingles = hpf_ar(white_noise_ar(), 6000.0) * jingle_env * 0.35;\n\n        // Attack transient\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + jingles + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/pandeiro.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "surdo",
    "description": "Deep bass drum with mallet attack",
    "genre": "Brazilian, Samba",
    "character": "Deep bass drum with mallet attack",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Brazilian, Samba | Character: Deep bass drum with mallet attack\ndefine_synthdef(\"surdo\")\n    .param(\"freq\", 60.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Long, boomy decay\n        let amp_env = envelope()\n            .perc(0.005, 0.6)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let freq_mod = pitch_env * freq * 1.5;\n\n        // Deep body\n        let body = sin_osc_ar(freq + freq_mod) * 0.8;\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.2;\n        let overtone = sin_osc_ar((freq + freq_mod) * 2.0) * 0.1;\n\n        // Mallet thump\n        let attack_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 800.0) * attack_env * 0.3;\n\n        (body + sub + overtone + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/surdo.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "timbale_high",
    "description": "Bright, ringing timbale with metallic overtones",
    "genre": "Latin, Salsa, Mambo",
    "character": "Bright, ringing timbale with metallic overtones",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Salsa, Mambo | Character: Bright, ringing timbale with metallic overtones\ndefine_synthdef(\"timbale_high\")\n    .param(\"freq\", 450.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Ringing decay\n        let amp_env = envelope()\n            .perc(0.001, 0.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.01)\n            .build();\n        let freq_mod = pitch_env * freq * 1.5;\n\n        // Metallic body with harmonics\n        let body = sin_osc_ar(freq + freq_mod) * 0.5;\n        let ring1 = sin_osc_ar((freq + freq_mod) * 2.5) * 0.25;\n        let ring2 = sin_osc_ar((freq + freq_mod) * 4.2) * 0.15;\n        let ring3 = sin_osc_ar((freq + freq_mod) * 5.8) * 0.08;\n\n        // Sharp metallic attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 5000.0) * attack_env * 0.2;\n\n        (body + ring1 + ring2 + ring3 + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/timbale_high.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "timbale_low",
    "description": "Deeper timbale with warm metallic ring",
    "genre": "Latin, Salsa, Mambo",
    "character": "Deeper timbale with warm metallic ring",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Salsa, Mambo | Character: Deeper timbale with warm metallic ring\ndefine_synthdef(\"timbale_low\")\n    .param(\"freq\", 280.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Long ringing decay\n        let amp_env = envelope()\n            .perc(0.001, 0.6)\n            .cleanup_on_finish()\n            .build();\n\n        // Subtle pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let freq_mod = pitch_env * freq * 1.2;\n\n        // Warm metallic body\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let ring1 = sin_osc_ar((freq + freq_mod) * 2.3) * 0.2;\n        let ring2 = sin_osc_ar((freq + freq_mod) * 3.8) * 0.1;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 6000.0) * attack_env * 0.15;\n\n        (body + ring1 + ring2 + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/timbale_low.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "timbale_rim",
    "description": "Cascara/rim pattern stick hit",
    "genre": "Latin, Salsa, Mambo",
    "character": "Cascara/rim pattern stick hit",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Latin, Salsa, Mambo | Character: Cascara/rim pattern stick hit\ndefine_synthdef(\"timbale_rim\")\n    .param(\"freq\", 800.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Short, tight decay\n        let amp_env = envelope()\n            .perc(0.0001, 0.12)\n            .cleanup_on_finish()\n            .build();\n\n        // High metallic ping\n        let body = sin_osc_ar(freq) * 0.4;\n        let ring1 = sin_osc_ar(freq * 2.7) * 0.3;\n        let ring2 = sin_osc_ar(freq * 4.1) * 0.2;\n\n        // Sharp stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.002)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 6000.0) * attack_env * 0.25;\n\n        (body + ring1 + ring2 + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "latin",
    "path": "drums/latin/timbale_rim.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Latin"
  },
  {
    "name": "cr78_kick",
    "description": "Roland CR-78 kick - warm, muted analog",
    "genre": "Vintage, New Wave, Synthpop",
    "character": "Roland CR-78 kick - warm, muted analog",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Vintage, New Wave, Synthpop | Character: Roland CR-78 kick - warm, muted analog\ndefine_synthdef(\"cr78_kick\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Soft, warm decay\n        let amp_env = envelope()\n            .perc(0.002, 0.3)\n            .cleanup_on_finish()\n            .build();\n\n        // Gentle pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 2.5;\n\n        // Warm sine body\n        let body = sin_osc_ar(freq + freq_mod);\n\n        // Soft attack\n        let attack_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 1000.0) * attack_env * 0.1;\n\n        (body + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/cr78_kick.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "cr78_snare",
    "description": "Roland CR-78 snare - lo-fi, filtered",
    "genre": "Vintage, New Wave, Synthpop",
    "character": "Roland CR-78 snare - lo-fi, filtered",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Vintage, New Wave, Synthpop | Character: Roland CR-78 snare - lo-fi, filtered\ndefine_synthdef(\"cr78_snare\")\n    .param(\"freq\", 180.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Vintage decay\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Body\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.5) * 0.35;\n\n        // Filtered noise\n        let noise_env = envelope()\n            .perc(0.001, 0.18)\n            .build();\n        let noise = bpf_ar(white_noise_ar(), 4000.0, 0.4) * noise_env * 0.5;\n\n        (body + noise) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/cr78_snare.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "dmx_kick",
    "description": "Oberheim DMX kick - tight, punchy",
    "genre": "80s Hip-hop, Electro",
    "character": "Oberheim DMX kick - tight, punchy",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: 80s Hip-hop, Electro | Character: Oberheim DMX kick - tight, punchy\ndefine_synthdef(\"dmx_kick\")\n    .param(\"freq\", 52.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Tight decay\n        let amp_env = envelope()\n            .perc(0.001, 0.32)\n            .cleanup_on_finish()\n            .build();\n\n        // Sharp pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 5.0;\n\n        // Punchy body\n        let body = sin_osc_ar(freq + freq_mod) * 0.85;\n\n        // Crisp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.006)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 1500.0) * attack_env * 0.15;\n\n        (body + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/dmx_kick.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "dmx_snare",
    "description": "Oberheim DMX snare - sharp, cutting",
    "genre": "80s Hip-hop, Electro",
    "character": "Oberheim DMX snare - sharp, cutting",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: 80s Hip-hop, Electro | Character: Oberheim DMX snare - sharp, cutting\ndefine_synthdef(\"dmx_snare\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Snappy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.22)\n            .cleanup_on_finish()\n            .build();\n\n        // Punchy body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.5) * 0.4;\n\n        // Bright noise\n        let noise_env = envelope()\n            .perc(0.001, 0.18)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 3500.0) * noise_env * 0.55;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/dmx_snare.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "linn_kick",
    "description": "LinnDrum kick - punchy, bright attack",
    "genre": "80s Pop, R&B, Hip-hop",
    "character": "LinnDrum kick - punchy, bright attack",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: 80s Pop, R&B, Hip-hop | Character: LinnDrum kick - punchy, bright attack\ndefine_synthdef(\"linn_kick\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Tight, punchy envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.06)\n            .build();\n        let freq_mod = pitch_env * freq * 4.0;\n\n        // Main tone\n        let body = sin_osc_ar(freq + freq_mod) * 0.8;\n\n        // Bright attack click\n        let click_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 2500.0, 0.5) * click_env * 0.25;\n\n        (body + click) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/linn_kick.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "linn_snare",
    "description": "LinnDrum snare - bright, crisp, sampled feel",
    "genre": "80s Pop, R&B, Hip-hop",
    "character": "LinnDrum snare - bright, crisp, sampled feel",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: 80s Pop, R&B, Hip-hop | Character: LinnDrum snare - bright, crisp, sampled feel\ndefine_synthdef(\"linn_snare\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Medium decay\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Body tone\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.4;\n\n        // Snare noise\n        let noise_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 2500.0) * noise_env * 0.5;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/linn_snare.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "machinedrum_kick",
    "description": "Elektron Machinedrum-style kick - digital, versatile",
    "genre": "IDM, Techno, Experimental",
    "character": "Elektron Machinedrum-style kick - digital, versatile",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: IDM, Techno, Experimental | Character: Elektron Machinedrum-style kick - digital, versatile\ndefine_synthdef(\"machinedrum_kick\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 1.0)\n    .param(\"shape\", 0.5)\n    .body(|freq, amp, shape| {\n        // Adjustable decay\n        let decay = 0.3 + shape * 0.2;\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope with shape control\n        let pitch_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(0.04 + shape * 0.04)\n            .build();\n        let freq_mod = pitch_env * freq * (2.5 + shape * 3.0);\n\n        // Body with waveshaping based on shape\n        let raw = sin_osc_ar(freq + freq_mod);\n        let body = (raw * (1.0 + shape)).tanh() * 0.8;\n\n        // Digital click\n        let click_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let click = hpf_ar(white_noise_ar(), 2000.0) * click_env * shape * 0.2;\n\n        (body + click) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/machinedrum_kick.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "machinedrum_snare",
    "description": "Elektron Machinedrum-style snare - digital, morphable",
    "genre": "IDM, Techno, Experimental",
    "character": "Elektron Machinedrum-style snare - digital, morphable",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: IDM, Techno, Experimental | Character: Elektron Machinedrum-style snare - digital, morphable\ndefine_synthdef(\"machinedrum_snare\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.9)\n    .param(\"metallic\", 0.4)\n    .body(|freq, amp, metallic| {\n        // Decay\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.35;\n\n        // Metallic ring (morphable)\n        let ring_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n        let ring = sin_osc_ar(freq * 3.7) * ring_env * metallic * 0.25;\n\n        // Noise\n        let noise_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 3000.0) * noise_env * (0.5 - metallic * 0.2);\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + ring + noise + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/machinedrum_snare.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "mpc_kick",
    "description": "MPC-style kick - clean, punchy",
    "genre": "Hip-hop, R&B, Production",
    "character": "MPC-style kick - clean, punchy",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Hip-hop, R&B, Production | Character: MPC-style kick - clean, punchy\ndefine_synthdef(\"mpc_kick\")\n    .param(\"freq\", 50.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Clean, tight decay\n        let amp_env = envelope()\n            .perc(0.001, 0.38)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.06)\n            .build();\n        let freq_mod = pitch_env * freq * 4.0;\n\n        // Clean body\n        let body = sin_osc_ar(freq + freq_mod) * 0.85;\n\n        // Subtle sub\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.1;\n\n        // Click\n        let click_env = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 2000.0, 0.6) * click_env * 0.15;\n\n        (body + sub + click) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/mpc_kick.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "mpc_snare",
    "description": "MPC-style snare - versatile, balanced",
    "genre": "Hip-hop, R&B, Production",
    "character": "MPC-style snare - versatile, balanced",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Hip-hop, R&B, Production | Character: MPC-style snare - versatile, balanced\ndefine_synthdef(\"mpc_snare\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Balanced decay\n        let amp_env = envelope()\n            .perc(0.001, 0.24)\n            .cleanup_on_finish()\n            .build();\n\n        // Body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.4;\n\n        // Noise\n        let noise_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 2800.0) * noise_env * 0.5;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.15;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/mpc_snare.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "sp1200_kick",
    "description": "E-mu SP-1200 kick - crunchy, 12-bit warmth",
    "genre": "90s Hip-hop, Boom Bap",
    "character": "E-mu SP-1200 kick - crunchy, 12-bit warmth",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: 90s Hip-hop, Boom Bap | Character: E-mu SP-1200 kick - crunchy, 12-bit warmth\ndefine_synthdef(\"sp1200_kick\")\n    .param(\"freq\", 48.0)\n    .param(\"amp\", 1.0)\n    .body(|freq, amp| {\n        // Punchy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.07)\n            .build();\n        let freq_mod = pitch_env * freq * 3.5;\n\n        // Main body with slight saturation (12-bit character)\n        let raw = sin_osc_ar(freq + freq_mod);\n        let body = (raw * 1.2).tanh() * 0.8;\n\n        // Sub layer\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.15;\n\n        // Crunchy click\n        let click_env = envelope()\n            .perc(0.0001, 0.012)\n            .build();\n        let click = lpf_ar(white_noise_ar(), 3000.0) * click_env * 0.2;\n\n        (body + sub + click) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/sp1200_kick.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "sp1200_snare",
    "description": "E-mu SP-1200 snare - gritty, lo-fi",
    "genre": "90s Hip-hop, Boom Bap",
    "character": "E-mu SP-1200 snare - gritty, lo-fi",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: 90s Hip-hop, Boom Bap | Character: E-mu SP-1200 snare - gritty, lo-fi\ndefine_synthdef(\"sp1200_snare\")\n    .param(\"freq\", 190.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Medium decay\n        let amp_env = envelope()\n            .perc(0.001, 0.28)\n            .cleanup_on_finish()\n            .build();\n\n        // Body with saturation\n        let pitch_env = envelope()\n            .perc(0.001, 0.025)\n            .build();\n        let raw_body = sin_osc_ar(freq + pitch_env * freq * 2.0);\n        let body = (raw_body * 1.3).tanh() * 0.35;\n\n        // Crunchy noise\n        let noise_env = envelope()\n            .perc(0.001, 0.22)\n            .build();\n        let raw_noise = bpf_ar(white_noise_ar(), 3500.0, 0.5);\n        let noise = (raw_noise * 1.5).tanh() * noise_env * 0.5;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.18;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/sp1200_snare.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "tempest_kick",
    "description": "DSI Tempest-style kick - modern analog, deep",
    "genre": "Electronic, Techno",
    "character": "DSI Tempest-style kick - modern analog, deep",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, Techno | Character: DSI Tempest-style kick - modern analog, deep\ndefine_synthdef(\"tempest_kick\")\n    .param(\"freq\", 48.0)\n    .param(\"amp\", 1.0)\n    .param(\"punch\", 0.7)\n    .body(|freq, amp, punch| {\n        // Deep decay\n        let amp_env = envelope()\n            .perc(0.001, 0.45)\n            .cleanup_on_finish()\n            .build();\n\n        // Aggressive pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(0.04 + punch * 0.03)\n            .build();\n        let freq_mod = pitch_env * freq * (3.0 + punch * 3.0);\n\n        // Thick analog body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.25;\n\n        // Punch click\n        let click_env = envelope()\n            .perc(0.0001, 0.006)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 2500.0, 0.4) * click_env * punch * 0.3;\n\n        (body + sub + click) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/tempest_kick.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "tempest_snare",
    "description": "DSI Tempest-style snare - analog synthesis",
    "genre": "Electronic, Techno",
    "character": "DSI Tempest-style snare - analog synthesis",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, Techno | Character: DSI Tempest-style snare - analog synthesis\ndefine_synthdef(\"tempest_snare\")\n    .param(\"freq\", 210.0)\n    .param(\"amp\", 0.9)\n    .param(\"tone\", 0.5)\n    .body(|freq, amp, tone| {\n        // Snappy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Body with tone control\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.5) * (0.3 + tone * 0.2);\n\n        // Noise layer\n        let noise_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 2500.0 + tone * 2000.0) * noise_env * (0.6 - tone * 0.2);\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.18;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/tempest_snare.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "volca_kick",
    "description": "Korg Volca Beats style kick - analog, characterful",
    "genre": "Electronic, Lo-fi",
    "character": "Korg Volca Beats style kick - analog, characterful",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, Lo-fi | Character: Korg Volca Beats style kick - analog, characterful\ndefine_synthdef(\"volca_kick\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 1.0)\n    .param(\"click\", 0.5)\n    .body(|freq, amp, click| {\n        // Analog-style decay\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 3.0;\n\n        // Analog body with slight waveshaping\n        let raw = sin_osc_ar(freq + freq_mod);\n        let body = (raw * 1.1).tanh() * 0.85;\n\n        // Variable click\n        let click_env = envelope()\n            .perc(0.0001, 0.01)\n            .build();\n        let click_sound = bpf_ar(white_noise_ar(), 1800.0, 0.5) * click_env * click * 0.3;\n\n        (body + click_sound) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/volca_kick.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "volca_snare",
    "description": "Korg Volca Beats style snare - analog, snappy",
    "genre": "Electronic, Lo-fi",
    "character": "Korg Volca Beats style snare - analog, snappy",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, Lo-fi | Character: Korg Volca Beats style snare - analog, snappy\ndefine_synthdef(\"volca_snare\")\n    .param(\"freq\", 180.0)\n    .param(\"amp\", 0.8)\n    .param(\"snappy\", 0.6)\n    .body(|freq, amp, snappy| {\n        // Decay envelope\n        let amp_env = envelope()\n            .perc(0.001, 0.22)\n            .cleanup_on_finish()\n            .build();\n\n        // Body\n        let pitch_env = envelope()\n            .perc(0.001, 0.018)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.8) * 0.35;\n\n        // Variable snappiness\n        let noise_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(0.15 + snappy * 0.1)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 2000.0 + snappy * 2000.0) * noise_env * (0.3 + snappy * 0.3);\n\n        (body + noise) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "machines",
    "path": "drums/machines/volca_snare.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Machines"
  },
  {
    "name": "clave",
    "description": "Genre: Latin, House | Character: Wooden clave, sharp and cutting",
    "genre": "Latin, House",
    "character": "Wooden clave, sharp and cutting",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clave\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Very short, tight envelope\n            let env = envelope()\n                .perc(0.0003, 0.025)\n                .cleanup_on_finish()\n                .build();\n\n            // High-pitched woody tones\n            let tone1 = saw_ar(2600.0) * 0.5;\n            let tone2 = saw_ar(3200.0) * 0.3;\n\n            let mix = tone1 + tone2;\n\n            // High-pass for brightness\n            let filtered = hpf_ar(mix, 2000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "percussion",
    "path": "drums/percussion/clave.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Percussion"
  },
  {
    "name": "cowbell",
    "description": "Genre: House, Latin | Character: Classic cowbell, bright and cutting",
    "genre": "House, Latin",
    "character": "Classic cowbell, bright and cutting",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"cowbell\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Medium-short decay\n            let env = envelope()\n                .perc(0.001, 0.12)\n                .cleanup_on_finish()\n                .build();\n\n            // Inharmonic frequencies for metallic bell character\n            let osc1 = saw_ar(540.0) * 0.4;\n            let osc2 = saw_ar(800.0) * 0.35;\n            let osc3 = saw_ar(1060.0) * 0.25;\n\n            let mix = osc1 + osc2 + osc3;\n\n            // Band-pass for bell resonance\n            let filtered = rlpf_ar(mix, 1200.0, 0.4);\n\n            // Add attack click\n            let click_env = envelope()\n                .perc(0.0001, 0.005)\n                .build();\n            let click = white_noise_ar() * click_env * 0.2;\n\n            (filtered + click) * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "percussion",
    "path": "drums/percussion/cowbell.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Percussion"
  },
  {
    "name": "rim",
    "description": "Genre: All | Character: Rim click/shot, sharp and metallic",
    "genre": "All",
    "character": "Rim click/shot, sharp and metallic",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"rim\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Very short, sharp envelope\n            let env = envelope()\n                .perc(0.0002, 0.035)\n                .cleanup_on_finish()\n                .build();\n\n            // High-frequency metallic tones\n            let tone1 = sin_osc_ar(850.0) * 0.4;\n            let tone2 = sin_osc_ar(1150.0) * 0.3;\n            let tone3 = sin_osc_ar(1420.0) * 0.2;\n\n            // Click component\n            let click = white_noise_ar();\n            let filtered_click = hpf_ar(click, 5000.0) * 0.4;\n\n            (tone1 + tone2 + tone3 + filtered_click) * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "percussion",
    "path": "drums/percussion/rim.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Percussion"
  },
  {
    "name": "shaker",
    "description": "Genre: Pop, Latin | Character: Shaker, bright and rattling",
    "genre": "Pop, Latin",
    "character": "Shaker, bright and rattling",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"shaker\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Very short, crisp envelope\n            let env = envelope()\n                .perc(0.001, 0.05)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright filtered noise\n            let noise = white_noise_ar();\n            let filtered = hpf_ar(noise, 7000.0);\n\n            // Add resonance for rattle\n            let resonant = rlpf_ar(filtered, 10000.0, 0.4);\n\n            resonant * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "percussion",
    "path": "drums/percussion/shaker.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Percussion"
  },
  {
    "name": "snap",
    "description": "Finger snap, quick and sharp",
    "genre": "Pop, R&B",
    "character": "Finger snap, quick and sharp",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Pop, R&B | Character: Finger snap, quick and sharp\ndefine_synthdef(\"snap\")\n    .param(\"amp\", 1.0)\n    .body(|amp| {\n        // Very short envelope\n        let env = envelope()\n            .perc(0.0003, 0.035)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright noise component\n        let noise = white_noise_ar();\n        let filtered_noise = hpf_ar(noise, 3000.0) * 0.6;\n\n        // Tonal component for body\n        let tone = sin_osc_ar(1200.0) * 0.4;\n\n        // Very sharp attack click\n        let click_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let click = white_noise_ar() * click_env * 0.3;\n\n        (filtered_noise + tone + click) * env * amp\n    });\n\n",
    "category": "drums",
    "subcategory": "percussion",
    "path": "drums/percussion/snap.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Percussion"
  },
  {
    "name": "tambourine",
    "description": "Genre: Pop, Rock | Character: Tambourine jingle, bright and sustained",
    "genre": "Pop, Rock",
    "character": "Tambourine jingle, bright and sustained",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tambourine\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Medium decay for jingle sustain\n            let env = envelope()\n                .perc(0.002, 0.18)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple metallic frequencies\n            let osc1 = saw_ar(6200.0) * 0.3;\n            let osc2 = saw_ar(7400.0) * 0.25;\n            let osc3 = saw_ar(8900.0) * 0.2;\n            let osc4 = saw_ar(10200.0) * 0.15;\n\n            let mix = osc1 + osc2 + osc3 + osc4;\n\n            // High-pass for brightness\n            let filtered = hpf_ar(mix, 5000.0);\n\n            // Add shimmer with band-pass\n            let shimmer = rlpf_ar(filtered, 9000.0, 0.5);\n\n            shimmer * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "percussion",
    "path": "drums/percussion/tambourine.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Percussion"
  },
  {
    "name": "tom_high",
    "description": "Genre: All | Character: High tom, resonant",
    "genre": "All",
    "character": "High tom, resonant",
    "params": [
      {
        "name": "freq",
        "default": 200
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tom_high\", |builder| {\n    builder\n        .param(\"freq\", 200.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Medium decay\n            let amp_env = envelope()\n                .perc(0.002, 0.25)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope for tom character\n            let pitch_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let freq_mod = pitch_env * freq * 1.5;\n\n            // Main tone\n            let tone = sin_osc_ar(freq + freq_mod);\n\n            // Add harmonics\n            let harmonic = sin_osc_ar((freq + freq_mod) * 1.5) * 0.2;\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.001, 0.015)\n                .build();\n            let attack = pink_noise_ar() * attack_env * 0.15;\n            let filtered_attack = lpf_ar(attack, 3000.0);\n\n            (tone + harmonic + filtered_attack) * amp_env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "percussion",
    "path": "drums/percussion/tom_high.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Percussion"
  },
  {
    "name": "tom_low",
    "description": "Genre: All | Character: Low tom, deep and resonant",
    "genre": "All",
    "character": "Low tom, deep and resonant",
    "params": [
      {
        "name": "freq",
        "default": 90
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tom_low\", |builder| {\n    builder\n        .param(\"freq\", 90.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Longer decay for low tom\n            let amp_env = envelope()\n                .perc(0.004, 0.4)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope\n            let pitch_env = envelope()\n                .perc(0.002, 0.12)\n                .build();\n            let freq_mod = pitch_env * freq * 1.8;\n\n            // Main tone\n            let tone = sin_osc_ar(freq + freq_mod);\n\n            // Rich harmonics for depth\n            let harmonic1 = sin_osc_ar((freq + freq_mod) * 1.3) * 0.3;\n            let harmonic2 = sin_osc_ar((freq + freq_mod) * 2.0) * 0.15;\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.002, 0.025)\n                .build();\n            let attack = pink_noise_ar() * attack_env * 0.2;\n            let filtered_attack = lpf_ar(attack, 2000.0);\n\n            (tone + harmonic1 + harmonic2 + filtered_attack) * amp_env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "percussion",
    "path": "drums/percussion/tom_low.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Percussion"
  },
  {
    "name": "tom_mid",
    "description": "Genre: All | Character: Mid tom, punchy",
    "genre": "All",
    "character": "Mid tom, punchy",
    "params": [
      {
        "name": "freq",
        "default": 140
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tom_mid\", |builder| {\n    builder\n        .param(\"freq\", 140.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Medium decay\n            let amp_env = envelope()\n                .perc(0.003, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch envelope\n            let pitch_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let freq_mod = pitch_env * freq * 1.6;\n\n            // Main tone\n            let tone = sin_osc_ar(freq + freq_mod);\n\n            // Harmonics for body\n            let harmonic1 = sin_osc_ar((freq + freq_mod) * 1.4) * 0.25;\n            let harmonic2 = sin_osc_ar((freq + freq_mod) * 2.1) * 0.1;\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let attack = pink_noise_ar() * attack_env * 0.18;\n            let filtered_attack = lpf_ar(attack, 2500.0);\n\n            (tone + harmonic1 + harmonic2 + filtered_attack) * amp_env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "percussion",
    "path": "drums/percussion/tom_mid.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Percussion"
  },
  {
    "name": "woodblock",
    "description": "Genre: Experimental, World | Character: Hollow wooden block",
    "genre": "Experimental, World",
    "character": "Hollow wooden block",
    "params": [
      {
        "name": "freq",
        "default": 800
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"woodblock\", |builder| {\n    builder\n        .param(\"freq\", 800.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Short, percussive envelope\n            let env = envelope()\n                .perc(0.0005, 0.045)\n                .cleanup_on_finish()\n                .build();\n\n            // Resonant frequencies for hollow character\n            let tone1 = sin_osc_ar(freq) * 0.5;\n            let tone2 = sin_osc_ar(freq * 1.8) * 0.3;\n            let tone3 = sin_osc_ar(freq * 2.4) * 0.2;\n\n            // Add filtered noise for wood texture\n            let noise = pink_noise_ar();\n            let filtered_noise = rlpf_ar(noise, freq * 3.0, 0.5) * 0.15;\n\n            (tone1 + tone2 + tone3 + filtered_noise) * env * amp\n        })\n});",
    "category": "drums",
    "subcategory": "percussion",
    "path": "drums/percussion/woodblock.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Percussion"
  },
  {
    "name": "snare_808",
    "description": "Classic 808 snare, short and snappy",
    "genre": "Hip-hop, Trap",
    "character": "Classic 808 snare, short and snappy",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Hip-hop, Trap | Character: Classic 808 snare, short and snappy\ndefine_synthdef(\"snare_808\")\n    .param(\"amp\", 1.0)\n    .body(|amp| {\n        // Noise component - short decay\n        let noise_env = envelope()\n            .perc(0.001, 0.12)\n            .cleanup_on_finish()\n            .build();\n        let noise = white_noise_ar();\n        let filtered_noise = hpf_ar(noise, 2000.0);\n        let snare_noise = filtered_noise * noise_env * 0.7;\n\n        // Tone component - metallic ring\n        let tone_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let tone = sin_osc_ar(180.0) * tone_env * 0.3;\n\n        (snare_noise + tone) * amp\n    });\n\n",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_808.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_909",
    "description": "Genre: House, Techno | Character: Classic 909, crisp and bright",
    "genre": "House, Techno",
    "character": "Classic 909, crisp and bright",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"snare_909\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Noise component - filtered white noise\n            let noise_env = envelope()\n                .perc(0.001, 0.18)\n                .cleanup_on_finish()\n                .build();\n            let noise = white_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 3500.0, 0.5);\n            let snare_noise = filtered_noise * noise_env;\n\n            // Tone components - two frequencies for body\n            let tone_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let tone1 = sin_osc_ar(185.0) * 0.3;\n            let tone2 = sin_osc_ar(330.0) * 0.2;\n            let tones = (tone1 + tone2) * tone_env;\n\n            (snare_noise * 0.8 + tones) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_909.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_acoustic",
    "description": "Genre: Jazz, Rock | Character: Natural acoustic snare with overtones",
    "genre": "Jazz, Rock",
    "character": "Natural acoustic snare with overtones",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"snare_acoustic\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Noise component - longer for acoustic character\n            let noise_env = envelope()\n                .perc(0.002, 0.25)\n                .cleanup_on_finish()\n                .build();\n            let noise = white_noise_ar();\n            // Less aggressive filtering for natural sound\n            let filtered_noise = rlpf_ar(noise, 5000.0, 0.6);\n            let snare_noise = filtered_noise * noise_env;\n\n            // Body tone - lower fundamental\n            let body_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n            let body = sin_osc_ar(200.0) * body_env * 0.25;\n\n            // Snare wires - higher harmonics\n            let wire_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n            let wires = (sin_osc_ar(320.0) * 0.15 + sin_osc_ar(480.0) * 0.1) * wire_env;\n\n            (snare_noise * 0.7 + body + wires) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_acoustic.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_brush",
    "description": "Brush snare with swishing texture",
    "genre": "Jazz, Acoustic",
    "character": "Brush snare with swishing texture",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Jazz, Acoustic | Character: Brush snare with swishing texture\ndefine_synthdef(\"snare_brush\")\n    .param(\"freq\", 180.0)\n    .param(\"amp\", 0.6)\n    .body(|freq, amp| {\n        // Soft decay\n        let amp_env = envelope()\n            .perc(0.005, 0.25)\n            .cleanup_on_finish()\n            .build();\n\n        // Subtle body\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.0) * 0.25;\n\n        // Brush swish texture\n        let swish_env = envelope()\n            .perc(0.01, 0.2)\n            .build();\n        let swish = bpf_ar(pink_noise_ar(), 4000.0, 0.6) * swish_env * 0.5;\n\n        // Wire buzz\n        let wire_env = envelope()\n            .perc(0.005, 0.15)\n            .build();\n        let wires = hpf_ar(white_noise_ar(), 5000.0) * wire_env * 0.2;\n\n        (body + swish + wires) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_brush.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_clap_snare",
    "description": "Genre: Hip-hop, Pop | Character: Snare with clap character, layered",
    "genre": "Hip-hop, Pop",
    "character": "Snare with clap character, layered",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"snare_clap_snare\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Clap layer - multiple short bursts\n            let clap_env1 = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let clap_env2 = envelope()\n                .perc(0.015, 0.03)\n                .build();\n            let clap_env3 = envelope()\n                .perc(0.025, 0.03)\n                .cleanup_on_finish()\n                .build();\n\n            let clap_noise = white_noise_ar();\n            let clap = hpf_ar(clap_noise, 1500.0) * (clap_env1 + clap_env2 * 0.7 + clap_env3 * 0.5);\n\n            // Snare layer\n            let snare_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n            let snare_noise = rlpf_ar(white_noise_ar(), 4000.0, 0.5) * snare_env;\n\n            // Tone\n            let tone_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let tone = sin_osc_ar(190.0) * tone_env * 0.2;\n\n            (clap * 0.5 + snare_noise * 0.6 + tone) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_clap_snare.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_filtered",
    "description": "Genre: Lo-fi, Experimental | Character: Heavily filtered, muffled",
    "genre": "Lo-fi, Experimental",
    "character": "Heavily filtered, muffled",
    "params": [
      {
        "name": "amp",
        "default": 1
      },
      {
        "name": "cutoff",
        "default": 1200
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"snare_filtered\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .param(\"cutoff\", 1200.0)\n        .body(|amp, cutoff| {\n            // Noise component with heavy filtering\n            let noise_env = envelope()\n                .perc(0.002, 0.18)\n                .cleanup_on_finish()\n                .build();\n            let noise = white_noise_ar();\n            // Heavy low-pass for muffled character\n            let filtered_noise = lpf_ar(noise, cutoff);\n            let snare_noise = filtered_noise * noise_env;\n\n            // Muted tone\n            let tone_env = envelope()\n                .perc(0.001, 0.12)\n                .build();\n            let tone = sin_osc_ar(160.0) * tone_env * 0.3;\n\n            (snare_noise * 0.8 + tone) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_filtered.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_garage",
    "description": "Snappy UK garage snare",
    "genre": "UK Garage, 2-Step",
    "character": "Snappy UK garage snare",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: UK Garage, 2-Step | Character: Snappy UK garage snare\ndefine_synthdef(\"snare_garage\")\n    .param(\"freq\", 210.0)\n    .param(\"amp\", 0.85)\n    .body(|freq, amp| {\n        // Short, snappy decay\n        let amp_env = envelope()\n            .perc(0.001, 0.16)\n            .cleanup_on_finish()\n            .build();\n\n        // Punchy body\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.5) * 0.4;\n\n        // Bright noise\n        let noise_env = envelope()\n            .perc(0.001, 0.12)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 4000.0) * noise_env * 0.5;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.22;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_garage.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_gated",
    "description": "Big gated reverb snare from the 80s",
    "genre": "80s Rock, Pop",
    "character": "Big gated reverb snare from the 80s",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: 80s Rock, Pop | Character: Big gated reverb snare from the 80s\ndefine_synthdef(\"snare_gated\")\n    .param(\"freq\", 190.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Medium decay with abrupt end (gated feel)\n        let amp_env = envelope()\n            .perc(0.001, 0.3)\n            .cleanup_on_finish()\n            .build();\n\n        // Body with pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.025)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 1.8) * 0.4;\n\n        // Sustained noise layer\n        let noise_env = envelope()\n            .perc(0.001, 0.28)\n            .build();\n        let noise = bpf_ar(white_noise_ar(), 3000.0, 0.5) * noise_env * 0.5;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_gated.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_jungle",
    "description": "Amen-break style snare with roll potential",
    "genre": "Jungle, Drum & Bass",
    "character": "Amen-break style snare with roll potential",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Jungle, Drum & Bass | Character: Amen-break style snare with roll potential\ndefine_synthdef(\"snare_jungle\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Tight decay\n        let amp_env = envelope()\n            .perc(0.001, 0.18)\n            .cleanup_on_finish()\n            .build();\n\n        // Body\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.5) * 0.35;\n\n        // Bright, cutting noise\n        let noise_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 3500.0) * noise_env * 0.55;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.25;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_jungle.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_layered",
    "description": "Genre: EDM, Pop | Character: Big, layered snare with depth",
    "genre": "EDM, Pop",
    "character": "Big, layered snare with depth",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"snare_layered\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Top layer - bright noise\n            let top_env = envelope()\n                .perc(0.001, 0.15)\n                .cleanup_on_finish()\n                .build();\n            let top = hpf_ar(white_noise_ar(), 4000.0) * top_env * 0.5;\n\n            // Mid layer - body\n            let mid_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n            let mid = rlpf_ar(white_noise_ar(), 2500.0, 0.5) * mid_env * 0.6;\n\n            // Bottom layer - tone\n            let bottom_env = envelope()\n                .perc(0.001, 0.12)\n                .build();\n            let bottom = sin_osc_ar(200.0) * bottom_env * 0.4;\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.0001, 0.005)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.3;\n\n            (top + mid + bottom + attack) * amp * 0.7\n        })\n});",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_layered.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_lofi",
    "description": "Genre: Lo-fi Hip-hop, Chillhop | Character: Dusty, lo-fi character with crackle",
    "genre": "Lo-fi Hip-hop, Chillhop",
    "character": "Dusty, lo-fi character with crackle",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"snare_lofi\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Main snare - filtered and soft\n            let snare_env = envelope()\n                .perc(0.003, 0.16)\n                .cleanup_on_finish()\n                .build();\n\n            // Use pink noise for warmer character\n            let noise = pink_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 2200.0, 0.6);\n            let snare_noise = filtered_noise * snare_env;\n\n            // Muted tone\n            let tone_env = envelope()\n                .perc(0.002, 0.11)\n                .build();\n            let tone = sin_osc_ar(175.0) * tone_env * 0.2;\n\n            // Vinyl crackle layer\n            let crackle_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let crackle = hpf_ar(white_noise_ar(), 6000.0) * crackle_env * 0.08;\n\n            (snare_noise * 0.7 + tone + crackle) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_lofi.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_loose_acoustic",
    "description": "Genre: Rock, Blues | Character: Loose, rattling acoustic snare",
    "genre": "Rock, Blues",
    "character": "Loose, rattling acoustic snare",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"snare_loose_acoustic\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Longer decay for loose character\n            let noise_env = envelope()\n                .perc(0.003, 0.35)\n                .cleanup_on_finish()\n                .build();\n            let noise = white_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 6000.0, 0.7);\n            let snare_noise = filtered_noise * noise_env;\n\n            // Body tone\n            let body_env = envelope()\n                .perc(0.002, 0.18)\n                .build();\n            let body = sin_osc_ar(195.0) * body_env * 0.2;\n\n            // Rattling snare wires - use LFNoise for texture\n            let wire_env = envelope()\n                .perc(0.002, 0.3)\n                .build();\n            let wires = hpf_ar(white_noise_ar(), 3000.0) * wire_env * 0.15;\n\n            (snare_noise * 0.6 + body + wires) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_loose_acoustic.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_marching",
    "description": "Tight marching snare with wire buzz",
    "genre": "Marching Band, Orchestral",
    "character": "Tight marching snare with wire buzz",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Marching Band, Orchestral | Character: Tight marching snare with wire buzz\ndefine_synthdef(\"snare_marching\")\n    .param(\"freq\", 250.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Tight, controlled decay\n        let amp_env = envelope()\n            .perc(0.001, 0.2)\n            .cleanup_on_finish()\n            .build();\n\n        // High-pitched body\n        let pitch_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * 0.35;\n\n        // Prominent wire buzz\n        let wire_env = envelope()\n            .perc(0.001, 0.18)\n            .build();\n        let wires = hpf_ar(white_noise_ar(), 4000.0) * wire_env * 0.5;\n\n        // Sharp stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.002)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.3;\n\n        (body + wires + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_marching.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_noise_layer",
    "description": "Pure noise snare layer for stacking",
    "genre": "Electronic, Production",
    "character": "Pure noise snare layer for stacking",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, Production | Character: Pure noise snare layer for stacking\ndefine_synthdef(\"snare_noise_layer\")\n    .param(\"freq\", 5000.0)\n    .param(\"amp\", 0.7)\n    .param(\"decay\", 0.2)\n    .body(|freq, amp, decay| {\n        // Adjustable decay\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay)\n            .cleanup_on_finish()\n            .build();\n\n        // Pure filtered noise\n        let noise = bpf_ar(white_noise_ar(), freq, 0.5);\n\n        // Attack transient\n        let attack_env = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (noise + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_noise_layer.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_piccolo",
    "description": "Genre: Funk, Pop | Character: High-pitched, tight piccolo snare",
    "genre": "Funk, Pop",
    "character": "High-pitched, tight piccolo snare",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"snare_piccolo\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Bright, short noise\n            let noise_env = envelope()\n                .perc(0.001, 0.08)\n                .cleanup_on_finish()\n                .build();\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(noise, 4000.0);\n            let snare_noise = filtered_noise * noise_env;\n\n            // High-pitched tone\n            let tone_env = envelope()\n                .perc(0.001, 0.06)\n                .build();\n            let tone = sin_osc_ar(280.0) * tone_env * 0.35;\n\n            // Crack/stick sound\n            let crack_env = envelope()\n                .perc(0.0005, 0.004)\n                .build();\n            let crack = white_noise_ar() * crack_env * 0.3;\n\n            (snare_noise * 0.7 + tone + crack) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_piccolo.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_pitched",
    "description": "Tunable synth snare with tonal body",
    "genre": "Electronic, Experimental",
    "character": "Tunable synth snare with tonal body",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, Experimental | Character: Tunable synth snare with tonal body\ndefine_synthdef(\"snare_pitched\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.8)\n    .param(\"tone\", 0.6)\n    .body(|freq, amp, tone| {\n        // Decay\n        let amp_env = envelope()\n            .perc(0.001, 0.22)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitched body with tone control\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let body = sin_osc_ar(freq + pitch_env * freq * 2.0) * tone * 0.5;\n\n        // Noise layer inversely proportional to tone\n        let noise_env = envelope()\n            .perc(0.001, 0.18)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 2500.0) * noise_env * (1.0 - tone * 0.5) * 0.5;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.004)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.15;\n\n        (body + noise + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_pitched.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_reverb",
    "description": "Genre: Ambient, Chillwave | Character: Snare with built-in reverb tail",
    "genre": "Ambient, Chillwave",
    "character": "Snare with built-in reverb tail",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"snare_reverb\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Main snare\n            let snare_env = envelope()\n                .perc(0.001, 0.13)\n                .cleanup_on_finish()\n                .build();\n            let snare_noise = rlpf_ar(white_noise_ar(), 3500.0, 0.5) * snare_env;\n            let tone = sin_osc_ar(210.0) * snare_env * 0.25;\n            let dry = snare_noise * 0.7 + tone;\n\n            // Reverb tail using delays\n            let delay1 = delay_l_ar(dry, 0.2, 0.037);\n            let delay2 = delay_l_ar(dry, 0.2, 0.041);\n            let delay3 = delay_l_ar(dry, 0.2, 0.053);\n            let delay4 = delay_l_ar(dry, 0.2, 0.067);\n\n            // Reverb envelope - longer tail\n            let reverb_env = envelope()\n                .perc(0.01, 0.4)\n                .build();\n            let reverb = (delay1 + delay2 + delay3 + delay4) * 0.15 * reverb_env;\n\n            (dry + reverb) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_reverb.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_rimshot",
    "description": "Genre: Latin, Reggaeton | Character: Rimshot, sharp and cutting",
    "genre": "Latin, Reggaeton",
    "character": "Rimshot, sharp and cutting",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"snare_rimshot\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Very short, sharp envelope\n            let rim_env = envelope()\n                .perc(0.0003, 0.04)\n                .cleanup_on_finish()\n                .build();\n\n            // High-frequency click\n            let click = white_noise_ar();\n            let filtered_click = hpf_ar(click, 6000.0);\n\n            // Metallic tone\n            let tone1 = sin_osc_ar(800.0) * 0.4;\n            let tone2 = sin_osc_ar(1200.0) * 0.3;\n            let tones = (tone1 + tone2) * rim_env;\n\n            (filtered_click * rim_env * 0.5 + tones) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_rimshot.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "snare_tight_electronic",
    "description": "Genre: Electro, Techno | Character: Tight, electronic, punchy",
    "genre": "Electro, Techno",
    "character": "Tight, electronic, punchy",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"snare_tight_electronic\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Short, controlled envelope\n            let noise_env = envelope()\n                .perc(0.001, 0.11)\n                .cleanup_on_finish()\n                .build();\n\n            // Filtered noise with resonance\n            let noise = white_noise_ar();\n            let filtered_noise = rlpf_ar(noise, 2800.0, 0.3);\n\n            // Punchy tone\n            let tone_env = envelope()\n                .perc(0.0005, 0.07)\n                .build();\n            let tone = sin_osc_ar(220.0) * tone_env * 0.4;\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.0001, 0.003)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.4;\n\n            (filtered_noise * noise_env + tone + attack) * amp\n        })\n});",
    "category": "drums",
    "subcategory": "snares",
    "path": "drums/snares/snare_tight_electronic.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Snares"
  },
  {
    "name": "tom_808",
    "description": "808 tom with pitch decay",
    "genre": "Hip-hop, Trap",
    "character": "808 tom with pitch decay",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Hip-hop, Trap | Character: 808 tom with pitch decay\ndefine_synthdef(\"tom_808\")\n    .param(\"freq\", 120.0)\n    .param(\"amp\", 0.85)\n    .body(|freq, amp| {\n        // 808 tom decay\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Classic 808 pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let freq_mod = pitch_env * freq * 2.5;\n\n        // Clean sine\n        let body = sin_osc_ar(freq + freq_mod);\n\n        body * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "toms",
    "path": "drums/toms/tom_808.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Toms"
  },
  {
    "name": "tom_concert",
    "description": "Concert tom with long resonance",
    "genre": "Orchestral, Cinematic",
    "character": "Concert tom with long resonance",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Orchestral, Cinematic | Character: Concert tom with long resonance\ndefine_synthdef(\"tom_concert\")\n    .param(\"freq\", 100.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Long resonant decay\n        let amp_env = envelope()\n            .perc(0.002, 0.6)\n            .cleanup_on_finish()\n            .build();\n\n        // Natural pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.04)\n            .build();\n        let freq_mod = pitch_env * freq * 1.2;\n\n        // Rich body with harmonics\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let harm1 = sin_osc_ar((freq + freq_mod) * 1.5) * 0.2;\n        let harm2 = sin_osc_ar((freq + freq_mod) * 2.0) * 0.1;\n\n        // Mallet attack\n        let attack_env = envelope()\n            .perc(0.001, 0.015)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 2500.0) * attack_env * 0.2;\n\n        (body + harm1 + harm2 + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "toms",
    "path": "drums/toms/tom_concert.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Toms"
  },
  {
    "name": "tom_floor",
    "description": "Deep floor tom",
    "genre": "Rock, Pop",
    "character": "Deep floor tom",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Rock, Pop | Character: Deep floor tom\ndefine_synthdef(\"tom_floor\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.85)\n    .body(|freq, amp| {\n        // Deep, resonant decay\n        let amp_env = envelope()\n            .perc(0.001, 0.5)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 1.5;\n\n        // Deep body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n        let sub = sin_osc_ar((freq + freq_mod) * 0.5) * 0.15;\n        let overtone = sin_osc_ar((freq + freq_mod) * 1.8) * 0.1;\n\n        // Stick attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.012)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 1500.0, 0.5) * attack_env * 0.2;\n\n        (body + sub + overtone + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "toms",
    "path": "drums/toms/tom_floor.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Toms"
  },
  {
    "name": "tom_roto",
    "description": "Rototom with tunable, sustained pitch",
    "genre": "70s Rock, Prog",
    "character": "Rototom with tunable, sustained pitch",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: 70s Rock, Prog | Character: Rototom with tunable, sustained pitch\ndefine_synthdef(\"tom_roto\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Medium sustain\n        let amp_env = envelope()\n            .perc(0.001, 0.35)\n            .cleanup_on_finish()\n            .build();\n\n        // Minimal pitch drop (rototom characteristic)\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let freq_mod = pitch_env * freq * 0.8;\n\n        // Clear, pitched body\n        let body = sin_osc_ar(freq + freq_mod) * 0.7;\n        let overtone = sin_osc_ar((freq + freq_mod) * 2.0) * 0.15;\n\n        // Sharp attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.006)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 3000.0) * attack_env * 0.18;\n\n        (body + overtone + attack) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "toms",
    "path": "drums/toms/tom_roto.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Toms"
  },
  {
    "name": "tom_synth",
    "description": "Synthetic electronic tom",
    "genre": "Electronic, Synthpop",
    "character": "Synthetic electronic tom",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, Synthpop | Character: Synthetic electronic tom\ndefine_synthdef(\"tom_synth\")\n    .param(\"freq\", 150.0)\n    .param(\"amp\", 0.8)\n    .body(|freq, amp| {\n        // Electronic decay\n        let amp_env = envelope()\n            .perc(0.001, 0.3)\n            .cleanup_on_finish()\n            .build();\n\n        // Dramatic pitch sweep\n        let pitch_env = envelope()\n            .perc(0.001, 0.1)\n            .build();\n        let freq_mod = pitch_env * freq * 3.0;\n\n        // Pure sine body\n        let body = sin_osc_ar(freq + freq_mod);\n\n        // Subtle click\n        let click_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let click = bpf_ar(white_noise_ar(), 2000.0, 0.5) * click_env * 0.15;\n\n        (body + click) * amp_env * amp\n    });\n",
    "category": "drums",
    "subcategory": "toms",
    "path": "drums/toms/tom_synth.vibe",
    "categoryName": "Drums",
    "subcategoryName": "Toms"
  },
  {
    "name": "analog_delay",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 0.3
      },
      {
        "name": "feedback",
        "default": 0.5
      },
      {
        "name": "tone",
        "default": 0.4
      },
      {
        "name": "mod_depth",
        "default": 0.3
      },
      {
        "name": "mix",
        "default": 0.4
      }
    ],
    "type": "fx",
    "source": "define_fx(\"analog_delay\", |builder| {\n    builder\n        .param(\"time\", 0.3)\n        .param(\"feedback\", 0.5)\n        .param(\"tone\", 0.4)\n        .param(\"mod_depth\", 0.3)\n        .param(\"mix\", 0.4)\n        .body(|input, time, feedback, tone, mod_depth, mix| {\n            // BBD-style modulation (clock instability)\n            let mod_lfo = sin_osc_ar(0.6) * mod_depth * 0.002;\n\n            // Modulated delay time\n            let mod_time = time + mod_lfo;\n\n            // Create the delay with feedback\n            // Simulating BBD's frequency response degradation\n            let delay_l = delay_c_ar(input[0], 2.0, mod_time);\n            let delay_r = delay_c_ar(input[1], 2.0, mod_time);\n\n            // Progressive filtering (each repeat darker)\n            let cutoff = 2000.0 + tone * 6000.0;\n            let filtered_l = lpf_ar(delay_l, cutoff);\n            let filtered_r = lpf_ar(delay_r, cutoff);\n\n            // Add subtle saturation (BBD compression)\n            let saturated_l = (filtered_l * 1.3).tanh();\n            let saturated_r = (filtered_r * 1.3).tanh();\n\n            // High-pass to remove DC and rumble\n            let cleaned_l = hpf_ar(saturated_l, 60.0);\n            let cleaned_r = hpf_ar(saturated_r, 60.0);\n\n            // Feedback path with additional filtering\n            let fb_l = delay_c_ar(cleaned_l * feedback, 2.0, mod_time);\n            let fb_r = delay_c_ar(cleaned_r * feedback, 2.0, mod_time);\n\n            let wet_l = cleaned_l + lpf_ar(fb_l, cutoff * 0.8) * feedback;\n            let wet_r = cleaned_r + lpf_ar(fb_r, cutoff * 0.8) * feedback;\n\n            [\n                (1.0 - mix) * input[0] + mix * wet_l,\n                (1.0 - mix) * input[1] + mix * wet_r\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "delays",
    "path": "effects/delays/analog_delay.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Delays"
  },
  {
    "name": "delay",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 0.25
      },
      {
        "name": "feedback",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"delay\", |builder| {\n    builder\n        .param(\"time\", 0.25)\n        .param(\"feedback\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, mix| {\n            // Simple stereo delay with feedback\n            let left_delayed = delay_n_ar(input[0] + (feedback * delay_n_ar(input[0], 2.0, time)), 2.0, time);\n            let right_delayed = delay_n_ar(input[1] + (feedback * delay_n_ar(input[1], 2.0, time)), 2.0, time);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * left_delayed,\n                (1.0 - mix) * input[1] + mix * right_delayed\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "delays",
    "path": "effects/delays/delay.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Delays"
  },
  {
    "name": "dub_delay",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 0.375
      },
      {
        "name": "feedback",
        "default": 0.7
      },
      {
        "name": "cutoff",
        "default": 2000
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"dub_delay\", |builder| {\n    builder\n        .param(\"time\", 0.375)\n        .param(\"feedback\", 0.7)\n        .param(\"cutoff\", 2000.0)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, cutoff, mix| {\n            // Comb filter delay with filtering in feedback path\n            let delayed_left = comb_c_ar(input[0], 2.0, time, feedback * 4.0);\n            let delayed_right = comb_c_ar(input[1], 2.0, time * 1.02, feedback * 4.0);\n\n            // Filter the delayed signal (dub character)\n            let filtered_left = lpf_ar(delayed_left, cutoff);\n            let filtered_right = lpf_ar(delayed_right, cutoff);\n\n            // Add some saturation\n            let sat_left = (filtered_left * 1.2).tanh();\n            let sat_right = (filtered_right * 1.2).tanh();\n\n            [\n                (1.0 - mix) * input[0] + mix * sat_left,\n                (1.0 - mix) * input[1] + mix * sat_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "delays",
    "path": "effects/delays/dub_delay.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Delays"
  },
  {
    "name": "ducking_delay",
    "description": "mix: Maximum wet level when not ducking (0.0 to 1.0)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 0.4
      },
      {
        "name": "feedback",
        "default": 0.4
      },
      {
        "name": "duck_amount",
        "default": 0.7
      },
      {
        "name": "duck_speed",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"ducking_delay\", |builder| {\n    builder\n        .param(\"time\", 0.4)\n        .param(\"feedback\", 0.4)\n        .param(\"duck_amount\", 0.7)\n        .param(\"duck_speed\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, duck_amount, duck_speed, mix| {\n            // Envelope follower for ducking\n            let mono_in = (input[0] + input[1]) * 0.5;\n            let amplitude = lag_ar(mono_in.abs(), 0.01 + (1.0 - duck_speed) * 0.1);\n\n            // Calculate duck level (more input = less delay)\n            let duck_mult = 1.0 - (amplitude * duck_amount * 4.0).min(1.0);\n\n            // Create the delays\n            let delay_l = delay_c_ar(input[0], 3.0, time);\n            let delay_r = delay_c_ar(input[1], 3.0, time);\n\n            // Feedback with filtering\n            let fb_l = delay_c_ar(delay_l * feedback, 3.0, time);\n            let fb_r = delay_c_ar(delay_r * feedback, 3.0, time);\n\n            let wet_l = delay_l + fb_l * feedback;\n            let wet_r = delay_r + fb_r * feedback;\n\n            // Apply ducking to wet signal\n            let ducked_l = wet_l * duck_mult;\n            let ducked_r = wet_r * duck_mult;\n\n            [\n                input[0] + ducked_l * mix,\n                input[1] + ducked_r * mix\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "delays",
    "path": "effects/delays/ducking_delay.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Delays"
  },
  {
    "name": "granular_delay",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 0.3
      },
      {
        "name": "pitch",
        "default": 1
      },
      {
        "name": "density",
        "default": 0.7
      },
      {
        "name": "feedback",
        "default": 0.4
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"granular_delay\", |builder| {\n    builder\n        .param(\"time\", 0.3)\n        .param(\"pitch\", 1.0)\n        .param(\"density\", 0.7)\n        .param(\"feedback\", 0.4)\n        .param(\"mix\", 0.5)\n        .body(|input, time, pitch, density, feedback, mix| {\n            // Multiple delay taps with varying times for granular effect\n            let grain_size = 0.05 + (1.0 - density) * 0.1;\n\n            // Create offset delay taps\n            let tap1_left = delay_c_ar(input[0], 2.0, time);\n            let tap2_left = delay_c_ar(input[0], 2.0, time * 1.33);\n            let tap3_left = delay_c_ar(input[0], 2.0, time * 0.75);\n\n            let tap1_right = delay_c_ar(input[1], 2.0, time * 1.1);\n            let tap2_right = delay_c_ar(input[1], 2.0, time * 0.9);\n            let tap3_right = delay_c_ar(input[1], 2.0, time * 1.5);\n\n            // Mix grains with varying amplitudes\n            let grain_left = tap1_left * 0.5 + tap2_left * 0.3 + tap3_left * 0.2;\n            let grain_right = tap1_right * 0.5 + tap2_right * 0.3 + tap3_right * 0.2;\n\n            // Apply pitch variation through playback rate modulation\n            let pitch_mod = sin_osc_ar(0.1 + density * 2.0) * 0.02 * (pitch - 1.0);\n            let modulated_left = delay_c_ar(grain_left, 0.1, 0.01 + pitch_mod.abs());\n            let modulated_right = delay_c_ar(grain_right, 0.1, 0.01 + pitch_mod.abs());\n\n            // Add feedback\n            let fb_left = modulated_left * feedback;\n            let fb_right = modulated_right * feedback;\n\n            // Final mix with slight filtering for smoothness\n            let out_left = lpf_ar(modulated_left + fb_left, 10000.0);\n            let out_right = lpf_ar(modulated_right + fb_right, 10000.0);\n\n            [\n                (1.0 - mix) * input[0] + mix * out_left,\n                (1.0 - mix) * input[1] + mix * out_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "delays",
    "path": "effects/delays/granular_delay.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Delays"
  },
  {
    "name": "multi_tap_delay",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 0.375
      },
      {
        "name": "feedback",
        "default": 0.4
      },
      {
        "name": "spread",
        "default": 0.7
      },
      {
        "name": "filter",
        "default": 0.6
      },
      {
        "name": "mix",
        "default": 0.4
      }
    ],
    "type": "fx",
    "source": "define_fx(\"multi_tap_delay\", |builder| {\n    builder\n        .param(\"time\", 0.375)\n        .param(\"feedback\", 0.4)\n        .param(\"spread\", 0.7)\n        .param(\"filter\", 0.6)\n        .param(\"mix\", 0.4)\n        .body(|input, time, feedback, spread, filter, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Six delay taps at musical intervals\n            let tap1 = delay_c_ar(mono, 2.0, time * 0.25) * 0.8;      // 1/4\n            let tap2 = delay_c_ar(mono, 2.0, time * 0.375) * 0.7;     // dotted 8th feel\n            let tap3 = delay_c_ar(mono, 2.0, time * 0.5) * 0.6;       // 1/2\n            let tap4 = delay_c_ar(mono, 2.0, time * 0.667) * 0.5;     // 2/3\n            let tap5 = delay_c_ar(mono, 2.0, time * 0.75) * 0.4;      // 3/4\n            let tap6 = delay_c_ar(mono, 2.0, time) * 0.5;             // full\n\n            // Distribute taps in stereo field\n            let left_taps = tap1 + tap3 * (1.0 - spread * 0.5) + tap5;\n            let right_taps = tap2 + tap4 * (1.0 - spread * 0.5) + tap6;\n\n            // Cross-feed for stereo coherence\n            let cross = 0.3 * (1.0 - spread);\n            let wet_l = left_taps + right_taps * cross;\n            let wet_r = right_taps + left_taps * cross;\n\n            // Apply feedback\n            let fb_l = delay_c_ar(wet_l * feedback, 2.0, time);\n            let fb_r = delay_c_ar(wet_r * feedback, 2.0, time);\n\n            let total_l = wet_l + fb_l * feedback;\n            let total_r = wet_r + fb_r * feedback;\n\n            // Tone control\n            let cutoff = 3000.0 + filter * 9000.0;\n            let filtered_l = lpf_ar(total_l, cutoff);\n            let filtered_r = lpf_ar(total_r, cutoff);\n\n            [\n                (1.0 - mix) * input[0] + mix * filtered_l * 0.7,\n                (1.0 - mix) * input[1] + mix * filtered_r * 0.7\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "delays",
    "path": "effects/delays/multi_tap_delay.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Delays"
  },
  {
    "name": "ping_pong_delay",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 0.375
      },
      {
        "name": "feedback",
        "default": 0.6
      },
      {
        "name": "mix",
        "default": 0.4
      }
    ],
    "type": "fx",
    "source": "define_fx(\"ping_pong_delay\", |builder| {\n    builder\n        .param(\"time\", 0.375)\n        .param(\"feedback\", 0.6)\n        .param(\"mix\", 0.4)\n        .body(|input, time, feedback, mix| {\n            // Create cross-coupled delays (left feeds right, right feeds left)\n            let del_left = delay_n_ar(input[0] + (feedback * delay_n_ar(input[1], 2.0, time)), 2.0, time);\n            let del_right = delay_n_ar(input[1] + (feedback * delay_n_ar(input[0], 2.0, time)), 2.0, time);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * del_left,\n                (1.0 - mix) * input[1] + mix * del_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "delays",
    "path": "effects/delays/ping_pong_delay.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Delays"
  },
  {
    "name": "reverse_delay",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 0.3
      },
      {
        "name": "feedback",
        "default": 0.4
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"reverse_delay\", |builder| {\n    builder\n        .param(\"time\", 0.3)\n        .param(\"feedback\", 0.4)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, mix| {\n            // Simulate reverse using multiple staggered delays with envelope\n            let env = sin_osc_ar(1.0 / time) * 0.5 + 0.5;\n\n            let d1_left = delay_c_ar(input[0], 1.0, time * 0.25) * (1.0 - env) * 0.3;\n            let d2_left = delay_c_ar(input[0], 1.0, time * 0.5) * env * 0.5;\n            let d3_left = delay_c_ar(input[0], 1.0, time * 0.75) * (1.0 - env) * 0.7;\n            let d4_left = delay_c_ar(input[0], 1.0, time) * env;\n\n            let d1_right = delay_c_ar(input[1], 1.0, time * 0.25) * (1.0 - env) * 0.3;\n            let d2_right = delay_c_ar(input[1], 1.0, time * 0.5) * env * 0.5;\n            let d3_right = delay_c_ar(input[1], 1.0, time * 0.75) * (1.0 - env) * 0.7;\n            let d4_right = delay_c_ar(input[1], 1.0, time) * env;\n\n            let wet_left = (d1_left + d2_left + d3_left + d4_left) * 0.4;\n            let wet_right = (d1_right + d2_right + d3_right + d4_right) * 0.4;\n\n            [\n                (1.0 - mix) * input[0] + mix * wet_left,\n                (1.0 - mix) * input[1] + mix * wet_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "delays",
    "path": "effects/delays/reverse_delay.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Delays"
  },
  {
    "name": "shimmer_delay",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 0.4
      },
      {
        "name": "feedback",
        "default": 0.6
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"shimmer_delay\", |builder| {\n    builder\n        .param(\"time\", 0.4)\n        .param(\"feedback\", 0.6)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, mix| {\n            // Main delay\n            let delayed_left = comb_c_ar(input[0], 1.0, time, feedback * 3.0);\n            let delayed_right = comb_c_ar(input[1], 1.0, time * 1.01, feedback * 3.0);\n\n            // Octave up simulation using ring mod\n            let octave_left = delayed_left * sin_osc_ar(880.0) * 0.3;\n            let octave_right = delayed_right * sin_osc_ar(880.0) * 0.3;\n\n            let shimmer_left = delayed_left * 0.7 + octave_left;\n            let shimmer_right = delayed_right * 0.7 + octave_right;\n\n            [\n                (1.0 - mix) * input[0] + mix * shimmer_left,\n                (1.0 - mix) * input[1] + mix * shimmer_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "delays",
    "path": "effects/delays/shimmer_delay.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Delays"
  },
  {
    "name": "slapback",
    "description": "level: Delay level (0.0 to 1.0)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 0.12
      },
      {
        "name": "level",
        "default": 0.6
      }
    ],
    "type": "fx",
    "source": "define_fx(\"slapback\", |builder| {\n    builder\n        .param(\"time\", 0.12)\n        .param(\"level\", 0.6)\n        .body(|input, time, level| {\n            // Single delay tap, no feedback\n            let delayed_left = delay_c_ar(input[0], 0.25, time);\n            let delayed_right = delay_c_ar(input[1], 0.25, time);\n\n            [\n                input[0] + delayed_left * level,\n                input[1] + delayed_right * level\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "delays",
    "path": "effects/delays/slapback.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Delays"
  },
  {
    "name": "tape_delay",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 0.5
      },
      {
        "name": "feedback",
        "default": 0.5
      },
      {
        "name": "wow",
        "default": 0.3
      },
      {
        "name": "flutter",
        "default": 0.2
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"tape_delay\", |builder| {\n    builder\n        .param(\"time\", 0.5)\n        .param(\"feedback\", 0.5)\n        .param(\"wow\", 0.3)\n        .param(\"flutter\", 0.2)\n        .param(\"mix\", 0.5)\n        .body(|input, time, feedback, wow, flutter, mix| {\n            // Generate wow (slow LFO) and flutter (fast LFO)\n            let wow_lfo = sin_osc_ar(0.5, 0.0) * wow * 0.001;\n            let flutter_lfo = sin_osc_ar(8.0, 0.0) * flutter * 0.0005;\n\n            // Modulated delay time\n            let mod_time = time + wow_lfo + flutter_lfo;\n\n            // Create delayed signals with modulation\n            let del_left = delay_c_ar(input[0] + (feedback * delay_c_ar(input[0], 2.0, mod_time)), 2.0, mod_time);\n            let del_right = delay_c_ar(input[1] + (feedback * delay_c_ar(input[1], 2.0, mod_time)), 2.0, mod_time);\n\n            // Tape saturation (soft clipping)\n            let saturated_left = (del_left * 1.5).tanh();\n            let saturated_right = (del_right * 1.5).tanh();\n\n            // High frequency roll-off for analog character\n            let filtered_left = lpf_ar(saturated_left, 4000.0);\n            let filtered_right = lpf_ar(saturated_right, 4000.0);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "delays",
    "path": "effects/delays/tape_delay.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Delays"
  },
  {
    "name": "bitcrush",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "bits",
        "default": 8
      },
      {
        "name": "sample_rate",
        "default": 8000
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"bitcrush\", |builder| {\n    builder\n        .param(\"bits\", 8.0)\n        .param(\"sample_rate\", 8000.0)\n        .param(\"mix\", 0.5)\n        .body(|input, bits, sample_rate, mix| {\n            // Map bits (1..16) to a gentle drive factor.\n            // We avoid using a true power function here to keep the graph stable.\n            // 1.0 ≈ barely crushed, 4.0 ≈ heavy crush.\n            let drive = 1.0 + (bits / 8.0);\n\n            // Sample rate reduction using Latch\n            let rate_reduced_left = latch_ar(input[0], impulse_ar(sample_rate, 0.0));\n            let rate_reduced_right = latch_ar(input[1], impulse_ar(sample_rate, 0.0));\n\n            // Bit depth reduction (approximate) by increasing drive and soft-clipping.\n            let crushed_left = (rate_reduced_left * drive).tanh();\n            let crushed_right = (rate_reduced_right * drive).tanh();\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * crushed_left,\n                (1.0 - mix) * input[1] + mix * crushed_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "distortion",
    "path": "effects/distortion/bitcrush.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Distortion"
  },
  {
    "name": "distortion",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "drive",
        "default": 8
      },
      {
        "name": "tone",
        "default": 5000
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"distortion\", |builder| {\n    builder\n        .param(\"drive\", 8.0)\n        .param(\"tone\", 5000.0)\n        .param(\"mix\", 0.5)\n        .body(|input, drive, tone, mix| {\n            // Large constant boost to ensure we hit tanh saturation even on quiet signals\n            // drive=8 -> 800x boost, drive=20 -> 2000x boost\n            let boost = 1.0;\n            \n            // Remove low-end mud and boost signal for clipping\n            let driven_left = hpf_ar(input[0], 80.0) * boost * drive;\n            let driven_right = hpf_ar(input[1], 80.0) * boost * drive;\n\n            // Soft clip using tanh for amp-like behavior\n            let clipped_left = driven_left.tanh();\n            let clipped_right = driven_right.tanh();\n\n            // Tone shaping to tame fizz\n            let shaped_left = lpf_ar(clipped_left, tone);\n            let shaped_right = lpf_ar(clipped_right, tone);\n\n            // Mix dry and wet signals\n            let dry_left = input[0] * (1.0 - mix);\n            let dry_right = input[1] * (1.0 - mix);\n            let wet_left = shaped_left * mix;\n            let wet_right = shaped_right * mix;\n            \n            [\n                dry_left + wet_left,\n                dry_right + wet_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "distortion",
    "path": "effects/distortion/distortion.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Distortion"
  },
  {
    "name": "exciter",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = full effect)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "drive",
        "default": 0.5
      },
      {
        "name": "freq",
        "default": 3000
      },
      {
        "name": "blend",
        "default": 0.3
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"exciter\", |builder| {\n    builder\n        .param(\"drive\", 0.5)\n        .param(\"freq\", 3000.0)\n        .param(\"blend\", 0.3)\n        .param(\"mix\", 1.0)\n        .body(|input, drive, freq, blend, mix| {\n            // Extract high frequency content\n            let highs_l = hpf_ar(input[0], freq);\n            let highs_r = hpf_ar(input[1], freq);\n\n            // Generate harmonics through soft saturation\n            let saturated_l = (highs_l * (1.0 + drive * 4.0)).tanh();\n            let saturated_r = (highs_r * (1.0 + drive * 4.0)).tanh();\n\n            // Extract the generated harmonics (remove original)\n            let harmonics_l = saturated_l - highs_l;\n            let harmonics_r = saturated_r - highs_r;\n\n            // Filter harmonics to focus on upper frequencies\n            let focused_l = hpf_ar(harmonics_l, freq * 1.5);\n            let focused_r = hpf_ar(harmonics_r, freq * 1.5);\n\n            // Blend harmonics with original\n            let enhanced_l = input[0] + focused_l * blend;\n            let enhanced_r = input[1] + focused_r * blend;\n\n            [\n                (1.0 - mix) * input[0] + mix * enhanced_l,\n                (1.0 - mix) * input[1] + mix * enhanced_r\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "distortion",
    "path": "effects/distortion/exciter.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Distortion"
  },
  {
    "name": "fuzz",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "gain",
        "default": 10
      },
      {
        "name": "tone",
        "default": 3000
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"fuzz\", |builder| {\n    builder\n        .param(\"gain\", 10.0)\n        .param(\"tone\", 3000.0)\n        .param(\"mix\", 1.0)\n        .body(|input, gain, tone, mix| {\n            // Boost and clip\n            let fuzzed_left = (input[0] * gain).tanh();\n            let fuzzed_right = (input[1] * gain).tanh();\n\n            // Additional hard clipping for that fuzz character\n            let clipped_left = fuzzed_left.clip(-0.8, 0.8);\n            let clipped_right = fuzzed_right.clip(-0.8, 0.8);\n\n            // Tone control\n            let toned_left = lpf_ar(clipped_left, tone);\n            let toned_right = lpf_ar(clipped_right, tone);\n\n            [\n                (1.0 - mix) * input[0] + mix * toned_left,\n                (1.0 - mix) * input[1] + mix * toned_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "distortion",
    "path": "effects/distortion/fuzz.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Distortion"
  },
  {
    "name": "lo_fi",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "bit_depth",
        "default": 10
      },
      {
        "name": "sample_rate",
        "default": 16000
      },
      {
        "name": "noise",
        "default": 0.02
      },
      {
        "name": "filter_freq",
        "default": 3500
      },
      {
        "name": "mix",
        "default": 0.7
      }
    ],
    "type": "fx",
    "source": "define_fx(\"lo_fi\", |builder| {\n    builder\n        .param(\"bit_depth\", 10.0)\n        .param(\"sample_rate\", 16000.0)\n        .param(\"noise\", 0.02)\n        .param(\"filter_freq\", 3500.0)\n        .param(\"mix\", 0.7)\n        .body(|input, bit_depth, sample_rate, noise, filter_freq, mix| {\n            // Sample rate reduction\n            let rate_reduced_left = latch_ar(input[0], impulse_ar(sample_rate, 0.0));\n            let rate_reduced_right = latch_ar(input[1], impulse_ar(sample_rate, 0.0));\n\n            // Approximate bit depth reduction using drive + soft-clipping.\n            // Map bit_depth (4..16) to a modest drive factor.\n            let drive = 1.0 + (bit_depth / 8.0);\n            let crushed_left = (rate_reduced_left * drive).tanh();\n            let crushed_right = (rate_reduced_right * drive).tanh();\n\n            // Add noise\n            let noise_sig = pink_noise_ar() * noise;\n            let noisy_left = crushed_left + noise_sig;\n            let noisy_right = crushed_right + noise_sig;\n\n            // Low pass filter\n            let filtered_left = lpf_ar(noisy_left, filter_freq);\n            let filtered_right = lpf_ar(noisy_right, filter_freq);\n\n            // Slight distortion\n            let lofi = [\n                (filtered_left * 1.2).tanh(),\n                (filtered_right * 1.2).tanh()\n            ];\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * lofi[0],\n                (1.0 - mix) * input[1] + mix * lofi[1]\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "distortion",
    "path": "effects/distortion/lo_fi.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Distortion"
  },
  {
    "name": "overdrive",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "drive",
        "default": 5
      },
      {
        "name": "tone",
        "default": 3000
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"overdrive\", |builder| {\n    builder\n        .param(\"drive\", 5.0)\n        .param(\"tone\", 3000.0)\n        .param(\"mix\", 0.5)\n        .body(|input, drive, tone, mix| {\n            // Pre-emphasis (slight high pass to reduce mud)\n            let emphasized_left = hpf_ar(input[0], 80.0);\n            let emphasized_right = hpf_ar(input[1], 80.0);\n\n            // Apply drive\n            let driven_left = emphasized_left * drive;\n            let driven_right = emphasized_right * drive;\n\n            // Soft clipping\n            let clipped_left = driven_left.tanh();\n            let clipped_right = driven_right.tanh();\n\n            // Tone control (low pass filter)\n            let filtered_left = lpf_ar(clipped_left, tone);\n            let filtered_right = lpf_ar(clipped_right, tone);\n\n            // Output gain compensation\n            let overdriven = [\n                filtered_left * 0.5,\n                filtered_right * 0.5\n            ];\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * overdriven[0],\n                (1.0 - mix) * input[1] + mix * overdriven[1]\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "distortion",
    "path": "effects/distortion/overdrive.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Distortion"
  },
  {
    "name": "saturator",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "drive",
        "default": 3
      },
      {
        "name": "warmth",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"saturator\", |builder| {\n    builder\n        .param(\"drive\", 3.0)\n        .param(\"warmth\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, drive, warmth, mix| {\n            // Add warmth by boosting low-mids\n            let warm_freq = 200.0 + warmth * 300.0;\n            let warmed_left = input[0] + lpf_ar(input[0], warm_freq) * warmth * 0.5;\n            let warmed_right = input[1] + lpf_ar(input[1], warm_freq) * warmth * 0.5;\n\n            // Soft saturation using tanh (smooth tube-like curve)\n            let driven_left = (warmed_left * drive).tanh() / drive.sqrt();\n            let driven_right = (warmed_right * drive).tanh() / drive.sqrt();\n\n            // Add subtle even harmonics for analog character\n            let harmonic_left = sin_osc_ar(0.0) * 0.0; // placeholder for DC offset\n            let harmonic_right = sin_osc_ar(0.0) * 0.0;\n\n            let saturated_left = driven_left + harmonic_left;\n            let saturated_right = driven_right + harmonic_right;\n\n            // Mix dry and wet\n            [\n                (1.0 - mix) * input[0] + mix * saturated_left,\n                (1.0 - mix) * input[1] + mix * saturated_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "distortion",
    "path": "effects/distortion/saturator.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Distortion"
  },
  {
    "name": "tape_saturation",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "drive",
        "default": 0.4
      },
      {
        "name": "bias",
        "default": 0.5
      },
      {
        "name": "speed",
        "default": 0.7
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"tape_saturation\", |builder| {\n    builder\n        .param(\"drive\", 0.4)\n        .param(\"bias\", 0.5)\n        .param(\"speed\", 0.7)\n        .param(\"mix\", 0.5)\n        .body(|input, drive, bias, speed, mix| {\n            // Input gain (drive into saturation)\n            let driven_l = input[0] * (1.0 + drive * 3.0);\n            let driven_r = input[1] * (1.0 + drive * 3.0);\n\n            // Tape saturation (asymmetric soft clipping)\n            let sat_l = (driven_l * (1.0 + bias * 0.5)).tanh() + driven_l * bias * 0.1;\n            let sat_r = (driven_r * (1.0 + bias * 0.5)).tanh() + driven_r * bias * 0.1;\n\n            // Tape head bump (bass boost around 60-100Hz)\n            let bump_freq = 70.0 + speed * 50.0;\n            let bump_l = rlpf_ar(sat_l, bump_freq, 0.5) * 0.3 * (1.0 - speed * 0.5);\n            let bump_r = rlpf_ar(sat_r, bump_freq, 0.5) * 0.3 * (1.0 - speed * 0.5);\n\n            // High frequency roll-off (tape speed dependent)\n            let hf_cutoff = 8000.0 + speed * 12000.0;\n            let filtered_l = lpf_ar(sat_l, hf_cutoff);\n            let filtered_r = lpf_ar(sat_r, hf_cutoff);\n\n            // Subtle wow (very slow pitch variation)\n            let wow = sin_osc_ar(0.3) * 0.0005;\n            let final_l = delay_c_ar(filtered_l + bump_l, 0.01, 0.001 + wow);\n            let final_r = delay_c_ar(filtered_r + bump_r, 0.01, 0.001 + wow);\n\n            // Output level compensation\n            let comp = 1.0 / (1.0 + drive * 0.5);\n\n            [\n                (1.0 - mix) * input[0] + mix * final_l * comp,\n                (1.0 - mix) * input[1] + mix * final_r * comp\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "distortion",
    "path": "effects/distortion/tape_saturation.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Distortion"
  },
  {
    "name": "vinyl",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "crackle",
        "default": 0.05
      },
      {
        "name": "dust",
        "default": 0.02
      },
      {
        "name": "wow",
        "default": 0.3
      },
      {
        "name": "flutter",
        "default": 0.2
      },
      {
        "name": "wear",
        "default": 4000
      },
      {
        "name": "mix",
        "default": 0.8
      }
    ],
    "type": "fx",
    "source": "define_fx(\"vinyl\", |builder| {\n    builder\n        .param(\"crackle\", 0.05)\n        .param(\"dust\", 0.02)\n        .param(\"wow\", 0.3)\n        .param(\"flutter\", 0.2)\n        .param(\"wear\", 4000.0)\n        .param(\"mix\", 0.8)\n        .body(|input, crackle, dust, wow, flutter, wear, mix| {\n            // Wow (slow pitch variation)\n            let wow_lfo = sin_osc_ar(0.5, 0.0) * wow * 0.001;\n            let flutter_lfo = sin_osc_ar(10.0, 0.0) * flutter * 0.0003;\n            let pitch_var = 0.01 + wow_lfo + flutter_lfo;\n\n            // Apply pitch variation via delay\n            let warbled_left = delay_c_ar(input[0], 0.1, pitch_var);\n            let warbled_right = delay_c_ar(input[1], 0.1, pitch_var);\n\n            // Record wear (high frequency rolloff)\n            let worn_left = lpf_ar(warbled_left, wear);\n            let worn_right = lpf_ar(warbled_right, wear);\n\n            // Add crackle (filtered noise)\n            let crackle_sig = lpf_ar(dust2_ar(1000.0) * crackle, 8000.0);\n\n            // Add dust pops (random impulses)\n            let dust_sig = dust_ar(50.0) * dust;\n\n            // Combine all elements\n            let vinyl_left = worn_left + crackle_sig + dust_sig;\n            let vinyl_right = worn_right + crackle_sig + dust_sig;\n\n            // Mix dry and wet signals\n            [\n                (1.0 - mix) * input[0] + mix * vinyl_left,\n                (1.0 - mix) * input[1] + mix * vinyl_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "distortion",
    "path": "effects/distortion/vinyl.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Distortion"
  },
  {
    "name": "waveshaper",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "amount",
        "default": 0.5
      },
      {
        "name": "curve",
        "default": 2
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"waveshaper\", |builder| {\n    builder\n        .param(\"amount\", 0.5)\n        .param(\"curve\", 2.0)\n        .param(\"mix\", 0.5)\n        .body(|input, amount, curve, mix| {\n            // Pre-gain based on amount\n            let pre_gain = 1.0 + amount * 4.0;\n\n            // Apply polynomial waveshaping\n            let boosted_left = input[0] * pre_gain;\n            let boosted_right = input[1] * pre_gain;\n\n            // Soft clip with curve control\n            let shaped_left = (boosted_left.tanh() + boosted_left * (1.0 - amount)) * 0.5;\n            let shaped_right = (boosted_right.tanh() + boosted_right * (1.0 - amount)) * 0.5;\n\n            // Normalize output\n            let norm_left = shaped_left / pre_gain.sqrt();\n            let norm_right = shaped_right / pre_gain.sqrt();\n\n            [\n                (1.0 - mix) * input[0] + mix * norm_left,\n                (1.0 - mix) * input[1] + mix * norm_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "distortion",
    "path": "effects/distortion/waveshaper.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Distortion"
  },
  {
    "name": "amp_follower",
    "description": "scale: Output scaling factor (0.1 to 5.0)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "attack",
        "default": 0.01
      },
      {
        "name": "release",
        "default": 0.1
      },
      {
        "name": "scale",
        "default": 2
      }
    ],
    "type": "fx",
    "source": "define_fx(\"amp_follower\", |builder| {\n    builder\n        .param(\"attack\", 0.01)\n        .param(\"release\", 0.1)\n        .param(\"scale\", 2.0)\n        .body(|input, attack, release, scale| {\n            // Extract amplitude envelope\n            let env_left = amplitude_ar(input[0], attack, release);\n            let env_right = amplitude_ar(input[1], attack, release);\n\n            // Apply envelope back to signal (can create pumping effect)\n            let followed = [\n                input[0] * env_left * scale,\n                input[1] * env_right * scale\n            ];\n\n            followed\n        })\n});",
    "category": "effects",
    "subcategory": "dynamics",
    "path": "effects/dynamics/amp_follower.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Dynamics"
  },
  {
    "name": "compressor",
    "description": "release: Release time in seconds",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "threshold",
        "default": 0.5
      },
      {
        "name": "ratio",
        "default": 4
      },
      {
        "name": "attack",
        "default": 0.01
      },
      {
        "name": "release",
        "default": 0.1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"compressor\", |builder| {\n    builder\n        .param(\"threshold\", 0.5)\n        .param(\"ratio\", 4.0)\n        .param(\"attack\", 0.01)\n        .param(\"release\", 0.1)\n        .body(|input, threshold, ratio, attack, release| {\n            // Apply compander to both channels\n            let left = compander_ar(input[0], input[0], threshold, 1.0, 1.0/ratio, attack, release);\n            let right = compander_ar(input[1], input[1], threshold, 1.0, 1.0/ratio, attack, release);\n\n            [left, right]\n        })\n});",
    "category": "effects",
    "subcategory": "dynamics",
    "path": "effects/dynamics/compressor.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Dynamics"
  },
  {
    "name": "de_esser",
    "description": "width: Detection bandwidth (0.0 = narrow, 1.0 = wide)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 6000
      },
      {
        "name": "threshold",
        "default": 0.5
      },
      {
        "name": "reduction",
        "default": 0.5
      },
      {
        "name": "width",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"de_esser\", |builder| {\n    builder\n        .param(\"freq\", 6000.0)\n        .param(\"threshold\", 0.5)\n        .param(\"reduction\", 0.5)\n        .param(\"width\", 0.5)\n        .body(|input, freq, threshold, reduction, width| {\n            // Extract sibilance band\n            let q = 0.5 + (1.0 - width) * 1.5;\n            let sib_l = rlpf_ar(hpf_ar(input[0], freq * 0.7), freq, q);\n            let sib_r = rlpf_ar(hpf_ar(input[1], freq * 0.7), freq, q);\n\n            // Detect sibilance level\n            let detect_l = lag_ar(sib_l.abs(), 0.002);\n            let detect_r = lag_ar(sib_r.abs(), 0.002);\n\n            // Calculate gain reduction\n            let thresh = 0.1 + threshold * 0.4;\n            let over_l = (detect_l - thresh).max(0.0);\n            let over_r = (detect_r - thresh).max(0.0);\n\n            // Smooth gain reduction\n            let gr_l = (1.0 - over_l * reduction * 10.0).max(0.2);\n            let gr_r = (1.0 - over_r * reduction * 10.0).max(0.2);\n\n            let smooth_gr_l = lag_ar(gr_l, 0.005);\n            let smooth_gr_r = lag_ar(gr_r, 0.005);\n\n            // Apply reduction only to sibilance band\n            let reduced_sib_l = sib_l * smooth_gr_l;\n            let reduced_sib_r = sib_r * smooth_gr_r;\n\n            // Subtract original sibilance, add reduced version\n            let out_l = input[0] - sib_l + reduced_sib_l;\n            let out_r = input[1] - sib_r + reduced_sib_r;\n\n            [out_l, out_r]\n        })\n});",
    "category": "effects",
    "subcategory": "dynamics",
    "path": "effects/dynamics/de_esser.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Dynamics"
  },
  {
    "name": "ducking",
    "description": "release: Release time in seconds",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "threshold",
        "default": 0.3
      },
      {
        "name": "ratio",
        "default": 5
      },
      {
        "name": "attack",
        "default": 0.01
      },
      {
        "name": "release",
        "default": 0.1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"ducking\", |builder| {\n    builder\n        .param(\"threshold\", 0.3)\n        .param(\"ratio\", 5.0)\n        .param(\"attack\", 0.01)\n        .param(\"release\", 0.1)\n        .body(|input, threshold, ratio, attack, release| {\n            // Apply compression (ducking)\n            let ducked_left = compander_ar(input[0], input[0], threshold, 1.0, 1.0/ratio, attack, release);\n            let ducked_right = compander_ar(input[1], input[1], threshold, 1.0, 1.0/ratio, attack, release);\n\n            [ducked_left, ducked_right]\n        })\n});",
    "category": "effects",
    "subcategory": "dynamics",
    "path": "effects/dynamics/ducking.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Dynamics"
  },
  {
    "name": "gate",
    "description": "release: Release time in seconds",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "threshold",
        "default": 0.1
      },
      {
        "name": "attack",
        "default": 0.01
      },
      {
        "name": "release",
        "default": 0.1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"gate\", |builder| {\n    builder\n        .param(\"threshold\", 0.1)\n        .param(\"attack\", 0.01)\n        .param(\"release\", 0.1)\n        .body(|input, threshold, attack, release| {\n            // Use Compander as a gate (expansion below threshold)\n            let gated_left = compander_ar(input[0], input[0], threshold, 10.0, 1.0, attack, release);\n            let gated_right = compander_ar(input[1], input[1], threshold, 10.0, 1.0, attack, release);\n\n            [gated_left, gated_right]\n        })\n});",
    "category": "effects",
    "subcategory": "dynamics",
    "path": "effects/dynamics/gate.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Dynamics"
  },
  {
    "name": "limiter",
    "description": "lookahead: Lookahead time in seconds (0.001 to 0.1)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "level",
        "default": 0.9
      },
      {
        "name": "lookahead",
        "default": 0.01
      }
    ],
    "type": "fx",
    "source": "define_fx(\"limiter\", |builder| {\n    builder\n        .param(\"level\", 0.9)\n        .param(\"lookahead\", 0.01)\n        .body(|input, level, lookahead| {\n            // Apply limiter to both channels\n            let limited_left = limiter_ar(input[0], level, lookahead);\n            let limited_right = limiter_ar(input[1], level, lookahead);\n\n            [limited_left, limited_right]\n        })\n});",
    "category": "effects",
    "subcategory": "dynamics",
    "path": "effects/dynamics/limiter.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Dynamics"
  },
  {
    "name": "multiband_comp",
    "description": "mix: Dry/wet mix",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "low_freq",
        "default": 200
      },
      {
        "name": "high_freq",
        "default": 3000
      },
      {
        "name": "low_thresh",
        "default": 0.5
      },
      {
        "name": "mid_thresh",
        "default": 0.4
      },
      {
        "name": "high_thresh",
        "default": 0.3
      },
      {
        "name": "ratio",
        "default": 4
      },
      {
        "name": "attack",
        "default": 0.01
      },
      {
        "name": "release",
        "default": 0.1
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"multiband_comp\", |builder| {\n    builder\n        .param(\"low_freq\", 200.0)\n        .param(\"high_freq\", 3000.0)\n        .param(\"low_thresh\", 0.5)\n        .param(\"mid_thresh\", 0.4)\n        .param(\"high_thresh\", 0.3)\n        .param(\"ratio\", 4.0)\n        .param(\"attack\", 0.01)\n        .param(\"release\", 0.1)\n        .param(\"mix\", 1.0)\n        .body(|input, low_freq, high_freq, low_thresh, mid_thresh, high_thresh, ratio, attack, release, mix| {\n            // Split into bands\n            let low_left = lpf_ar(input[0], low_freq);\n            let low_right = lpf_ar(input[1], low_freq);\n\n            let high_left = hpf_ar(input[0], high_freq);\n            let high_right = hpf_ar(input[1], high_freq);\n\n            let mid_left = hpf_ar(lpf_ar(input[0], high_freq), low_freq);\n            let mid_right = hpf_ar(lpf_ar(input[1], high_freq), low_freq);\n\n            // Compress each band\n            let comp_low_left = compander_ar(low_left, low_left, low_thresh, 1.0, 1.0/ratio, attack, release);\n            let comp_low_right = compander_ar(low_right, low_right, low_thresh, 1.0, 1.0/ratio, attack, release);\n\n            let comp_mid_left = compander_ar(mid_left, mid_left, mid_thresh, 1.0, 1.0/ratio, attack, release);\n            let comp_mid_right = compander_ar(mid_right, mid_right, mid_thresh, 1.0, 1.0/ratio, attack, release);\n\n            let comp_high_left = compander_ar(high_left, high_left, high_thresh, 1.0, 1.0/ratio, attack, release);\n            let comp_high_right = compander_ar(high_right, high_right, high_thresh, 1.0, 1.0/ratio, attack, release);\n\n            // Recombine bands\n            let processed_left = comp_low_left + comp_mid_left + comp_high_left;\n            let processed_right = comp_low_right + comp_mid_right + comp_high_right;\n\n            [\n                (1.0 - mix) * input[0] + mix * processed_left,\n                (1.0 - mix) * input[1] + mix * processed_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "dynamics",
    "path": "effects/dynamics/multiband_comp.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Dynamics"
  },
  {
    "name": "parallel_comp",
    "description": "blend: Blend of compressed signal (0.0 to 1.0)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "ratio",
        "default": 8
      },
      {
        "name": "attack",
        "default": 0.3
      },
      {
        "name": "release",
        "default": 0.4
      },
      {
        "name": "makeup",
        "default": 1
      },
      {
        "name": "blend",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"parallel_comp\", |builder| {\n    builder\n        .param(\"ratio\", 8.0)\n        .param(\"attack\", 0.3)\n        .param(\"release\", 0.4)\n        .param(\"makeup\", 1.0)\n        .param(\"blend\", 0.5)\n        .body(|input, ratio, attack, release, makeup, blend| {\n            // Convert attack/release to time constants\n            let attack_time = 0.001 + attack * 0.05;\n            let release_time = 0.05 + release * 0.3;\n\n            // Envelope follower for compression\n            let env_l = lag_ar(input[0].abs(), attack_time);\n            let env_r = lag_ar(input[1].abs(), attack_time);\n\n            // Calculate gain reduction (ratio-based compression)\n            let threshold = 0.2;\n            let over_l = (env_l - threshold).max(0.0);\n            let over_r = (env_r - threshold).max(0.0);\n\n            // Apply ratio\n            let reduction_l = over_l * (1.0 - 1.0 / ratio);\n            let reduction_r = over_r * (1.0 - 1.0 / ratio);\n\n            // Smooth gain reduction\n            let gain_l = lag_ar(1.0 - reduction_l * 2.0, release_time).max(0.1);\n            let gain_r = lag_ar(1.0 - reduction_r * 2.0, release_time).max(0.1);\n\n            // Apply compression\n            let comp_l = input[0] * gain_l * makeup;\n            let comp_r = input[1] * gain_r * makeup;\n\n            // Parallel blend (dry + compressed)\n            let out_l = input[0] + comp_l * blend;\n            let out_r = input[1] + comp_r * blend;\n\n            // Normalize output\n            let norm = 1.0 / (1.0 + blend * 0.5);\n\n            [out_l * norm, out_r * norm]\n        })\n});",
    "category": "effects",
    "subcategory": "dynamics",
    "path": "effects/dynamics/parallel_comp.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Dynamics"
  },
  {
    "name": "sidechain",
    "description": "amount: Effect intensity (0.0 = off, 1.0 = full pump)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "threshold",
        "default": 0.3
      },
      {
        "name": "ratio",
        "default": 8
      },
      {
        "name": "attack",
        "default": 0.001
      },
      {
        "name": "release",
        "default": 0.15
      },
      {
        "name": "amount",
        "default": 0.7
      }
    ],
    "type": "fx",
    "source": "define_fx(\"sidechain\", |builder| {\n    builder\n        .param(\"threshold\", 0.3)\n        .param(\"ratio\", 8.0)\n        .param(\"attack\", 0.001)\n        .param(\"release\", 0.15)\n        .param(\"amount\", 0.7)\n        .body(|input, threshold, ratio, attack, release, amount| {\n            // Follow the input amplitude for self-ducking\n            // In a real scenario you'd use a sidechain input\n            let left_amp = amplitude_ar(input[0], attack, release);\n            let right_amp = amplitude_ar(input[1], attack, release);\n            let env = (left_amp + right_amp) * 0.5;\n\n            // Calculate gain reduction when above threshold\n            let above_thresh = env - threshold;\n            let gain_reduction = 1.0 - (above_thresh.max(0.0) * (1.0 - 1.0/ratio) * amount);\n\n            // Apply gain reduction\n            [\n                input[0] * gain_reduction,\n                input[1] * gain_reduction\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "dynamics",
    "path": "effects/dynamics/sidechain.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Dynamics"
  },
  {
    "name": "transient_shaper",
    "description": "output: Output gain compensation",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "attack",
        "default": "0.0"
      },
      {
        "name": "sustain",
        "default": "0.0"
      },
      {
        "name": "output",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"transient_shaper\", |builder| {\n    builder\n        .param(\"attack\", 0.0)\n        .param(\"sustain\", 0.0)\n        .param(\"output\", 1.0)\n        .body(|input, attack, sustain, output| {\n            // Fast envelope for transient detection\n            let fast_env_l = lag_ar(input[0].abs(), 0.001);\n            let fast_env_r = lag_ar(input[1].abs(), 0.001);\n\n            // Slow envelope for sustain detection\n            let slow_env_l = lag_ar(input[0].abs(), 0.1);\n            let slow_env_r = lag_ar(input[1].abs(), 0.1);\n\n            // Transient = fast - slow (positive during attacks)\n            let transient_l = (fast_env_l - slow_env_l).max(0.0);\n            let transient_r = (fast_env_r - slow_env_r).max(0.0);\n\n            // Attack gain (boost or cut transients)\n            let attack_gain = 1.0 + attack * 2.0;\n            let attack_mod_l = 1.0 + transient_l * (attack_gain - 1.0) * 10.0;\n            let attack_mod_r = 1.0 + transient_r * (attack_gain - 1.0) * 10.0;\n\n            // Sustain gain (boost or cut body)\n            let sustain_mod_l = 1.0 + slow_env_l * sustain * 2.0;\n            let sustain_mod_r = 1.0 + slow_env_r * sustain * 2.0;\n\n            // Combine attack and sustain processing\n            let out_l = input[0] * attack_mod_l * sustain_mod_l;\n            let out_r = input[1] * attack_mod_r * sustain_mod_r;\n\n            // Soft limiting to prevent clipping\n            let limited_l = (out_l * output).tanh();\n            let limited_r = (out_r * output).tanh();\n\n            [limited_l, limited_r]\n        })\n});",
    "category": "effects",
    "subcategory": "dynamics",
    "path": "effects/dynamics/transient_shaper.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Dynamics"
  },
  {
    "name": "bandpass",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 1000
      },
      {
        "name": "bandwidth",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"bandpass\", |builder| {\n    builder\n        .param(\"freq\", 1000.0)\n        .param(\"bandwidth\", 0.5)\n        .param(\"mix\", 1.0)\n        .body(|input, freq, bandwidth, mix| {\n            // BPF provides band pass filtering\n            let filtered_left = bpf_ar(input[0], freq, bandwidth);\n            let filtered_right = bpf_ar(input[1], freq, bandwidth);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "filters",
    "path": "effects/filters/bandpass.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Filters"
  },
  {
    "name": "comb_filter",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "decay",
        "default": 2
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"comb_filter\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"decay\", 2.0)\n        .param(\"mix\", 0.5)\n        .body(|input, freq, decay, mix| {\n            // Calculate delay time from frequency\n            let delay_time = 1.0 / freq;\n\n            // Apply comb filter\n            let combed_left = comb_l_ar(input[0], 0.1, delay_time, decay);\n            let combed_right = comb_l_ar(input[1], 0.1, delay_time, decay);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * combed_left,\n                (1.0 - mix) * input[1] + mix * combed_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "filters",
    "path": "effects/filters/comb_filter.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Filters"
  },
  {
    "name": "eq_three_band",
    "description": "high_freq: Mid/high crossover frequency in Hz",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "low_gain",
        "default": "0.0"
      },
      {
        "name": "mid_gain",
        "default": "0.0"
      },
      {
        "name": "high_gain",
        "default": "0.0"
      },
      {
        "name": "low_freq",
        "default": 250
      },
      {
        "name": "high_freq",
        "default": 4000
      }
    ],
    "type": "fx",
    "source": "define_fx(\"eq_three_band\", |builder| {\n    builder\n        .param(\"low_gain\", 0.0)\n        .param(\"mid_gain\", 0.0)\n        .param(\"high_gain\", 0.0)\n        .param(\"low_freq\", 250.0)\n        .param(\"high_freq\", 4000.0)\n        .body(|input, low_gain, mid_gain, high_gain, low_freq, high_freq| {\n            // Process left channel\n            let low_left = b_low_shelf_ar(input[0], low_freq, 1.0, low_gain);\n            let mid_left = b_peak_eq_ar(low_left, (low_freq + high_freq) * 0.5, 1.0, mid_gain);\n            let eq_left = b_hi_shelf_ar(mid_left, high_freq, 1.0, high_gain);\n\n            // Process right channel\n            let low_right = b_low_shelf_ar(input[1], low_freq, 1.0, low_gain);\n            let mid_right = b_peak_eq_ar(low_right, (low_freq + high_freq) * 0.5, 1.0, mid_gain);\n            let eq_right = b_hi_shelf_ar(mid_right, high_freq, 1.0, high_gain);\n\n            [eq_left, eq_right]\n        })\n});",
    "category": "effects",
    "subcategory": "filters",
    "path": "effects/filters/eq_three_band.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Filters"
  },
  {
    "name": "formant_filter",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 800
      },
      {
        "name": "attack",
        "default": 0.01
      },
      {
        "name": "decay",
        "default": 0.1
      },
      {
        "name": "mix",
        "default": 0.7
      }
    ],
    "type": "fx",
    "source": "define_fx(\"formant_filter\", |builder| {\n    builder\n        .param(\"freq\", 800.0)\n        .param(\"attack\", 0.01)\n        .param(\"decay\", 0.1)\n        .param(\"mix\", 0.7)\n        .body(|input, freq, attack, decay, mix| {\n            // Apply formant filtering\n            let formant_left = formlet_ar(input[0], freq, attack, decay);\n            let formant_right = formlet_ar(input[1], freq, attack, decay);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * formant_left,\n                (1.0 - mix) * input[1] + mix * formant_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "filters",
    "path": "effects/filters/formant_filter.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Filters"
  },
  {
    "name": "highpass",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "cutoff",
        "default": 200
      },
      {
        "name": "resonance",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"highpass\", |builder| {\n    builder\n        .param(\"cutoff\", 200.0)\n        .param(\"resonance\", 0.5)\n        .param(\"mix\", 1.0)\n        .body(|input, cutoff, resonance, mix| {\n            // RHPF provides resonant high pass filtering\n            let filtered_left = rhpf_ar(input[0], cutoff, resonance);\n            let filtered_right = rhpf_ar(input[1], cutoff, resonance);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "filters",
    "path": "effects/filters/highpass.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Filters"
  },
  {
    "name": "ladder_filter",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "cutoff",
        "default": 1000
      },
      {
        "name": "res",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"ladder_filter\", |builder| {\n    builder\n        .param(\"cutoff\", 1000.0)\n        .param(\"res\", 0.5)\n        .param(\"mix\", 1.0)\n        .body(|input, cutoff, res, mix| {\n            // Multi-stage lowpass for ladder characteristic\n            let stage1_left = lpf_ar(input[0], cutoff);\n            let stage2_left = lpf_ar(stage1_left, cutoff);\n            let stage3_left = lpf_ar(stage2_left, cutoff);\n            let stage4_left = lpf_ar(stage3_left, cutoff);\n\n            let stage1_right = lpf_ar(input[1], cutoff);\n            let stage2_right = lpf_ar(stage1_right, cutoff);\n            let stage3_right = lpf_ar(stage2_right, cutoff);\n            let stage4_right = lpf_ar(stage3_right, cutoff);\n\n            // Add resonance feedback\n            let feedback = res * 3.8;\n            let res_left = stage4_left + input[0] * feedback * 0.1;\n            let res_right = stage4_right + input[1] * feedback * 0.1;\n\n            [\n                (1.0 - mix) * input[0] + mix * res_left,\n                (1.0 - mix) * input[1] + mix * res_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "filters",
    "path": "effects/filters/ladder_filter.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Filters"
  },
  {
    "name": "lowpass",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "cutoff",
        "default": 2000
      },
      {
        "name": "resonance",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"lowpass\", |builder| {\n    builder\n        .param(\"cutoff\", 2000.0)\n        .param(\"resonance\", 0.5)\n        .param(\"mix\", 1.0)\n        .body(|input, cutoff, resonance, mix| {\n            // RLPF provides resonant low pass filtering\n            let filtered_left = rlpf_ar(input[0], cutoff, resonance);\n            let filtered_right = rlpf_ar(input[1], cutoff, resonance);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "filters",
    "path": "effects/filters/lowpass.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Filters"
  },
  {
    "name": "moog_filter",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "cutoff",
        "default": 1000
      },
      {
        "name": "resonance",
        "default": 2.5
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"moog_filter\", |builder| {\n    builder\n        .param(\"cutoff\", 1000.0)\n        .param(\"resonance\", 2.5)\n        .param(\"mix\", 1.0)\n        .body(|input, cutoff, resonance, mix| {\n            // MoogFF - the classic Moog ladder filter\n            let filtered_left = moog_ff_ar(input[0], cutoff, resonance, 0.0);\n            let filtered_right = moog_ff_ar(input[1], cutoff, resonance, 0.0);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "filters",
    "path": "effects/filters/moog_filter.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Filters"
  },
  {
    "name": "resonator",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "decay",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"resonator\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"decay\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, freq, decay, mix| {\n            // Comb filter for resonance\n            let delay_time = 1.0 / freq;\n            let resonated_left = comb_c_ar(input[0], 0.05, delay_time, decay * 2.0);\n            let resonated_right = comb_c_ar(input[1], 0.05, delay_time, decay * 2.0);\n\n            [\n                (1.0 - mix) * input[0] + mix * resonated_left,\n                (1.0 - mix) * input[1] + mix * resonated_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "filters",
    "path": "effects/filters/resonator.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Filters"
  },
  {
    "name": "auto_pan",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "rate",
        "default": 0.25
      },
      {
        "name": "depth",
        "default": 0.8
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"auto_pan\", |builder| {\n    builder\n        .param(\"rate\", 0.25)\n        .param(\"depth\", 0.8)\n        .param(\"mix\", 1.0)\n        .body(|input, rate, depth, mix| {\n            // LFO for pan position\n            let lfo = sin_osc_ar(rate, 0.0);\n            let pan_pos = lfo * depth;\n\n            // Mix to mono first, then pan\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Pan the signal and split into stereo channels\n            let stereo = channels(pan2_ar(mono, pan_pos, 1.0), 2);\n\n            // Mix dry and wet signals\n            [\n                (1.0 - mix) * input[0] + mix * stereo[0],\n                (1.0 - mix) * input[1] + mix * stereo[1]\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/auto_pan.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "auto_wah",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "sensitivity",
        "default": 0.5
      },
      {
        "name": "depth",
        "default": 2000
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"auto_wah\", |builder| {\n    builder\n        .param(\"sensitivity\", 0.5)\n        .param(\"depth\", 2000.0)\n        .param(\"mix\", 1.0)\n        .body(|input, sensitivity, depth, mix| {\n            // Envelope follower\n            let env_left = amplitude_ar(input[0], 0.01, 0.1);\n            let env_right = amplitude_ar(input[1], 0.01, 0.1);\n\n            // Calculate filter cutoff based on envelope\n            let cutoff_left = 400.0 + env_left * sensitivity * depth;\n            let cutoff_right = 400.0 + env_right * sensitivity * depth;\n\n            // Resonant bandpass for wah character\n            let wah_left = bpf_ar(input[0], cutoff_left, 0.2);\n            let wah_right = bpf_ar(input[1], cutoff_right, 0.2);\n\n            [\n                (1.0 - mix) * input[0] + mix * wah_left,\n                (1.0 - mix) * input[1] + mix * wah_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/auto_wah.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "chorus",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "rate",
        "default": 0.5
      },
      {
        "name": "depth",
        "default": 0.01
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"chorus\", |builder| {\n    builder\n        .param(\"rate\", 0.5)\n        .param(\"depth\", 0.01)\n        .param(\"mix\", 0.5)\n        .body(|input, rate, depth, mix| {\n            // LFO for modulation\n            let lfo_left = sin_osc_ar(rate, 0.0);\n            let lfo_right = sin_osc_ar(rate, 1.57); // 90 degrees phase offset\n\n            // Modulated delay time\n            let delay_time_left = 0.02 + (depth * lfo_left);\n            let delay_time_right = 0.02 + (depth * lfo_right);\n\n            // Delayed signals with interpolation for smooth modulation\n            let delayed_left = delay_c_ar(input[0], 0.1, delay_time_left);\n            let delayed_right = delay_c_ar(input[1], 0.1, delay_time_right);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * delayed_left,\n                (1.0 - mix) * input[1] + mix * delayed_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/chorus.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "dimension_chorus",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "mode",
        "default": 0.5
      },
      {
        "name": "rate",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"dimension_chorus\", |builder| {\n    builder\n        .param(\"mode\", 0.5)\n        .param(\"rate\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, mode, rate, mix| {\n            let lfo_rate = 0.3 + rate * 1.2;\n\n            // Four BBD-style delay lines with different phases\n            let lfo1 = sin_osc_ar(lfo_rate) * mode * 0.003;\n            let lfo2 = sin_osc_ar(lfo_rate, 1.57) * mode * 0.003;  // 90 degrees\n            let lfo3 = sin_osc_ar(lfo_rate, 3.14) * mode * 0.003; // 180 degrees\n            let lfo4 = sin_osc_ar(lfo_rate, 4.71) * mode * 0.003; // 270 degrees\n\n            // Base delay times (BBD character)\n            let base_delay = 0.005 + mode * 0.005;\n\n            // Chorus voices - left channel\n            let voice1_l = delay_c_ar(input[0], 0.05, base_delay + lfo1);\n            let voice2_l = delay_c_ar(input[0], 0.05, base_delay * 1.1 + lfo3);\n\n            // Chorus voices - right channel\n            let voice1_r = delay_c_ar(input[1], 0.05, base_delay + lfo2);\n            let voice2_r = delay_c_ar(input[1], 0.05, base_delay * 1.1 + lfo4);\n\n            // Subtle high frequency roll-off (BBD character)\n            let chorus_l = lpf_ar((voice1_l + voice2_l) * 0.5, 12000.0);\n            let chorus_r = lpf_ar((voice1_r + voice2_r) * 0.5, 12000.0);\n\n            // Mix with slight cross-feed for dimension\n            let wet_l = chorus_l + chorus_r * 0.15;\n            let wet_r = chorus_r + chorus_l * 0.15;\n\n            [\n                (1.0 - mix) * input[0] + mix * wet_l,\n                (1.0 - mix) * input[1] + mix * wet_r\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/dimension_chorus.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "flanger",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "rate",
        "default": 0.3
      },
      {
        "name": "depth",
        "default": 0.005
      },
      {
        "name": "feedback",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"flanger\", |builder| {\n    builder\n        .param(\"rate\", 0.3)\n        .param(\"depth\", 0.005)\n        .param(\"feedback\", 0.5)\n        .param(\"mix\", 0.5)\n        .body(|input, rate, depth, feedback, mix| {\n            // LFO for modulation\n            let lfo = sin_osc_ar(rate, 0.0);\n\n            // Modulated delay time (shorter than chorus for flanger effect)\n            let delay_time = 0.003 + (depth * lfo);\n\n            // Create delayed signals with feedback\n            let delayed_left = delay_c_ar(input[0] + (feedback * delay_c_ar(input[0], 0.02, delay_time)), 0.02, delay_time);\n            let delayed_right = delay_c_ar(input[1] + (feedback * delay_c_ar(input[1], 0.02, delay_time)), 0.02, delay_time);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * delayed_left,\n                (1.0 - mix) * input[1] + mix * delayed_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/flanger.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "freq_shift",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "shift",
        "default": 5
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"freq_shift\", |builder| {\n    builder\n        .param(\"shift\", 5.0)\n        .param(\"mix\", 0.5)\n        .body(|input, shift, mix| {\n            // Ring modulation with sine wave creates frequency shifting\n            // Positive shift moves frequencies up, negative moves down\n            let mod_osc = sin_osc_ar(shift.abs());\n\n            // Apply ring modulation\n            let shifted_left = input[0] * mod_osc;\n            let shifted_right = input[1] * mod_osc;\n\n            // Filter to remove unwanted sidebands\n            let filtered_left = lpf_ar(shifted_left, 12000.0);\n            let filtered_right = lpf_ar(shifted_right, 12000.0);\n\n            // Mix dry and wet\n            [\n                (1.0 - mix) * input[0] + mix * filtered_left,\n                (1.0 - mix) * input[1] + mix * filtered_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/freq_shift.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "phaser",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "rate",
        "default": 0.5
      },
      {
        "name": "depth",
        "default": 1000
      },
      {
        "name": "freq",
        "default": 1000
      },
      {
        "name": "feedback",
        "default": 0.3
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"phaser\", |builder| {\n    builder\n        .param(\"rate\", 0.5)\n        .param(\"depth\", 1000.0)\n        .param(\"freq\", 1000.0)\n        .param(\"feedback\", 0.3)\n        .param(\"mix\", 0.5)\n        .body(|input, rate, depth, freq, feedback, mix| {\n            // LFO for filter modulation\n            let lfo = sin_osc_ar(rate, 0.0);\n            let mod_freq = freq + (depth * lfo);\n\n            // Chain of all-pass filters for phaser effect\n            let phased_left = input[0];\n            let phased_right = input[1];\n\n            // Apply multiple stages of all-pass filtering\n            phased_left = allpass_n_ar(phased_left, 0.02, 1.0 / mod_freq, 0.0);\n            phased_left = allpass_n_ar(phased_left, 0.02, 1.0 / (mod_freq * 1.5), 0.0);\n            phased_left = allpass_n_ar(phased_left, 0.02, 1.0 / (mod_freq * 2.0), 0.0);\n\n            phased_right = allpass_n_ar(phased_right, 0.02, 1.0 / mod_freq, 0.0);\n            phased_right = allpass_n_ar(phased_right, 0.02, 1.0 / (mod_freq * 1.5), 0.0);\n            phased_right = allpass_n_ar(phased_right, 0.02, 1.0 / (mod_freq * 2.0), 0.0);\n\n            // Add feedback\n            phased_left = phased_left + (feedback * phased_left);\n            phased_right = phased_right + (feedback * phased_right);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * phased_left,\n                (1.0 - mix) * input[1] + mix * phased_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/phaser.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "pitch_shift",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "ratio",
        "default": 1.5
      },
      {
        "name": "window",
        "default": 0.2
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"pitch_shift\", |builder| {\n    builder\n        .param(\"ratio\", 1.5)\n        .param(\"window\", 0.2)\n        .param(\"mix\", 0.5)\n        .body(|input, ratio, window, mix| {\n            // Apply pitch shifting to both channels\n            let shifted_left = pitch_shift_ar(input[0], window, ratio, 0.0, 0.0);\n            let shifted_right = pitch_shift_ar(input[1], window, ratio, 0.0, 0.0);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * shifted_left,\n                (1.0 - mix) * input[1] + mix * shifted_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/pitch_shift.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "ring_mod",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"ring_mod\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"mix\", 0.5)\n        .body(|input, freq, mix| {\n            // Generate modulator (carrier wave)\n            let modulator = sin_osc_ar(freq, 0.0);\n\n            // Ring modulation: multiply input by modulator\n            let modulated = [\n                input[0] * modulator,\n                input[1] * modulator\n            ];\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * modulated[0],\n                (1.0 - mix) * input[1] + mix * modulated[1]\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/ring_mod.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "rotary",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "rate",
        "default": 6
      },
      {
        "name": "depth",
        "default": 0.003
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"rotary\", |builder| {\n    builder\n        .param(\"rate\", 6.0)\n        .param(\"depth\", 0.003)\n        .param(\"mix\", 1.0)\n        .body(|input, rate, depth, mix| {\n            // Mix to mono for effect\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // LFOs for modulation (90 degrees apart for stereo)\n            let lfo_left = sin_osc_ar(rate, 0.0);\n            let lfo_right = sin_osc_ar(rate, 1.57);\n\n            // Doppler effect (pitch modulation via delay)\n            let delay_left = 0.005 + (depth * lfo_left);\n            let delay_right = 0.005 + (depth * lfo_right);\n\n            let doppler_left = delay_c_ar(mono, 0.1, delay_left);\n            let doppler_right = delay_c_ar(mono, 0.1, delay_right);\n\n            // Amplitude modulation (volume changes as speaker rotates)\n            let amp_mod_left = 0.8 + (0.2 * lfo_left);\n            let amp_mod_right = 0.8 + (0.2 * lfo_right);\n\n            // Combine effects\n            let rotated = [\n                doppler_left * amp_mod_left,\n                doppler_right * amp_mod_right\n            ];\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * rotated[0],\n                (1.0 - mix) * input[1] + mix * rotated[1]\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/rotary.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "tremolo",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "rate",
        "default": 4
      },
      {
        "name": "depth",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"tremolo\", |builder| {\n    builder\n        .param(\"rate\", 4.0)\n        .param(\"depth\", 0.5)\n        .param(\"mix\", 1.0)\n        .body(|input, rate, depth, mix| {\n            // LFO for amplitude modulation\n            let lfo = sin_osc_ar(rate, 0.0);\n\n            // Convert LFO from -1..1 to modulation range\n            let mod = 1.0 - (depth * 0.5 * (1.0 + lfo));\n\n            // Apply modulation to both channels\n            let modulated = [\n                input[0] * mod,\n                input[1] * mod\n            ];\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * modulated[0],\n                (1.0 - mix) * input[1] + mix * modulated[1]\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/tremolo.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "vibrato",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "rate",
        "default": 5
      },
      {
        "name": "depth",
        "default": 0.002
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"vibrato\", |builder| {\n    builder\n        .param(\"rate\", 5.0)\n        .param(\"depth\", 0.002)\n        .param(\"mix\", 1.0)\n        .body(|input, rate, depth, mix| {\n            // LFO for pitch modulation\n            let lfo = sin_osc_ar(rate, 0.0);\n\n            // Modulated delay time creates pitch variation\n            let delay_time = 0.01 + (depth * lfo);\n\n            // Apply modulated delay\n            let vibrato_left = delay_c_ar(input[0], 0.1, delay_time);\n            let vibrato_right = delay_c_ar(input[1], 0.1, delay_time);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * vibrato_left,\n                (1.0 - mix) * input[1] + mix * vibrato_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "modulation",
    "path": "effects/modulation/vibrato.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Modulation"
  },
  {
    "name": "gverb",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "roomsize",
        "default": 50
      },
      {
        "name": "revtime",
        "default": 3
      },
      {
        "name": "damping",
        "default": 0.5
      },
      {
        "name": "spread",
        "default": 15
      },
      {
        "name": "drylevel",
        "default": 0.7
      },
      {
        "name": "earlylevel",
        "default": 0.7
      },
      {
        "name": "taillevel",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 0.35
      }
    ],
    "type": "fx",
    "source": "define_fx(\"gverb\", |builder| {\n    builder\n        .param(\"roomsize\", 50.0)\n        .param(\"revtime\", 3.0)\n        .param(\"damping\", 0.5)\n        .param(\"spread\", 15.0)\n        .param(\"drylevel\", 0.7)\n        .param(\"earlylevel\", 0.7)\n        .param(\"taillevel\", 0.5)\n        .param(\"mix\", 0.35)\n        .body(|input, roomsize, revtime, damping, spread, drylevel, earlylevel, taillevel, mix| {\n            // Mix to mono for the reverb input\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Split the stereo outputs and apply dry/wet mix manually\n            let wet_node = g_verb_ar(mono, roomsize, revtime, damping, 0.5, spread, drylevel, earlylevel, taillevel, 300.0);\n            let wet_left = channel(wet_node, 0);\n            let wet_right = channel(wet_node, 1);\n\n            [\n                (1.0 - mix) * input[0] + mix * wet_left,\n                (1.0 - mix) * input[1] + mix * wet_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "reverbs",
    "path": "effects/reverbs/gverb.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Reverbs"
  },
  {
    "name": "hall_reverb",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "size",
        "default": 0.7
      },
      {
        "name": "decay",
        "default": 0.6
      },
      {
        "name": "damping",
        "default": 0.4
      },
      {
        "name": "predelay",
        "default": 0.02
      },
      {
        "name": "mix",
        "default": 0.35
      }
    ],
    "type": "fx",
    "source": "define_fx(\"hall_reverb\", |builder| {\n    builder\n        .param(\"size\", 0.7)\n        .param(\"decay\", 0.6)\n        .param(\"damping\", 0.4)\n        .param(\"predelay\", 0.02)\n        .param(\"mix\", 0.35)\n        .body(|input, size, decay, damping, predelay, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Pre-delay for source separation\n            let predelayed = delay_c_ar(mono, 0.2, predelay);\n\n            // FreeVerb as core reverb engine with hall-like settings\n            let verb = free_verb_ar(predelayed, 1.0, 0.5 + size * 0.45, damping);\n\n            // Additional diffusion for hall character\n            let diff1 = allpass_c_ar(verb, 0.2, 0.067 * (1.0 + size), decay * 0.6);\n            let diff2 = allpass_c_ar(diff1, 0.2, 0.093 * (1.0 + size), decay * 0.5);\n            let diff3 = allpass_c_ar(diff2, 0.2, 0.117 * (1.0 + size), decay * 0.4);\n\n            // Late reflections\n            let late1 = delay_c_ar(diff3, 0.5, 0.13 + size * 0.15) * 0.4;\n            let late2 = delay_c_ar(diff3, 0.5, 0.19 + size * 0.12) * 0.3;\n            let late3 = delay_c_ar(diff3, 0.5, 0.27 + size * 0.1) * 0.2;\n\n            let combined = diff3 + late1 + late2 + late3;\n\n            // High frequency roll-off for natural air absorption\n            let damped = lpf_ar(combined, 8000.0 - damping * 4000.0);\n\n            // Stereo decorrelation\n            let left = damped + delay_c_ar(damped, 0.05, 0.011) * 0.3;\n            let right = damped + delay_c_ar(damped, 0.05, 0.017) * 0.3;\n\n            [\n                (1.0 - mix) * input[0] + mix * left * 0.7,\n                (1.0 - mix) * input[1] + mix * right * 0.7\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "reverbs",
    "path": "effects/reverbs/hall_reverb.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Reverbs"
  },
  {
    "name": "plate_reverb",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "time",
        "default": 2
      },
      {
        "name": "damping",
        "default": 0.4
      },
      {
        "name": "mix",
        "default": 0.3
      }
    ],
    "type": "fx",
    "source": "define_fx(\"plate_reverb\", |builder| {\n    builder\n        .param(\"time\", 2.0)\n        .param(\"damping\", 0.4)\n        .param(\"mix\", 0.3)\n        .body(|input, time, damping, mix| {\n            // Mix to mono\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Pre-delay\n            let predelayed = delay_n_ar(mono, 0.1, 0.02);\n\n            // High frequency damping\n            let damped = lpf_ar(predelayed, 8000.0 * (1.0 - damping));\n\n            // Series of allpass filters for diffusion\n            let diffused = damped;\n            diffused = allpass_c_ar(diffused, 0.1, 0.0297, time * 0.1);\n            diffused = allpass_c_ar(diffused, 0.1, 0.0371, time * 0.1);\n            diffused = allpass_c_ar(diffused, 0.1, 0.0411, time * 0.1);\n            diffused = allpass_c_ar(diffused, 0.1, 0.0437, time * 0.1);\n\n            // Parallel comb filters for reverb tail\n            let comb1 = comb_l_ar(diffused, 0.2, 0.0297, time);\n            let comb2 = comb_l_ar(diffused, 0.2, 0.0371, time);\n            let comb3 = comb_l_ar(diffused, 0.2, 0.0411, time);\n            let comb4 = comb_l_ar(diffused, 0.2, 0.0437, time);\n\n            // Mix combs\n            let reverb = (comb1 + comb2 + comb3 + comb4) * 0.25;\n\n            // Create stereo with slight decorrelation\n            let left = reverb;\n            let right = delay_n_ar(reverb, 0.01, 0.005);\n\n            // Mix dry and wet signals\n            let output = [\n                (1.0 - mix) * input[0] + mix * left,\n                (1.0 - mix) * input[1] + mix * right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "reverbs",
    "path": "effects/reverbs/plate_reverb.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Reverbs"
  },
  {
    "name": "reverb",
    "description": "Intentionally simple (“dumb”) reverb made from delays and filters so it is easy to debug.",
    "genre": "",
    "character": "",
    "params": [],
    "type": "fx",
    "source": "// Intentionally simple (“dumb”) reverb made from delays and filters so it is easy to debug.\n// This is not a studio-quality algorithm, but it makes the effect extremely obvious.\n\ndefine_fx(\"reverb\")\n    .param(\"room\", 0.6)\n    .param(\"damp\", 0.4)\n    .param(\"mix\", 0.3)\n    .body(|input, room, damp, mix| {\n        // Collapse to mono, run FreeVerb fully wet, then duplicate.\n        let mono = (input[0] + input[1]) * 0.5;\n        let wet = free_verb_ar(mono, 1.0, room, damp);\n        let stereo = dup(wet, 2);\n\n        [\n            (1.0 - mix) * input[0] + mix * stereo[0],\n            (1.0 - mix) * input[1] + mix * stereo[1]\n        ]\n    });\n",
    "category": "effects",
    "subcategory": "reverbs",
    "path": "effects/reverbs/reverb.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Reverbs"
  },
  {
    "name": "reverb_minimal",
    "description": "damp: High-frequency damping (0.0 to 1.0)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "room",
        "default": 0.6
      },
      {
        "name": "damp",
        "default": 0.4
      }
    ],
    "type": "fx",
    "source": "define_fx(\"reverb_minimal\", |builder| {\n    builder\n        .param(\"room\", 0.6)\n        .param(\"damp\", 0.4)\n        .body(|input, room, damp| {\n            // Collapse to mono so we only need a single FreeVerb output.\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Run FreeVerb fully wet (mix=1.0) and duplicate the result to stereo.\n            let wet = free_verb_ar(mono, 1.0, room, damp);\n            let stereo = dup(wet, 2);\n\n            stereo\n        })\n});",
    "category": "effects",
    "subcategory": "reverbs",
    "path": "effects/reverbs/reverb_minimal.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Reverbs"
  },
  {
    "name": "room_reverb",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "size",
        "default": 0.4
      },
      {
        "name": "brightness",
        "default": 0.5
      },
      {
        "name": "mix",
        "default": 0.25
      }
    ],
    "type": "fx",
    "source": "define_fx(\"room_reverb\", |builder| {\n    builder\n        .param(\"size\", 0.4)\n        .param(\"brightness\", 0.5)\n        .param(\"mix\", 0.25)\n        .body(|input, size, brightness, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Early reflections (room walls simulation)\n            let er1 = delay_c_ar(mono, 0.1, 0.007 + size * 0.01) * 0.6;\n            let er2 = delay_c_ar(mono, 0.1, 0.013 + size * 0.015) * 0.5;\n            let er3 = delay_c_ar(mono, 0.1, 0.019 + size * 0.02) * 0.4;\n            let er4 = delay_c_ar(mono, 0.1, 0.027 + size * 0.025) * 0.3;\n            let er5 = delay_c_ar(mono, 0.1, 0.037 + size * 0.03) * 0.25;\n\n            let early = er1 + er2 + er3 + er4 + er5;\n\n            // Diffuse tail\n            let room = 0.3 + size * 0.4;\n            let tail = free_verb_ar(early, 1.0, room, 0.6 - brightness * 0.4);\n\n            // Natural room tone (absorptive surfaces)\n            let cutoff = 6000.0 + brightness * 6000.0;\n            let filtered = lpf_ar(tail, cutoff);\n\n            // Create stereo from early reflections\n            let left_er = er1 + er3 * 0.7 + er5 * 0.5;\n            let right_er = er2 + er4 * 0.7 + er5 * 0.5;\n\n            let wet_left = filtered + left_er * 0.3;\n            let wet_right = filtered + right_er * 0.3;\n\n            [\n                (1.0 - mix) * input[0] + mix * wet_left * 0.8,\n                (1.0 - mix) * input[1] + mix * wet_right * 0.8\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "reverbs",
    "path": "effects/reverbs/room_reverb.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Reverbs"
  },
  {
    "name": "shimmer_reverb",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "size",
        "default": 0.7
      },
      {
        "name": "shimmer",
        "default": 0.4
      },
      {
        "name": "pitch",
        "default": 2
      },
      {
        "name": "decay",
        "default": 0.6
      },
      {
        "name": "mix",
        "default": 0.4
      }
    ],
    "type": "fx",
    "source": "define_fx(\"shimmer_reverb\", |builder| {\n    builder\n        .param(\"size\", 0.7)\n        .param(\"shimmer\", 0.4)\n        .param(\"pitch\", 2.0)\n        .param(\"decay\", 0.6)\n        .param(\"mix\", 0.4)\n        .body(|input, size, shimmer, pitch, decay, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Main reverb\n            let verb = free_verb_ar(mono, 1.0, 0.5 + size * 0.45, 0.3);\n\n            // Pitch shifter for shimmer effect (using delay-based pitch approximation)\n            let shift_time = 0.05 / pitch;\n            let shifted = delay_c_ar(verb, 0.2, shift_time);\n\n            // Feed the shifted signal back through more reverb\n            let shimmer_verb = free_verb_ar(shifted * shimmer, 1.0, 0.7, 0.5);\n\n            // Combine layers with decay\n            let layer1 = verb;\n            let layer2 = shimmer_verb * decay * 0.6;\n            let layer3 = delay_c_ar(shimmer_verb, 0.5, 0.2) * decay * 0.4;\n\n            let combined = layer1 + layer2 + layer3;\n\n            // Smooth high frequencies for ethereal character\n            let smoothed = lpf_ar(combined, 10000.0);\n\n            // Add subtle modulation\n            let mod_lfo = sin_osc_ar(0.3) * 0.002;\n            let modulated = delay_c_ar(smoothed, 0.05, 0.02 + mod_lfo);\n\n            // Wide stereo spread\n            let left = modulated;\n            let right = delay_c_ar(modulated, 0.02, 0.007);\n\n            [\n                (1.0 - mix) * input[0] + mix * left * 0.6,\n                (1.0 - mix) * input[1] + mix * right * 0.6\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "reverbs",
    "path": "effects/reverbs/shimmer_reverb.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Reverbs"
  },
  {
    "name": "spring_reverb",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "tension",
        "default": 0.5
      },
      {
        "name": "diffusion",
        "default": 0.6
      },
      {
        "name": "mix",
        "default": 0.35
      }
    ],
    "type": "fx",
    "source": "define_fx(\"spring_reverb\", |builder| {\n    builder\n        .param(\"tension\", 0.5)\n        .param(\"diffusion\", 0.6)\n        .param(\"mix\", 0.35)\n        .body(|input, tension, diffusion, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Spring simulation using comb filters with slightly detuned delays\n            let base_time = 0.03 + (1.0 - tension) * 0.04;\n\n            // Multiple spring modes (simulating the coils)\n            let spring1 = delay_c_ar(mono, 0.2, base_time) * 0.5;\n            let spring2 = delay_c_ar(mono, 0.2, base_time * 1.13) * 0.4;\n            let spring3 = delay_c_ar(mono, 0.2, base_time * 1.27) * 0.3;\n            let spring4 = delay_c_ar(mono, 0.2, base_time * 0.87) * 0.35;\n\n            // Combine springs\n            let springs = spring1 + spring2 + spring3 + spring4;\n\n            // Add metallic resonance (characteristic spring \"boing\")\n            let resonance = rlpf_ar(springs, 2800.0 + tension * 1000.0, 0.3);\n\n            // Diffusion through allpass filtering\n            let diffused = allpass_c_ar(resonance, 0.1, 0.05 * diffusion, 0.5 * diffusion);\n\n            // High frequency damping for natural decay\n            let damped = lpf_ar(diffused, 4500.0 - (1.0 - tension) * 1500.0);\n\n            // Add subtle modulation for organic feel\n            let mod_lfo = sin_osc_ar(0.8) * 0.001;\n            let modulated = delay_c_ar(damped, 0.05, 0.02 + mod_lfo);\n\n            // Create stereo spread\n            let left = modulated;\n            let right = delay_c_ar(modulated, 0.01, 0.003);\n\n            [\n                (1.0 - mix) * input[0] + mix * left,\n                (1.0 - mix) * input[1] + mix * right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "reverbs",
    "path": "effects/reverbs/spring_reverb.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Reverbs"
  },
  {
    "name": "haas",
    "description": "mix: Effect intensity (0.0 = no effect, 1.0 = maximum)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "delay_time",
        "default": 0.015
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"haas\", |builder| {\n    builder\n        .param(\"delay_time\", 0.015)\n        .param(\"mix\", 0.5)\n        .body(|input, delay_time, mix| {\n            // Mix to mono\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Delay one channel\n            let delayed = delay_n_ar(mono, 0.1, delay_time);\n\n            // Create stereo image\n            let haas_left = mono;\n            let haas_right = delayed;\n\n            // Mix with original\n            let output = [\n                (1.0 - mix) * input[0] + mix * haas_left,\n                (1.0 - mix) * input[1] + mix * haas_right\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "spatial",
    "path": "effects/spatial/haas.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Spatial"
  },
  {
    "name": "stereo_enhancer",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = processed)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "width",
        "default": 1.2
      },
      {
        "name": "center",
        "default": "0.0"
      },
      {
        "name": "bass_mono",
        "default": 100
      },
      {
        "name": "mix",
        "default": 1
      }
    ],
    "type": "fx",
    "source": "define_fx(\"stereo_enhancer\", |builder| {\n    builder\n        .param(\"width\", 1.2)\n        .param(\"center\", 0.0)\n        .param(\"bass_mono\", 100.0)\n        .param(\"mix\", 1.0)\n        .body(|input, width, center, bass_mono, mix| {\n            // Encode to Mid/Side\n            let mid = (input[0] + input[1]) * 0.5;\n            let side = (input[0] - input[1]) * 0.5;\n\n            // Apply width to sides\n            let wide_side = side * width;\n\n            // Apply center boost/cut\n            let center_boost = 1.0 + center * 0.5;\n            let side_cut = 1.0 - center * 0.5;\n            let processed_mid = mid * center_boost;\n            let processed_side = wide_side * side_cut;\n\n            // Decode back to L/R\n            let wide_l = processed_mid + processed_side;\n            let wide_r = processed_mid - processed_side;\n\n            // Bass mono (sum low frequencies to center)\n            let bass_l = lpf_ar(input[0], bass_mono);\n            let bass_r = lpf_ar(input[1], bass_mono);\n            let bass_mono_sig = (bass_l + bass_r) * 0.5;\n\n            // Remove bass from widened signal, add mono bass\n            let no_bass_l = hpf_ar(wide_l, bass_mono);\n            let no_bass_r = hpf_ar(wide_r, bass_mono);\n\n            let final_l = no_bass_l + bass_mono_sig;\n            let final_r = no_bass_r + bass_mono_sig;\n\n            [\n                (1.0 - mix) * input[0] + mix * final_l,\n                (1.0 - mix) * input[1] + mix * final_r\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "spatial",
    "path": "effects/spatial/stereo_enhancer.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Spatial"
  },
  {
    "name": "stereo_width",
    "description": "width: Stereo width (0.0 = mono, 1.0 = normal, 2.0 = maximum width)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "width",
        "default": 1.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"stereo_width\", |builder| {\n    builder\n        .param(\"width\", 1.5)\n        .body(|input, width| {\n            // Mid-side processing\n            let mid = (input[0] + input[1]) * 0.5;\n            let side = (input[0] - input[1]) * 0.5;\n\n            // Apply width to side signal\n            let side_widened = side * width;\n\n            // Convert back to left-right\n            let output = [\n                mid + side_widened,\n                mid - side_widened\n            ];\n\n            output\n        })\n});",
    "category": "effects",
    "subcategory": "spatial",
    "path": "effects/spatial/stereo_width.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Spatial"
  },
  {
    "name": "dc_blocker",
    "description": "coef: Filter coefficient (0.9 to 0.999, higher = more bass removed)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "coef",
        "default": 0.995
      }
    ],
    "type": "fx",
    "source": "define_fx(\"dc_blocker\", |builder| {\n    builder\n        .param(\"coef\", 0.995)\n        .body(|input, coef| {\n            // Apply DC blocking filter\n            let blocked_left = leak_dc_ar(input[0], coef);\n            let blocked_right = leak_dc_ar(input[1], coef);\n\n            [blocked_left, blocked_right]\n        })\n});",
    "category": "effects",
    "subcategory": "utility",
    "path": "effects/utility/dc_blocker.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Utility"
  },
  {
    "name": "stutter",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "rate",
        "default": 8
      },
      {
        "name": "mix",
        "default": 0.5
      }
    ],
    "type": "fx",
    "source": "define_fx(\"stutter\", |builder| {\n    builder\n        .param(\"rate\", 8.0)\n        .param(\"mix\", 0.5)\n        .body(|input, rate, mix| {\n            // Buffer size based on rate\n            let buf_time = 1.0 / rate;\n\n            // Stuttered signal using comb filter technique\n            let stutter_left = comb_c_ar(input[0], 0.5, buf_time, 0.0);\n            let stutter_right = comb_c_ar(input[1], 0.5, buf_time, 0.0);\n\n            [\n                (1.0 - mix) * input[0] + mix * stutter_left,\n                (1.0 - mix) * input[1] + mix * stutter_right\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "utility",
    "path": "effects/utility/stutter.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Utility"
  },
  {
    "name": "vocoder",
    "description": "mix: Dry/wet mix (0.0 = dry, 1.0 = wet)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "bands",
        "default": 16
      },
      {
        "name": "mix",
        "default": 0.8
      }
    ],
    "type": "fx",
    "source": "define_fx(\"vocoder\", |builder| {\n    builder\n        .param(\"bands\", 16.0)\n        .param(\"mix\", 0.8)\n        .body(|input, bands, mix| {\n            let mono = (input[0] + input[1]) * 0.5;\n\n            // Simplified vocoder using multiple bandpass filters\n            let band1 = bpf_ar(mono, 200.0, 0.2) * 0.2;\n            let band2 = bpf_ar(mono, 400.0, 0.2) * 0.2;\n            let band3 = bpf_ar(mono, 800.0, 0.2) * 0.2;\n            let band4 = bpf_ar(mono, 1600.0, 0.2) * 0.2;\n            let band5 = bpf_ar(mono, 3200.0, 0.2) * 0.15;\n            let band6 = bpf_ar(mono, 6400.0, 0.2) * 0.1;\n\n            let wet = band1 + band2 + band3 + band4 + band5 + band6;\n\n            [\n                (1.0 - mix) * input[0] + mix * wet,\n                (1.0 - mix) * input[1] + mix * wet\n            ]\n        })\n});",
    "category": "effects",
    "subcategory": "utility",
    "path": "effects/utility/vocoder.vibe",
    "categoryName": "Effects",
    "subcategoryName": "Utility"
  },
  {
    "name": "atmosphere_bright",
    "description": "Genre: Ambient, New Age | Character: Bright ethereal atmosphere",
    "genre": "Ambient, New Age",
    "character": "Bright ethereal atmosphere",
    "params": [
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"atmosphere_bright\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(1.5, 1.0, 1.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Shimmering high frequencies\n            let shimmer1 = sin_osc_ar(2000.0 + sin_osc_ar(0.3) * 200.0);\n            let shimmer2 = sin_osc_ar(3000.0 + sin_osc_ar(0.4) * 150.0);\n            let shimmer3 = sin_osc_ar(4500.0 + sin_osc_ar(0.5) * 100.0);\n\n            let shimmer = (shimmer1 + shimmer2 * 0.6 + shimmer3 * 0.3) * 0.1;\n\n            // Warm pad underneath\n            let pad_freq = 200.0;\n            let pad = sin_osc_ar(pad_freq) + sin_osc_ar(pad_freq * 2.0) * 0.4;\n            let pad_filtered = lpf_ar(pad, 1000.0) * 0.2;\n\n            // Air texture\n            let air = hpf_ar(pink_noise_ar(), 4000.0) * 0.08;\n\n            let mix = shimmer + pad_filtered + air;\n\n            mix * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "atmospheres",
    "path": "fx/atmospheres/atmosphere_bright.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Atmospheres"
  },
  {
    "name": "atmosphere_dark",
    "description": "Genre: Dark Ambient, Horror | Character: Dark foreboding atmosphere",
    "genre": "Dark Ambient, Horror",
    "character": "Dark foreboding atmosphere",
    "params": [
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"atmosphere_dark\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(2.0, 1.0, 2.0)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep drone\n            let drone_freq = 40.0 + sin_osc_ar(0.05) * 5.0;\n            let drone = sin_osc_ar(drone_freq) + sin_osc_ar(drone_freq * 1.5) * 0.4;\n\n            // Distant thunder-like rumble\n            let rumble = lpf_ar(pink_noise_ar(), 60.0);\n            let rumble_mod = rumble * (sin_osc_ar(0.1) * 0.5 + 0.5);\n\n            // Eerie high frequencies\n            let high = sin_osc_ar(2000.0 + sin_osc_ar(0.07) * 300.0) * 0.03;\n\n            // Subtle metallic resonance\n            let metal = rlpf_ar(pink_noise_ar(), 800.0, 0.05) * 0.1;\n\n            let mix = drone * 0.3 + rumble_mod * 0.4 + high + metal;\n\n            mix * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "atmospheres",
    "path": "fx/atmospheres/atmosphere_dark.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Atmospheres"
  },
  {
    "name": "atmosphere_pulse",
    "description": "Genre: Electronic, Techno | Character: Pulsing rhythmic atmosphere",
    "genre": "Electronic, Techno",
    "character": "Pulsing rhythmic atmosphere",
    "params": [
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "rate",
        "default": 2
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"atmosphere_pulse\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .param(\"rate\", 2.0)\n        .param(\"gate\", 1.0)\n        .body(|amp, rate, gate| {\n            let env = envelope()\n                .asr(0.5, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pulsing LFO\n            let pulse_lfo = sin_osc_ar(rate) * 0.5 + 0.5;\n\n            // Sub pulse\n            let sub = sin_osc_ar(50.0) * pulse_lfo * 0.4;\n\n            // Mid-range pulse\n            let mid = saw_ar(100.0) + saw_ar(100.5);\n            let mid_filtered = lpf_ar(mid, 400.0) * pulse_lfo * 0.2;\n\n            // High shimmer\n            let high = hpf_ar(white_noise_ar(), 6000.0) * pulse_lfo * 0.1;\n\n            let mix = sub + mid_filtered + high;\n\n            mix * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "atmospheres",
    "path": "fx/atmospheres/atmosphere_pulse.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Atmospheres"
  },
  {
    "name": "atmosphere_tension",
    "description": "Genre: Cinematic, Horror | Character: Tense building atmosphere",
    "genre": "Cinematic, Horror",
    "character": "Tense building atmosphere",
    "params": [
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"atmosphere_tension\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(1.0, 1.0, 1.0)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Dissonant cluster\n            let freq = 100.0;\n            let tone1 = sin_osc_ar(freq);\n            let tone2 = sin_osc_ar(freq * 1.06);  // Minor 2nd\n            let tone3 = sin_osc_ar(freq * 1.41);  // Tritone\n            let tone4 = sin_osc_ar(freq * 1.89);  // Minor 7th\n\n            let cluster = (tone1 + tone2 * 0.7 + tone3 * 0.5 + tone4 * 0.4) * 0.2;\n\n            // Slow tremolo for unease\n            let trem = sin_osc_ar(0.5) * 0.3 + 0.7;\n\n            // High drone\n            let high = sin_osc_ar(3000.0 + sin_osc_ar(0.1) * 500.0) * 0.05;\n\n            // Low rumble\n            let rumble = lpf_ar(pink_noise_ar(), 80.0) * 0.3;\n\n            let mix = cluster * trem + high + rumble;\n\n            mix * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "atmospheres",
    "path": "fx/atmospheres/atmosphere_tension.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Atmospheres"
  },
  {
    "name": "atmosphere_wind",
    "description": "Genre: Ambient, Cinematic | Character: Wind/outdoor atmosphere",
    "genre": "Ambient, Cinematic",
    "character": "Wind/outdoor atmosphere",
    "params": [
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"atmosphere_wind\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(1.0, 1.0, 1.0)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Base wind noise\n            let wind = pink_noise_ar();\n\n            // Slow modulation for gusts\n            let gust1 = sin_osc_ar(0.15) * 0.4 + 0.6;\n            let gust2 = sin_osc_ar(0.23) * 0.3 + 0.7;\n\n            // Multiple filtered bands\n            let low_wind = lpf_ar(wind, 300.0) * gust1 * 0.5;\n            let mid_wind = lpf_ar(hpf_ar(wind, 200.0), 2000.0) * gust2 * 0.4;\n            let high_wind = hpf_ar(wind, 3000.0) * gust1 * gust2 * 0.2;\n\n            // Whistling (occasional high resonance)\n            let whistle = rlpf_ar(wind, 1500.0 + sin_osc_ar(0.1) * 500.0, 0.05) * 0.15;\n\n            let mix = low_wind + mid_wind + high_wind + whistle;\n\n            mix * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "atmospheres",
    "path": "fx/atmospheres/atmosphere_wind.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Atmospheres"
  },
  {
    "name": "downer_filtered",
    "description": "Genre: House, Techno | Character: Resonant filter downlifter",
    "genre": "House, Techno",
    "character": "Resonant filter downlifter",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 2.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"downer_filtered\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 2.5)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.05, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            let down_env = 1.0 - env;\n\n            // Rich source\n            let source = saw_ar(100.0) + pulse_ar(100.0, 0.3) * 0.5;\n\n            // Highly resonant falling filter\n            let cutoff = 300.0 + down_env * 8000.0;\n            let filtered = rlpf_ar(source, cutoff, 0.15);\n\n            // Second resonant peak\n            let peak2 = rlpf_ar(source, cutoff * 0.5, 0.2) * 0.4;\n\n            (filtered + peak2) * env * amp * 0.7\n        })\n});",
    "category": "fx",
    "subcategory": "downers",
    "path": "fx/downers/downer_filtered.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Downers"
  },
  {
    "name": "downer_noise",
    "description": "Genre: EDM, House | Character: Noise-based downlifter",
    "genre": "EDM, House",
    "character": "Noise-based downlifter",
    "params": [
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "duration",
        "default": 2
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"downer_noise\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .param(\"duration\", 2.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.01, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Inverted envelope for downward motion\n            let down_env = 1.0 - env;\n\n            // Falling filter on noise\n            let noise = white_noise_ar();\n            let cutoff = 200.0 + down_env * 10000.0;\n            let filtered = lpf_ar(noise, cutoff);\n\n            // Resonant sweep\n            let res = rlpf_ar(noise, cutoff * 0.8, 0.25) * 0.5;\n\n            (filtered + res) * env * amp * 0.7\n        })\n});",
    "category": "fx",
    "subcategory": "downers",
    "path": "fx/downers/downer_noise.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Downers"
  },
  {
    "name": "downer_pitch",
    "description": "Genre: EDM, Dubstep | Character: Pitch-falling downlifter",
    "genre": "EDM, Dubstep",
    "character": "Pitch-falling downlifter",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 2
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"downer_pitch\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 2.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.01, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Falling pitch\n            let down_env = 1.0 - env;\n            let freq = 60.0 + down_env * 800.0;\n\n            // Multiple oscillators for thickness\n            let osc1 = sin_osc_ar(freq);\n            let osc2 = sin_osc_ar(freq * 1.01);\n            let osc3 = sin_osc_ar(freq * 0.99);\n            let osc4 = saw_ar(freq * 0.5) * 0.3;\n\n            let combined = (osc1 + osc2 + osc3) * 0.3 + osc4;\n\n            // Add filtered noise\n            let noise = lpf_ar(white_noise_ar(), freq * 2.0) * 0.2;\n\n            (combined + noise) * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "downers",
    "path": "fx/downers/downer_pitch.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Downers"
  },
  {
    "name": "downer_slow",
    "description": "Genre: Ambient, Cinematic | Character: Slow atmospheric downer",
    "genre": "Ambient, Cinematic",
    "character": "Slow atmospheric downer",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"downer_slow\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 6.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.5, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            let down_env = 1.0 - env;\n\n            // Slowly falling pad-like tone\n            let freq = 80.0 + down_env * 300.0;\n            let pad1 = sin_osc_ar(freq);\n            let pad2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let pad3 = sin_osc_ar(freq * 3.0) * 0.2;\n\n            // Slow modulation\n            let mod_lfo = sin_osc_ar(0.2) * 0.1 + 0.9;\n            let pad = (pad1 + pad2 + pad3) * mod_lfo * 0.4;\n\n            // Descending noise texture\n            let noise = pink_noise_ar();\n            let noise_filtered = lpf_ar(noise, 500.0 + down_env * 3000.0) * 0.2;\n\n            (pad + noise_filtered) * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "downers",
    "path": "fx/downers/downer_slow.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Downers"
  },
  {
    "name": "downer_synth",
    "description": "Genre: Trance, Progressive | Character: Synth-based downlifter",
    "genre": "Trance, Progressive",
    "character": "Synth-based downlifter",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"downer_synth\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 3.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.1, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            let down_env = 1.0 - env;\n\n            // Falling supersaw\n            let freq = 100.0 + down_env * 600.0;\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.005);\n            let saw3 = saw_ar(freq * 0.995);\n            let saw4 = saw_ar(freq * 1.01);\n            let saw5 = saw_ar(freq * 0.99);\n\n            let supersaw = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.15;\n\n            // Closing filter\n            let cutoff = 500.0 + down_env * 6000.0;\n            let filtered = rlpf_ar(supersaw, cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "downers",
    "path": "fx/downers/downer_synth.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Downers"
  },
  {
    "name": "impact_bass_drop",
    "description": "Genre: Dubstep, EDM | Character: Bass drop impact",
    "genre": "Dubstep, EDM",
    "character": "Bass drop impact",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"impact_bass_drop\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch-dropping sine\n            let pitch_e = envelope()\n                .perc(0.001, 0.3)\n                .build();\n            let freq = 200.0 - pitch_e * 160.0;\n            let drop = sin_osc_ar(freq);\n\n            // Sub layer\n            let sub_e = envelope()\n                .perc(0.01, 1.2)\n                .build();\n            let sub = sin_osc_ar(35.0) * sub_e * 0.8;\n\n            // Distorted layer for aggression\n            let dist = (drop * 4.0).tanh() * 0.4;\n\n            // Click transient\n            let click = white_noise_ar();\n            let click_e = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let click_filtered = lpf_ar(click, 5000.0) * click_e * 0.3;\n\n            let mix = drop * env * 0.5 + sub + dist * env + click_filtered;\n\n            mix * amp * 0.6\n        })\n});",
    "category": "fx",
    "subcategory": "impacts",
    "path": "fx/impacts/impact_bass_drop.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Impacts"
  },
  {
    "name": "impact_hard",
    "description": "Genre: EDM, Cinematic | Character: Hard, aggressive impact",
    "genre": "EDM, Cinematic",
    "character": "Hard, aggressive impact",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"impact_hard\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Quick attack, medium decay\n            let env = envelope()\n                .perc(0.001, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Low frequency punch\n            let sub = sin_osc_ar(50.0) * 0.6;\n\n            // Noise component for impact\n            let noise = white_noise_ar();\n            let filtered_noise = lpf_ar(noise, 2000.0) * 0.4;\n\n            // Metallic component\n            let metal = (sin_osc_ar(180.0) + sin_osc_ar(320.0) + sin_osc_ar(580.0)) * 0.2;\n\n            let mix = sub + filtered_noise + metal;\n\n            mix * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "impacts",
    "path": "fx/impacts/impact_hard.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Impacts"
  },
  {
    "name": "impact_industrial",
    "description": "Genre: Industrial, Dark Techno | Character: Harsh industrial impact",
    "genre": "Industrial, Dark Techno",
    "character": "Harsh industrial impact",
    "params": [
      {
        "name": "amp",
        "default": 0.8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"impact_industrial\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic resonance\n            let metal1 = sin_osc_ar(230.0);\n            let metal2 = sin_osc_ar(470.0);\n            let metal3 = sin_osc_ar(890.0);\n            let metal4 = sin_osc_ar(1340.0);\n            let metal = metal1 + metal2 * 0.7 + metal3 * 0.5 + metal4 * 0.3;\n            let metal_e = envelope()\n                .perc(0.001, 0.5)\n                .build();\n\n            // Distorted body\n            let body = saw_ar(60.0) + pulse_ar(90.0, 0.2);\n            let body_dist = (body * 5.0).tanh();\n            let body_e = envelope()\n                .perc(0.001, 0.4)\n                .build();\n\n            // Noise burst with resonance\n            let noise = white_noise_ar();\n            let noise_filtered = rlpf_ar(noise, 2000.0, 0.15);\n            let noise_e = envelope()\n                .perc(0.001, 0.1)\n                .build();\n\n            let mix = metal * metal_e * 0.3 + body_dist * body_e * 0.4 + noise_filtered * noise_e * 0.4;\n\n            mix * env * amp * 0.7\n        })\n});",
    "category": "fx",
    "subcategory": "impacts",
    "path": "fx/impacts/impact_industrial.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Impacts"
  },
  {
    "name": "impact_metallic",
    "description": "Genre: Industrial, Experimental | Character: Metallic, resonant impact",
    "genre": "Industrial, Experimental",
    "character": "Metallic, resonant impact",
    "params": [
      {
        "name": "amp",
        "default": 0.8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"impact_metallic\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            // Sharp attack, long resonance\n            let env = envelope()\n                .perc(0.001, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Inharmonic metallic frequencies\n            let metal1 = sin_osc_ar(280.0) * 0.3;\n            let metal2 = sin_osc_ar(470.0) * 0.25;\n            let metal3 = sin_osc_ar(710.0) * 0.2;\n            let metal4 = sin_osc_ar(980.0) * 0.15;\n            let metal5 = sin_osc_ar(1350.0) * 0.1;\n\n            let mix = metal1 + metal2 + metal3 + metal4 + metal5;\n\n            // Add noise burst\n            let noise_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let noise = white_noise_ar() * noise_env * 0.3;\n            let filtered_noise = hpf_ar(noise, 3000.0);\n\n            (mix + filtered_noise) * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "impacts",
    "path": "fx/impacts/impact_metallic.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Impacts"
  },
  {
    "name": "impact_noise",
    "description": "Genre: All | Character: Noise-based impact, versatile",
    "genre": "All",
    "character": "Noise-based impact, versatile",
    "params": [
      {
        "name": "amp",
        "default": 0.8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"impact_noise\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            // Quick decay\n            let env = envelope()\n                .perc(0.002, 0.6)\n                .cleanup_on_finish()\n                .build();\n\n            // Layered noise for fullness\n            let low_noise = lpf_ar(pink_noise_ar(), 800.0) * 0.5;\n            let mid_noise = rlpf_ar(white_noise_ar(), 2500.0, 0.5) * 0.3;\n            let high_noise = hpf_ar(white_noise_ar(), 4000.0) * 0.2;\n\n            let mix = low_noise + mid_noise + high_noise;\n\n            mix * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "impacts",
    "path": "fx/impacts/impact_noise.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Impacts"
  },
  {
    "name": "impact_orchestral",
    "description": "Genre: Orchestral, Classical | Character: Orchestra tutti hit",
    "genre": "Orchestral, Classical",
    "character": "Orchestra tutti hit",
    "params": [
      {
        "name": "amp",
        "default": 0.9
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"impact_orchestral\", |builder| {\n    builder\n        .param(\"amp\", 0.9)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.02, 2.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Brass section\n            let brass1 = saw_ar(130.0);\n            let brass2 = saw_ar(196.0);\n            let brass3 = saw_ar(262.0);\n            let brass = (brass1 + brass2 * 0.8 + brass3 * 0.6) * 0.2;\n            let brass_filtered = lpf_ar(brass, 1200.0);\n            let brass_e = envelope()\n                .perc(0.02, 1.5)\n                .build();\n\n            // String section\n            let str1 = sin_osc_ar(262.0);\n            let str2 = sin_osc_ar(392.0);\n            let str3 = sin_osc_ar(523.0);\n            let strings = (str1 + str2 * 0.7 + str3 * 0.5) * 0.25;\n            let str_e = envelope()\n                .perc(0.05, 2.0)\n                .build();\n\n            // Timpani-like bass\n            let timp = sin_osc_ar(65.0) + sin_osc_ar(130.0) * 0.4;\n            let timp_e = envelope()\n                .perc(0.001, 0.8)\n                .build();\n\n            // Cymbal crash\n            let cymbal = hpf_ar(white_noise_ar(), 6000.0);\n            let cym_e = envelope()\n                .perc(0.01, 1.5)\n                .build();\n\n            let mix = brass_filtered * brass_e + strings * str_e + timp * timp_e * 0.5 + cymbal * cym_e * 0.15;\n\n            mix * amp * 0.5\n        })\n});",
    "category": "fx",
    "subcategory": "impacts",
    "path": "fx/impacts/impact_orchestral.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Impacts"
  },
  {
    "name": "impact_soft",
    "description": "Genre: Ambient, Cinematic | Character: Soft, subtle impact",
    "genre": "Ambient, Cinematic",
    "character": "Soft, subtle impact",
    "params": [
      {
        "name": "amp",
        "default": 0.8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"impact_soft\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            // Gentle envelope\n            let env = envelope()\n                .perc(0.005, 1.2)\n                .cleanup_on_finish()\n                .build();\n\n            // Low frequency body\n            let sub = sin_osc_ar(80.0) * 0.5;\n\n            // Filtered noise\n            let noise = pink_noise_ar();\n            let filtered_noise = lpf_ar(noise, 1500.0) * 0.3;\n\n            // Warm tone\n            let tone = sin_osc_ar(150.0) * 0.2;\n\n            let mix = sub + filtered_noise + tone;\n\n            mix * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "impacts",
    "path": "fx/impacts/impact_soft.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Impacts"
  },
  {
    "name": "impact_sub",
    "description": "Genre: Dubstep, Bass Music | Character: Deep sub impact",
    "genre": "Dubstep, Bass Music",
    "character": "Deep sub impact",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"impact_sub\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            // Medium decay\n            let env = envelope()\n                .perc(0.002, 1.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Very low frequencies\n            let sub1 = sin_osc_ar(35.0) * 0.6;\n            let sub2 = sin_osc_ar(70.0) * 0.3;\n\n            // Minimal noise for definition\n            let noise_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n            let noise = pink_noise_ar() * noise_env * 0.1;\n            let filtered_noise = lpf_ar(noise, 300.0);\n\n            let mix = sub1 + sub2 + filtered_noise;\n\n            mix * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "impacts",
    "path": "fx/impacts/impact_sub.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Impacts"
  },
  {
    "name": "impact_trailer",
    "description": "Genre: Trailer, Action | Character: Massive trailer hit",
    "genre": "Trailer, Action",
    "character": "Massive trailer hit",
    "params": [
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"impact_trailer\", |builder| {\n    builder\n        .param(\"amp\", 1.0)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 3.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple sub harmonics for weight\n            let sub1 = sin_osc_ar(30.0) * 0.6;\n            let sub2 = sin_osc_ar(45.0) * 0.4;\n            let sub3 = sin_osc_ar(60.0) * 0.3;\n            let sub_e = envelope()\n                .perc(0.001, 2.0)\n                .build();\n            let subs = (sub1 + sub2 + sub3) * sub_e;\n\n            // Distorted mid-range punch\n            let mid = saw_ar(100.0) + saw_ar(150.0) * 0.5;\n            let mid_dist = (mid * 3.0).tanh();\n            let mid_e = envelope()\n                .perc(0.001, 0.5)\n                .build();\n            let mid_filtered = lpf_ar(mid_dist, 800.0) * mid_e * 0.4;\n\n            // High-end crack\n            let crack = white_noise_ar();\n            let crack_e = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let crack_filtered = hpf_ar(crack, 2000.0) * crack_e * 0.5;\n\n            // Resonant tail\n            let tail_freq = 80.0 + env * 40.0;\n            let tail = rlpf_ar(pink_noise_ar(), tail_freq, 0.1) * env * 0.2;\n\n            let mix = subs + mid_filtered + crack_filtered + tail;\n\n            mix * amp * 0.5\n        })\n});",
    "category": "fx",
    "subcategory": "impacts",
    "path": "fx/impacts/impact_trailer.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Impacts"
  },
  {
    "name": "riser_cinematic",
    "description": "Genre: Trailer, Film Score | Character: Epic cinematic riser",
    "genre": "Trailer, Film Score",
    "character": "Epic cinematic riser",
    "params": [
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "duration",
        "default": 5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"riser_cinematic\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .param(\"duration\", 5.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.5, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep brass-like foundation\n            let brass_freq = 60.0 + env * 100.0;\n            let brass = saw_ar(brass_freq) + saw_ar(brass_freq * 1.5) * 0.5;\n            let brass_filtered = lpf_ar(brass, 800.0 + env * 2000.0) * 0.3;\n\n            // String-like shimmer layer\n            let string_freq = 220.0 + env * 440.0;\n            let strings = sin_osc_ar(string_freq) + sin_osc_ar(string_freq * 2.01) * 0.5;\n            let string_vib = sin_osc_ar(5.0) * 0.01 + 1.0;\n            let strings_mod = strings * string_vib * env * 0.3;\n\n            // Noise texture\n            let noise = pink_noise_ar();\n            let noise_filtered = hpf_ar(lpf_ar(noise, 4000.0 + env * 8000.0), 200.0) * 0.2;\n\n            // Sub layer\n            let sub = sin_osc_ar(40.0 + env * 20.0) * 0.4;\n\n            // Combine all layers\n            let mix = brass_filtered + strings_mod + noise_filtered * env + sub;\n\n            mix * env * amp * 0.5\n        })\n});",
    "category": "fx",
    "subcategory": "risers",
    "path": "fx/risers/riser_cinematic.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Risers"
  },
  {
    "name": "riser_filtered",
    "description": "Genre: Techno, Trance | Character: Resonant filtered riser",
    "genre": "Techno, Trance",
    "character": "Resonant filtered riser",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"riser_filtered\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .body(|amp| {\n            // Rise envelope\n            let env = envelope()\n                .perc(0.02, 2.8)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise\n            let noise = white_noise_ar();\n\n            // Aggressive filter sweep with high resonance\n            let filter_env = envelope()\n                .perc(0.4, 2.6)\n                .build();\n            let mod_cutoff = 300.0 + (filter_env * 10000.0);\n\n            let filtered = rlpf_ar(noise, mod_cutoff, 0.15);\n\n            filtered * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "risers",
    "path": "fx/risers/riser_filtered.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Risers"
  },
  {
    "name": "riser_pink_noise",
    "description": "Genre: House, Techno | Character: Pink noise riser, warmer than white",
    "genre": "House, Techno",
    "character": "Pink noise riser, warmer than white",
    "params": [
      {
        "name": "amp",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"riser_pink_noise\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Long rise\n            let env = envelope()\n                .perc(0.02, 3.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise for warmth\n            let noise = pink_noise_ar();\n\n            // Filter sweep\n            let filter_env = envelope()\n                .perc(0.6, 3.2)\n                .build();\n            let mod_cutoff = 150.0 + (filter_env * 6000.0);\n\n            let filtered = lpf_ar(noise, mod_cutoff);\n\n            // High-pass for clarity\n            let clean = hpf_ar(filtered, 80.0);\n\n            clean * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "risers",
    "path": "fx/risers/riser_pink_noise.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Risers"
  },
  {
    "name": "riser_pitch",
    "description": "Genre: Trance, EDM | Character: Pitch-rising synth",
    "genre": "Trance, EDM",
    "character": "Pitch-rising synth",
    "params": [
      {
        "name": "start_freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"riser_pitch\", |builder| {\n    builder\n        .param(\"start_freq\", 55.0)\n        .param(\"amp\", 0.5)\n        .body(|start_freq, amp| {\n            // Rise envelope\n            let env = envelope()\n                .perc(0.02, 3.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch sweep envelope\n            let pitch_env = envelope()\n                .perc(0.5, 2.8)\n                .build();\n            let freq = start_freq + (pitch_env * start_freq * 8.0);\n\n            // Multiple detuned oscillators\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.005);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Filter\n            let filtered = lpf_ar(mix, 4000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "risers",
    "path": "fx/risers/riser_pitch.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Risers"
  },
  {
    "name": "riser_reverse",
    "description": "Genre: Experimental, IDM | Character: Reverse-style riser effect",
    "genre": "Experimental, IDM",
    "character": "Reverse-style riser effect",
    "params": [
      {
        "name": "amp",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"riser_reverse\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Reverse envelope (starts high, fades slightly, then rises)\n            let env = envelope()\n                .perc(1.5, 2.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise\n            let noise = pink_noise_ar();\n\n            // Filter sweeps backwards then forwards\n            let filter_env = envelope()\n                .perc(1.2, 1.8)\n                .build();\n            let mod_cutoff = 5000.0 + (filter_env * 5000.0);\n\n            let filtered = lpf_ar(noise, mod_cutoff);\n\n            // Resonance\n            let resonant = rlpf_ar(filtered, mod_cutoff * 0.7, 0.4);\n\n            resonant * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "risers",
    "path": "fx/risers/riser_reverse.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Risers"
  },
  {
    "name": "riser_shepard",
    "description": "Genre: Electronic, Cinematic | Character: Shepard tone illusion riser",
    "genre": "Electronic, Cinematic",
    "character": "Shepard tone illusion riser",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"riser_shepard\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 6.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.1, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Shepard tone: multiple octaves fading in/out\n            let base_freq = 110.0;\n            let rise = env * 2.0; // Rise two octaves over duration\n\n            // Calculate frequencies for each octave layer\n            let f1 = base_freq * (1.0 + rise);\n            let f2 = f1 * 2.0;\n            let f3 = f1 * 4.0;\n            let f4 = f1 * 0.5;\n\n            // Amplitude curves (gaussian-like) centered on mid frequencies\n            let a1 = (1.0 - (f1 / 880.0 - 1.0).abs()).max(0.0);\n            let a2 = (1.0 - (f2 / 880.0 - 1.0).abs()).max(0.0);\n            let a3 = (1.0 - (f3 / 880.0 - 1.0).abs()).max(0.0);\n            let a4 = (1.0 - (f4 / 880.0 - 1.0).abs()).max(0.0);\n\n            // Generate tones\n            let tone1 = sin_osc_ar(f1) * a1;\n            let tone2 = sin_osc_ar(f2) * a2;\n            let tone3 = sin_osc_ar(f3) * a3;\n            let tone4 = sin_osc_ar(f4) * a4;\n\n            let combined = (tone1 + tone2 + tone3 + tone4) * 0.25;\n\n            combined * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "risers",
    "path": "fx/risers/riser_shepard.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Risers"
  },
  {
    "name": "riser_synth",
    "description": "Genre: Trance, Progressive | Character: Synth-based melodic riser",
    "genre": "Trance, Progressive",
    "character": "Synth-based melodic riser",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"riser_synth\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 4.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.1, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Rising pitch from low to high\n            let pitch = 80.0 + env * 800.0;\n\n            // Supersaw-style riser\n            let saw1 = saw_ar(pitch);\n            let saw2 = saw_ar(pitch * 1.005);\n            let saw3 = saw_ar(pitch * 0.995);\n            let saw4 = saw_ar(pitch * 1.01);\n            let saw5 = saw_ar(pitch * 0.99);\n\n            let supersaw = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.15;\n\n            // Filter opening with rise\n            let cutoff = 500.0 + env * 8000.0;\n            let filtered = rlpf_ar(supersaw, cutoff, 0.4);\n\n            // Add shimmer\n            let shimmer = sin_osc_ar(pitch * 4.0) * env * 0.1;\n\n            (filtered + shimmer) * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "risers",
    "path": "fx/risers/riser_synth.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Risers"
  },
  {
    "name": "riser_tension",
    "description": "Genre: Cinematic, EDM | Character: Building tension riser",
    "genre": "Cinematic, EDM",
    "character": "Building tension riser",
    "params": [
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "duration",
        "default": 4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"riser_tension\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .param(\"duration\", 4.0)\n        .body(|amp, duration| {\n            // Main envelope\n            let env = envelope()\n                .perc(0.01, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned oscillators for tension\n            let freq_env = env * env * 400.0 + 60.0;  // Accelerating pitch rise\n            let osc1 = sin_osc_ar(freq_env);\n            let osc2 = sin_osc_ar(freq_env * 1.01);\n            let osc3 = sin_osc_ar(freq_env * 0.99);\n            let osc4 = saw_ar(freq_env * 2.0) * 0.3;\n\n            let combined = (osc1 + osc2 + osc3) * 0.3 + osc4;\n\n            // Rising noise layer\n            let noise = white_noise_ar() * env * 0.3;\n            let filtered_noise = hpf_ar(noise, 2000.0 + env * 6000.0);\n\n            // Combine\n            let mix = combined + filtered_noise;\n\n            // Add resonant peak for drama\n            let resonant = rlpf_ar(mix, 1000.0 + env * 4000.0, 0.2);\n\n            resonant * env * amp * 0.6\n        })\n});",
    "category": "fx",
    "subcategory": "risers",
    "path": "fx/risers/riser_tension.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Risers"
  },
  {
    "name": "riser_vocal",
    "description": "Genre: Future Bass, Pop | Character: Vocal formant riser",
    "genre": "Future Bass, Pop",
    "character": "Vocal formant riser",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"riser_vocal\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 3.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.2, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Rising pitch\n            let pitch = 150.0 + env * 400.0;\n\n            // Rich harmonic source\n            let source = saw_ar(pitch) + pulse_ar(pitch, 0.3) * 0.5;\n\n            // Morphing formants (ah -> ee transition)\n            let f1_start = 800.0;\n            let f1_end = 400.0;\n            let f2_start = 1200.0;\n            let f2_end = 2200.0;\n\n            let f1 = f1_start + env * (f1_end - f1_start);\n            let f2 = f2_start + env * (f2_end - f2_start);\n\n            // Apply formant filters\n            let formant1 = rlpf_ar(source, f1, 0.1);\n            let formant2 = rlpf_ar(source, f2, 0.15);\n            let formant3 = rlpf_ar(source, 2600.0, 0.2);\n\n            let vocal = formant1 * 0.5 + formant2 * 0.3 + formant3 * 0.2;\n\n            // Add breathiness\n            let breath = hpf_ar(pink_noise_ar(), 3000.0) * env * 0.15;\n\n            (vocal + breath) * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "risers",
    "path": "fx/risers/riser_vocal.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Risers"
  },
  {
    "name": "riser_white_noise",
    "description": "Genre: EDM, Trap | Character: White noise riser with filter sweep",
    "genre": "EDM, Trap",
    "character": "White noise riser with filter sweep",
    "params": [
      {
        "name": "amp",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"riser_white_noise\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Long rise envelope\n            let env = envelope()\n                .perc(0.01, 3.0)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise source\n            let noise = white_noise_ar();\n\n            // Rising filter sweep\n            let filter_env = envelope()\n                .perc(0.5, 2.8)\n                .build();\n            let mod_cutoff = 200.0 + (filter_env * 8000.0);\n\n            let filtered = lpf_ar(noise, mod_cutoff);\n\n            // Resonance for emphasis\n            let resonant = rlpf_ar(filtered, mod_cutoff * 0.8, 0.3);\n\n            resonant * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "risers",
    "path": "fx/risers/riser_white_noise.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Risers"
  },
  {
    "name": "stinger_brass",
    "description": "Genre: Trailer, Cinematic | Character: Brass stinger hit",
    "genre": "Trailer, Cinematic",
    "character": "Brass stinger hit",
    "params": [
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "note",
        "default": 60
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stinger_brass\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .param(\"note\", 60.0)\n        .body(|amp, note| {\n            let env = envelope()\n                .perc(0.01, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            let freq = 440.0 * (2.0.pow((note - 69.0) / 12.0));\n\n            // Brass-like tone\n            let brass1 = saw_ar(freq);\n            let brass2 = saw_ar(freq * 1.5) * 0.5;\n            let brass3 = saw_ar(freq * 2.0) * 0.3;\n\n            let brass = brass1 + brass2 + brass3;\n\n            // Opening filter for brass attack\n            let filter_e = envelope()\n                .perc(0.01, 0.2)\n                .build();\n            let cutoff = 500.0 + filter_e * 2500.0;\n            let filtered = lpf_ar(brass, cutoff);\n\n            filtered * env * amp * 0.4\n        })\n});",
    "category": "fx",
    "subcategory": "stingers",
    "path": "fx/stingers/stinger_brass.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Stingers"
  },
  {
    "name": "stinger_bright",
    "description": "Genre: Pop, Commercial | Character: Bright positive stinger",
    "genre": "Pop, Commercial",
    "character": "Bright positive stinger",
    "params": [
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "note",
        "default": 72
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stinger_bright\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .param(\"note\", 72.0)\n        .body(|amp, note| {\n            let env = envelope()\n                .perc(0.001, 0.5)\n                .cleanup_on_finish()\n                .build();\n\n            let freq = 440.0 * (2.0.pow((note - 69.0) / 12.0));\n\n            // Bright bell-like tone\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.4;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n\n            let bell = h1 + h2 + h3 + h4 + h5;\n\n            // Add shimmer\n            let shimmer = sin_osc_ar(freq * 6.0) * 0.1;\n            let shimmer_mod = shimmer * sin_osc_ar(10.0);\n\n            let mix = bell + shimmer_mod;\n\n            mix * env * amp * 0.4\n        })\n});",
    "category": "fx",
    "subcategory": "stingers",
    "path": "fx/stingers/stinger_bright.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Stingers"
  },
  {
    "name": "stinger_dark",
    "description": "Genre: Horror, Dark Ambient | Character: Dark ominous stinger",
    "genre": "Horror, Dark Ambient",
    "character": "Dark ominous stinger",
    "params": [
      {
        "name": "amp",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stinger_dark\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Dissonant cluster\n            let freq = 80.0;\n            let tone1 = sin_osc_ar(freq);\n            let tone2 = sin_osc_ar(freq * 1.06);  // Minor second\n            let tone3 = sin_osc_ar(freq * 1.41);  // Tritone\n            let tone4 = sin_osc_ar(freq * 0.5);   // Sub\n\n            let cluster = tone1 + tone2 * 0.7 + tone3 * 0.5 + tone4 * 0.6;\n\n            // Add metallic resonance\n            let metal = sin_osc_ar(300.0) * sin_osc_ar(450.0);\n            let metal_e = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Noise burst\n            let noise = lpf_ar(white_noise_ar(), 2000.0);\n            let noise_e = envelope()\n                .perc(0.001, 0.1)\n                .build();\n\n            let mix = cluster * 0.3 + metal * metal_e * 0.2 + noise * noise_e * 0.3;\n\n            mix * env * amp * 0.6\n        })\n});",
    "category": "fx",
    "subcategory": "stingers",
    "path": "fx/stingers/stinger_dark.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Stingers"
  },
  {
    "name": "stinger_orchestral",
    "description": "Genre: Film Score, Classical | Character: Orchestral tutti stinger",
    "genre": "Film Score, Classical",
    "character": "Orchestral tutti stinger",
    "params": [
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "note",
        "default": 48
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stinger_orchestral\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .param(\"note\", 48.0)\n        .body(|amp, note| {\n            let env = envelope()\n                .perc(0.02, 1.2)\n                .cleanup_on_finish()\n                .build();\n\n            let freq = 440.0 * (2.0.pow((note - 69.0) / 12.0));\n\n            // Strings\n            let str1 = sin_osc_ar(freq);\n            let str2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let strings = (str1 + str2) * 0.3;\n\n            // Brass\n            let brass = saw_ar(freq) + saw_ar(freq * 1.5) * 0.4;\n            let brass_e = envelope()\n                .perc(0.02, 0.6)\n                .build();\n            let brass_filtered = lpf_ar(brass, 1500.0) * brass_e * 0.25;\n\n            // Low end\n            let bass = sin_osc_ar(freq * 0.5) * 0.4;\n\n            // Combine\n            let mix = strings + brass_filtered + bass;\n\n            mix * env * amp * 0.5\n        })\n});",
    "category": "fx",
    "subcategory": "stingers",
    "path": "fx/stingers/stinger_orchestral.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Stingers"
  },
  {
    "name": "stinger_synth",
    "description": "Genre: EDM, Electronic | Character: Synth stab stinger",
    "genre": "EDM, Electronic",
    "character": "Synth stab stinger",
    "params": [
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "note",
        "default": 60
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stinger_synth\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .param(\"note\", 60.0)\n        .body(|amp, note| {\n            let env = envelope()\n                .perc(0.001, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            let freq = 440.0 * (2.0.pow((note - 69.0) / 12.0));\n\n            // Punchy synth\n            let osc1 = saw_ar(freq);\n            let osc2 = pulse_ar(freq, 0.5) * 0.6;\n            let osc3 = saw_ar(freq * 2.0) * 0.3;\n\n            let combined = osc1 + osc2 + osc3;\n\n            // Snappy filter\n            let filter_e = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let cutoff = 800.0 + filter_e * 4000.0;\n            let filtered = rlpf_ar(combined, cutoff, 0.3);\n\n            filtered * env * amp * 0.5\n        })\n});",
    "category": "fx",
    "subcategory": "stingers",
    "path": "fx/stingers/stinger_synth.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Stingers"
  },
  {
    "name": "subdrop_cinematic",
    "description": "Genre: Trailer, Film | Character: Cinematic sub boom",
    "genre": "Trailer, Film",
    "character": "Cinematic sub boom",
    "params": [
      {
        "name": "amp",
        "default": 0.9
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"subdrop_cinematic\", |builder| {\n    builder\n        .param(\"amp\", 0.9)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.02, 3.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep sub with slow pitch descent\n            let pitch_e = envelope()\n                .perc(0.02, 2.0)\n                .build();\n            let freq = 50.0 - pitch_e * 20.0;\n            let sub = sin_osc_ar(freq);\n\n            // Second sub layer\n            let sub2 = sin_osc_ar(freq * 0.5) * 0.5;\n\n            // Mid-range punch\n            let punch = sin_osc_ar(100.0) + sin_osc_ar(150.0) * 0.5;\n            let punch_e = envelope()\n                .perc(0.01, 0.5)\n                .build();\n            let punch_filtered = lpf_ar(punch, 300.0) * punch_e * 0.3;\n\n            // Reverberant tail simulation\n            let tail = sin_osc_ar(40.0) * env * 0.4;\n\n            let mix = sub * 0.6 + sub2 + punch_filtered + tail;\n\n            mix * env * amp * 0.6\n        })\n});",
    "category": "fx",
    "subcategory": "subdrops",
    "path": "fx/subdrops/subdrop_cinematic.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Subdrops"
  },
  {
    "name": "subdrop_classic",
    "description": "Genre: Dubstep, Bass Music | Character: Classic sub drop for emphasis",
    "genre": "Dubstep, Bass Music",
    "character": "Classic sub drop for emphasis",
    "params": [
      {
        "name": "freq",
        "default": 50
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"subdrop_classic\", |builder| {\n    builder\n        .param(\"freq\", 50.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Quick attack, medium decay\n            let env = envelope()\n                .perc(0.01, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch drop envelope\n            let pitch_env = envelope()\n                .perc(0.01, 0.15)\n                .build();\n            let freq_mod = pitch_env * freq * 4.0;\n\n            // Sub sine\n            let sub = sin_osc_ar(freq + freq_mod);\n\n            sub * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "subdrops",
    "path": "fx/subdrops/subdrop_classic.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Subdrops"
  },
  {
    "name": "subdrop_click",
    "description": "Genre: Dubstep, Trap | Character: Sub drop with click attack",
    "genre": "Dubstep, Trap",
    "character": "Sub drop with click attack",
    "params": [
      {
        "name": "freq",
        "default": 50
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"subdrop_click\", |builder| {\n    builder\n        .param(\"freq\", 50.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Envelope\n            let env = envelope()\n                .perc(0.01, 0.7)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch drop\n            let pitch_env = envelope()\n                .perc(0.01, 0.12)\n                .build();\n            let freq_mod = pitch_env * freq * 3.5;\n\n            // Sub\n            let sub = sin_osc_ar(freq + freq_mod);\n\n            // Click for attack definition\n            let click_env = envelope()\n                .perc(0.001, 0.008)\n                .build();\n            let click = white_noise_ar() * click_env * 0.3;\n            let filtered_click = lpf_ar(click, 2000.0);\n\n            (sub + filtered_click) * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "subdrops",
    "path": "fx/subdrops/subdrop_click.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Subdrops"
  },
  {
    "name": "subdrop_deep",
    "description": "Genre: Deep Dubstep | Character: Very deep, chest-hitting sub drop",
    "genre": "Deep Dubstep",
    "character": "Very deep, chest-hitting sub drop",
    "params": [
      {
        "name": "freq",
        "default": 35
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"subdrop_deep\", |builder| {\n    builder\n        .param(\"freq\", 35.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Longer decay for depth\n            let env = envelope()\n                .perc(0.015, 1.2)\n                .cleanup_on_finish()\n                .build();\n\n            // Extended pitch drop\n            let pitch_env = envelope()\n                .perc(0.015, 0.25)\n                .build();\n            let freq_mod = pitch_env * freq * 5.0;\n\n            // Pure sine for maximum sub\n            let sub = sin_osc_ar(freq + freq_mod);\n\n            sub * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "subdrops",
    "path": "fx/subdrops/subdrop_deep.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Subdrops"
  },
  {
    "name": "subdrop_distorted",
    "description": "Genre: Brostep, Heavy Dubstep | Character: Distorted sub drop with grit",
    "genre": "Brostep, Heavy Dubstep",
    "character": "Distorted sub drop with grit",
    "params": [
      {
        "name": "freq",
        "default": 45
      },
      {
        "name": "amp",
        "default": 0.9
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"subdrop_distorted\", |builder| {\n    builder\n        .param(\"freq\", 45.0)\n        .param(\"amp\", 0.9)\n        .body(|freq, amp| {\n            // Envelope\n            let env = envelope()\n                .perc(0.008, 0.9)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch drop\n            let pitch_env = envelope()\n                .perc(0.008, 0.18)\n                .build();\n            let freq_mod = pitch_env * freq * 4.5;\n\n            // Sub with distortion\n            let sub = sin_osc_ar(freq + freq_mod) * 1.8;\n            let driven = clip(sub, -0.9, 0.9);\n\n            driven * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "subdrops",
    "path": "fx/subdrops/subdrop_distorted.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Subdrops"
  },
  {
    "name": "subdrop_long",
    "description": "Genre: Bass Music, Experimental | Character: Long, sustained sub drop",
    "genre": "Bass Music, Experimental",
    "character": "Long, sustained sub drop",
    "params": [
      {
        "name": "freq",
        "default": 50
      },
      {
        "name": "amp",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"subdrop_long\", |builder| {\n    builder\n        .param(\"freq\", 50.0)\n        .param(\"amp\", 1.0)\n        .body(|freq, amp| {\n            // Long decay\n            let env = envelope()\n                .perc(0.02, 2.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Extended pitch drop\n            let pitch_env = envelope()\n                .perc(0.02, 0.4)\n                .build();\n            let freq_mod = pitch_env * freq * 5.0;\n\n            // Sub sine\n            let sub = sin_osc_ar(freq + freq_mod);\n\n            sub * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "subdrops",
    "path": "fx/subdrops/subdrop_long.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Subdrops"
  },
  {
    "name": "subdrop_tight",
    "description": "Genre: Techno, Minimal | Character: Tight controlled sub",
    "genre": "Techno, Minimal",
    "character": "Tight controlled sub",
    "params": [
      {
        "name": "amp",
        "default": 0.8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"subdrop_tight\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 0.6)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast pitch drop\n            let pitch_e = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let freq = 80.0 - pitch_e * 40.0;\n\n            // Clean sine sub\n            let sub = sin_osc_ar(freq);\n\n            // Subtle click\n            let click = white_noise_ar();\n            let click_e = envelope()\n                .perc(0.001, 0.005)\n                .build();\n            let click_filtered = lpf_ar(click, 8000.0) * click_e * 0.15;\n\n            (sub + click_filtered) * env * amp * 0.8\n        })\n});",
    "category": "fx",
    "subcategory": "subdrops",
    "path": "fx/subdrops/subdrop_tight.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Subdrops"
  },
  {
    "name": "subdrop_wobble",
    "description": "Genre: Dubstep, Bass Music | Character: Wobbling sub drop",
    "genre": "Dubstep, Bass Music",
    "character": "Wobbling sub drop",
    "params": [
      {
        "name": "amp",
        "default": 0.8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"subdrop_wobble\", |builder| {\n    builder\n        .param(\"amp\", 0.8)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.001, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch drop\n            let pitch_e = envelope()\n                .perc(0.001, 0.2)\n                .build();\n            let freq = 100.0 - pitch_e * 60.0;\n\n            // Main sub with wobble\n            let wobble_speed = 6.0 + (1.0 - env) * 10.0;  // Speeds up as it decays\n            let wobble = sin_osc_ar(wobble_speed) * 0.5 + 0.5;\n            let sub = sin_osc_ar(freq) * wobble;\n\n            // Second harmonic wobbling\n            let h2 = sin_osc_ar(freq * 2.0) * wobble * 0.3;\n\n            // Click transient\n            let click = white_noise_ar();\n            let click_e = envelope()\n                .perc(0.001, 0.01)\n                .build();\n\n            let mix = sub + h2 + click * click_e * 0.2;\n\n            mix * env * amp * 0.7\n        })\n});",
    "category": "fx",
    "subcategory": "subdrops",
    "path": "fx/subdrops/subdrop_wobble.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Subdrops"
  },
  {
    "name": "sweep_cinematic",
    "description": "Genre: Cinematic, Trailer | Character: Epic cinematic sweep",
    "genre": "Cinematic, Trailer",
    "character": "Epic cinematic sweep",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sweep_cinematic\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 3.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.3, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Rising strings-like layer\n            let string_freq = 200.0 + env * 600.0;\n            let strings = sin_osc_ar(string_freq) + sin_osc_ar(string_freq * 2.0) * 0.5;\n\n            // Brass swell\n            let brass_freq = 100.0 + env * 200.0;\n            let brass = saw_ar(brass_freq) * 0.3;\n            let brass_filtered = lpf_ar(brass, 600.0 + env * 1500.0);\n\n            // Wind/air texture\n            let wind = pink_noise_ar();\n            let wind_filtered = lpf_ar(hpf_ar(wind, 500.0 + env * 2000.0), 4000.0 + env * 6000.0);\n\n            let mix = strings * 0.3 + brass_filtered + wind_filtered * 0.4;\n\n            mix * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "sweeps",
    "path": "fx/sweeps/sweep_cinematic.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Sweeps"
  },
  {
    "name": "sweep_filter_down",
    "description": "Genre: House, Techno | Character: Downward filter sweep",
    "genre": "House, Techno",
    "character": "Downward filter sweep",
    "params": [
      {
        "name": "amp",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sweep_filter_down\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Sweep envelope\n            let env = envelope()\n                .perc(0.01, 2.0)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise source\n            let noise = white_noise_ar();\n\n            // Downward filter sweep (inverted envelope)\n            let filter_env = envelope()\n                .perc(0.01, 0.2)\n                .build();\n            let mod_cutoff = 8000.0 - (filter_env * 7000.0);\n\n            let filtered = rlpf_ar(noise, mod_cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "sweeps",
    "path": "fx/sweeps/sweep_filter_down.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Sweeps"
  },
  {
    "name": "sweep_filter_up",
    "description": "Genre: House, Techno | Character: Upward filter sweep",
    "genre": "House, Techno",
    "character": "Upward filter sweep",
    "params": [
      {
        "name": "amp",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sweep_filter_up\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Sweep envelope\n            let env = envelope()\n                .perc(0.01, 2.0)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise source\n            let noise = white_noise_ar();\n\n            // Upward filter sweep\n            let filter_env = envelope()\n                .perc(0.05, 1.8)\n                .build();\n            let mod_cutoff = 200.0 + (filter_env * 8000.0);\n\n            let filtered = rlpf_ar(noise, mod_cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "sweeps",
    "path": "fx/sweeps/sweep_filter_up.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Sweeps"
  },
  {
    "name": "sweep_laser",
    "description": "Genre: Sci-Fi, Electronic | Character: Laser-style sweep",
    "genre": "Sci-Fi, Electronic",
    "character": "Laser-style sweep",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sweep_laser\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 0.5)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Rapidly falling pitch\n            let freq = 4000.0 - env * 3800.0;\n            let laser = sin_osc_ar(freq);\n\n            // Add harmonics for richness\n            let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.15;\n\n            // Resonant filter sweep\n            let combined = laser + h2 + h3;\n            let filtered = rlpf_ar(combined, freq, 0.2);\n\n            filtered * env * amp * 0.7\n        })\n});",
    "category": "fx",
    "subcategory": "sweeps",
    "path": "fx/sweeps/sweep_laser.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Sweeps"
  },
  {
    "name": "sweep_pitch",
    "description": "Genre: EDM, Trance | Character: Pitch sweep effect",
    "genre": "EDM, Trance",
    "character": "Pitch sweep effect",
    "params": [
      {
        "name": "start_freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sweep_pitch\", |builder| {\n    builder\n        .param(\"start_freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .body(|start_freq, amp| {\n            // Sweep envelope\n            let env = envelope()\n                .perc(0.02, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch sweep\n            let pitch_env = envelope()\n                .perc(0.05, 1.3)\n                .build();\n            let freq = start_freq + (pitch_env * start_freq * 6.0);\n\n            // Detuned oscillators\n            let osc1 = saw_ar(freq * 0.997);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.003);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Filter\n            let filtered = lpf_ar(mix, 5000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "sweeps",
    "path": "fx/sweeps/sweep_pitch.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Sweeps"
  },
  {
    "name": "sweep_release",
    "description": "Genre: EDM, House | Character: Release sweep (post-drop)",
    "genre": "EDM, House",
    "character": "Release sweep (post-drop)",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 2
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sweep_release\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 2.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // High starting point, sweeping down\n            let sweep_env = 1.0 - env;  // Inverse of main envelope\n\n            // Filtered noise sweeping down\n            let noise = white_noise_ar();\n            let cutoff = 12000.0 * sweep_env + 200.0;\n            let filtered = lpf_ar(noise, cutoff);\n\n            // Resonant peak following sweep\n            let res = rlpf_ar(filtered, cutoff * 0.5, 0.2) * 0.5;\n\n            // Pitched component falling\n            let freq = 1000.0 * sweep_env + 100.0;\n            let tone = sin_osc_ar(freq) * 0.3;\n\n            (filtered * 0.5 + res + tone) * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "sweeps",
    "path": "fx/sweeps/sweep_release.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Sweeps"
  },
  {
    "name": "sweep_reverse",
    "description": "Genre: Experimental, IDM | Character: Reverse sweep effect",
    "genre": "Experimental, IDM",
    "character": "Reverse sweep effect",
    "params": [
      {
        "name": "amp",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sweep_reverse\", |builder| {\n    builder\n        .param(\"amp\", 0.6)\n        .body(|amp| {\n            // Reverse-style envelope (builds up)\n            let env = envelope()\n                .perc(0.8, 1.5)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise\n            let noise = white_noise_ar();\n\n            // Reverse filter sweep (starts high, goes low, then back up)\n            let filter_env = envelope()\n                .perc(1.0, 1.2)\n                .build();\n            let mod_cutoff = 6000.0 - (filter_env * 4000.0);\n\n            let filtered = rlpf_ar(noise, mod_cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "sweeps",
    "path": "fx/sweeps/sweep_reverse.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Sweeps"
  },
  {
    "name": "sweep_tension",
    "description": "Genre: Horror, Thriller | Character: Tension-building sweep",
    "genre": "Horror, Thriller",
    "character": "Tension-building sweep",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sweep_tension\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 4.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(1.0, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Dissonant cluster that slowly rises\n            let base = 150.0 + env * 200.0;\n            let tone1 = sin_osc_ar(base);\n            let tone2 = sin_osc_ar(base * 1.06);  // Minor second\n            let tone3 = sin_osc_ar(base * 1.12);  // Augmented\n            let tone4 = sin_osc_ar(base * 0.94);\n\n            let cluster = (tone1 + tone2 + tone3 + tone4) * 0.2;\n\n            // Tremolo for unease\n            let trem = sin_osc_ar(4.0 + env * 8.0) * 0.3 + 0.7;\n            let tremmed = cluster * trem;\n\n            // High-pitched drone\n            let high = sin_osc_ar(2000.0 + env * 3000.0) * env * 0.1;\n\n            // Low rumble\n            let rumble = lpf_ar(pink_noise_ar(), 100.0) * 0.3;\n\n            (tremmed + high + rumble) * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "sweeps",
    "path": "fx/sweeps/sweep_tension.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Sweeps"
  },
  {
    "name": "sweep_whoosh",
    "description": "Genre: Cinematic, Trailer | Character: Whoosh/wind sweep",
    "genre": "Cinematic, Trailer",
    "character": "Whoosh/wind sweep",
    "params": [
      {
        "name": "amp",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sweep_whoosh\", |builder| {\n    builder\n        .param(\"amp\", 0.7)\n        .body(|amp| {\n            // Quick whoosh envelope\n            let env = envelope()\n                .perc(0.005, 0.8)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise for natural wind character\n            let noise = pink_noise_ar();\n\n            // Fast filter sweep for whoosh\n            let filter_env = envelope()\n                .perc(0.01, 0.6)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 6000.0);\n\n            let filtered = rlpf_ar(noise, mod_cutoff, 0.4);\n\n            // High-pass for air\n            let clean = hpf_ar(filtered, 200.0);\n\n            clean * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "sweeps",
    "path": "fx/sweeps/sweep_whoosh.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Sweeps"
  },
  {
    "name": "transition_glitch",
    "description": "Genre: Electronic, Experimental | Character: Glitchy digital transition",
    "genre": "Electronic, Experimental",
    "character": "Glitchy digital transition",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"transition_glitch\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 0.5)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.01, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Digital noise bursts\n            let noise = white_noise_ar();\n\n            // Rapid gate for glitch effect\n            let gate_lfo = pulse_ar(20.0 + env * 60.0, 0.3);\n            let gated = noise * gate_lfo;\n\n            // Bitcrushed character (simulated)\n            let crushed = (gated * 8.0).floor() / 8.0;\n\n            // Pitched glitch element\n            let glitch_freq = 200.0 + env * 2000.0;\n            let glitch_tone = pulse_ar(glitch_freq, 0.1) * 0.3;\n\n            // High-pass for digital character\n            let mix = hpf_ar(crushed + glitch_tone, 500.0);\n\n            mix * env * amp * 0.6\n        })\n});",
    "category": "fx",
    "subcategory": "transitions",
    "path": "fx/transitions/transition_glitch.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Transitions"
  },
  {
    "name": "transition_reverse",
    "description": "Genre: All genres | Character: Reverse cymbal-like transition",
    "genre": "All genres",
    "character": "Reverse cymbal-like transition",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"transition_reverse\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .body(|amp| {\n            // Reverse envelope (builds up)\n            let env = envelope()\n                .perc(0.9, 0.05)\n                .cleanup_on_finish()\n                .build();\n\n            // Cymbal-like noise\n            let noise = white_noise_ar();\n            let filtered = hpf_ar(noise, 3000.0);\n\n            // Add metallic resonance\n            let metal1 = sin_osc_ar(2500.0) * 0.1;\n            let metal2 = sin_osc_ar(4200.0) * 0.08;\n            let metal3 = sin_osc_ar(6800.0) * 0.05;\n\n            let cymbal = filtered + metal1 + metal2 + metal3;\n\n            // Filter opens as it builds\n            let cutoff = 2000.0 + env * 10000.0;\n            let final_filter = lpf_ar(cymbal, cutoff);\n\n            final_filter * env * amp * 0.5\n        })\n});",
    "category": "fx",
    "subcategory": "transitions",
    "path": "fx/transitions/transition_reverse.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Transitions"
  },
  {
    "name": "transition_sweep",
    "description": "Genre: EDM, House | Character: Tonal transition sweep",
    "genre": "EDM, House",
    "character": "Tonal transition sweep",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"transition_sweep\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 1.0)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.05, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch sweep\n            let sweep = env * (1.0 - env) * 4.0;\n            let freq = 200.0 + sweep * 2000.0;\n\n            // Synth tone\n            let tone = saw_ar(freq) + saw_ar(freq * 1.01) + saw_ar(freq * 0.99);\n\n            // Filter following pitch\n            let filtered = lpf_ar(tone, freq * 3.0) * 0.3;\n\n            // Add noise texture\n            let noise = lpf_ar(white_noise_ar(), freq * 2.0) * 0.2;\n\n            (filtered + noise) * env * amp\n        })\n});",
    "category": "fx",
    "subcategory": "transitions",
    "path": "fx/transitions/transition_sweep.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Transitions"
  },
  {
    "name": "whoosh_fast",
    "description": "Genre: All genres | Character: Fast whoosh transition",
    "genre": "All genres",
    "character": "Fast whoosh transition",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"whoosh_fast\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .body(|amp| {\n            let env = envelope()\n                .perc(0.01, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast filter sweep on noise\n            let noise = white_noise_ar();\n\n            // Sweep from high to low quickly\n            let sweep_e = envelope()\n                .perc(0.01, 0.25)\n                .build();\n            let cutoff = 500.0 + sweep_e * 10000.0;\n\n            let filtered = lpf_ar(noise, cutoff);\n\n            // Add resonance at sweep point\n            let res = rlpf_ar(noise, cutoff * 0.8, 0.2) * 0.4;\n\n            (filtered + res) * env * amp * 0.7\n        })\n});",
    "category": "fx",
    "subcategory": "transitions",
    "path": "fx/transitions/whoosh_fast.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Transitions"
  },
  {
    "name": "whoosh_slow",
    "description": "Genre: Cinematic, Ambient | Character: Slow atmospheric whoosh",
    "genre": "Cinematic, Ambient",
    "character": "Slow atmospheric whoosh",
    "params": [
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "duration",
        "default": 1.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"whoosh_slow\", |builder| {\n    builder\n        .param(\"amp\", 0.5)\n        .param(\"duration\", 1.5)\n        .body(|amp, duration| {\n            let env = envelope()\n                .perc(0.3, 1.0)\n                .time_scale(duration)\n                .cleanup_on_finish()\n                .build();\n\n            let noise = pink_noise_ar();\n\n            // Slow rise and fall\n            let sweep = env * (1.0 - env) * 4.0;  // Peak in middle\n            let cutoff = 300.0 + sweep * 6000.0;\n\n            let filtered = lpf_ar(noise, cutoff);\n\n            // Add wind-like character\n            let mod_lfo = sin_osc_ar(3.0) * 0.2 + 0.8;\n            let wind = filtered * mod_lfo;\n\n            wind * env * amp * 0.8\n        })\n});",
    "category": "fx",
    "subcategory": "transitions",
    "path": "fx/transitions/whoosh_slow.vibe",
    "categoryName": "Fx",
    "subcategoryName": "Transitions"
  },
  {
    "name": "accordion_keys",
    "description": "Reedy, bright",
    "genre": "",
    "character": "Reedy, bright",
    "params": [],
    "type": "synthdef",
    "source": "// Folk instrument | Character: Reedy, bright\ndefine_synthdef(\"accordion_keys\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Reed vibration\n        let tremolo = sin_osc_ar(6.0) * 0.15 + 1.0;\n\n        // Detuned reeds\n        let reed1 = saw_ar(freq * 0.998) * 0.35;\n        let reed2 = saw_ar(freq * 1.002) * 0.35;\n\n        let mix = (reed1 + reed2) * tremolo;\n\n        // Reedy character\n        let filtered = bpf_ar(mix, 1500.0, 0.4) + mix * 0.4;\n\n        filtered * env * amp\n    });\n",
    "category": "keys",
    "subcategory": "",
    "path": "keys/accordion_keys.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "celeste",
    "description": "Celeste/celesta keyboard with bell-like, sparkling tone.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 880
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"celeste\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Bell-like envelope\n            let env = envelope()\n                .asr(0.002, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay for bell character\n            let decay_env = envelope()\n                .perc(0.001, 0.8)\n                .build();\n\n            // Metallic bell harmonics\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.17) * 0.2; // Inharmonic for bell character\n            let h5 = sin_osc_ar(freq * 5.43) * 0.15;\n            let h6 = sin_osc_ar(freq * 6.8) * 0.1;\n\n            let bell = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Soft hammer attack\n            let attack_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n            let attack = sin_osc_ar(freq * 8.0) * attack_env * 0.2;\n\n            let celeste = bell + attack;\n\n            celeste * env * decay_env * amp * 0.5\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/celeste.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "clavinet",
    "description": "percussive attack and bright, plucky tone.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "brightness",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clavinet\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.7) // Filter brightness\n        .body(|freq, amp, gate, brightness| {\n            // Percussive envelope\n            let env = envelope()\n                .asr(0.001, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay envelope for string character\n            let decay_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Plucked string-like waveform (rich in harmonics)\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.001);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Hammer/pick attack transient\n            let pick_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let pick = white_noise_ar() * pick_env * 0.3;\n\n            // Filter with envelope for pluck character\n            let filter_freq = 1000.0 + brightness * 4000.0 + decay_env * 3000.0;\n            let filtered = rlpf_ar(source + pick, filter_freq, 0.3);\n\n            // Emphasize fundamental\n            let fundamental = sin_osc_ar(freq) * 0.3;\n\n            (filtered + fundamental) * env * decay_env * amp * 0.8\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/clavinet.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "electric_piano",
    "description": "and warm decay.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "brightness",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"electric_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.5) // Tine brightness\n        .body(|freq, amp, gate, brightness| {\n            // Gate-controlled envelope with classic EP decay\n            let env = envelope()\n                .asr(0.005, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast attack envelope for bell character\n            let bell_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            // Fundamental with harmonics (tine + tone bar)\n            let fundamental = sin_osc_ar(freq);\n            let second = sin_osc_ar(freq * 2.0) * 0.5;\n            let third = sin_osc_ar(freq * 3.0) * 0.25;\n            let fourth = sin_osc_ar(freq * 4.0) * 0.15;\n            let fifth = sin_osc_ar(freq * 5.0) * 0.1;\n\n            // Bell/tine component (higher partials with fast decay)\n            let bell = sin_osc_ar(freq * 6.0) * bell_env * 0.2 * brightness;\n            let bell2 = sin_osc_ar(freq * 7.0) * bell_env * 0.1 * brightness;\n\n            let tone = fundamental + second + third + fourth + fifth + bell + bell2;\n\n            // Slight chorus/detuning for thickness\n            let detuned = sin_osc_ar(freq * 1.002) * 0.2;\n\n            // Low pass to tame highs\n            let filtered = lpf_ar(tone + detuned, 3000.0 + brightness * 3000.0);\n\n            filtered * env * amp * 0.6\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/electric_piano.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "grand_piano",
    "description": "velocity-sensitive with full harmonic content",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "velocity",
        "default": 0.7
      },
      {
        "name": "brightness",
        "default": 0.5
      },
      {
        "name": "resonance",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"grand_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"velocity\", 0.7)     // 0-1: affects brightness and attack\n        .param(\"brightness\", 0.5)   // Tonal character\n        .param(\"resonance\", 0.4)    // Sympathetic string resonance amount\n        .body(|freq, amp, gate, velocity, brightness, resonance| {\n            // Main amplitude envelope - piano has sharp attack, long decay\n            let decay_time = 2.0 + (1.0 / (freq / 100.0));  // Lower notes decay longer\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Hammer strike envelope - very fast, creates initial \"thunk\"\n            let hammer_env = envelope()\n                .perc(0.0005, 0.008)\n                .build();\n\n            // Velocity affects brightness - harder hit = more harmonics\n            let vel_brightness = 0.3 + (velocity * 0.7);\n            let cutoff_base = 800.0 + (vel_brightness * brightness * 8000.0);\n\n            // String harmonics - piano has inharmonic partials due to string stiffness\n            // Inharmonicity factor increases with partial number\n            let inharm = 1.0 + (freq / 20000.0);  // Subtle inharmonicity\n\n            // Fundamental and harmonics with proper amplitude rolloff\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0 * inharm) * 0.7;\n            let h3 = sin_osc_ar(freq * 3.0 * inharm * inharm) * 0.45;\n            let h4 = sin_osc_ar(freq * 4.0 * inharm * inharm * inharm) * 0.28;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.18;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.12;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.08;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.05;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Hammer noise - creates the initial attack character\n            let hammer_noise = white_noise_ar() * hammer_env * velocity * 0.15;\n            let hammer_filtered = bpf_ar(hammer_noise, freq * 8.0, 0.5);\n\n            // Dynamic low-pass filter - simulates hammer felt softening\n            let filter_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n            let dyn_cutoff = cutoff_base + (filter_env * 4000.0 * velocity);\n            let filtered_tone = lpf_ar(string_tone, dyn_cutoff);\n\n            // Soundboard resonance - adds body and warmth\n            let board_freq1 = 120.0;\n            let board_freq2 = 280.0;\n            let board_res1 = rlpf_ar(filtered_tone, board_freq1, 0.4) * 0.15;\n            let board_res2 = rlpf_ar(filtered_tone, board_freq2, 0.5) * 0.1;\n\n            // Sympathetic string resonance (other strings vibrating)\n            let symp1 = sin_osc_ar(freq * 2.0) * 0.02 * resonance;\n            let symp2 = sin_osc_ar(freq * 3.0) * 0.015 * resonance;\n            let symp_env = envelope()\n                .perc(0.1, 1.2)\n                .time_scale(decay_time)\n                .build();\n            let sympathetic = (symp1 + symp2) * symp_env;\n\n            // High frequency damping over time (strings lose brightness as they decay)\n            let hf_damp_env = envelope()\n                .perc(0.001, 0.5)\n                .time_scale(decay_time)\n                .build();\n            let hf_cutoff = 2000.0 + (hf_damp_env * 6000.0);\n\n            let main_tone = filtered_tone + board_res1 + board_res2 + hammer_filtered;\n            let damped = lpf_ar(main_tone, hf_cutoff);\n\n            // Final mix with slight compression via soft clipping\n            let output = (damped + sympathetic) * env * amp * 0.5;\n            output.softclip() * 0.9\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/grand_piano.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "grand_piano_bright",
    "description": "more upper harmonics, concert hall character",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "velocity",
        "default": 0.8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"grand_piano_bright\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"velocity\", 0.8)\n        .body(|freq, amp, gate, velocity| {\n            let decay_time = 2.5 + (1.0 / (freq / 80.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Brighter harmonic content\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.75;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.3;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.22;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.15;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.1;\n            let h9 = sin_osc_ar(freq * 9.0) * 0.07;\n            let h10 = sin_osc_ar(freq * 10.0) * 0.05;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8 + h9 + h10;\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.0003, 0.015)\n                .build();\n            let attack = white_noise_ar() * attack_env * velocity * 0.12;\n            let attack_filtered = bpf_ar(attack, freq * 6.0, 0.4);\n\n            // Higher cutoff for brightness\n            let cutoff = 3000.0 + (velocity * 8000.0);\n            let filtered = lpf_ar(tone + attack_filtered, cutoff);\n\n            // Subtle detuning for richness (like multiple strings per note)\n            let detune1 = sin_osc_ar(freq * 0.9995) * 0.1;\n            let detune2 = sin_osc_ar(freq * 1.0005) * 0.1;\n\n            let output = (filtered + detune1 + detune2) * env * amp * 0.45;\n            output.softclip() * 0.9\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/grand_piano.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "grand_piano_warm",
    "description": "darker, more intimate character",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "velocity",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"grand_piano_warm\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"velocity\", 0.6)\n        .body(|freq, amp, gate, velocity| {\n            let decay_time = 3.0 + (1.0 / (freq / 60.0));\n            let env = envelope()\n                .perc(0.002, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Warmer harmonic content - less upper partials\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.1;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.05;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Softer attack\n            let attack_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let attack = white_noise_ar() * attack_env * velocity * 0.05;\n\n            // Lower cutoff for warmth\n            let cutoff = 1500.0 + (velocity * 3000.0);\n            let filtered = lpf_ar(tone + attack, cutoff);\n\n            // Extra low-end body\n            let body = rlpf_ar(filtered, 200.0, 0.5) * 0.2;\n\n            let output = (filtered + body) * env * amp * 0.5;\n            output\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/grand_piano.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "upright_piano",
    "description": "different character from grand",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "velocity",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"upright_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"velocity\", 0.7)\n        .body(|freq, amp, gate, velocity| {\n            let decay_time = 1.8 + (1.0 / (freq / 120.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Upright has more \"honky\" character - emphasized odd harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.55;  // Emphasized\n            let h4 = sin_osc_ar(freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.3;   // Emphasized\n            let h6 = sin_osc_ar(freq * 6.0) * 0.15;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.12;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Mechanical noise (felt hammers, action)\n            let mech_env = envelope()\n                .perc(0.0005, 0.012)\n                .build();\n            let mech = white_noise_ar() * mech_env * velocity * 0.08;\n\n            // Smaller soundboard resonance\n            let cutoff = 2000.0 + (velocity * 4000.0);\n            let filtered = lpf_ar(tone + mech, cutoff);\n\n            // Box-like resonance of upright cabinet\n            let cabinet = rlpf_ar(filtered, 350.0, 0.6) * 0.15;\n\n            let output = (filtered + cabinet) * env * amp * 0.5;\n            output.softclip() * 0.9\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/grand_piano.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "tack_piano",
    "description": "prepared piano with tacks on hammers",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "velocity",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tack_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"velocity\", 0.7)\n        .body(|freq, amp, gate, velocity| {\n            let decay_time = 1.2;\n            let env = envelope()\n                .perc(0.001, decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Very bright attack from tacks\n            let attack_env = envelope()\n                .perc(0.0002, 0.005)\n                .build();\n            let tack_hit = white_noise_ar() * attack_env * 0.4;\n            let tack_filtered = hpf_ar(tack_hit, 3000.0);\n\n            // Bright harmonics\n            let h1 = sin_osc_ar(freq) * 0.8;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.35;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.3;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.25;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.2;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // High cutoff - very bright character\n            let filtered = lpf_ar(tone, 8000.0 + (velocity * 4000.0));\n\n            let output = (filtered + tack_filtered) * env * amp * 0.4;\n            output.softclip()\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/grand_piano.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "hammond_organ",
    "description": "Uses additive synthesis to simulate drawbar settings.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "percussion",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hammond_organ\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"percussion\", 0.5) // Percussion amount\n        .body(|freq, amp, gate, percussion| {\n            // Instant attack organ envelope\n            let env = envelope()\n                .asr(0.003, 1.0, 0.01)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Drawbar harmonics (typical jazz setting: 888000000)\n            // Sub-octave (16')\n            let d1 = sin_osc_ar(freq * 0.5) * 0.8;\n            // Fundamental (8')\n            let d2 = sin_osc_ar(freq) * 0.8;\n            // Fifth (5 1/3')\n            let d3 = sin_osc_ar(freq * 1.5) * 0.8;\n            // Octave (4')\n            let d4 = sin_osc_ar(freq * 2.0) * 0.6;\n            // 12th (2 2/3')\n            let d5 = sin_osc_ar(freq * 3.0) * 0.4;\n            // 15th (2')\n            let d6 = sin_osc_ar(freq * 4.0) * 0.3;\n            // 17th (1 3/5')\n            let d7 = sin_osc_ar(freq * 5.0) * 0.2;\n            // 19th (1 1/3')\n            let d8 = sin_osc_ar(freq * 6.0) * 0.1;\n            // 22nd (1')\n            let d9 = sin_osc_ar(freq * 8.0) * 0.05;\n\n            let drawbars = d1 + d2 + d3 + d4 + d5 + d6 + d7 + d8 + d9;\n\n            // Percussion envelope (fast decay click)\n            let perc_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let perc = sin_osc_ar(freq * 3.0) * perc_env * percussion * 0.4;\n\n            // Key click\n            let click_env = envelope()\n                .perc(0.0001, 0.003)\n                .build();\n            let click = white_noise_ar() * click_env * 0.1;\n\n            let organ = drawbars * 0.4 + perc + click;\n\n            organ * env * amp\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/hammond_organ.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "harpsichord",
    "description": "Plucked string, bright",
    "genre": "",
    "character": "Plucked string, bright",
    "params": [],
    "type": "synthdef",
    "source": "// Baroque keyboard | Character: Plucked string, bright\ndefine_synthdef(\"harpsichord\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.05)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pluck attack\n        let pluck_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 3000.0) * pluck_env * 0.4;\n\n        // Bright string resonance\n        let str1 = pulse_ar(freq, 0.5) * 0.35;\n        let str2 = pulse_ar(freq * 2.0, 0.5) * 0.2;\n        let str3 = sin_osc_ar(freq * 3.0) * 0.1;\n\n        let sig = str1 + str2 + str3 + attack;\n\n        // Bright character\n        let filtered = hpf_ar(sig, 300.0);\n\n        filtered * env * amp\n    });\n",
    "category": "keys",
    "subcategory": "",
    "path": "keys/harpsichord.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "honky_tonk",
    "description": "Slightly detuned piano with characteristic \"tack\" attack.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "detune",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"honky_tonk\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"detune\", 0.5) // Detune amount\n        .body(|freq, amp, gate, detune| {\n            // Piano-like envelope\n            let env = envelope()\n                .asr(0.005, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay envelope for sustain\n            let decay_env = envelope()\n                .perc(0.001, 1.0)\n                .build();\n\n            // Detuned strings (honky-tonk character)\n            let detune_amt = 0.002 + detune * 0.008;\n            let str1 = sin_osc_ar(freq * (1.0 - detune_amt));\n            let str2 = sin_osc_ar(freq);\n            let str3 = sin_osc_ar(freq * (1.0 + detune_amt));\n\n            // Harmonics\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n            let strings = (str1 + str2 + str3) * 0.4 + h2 + h3 + h4;\n\n            // Tack piano hammer sound\n            let tack_env = envelope()\n                .perc(0.0001, 0.02)\n                .build();\n            let tack = white_noise_ar() * tack_env * 0.25;\n\n            let piano = strings + tack;\n\n            // Bright filtering\n            let filtered = lpf_ar(piano, 6000.0);\n\n            filtered * env * decay_env * amp * 0.6\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/honky_tonk.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "crotales",
    "description": "very high, pure",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 2093
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"crotales\", |builder| {\n    builder\n        .param(\"freq\", 2093.0)   // C7\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let decay_time = 3.0;\n            let env = envelope()\n                .perc(0.001, decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Light strike\n            let strike_env = envelope()\n                .perc(0.0001, 0.001)\n                .build();\n            let strike = white_noise_ar() * strike_env * 0.1;\n\n            // Very pure, bell-like\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n            let h3 = sin_osc_ar(freq * 3.17) * 0.15;\n\n            let tone = h1 + h2 + h3 + strike;\n\n            hpf_ar(tone, 1000.0) * env * amp * 0.5\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/mallet_instruments.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "celesta",
    "description": "keyboard glockenspiel",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 1046.5
      },
      {
        "name": "amp",
        "default": 0.45
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"celesta\", |builder| {\n    builder\n        .param(\"freq\", 1046.5)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let decay_time = 1.8;\n            let env = envelope()\n                .perc(0.001, decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Felt hammer - softer than glockenspiel\n            let strike_env = envelope()\n                .perc(0.001, 0.006)\n                .build();\n            let strike = white_noise_ar() * strike_env * 0.08;\n\n            // Steel bars with resonators - warmer than glockenspiel\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.76) * 0.35;\n            let h3 = sin_osc_ar(freq * 5.4) * 0.18;\n            let h4 = sin_osc_ar(freq * 8.9) * 0.08;\n\n            let bar_tone = h1 + h2 + h3 + h4;\n\n            // Wooden resonator adds warmth\n            let resonator = rlpf_ar(bar_tone, freq * 1.5, 0.4) * 0.25;\n\n            // High freq decay\n            let hf_env = envelope()\n                .perc(0.001, 0.4)\n                .time_scale(decay_time)\n                .build();\n\n            let tone = h1 + (h2 + h3 + h4) * hf_env + resonator + strike;\n\n            hpf_ar(tone, 300.0) * env * amp * 0.5\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/mallet_instruments.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "mellotron_choir",
    "description": "Classic mellotron choir",
    "genre": "",
    "character": "Classic mellotron choir",
    "params": [],
    "type": "synthdef",
    "source": "// Sampler-style | Character: Classic mellotron choir\ndefine_synthdef(\"mellotron_choir\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Tape warble\n        let warble = sin_osc_ar(4.0) * freq * 0.005;\n\n        // Choir-like source\n        let source = saw_ar(freq + warble) * 0.4;\n\n        // Choir formants\n        let f1 = bpf_ar(source, 600.0, 0.15) * 0.4;\n        let f2 = bpf_ar(source, 1200.0, 0.18) * 0.3;\n        let f3 = bpf_ar(source, 2400.0, 0.2) * 0.15;\n\n        let sig = f1 + f2 + f3;\n\n        // Tape lo-fi character\n        let filtered = lpf_ar(sig, 5000.0);\n\n        filtered * env * amp\n    });\n",
    "category": "keys",
    "subcategory": "",
    "path": "keys/mellotron_choir.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "mellotron_flute",
    "description": "Classic mellotron flute sound",
    "genre": "",
    "character": "Classic mellotron flute sound",
    "params": [],
    "type": "synthdef",
    "source": "// Sampler-style | Character: Classic mellotron flute sound\ndefine_synthdef(\"mellotron_flute\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Tape warble\n        let warble = sin_osc_ar(3.5) * freq * 0.004;\n\n        // Flute-like tone\n        let pure = sin_osc_ar(freq + warble) * 0.5;\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.0, 0.2) * 0.15;\n        let second_harmonic = sin_osc_ar(freq * 2.0 + warble) * 0.15;\n\n        let sig = pure + breath + second_harmonic;\n\n        // Tape character - slight filtering\n        let filtered = lpf_ar(sig, 4000.0);\n\n        filtered * env * amp\n    });\n",
    "category": "keys",
    "subcategory": "",
    "path": "keys/mellotron_flute.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "mellotron_strings",
    "description": "Mellotron string sound",
    "genre": "Progressive Rock, Psychedelic",
    "character": "Mellotron string sound",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Progressive Rock, Psychedelic | Character: Mellotron string sound\ndefine_synthdef(\"mellotron_strings\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slightly detuned for tape character\n        let wow = sin_osc_ar(0.5) * freq * 0.004;\n\n        let osc1 = saw_ar(freq + wow) * 0.3;\n        let osc2 = saw_ar(freq * 1.002) * 0.25;\n        let osc3 = saw_ar(freq * 0.998 + wow * 0.5) * 0.25;\n\n        let mix = osc1 + osc2 + osc3;\n\n        // Tape-like filtering\n        let filtered = lpf_ar(mix, 3500.0);\n\n        // Add noise for tape hiss\n        let hiss = hpf_ar(white_noise_ar(), 6000.0) * 0.02;\n\n        (filtered + hiss) * env * amp\n    });\n",
    "category": "keys",
    "subcategory": "",
    "path": "keys/mellotron_strings.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "organ_b3",
    "description": "Hammond B3 organ with drawbars",
    "genre": "Gospel, Jazz, Rock",
    "character": "Hammond B3 organ with drawbars",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Gospel, Jazz, Rock | Character: Hammond B3 organ with drawbars\ndefine_synthdef(\"organ_b3\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.05)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Tonewheel harmonics (simplified drawbar settings)\n        let h1 = sin_osc_ar(freq * 0.5) * 0.15;    // 16'\n        let h2 = sin_osc_ar(freq * 0.75) * 0.08;   // 5 1/3'\n        let h3 = sin_osc_ar(freq) * 0.4;           // 8'\n        let h4 = sin_osc_ar(freq * 2.0) * 0.25;    // 4'\n        let h5 = sin_osc_ar(freq * 3.0) * 0.1;     // 2 2/3'\n        let h6 = sin_osc_ar(freq * 4.0) * 0.15;    // 2'\n        let h7 = sin_osc_ar(freq * 6.0) * 0.05;    // 1 1/3'\n\n        let mix = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n        // Key click\n        let click = envelope()\n            .perc(0.0001, 0.003)\n            .build();\n        let key_click = white_noise_ar() * click * 0.08;\n\n        (mix + key_click) * env * amp\n    });\n",
    "category": "keys",
    "subcategory": "",
    "path": "keys/organ_b3.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "piano_felt",
    "description": "Felt piano - soft and muted",
    "genre": "Ambient, Cinematic",
    "character": "Felt piano - soft and muted",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Ambient, Cinematic | Character: Felt piano - soft and muted\ndefine_synthdef(\"piano_felt\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Piano-like harmonics\n        let h1 = sin_osc_ar(freq) * 0.5;\n        let h2 = sin_osc_ar(freq * 2.0) * 0.15;\n        let h3 = sin_osc_ar(freq * 3.0) * 0.08;\n\n        // Soft hammer attack\n        let attack = envelope()\n            .perc(0.005, 0.03)\n            .build();\n        let hammer = lpf_ar(white_noise_ar(), 800.0) * attack * 0.1;\n\n        let mix = h1 + h2 + h3 + hammer;\n\n        // Heavy felt damping\n        lpf_ar(mix, 1500.0) * env * amp\n    });\n",
    "category": "keys",
    "subcategory": "",
    "path": "keys/piano_felt.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "piano_toy",
    "description": "Toy piano - bright and metallic",
    "genre": "Lo-fi, Indie",
    "character": "Toy piano - bright and metallic",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Lo-fi, Indie | Character: Toy piano - bright and metallic\ndefine_synthdef(\"piano_toy\")\n    .param(\"freq\", 880.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        // Short, metallic decay\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Metallic harmonics\n        let h1 = sin_osc_ar(freq) * 0.4;\n        let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n        let h3 = sin_osc_ar(freq * 2.8) * 0.2;\n        let h4 = sin_osc_ar(freq * 4.2) * 0.12;\n\n        // Hammer click\n        let click = envelope()\n            .perc(0.0001, 0.008)\n            .build();\n        let hammer = hpf_ar(white_noise_ar(), 4000.0) * click * 0.15;\n\n        let sig = h1 + h2 + h3 + h4 + hammer;\n\n        sig * amp_env * amp\n    });\n",
    "category": "keys",
    "subcategory": "",
    "path": "keys/piano_toy.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "pipe_organ",
    "description": "Majestic, sustained",
    "genre": "",
    "character": "Majestic, sustained",
    "params": [],
    "type": "synthdef",
    "source": "// Church instrument | Character: Majestic, sustained\ndefine_synthdef(\"pipe_organ\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.15, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Multiple pipes at different footages\n        let pipe8 = sin_osc_ar(freq) * 0.4;\n        let pipe4 = sin_osc_ar(freq * 2.0) * 0.25;\n        let pipe2 = sin_osc_ar(freq * 4.0) * 0.15;\n        let pipe16 = sin_osc_ar(freq * 0.5) * 0.3;\n\n        // Wind noise\n        let wind = lpf_ar(pink_noise_ar(), 500.0) * 0.05;\n\n        let sig = pipe8 + pipe4 + pipe2 + pipe16 + wind;\n\n        sig * env * amp\n    });\n",
    "category": "keys",
    "subcategory": "",
    "path": "keys/pipe_organ.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "rhodes_bright",
    "description": "Bright Rhodes electric piano",
    "genre": "Jazz, R&B, Soul",
    "character": "Bright Rhodes electric piano",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Jazz, R&B, Soul | Character: Bright Rhodes electric piano\ndefine_synthdef(\"rhodes_bright\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // FM synthesis for bell-like Rhodes tone\n        let mod_env = envelope()\n            .perc(0.001, 0.5)\n            .build();\n\n        let mod_index = 2.0 + mod_env * 4.0;\n        let modulator = sin_osc_ar(freq * 2.0) * mod_index * freq;\n        let carrier = sin_osc_ar(freq + modulator);\n\n        // Bark (attack transient)\n        let bark = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = sin_osc_ar(freq * 8.0) * bark * 0.15;\n\n        let sig = carrier * 0.6 + attack;\n\n        sig * env * amp\n    });\n",
    "category": "keys",
    "subcategory": "",
    "path": "keys/rhodes_bright.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "rhodes_dark",
    "description": "Dark, mellow Rhodes",
    "genre": "Jazz, Neo-Soul",
    "character": "Dark, mellow Rhodes",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Jazz, Neo-Soul | Character: Dark, mellow Rhodes\ndefine_synthdef(\"rhodes_dark\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.008, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Less FM for darker tone\n        let mod_env = envelope()\n            .perc(0.001, 0.4)\n            .build();\n\n        let mod_index = 1.0 + mod_env * 2.0;\n        let modulator = sin_osc_ar(freq * 2.0) * mod_index * freq;\n        let carrier = sin_osc_ar(freq + modulator);\n\n        // Warmer filtering\n        let sig = lpf_ar(carrier, 2500.0);\n\n        sig * env * amp\n    });\n",
    "category": "keys",
    "subcategory": "",
    "path": "keys/rhodes_dark.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "wurlitzer",
    "description": "Wurlitzer-style EP with characteristic bark and reed-like tone.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "drive",
        "default": 0.3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"wurlitzer\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"drive\", 0.3) // Overdrive amount\n        .body(|freq, amp, gate, drive| {\n            // Envelope with punchy attack\n            let env = envelope()\n                .asr(0.003, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Reed-like oscillators\n            let fund = sin_osc_ar(freq);\n            let odd2 = sin_osc_ar(freq * 3.0) * 0.4;\n            let odd3 = sin_osc_ar(freq * 5.0) * 0.2;\n            let odd4 = sin_osc_ar(freq * 7.0) * 0.1;\n\n            // Characteristic wurli bark\n            let bark_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let bark = white_noise_ar() * bark_env * 0.15;\n\n            let tone = fund + odd2 + odd3 + odd4 + bark;\n\n            // Soft overdrive for warmth\n            let driven = (tone * (1.0 + drive * 3.0)).tanh();\n\n            // Bandpass for wurli character\n            let filtered = lpf_ar(hpf_ar(driven, 200.0), 4000.0);\n\n            filtered * env * amp * 0.5\n        })\n});",
    "category": "keys",
    "subcategory": "",
    "path": "keys/wurlitzer.vibe",
    "categoryName": "Keys"
  },
  {
    "name": "lead_arp",
    "description": "ARP Odyssey-style lead - bright and buzzy",
    "genre": "Progressive Rock, Electronic",
    "character": "ARP Odyssey-style lead - bright and buzzy",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Progressive Rock, Electronic | Character: ARP Odyssey-style lead - bright and buzzy\ndefine_synthdef(\"lead_arp\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.005, 0.3)\n            .build();\n\n        // Two oscillators with hard sync feel\n        let osc1 = saw_ar(freq);\n        let osc2 = pulse_ar(freq * 1.01, 0.4);\n\n        // Ring mod option\n        let ring = osc1 * osc2 * 0.3;\n\n        let mix = (osc1 + osc2 + ring) * 0.3;\n\n        // Bright filter\n        let cutoff = 1500.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.3) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "classic",
    "path": "leads/classic/lead_arp.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Classic"
  },
  {
    "name": "lead_cs80",
    "description": "Yamaha CS-80 brass lead - expressive and lush",
    "genre": "Cinematic, Synthwave",
    "character": "Yamaha CS-80 brass lead - expressive and lush",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Cinematic, Synthwave | Character: Yamaha CS-80 brass lead - expressive and lush\ndefine_synthdef(\"lead_cs80\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.02, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope with slow attack\n        let filt_env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .build();\n\n        // Multiple detuned oscillators for thickness\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n        let osc4 = saw_ar(freq * 1.006);\n\n        let mix = (osc1 + osc2 + osc3 + osc4) * 0.22;\n\n        // Expressive filter\n        let cutoff = 800.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "classic",
    "path": "leads/classic/lead_cs80.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Classic"
  },
  {
    "name": "lead_dx7",
    "description": "DX7 FM lead - bell-like and cutting",
    "genre": "80s Pop, R&B",
    "character": "DX7 FM lead - bell-like and cutting",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: 80s Pop, R&B | Character: DX7 FM lead - bell-like and cutting\ndefine_synthdef(\"lead_dx7\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // FM index envelope\n        let mod_env = envelope()\n            .perc(0.001, 0.3)\n            .build();\n\n        // 2-operator FM\n        let mod_ratio = 2.0;\n        let mod_index = 3.0 + mod_env * 8.0;\n        let modulator = sin_osc_ar(freq * mod_ratio) * mod_index * freq;\n        let carrier = sin_osc_ar(freq + modulator);\n\n        // Second carrier for brightness\n        let mod2 = sin_osc_ar(freq * 3.0) * mod_env * freq * 2.0;\n        let carrier2 = sin_osc_ar(freq + mod2) * 0.4;\n\n        let sig = (carrier + carrier2) * 0.5;\n\n        sig * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "classic",
    "path": "leads/classic/lead_dx7.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Classic"
  },
  {
    "name": "lead_juno_hoover",
    "description": "Hoover/Mentasm sound - aggressive and iconic",
    "genre": "Rave, Hardcore, Jungle",
    "character": "Hoover/Mentasm sound - aggressive and iconic",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Rave, Hardcore, Jungle | Character: Hoover/Mentasm sound - aggressive and iconic\ndefine_synthdef(\"lead_juno_hoover\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch LFO for characteristic wobble\n        let pitch_lfo = sin_osc_ar(6.0) * freq * 0.02;\n\n        // Multiple heavily detuned saws\n        let osc1 = saw_ar(freq * 0.97 + pitch_lfo);\n        let osc2 = saw_ar(freq * 0.99);\n        let osc3 = saw_ar(freq);\n        let osc4 = saw_ar(freq * 1.01);\n        let osc5 = saw_ar(freq * 1.03 + pitch_lfo * 0.5);\n\n        let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.18;\n\n        // PWM layer\n        let pwm = sin_osc_ar(0.3) * 0.3 + 0.5;\n        let pulse_layer = pulse_ar(freq * 0.5, pwm) * 0.3;\n\n        let sig = mix + pulse_layer;\n\n        // Aggressive filter\n        rlpf_ar(sig, 3000.0, 0.4) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "classic",
    "path": "leads/classic/lead_juno_hoover.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Classic"
  },
  {
    "name": "lead_moog",
    "description": "Classic Minimoog lead - fat and expressive",
    "genre": "Funk, Progressive Rock",
    "character": "Classic Minimoog lead - fat and expressive",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Funk, Progressive Rock | Character: Classic Minimoog lead - fat and expressive\ndefine_synthdef(\"lead_moog\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .param(\"cutoff\", 2000.0)\n    .body(|freq, amp, gate, cutoff| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.01, 0.4)\n            .build();\n\n        // Three oscillators slightly detuned\n        let osc1 = saw_ar(freq);\n        let osc2 = saw_ar(freq * 1.005);\n        let osc3 = saw_ar(freq * 0.5); // Sub octave\n\n        let mix = (osc1 + osc2 + osc3 * 0.5) * 0.35;\n\n        // Classic Moog filter\n        let mod_cutoff = cutoff + filt_env * 3000.0;\n        let filtered = rlpf_ar(mix, mod_cutoff, 0.25);\n\n        filtered * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "classic",
    "path": "leads/classic/lead_moog.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Classic"
  },
  {
    "name": "lead_ms20",
    "description": "Korg MS-20 lead - screaming and aggressive",
    "genre": "Industrial, Experimental",
    "character": "Korg MS-20 lead - screaming and aggressive",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Industrial, Experimental | Character: Korg MS-20 lead - screaming and aggressive\ndefine_synthdef(\"lead_ms20\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .param(\"drive\", 1.5)\n    .body(|freq, amp, gate, drive| {\n        let env = envelope()\n            .asr(0.002, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.002, 0.35)\n            .build();\n\n        // Dual oscillators\n        let osc1 = saw_ar(freq);\n        let osc2 = pulse_ar(freq * 1.005, 0.3);\n\n        let mix = (osc1 + osc2) * 0.4;\n\n        // MS-20 style - HP then LP with drive\n        let hp = hpf_ar(mix, 100.0);\n        let driven = (hp * drive).tanh();\n\n        // Aggressive resonant filter\n        let cutoff = 800.0 + filt_env * 5000.0;\n        rlpf_ar(driven, cutoff, 0.5) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "classic",
    "path": "leads/classic/lead_ms20.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Classic"
  },
  {
    "name": "lead_prophet",
    "description": "Prophet-5 lead - lush and expressive",
    "genre": "Synthpop, New Wave",
    "character": "Prophet-5 lead - lush and expressive",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Synthpop, New Wave | Character: Prophet-5 lead - lush and expressive\ndefine_synthdef(\"lead_prophet\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.008, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.008, 0.35)\n            .build();\n\n        // Two oscillators detuned\n        let osc1 = saw_ar(freq);\n        let osc2 = saw_ar(freq * 1.008);\n        let pulse_osc = pulse_ar(freq, 0.45) * 0.5;\n\n        let mix = (osc1 + osc2 + pulse_osc) * 0.3;\n\n        // Lush filter\n        let cutoff = 1200.0 + filt_env * 3000.0;\n        rlpf_ar(mix, cutoff, 0.2) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "classic",
    "path": "leads/classic/lead_prophet.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Classic"
  },
  {
    "name": "lead_sh101",
    "description": "Roland SH-101 lead - clean and versatile",
    "genre": "Acid, Techno, Synthpop",
    "character": "Roland SH-101 lead - clean and versatile",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Acid, Techno, Synthpop | Character: Roland SH-101 lead - clean and versatile\ndefine_synthdef(\"lead_sh101\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .param(\"pw\", 0.5)\n    .body(|freq, amp, gate, pw| {\n        let env = envelope()\n            .asr(0.003, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.003, 0.25)\n            .build();\n\n        // Single oscillator with selectable wave\n        let osc = pulse_ar(freq, pw);\n        let sub = pulse_ar(freq * 0.5, 0.5) * 0.3;\n\n        let mix = (osc + sub) * 0.45;\n\n        // Classic 101 filter\n        let cutoff = 1000.0 + filt_env * 3500.0;\n        rlpf_ar(mix, cutoff, 0.35) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "classic",
    "path": "leads/classic/lead_sh101.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Classic"
  },
  {
    "name": "lead_complextro",
    "description": "Complextro lead - glitchy and dynamic",
    "genre": "Complextro, Electro House",
    "character": "Complextro lead - glitchy and dynamic",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Complextro, Electro House | Character: Complextro lead - glitchy and dynamic\ndefine_synthdef(\"lead_complextro\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.05)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.001, 0.15)\n            .build();\n\n        // Multiple waveforms\n        let saw = saw_ar(freq) * 0.4;\n        let pulse = pulse_ar(freq, 0.3) * 0.3;\n        let square = pulse_ar(freq, 0.5) * 0.2;\n\n        // Bit reduction effect\n        let mix = saw + pulse + square;\n        let crushed = (mix * 8.0).floor() / 8.0 * 0.3;\n\n        let sig = mix * 0.7 + crushed;\n\n        // Sharp, punchy filter\n        let cutoff = 1000.0 + filt_env * 5000.0;\n        rlpf_ar(sig, cutoff, 0.4) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "modern",
    "path": "leads/modern/lead_complextro.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Modern"
  },
  {
    "name": "lead_future_bass",
    "description": "Future bass lead - bright and wobbly",
    "genre": "Future Bass, Kawaii",
    "character": "Future bass lead - bright and wobbly",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Future Bass, Kawaii | Character: Future bass lead - bright and wobbly\ndefine_synthdef(\"lead_future_bass\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Wobble LFO\n        let wobble = sin_osc_ar(6.0) * 0.5 + 0.5;\n\n        // Bright supersaws\n        let saw1 = saw_ar(freq * 0.995);\n        let saw2 = saw_ar(freq);\n        let saw3 = saw_ar(freq * 1.005);\n        let saw4 = saw_ar(freq * 2.0) * 0.3; // Octave\n\n        let mix = (saw1 + saw2 + saw3 + saw4) * 0.25;\n\n        // Wobbling filter\n        let cutoff = 2000.0 + wobble * 4000.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "modern",
    "path": "leads/modern/lead_future_bass.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Modern"
  },
  {
    "name": "lead_hardstyle",
    "description": "Hardstyle screech lead",
    "genre": "Hardstyle, Hardcore",
    "character": "Hardstyle screech lead",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Hardstyle, Hardcore | Character: Hardstyle screech lead\ndefine_synthdef(\"lead_hardstyle\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope for screech\n        let filt_env = envelope()\n            .perc(0.001, 0.4)\n            .build();\n\n        // Detuned saws\n        let osc1 = saw_ar(freq * 0.99);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.01);\n\n        let mix = (osc1 + osc2 + osc3) * 0.35;\n\n        // Aggressive resonant filter (the screech)\n        let cutoff = 1000.0 + filt_env * 6000.0;\n        let filtered = rlpf_ar(mix, cutoff, 0.6);\n\n        // Distortion\n        (filtered * 2.0).tanh() * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "modern",
    "path": "leads/modern/lead_hardstyle.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Modern"
  },
  {
    "name": "lead_neuro",
    "description": "Neurofunk lead - aggressive and morphing",
    "genre": "Neurofunk, Drum & Bass",
    "character": "Neurofunk lead - aggressive and morphing",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Neurofunk, Drum & Bass | Character: Neurofunk lead - aggressive and morphing\ndefine_synthdef(\"lead_neuro\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .param(\"morph\", 0.5)\n    .body(|freq, amp, gate, morph| {\n        let env = envelope()\n            .asr(0.002, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // LFO for morphing\n        let morph_lfo = sin_osc_ar(4.0 + morph * 8.0) * 0.5 + 0.5;\n\n        // FM modulation\n        let mod_amount = morph_lfo * morph * 10.0;\n        let modulator = sin_osc_ar(freq * 2.0) * mod_amount * freq;\n        let carrier = saw_ar(freq + modulator);\n\n        // Ring mod layer\n        let ring = carrier * sin_osc_ar(freq * 1.5) * morph;\n\n        let mix = (carrier + ring) * 0.4;\n\n        // Aggressive filtered\n        let cutoff = 500.0 + morph_lfo * 4000.0;\n        let filtered = rlpf_ar(mix, cutoff, 0.4 + morph * 0.3);\n\n        (filtered * 1.5).tanh() * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "modern",
    "path": "leads/modern/lead_neuro.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Modern"
  },
  {
    "name": "lead_progressive",
    "description": "Progressive lead - smooth and evolving",
    "genre": "Progressive House, Melodic Techno",
    "character": "Progressive lead - smooth and evolving",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Progressive House, Melodic Techno | Character: Progressive lead - smooth and evolving\ndefine_synthdef(\"lead_progressive\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.03, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow filter envelope\n        let filt_env = envelope()\n            .asr(0.2, 1.0, 0.3)\n            .gate(gate)\n            .build();\n\n        // Slightly detuned for width\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n\n        let mix = (osc1 + osc2 + osc3) * 0.3;\n\n        // Smooth, evolving filter\n        let cutoff = 800.0 + filt_env * 3000.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "modern",
    "path": "leads/modern/lead_progressive.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Modern"
  },
  {
    "name": "lead_psytrance",
    "description": "Psytrance acid lead - hypnotic and squelchy",
    "genre": "Psytrance, Goa",
    "character": "Psytrance acid lead - hypnotic and squelchy",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Psytrance, Goa | Character: Psytrance acid lead - hypnotic and squelchy\ndefine_synthdef(\"lead_psytrance\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .param(\"acid\", 0.7)\n    .body(|freq, amp, gate, acid| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Accent/filter envelope\n        let filt_env = envelope()\n            .perc(0.001, 0.2)\n            .build();\n\n        // Saw oscillator\n        let osc = saw_ar(freq);\n\n        // Sub for power\n        let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n        let mix = (osc + sub) * 0.5;\n\n        // Acid filter with high resonance\n        let cutoff = 400.0 + filt_env * acid * 5000.0;\n        let res = 0.3 + acid * 0.4;\n        rlpf_ar(mix, cutoff, res) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "modern",
    "path": "leads/modern/lead_psytrance.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Modern"
  },
  {
    "name": "lead_trance",
    "description": "Trance supersaw lead - massive and euphoric",
    "genre": "Trance, Progressive",
    "character": "Trance supersaw lead - massive and euphoric",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Trance, Progressive | Character: Trance supersaw lead - massive and euphoric\ndefine_synthdef(\"lead_trance\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.015, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .asr(0.05, 1.0, 0.15)\n            .gate(gate)\n            .build();\n\n        // 7 detuned oscillators for supersaw\n        let osc1 = saw_ar(freq * 0.985);\n        let osc2 = saw_ar(freq * 0.992);\n        let osc3 = saw_ar(freq * 0.998);\n        let osc4 = saw_ar(freq);\n        let osc5 = saw_ar(freq * 1.002);\n        let osc6 = saw_ar(freq * 1.008);\n        let osc7 = saw_ar(freq * 1.015);\n\n        let mix = (osc1 + osc2 + osc3 + osc4 + osc5 + osc6 + osc7) * 0.14;\n\n        // Euphoric filter\n        let cutoff = 1500.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.12) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "modern",
    "path": "leads/modern/lead_trance.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Modern"
  },
  {
    "name": "lead_bitcrushed",
    "description": "Bitcrushed lo-fi lead",
    "genre": "Chiptune, Lo-fi",
    "character": "Bitcrushed lo-fi lead",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Chiptune, Lo-fi | Character: Bitcrushed lo-fi lead\ndefine_synthdef(\"lead_bitcrushed\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .param(\"bits\", 8.0)\n    .body(|freq, amp, gate, bits| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Source oscillator\n        let osc = saw_ar(freq);\n\n        // Bit reduction\n        let levels = (2.0).pow(bits);\n        let crushed = (osc * levels).floor() / levels;\n\n        crushed * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "organic",
    "path": "leads/organic/lead_bitcrushed.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Organic"
  },
  {
    "name": "lead_flute",
    "description": "Synth flute - breathy and soft",
    "genre": "Ambient, World, Electronic",
    "character": "Synth flute - breathy and soft",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Ambient, World, Electronic | Character: Synth flute - breathy and soft\ndefine_synthdef(\"lead_flute\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.08, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.0) * freq * 0.01;\n\n        // Main tone with harmonics\n        let body = sin_osc_ar(freq + vib) * 0.5;\n        let harm1 = sin_osc_ar((freq + vib) * 2.0) * 0.2;\n        let harm2 = sin_osc_ar((freq + vib) * 3.0) * 0.08;\n\n        // Breath noise\n        let breath_e = envelope()\n            .asr(0.1, 0.6, 0.15)\n            .gate(gate)\n            .build();\n        let breath = bpf_ar(pink_noise_ar(), freq * 1.5, 0.8) * breath_e * 0.2;\n\n        let sig = body + harm1 + harm2 + breath;\n\n        sig * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "organic",
    "path": "leads/organic/lead_flute.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Organic"
  },
  {
    "name": "lead_granular",
    "description": "Granular lead texture",
    "genre": "Ambient, Experimental",
    "character": "Granular lead texture",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Ambient, Experimental | Character: Granular lead texture\ndefine_synthdef(\"lead_granular\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .param(\"density\", 0.5)\n    .body(|freq, amp, gate, density| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Base tone\n        let base = sin_osc_ar(freq) * 0.4;\n\n        // Grain-like modulations\n        let grain_rate = 10.0 + density * 40.0;\n        let grain_mod = sin_osc_ar(grain_rate) * 0.5 + 0.5;\n\n        let grain1 = sin_osc_ar(freq * 1.002) * grain_mod * 0.2;\n        let grain2 = sin_osc_ar(freq * 0.998) * (1.0 - grain_mod) * 0.2;\n\n        // Random pitch deviations\n        let dust_mod = dust_ar(grain_rate * 2.0) * freq * 0.01;\n        let grain3 = sin_osc_ar(freq + dust_mod) * 0.15;\n\n        let sig = base + grain1 + grain2 + grain3;\n\n        sig * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "organic",
    "path": "leads/organic/lead_granular.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Organic"
  },
  {
    "name": "lead_tape",
    "description": "Tape-saturated warm lead",
    "genre": "Lo-fi, Synthwave",
    "character": "Tape-saturated warm lead",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Lo-fi, Synthwave | Character: Tape-saturated warm lead\ndefine_synthdef(\"lead_tape\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Tape wow/flutter\n        let wow = sin_osc_ar(0.4) * freq * 0.003;\n        let flutter = sin_osc_ar(6.0) * freq * 0.001;\n\n        // Slightly detuned oscillators\n        let osc1 = saw_ar(freq + wow + flutter);\n        let osc2 = saw_ar(freq * 1.003 + wow);\n\n        let mix = (osc1 + osc2) * 0.4;\n\n        // Tape saturation\n        let saturated = (mix * 1.5).tanh();\n\n        // Warm filtering (rolled off highs)\n        lpf_ar(saturated, 4000.0) * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "organic",
    "path": "leads/organic/lead_tape.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Organic"
  },
  {
    "name": "lead_theremin",
    "description": "Theremin emulation - eerie and wavering",
    "genre": "Experimental, Soundtrack",
    "character": "Theremin emulation - eerie and wavering",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Experimental, Soundtrack | Character: Theremin emulation - eerie and wavering\ndefine_synthdef(\"lead_theremin\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Characteristic wavering vibrato\n        let vib1 = sin_osc_ar(6.0) * freq * 0.015;\n        let vib2 = sin_osc_ar(0.5) * freq * 0.008;\n\n        // Pure sine tone\n        let body = sin_osc_ar(freq + vib1 + vib2);\n\n        body * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "organic",
    "path": "leads/organic/lead_theremin.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Organic"
  },
  {
    "name": "lead_vocal",
    "description": "Vocal synth lead - human-like formants",
    "genre": "Electronic, Synthpop",
    "character": "Vocal synth lead - human-like formants",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, Synthpop | Character: Vocal synth lead - human-like formants\ndefine_synthdef(\"lead_vocal\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .param(\"vowel\", 0.5)\n    .body(|freq, amp, gate, vowel| {\n        let env = envelope()\n            .asr(0.02, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.008;\n\n        // Rich harmonic source\n        let osc = saw_ar(freq + vib) * 0.5;\n\n        // Formant frequencies based on vowel\n        let f1 = 400.0 + vowel * 400.0;\n        let f2 = 1000.0 + vowel * 1000.0;\n        let f3 = 2500.0 + vowel * 500.0;\n\n        // Formant filters\n        let form1 = bpf_ar(osc, f1, 0.12) * 0.5;\n        let form2 = bpf_ar(osc, f2, 0.15) * 0.3;\n        let form3 = bpf_ar(osc, f3, 0.2) * 0.15;\n\n        let sig = form1 + form2 + form3;\n\n        sig * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "organic",
    "path": "leads/organic/lead_vocal.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Organic"
  },
  {
    "name": "lead_whistle",
    "description": "Synth whistle - pure and expressive",
    "genre": "Electronic, World",
    "character": "Synth whistle - pure and expressive",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, World | Character: Synth whistle - pure and expressive\ndefine_synthdef(\"lead_whistle\")\n    .param(\"freq\", 880.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slight vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.012;\n\n        // Pure sine with breath noise\n        let body = sin_osc_ar(freq + vib) * 0.7;\n\n        // Breath component\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.0, 0.5) * 0.15;\n\n        let sig = body + breath;\n\n        sig * env * amp\n    });\n",
    "category": "leads",
    "subcategory": "organic",
    "path": "leads/organic/lead_whistle.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Organic"
  },
  {
    "name": "lead_pluck_bell",
    "description": "Genre: Ambient, Experimental | Character: Bell-like with inharmonic overtones",
    "genre": "Ambient, Experimental",
    "character": "Bell-like with inharmonic overtones",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_pluck_bell\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Bell envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Inharmonic partials for bell character\n            let partial1 = sin_osc_ar(freq) * 0.6;\n            let partial2 = sin_osc_ar(freq * 2.4) * 0.3;\n            let partial3 = sin_osc_ar(freq * 3.8) * 0.15;\n            let partial4 = sin_osc_ar(freq * 5.3) * 0.08;\n\n            let mix = partial1 + partial2 + partial3 + partial4;\n\n            // Gentle filter\n            let filtered = lpf_ar(mix, 4000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "pluck",
    "path": "leads/pluck/pluck_bell.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Pluck"
  },
  {
    "name": "lead_pluck_bright",
    "description": "Genre: House, Pop | Character: Bright, shimmering pluck lead",
    "genre": "House, Pop",
    "character": "Bright, shimmering pluck lead",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_pluck_bright\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Quick attack, medium decay\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let harmonic4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n            let mix = fundamental + harmonic2 + harmonic3 + harmonic4;\n\n            // Filter sweep\n            let filter_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 2000.0 + (filter_env * 5000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "pluck",
    "path": "leads/pluck/pluck_bright.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Pluck"
  },
  {
    "name": "pluck_harp",
    "description": "Genre: Ambient, Classical | Character: Harp-like pluck",
    "genre": "Ambient, Classical",
    "character": "Harp-like pluck",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pluck_harp\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Harp envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Rich harmonic series\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.25;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.125;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.08;\n\n            let mix = h1 + h2 + h3 + h4 + h5;\n\n            // Pluck attack\n            let attack_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let attack = pink_noise_ar() * attack_env * 0.12;\n            let filtered_attack = lpf_ar(attack, 3000.0);\n\n            (mix + filtered_attack) * env * amp * 0.7\n        })\n});",
    "category": "leads",
    "subcategory": "pluck",
    "path": "leads/pluck/pluck_harp.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Pluck"
  },
  {
    "name": "pluck_kalimba",
    "description": "Genre: World, Ambient | Character: Kalimba/thumb piano sound",
    "genre": "World, Ambient",
    "character": "Kalimba/thumb piano sound",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pluck_kalimba\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Quick attack, medium decay\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 3.0) * 0.3;\n            let harmonic3 = sin_osc_ar(freq * 6.0) * 0.15;\n\n            // Add subtle noise for pluck attack\n            let attack_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let attack = pink_noise_ar() * attack_env * 0.08;\n            let filtered_attack = hpf_ar(attack, 2000.0);\n\n            let mix = fundamental + harmonic2 + harmonic3 + filtered_attack;\n\n            mix * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "pluck",
    "path": "leads/pluck/pluck_kalimba.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Pluck"
  },
  {
    "name": "lead_pluck_long",
    "description": "Genre: Ambient, Chillout | Character: Long, sustained pluck",
    "genre": "Ambient, Chillout",
    "character": "Long, sustained pluck",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_pluck_long\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Long sustain\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Rich harmonics\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.35;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.12;\n\n            let mix = h1 + h2 + h3 + h4;\n\n            // Slow filter evolution\n            let filter_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1200.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "pluck",
    "path": "leads/pluck/pluck_long.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Pluck"
  },
  {
    "name": "pluck_marimba",
    "description": "Genre: World, Ambient | Character: Marimba-like, wooden timbre",
    "genre": "World, Ambient",
    "character": "Marimba-like, wooden timbre",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pluck_marimba\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Marimba envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Woody timbre with specific harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 4.0) * 0.25;\n            let harmonic3 = sin_osc_ar(freq * 5.4) * 0.15;\n\n            let mix = fundamental + harmonic2 + harmonic3;\n\n            // Filter envelope\n            let filter_env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "pluck",
    "path": "leads/pluck/pluck_marimba.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Pluck"
  },
  {
    "name": "lead_pluck_muted",
    "description": "Genre: Lo-fi, Jazz | Character: Muted, soft pluck",
    "genre": "Lo-fi, Jazz",
    "character": "Muted, soft pluck",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_pluck_muted\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Soft envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Warm harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.2;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.1;\n\n            let mix = fundamental + harmonic2 + harmonic3;\n\n            // Low filter for muted character\n            let filtered = lpf_ar(mix, 1200.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "pluck",
    "path": "leads/pluck/pluck_muted.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Pluck"
  },
  {
    "name": "pluck_piano",
    "description": "Genre: All | Character: Piano-like pluck",
    "genre": "All",
    "character": "Piano-like pluck",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pluck_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Piano envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Complex harmonic structure\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.25;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.1;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.05;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Hammer attack\n            let attack_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let hammer = white_noise_ar() * attack_env * 0.15;\n            let filtered_hammer = lpf_ar(hammer, 4000.0);\n\n            (harmonics + filtered_hammer) * env * amp * 0.7\n        })\n});",
    "category": "leads",
    "subcategory": "pluck",
    "path": "leads/pluck/pluck_piano.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Pluck"
  },
  {
    "name": "lead_pluck_resonant",
    "description": "Genre: Techno, House | Character: Resonant pluck with filter character",
    "genre": "Techno, House",
    "character": "Resonant pluck with filter character",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_pluck_resonant\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Medium envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth for resonant filtering\n            let osc = saw_ar(freq);\n\n            // Resonant filter sweep\n            let filter_env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 3500.0);\n\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "pluck",
    "path": "leads/pluck/pluck_resonant.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Pluck"
  },
  {
    "name": "lead_pluck_short",
    "description": "Genre: Minimal, House | Character: Very short, staccato pluck",
    "genre": "Minimal, House",
    "character": "Very short, staccato pluck",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_pluck_short\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very short envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simple harmonics for clarity\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.3;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.15;\n\n            let mix = fundamental + harmonic2 + harmonic3;\n\n            // Fast filter sweep\n            let filter_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 3500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "pluck",
    "path": "leads/pluck/pluck_short.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Pluck"
  },
  {
    "name": "stab_brass",
    "description": "Genre: House, Funk | Character: Brass-like stab",
    "genre": "House, Funk",
    "character": "Brass-like stab",
    "params": [
      {
        "name": "freq",
        "default": 330
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stab_brass\", |builder| {\n    builder\n        .param(\"freq\", 330.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Brass-like envelope with bite\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chord with harmonics\n            let root = saw_ar(freq);\n            let third = saw_ar(freq * 1.25);\n            let fifth = saw_ar(freq * 1.5);\n            let seventh = saw_ar(freq * 1.75);\n\n            let chord = (root + third * 0.7 + fifth * 0.6 + seventh * 0.4) * 0.35;\n\n            // Brass-like filter\n            let filter_env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1200.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "stabs",
    "path": "leads/stabs/stab_brass.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Stabs"
  },
  {
    "name": "stab_bright",
    "description": "Genre: House, Techno | Character: Bright synth stab for emphasis",
    "genre": "House, Techno",
    "character": "Bright synth stab for emphasis",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stab_bright\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Sharp, quick envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chord (root, fifth, octave)\n            let root = saw_ar(freq);\n            let fifth = saw_ar(freq * 1.5);\n            let octave = saw_ar(freq * 2.0);\n\n            let chord = (root + fifth * 0.8 + octave * 0.6) * 0.4;\n\n            // Filter sweep\n            let filter_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 2000.0 + (filter_env * 4000.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "stabs",
    "path": "leads/stabs/stab_bright.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Stabs"
  },
  {
    "name": "stab_dark",
    "description": "Genre: Techno, Industrial | Character: Dark, aggressive stab",
    "genre": "Techno, Industrial",
    "character": "Dark, aggressive stab",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stab_dark\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Quick envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Minor chord (root, minor third, fifth)\n            let root = saw_ar(freq);\n            let minor_third = saw_ar(freq * 1.2);\n            let fifth = saw_ar(freq * 1.5);\n\n            let chord = (root + minor_third * 0.8 + fifth * 0.6) * 0.4;\n\n            // Dark filter\n            let filter_env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 600.0 + (filter_env * 1500.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "stabs",
    "path": "leads/stabs/stab_dark.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Stabs"
  },
  {
    "name": "stab_distorted",
    "description": "Genre: Industrial, Hard Techno | Character: Distorted, aggressive stab",
    "genre": "Industrial, Hard Techno",
    "character": "Distorted, aggressive stab",
    "params": [
      {
        "name": "freq",
        "default": 330
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stab_distorted\", |builder| {\n    builder\n        .param(\"freq\", 330.0)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Aggressive envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chord\n            let root = saw_ar(freq);\n            let fifth = saw_ar(freq * 1.5);\n            let octave = saw_ar(freq * 2.0);\n\n            let chord = (root + fifth * 0.8 + octave * 0.6) * 0.6;\n\n            // Distortion\n            let driven = clip(chord, -0.8, 0.8);\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1000.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(driven, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "stabs",
    "path": "leads/stabs/stab_distorted.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Stabs"
  },
  {
    "name": "stab_orchestral",
    "description": "Genre: Cinematic, Orchestral | Character: Orchestral string stab",
    "genre": "Cinematic, Orchestral",
    "character": "Orchestral string stab",
    "params": [
      {
        "name": "freq",
        "default": 330
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stab_orchestral\", |builder| {\n    builder\n        .param(\"freq\", 330.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // String-like envelope with bow attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Rich chord\n            let root = saw_ar(freq);\n            let third = saw_ar(freq * 1.25);\n            let fifth = saw_ar(freq * 1.5);\n            let octave = saw_ar(freq * 2.0);\n\n            let chord = (root + third * 0.8 + fifth * 0.7 + octave * 0.5) * 0.35;\n\n            // String-like filter\n            let filter_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1200.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            // Remove mud\n            let clean = hpf_ar(filtered, 150.0);\n\n            clean * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "stabs",
    "path": "leads/stabs/stab_orchestral.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Stabs"
  },
  {
    "name": "stab_piano",
    "description": "Genre: House, Garage | Character: Piano-like chord stab",
    "genre": "House, Garage",
    "character": "Piano-like chord stab",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stab_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Piano-like envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chord with harmonics\n            let r1 = sin_osc_ar(freq);\n            let r2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let r3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let root = r1 + r2 + r3;\n\n            let f1 = sin_osc_ar(freq * 1.5);\n            let f2 = sin_osc_ar(freq * 3.0) * 0.3;\n            let fifth = f1 + f2;\n\n            let chord = (root + fifth * 0.7) * 0.45;\n\n            // Attack transient\n            let attack_env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.12;\n            let filtered_attack = lpf_ar(attack, 4000.0);\n\n            (chord + filtered_attack) * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "stabs",
    "path": "leads/stabs/stab_piano.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Stabs"
  },
  {
    "name": "stab_short",
    "description": "Genre: Techno, Minimal | Character: Very short, percussive stab",
    "genre": "Techno, Minimal",
    "character": "Very short, percussive stab",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.75
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stab_short\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.75)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very short envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.0005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simple chord\n            let root = saw_ar(freq);\n            let fifth = saw_ar(freq * 1.5);\n\n            let chord = (root + fifth * 0.7) * 0.5;\n\n            // Fast filter sweep\n            let filter_env = envelope()\n                .asr(0.0005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 3500.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "stabs",
    "path": "leads/stabs/stab_short.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Stabs"
  },
  {
    "name": "stab_super",
    "description": "Genre: Trance, EDM | Character: Supersaw stab, wide and powerful",
    "genre": "Trance, EDM",
    "character": "Supersaw stab, wide and powerful",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"stab_super\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Punchy envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned chord for width\n            let r1 = saw_ar(freq * 0.995);\n            let r2 = saw_ar(freq * 1.005);\n            let f1 = saw_ar(freq * 1.495);\n            let f2 = saw_ar(freq * 1.505);\n            let o1 = saw_ar(freq * 1.995);\n            let o2 = saw_ar(freq * 2.005);\n\n            let chord = (r1 + r2 + f1 * 0.7 + f2 * 0.7 + o1 * 0.5 + o2 * 0.5) * 0.25;\n\n            // Bright filter sweep\n            let filter_env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 4500.0);\n\n            let filtered = lpf_ar(chord, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "stabs",
    "path": "leads/stabs/stab_super.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Stabs"
  },
  {
    "name": "lead_aggressive",
    "description": "Genre: Hard Techno, Industrial | Character: Aggressive, distorted lead",
    "genre": "Hard Techno, Industrial",
    "character": "Aggressive, distorted lead",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Aggressive envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.008, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Overdriven saws\n            let saw1 = saw_ar(freq * 0.995) * 1.8;\n            let saw2 = saw_ar(freq * 1.005) * 1.8;\n            let mix = (saw1 + saw2) * 0.5;\n\n            // Clip for distortion\n            let distorted = clip(mix, -0.8, 0.8);\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 3500.0);\n\n            let filtered = lpf_ar(distorted, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "synth",
    "path": "leads/synth/lead_aggressive.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Synth"
  },
  {
    "name": "lead_bright",
    "description": "Bright, energetic lead",
    "genre": "Trance, Progressive",
    "character": "Bright, energetic lead",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Trance, Progressive | Character: Bright, energetic lead\ndefine_synthdef(\"lead_bright\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n\n        // Envelope\n        // Gate-controlled ASR envelope for proper note-on/note-off behavior\n        let env = envelope()\n            .asr(0.01, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright sawtooth mix\n        let saw = saw_ar(freq);\n        let harmonic = saw_ar(freq * 2.0) * 0.3;\n        let mix = saw + harmonic;\n\n        // High-pass for extra brightness\n        let hp = hpf_ar(mix, 200.0);\n\n        // Filter\n        let filter_env = envelope()\n            .asr(0.03, 1.0, 0.1)\n            .gate(gate)\n            .build();\n        let mod_cutoff = 2000.0 + (filter_env * 4000.0);\n\n        let filtered = lpf_ar(hp, mod_cutoff);\n\n        filtered * env * amp\n    });\n\n",
    "category": "leads",
    "subcategory": "synth",
    "path": "leads/synth/lead_bright.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Synth"
  },
  {
    "name": "lead_dark",
    "description": "Genre: Techno, Industrial | Character: Dark, moody lead",
    "genre": "Techno, Industrial",
    "character": "Dark, moody lead",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_dark\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix of saw and pulse for darker timbre\n            let saw = saw_ar(freq) * 0.5;\n            let pulse = saw_ar(freq) * 0.5;\n            let mix = saw + pulse;\n\n            // Dark filter range\n            let filter_env = envelope()\n                .asr(0.15, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 400.0 + (filter_env * 1500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "synth",
    "path": "leads/synth/lead_dark.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Synth"
  },
  {
    "name": "lead_detuned",
    "description": "Genre: House, Techno | Character: Detuned lead with chorus effect",
    "genre": "House, Techno",
    "character": "Detuned lead with chorus effect",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_detuned\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Wide detuning for chorus\n            let osc1 = saw_ar(freq * 0.985);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.015);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1400.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "synth",
    "path": "leads/synth/lead_detuned.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Synth"
  },
  {
    "name": "lead_filtered",
    "description": "Genre: Techno, Minimal | Character: Heavily filtered lead",
    "genre": "Techno, Minimal",
    "character": "Heavily filtered lead",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_filtered\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth\n            let osc = saw_ar(freq);\n\n            // Resonant filter with sweep\n            let filter_env = envelope()\n                .asr(0.1, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 600.0 + (filter_env * 2500.0);\n\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "synth",
    "path": "leads/synth/lead_filtered.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Synth"
  },
  {
    "name": "lead_pwm",
    "description": "Genre: Synthwave, Electro | Character: Pulse width modulation lead",
    "genre": "Synthwave, Electro",
    "character": "Pulse width modulation lead",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_pwm\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // PWM envelope - modulate pulse width\n            let pwm_env = envelope()\n                .asr(0.1, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let width = 0.2 + (pwm_env * 0.6);\n\n            // Pulse wave with width as f64 constant (approximation)\n            // Using two pulses with different widths for movement\n            let pulse1 = saw_ar(freq);\n            let pulse2 = saw_ar(freq);\n            let mix = (pulse1 + pulse2) * 0.5;\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1300.0 + (filter_env * 2800.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "synth",
    "path": "leads/synth/lead_pwm.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Synth"
  },
  {
    "name": "lead_saw",
    "description": "Genre: Trance, House | Character: Classic saw lead, bright and cutting",
    "genre": "Trance, House",
    "character": "Classic saw lead, bright and cutting",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_saw\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Lead envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slightly detuned saws\n            let saw1 = saw_ar(freq * 0.998);\n            let saw2 = saw_ar(freq * 1.002);\n            let mix = (saw1 + saw2) * 0.5;\n\n            // Filter envelope for movement\n            let filter_env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1200.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "synth",
    "path": "leads/synth/lead_saw.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Synth"
  },
  {
    "name": "lead_smooth",
    "description": "Genre: Ambient, Chillout | Character: Smooth, gentle lead",
    "genre": "Ambient, Chillout",
    "character": "Smooth, gentle lead",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_smooth\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Soft envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sine with subtle harmonics\n            let fundamental = sin_osc_ar(freq);\n            let harmonic2 = sin_osc_ar(freq * 2.0) * 0.15;\n            let harmonic3 = sin_osc_ar(freq * 3.0) * 0.08;\n\n            let mix = fundamental + harmonic2 + harmonic3;\n\n            // Gentle filter\n            let filtered = lpf_ar(mix, 3000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "synth",
    "path": "leads/synth/lead_smooth.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Synth"
  },
  {
    "name": "lead_square",
    "description": "Genre: Electro, Synthwave | Character: Square wave lead, hollow and vintage",
    "genre": "Electro, Synthwave",
    "character": "Square wave lead, hollow and vintage",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_square\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.015, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Square waves (pulse with 0.5 width)\n            let square1 = saw_ar(freq * 0.999);\n            let square2 = saw_ar(freq * 1.001);\n            let mix = (square1 + square2) * 0.5;\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "synth",
    "path": "leads/synth/lead_square.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Synth"
  },
  {
    "name": "lead_supersaw",
    "description": "Genre: Trance, EDM | Character: Massive supersaw, wide and powerful",
    "genre": "Trance, EDM",
    "character": "Massive supersaw, wide and powerful",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lead_supersaw\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.02, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned saws\n            let saw1 = saw_ar(freq * 0.990);\n            let saw2 = saw_ar(freq * 0.996);\n            let saw3 = saw_ar(freq);\n            let saw4 = saw_ar(freq * 1.004);\n            let saw5 = saw_ar(freq * 1.010);\n\n            let mix = (saw1 + saw2 + saw3 + saw4 + saw5) * 0.2;\n\n            // Filter\n            let filter_env = envelope()\n                .asr(0.1, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 1000.0 + (filter_env * 4000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "leads",
    "subcategory": "synth",
    "path": "leads/synth/lead_supersaw.vibe",
    "categoryName": "Leads",
    "subcategoryName": "Synth"
  },
  {
    "name": "dubstep_wobble",
    "description": "Classic LFO wobble",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "rate",
        "default": 4
      },
      {
        "name": "intensity",
        "default": 0.8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"dubstep_wobble\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"rate\", 4.0) // Wobble rate\n        .param(\"intensity\", 0.8)\n        .body(|freq, amp, gate, rate, intensity| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bass oscillator\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.005);\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let mix = (saw1 + saw2) * 0.4 + sub;\n\n            // LFO for wobble\n            let lfo = sin_osc_ar(rate);\n            let filter_freq = 200.0 + (lfo * 0.5 + 0.5) * intensity * 3000.0;\n\n            // Resonant filter sweep\n            let filtered = rlpf_ar(mix, filter_freq, 0.25);\n\n            // Add some grit\n            let grit = (filtered * 1.5).tanh();\n\n            grit * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/dubstep.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "dubstep_growl",
    "description": "Aggressive FM growl",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "aggression",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"dubstep_growl\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"aggression\", 0.7)\n        .body(|freq, amp, gate, aggression| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM growl synthesis\n            let mod_depth = aggression * 5.0;\n            let modulator1 = sin_osc_ar(freq * 2.0) * mod_depth;\n            let modulator2 = sin_osc_ar(freq * 3.0) * mod_depth * 0.5;\n\n            let carrier = sin_osc_ar(freq + modulator1 + modulator2);\n\n            // Sub layer\n            let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n            let growl = carrier + sub;\n\n            // Heavy distortion\n            let dist = (growl * (2.0 + aggression * 3.0)).tanh();\n\n            // Filter for tone shaping\n            let filtered = lpf_ar(dist, 4000.0);\n\n            filtered * env * amp * 0.7\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/dubstep.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "dubstep_riddim",
    "description": "Minimal riddim bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"dubstep_riddim\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Short filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n\n            // Simple saw bass\n            let saw = saw_ar(freq);\n            let sub = sin_osc_ar(freq * 0.5) * 0.5;\n\n            let mix = saw * 0.6 + sub;\n\n            // Sharp filter sweep\n            let cutoff = 150.0 + filt_env * 2500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.3);\n\n            // Distortion\n            let dist = (filtered * 2.0).tanh();\n\n            dist * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/dubstep.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "dubstep_snare",
    "description": "Heavy layered snare",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 180
      },
      {
        "name": "amp",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"dubstep_snare\", |builder| {\n    builder\n        .param(\"freq\", 180.0)\n        .param(\"amp\", 0.7)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.25)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch sweep\n            let pitch_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n\n            // Body\n            let body = sin_osc_ar(freq + pitch_env * 100.0);\n\n            // Noise layer\n            let noise = white_noise_ar();\n            let filtered_noise = lpf_ar(hpf_ar(noise, 1500.0), 8000.0);\n\n            // Distorted mix\n            let mix = body * 0.4 + filtered_noise * 0.6;\n            let dist = (mix * 2.0).tanh();\n\n            dist * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/dubstep.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "dubstep_chord",
    "description": "Massive saw chord",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"dubstep_chord\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Massive detuned stack\n            let spread = 0.02;\n            let v1 = saw_ar(freq * (1.0 - spread * 2.0));\n            let v2 = saw_ar(freq * (1.0 - spread));\n            let v3 = saw_ar(freq);\n            let v4 = saw_ar(freq * (1.0 + spread));\n            let v5 = saw_ar(freq * (1.0 + spread * 2.0));\n\n            let mix = (v1 + v2 + v3 + v4 + v5) * 0.22;\n\n            // Aggressive filter\n            let filtered = rlpf_ar(mix, 5000.0, 0.35);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/dubstep.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "future_chord",
    "description": "Iconic supersaws",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "width",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"future_chord\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"width\", 0.6)\n        .body(|freq, amp, gate, width| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Supersaw stack\n            let spread = width * 0.025;\n            let v1 = saw_ar(freq * (1.0 - spread * 2.0));\n            let v2 = saw_ar(freq * (1.0 - spread));\n            let v3 = saw_ar(freq);\n            let v4 = saw_ar(freq * (1.0 + spread));\n            let v5 = saw_ar(freq * (1.0 + spread * 2.0));\n\n            let saws = (v1 + v2 + v3 + v4 + v5) * 0.22;\n\n            // Subtle sub layer\n            let sub = sin_osc_ar(freq * 0.5) * 0.15;\n\n            // High pass for clarity\n            let clean = hpf_ar(saws, 200.0);\n\n            (clean + sub) * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/future_bass.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "future_lead",
    "description": "Bright lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 880
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"future_lead\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Clean saw with slight detune\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.003);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Bright filtering\n            let filtered = lpf_ar(source, 8000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/future_bass.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "future_wobble",
    "description": "Sidechain-style pump",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "rate",
        "default": 4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"future_wobble\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"rate\", 4.0)\n        .body(|freq, amp, gate, rate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chord-like oscillators\n            let v1 = saw_ar(freq * 0.995);\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * 1.005);\n\n            let chord = (v1 + v2 + v3) * 0.35;\n\n            // Pump LFO (simulates sidechain)\n            let pump = sin_osc_ar(rate) * 0.4 + 0.6;\n\n            let filtered = lpf_ar(chord, 4000.0);\n\n            filtered * env * amp * pump\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/future_bass.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "future_pad",
    "description": "Soft atmospheric pad",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.3
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"future_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.5, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Soft detuned voices\n            let v1 = saw_ar(freq * 0.997);\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * 1.003);\n            let v4 = sin_osc_ar(freq * 0.5) * 0.3;\n\n            let mix = (v1 + v2 + v3) * 0.25 + v4;\n\n            // Very soft filtering\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/future_bass.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "future_pluck",
    "description": "Short melodic pluck",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"future_pluck\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let decay_env = envelope()\n                .perc(0.001, 0.25)\n                .build();\n\n            // Bright saw pluck\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.002);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Filter sweep\n            let cutoff = 800.0 + decay_env * 5000.0;\n            let filtered = rlpf_ar(source, cutoff, 0.35);\n\n            filtered * env * decay_env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/future_bass.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "hyperpop_lead",
    "description": "Bright processed lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 880
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "crunch",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hyperpop_lead\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"crunch\", 0.5)\n        .body(|freq, amp, gate, crunch| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright saw\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.005);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Bitcrushed layer\n            let crushed = (source * (4.0 + crunch * 8.0)).tanh();\n\n            // Very bright\n            let bright = hpf_ar(crushed, 500.0);\n\n            bright * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/hyperpop.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "hyperpop_chord",
    "description": "Processed chord stab",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hyperpop_chord\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Stacked supersaws\n            let spread = 0.015;\n            let v1 = saw_ar(freq * (1.0 - spread));\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * (1.0 + spread));\n\n            let mix = (v1 + v2 + v3) * 0.35;\n\n            // Crunchy processing\n            let crunched = (mix * 3.0).tanh();\n\n            // Bright filter\n            let filtered = hpf_ar(crunched, 300.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/hyperpop.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "hyperpop_bass",
    "description": "Distorted glitchy bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hyperpop_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.003, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n\n            // Aggressive bass\n            let saw = saw_ar(freq);\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let mix = saw * 0.6 + sub;\n\n            // Heavy distortion\n            let dist = (mix * 4.0).tanh();\n\n            // Filter sweep\n            let cutoff = 200.0 + filt_env * 3000.0;\n            let filtered = rlpf_ar(dist, cutoff, 0.35);\n\n            filtered * env * amp * 0.7\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/hyperpop.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "hyperpop_synth",
    "description": "Metallic processed synth",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hyperpop_synth\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM for metallic character\n            let mod_depth = 2.0;\n            let modulator = sin_osc_ar(freq * 3.5) * mod_depth;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Second layer\n            let saw = saw_ar(freq) * 0.3;\n\n            let mix = carrier + saw;\n\n            // Extreme processing\n            let processed = (mix * 3.0).tanh();\n\n            processed * env * amp * 0.6\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/hyperpop.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "hyperpop_hat",
    "description": "Crushed digital hat",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 12000
      },
      {
        "name": "amp",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hyperpop_hat\", |builder| {\n    builder\n        .param(\"freq\", 12000.0)\n        .param(\"amp\", 0.4)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.04)\n                .cleanup_on_finish()\n                .build();\n\n            // Noise-based hat\n            let noise = white_noise_ar();\n\n            // Extreme high pass\n            let filtered = hpf_ar(noise, freq);\n\n            // Digital crunch\n            let crunched = (filtered * 5.0).tanh();\n\n            crunched * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/hyperpop.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "lofi_keys",
    "description": "Warm dusty keys",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "dusty",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lofi_keys\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"dusty\", 0.5) // Amount of degradation\n        .body(|freq, amp, gate, dusty| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Rhodes-like tone\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n            let clean = h1 + h2 + h3 + h4;\n\n            // Add vinyl warmth\n            let noise = white_noise_ar() * dusty * 0.02;\n            let warped = clean + noise;\n\n            // Lo-fi filtering (roll off highs)\n            let lofi = lpf_ar(warped, 3000.0 - dusty * 1500.0);\n\n            lofi * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/lofi.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "lofi_piano",
    "description": "Dusty sampled feel",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lofi_piano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let decay_env = envelope()\n                .perc(0.001, 1.2)\n                .build();\n\n            // Piano harmonics\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.08;\n\n            let piano = h1 + h2 + h3 + h4 + h5;\n\n            // Lo-fi character\n            let lofi = lpf_ar(piano, 2500.0);\n\n            // Slight detuning for worn tape feel\n            let warble = sin_osc_ar(0.5) * 0.002 + 1.0;\n\n            lofi * env * decay_env * amp * warble * 0.6\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/lofi.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "lofi_bass",
    "description": "Warm rounded bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lofi_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Soft bass tone\n            let fund = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n\n            let bass = fund + h2;\n\n            // Warm filtering\n            let warm = lpf_ar(bass, 800.0);\n\n            warm * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/lofi.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "lofi_pad",
    "description": "Atmospheric background",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.3
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lofi_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.8, 1.0, 0.8)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Soft detuned voices\n            let v1 = sin_osc_ar(freq * 0.998);\n            let v2 = sin_osc_ar(freq);\n            let v3 = sin_osc_ar(freq * 1.002);\n\n            let mix = (v1 + v2 + v3) * 0.35;\n\n            // Very lo-fi\n            let lofi = lpf_ar(mix, 1500.0);\n\n            // Tape warble\n            let warble = sin_osc_ar(0.3) * 0.005 + 1.0;\n\n            lofi * env * amp * warble\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/lofi.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "lofi_crackle",
    "description": "Background texture",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "amp",
        "default": 0.15
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "density",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lofi_crackle\", |builder| {\n    builder\n        .param(\"amp\", 0.15)\n        .param(\"gate\", 1.0)\n        .param(\"density\", 0.5)\n        .body(|amp, gate, density| {\n            let env = envelope()\n                .asr(0.1, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Random impulses for crackle\n            let crackle = dust_ar(5.0 + density * 20.0);\n            let filtered_crackle = hpf_ar(crackle, 1000.0);\n\n            // Background hiss\n            let hiss = white_noise_ar() * 0.02;\n            let filtered_hiss = lpf_ar(hpf_ar(hiss, 500.0), 4000.0);\n\n            (filtered_crackle * 0.3 + filtered_hiss) * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/lofi.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "serum_growl",
    "description": "The dubstep staple",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "growl_rate",
        "default": 8
      },
      {
        "name": "intensity",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"serum_growl\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"growl_rate\", 8.0) // LFO rate for growl\n        .param(\"intensity\", 0.7)\n        .body(|freq, amp, gate, growl_rate, intensity| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM modulation for growl character\n            let lfo = sin_osc_ar(growl_rate);\n            let mod_depth = lfo * intensity * 0.3 + 0.3;\n\n            let modulator = sin_osc_ar(freq * 2.0) * mod_depth * freq;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Second layer for thickness\n            let mod2 = sin_osc_ar(freq * 3.0) * mod_depth * freq * 0.5;\n            let carrier2 = sin_osc_ar(freq * 0.5 + mod2) * 0.6;\n\n            let growl = carrier * 0.5 + carrier2;\n\n            // Distortion for edge\n            let dist = (growl * 2.0).tanh();\n\n            // Filter sweep\n            let filter_mod = lfo * 1000.0 + 2000.0;\n            let filtered = rlpf_ar(dist, filter_mod, 0.4);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/serum_style.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "serum_reese",
    "description": "Modern reese",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "detune",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"serum_reese\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"detune\", 0.5)\n        .body(|freq, amp, gate, detune| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned saws for modern reese\n            let spread = detune * 0.02;\n            let v1 = saw_ar(freq * (1.0 - spread * 2.0));\n            let v2 = saw_ar(freq * (1.0 - spread));\n            let v3 = saw_ar(freq);\n            let v4 = saw_ar(freq * (1.0 + spread));\n            let v5 = saw_ar(freq * (1.0 + spread * 2.0));\n\n            let mix = (v1 + v2 + v3 + v4 + v5) * 0.22;\n\n            // Subtle modulation\n            let mod_lfo = sin_osc_ar(0.2) * 0.002 + 1.0;\n\n            // Bass boost\n            let boosted = mix + lpf_ar(mix, 100.0) * 0.5;\n\n            boosted * env * amp * mod_lfo\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/serum_style.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "serum_supersaw",
    "description": "Ultra-wide lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "width",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"serum_supersaw\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"width\", 0.7)\n        .body(|freq, amp, gate, width| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // 7 voices with varying detune\n            let spread = width * 0.04;\n            let v1 = saw_ar(freq * (1.0 - spread * 3.0));\n            let v2 = saw_ar(freq * (1.0 - spread * 2.0));\n            let v3 = saw_ar(freq * (1.0 - spread));\n            let v4 = saw_ar(freq);\n            let v5 = saw_ar(freq * (1.0 + spread));\n            let v6 = saw_ar(freq * (1.0 + spread * 2.0));\n            let v7 = saw_ar(freq * (1.0 + spread * 3.0));\n\n            let mix = (v1 + v2 + v3 + v4 + v5 + v6 + v7) * 0.17;\n\n            // Bright filter\n            let filtered = lpf_ar(mix, 10000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/serum_style.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "serum_pluck",
    "description": "Modern pluck lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"serum_pluck\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast decay envelope\n            let decay_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Saw with filter sweep\n            let saw = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.005);\n\n            let source = (saw + saw2) * 0.5;\n\n            // Filter pluck\n            let cutoff = 500.0 + decay_env * 6000.0;\n            let filtered = rlpf_ar(source, cutoff, 0.3);\n\n            filtered * env * decay_env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/serum_style.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "serum_hoover",
    "description": "Classic rave hoover updated",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"serum_hoover\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned oscillators with movement\n            let lfo = sin_osc_ar(0.5) * 0.01 + 1.0;\n            let v1 = saw_ar(freq * 0.99 * lfo);\n            let v2 = saw_ar(freq * lfo);\n            let v3 = saw_ar(freq * 1.01 * lfo);\n\n            // Sync-like harmonics\n            let sync_osc = saw_ar(freq * 2.5) * 0.3;\n\n            let mix = (v1 + v2 + v3) * 0.35 + sync_osc;\n\n            // Resonant sweep\n            let filter_lfo = sin_osc_ar(0.3) * 500.0 + 2000.0;\n            let filtered = rlpf_ar(mix, filter_lfo, 0.4);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/serum_style.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "synthwave_bass",
    "description": "Pulsing retro bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"synthwave_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            // Fat saw bass\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.003);\n            let sub = sin_osc_ar(freq * 0.5) * 0.5;\n\n            let mix = (saw1 + saw2) * 0.4 + sub;\n\n            // Punchy filter\n            let cutoff = 300.0 + filt_env * 2000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/synthwave.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "synthwave_lead",
    "description": "Soaring lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"synthwave_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws\n            let saw1 = saw_ar(freq * 0.998);\n            let saw2 = saw_ar(freq);\n            let saw3 = saw_ar(freq * 1.002);\n\n            let mix = (saw1 + saw2 + saw3) * 0.35;\n\n            // Bright with slight resonance\n            let filtered = rlpf_ar(mix, 5000.0, 0.4);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/synthwave.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "synthwave_pad",
    "description": "Lush retro pad",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"synthwave_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Juno-like chorus\n            let lfo1 = sin_osc_ar(0.5) * 0.006;\n            let lfo2 = sin_osc_ar(0.6) * 0.006;\n\n            let v1 = saw_ar(freq * (1.0 + lfo1));\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * (1.0 + lfo2));\n\n            let mix = (v1 + v2 + v3) * 0.35;\n\n            // Warm filtering\n            let filtered = lpf_ar(mix, 3000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/synthwave.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "synthwave_arp",
    "description": "Arpeggiated lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"synthwave_arp\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Clean saw with slight detune\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.002);\n\n            let mix = (saw1 + saw2) * 0.5;\n\n            // Bright plucky filter\n            let filt_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let cutoff = 1000.0 + filt_env * 4000.0;\n\n            let filtered = rlpf_ar(mix, cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/synthwave.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "synthwave_snare",
    "description": "Gated reverb snare character",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 200
      },
      {
        "name": "amp",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"synthwave_snare\", |builder| {\n    builder\n        .param(\"freq\", 200.0)\n        .param(\"amp\", 0.6)\n        .body(|freq, amp| {\n            // 80s snare envelope\n            let env = envelope()\n                .perc(0.001, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Snare body\n            let body = sin_osc_ar(freq);\n\n            // Noise\n            let noise = white_noise_ar();\n            let filtered_noise = hpf_ar(lpf_ar(noise, 8000.0), 2000.0);\n\n            // Mix\n            let snare = body * 0.4 + filtered_noise * 0.6;\n\n            snare * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/synthwave.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "trap_808_long",
    "description": "Extended 808 bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 40
      },
      {
        "name": "amp",
        "default": 0.8
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "decay",
        "default": 2
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trap_808_long\", |builder| {\n    builder\n        .param(\"freq\", 40.0)\n        .param(\"amp\", 0.8)\n        .param(\"gate\", 1.0)\n        .param(\"decay\", 2.0) // Long decay time\n        .body(|freq, amp, gate, decay| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Long decay envelope\n            let decay_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay)\n                .build();\n\n            // Pitch envelope for 808 character\n            let pitch_env = envelope()\n                .perc(0.001, 0.08)\n                .build();\n            let freq_mod = pitch_env * freq * 3.0;\n\n            // Pure sine 808\n            let osc = sin_osc_ar(freq + freq_mod);\n\n            // Slight saturation for presence\n            let sat = (osc * 1.5).tanh() * 0.8;\n\n            sat * env * decay_env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/trap.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "trap_808_dist",
    "description": "Heavy distorted 808",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 40
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "drive",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trap_808_dist\", |builder| {\n    builder\n        .param(\"freq\", 40.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .param(\"drive\", 0.6)\n        .body(|freq, amp, gate, drive| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let decay_env = envelope()\n                .perc(0.001, 1.5)\n                .build();\n\n            // Pitch envelope\n            let pitch_env = envelope()\n                .perc(0.001, 0.06)\n                .build();\n            let freq_mod = pitch_env * freq * 4.0;\n\n            // 808 oscillator\n            let osc = sin_osc_ar(freq + freq_mod);\n\n            // Heavy distortion\n            let dist_amount = 2.0 + drive * 6.0;\n            let dist = (osc * dist_amount).tanh();\n\n            // Low pass to control harshness\n            let filtered = lpf_ar(dist, 3000.0);\n\n            filtered * env * decay_env * amp * 0.7\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/trap.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "trap_hat",
    "description": "Fast trap hats",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 8000
      },
      {
        "name": "amp",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trap_hat\", |builder| {\n    builder\n        .param(\"freq\", 8000.0)\n        .param(\"amp\", 0.4)\n        .body(|freq, amp| {\n            // Very short envelope\n            let env = envelope()\n                .perc(0.001, 0.05)\n                .cleanup_on_finish()\n                .build();\n\n            // High-passed noise\n            let noise = white_noise_ar();\n            let filtered = hpf_ar(noise, freq);\n\n            // Metallic resonance\n            let metal = rlpf_ar(noise, freq * 1.2, 0.1) * 0.5;\n\n            (filtered + metal) * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/trap.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "trap_hat_roll",
    "description": "Rapid-fire hats",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 9000
      },
      {
        "name": "amp",
        "default": 0.3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trap_hat_roll\", |builder| {\n    builder\n        .param(\"freq\", 9000.0)\n        .param(\"amp\", 0.3)\n        .body(|freq, amp| {\n            // Extra short for rolls\n            let env = envelope()\n                .perc(0.0001, 0.02)\n                .cleanup_on_finish()\n                .build();\n\n            // Tight filtered noise\n            let noise = white_noise_ar();\n            let filtered = hpf_ar(noise, freq);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/trap.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "trap_lead",
    "description": "Dark melodic lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trap_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Dark detuned saw\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.004);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Dark filter\n            let filtered = lpf_ar(source, 2500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/trap.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "trap_bell",
    "description": "Melodic bell lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 880
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"trap_bell\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let decay_env = envelope()\n                .perc(0.001, 0.8)\n                .build();\n\n            // Simple FM bell\n            let mod_depth = decay_env * 2.0;\n            let modulator = sin_osc_ar(freq * 2.0) * mod_depth;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Harmonics\n            let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.15;\n\n            let bell = carrier + h2 + h3;\n\n            bell * env * decay_env * amp * 0.5\n        })\n});",
    "category": "modern",
    "subcategory": "",
    "path": "modern/trap.vibe",
    "categoryName": "Modern"
  },
  {
    "name": "mod_lfo",
    "description": "LFO module (as audio rate for AM effects)",
    "genre": "Modular, Experimental",
    "character": "LFO module (as audio rate for AM effects)",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Modular, Experimental | Character: LFO module (as audio rate for AM effects)\ndefine_synthdef(\"mod_lfo\")\n    .param(\"freq\", 5.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .param(\"wave\", 0.0) // 0=sine, 0.5=triangle, 1.0=saw\n    .body(|freq, amp, gate, wave| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Crossfade LFO shapes\n        let sine_wave = sin_osc_ar(freq) * (1.0 - wave * 2.0).max(0.0);\n        let tri_wave = lf_tri_ar(freq) * (1.0 - (wave - 0.5).abs() * 2.0).max(0.0);\n        let saw_wave = saw_ar(freq) * ((wave - 0.5) * 2.0).max(0.0);\n\n        let mix = (sine_wave + tri_wave + saw_wave) * 0.5 + 0.5;\n\n        mix * env * amp\n    });\n",
    "category": "modular",
    "subcategory": "",
    "path": "modular/mod_lfo.vibe",
    "categoryName": "Modular"
  },
  {
    "name": "mod_noise",
    "description": "Noise source module",
    "genre": "Modular, Experimental",
    "character": "Noise source module",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Modular, Experimental | Character: Noise source module\ndefine_synthdef(\"mod_noise\")\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .param(\"color\", 0.5) // 0=white, 1=pink\n    .body(|amp, gate, color| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.001)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Crossfade white to pink\n        let white = white_noise_ar() * (1.0 - color);\n        let pink = pink_noise_ar() * color;\n\n        (white + pink) * env * amp\n    });\n",
    "category": "modular",
    "subcategory": "",
    "path": "modular/mod_noise.vibe",
    "categoryName": "Modular"
  },
  {
    "name": "mod_vco",
    "description": "Basic VCO module",
    "genre": "Modular, Experimental",
    "character": "Basic VCO module",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Modular, Experimental | Character: Basic VCO module\ndefine_synthdef(\"mod_vco\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.7)\n    .param(\"gate\", 1.0)\n    .param(\"wave\", 0.0) // 0=saw, 0.5=pulse, 1.0=sine\n    .body(|freq, amp, gate, wave| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.001)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Crossfade between waveforms\n        let saw_wave = saw_ar(freq) * (1.0 - wave * 2.0).max(0.0);\n        let pulse_wave = pulse_ar(freq, 0.5) * (1.0 - (wave - 0.5).abs() * 2.0).max(0.0);\n        let sine_wave = sin_osc_ar(freq) * ((wave - 0.5) * 2.0).max(0.0);\n\n        let mix = saw_wave + pulse_wave + sine_wave;\n\n        mix * env * amp\n    });\n",
    "category": "modular",
    "subcategory": "",
    "path": "modular/mod_vco.vibe",
    "categoryName": "Modular"
  },
  {
    "name": "brass_stab",
    "description": "Punchy brass stab",
    "genre": "Orchestral, Cinematic",
    "character": "Punchy brass stab",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Orchestral, Cinematic | Character: Punchy brass stab\ndefine_synthdef(\"brass_stab\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.7)\n    .body(|freq, amp| {\n        // Punchy brass envelope\n        let amp_env = envelope()\n            .perc(0.01, 0.3)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.01, 0.2)\n            .build();\n\n        // Brass section\n        let osc1 = saw_ar(freq * 0.998) * 0.3;\n        let osc2 = saw_ar(freq) * 0.35;\n        let osc3 = saw_ar(freq * 1.002) * 0.3;\n\n        let mix = osc1 + osc2 + osc3;\n\n        // Brass filter character\n        let cutoff = 1000.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.2) * amp_env * amp\n    });\n",
    "category": "orchestral",
    "subcategory": "",
    "path": "orchestral/brass_stab.vibe",
    "categoryName": "Orchestral"
  },
  {
    "name": "strings_legato",
    "description": "Smooth legato string section",
    "genre": "Orchestral, Cinematic",
    "character": "Smooth legato string section",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Orchestral, Cinematic | Character: Smooth legato string section\ndefine_synthdef(\"strings_legato\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Smooth legato envelope\n        let env = envelope()\n            .asr(0.15, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.006;\n\n        // String section\n        let v1 = saw_ar(freq * 0.997 + vib) * 0.22;\n        let v2 = saw_ar(freq + vib * 0.8) * 0.25;\n        let v3 = saw_ar(freq * 1.003 + vib * 1.1) * 0.22;\n        let v4 = saw_ar(freq * 1.006) * 0.18;\n\n        let mix = v1 + v2 + v3 + v4;\n\n        lpf_ar(mix, 5000.0) * env * amp\n    });\n",
    "category": "orchestral",
    "subcategory": "",
    "path": "orchestral/strings_legato.vibe",
    "categoryName": "Orchestral"
  },
  {
    "name": "strings_staccato",
    "description": "Short staccato string section",
    "genre": "Orchestral, Cinematic",
    "character": "Short staccato string section",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Orchestral, Cinematic | Character: Short staccato string section\ndefine_synthdef(\"strings_staccato\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .body(|freq, amp| {\n        // Short staccato envelope\n        let amp_env = envelope()\n            .perc(0.01, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Multiple detuned oscillators for section\n        let v1 = saw_ar(freq * 0.998) * 0.25;\n        let v2 = saw_ar(freq) * 0.25;\n        let v3 = saw_ar(freq * 1.002) * 0.25;\n        let v4 = saw_ar(freq * 1.005) * 0.2;\n\n        let mix = v1 + v2 + v3 + v4;\n\n        // Warm filtering\n        lpf_ar(mix, 4000.0) * amp_env * amp\n    });\n",
    "category": "orchestral",
    "subcategory": "",
    "path": "orchestral/strings_staccato.vibe",
    "categoryName": "Orchestral"
  },
  {
    "name": "timpani",
    "description": "Timpani drum with resonant tone",
    "genre": "Orchestral, Cinematic",
    "character": "Timpani drum with resonant tone",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Orchestral, Cinematic | Character: Timpani drum with resonant tone\ndefine_synthdef(\"timpani\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.9)\n    .body(|freq, amp| {\n        // Long resonant decay\n        let amp_env = envelope()\n            .perc(0.002, 1.2)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let freq_mod = pitch_env * freq * 0.8;\n\n        // Main body\n        let body = sin_osc_ar(freq + freq_mod) * 0.6;\n        let harm1 = sin_osc_ar((freq + freq_mod) * 1.5) * 0.2;\n        let harm2 = sin_osc_ar((freq + freq_mod) * 2.0) * 0.1;\n\n        // Mallet attack\n        let attack_env = envelope()\n            .perc(0.001, 0.025)\n            .build();\n        let attack = lpf_ar(white_noise_ar(), 2000.0) * attack_env * 0.3;\n\n        (body + harm1 + harm2 + attack) * amp_env * amp\n    });\n",
    "category": "orchestral",
    "subcategory": "",
    "path": "orchestral/timpani.vibe",
    "categoryName": "Orchestral"
  },
  {
    "name": "wind_chimes",
    "description": "Metal wind chimes",
    "genre": "Orchestral, Ambient",
    "character": "Metal wind chimes",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Orchestral, Ambient | Character: Metal wind chimes\ndefine_synthdef(\"wind_chimes\")\n    .param(\"freq\", 2000.0)\n    .param(\"amp\", 0.4)\n    .param(\"density\", 0.5)\n    .body(|freq, amp, density| {\n        // Overall envelope\n        let amp_env = envelope()\n            .perc(0.001, 2.0)\n            .cleanup_on_finish()\n            .build();\n\n        // Multiple resonant frequencies\n        let chime1 = sin_osc_ar(freq) * dust_ar(density * 10.0) * 0.2;\n        let chime2 = sin_osc_ar(freq * 1.2) * dust_ar(density * 8.0) * 0.18;\n        let chime3 = sin_osc_ar(freq * 1.5) * dust_ar(density * 12.0) * 0.15;\n        let chime4 = sin_osc_ar(freq * 0.8) * dust_ar(density * 6.0) * 0.15;\n        let chime5 = sin_osc_ar(freq * 1.8) * dust_ar(density * 10.0) * 0.12;\n\n        let mix = chime1 + chime2 + chime3 + chime4 + chime5;\n\n        mix * amp_env * amp\n    });\n",
    "category": "orchestral",
    "subcategory": "",
    "path": "orchestral/wind_chimes.vibe",
    "categoryName": "Orchestral"
  },
  {
    "name": "pad_bright",
    "description": "Genre: Ambient, Chillout | Character: Bright, airy pad",
    "genre": "Ambient, Chillout",
    "character": "Bright, airy pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_bright\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow attack, long release\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.4, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright oscillators with wide detuning\n            let osc1 = saw_ar(freq * 0.990);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.010);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Bright filtering\n            let filtered = lpf_ar(mix, 3000.0);\n\n            // High-pass to remove mud\n            let clean = hpf_ar(filtered, 150.0);\n\n            clean * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "ambient",
    "path": "pads/ambient/pad_bright.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Ambient"
  },
  {
    "name": "pad_cold",
    "description": "Genre: Ambient, Drone | Character: Cold, digital pad",
    "genre": "Ambient, Drone",
    "character": "Cold, digital pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_cold\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.4, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pulse waves for digital character\n            let pulse1 = saw_ar(freq * 0.997);\n            let pulse2 = saw_ar(freq);\n            let pulse3 = saw_ar(freq * 1.003);\n\n            let mix = (pulse1 + pulse2 + pulse3) * 0.33;\n\n            // Cold filtering - remove lows\n            let hp = hpf_ar(mix, 300.0);\n            let filtered = lpf_ar(hp, 2500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "ambient",
    "path": "pads/ambient/pad_cold.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Ambient"
  },
  {
    "name": "pad_dark",
    "description": "Genre: Ambient, Dark Ambient | Character: Dark, brooding pad",
    "genre": "Ambient, Dark Ambient",
    "character": "Dark, brooding pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_dark\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow attack, long release\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.3, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Low, dark oscillators\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.005);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Dark filtering\n            let filtered = lpf_ar(mix, 800.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "ambient",
    "path": "pads/ambient/pad_dark.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Ambient"
  },
  {
    "name": "pad_dense",
    "description": "Genre: Ambient, Drone | Character: Dense, thick pad",
    "genre": "Ambient, Drone",
    "character": "Dense, thick pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.35
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_dense\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.35)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Moderate attack, long sustain\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.3, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Many detuned oscillators for thickness\n            let osc1 = saw_ar(freq * 0.988);\n            let osc2 = saw_ar(freq * 0.994);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.006);\n            let osc5 = saw_ar(freq * 1.012);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Warm filtering\n            let filtered = lpf_ar(mix, 1800.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "ambient",
    "path": "pads/ambient/pad_dense.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Ambient"
  },
  {
    "name": "pad_evolving",
    "description": "Genre: Ambient, Experimental | Character: Evolving pad with filter movement",
    "genre": "Ambient, Experimental",
    "character": "Evolving pad with filter movement",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_evolving\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Long attack and release\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.5, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned oscillators\n            let osc1 = saw_ar(freq * 0.993);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.007);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Filter evolves over time\n            let filter_env = envelope()\n                .asr(1.0, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 600.0 + (filter_env * 2000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "ambient",
    "path": "pads/ambient/pad_evolving.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Ambient"
  },
  {
    "name": "pad_filtered",
    "description": "Genre: Ambient, Techno | Character: Heavily filtered pad with resonance",
    "genre": "Ambient, Techno",
    "character": "Heavily filtered pad with resonance",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_filtered\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.4, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.005);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Resonant filter\n            let filter_env = envelope()\n                .asr(0.8, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 1500.0);\n\n            let filtered = rlpf_ar(mix, mod_cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "ambient",
    "path": "pads/ambient/pad_filtered.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Ambient"
  },
  {
    "name": "pad_shimmer",
    "description": "Genre: Ambient, Post-Rock | Character: Shimmering pad with high harmonics",
    "genre": "Ambient, Post-Rock",
    "character": "Shimmering pad with high harmonics",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_shimmer\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Long attack for shimmer\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.5, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fundamental and high harmonics\n            let fundamental = saw_ar(freq) * 0.4;\n            let harmonic2 = saw_ar(freq * 2.0) * 0.25;\n            let harmonic3 = saw_ar(freq * 3.0) * 0.15;\n            let harmonic4 = saw_ar(freq * 4.0) * 0.1;\n\n            let mix = fundamental + harmonic2 + harmonic3 + harmonic4;\n\n            // Bright filter\n            let filtered = lpf_ar(mix, 4000.0);\n\n            // High-pass for air\n            let clean = hpf_ar(filtered, 200.0);\n\n            clean * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "ambient",
    "path": "pads/ambient/pad_shimmer.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Ambient"
  },
  {
    "name": "pad_space",
    "description": "Genre: Ambient, Space Music | Character: Spacious, atmospheric pad",
    "genre": "Ambient, Space Music",
    "character": "Spacious, atmospheric pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.35
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_space\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.35)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very long attack and release\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.8, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Wide detuning for space\n            let osc1 = saw_ar(freq * 0.985);\n            let osc2 = saw_ar(freq * 0.995);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.005);\n            let osc5 = saw_ar(freq * 1.015);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Filter movement for evolution\n            let filter_env = envelope()\n                .asr(1.5, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            // Remove mud\n            let clean = hpf_ar(filtered, 120.0);\n\n            clean * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "ambient",
    "path": "pads/ambient/pad_space.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Ambient"
  },
  {
    "name": "pad_sparse",
    "description": "Genre: Ambient, Minimal | Character: Sparse, minimal pad",
    "genre": "Ambient, Minimal",
    "character": "Sparse, minimal pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.45
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_sparse\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very slow attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.6, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Just two oscillators, subtle detuning\n            let osc1 = sin_osc_ar(freq * 0.998);\n            let osc2 = sin_osc_ar(freq * 1.002);\n\n            let mix = (osc1 + osc2) * 0.5;\n\n            // Minimal filtering\n            let filtered = lpf_ar(mix, 2000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "ambient",
    "path": "pads/ambient/pad_sparse.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Ambient"
  },
  {
    "name": "pad_warm",
    "description": "Genre: Ambient, Chillout | Character: Warm, comforting pad",
    "genre": "Ambient, Chillout",
    "character": "Warm, comforting pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_warm\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Gentle attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.35, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix of sine and saw for warmth\n            let sine = sin_osc_ar(freq);\n            let saw1 = saw_ar(freq * 0.997) * 0.3;\n            let saw2 = saw_ar(freq * 1.003) * 0.3;\n\n            let mix = sine * 0.6 + (saw1 + saw2);\n\n            // Warm filtering\n            let filtered = lpf_ar(mix, 2000.0);\n\n            filtered * env * amp * 0.8\n        })\n});",
    "category": "pads",
    "subcategory": "ambient",
    "path": "pads/ambient/pad_warm.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Ambient"
  },
  {
    "name": "pad_cs80",
    "description": "Yamaha CS-80 pad - expressive and cinematic",
    "genre": "Cinematic, Synthwave",
    "character": "Yamaha CS-80 pad - expressive and cinematic",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Cinematic, Synthwave | Character: Yamaha CS-80 pad - expressive and cinematic\ndefine_synthdef(\"pad_cs80\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.25, 1.0, 0.35)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow filter envelope\n        let filt_env = envelope()\n            .asr(0.4, 1.0, 0.4)\n            .gate(gate)\n            .build();\n\n        // Rich detuned oscillators\n        let osc1 = saw_ar(freq * 0.994);\n        let osc2 = saw_ar(freq * 0.998);\n        let osc3 = saw_ar(freq);\n        let osc4 = saw_ar(freq * 1.002);\n        let osc5 = saw_ar(freq * 1.006);\n\n        let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.18;\n\n        // Expressive filter\n        let cutoff = 500.0 + filt_env * 2500.0;\n        rlpf_ar(mix, cutoff, 0.12) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "analog",
    "path": "pads/analog/pad_cs80.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Analog"
  },
  {
    "name": "pad_juno",
    "description": "Roland Juno chorus pad - lush and warm",
    "genre": "House, Synthwave",
    "character": "Roland Juno chorus pad - lush and warm",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: House, Synthwave | Character: Roland Juno chorus pad - lush and warm\ndefine_synthdef(\"pad_juno\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // PWM characteristic of Juno\n        let pwm = sin_osc_ar(0.3) * 0.25 + 0.5;\n        let osc1 = pulse_ar(freq, pwm);\n        let osc2 = pulse_ar(freq * 1.005, pwm);\n\n        // Sub layer\n        let sub = pulse_ar(freq * 0.5, 0.5) * 0.3;\n\n        let mix = (osc1 + osc2 + sub) * 0.3;\n\n        // Juno-style chorus simulation\n        let chorus_lfo = sin_osc_ar(0.5);\n        let delayed = delay_c_ar(mix, 0.03, 0.015 + chorus_lfo * 0.005);\n        let chorused = (mix + delayed) * 0.5;\n\n        lpf_ar(chorused, 3000.0) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "analog",
    "path": "pads/analog/pad_juno.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Analog"
  },
  {
    "name": "pad_jupiter",
    "description": "Roland Jupiter-8 pad - bright and wide",
    "genre": "Electronic, Synthpop",
    "character": "Roland Jupiter-8 pad - bright and wide",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, Synthpop | Character: Roland Jupiter-8 pad - bright and wide\ndefine_synthdef(\"pad_jupiter\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.18, 1.0, 0.28)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .asr(0.25, 1.0, 0.3)\n            .gate(gate)\n            .build();\n\n        // Detuned saws with pulse\n        let saw1 = saw_ar(freq * 0.997);\n        let saw2 = saw_ar(freq);\n        let saw3 = saw_ar(freq * 1.003);\n        let pulse = pulse_ar(freq, 0.45) * 0.4;\n\n        let mix = (saw1 + saw2 + saw3 + pulse) * 0.25;\n\n        // Bright but smooth filter\n        let cutoff = 1000.0 + filt_env * 3500.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "analog",
    "path": "pads/analog/pad_jupiter.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Analog"
  },
  {
    "name": "pad_oberheim",
    "description": "Oberheim brass pad - thick and powerful",
    "genre": "80s, Synthpop",
    "character": "Oberheim brass pad - thick and powerful",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: 80s, Synthpop | Character: Oberheim brass pad - thick and powerful\ndefine_synthdef(\"pad_oberheim\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .asr(0.15, 1.0, 0.25)\n            .gate(gate)\n            .build();\n\n        // Multiple saws for thickness\n        let osc1 = saw_ar(freq * 0.995);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.005);\n        let pulse_osc = pulse_ar(freq, 0.4) * 0.5;\n\n        let mix = (osc1 + osc2 + osc3 + pulse_osc) * 0.25;\n\n        // Powerful filter sweep\n        let cutoff = 600.0 + filt_env * 3000.0;\n        rlpf_ar(mix, cutoff, 0.2) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "analog",
    "path": "pads/analog/pad_oberheim.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Analog"
  },
  {
    "name": "pad_prophet",
    "description": "Prophet-5 strings pad",
    "genre": "Synthpop, New Wave",
    "character": "Prophet-5 strings pad",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Synthpop, New Wave | Character: Prophet-5 strings pad\ndefine_synthdef(\"pad_prophet\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.15, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .asr(0.3, 1.0, 0.3)\n            .gate(gate)\n            .build();\n\n        // Detuned saws\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n        let osc4 = saw_ar(freq * 1.006);\n\n        let mix = (osc1 + osc2 + osc3 + osc4) * 0.22;\n\n        // Warm filter\n        let cutoff = 800.0 + filt_env * 2000.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "analog",
    "path": "pads/analog/pad_prophet.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Analog"
  },
  {
    "name": "pad_epic",
    "description": "Epic orchestral pad - massive and powerful",
    "genre": "Epic, Trailer",
    "character": "Epic orchestral pad - massive and powerful",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Epic, Trailer | Character: Epic orchestral pad - massive and powerful\ndefine_synthdef(\"pad_epic\")\n    .param(\"freq\", 110.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.4, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope for power\n        let filt_env = envelope()\n            .asr(0.5, 1.0, 0.4)\n            .gate(gate)\n            .build();\n\n        // Multiple octaves for size\n        let low = saw_ar(freq) * 0.3;\n        let mid1 = saw_ar(freq * 2.0 * 0.998) * 0.2;\n        let mid2 = saw_ar(freq * 2.0) * 0.2;\n        let mid3 = saw_ar(freq * 2.0 * 1.002) * 0.2;\n        let high = saw_ar(freq * 4.0) * 0.1;\n\n        let mix = low + mid1 + mid2 + mid3 + high;\n\n        // Powerful filter sweep\n        let cutoff = 400.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.15) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "cinematic",
    "path": "pads/cinematic/pad_epic.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Cinematic"
  },
  {
    "name": "pad_horror",
    "description": "Horror pad - dark and unsettling",
    "genre": "Horror, Dark Ambient",
    "character": "Horror pad - dark and unsettling",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Horror, Dark Ambient | Character: Horror pad - dark and unsettling\ndefine_synthdef(\"pad_horror\")\n    .param(\"freq\", 80.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.6, 1.0, 0.5)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow detuning for unease\n        let detune = sin_osc_ar(0.1) * freq * 0.03;\n\n        // Dark oscillators\n        let osc1 = saw_ar(freq + detune) * 0.3;\n        let osc2 = saw_ar(freq * 1.5 - detune) * 0.2;\n        let sub = sin_osc_ar(freq * 0.5) * 0.25;\n\n        // Noise texture\n        let noise = lpf_ar(pink_noise_ar(), 400.0) * 0.1;\n\n        let mix = osc1 + osc2 + sub + noise;\n\n        // Dark filtering\n        lpf_ar(mix, 600.0) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "cinematic",
    "path": "pads/cinematic/pad_horror.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Cinematic"
  },
  {
    "name": "pad_mysterious",
    "description": "Mysterious pad - enigmatic and suspenseful",
    "genre": "Mystery, Thriller",
    "character": "Mysterious pad - enigmatic and suspenseful",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Mystery, Thriller | Character: Mysterious pad - enigmatic and suspenseful\ndefine_synthdef(\"pad_mysterious\")\n    .param(\"freq\", 165.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.45, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow, mysterious modulation\n        let mod1 = sin_osc_ar(0.2) * freq * 0.015;\n        let mod2 = sin_osc_ar(0.13) * freq * 0.01;\n\n        // Layered tones\n        let tone1 = sin_osc_ar(freq + mod1) * 0.4;\n        let tone2 = sin_osc_ar(freq * 1.5 + mod2) * 0.2;\n        let tone3 = lf_tri_ar(freq * 2.0) * 0.15;\n\n        // Subtle texture\n        let texture = bpf_ar(pink_noise_ar(), freq * 4.0, 0.5) * 0.08;\n\n        let mix = tone1 + tone2 + tone3 + texture;\n\n        lpf_ar(mix, 2500.0) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "cinematic",
    "path": "pads/cinematic/pad_mysterious.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Cinematic"
  },
  {
    "name": "pad_scifi",
    "description": "Sci-fi pad - futuristic and alien",
    "genre": "Sci-Fi, Electronic",
    "character": "Sci-fi pad - futuristic and alien",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Sci-Fi, Electronic | Character: Sci-fi pad - futuristic and alien\ndefine_synthdef(\"pad_scifi\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.3, 1.0, 0.35)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // FM modulation for sci-fi texture\n        let mod_lfo = sin_osc_ar(0.3) * 3.0 + 5.0;\n        let modulator = sin_osc_ar(freq * 2.0) * mod_lfo * freq;\n        let carrier = sin_osc_ar(freq + modulator) * 0.4;\n\n        // Metallic ring\n        let ring = sin_osc_ar(freq * 3.14) * 0.15;\n\n        // Sub tone\n        let sub = sin_osc_ar(freq * 0.5) * 0.2;\n\n        let mix = carrier + ring + sub;\n\n        // Sweeping filter\n        let sweep = sin_osc_ar(0.2) * 1500.0 + 2500.0;\n        lpf_ar(mix, sweep) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "cinematic",
    "path": "pads/cinematic/pad_scifi.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Cinematic"
  },
  {
    "name": "pad_tension",
    "description": "Tension-building pad",
    "genre": "Film Score, Horror",
    "character": "Tension-building pad",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Film Score, Horror | Character: Tension-building pad\ndefine_synthdef(\"pad_tension\")\n    .param(\"freq\", 110.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.5, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Dissonant cluster\n        let osc1 = sin_osc_ar(freq) * 0.35;\n        let osc2 = sin_osc_ar(freq * 1.06) * 0.25; // Minor 2nd\n        let osc3 = sin_osc_ar(freq * 1.12) * 0.2;  // Augmented\n\n        // Low rumble\n        let rumble = lpf_ar(pink_noise_ar(), 100.0) * 0.15;\n\n        // Slow rising filter\n        let filt_env = envelope()\n            .asr(1.0, 1.0, 0.5)\n            .gate(gate)\n            .build();\n\n        let mix = osc1 + osc2 + osc3 + rumble;\n        let cutoff = 200.0 + filt_env * 1500.0;\n\n        lpf_ar(mix, cutoff) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "cinematic",
    "path": "pads/cinematic/pad_tension.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Cinematic"
  },
  {
    "name": "pad_aggressive",
    "description": "Genre: Techno, Industrial | Character: Aggressive, driven pad",
    "genre": "Techno, Industrial",
    "character": "Aggressive, driven pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.35
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_aggressive\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.35)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Sharper attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned saws with more energy\n            let osc1 = saw_ar(freq * 0.993);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.007);\n\n            let mix = (osc1 + osc2 + osc3) * 0.4;\n\n            // Clip for aggression\n            let driven = clip(mix, -0.9, 0.9);\n\n            // Filtering\n            let filtered = lpf_ar(driven, 2800.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "lush",
    "path": "pads/lush/pad_aggressive.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Lush"
  },
  {
    "name": "pad_chorus",
    "description": "Genre: Synthwave, Pop | Character: Chorused pad with movement",
    "genre": "Synthwave, Pop",
    "character": "Chorused pad with movement",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_chorus\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Pad envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.3, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned oscillators simulating chorus\n            let osc1 = saw_ar(freq * 0.992);\n            let osc2 = saw_ar(freq * 0.996);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.004);\n            let osc5 = saw_ar(freq * 1.008);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Filtering\n            let filtered = lpf_ar(mix, 3000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "lush",
    "path": "pads/lush/pad_chorus.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Lush"
  },
  {
    "name": "pad_detuned",
    "description": "Genre: Trance, EDM | Character: Heavily detuned, wide and lush",
    "genre": "Trance, EDM",
    "character": "Heavily detuned, wide and lush",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.35
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_detuned\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.35)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow attack for pad character\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.25, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Many detuned oscillators for width\n            let osc1 = saw_ar(freq * 0.980);\n            let osc2 = saw_ar(freq * 0.990);\n            let osc3 = saw_ar(freq * 0.998);\n            let osc4 = saw_ar(freq);\n            let osc5 = saw_ar(freq * 1.002);\n            let osc6 = saw_ar(freq * 1.010);\n            let osc7 = saw_ar(freq * 1.020);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5 + osc6 + osc7) * 0.14;\n\n            // Lush filtering\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "lush",
    "path": "pads/lush/pad_detuned.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Lush"
  },
  {
    "name": "pad_morphing",
    "description": "Genre: Ambient, Experimental | Character: Morphing, evolving lush pad",
    "genre": "Ambient, Experimental",
    "character": "Morphing, evolving lush pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_morphing\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Long evolution\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.6, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned oscillators\n            let osc1 = saw_ar(freq * 0.991);\n            let osc2 = saw_ar(freq * 0.998);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.002);\n            let osc5 = saw_ar(freq * 1.009);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Evolving filter\n            let filter_env = envelope()\n                .asr(1.2, 1.0, 0.1)\n                .gate(gate)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 3000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            // Resonance evolves too\n            let resonant = rlpf_ar(filtered, mod_cutoff * 0.8, 0.5);\n\n            resonant * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "lush",
    "path": "pads/lush/pad_morphing.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Lush"
  },
  {
    "name": "pad_narrow",
    "description": "Genre: Minimal, House | Character: Narrow, focused lush pad",
    "genre": "Minimal, House",
    "character": "Narrow, focused lush pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.45
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_narrow\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Pad envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.3, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Subtle detuning\n            let osc1 = saw_ar(freq * 0.998);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.002);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Filtering\n            let filtered = lpf_ar(mix, 2200.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "lush",
    "path": "pads/lush/pad_narrow.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Lush"
  },
  {
    "name": "pad_organ",
    "description": "Genre: Gospel, Jazz | Character: Organ-like pad with drawbars",
    "genre": "Gospel, Jazz",
    "character": "Organ-like pad with drawbars",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_organ\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Quick attack like organ\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Organ drawbars (harmonic series)\n            let h1 = sin_osc_ar(freq) * 0.5;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.1;\n\n            let mix = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Gentle filtering\n            let filtered = lpf_ar(mix, 3500.0);\n\n            filtered * env * amp * 0.6\n        })\n});",
    "category": "pads",
    "subcategory": "lush",
    "path": "pads/lush/pad_organ.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Lush"
  },
  {
    "name": "pad_soft",
    "description": "Genre: Ambient, Chillout | Character: Soft, gentle lush pad",
    "genre": "Ambient, Chillout",
    "character": "Soft, gentle lush pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.45
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_soft\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Very soft attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.5, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix of sine and detuned saws for softness\n            let sine1 = sin_osc_ar(freq * 0.997);\n            let sine2 = sin_osc_ar(freq);\n            let sine3 = sin_osc_ar(freq * 1.003);\n            let saw = saw_ar(freq) * 0.2;\n\n            let mix = (sine1 + sine2 + sine3) * 0.3 + saw;\n\n            // Soft filtering\n            let filtered = lpf_ar(mix, 2000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "lush",
    "path": "pads/lush/pad_soft.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Lush"
  },
  {
    "name": "pad_string",
    "description": "Genre: Orchestral, Cinematic | Character: String-like pad",
    "genre": "Orchestral, Cinematic",
    "character": "String-like pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_string\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // String-like envelope with bow attack\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.15, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple sawtooths for string character\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.005);\n\n            // Add harmonics\n            let harmonic = saw_ar(freq * 2.0) * 0.15;\n\n            let mix = (osc1 + osc2 + osc3) * 0.33 + harmonic;\n\n            // String-like filtering\n            let filtered = lpf_ar(mix, 2500.0);\n\n            // Remove mud\n            let clean = hpf_ar(filtered, 150.0);\n\n            clean * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "lush",
    "path": "pads/lush/pad_string.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Lush"
  },
  {
    "name": "pad_voice",
    "description": "Genre: Ambient, Choral | Character: Voice-like pad with formants",
    "genre": "Ambient, Choral",
    "character": "Voice-like pad with formants",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_voice\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Choir-like envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.35, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Detuned oscillators\n            let osc1 = saw_ar(freq * 0.994);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.006);\n\n            let mix = (osc1 + osc2 + osc3) * 0.33;\n\n            // Voice-like formant filtering (simplified)\n            let formant1 = rlpf_ar(mix, 800.0, 0.5) * 0.4;\n            let formant2 = rlpf_ar(mix, 1200.0, 0.6) * 0.35;\n            let formant3 = rlpf_ar(mix, 2400.0, 0.7) * 0.25;\n\n            let voiced = formant1 + formant2 + formant3;\n\n            voiced * env * amp * 0.8\n        })\n});",
    "category": "pads",
    "subcategory": "lush",
    "path": "pads/lush/pad_voice.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Lush"
  },
  {
    "name": "pad_wide",
    "description": "Genre: Ambient, Chillout | Character: Very wide stereo pad",
    "genre": "Ambient, Chillout",
    "character": "Very wide stereo pad",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.35
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pad_wide\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.35)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n\n            // Slow envelope\n            // Gate-controlled ASR envelope for proper note-on/note-off behavior\n            let env = envelope()\n                .asr(0.4, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Extreme detuning for width\n            let left1 = saw_ar(freq * 0.975);\n            let left2 = saw_ar(freq * 0.990);\n            let center = saw_ar(freq);\n            let right1 = saw_ar(freq * 1.010);\n            let right2 = saw_ar(freq * 1.025);\n\n            let mix = (left1 + left2 + center + right1 + right2) * 0.2;\n\n            // Filtering\n            let filtered = lpf_ar(mix, 2800.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "pads",
    "subcategory": "lush",
    "path": "pads/lush/pad_wide.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Lush"
  },
  {
    "name": "pad_arp",
    "description": "Arpeggiated pad texture",
    "genre": "Ambient, Electronic",
    "character": "Arpeggiated pad texture",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Ambient, Electronic | Character: Arpeggiated pad texture\ndefine_synthdef(\"pad_arp\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .param(\"rate\", 8.0)\n    .body(|freq, amp, gate, rate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Arp-like amplitude modulation\n        let arp_lfo = sin_osc_ar(rate);\n        let arp_env = arp_lfo * 0.5 + 0.5;\n\n        // Different pitches modulated\n        let osc1 = sin_osc_ar(freq) * arp_env;\n        let osc2 = sin_osc_ar(freq * 1.5) * (1.0 - arp_env) * 0.5;\n        let osc3 = sin_osc_ar(freq * 2.0) * arp_env * 0.3;\n\n        // Pad bed\n        let bed = saw_ar(freq * 0.5) * 0.15;\n\n        let mix = osc1 + osc2 + osc3 + bed;\n\n        lpf_ar(mix, 4000.0) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "movement",
    "path": "pads/movement/pad_arp.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Movement"
  },
  {
    "name": "pad_gate",
    "description": "Gated/sidechain pad effect",
    "genre": "Trance, EDM",
    "character": "Gated/sidechain pad effect",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Trance, EDM | Character: Gated/sidechain pad effect\ndefine_synthdef(\"pad_gate\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .param(\"rate\", 4.0)\n    .body(|freq, amp, gate, rate| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Gate LFO (sharp on/off)\n        let gate_lfo = pulse_ar(rate, 0.5) * 0.8 + 0.2;\n\n        // Pad oscillators\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n\n        let mix = (osc1 + osc2 + osc3) * 0.3;\n\n        lpf_ar(mix, 3000.0) * gate_lfo * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "movement",
    "path": "pads/movement/pad_gate.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Movement"
  },
  {
    "name": "pad_pulsing",
    "description": "Rhythmic pulsing pad",
    "genre": "Electronic, Trance",
    "character": "Rhythmic pulsing pad",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, Trance | Character: Rhythmic pulsing pad\ndefine_synthdef(\"pad_pulsing\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .param(\"rate\", 4.0)\n    .body(|freq, amp, gate, rate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pulse LFO\n        let pulse_lfo = sin_osc_ar(rate) * 0.4 + 0.6;\n\n        // Pad sound\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n\n        let mix = (osc1 + osc2 + osc3) * 0.3;\n\n        // Filter with pulse\n        let cutoff = 800.0 + pulse_lfo * 2000.0;\n        rlpf_ar(mix, cutoff, 0.15) * pulse_lfo * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "movement",
    "path": "pads/movement/pad_pulsing.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Movement"
  },
  {
    "name": "pad_random",
    "description": "Random modulation pad",
    "genre": "Experimental, Ambient",
    "character": "Random modulation pad",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Experimental, Ambient | Character: Random modulation pad\ndefine_synthdef(\"pad_random\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Random modulations\n        let rand1 = lf_noise1_ar(2.0) * freq * 0.01;\n        let rand2 = lf_noise1_ar(3.0) * freq * 0.008;\n        let rand_amp = lf_noise1_ar(1.0) * 0.2 + 0.8;\n\n        // Oscillators with random pitch\n        let osc1 = sin_osc_ar(freq + rand1) * 0.4;\n        let osc2 = sin_osc_ar(freq * 2.0 + rand2) * 0.2;\n        let osc3 = saw_ar(freq + rand1 * 0.5) * 0.25;\n\n        let mix = (osc1 + osc2 + osc3) * rand_amp;\n\n        // Random filter\n        let rand_cutoff = lf_noise1_ar(0.5) * 1500.0 + 2000.0;\n        lpf_ar(mix, rand_cutoff) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "movement",
    "path": "pads/movement/pad_random.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Movement"
  },
  {
    "name": "pad_swelling",
    "description": "Slowly swelling pad",
    "genre": "Cinematic, Ambient",
    "character": "Slowly swelling pad",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Cinematic, Ambient | Character: Slowly swelling pad\ndefine_synthdef(\"pad_swelling\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        // Very slow attack\n        let env = envelope()\n            .asr(2.0, 1.0, 0.5)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter swell envelope\n        let filt_env = envelope()\n            .asr(2.5, 1.0, 0.5)\n            .gate(gate)\n            .build();\n\n        // Rich detuned oscillators\n        let osc1 = saw_ar(freq * 0.996);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.004);\n\n        let mix = (osc1 + osc2 + osc3) * 0.3;\n\n        // Swelling filter\n        let cutoff = 300.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.12) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "movement",
    "path": "pads/movement/pad_swelling.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Movement"
  },
  {
    "name": "pad_breath",
    "description": "Breathy pad - soft and airy",
    "genre": "Ambient, New Age",
    "character": "Breathy pad - soft and airy",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Ambient, New Age | Character: Breathy pad - soft and airy\ndefine_synthdef(\"pad_breath\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.4, 1.0, 0.5)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Soft tone\n        let body = sin_osc_ar(freq) * 0.4;\n        let harm = sin_osc_ar(freq * 2.0) * 0.15;\n\n        // Breath noise component\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.0, 0.5) * 0.25;\n\n        // Air movement\n        let air_lfo = sin_osc_ar(0.2) * 0.3 + 0.7;\n        let air = bpf_ar(pink_noise_ar(), 3000.0, 0.8) * air_lfo * 0.12;\n\n        let sig = body + harm + breath + air;\n\n        lpf_ar(sig, 4000.0) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "textural",
    "path": "pads/textural/pad_breath.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Textural"
  },
  {
    "name": "pad_choir",
    "description": "Choir pad - ethereal voices",
    "genre": "Cinematic, Ambient",
    "character": "Choir pad - ethereal voices",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Cinematic, Ambient | Character: Choir pad - ethereal voices\ndefine_synthdef(\"pad_choir\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.35, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.0) * freq * 0.008;\n\n        // Multiple voices with formants\n        let voice1 = saw_ar(freq + vib) * 0.3;\n        let voice2 = saw_ar(freq * 1.002 + vib * 0.8) * 0.25;\n        let voice3 = saw_ar(freq * 0.998 + vib * 1.2) * 0.25;\n\n        let mix = voice1 + voice2 + voice3;\n\n        // Vowel formants (aaah)\n        let f1 = bpf_ar(mix, 700.0, 0.12) * 0.5;\n        let f2 = bpf_ar(mix, 1200.0, 0.15) * 0.3;\n        let f3 = bpf_ar(mix, 2500.0, 0.2) * 0.15;\n\n        let sig = f1 + f2 + f3;\n\n        sig * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "textural",
    "path": "pads/textural/pad_choir.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Textural"
  },
  {
    "name": "pad_ghostly",
    "description": "Ghostly pad - eerie and unsettling",
    "genre": "Horror, Dark Ambient",
    "character": "Ghostly pad - eerie and unsettling",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Horror, Dark Ambient | Character: Ghostly pad - eerie and unsettling\ndefine_synthdef(\"pad_ghostly\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.5, 1.0, 0.6)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow, eerie modulation\n        let mod1 = sin_osc_ar(0.15) * freq * 0.02;\n        let mod2 = sin_osc_ar(0.23) * freq * 0.015;\n\n        // Detuned, wavering tones\n        let tone1 = sin_osc_ar(freq + mod1) * 0.35;\n        let tone2 = sin_osc_ar(freq * 1.01 + mod2) * 0.25;\n        let tone3 = sin_osc_ar(freq * 0.99 - mod1) * 0.25;\n\n        // Spectral component\n        let spectral = bpf_ar(pink_noise_ar(), freq * 3.0, 0.3) * 0.1;\n\n        let sig = tone1 + tone2 + tone3 + spectral;\n\n        lpf_ar(sig, 2500.0) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "textural",
    "path": "pads/textural/pad_ghostly.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Textural"
  },
  {
    "name": "pad_glass",
    "description": "Glass/crystalline pad - bright and delicate",
    "genre": "Ambient, Cinematic",
    "character": "Glass/crystalline pad - bright and delicate",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Ambient, Cinematic | Character: Glass/crystalline pad - bright and delicate\ndefine_synthdef(\"pad_glass\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.3, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright sine harmonics\n        let h1 = sin_osc_ar(freq) * 0.4;\n        let h2 = sin_osc_ar(freq * 2.0) * 0.25;\n        let h3 = sin_osc_ar(freq * 3.0) * 0.15;\n        let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n        let h5 = sin_osc_ar(freq * 5.0) * 0.06;\n\n        // Slight shimmer\n        let shimmer_lfo = sin_osc_ar(4.0) * 0.02 + 1.0;\n        let shimmer = sin_osc_ar(freq * 6.0 * shimmer_lfo) * 0.04;\n\n        let sig = h1 + h2 + h3 + h4 + h5 + shimmer;\n\n        sig * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "textural",
    "path": "pads/textural/pad_glass.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Textural"
  },
  {
    "name": "pad_metallic",
    "description": "Metallic pad - cold and resonant",
    "genre": "Industrial, Ambient",
    "character": "Metallic pad - cold and resonant",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Industrial, Ambient | Character: Metallic pad - cold and resonant\ndefine_synthdef(\"pad_metallic\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.35)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Inharmonic metallic partials\n        let p1 = sin_osc_ar(freq) * 0.35;\n        let p2 = sin_osc_ar(freq * 1.7) * 0.2;\n        let p3 = sin_osc_ar(freq * 2.4) * 0.15;\n        let p4 = sin_osc_ar(freq * 3.1) * 0.12;\n        let p5 = sin_osc_ar(freq * 4.6) * 0.08;\n\n        // FM metallic texture\n        let mod_freq = sin_osc_ar(freq * 1.5) * freq * 0.5;\n        let fm_metal = sin_osc_ar(freq + mod_freq) * 0.15;\n\n        let sig = p1 + p2 + p3 + p4 + p5 + fm_metal;\n\n        sig * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "textural",
    "path": "pads/textural/pad_metallic.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Textural"
  },
  {
    "name": "pad_underwater",
    "description": "Underwater pad - muffled and deep",
    "genre": "Ambient, Soundscape",
    "character": "Underwater pad - muffled and deep",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Ambient, Soundscape | Character: Underwater pad - muffled and deep\ndefine_synthdef(\"pad_underwater\")\n    .param(\"freq\", 110.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.4, 1.0, 0.5)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Slow movement\n        let wobble = sin_osc_ar(0.3) * freq * 0.01;\n\n        // Deep tones\n        let deep1 = sin_osc_ar(freq + wobble) * 0.5;\n        let deep2 = sin_osc_ar(freq * 2.0 + wobble * 0.5) * 0.2;\n\n        // Bubble-like texture\n        let bubble_rate = 3.0;\n        let bubbles = sin_osc_ar(freq * 4.0) * dust_ar(bubble_rate) * 0.1;\n\n        let sig = deep1 + deep2 + bubbles;\n\n        // Heavy low-pass for underwater muffled effect\n        lpf_ar(sig, 800.0) * env * amp\n    });\n",
    "category": "pads",
    "subcategory": "textural",
    "path": "pads/textural/pad_underwater.vibe",
    "categoryName": "Pads",
    "subcategoryName": "Textural"
  },
  {
    "name": "chip_noise",
    "description": "Chip noise channel for drums/sfx",
    "genre": "Chiptune, 8-bit",
    "character": "Chip noise channel for drums/sfx",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Chiptune, 8-bit | Character: Chip noise channel for drums/sfx\ndefine_synthdef(\"chip_noise\")\n    .param(\"freq\", 8000.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        let amp_env = envelope()\n            .perc(0.001, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Filtered noise (simulating chip noise)\n        let noise = hpf_ar(white_noise_ar(), freq);\n\n        noise * amp_env * amp\n    });\n",
    "category": "retro",
    "subcategory": "",
    "path": "retro/chip_noise.vibe",
    "categoryName": "Retro"
  },
  {
    "name": "chip_pulse",
    "description": "Classic pulse wave with variable duty",
    "genre": "Chiptune, 8-bit",
    "character": "Classic pulse wave with variable duty",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Chiptune, 8-bit | Character: Classic pulse wave with variable duty\ndefine_synthdef(\"chip_pulse\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .param(\"duty\", 0.5)\n    .body(|freq, amp, gate, duty| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pure pulse wave (chip-style)\n        let osc = pulse_ar(freq, duty);\n\n        osc * env * amp\n    });\n",
    "category": "retro",
    "subcategory": "",
    "path": "retro/chip_pulse.vibe",
    "categoryName": "Retro"
  },
  {
    "name": "chip_triangle",
    "description": "NES-style triangle wave bass",
    "genre": "Chiptune, 8-bit",
    "character": "NES-style triangle wave bass",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Chiptune, 8-bit | Character: NES-style triangle wave bass\ndefine_synthdef(\"chip_triangle\")\n    .param(\"freq\", 110.0)\n    .param(\"amp\", 0.7)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Pure triangle wave\n        let osc = lf_tri_ar(freq);\n\n        osc * env * amp\n    });\n",
    "category": "retro",
    "subcategory": "",
    "path": "retro/chip_triangle.vibe",
    "categoryName": "Retro"
  },
  {
    "name": "sfx_coin",
    "description": "Coin collect sound effect",
    "genre": "Video Game, Chiptune",
    "character": "Coin collect sound effect",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Video Game, Chiptune | Character: Coin collect sound effect\ndefine_synthdef(\"sfx_coin\")\n    .param(\"freq\", 1200.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        let amp_env = envelope()\n            .perc(0.001, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Two-tone coin sound\n        let tone1 = sin_osc_ar(freq) * 0.5;\n        let tone2_e = envelope()\n            .perc(0.05, 0.1)\n            .build();\n        let tone2 = sin_osc_ar(freq * 1.5) * tone2_e * 0.5;\n\n        (tone1 + tone2) * amp_env * amp\n    });\n",
    "category": "retro",
    "subcategory": "",
    "path": "retro/sfx_coin.vibe",
    "categoryName": "Retro"
  },
  {
    "name": "sfx_jump",
    "description": "Jump sound effect",
    "genre": "Video Game, Chiptune",
    "character": "Jump sound effect",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Video Game, Chiptune | Character: Jump sound effect\ndefine_synthdef(\"sfx_jump\")\n    .param(\"freq\", 150.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        let amp_env = envelope()\n            .perc(0.001, 0.15)\n            .cleanup_on_finish()\n            .build();\n\n        // Quick pitch up then down\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let sweep_freq = freq + pitch_env * freq * 3.0;\n\n        // Triangle wave\n        let osc = lf_tri_ar(sweep_freq);\n\n        osc * amp_env * amp\n    });\n",
    "category": "retro",
    "subcategory": "",
    "path": "retro/sfx_jump.vibe",
    "categoryName": "Retro"
  },
  {
    "name": "sfx_laser",
    "description": "Laser/shoot sound effect",
    "genre": "Video Game, Chiptune",
    "character": "Laser/shoot sound effect",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Video Game, Chiptune | Character: Laser/shoot sound effect\ndefine_synthdef(\"sfx_laser\")\n    .param(\"freq\", 800.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        let amp_env = envelope()\n            .perc(0.001, 0.1)\n            .cleanup_on_finish()\n            .build();\n\n        // Descending pitch\n        let pitch_env = envelope()\n            .perc(0.001, 0.08)\n            .build();\n        let sweep_freq = freq * (1.0 + pitch_env * 2.0);\n\n        // Square wave\n        let osc = pulse_ar(sweep_freq, 0.5);\n\n        // Add noise burst\n        let noise_e = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let noise = hpf_ar(white_noise_ar(), 5000.0) * noise_e * 0.3;\n\n        (osc + noise) * amp_env * amp\n    });\n",
    "category": "retro",
    "subcategory": "",
    "path": "retro/sfx_laser.vibe",
    "categoryName": "Retro"
  },
  {
    "name": "sfx_powerup",
    "description": "Power-up ascending sound",
    "genre": "Video Game, Chiptune",
    "character": "Power-up ascending sound",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Video Game, Chiptune | Character: Power-up ascending sound\ndefine_synthdef(\"sfx_powerup\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        let amp_env = envelope()\n            .perc(0.001, 0.4)\n            .cleanup_on_finish()\n            .build();\n\n        // Ascending pitch\n        let pitch_env = envelope()\n            .perc(0.001, 0.35)\n            .build();\n        let sweep_freq = freq + pitch_env * freq * 4.0;\n\n        // Pulse wave for chip sound\n        let osc = pulse_ar(sweep_freq, 0.5);\n\n        osc * amp_env * amp\n    });\n",
    "category": "retro",
    "subcategory": "",
    "path": "retro/sfx_powerup.vibe",
    "categoryName": "Retro"
  },
  {
    "name": "synth_80s_brass",
    "description": "Classic 80s brass stab",
    "genre": "Synthwave, 80s",
    "character": "Classic 80s brass stab",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Synthwave, 80s | Character: Classic 80s brass stab\ndefine_synthdef(\"synth_80s_brass\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.02, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Filter envelope\n        let filt_env = envelope()\n            .perc(0.02, 0.3)\n            .build();\n\n        // Detuned saws\n        let osc1 = saw_ar(freq * 0.998);\n        let osc2 = saw_ar(freq);\n        let osc3 = saw_ar(freq * 1.002);\n\n        let mix = (osc1 + osc2 + osc3) * 0.35;\n\n        // Bright filter sweep\n        let cutoff = 1000.0 + filt_env * 4000.0;\n        rlpf_ar(mix, cutoff, 0.2) * env * amp\n    });\n",
    "category": "retro",
    "subcategory": "",
    "path": "retro/synth_80s_brass.vibe",
    "categoryName": "Retro"
  },
  {
    "name": "acoustic_guitar",
    "description": "steel string dreadnought style",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "position",
        "default": 0.5
      },
      {
        "name": "pluck_hard",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acoustic_guitar\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"position\", 0.5)     // 0=bridge (bright), 1=neck (mellow)\n        .param(\"pluck_hard\", 0.6)   // Pluck hardness\n        .body(|freq, amp, gate, position, pluck_hard| {\n            // String decay time - lower notes ring longer\n            let decay_time = 1.5 + (1.0 / (freq / 80.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Pluck excitation - filtered noise burst\n            let excite_env = envelope()\n                .perc(0.0003, 1.0)\n                .time_scale(0.003 + ((1.0 - pluck_hard) * 0.004))\n                .build();\n            let excite_noise = white_noise_ar() * excite_env;\n\n            // Filter excitation based on pluck position\n            // Near bridge = brighter (higher cutoff)\n            let excite_cutoff = 2000.0 + ((1.0 - position) * 6000.0 * pluck_hard);\n            let excite = lpf_ar(excite_noise, excite_cutoff) * 0.8;\n\n            // String harmonics - guitar has rich harmonic content\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.25;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.18;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.12;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.08;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Pluck position affects harmonic emphasis\n            // Node at position suppresses harmonics that have nodes there\n            let pos_filter = 1500.0 + (position * 3000.0);\n            let string_filtered = rlpf_ar(string_tone, pos_filter, 0.5);\n\n            // Body resonance - acoustic guitar body frequencies\n            // Main air resonance around 100Hz (sound hole)\n            let body1 = rlpf_ar(string_filtered + excite, 98.0, 0.3) * 0.35;\n            // Top plate resonance\n            let body2 = rlpf_ar(string_filtered + excite, 200.0, 0.4) * 0.25;\n            // Back plate\n            let body3 = rlpf_ar(string_filtered + excite, 380.0, 0.35) * 0.2;\n            // Higher body modes\n            let body4 = rlpf_ar(string_filtered, 580.0, 0.4) * 0.15;\n\n            // High frequency damping over time\n            let hf_env = envelope()\n                .perc(0.001, 0.4)\n                .time_scale(decay_time)\n                .build();\n            let hf_cutoff = 1500.0 + (hf_env * 5000.0);\n\n            let tone = string_filtered + body1 + body2 + body3 + body4;\n            let damped = lpf_ar(tone, hf_cutoff);\n\n            let output = (damped + excite * 0.3) * env * amp * 0.45;\n            output.softclip()\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/acoustic_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "classical_guitar",
    "description": "Nylon String Classical Guitar",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "position",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"classical_guitar\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"position\", 0.6)\n        .body(|freq, amp, gate, position| {\n            let decay_time = 2.0 + (1.0 / (freq / 60.0));\n            let env = envelope()\n                .perc(0.002, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Softer pluck for nylon strings\n            let excite_env = envelope()\n                .perc(0.001, 0.008)\n                .build();\n            let excite = lpf_ar(white_noise_ar() * excite_env, 2500.0) * 0.5;\n\n            // Nylon has fewer high harmonics, rounder tone\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.12;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.06;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Classical guitar body - different resonances\n            let body1 = rlpf_ar(string_tone + excite, 95.0, 0.35) * 0.4;\n            let body2 = rlpf_ar(string_tone + excite, 185.0, 0.4) * 0.3;\n            let body3 = rlpf_ar(string_tone, 350.0, 0.35) * 0.2;\n\n            // Warmer overall - lower cutoff\n            let cutoff = 2500.0 + (position * 1500.0);\n            let filtered = lpf_ar(string_tone + body1 + body2 + body3, cutoff);\n\n            let output = (filtered + excite * 0.2) * env * amp * 0.5;\n            output\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/acoustic_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "fingerpick_guitar",
    "description": "optimized for fingerstyle",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.55
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "nail",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"fingerpick_guitar\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .param(\"nail\", 0.4)  // Amount of fingernail vs flesh\n        .body(|freq, amp, gate, nail| {\n            let decay_time = 1.8 + (1.0 / (freq / 90.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Finger pluck - softer than pick\n            let excite_env = envelope()\n                .perc(0.0005, 0.006)\n                .build();\n            let excite_cutoff = 1800.0 + (nail * 4000.0);\n            let excite = lpf_ar(white_noise_ar() * excite_env, excite_cutoff) * 0.6;\n\n            // Warm string tone\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.4;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.28;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.18;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.1;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.05;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Body resonance\n            let body1 = rlpf_ar(string_tone + excite, 100.0, 0.35) * 0.35;\n            let body2 = rlpf_ar(string_tone + excite, 210.0, 0.4) * 0.25;\n            let body3 = rlpf_ar(string_tone, 400.0, 0.35) * 0.18;\n\n            let tone = string_tone + body1 + body2 + body3;\n\n            // Overall warmth\n            let filtered = lpf_ar(tone, 4000.0 + (nail * 2000.0));\n\n            let output = (filtered + excite * 0.25) * env * amp * 0.5;\n            output.softclip()\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/acoustic_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "twelve_string_guitar",
    "description": "double strings create chorus effect",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.55
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "detune",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"twelve_string_guitar\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .param(\"detune\", 0.5)\n        .body(|freq, amp, gate, detune| {\n            let decay_time = 1.6 + (1.0 / (freq / 100.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Pluck excitation\n            let excite_env = envelope()\n                .perc(0.0003, 0.004)\n                .build();\n            let excite = lpf_ar(white_noise_ar() * excite_env, 5000.0) * 0.6;\n\n            // Main string\n            let detune_amt = 0.002 + (detune * 0.004);\n            let h1a = sin_osc_ar(freq) * 0.5;\n            let h1b = sin_osc_ar(freq * (1.0 + detune_amt)) * 0.5;  // Paired string\n\n            // Lower strings have octave pair\n            let octave_mix = 0.4;\n            let h1c = sin_osc_ar(freq * 2.0) * octave_mix * 0.4;  // Octave string\n            let h1d = sin_osc_ar(freq * 2.0 * (1.0 - detune_amt * 0.5)) * octave_mix * 0.4;\n\n            let h2a = sin_osc_ar(freq * 2.0) * 0.35;\n            let h2b = sin_osc_ar(freq * 2.0 * (1.0 + detune_amt)) * 0.35;\n\n            let h3a = sin_osc_ar(freq * 3.0) * 0.25;\n            let h3b = sin_osc_ar(freq * 3.0 * (1.0 + detune_amt)) * 0.25;\n\n            let h4a = sin_osc_ar(freq * 4.0) * 0.15;\n            let h4b = sin_osc_ar(freq * 4.0 * (1.0 + detune_amt)) * 0.15;\n\n            let string_tone = h1a + h1b + h1c + h1d + h2a + h2b + h3a + h3b + h4a + h4b;\n\n            // Body\n            let body1 = rlpf_ar(string_tone + excite, 100.0, 0.35) * 0.3;\n            let body2 = rlpf_ar(string_tone + excite, 220.0, 0.4) * 0.22;\n\n            let tone = string_tone + body1 + body2;\n            let filtered = lpf_ar(tone, 6000.0);\n\n            let output = (filtered + excite * 0.2) * env * amp * 0.35;\n            output.softclip()\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/acoustic_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "guitar_harmonic",
    "description": "natural harmonic sound",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"guitar_harmonic\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let decay_time = 3.0;\n            let env = envelope()\n                .perc(0.001, decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Harmonics are pure - very few other partials\n            let main = sin_osc_ar(freq) * 1.0;\n            let slight_2nd = sin_osc_ar(freq * 2.0) * 0.08;\n\n            // Bell-like attack\n            let attack_env = envelope()\n                .perc(0.0002, 0.002)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.1;\n\n            let tone = main + slight_2nd;\n\n            // Very clean, high passed\n            let clean = hpf_ar(tone, 200.0);\n\n            let output = (clean + attack) * env * amp * 0.6;\n            output\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/acoustic_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "guitar_muted",
    "description": "Muted/Palm Muted Guitar",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "mute_amount",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"guitar_muted\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"mute_amount\", 0.7)\n        .body(|freq, amp, gate, mute_amount| {\n            // Very short decay when muted\n            let decay_time = 0.15 + ((1.0 - mute_amount) * 0.6);\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Punchy attack\n            let attack_env = envelope()\n                .perc(0.0003, 0.008)\n                .build();\n            let attack = lpf_ar(white_noise_ar() * attack_env, 3000.0) * 0.5;\n\n            // Muted string - suppressed high harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5 * (1.0 - mute_amount * 0.5);\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3 * (1.0 - mute_amount * 0.7);\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15 * (1.0 - mute_amount * 0.9);\n\n            let string_tone = h1 + h2 + h3 + h4;\n\n            // Heavy low-pass for muted character\n            let cutoff = 800.0 + ((1.0 - mute_amount) * 2000.0);\n            let filtered = lpf_ar(string_tone, cutoff);\n\n            let output = (filtered + attack) * env * amp * 0.6;\n            output.softclip()\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/acoustic_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "upright_bass",
    "description": "Acoustic pizzicato (plucked)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 82.41
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "position",
        "default": 0.5
      },
      {
        "name": "finger_noise",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"upright_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)    // E2\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"position\", 0.5)     // Playing position (0=bridge, 1=fingerboard)\n        .param(\"finger_noise\", 0.4)\n        .body(|freq, amp, gate, position, finger_noise| {\n            // Pizzicato envelope\n            let decay_time = 1.2 + (1.0 / (freq / 40.0));\n            let env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Finger pluck transient\n            let pluck_env = envelope()\n                .perc(0.0005, 0.008)\n                .build();\n            let pluck = white_noise_ar() * pluck_env * 0.3;\n            let pluck_filtered = lpf_ar(pluck, 1500.0 + ((1.0 - position) * 2000.0));\n\n            // String harmonics - thick gut/steel string\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.22;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.14;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.08;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Position affects brightness\n            let pos_cutoff = 800.0 + ((1.0 - position) * 1500.0);\n            let positioned = lpf_ar(string_tone, pos_cutoff);\n\n            // Large body resonance\n            let body1 = rlpf_ar(positioned + pluck_filtered, 60.0, 0.35) * 0.5;   // Bass resonance\n            let body2 = rlpf_ar(positioned, 200.0, 0.4) * 0.35;  // Body mode\n            let body3 = rlpf_ar(positioned, 450.0, 0.4) * 0.25;  // Top plate\n\n            // Finger noise on release\n            let noise = white_noise_ar() * finger_noise * 0.04;\n            let noise_filtered = bpf_ar(noise, 1200.0, 0.5);\n\n            let tone = positioned + body1 + body2 + body3 + pluck_filtered + noise_filtered;\n\n            hpf_ar(tone, 35.0) * env * amp * 0.5\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/bass_instruments.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "upright_bass_bowed",
    "description": "Arco (bowed)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 82.41
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "bow_pressure",
        "default": 0.6
      },
      {
        "name": "bow_position",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"upright_bass_bowed\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"bow_pressure\", 0.6)\n        .param(\"bow_position\", 0.5)\n        .body(|freq, amp, gate, bow_pressure, bow_position| {\n            let env = envelope()\n                .asr(0.12, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slow vibrato\n            let vib_delay = envelope()\n                .perc(0.4, 4.0)\n                .build();\n            let vib = sin_osc_ar(5.0) * 0.004 * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Bowed string - sawtooth-like with bow noise\n            let h1 = saw_ar(mod_freq) * 0.4;\n            let h2 = saw_ar(mod_freq * 1.001) * 0.3;  // Slight chorus\n\n            let string_tone = h1 + h2;\n\n            // Bow noise - rosin scratching\n            let bow_noise = white_noise_ar() * bow_pressure * 0.06;\n            let bow_filtered = bpf_ar(bow_noise, mod_freq * 3.0, 0.4);\n\n            // Position affects tone\n            let pos_cutoff = 600.0 + ((1.0 - bow_position) * 1200.0);\n            let positioned = lpf_ar(string_tone, pos_cutoff);\n\n            // Body resonance\n            let body1 = rlpf_ar(positioned, 65.0, 0.35) * 0.45;\n            let body2 = rlpf_ar(positioned, 220.0, 0.4) * 0.35;\n            let body3 = rlpf_ar(positioned, 500.0, 0.4) * 0.2;\n\n            let tone = positioned + body1 + body2 + body3 + bow_filtered;\n\n            hpf_ar(tone, 35.0) * env * amp * 0.55\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/bass_instruments.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "electric_bass",
    "description": "Precision Bass style (split coil)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 82.41
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "tone",
        "default": 0.6
      },
      {
        "name": "attack_style",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"electric_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"tone\", 0.6)          // Tone knob\n        .param(\"attack_style\", 0.5)  // 0=finger, 1=pick\n        .body(|freq, amp, gate, tone, attack_style| {\n            let decay_time = 2.0 + (1.0 / (freq / 50.0));\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sustain envelope\n            let sus_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .build();\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.0003, 1.0)\n                .time_scale(0.004 + ((1.0 - attack_style) * 0.006))\n                .build();\n            let attack_cutoff = 2000.0 + (attack_style * 3000.0);\n            let attack = lpf_ar(white_noise_ar() * attack_env, attack_cutoff) * 0.25;\n\n            // String harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.4;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.08;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // P-Bass pickup - warm, punchy\n            let pickup = rlpf_ar(string_tone, 1000.0, 0.4);\n\n            // Tone control\n            let tone_cutoff = 500.0 + (tone * 3000.0);\n            let toned = lpf_ar(pickup, tone_cutoff);\n\n            // Amp simulation - slight warmth\n            let amped = (toned * 1.1).softclip();\n\n            let output = (amped + attack) * env * sus_env * amp * 0.5;\n            hpf_ar(output, 30.0)\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/bass_instruments.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "jazz_bass",
    "description": "Jazz Bass style (dual single coil)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 82.41
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "neck_pickup",
        "default": 0.7
      },
      {
        "name": "bridge_pickup",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"jazz_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"neck_pickup\", 0.7)\n        .param(\"bridge_pickup\", 0.5)\n        .body(|freq, amp, gate, neck_pickup, bridge_pickup| {\n            let decay_time = 2.5 + (1.0 / (freq / 50.0));\n            let env = envelope()\n                .asr(0.002, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let sus_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .build();\n\n            // Finger attack\n            let attack_env = envelope()\n                .perc(0.0005, 0.008)\n                .build();\n            let attack = lpf_ar(white_noise_ar() * attack_env, 2500.0) * 0.2;\n\n            // String tone\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.38;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.24;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.09;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.05;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Neck pickup - warm\n            let neck = rlpf_ar(string_tone, 800.0, 0.4) * neck_pickup;\n\n            // Bridge pickup - bright, growly\n            let bridge = rlpf_ar(string_tone, 2000.0, 0.35) * bridge_pickup;\n\n            // Mix pickups - J-Bass has characteristic mid scoop when both on\n            let mix = neck * 0.6 + bridge * 0.4;\n\n            // J-Bass has more mid growl\n            let growl = rlpf_ar(string_tone, 700.0, 0.3) * 0.2;\n\n            let output = (mix + growl + attack) * env * sus_env * amp * 0.5;\n            hpf_ar(output, 30.0)\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/bass_instruments.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "fretless_bass",
    "description": "Fretless Electric Bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 82.41
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "mwah",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"fretless_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"mwah\", 0.6)     // Characteristic fretless \"mwah\"\n        .body(|freq, amp, gate, mwah| {\n            let decay_time = 2.0 + (1.0 / (freq / 50.0));\n            let env = envelope()\n                .asr(0.005, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let sus_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .build();\n\n            // Soft finger attack\n            let attack_env = envelope()\n                .perc(0.001, 0.012)\n                .build();\n            let attack = lpf_ar(white_noise_ar() * attack_env, 1500.0) * 0.15;\n\n            // String harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.22;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.14;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5;\n\n            // \"Mwah\" effect - resonant harmonic at string/finger contact\n            // This is the singing quality of fretless\n            let mwah_freq = freq * 3.0;  // Third harmonic\n            let mwah_env = envelope()\n                .perc(0.01, 0.3)\n                .build();\n            let mwah_tone = rlpf_ar(string_tone, mwah_freq, 0.1) * mwah * mwah_env * 0.4;\n\n            // Smooth, singing tone\n            let smooth = lpf_ar(string_tone, 2500.0);\n\n            let output = (smooth + mwah_tone + attack) * env * sus_env * amp * 0.5;\n            hpf_ar(output, 30.0)\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/bass_instruments.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "slap_bass",
    "description": "Slap Bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 82.41
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "slap_pop",
        "default": "0.0"
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"slap_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"slap_pop\", 0.0)  // 0=slap (thumb), 1=pop (finger)\n        .body(|freq, amp, gate, slap_pop| {\n            let decay_time = 0.8;\n            let env = envelope()\n                .perc(0.001, decay_time)\n                .cleanup_on_finish()\n                .build();\n\n            // Slap attack - thumb hitting string against fretboard\n            let slap_env = envelope()\n                .perc(0.0001, 0.003)\n                .build();\n            let slap_noise = white_noise_ar() * slap_env * (1.0 - slap_pop) * 0.4;\n            let slap_filtered = bpf_ar(slap_noise, 1500.0, 0.3);\n\n            // Pop attack - string snapping against fretboard\n            let pop_env = envelope()\n                .perc(0.0001, 0.002)\n                .build();\n            let pop_noise = white_noise_ar() * pop_env * slap_pop * 0.5;\n            let pop_filtered = hpf_ar(pop_noise, 3000.0);\n\n            // Bright, aggressive harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.3;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.22;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.15;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.1;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Bright pickup for slap\n            let bright = rlpf_ar(string_tone, 3000.0, 0.3);\n\n            // Compression effect\n            let compressed = (bright * 1.5).softclip();\n\n            let output = (compressed + slap_filtered + pop_filtered) * env * amp * 0.45;\n            hpf_ar(output, 35.0)\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/bass_instruments.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "synth_bass_moog",
    "description": "Moog-style",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "cutoff",
        "default": 800
      },
      {
        "name": "resonance",
        "default": 0.5
      },
      {
        "name": "filter_env",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"synth_bass_moog\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 800.0)\n        .param(\"resonance\", 0.5)\n        .param(\"filter_env\", 0.6)\n        .body(|freq, amp, gate, cutoff, resonance, filter_env| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Classic Moog oscillators - saw + square sub\n            let saw1 = saw_ar(freq) * 0.5;\n            let saw2 = saw_ar(freq * 1.005) * 0.4;  // Slight detune\n            let sub = pulse_ar(freq * 0.5, 0.5) * 0.4;  // Sub oscillator\n\n            let osc_mix = saw1 + saw2 + sub;\n\n            // Moog ladder filter\n            let mod_cutoff = cutoff + (filt_env * filter_env * cutoff * 4.0);\n            let res_val = resonance * 3.5;  // Moog resonance goes to self-oscillation\n            let filtered = moog_ff_ar(osc_mix, mod_cutoff, res_val, 0.0);\n\n            // Slight saturation\n            let warm = (filtered * 1.2).tanh();\n\n            warm * env * amp * 0.5\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/bass_instruments.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "acid_bass",
    "description": "303 Acid style",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "cutoff",
        "default": 400
      },
      {
        "name": "resonance",
        "default": 0.7
      },
      {
        "name": "env_mod",
        "default": 0.8
      },
      {
        "name": "accent",
        "default": "0.0"
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"acid_bass\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 400.0)\n        .param(\"resonance\", 0.7)\n        .param(\"env_mod\", 0.8)\n        .param(\"accent\", 0.0)\n        .body(|freq, amp, gate, cutoff, resonance, env_mod, accent| {\n            let env = envelope()\n                .perc(0.001, 0.2)\n                .cleanup_on_finish()\n                .build();\n\n            // 303 filter envelope - very snappy\n            let filt_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            // 303 oscillator - saw or square\n            let osc = saw_ar(freq);\n\n            // Classic 303 filter - resonant sweep\n            let accent_boost = 1.0 + (accent * 2.0);\n            let mod_cutoff = cutoff + (filt_env * env_mod * cutoff * 6.0 * accent_boost);\n            let res = 0.1 / (resonance * 0.9 + 0.1);  // Convert to rq\n\n            let filtered = rlpf_ar(osc, mod_cutoff, res);\n\n            // 303 distortion\n            let dist = (filtered * (1.5 + accent)).tanh();\n\n            dist * env * amp * 0.5\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/bass_instruments.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "picked_bass",
    "description": "Rock/Metal style",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 82.41
      },
      {
        "name": "amp",
        "default": 0.65
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "pick_attack",
        "default": 0.8
      },
      {
        "name": "drive",
        "default": 0.3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"picked_bass\", |builder| {\n    builder\n        .param(\"freq\", 82.41)\n        .param(\"amp\", 0.65)\n        .param(\"gate\", 1.0)\n        .param(\"pick_attack\", 0.8)\n        .param(\"drive\", 0.3)\n        .body(|freq, amp, gate, pick_attack, drive| {\n            let decay_time = 1.5;\n            let env = envelope()\n                .asr(0.001, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let sus_env = envelope()\n                .perc(0.001, decay_time)\n                .build();\n\n            // Hard pick attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.002)\n                .build();\n            let attack = hpf_ar(white_noise_ar() * attack_env, 2500.0) * pick_attack * 0.35;\n\n            // Aggressive harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.25;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.18;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.12;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Bridge pickup - aggressive\n            let pickup = rlpf_ar(string_tone, 1500.0, 0.35);\n\n            // Amp drive\n            let driven = (pickup * (1.0 + drive * 2.0)).tanh();\n\n            // Bright EQ\n            let bright = hpf_ar(driven, 60.0);\n\n            let output = (bright + attack) * env * sus_env * amp * 0.5;\n            output.softclip()\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/bass_instruments.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "electric_guitar_clean",
    "description": "Fender-style single coil",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "pickup_pos",
        "default": 0.5
      },
      {
        "name": "tone",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"electric_guitar_clean\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"pickup_pos\", 0.5)    // 0=bridge, 1=neck\n        .param(\"tone\", 0.6)          // Tone knob\n        .body(|freq, amp, gate, pickup_pos, tone| {\n            let decay_time = 2.5 + (1.0 / (freq / 80.0));\n            let env = envelope()\n                .asr(0.001, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Pick attack\n            let attack_env = envelope()\n                .perc(0.0002, 0.004)\n                .build();\n            let attack = lpf_ar(white_noise_ar() * attack_env, 4000.0) * 0.3;\n\n            // Electric guitar string - sawtooth-like with harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.28;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.2;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.15;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.1;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Single coil pickup characteristics\n            // Bridge pickup = brighter, more bite\n            // Neck pickup = warmer, fuller\n            let pickup_cutoff = 2500.0 + ((1.0 - pickup_pos) * 4000.0);\n            let pickup_resonance = 0.3 + (pickup_pos * 0.2);\n\n            // Pickup frequency response - single coils have characteristic resonant peak\n            let pickup_peak = 3000.0 + ((1.0 - pickup_pos) * 2000.0);\n            let pickup = rlpf_ar(string_tone, pickup_peak, pickup_resonance);\n\n            // Tone control (passive LP filter)\n            let tone_cutoff = 1000.0 + (tone * 6000.0);\n            let toned = lpf_ar(pickup, tone_cutoff);\n\n            // Clean amp - slight warmth\n            let amped = toned * 1.2;\n            let warm = lpf_ar(amped, 8000.0);\n\n            // Sustain envelope for body decay\n            let sus_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .build();\n\n            let output = (warm + attack) * env * sus_env * amp * 0.5;\n            output\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/electric_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "electric_guitar_crunch",
    "description": "Edge of breakup",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "gain",
        "default": 0.5
      },
      {
        "name": "tone",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"electric_guitar_crunch\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"gain\", 0.5)\n        .param(\"tone\", 0.6)\n        .body(|freq, amp, gate, gain, tone| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Harder pick attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.003)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.25;\n\n            // Humbucker-style darker tone\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.3;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.22;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.15;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Pre-gain EQ boost\n            let boosted = rlpf_ar(string_tone, 800.0, 0.5) * 0.4 + string_tone;\n\n            // Tube-style soft clipping\n            let drive = 1.0 + (gain * 3.0);\n            let driven = (boosted * drive).tanh();\n\n            // Post-distortion EQ\n            let tone_cutoff = 2000.0 + (tone * 4000.0);\n            let toned = lpf_ar(driven, tone_cutoff);\n\n            // Cabinet simulation - remove harsh highs\n            let cabinet = lpf_ar(toned, 5000.0);\n            let cab_body = rlpf_ar(cabinet, 400.0, 0.6) * 0.2;\n\n            let output = (cabinet + cab_body + attack) * env * amp * 0.5;\n            output.softclip()\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/electric_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "electric_guitar_distorted",
    "description": "Metal/Rock distortion",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "gain",
        "default": 0.8
      },
      {
        "name": "tone",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"electric_guitar_distorted\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"gain\", 0.8)\n        .param(\"tone\", 0.5)\n        .body(|freq, amp, gate, gain, tone| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Aggressive pick attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.002)\n                .build();\n            let attack = hpf_ar(white_noise_ar() * attack_env, 1000.0) * 0.2;\n\n            // Thick humbucker tone\n            let h1 = saw_ar(freq) * 0.5;\n            let h2 = saw_ar(freq * 0.999) * 0.3;  // Slight detune for thickness\n            let h3 = saw_ar(freq * 1.001) * 0.3;\n\n            let raw = h1 + h2 + h3;\n\n            // Tight low-end before distortion\n            let tight = hpf_ar(raw, 80.0);\n\n            // Multi-stage gain (tube amp simulation)\n            let drive1 = 2.0 + (gain * 4.0);\n            let stage1 = (tight * drive1).tanh();\n\n            // Inter-stage EQ\n            let mid_boost = rlpf_ar(stage1, 1000.0, 0.4) * 0.3;\n            let stage1_eq = stage1 + mid_boost;\n\n            // Second gain stage\n            let drive2 = 1.5 + (gain * 2.0);\n            let stage2 = (stage1_eq * drive2).tanh();\n\n            // Post-distortion tone shaping\n            let high_cut = 3000.0 + (tone * 3000.0);\n            let low_cut = 80.0 + ((1.0 - tone) * 60.0);\n\n            let shaped = lpf_ar(hpf_ar(stage2, low_cut), high_cut);\n\n            // Cabinet simulation - 4x12 style\n            let cab1 = rlpf_ar(shaped, 2500.0, 0.5) * 0.6;\n            let cab2 = rlpf_ar(shaped, 500.0, 0.6) * 0.4;\n            let cab3 = lpf_ar(shaped, 4500.0);\n\n            let cabinet = (cab1 + cab2 + cab3) * 0.4;\n\n            // Noise gate effect - clean silence\n            let output = (cabinet + attack) * env * amp * 0.5;\n            output.softclip()\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/electric_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "electric_guitar_jazz",
    "description": "Warm, round tone",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "warmth",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"electric_guitar_jazz\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"warmth\", 0.7)\n        .body(|freq, amp, gate, warmth| {\n            let decay_time = 2.0 + (1.0 / (freq / 100.0));\n            let env = envelope()\n                .asr(0.002, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Soft thumb/finger attack\n            let attack_env = envelope()\n                .perc(0.001, 0.01)\n                .build();\n            let attack = lpf_ar(white_noise_ar() * attack_env, 1500.0) * 0.15;\n\n            // Hollow body guitar tone - fewer high harmonics\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.08;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5;\n\n            // Neck humbucker - very warm\n            let pickup = lpf_ar(string_tone, 2500.0);\n\n            // Rolled off tone knob\n            let tone_cutoff = 1200.0 + ((1.0 - warmth) * 2000.0);\n            let toned = lpf_ar(pickup, tone_cutoff);\n\n            // Hollow body resonance\n            let body_res = rlpf_ar(toned, 180.0, 0.5) * 0.25;\n\n            // Clean amp with slight warmth\n            let amped = (toned + body_res) * 1.1;\n\n            // Sustain\n            let sus_env = envelope()\n                .perc(0.001, 1.0)\n                .time_scale(decay_time)\n                .build();\n\n            let output = (amped + attack) * env * sus_env * amp * 0.5;\n            output\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/electric_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "electric_guitar_funk",
    "description": "Bright, percussive",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"electric_guitar_funk\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Short, percussive envelope\n            let env = envelope()\n                .perc(0.001, 0.3)\n                .cleanup_on_finish()\n                .build();\n\n            // Sharp attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.002)\n                .build();\n            let attack = hpf_ar(white_noise_ar() * attack_env, 2000.0) * 0.3;\n\n            // Bright single coil\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.3;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.22;\n            let h7 = sin_osc_ar(freq * 7.0) * 0.15;\n            let h8 = sin_osc_ar(freq * 8.0) * 0.1;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Bridge pickup - bright and snappy\n            let pickup = rlpf_ar(string_tone, 4000.0, 0.3);\n\n            // Bright tone\n            let bright = hpf_ar(pickup, 200.0);\n\n            // Compression effect (soft clip)\n            let compressed = (bright * 1.5).softclip();\n\n            let output = (compressed + attack) * env * amp * 0.5;\n            output\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/electric_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "power_chord",
    "description": "Thick rhythm guitar",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 82.41
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "gain",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"power_chord\", |builder| {\n    builder\n        .param(\"freq\", 82.41)   // Low E default\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"gain\", 0.7)\n        .body(|freq, amp, gate, gain| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Root note\n            let root1 = saw_ar(freq) * 0.4;\n            let root2 = saw_ar(freq * 1.002) * 0.4;\n\n            // Fifth (7 semitones up = freq * 1.498)\n            let fifth_freq = freq * 1.498;\n            let fifth1 = saw_ar(fifth_freq) * 0.35;\n            let fifth2 = saw_ar(fifth_freq * 0.998) * 0.35;\n\n            // Octave\n            let oct = saw_ar(freq * 2.0) * 0.25;\n\n            let chord = root1 + root2 + fifth1 + fifth2 + oct;\n\n            // Tight low end\n            let tight = hpf_ar(chord, 60.0);\n\n            // Distortion\n            let drive = 2.0 + (gain * 4.0);\n            let dist = (tight * drive).tanh();\n\n            // Tone shaping\n            let shaped = lpf_ar(hpf_ar(dist, 80.0), 4000.0);\n\n            // Cabinet\n            let cab = rlpf_ar(shaped, 2000.0, 0.5);\n\n            let output = cab * env * amp * 0.4;\n            output.softclip()\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/electric_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "electric_guitar_wah",
    "description": "with auto-wah effect",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "wah_rate",
        "default": 2
      },
      {
        "name": "wah_depth",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"electric_guitar_wah\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"wah_rate\", 2.0)\n        .param(\"wah_depth\", 0.7)\n        .body(|freq, amp, gate, wah_rate, wah_depth| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // String tone\n            let h1 = sin_osc_ar(freq) * 1.0;\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.45;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.3;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.2;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.12;\n\n            let string_tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Wah LFO\n            let wah_lfo = sin_osc_ar(wah_rate) * 0.5 + 0.5;  // 0 to 1\n\n            // Wah filter sweep\n            let wah_low = 400.0;\n            let wah_high = 2500.0;\n            let wah_freq = wah_low + (wah_lfo * wah_depth * (wah_high - wah_low));\n\n            let wah = rlpf_ar(string_tone, wah_freq, 0.15);\n\n            // Slight overdrive\n            let driven = (wah * 1.5).softclip();\n\n            let output = driven * env * amp * 0.5;\n            output\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/electric_guitar.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "harp",
    "description": "Concert harp with characteristic resonant pluck.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"harp\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Harp envelope\n            let env = envelope()\n                .asr(0.003, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Long decay\n            let decay_env = envelope()\n                .perc(0.001, 2.0)\n                .build();\n\n            // Harp string harmonics\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.05;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5;\n\n            // Pluck attack\n            let pluck_env = envelope()\n                .perc(0.001, 0.03)\n                .build();\n            let pluck = white_noise_ar() * pluck_env * 0.15;\n\n            // Body resonance\n            let body = rlpf_ar(harmonics, 1800.0, 0.2);\n            let bright = hpf_ar(body, 100.0);\n\n            (bright + pluck) * env * decay_env * amp * 0.7\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/harp.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "pizzicato",
    "description": "Plucked string sound for pizzicato passages.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pizzicato\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Short pluck envelope (gate-controlled for poly)\n            let env = envelope()\n                .asr(0.001, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast decay envelope\n            let decay_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // Plucked string (bright attack, fast decay)\n            let fund = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.08;\n\n            let harmonics = fund + h2 + h3 + h4 + h5;\n\n            // Pluck transient\n            let pluck_env = envelope()\n                .perc(0.0001, 0.02)\n                .build();\n            let pluck = white_noise_ar() * pluck_env * 0.2;\n\n            // Filter sweep for pluck character\n            let filter_freq = 1500.0 + decay_env * 3000.0;\n            let filtered = lpf_ar(harmonics + pluck, filter_freq);\n\n            filtered * env * decay_env * amp\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/pizzicato.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "solo_cello",
    "description": "Deep cello-like sound with expressive vibrato.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "vibrato",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"solo_cello\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"vibrato\", 0.5) // Vibrato amount\n        .body(|freq, amp, gate, vibrato| {\n            // Smooth bowing envelope\n            let env = envelope()\n                .asr(0.15, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slower, deeper vibrato than violin\n            let vib_freq = 4.5;\n            let vib_depth = vibrato * 0.012;\n            let vib = sin_osc_ar(vib_freq) * vib_depth + 1.0;\n            let mod_freq = freq * vib;\n\n            // Rich bowed tone\n            let osc1 = saw_ar(mod_freq);\n            let osc2 = saw_ar(mod_freq * 0.999) * 0.6;\n            let sub = sin_osc_ar(mod_freq * 0.5) * 0.3;\n\n            let string = (osc1 + osc2) * 0.5 + sub;\n\n            // Cello body resonance (lower formants)\n            let body1 = rlpf_ar(string, 400.0, 0.3) * 0.5;\n            let body2 = rlpf_ar(string, 1200.0, 0.3) * 0.3;\n            let body3 = rlpf_ar(string, 2000.0, 0.4) * 0.2;\n\n            let cello = body1 + body2 + body3;\n\n            // Warm low pass\n            let warm = lpf_ar(cello, 3000.0);\n\n            warm * env * amp * 0.8\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/solo_cello.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "solo_violin",
    "description": "Solo violin-like sound with vibrato and bow noise.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "vibrato",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"solo_violin\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"vibrato\", 0.6) // Vibrato amount\n        .body(|freq, amp, gate, vibrato| {\n            // Bowed string envelope\n            let env = envelope()\n                .asr(0.1, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib_freq = 5.5;\n            let vib_depth = vibrato * 0.015;\n            let vib = sin_osc_ar(vib_freq) * vib_depth + 1.0;\n            let mod_freq = freq * vib;\n\n            // Sawtooth-like bowed string\n            let osc1 = saw_ar(mod_freq);\n            let osc2 = saw_ar(mod_freq * 1.002) * 0.5;\n\n            let string = (osc1 + osc2) * 0.6;\n\n            // Bow noise (subtle)\n            let bow_noise = white_noise_ar() * 0.02;\n            let bow_filtered = hpf_ar(lpf_ar(bow_noise, 4000.0), 1000.0);\n\n            // Resonant body filtering\n            let body = rlpf_ar(string, 2500.0, 0.3);\n            let body2 = rlpf_ar(string, 800.0, 0.4) * 0.3;\n\n            let violin = body + body2 + bow_filtered;\n\n            // High pass to remove mud\n            let clean = hpf_ar(violin, 200.0);\n\n            clean * env * amp\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/solo_violin.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "string_ensemble",
    "description": "for a lush, cinematic sound.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"string_ensemble\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            // Slow swell envelope\n            let env = envelope()\n                .asr(0.3, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned voices for ensemble\n            let detune = 0.005;\n            let v1 = saw_ar(freq * (1.0 - detune * 2.0));\n            let v2 = saw_ar(freq * (1.0 - detune));\n            let v3 = saw_ar(freq);\n            let v4 = saw_ar(freq * (1.0 + detune));\n            let v5 = saw_ar(freq * (1.0 + detune * 2.0));\n\n            // Octave layer for depth\n            let oct_down = saw_ar(freq * 0.5) * 0.4;\n\n            let voices = (v1 + v2 + v3 + v4 + v5) * 0.25 + oct_down;\n\n            // String-like filtering\n            let filtered = lpf_ar(voices, 3500.0);\n\n            // Subtle vibrato\n            let vib_rate = 5.0;\n            let vib = sin_osc_ar(vib_rate) * 0.003 + 1.0;\n\n            filtered * env * amp * vib\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/string_ensemble.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "tremolo_strings",
    "description": "Rapidly bowed tremolo strings for dramatic passages.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "speed",
        "default": 8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tremolo_strings\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"speed\", 8.0) // Tremolo speed in Hz\n        .body(|freq, amp, gate, speed| {\n            // String envelope\n            let env = envelope()\n                .asr(0.1, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned voices\n            let v1 = saw_ar(freq * 0.998);\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * 1.002);\n\n            let strings = (v1 + v2 + v3) * 0.4;\n\n            // Tremolo modulation\n            let trem = sin_osc_ar(speed) * 0.4 + 0.6;\n\n            // String body\n            let body = lpf_ar(strings, 3000.0);\n\n            // Slight vibrato\n            let vib = sin_osc_ar(5.0) * 0.002 + 1.0;\n\n            body * trem * env * amp * vib\n        })\n});",
    "category": "strings",
    "subcategory": "",
    "path": "strings/tremolo_strings.vibe",
    "categoryName": "Strings"
  },
  {
    "name": "arp_2600_lead",
    "description": "Classic modular lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "filter_freq",
        "default": 3000
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"arp_2600_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 3000.0)\n        .body(|freq, amp, gate, filter_freq| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Three VCOs\n            let vco1 = saw_ar(freq);\n            let vco2 = saw_ar(freq * 2.0) * 0.5; // Octave up\n            let vco3 = saw_ar(freq * 0.5) * 0.3; // Octave down\n\n            let mix = (vco1 + vco2 + vco3) * 0.4;\n\n            // 4-pole ladder filter\n            let filtered = rlpf_ar(mix, filter_freq, 0.35);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/arp.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "arp_odyssey_bass",
    "description": "Punchy duophonic bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"arp_odyssey_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n\n            // Two oscillators\n            let vco1 = saw_ar(freq);\n            let vco2 = saw_ar(freq * 0.5); // Sub\n\n            let mix = (vco1 * 0.6 + vco2 * 0.4);\n\n            // ARP filter character\n            let cutoff = 400.0 + filt_env * 2000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.4);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/arp.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "arp_strings",
    "description": "Classic string machine",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"arp_strings\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.2, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple oscillators for ensemble\n            let v1 = saw_ar(freq * 0.995);\n            let v2 = saw_ar(freq * 0.998);\n            let v3 = saw_ar(freq * 1.002);\n            let v4 = saw_ar(freq * 1.005);\n\n            let mix = (v1 + v2 + v3 + v4) * 0.28;\n\n            // String machine filtering\n            let filtered = lpf_ar(hpf_ar(mix, 200.0), 4000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/arp.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "arp_solina",
    "description": "The string ensemble sound",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"arp_solina\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.15, 1.0, 0.25)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Divide-down style ensemble\n            let v1 = saw_ar(freq * 0.994);\n            let v2 = saw_ar(freq * 0.997);\n            let v3 = saw_ar(freq);\n            let v4 = saw_ar(freq * 1.003);\n            let v5 = saw_ar(freq * 1.006);\n\n            let mix = (v1 + v2 + v3 + v4 + v5) * 0.22;\n\n            // Phaser-like modulation\n            let mod_osc = sin_osc_ar(0.3) * 0.003 + 1.0;\n\n            // Bandpass for string character\n            let filtered = lpf_ar(hpf_ar(mix, 300.0), 5000.0);\n\n            filtered * env * amp * mod_osc\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/arp.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "cs80_lead",
    "description": "Expressive lead with vibrato",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "vibrato",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"cs80_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"vibrato\", 0.5)\n        .body(|freq, amp, gate, vibrato| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Characteristic vibrato\n            let vib = sin_osc_ar(5.0) * freq * 0.015 * vibrato;\n            let mod_freq = freq + vib;\n\n            // Dual layers - saw and ring mod\n            let osc1 = saw_ar(mod_freq) * 0.4;\n            let osc2 = saw_ar(mod_freq * 1.003) * 0.4;\n            let ring = sin_osc_ar(mod_freq * 2.0) * 0.2;\n\n            let mix = osc1 + osc2 + ring;\n\n            // Warm filtering\n            let filtered = lpf_ar(mix, 3500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/cs80.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "cs80_brass",
    "description": "Famous brass sound (Blade Runner)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.55
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"cs80_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.25)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.1, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // Dual oscillators with detune\n            let osc1 = saw_ar(freq * 0.998);\n            let osc2 = saw_ar(freq * 1.002);\n            let sub = saw_ar(freq * 0.5) * 0.3;\n\n            let mix = (osc1 + osc2) * 0.4 + sub;\n\n            // Resonant filter sweep\n            let cutoff = 800.0 + filt_env * 2500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.7);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/cs80.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "cs80_strings",
    "description": "Lush string pad",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.45
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"cs80_strings\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.3, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Chorus-like detuning\n            let lfo = sin_osc_ar(0.3) * 0.003;\n            let osc1 = saw_ar(freq * (0.997 + lfo));\n            let osc2 = saw_ar(freq * (1.0 - lfo));\n            let osc3 = saw_ar(freq * (1.003 + lfo));\n\n            let mix = (osc1 + osc2 + osc3) * 0.35;\n\n            // Warm string filtering\n            let filtered = lpf_ar(mix, 3000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/cs80.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "dx7_epiano",
    "description": "The sound of the 80s",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "brightness",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"dx7_epiano\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"brightness\", 0.6)\n        .body(|freq, amp, gate, brightness| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // FM modulation envelope (fast attack, medium decay)\n            let mod_env = envelope()\n                .perc(0.001, 0.3)\n                .build();\n\n            // 2-operator FM synthesis\n            let mod_depth = brightness * 3.0 * mod_env + 0.5;\n            let modulator = sin_osc_ar(freq * 14.0) * mod_depth;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Second partial for richness\n            let mod2 = sin_osc_ar(freq * 7.0) * (brightness * 1.5 * mod_env);\n            let carrier2 = sin_osc_ar(freq * 2.0 + mod2) * 0.4;\n\n            // Third partial\n            let carrier3 = sin_osc_ar(freq * 3.0) * mod_env * 0.2;\n\n            let fm = carrier + carrier2 + carrier3;\n\n            fm * env * amp * 0.5\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/dx7.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "dx7_bass",
    "description": "Punchy FM bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"dx7_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.003, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sharp FM modulation envelope\n            let mod_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            // FM with ratio for bass punch\n            let mod_depth = mod_env * 4.0 + 0.3;\n            let modulator = sin_osc_ar(freq * 1.0) * mod_depth * freq;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Sub for weight\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            (carrier * 0.7 + sub) * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/dx7.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "dx7_bells",
    "description": "Classic FM bells",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 880
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"dx7_bells\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Long decay for bell\n            let decay_env = envelope()\n                .perc(0.001, 2.0)\n                .build();\n\n            // Inharmonic FM ratios for bell character\n            let mod1 = sin_osc_ar(freq * 3.5) * decay_env * 2.0;\n            let carrier1 = sin_osc_ar(freq + mod1);\n\n            let mod2 = sin_osc_ar(freq * 7.1) * decay_env * 1.5;\n            let carrier2 = sin_osc_ar(freq * 2.0 + mod2) * 0.5;\n\n            let mod3 = sin_osc_ar(freq * 11.0) * decay_env * 0.8;\n            let carrier3 = sin_osc_ar(freq * 4.0 + mod3) * 0.3;\n\n            let bell = carrier1 + carrier2 + carrier3;\n\n            bell * env * decay_env * amp * 0.5\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/dx7.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "dx7_brass",
    "description": "Punchy FM brass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"dx7_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Brass-like FM modulation\n            let mod_env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            let mod_depth = mod_env * 2.5 + 0.5;\n            let modulator = sin_osc_ar(freq * 1.0) * mod_depth;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Higher harmonic\n            let mod2 = sin_osc_ar(freq * 3.0) * mod_env * 1.5;\n            let carrier2 = sin_osc_ar(freq * 2.0 + mod2) * 0.4;\n\n            let brass = carrier + carrier2;\n\n            brass * env * amp * 0.6\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/dx7.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "dx7_marimba",
    "description": "Classic FM marimba",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"dx7_marimba\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Fast decay for mallet sound\n            let decay_env = envelope()\n                .perc(0.001, 0.5)\n                .build();\n\n            // FM for woody attack\n            let mod_depth = decay_env * 3.0;\n            let modulator = sin_osc_ar(freq * 4.0) * mod_depth;\n            let carrier = sin_osc_ar(freq + modulator);\n\n            // Fundamental\n            let fundamental = sin_osc_ar(freq) * 0.6;\n\n            (carrier * 0.5 + fundamental) * env * decay_env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/dx7.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "juno_pad",
    "description": "The iconic lush pad",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "chorus",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"juno_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"chorus\", 0.7) // Chorus depth\n        .body(|freq, amp, gate, chorus| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Single DCO with sub oscillator\n            let saw = saw_ar(freq);\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let source = saw * 0.7 + sub;\n\n            // Juno-style chorus (stereo detune)\n            let lfo1 = sin_osc_ar(0.5) * chorus * 0.008;\n            let lfo2 = sin_osc_ar(0.6) * chorus * 0.008;\n\n            let voice1 = saw_ar(freq * (1.0 + lfo1));\n            let voice2 = saw_ar(freq * (1.0 + lfo2));\n\n            let chorused = (source + voice1 + voice2) * 0.35;\n\n            // Warm resonant filter\n            let filtered = rlpf_ar(chorused, 2000.0, 0.4);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/juno.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "juno_brass",
    "description": "Classic synth brass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"juno_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope for brass attack\n            let filt_env = envelope()\n                .asr(0.03, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            // Saw waves with PWM character\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.003);\n\n            let source = (saw1 + saw2) * 0.5;\n\n            // Filter sweep\n            let cutoff = 600.0 + filt_env * 3000.0;\n            let filtered = rlpf_ar(source, cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/juno.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "juno_bass",
    "description": "Punchy analog bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"juno_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Saw + sub\n            let saw = saw_ar(freq);\n            let sub = sin_osc_ar(freq * 0.5) * 0.5;\n\n            let source = saw * 0.6 + sub;\n\n            // Punchy filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n            let cutoff = 400.0 + filt_env * 2000.0;\n\n            let filtered = rlpf_ar(source, cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/juno.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "juno_strings",
    "description": "Classic polysynth strings",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"juno_strings\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.3, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned voices\n            let v1 = saw_ar(freq * 0.996);\n            let v2 = saw_ar(freq * 0.999);\n            let v3 = saw_ar(freq * 1.001);\n            let v4 = saw_ar(freq * 1.004);\n\n            let voices = (v1 + v2 + v3 + v4) * 0.3;\n\n            // Smooth filtering\n            let filtered = lpf_ar(voices, 3500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/juno.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "jupiter_pad",
    "description": "Massive warm pad",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "spread",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"jupiter_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"spread\", 0.6)\n        .body(|freq, amp, gate, spread| {\n            let env = envelope()\n                .asr(0.5, 1.0, 0.6)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Two VCOs with cross-modulation\n            let detune = spread * 0.012;\n            let vco1 = saw_ar(freq * (1.0 - detune));\n            let vco2 = saw_ar(freq * (1.0 + detune));\n\n            // Sub oscillator\n            let sub = sin_osc_ar(freq * 0.5) * 0.35;\n\n            let mix = (vco1 + vco2) * 0.4 + sub;\n\n            // HPF for clarity then LPF for warmth\n            let filtered = lpf_ar(hpf_ar(mix, 60.0), 3000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/jupiter.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "jupiter_supersaw",
    "description": "The trance staple",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "detune",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"jupiter_supersaw\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"detune\", 0.5)\n        .body(|freq, amp, gate, detune| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // 7 detuned sawtooth oscillators\n            let spread = detune * 0.03;\n            let v1 = saw_ar(freq * (1.0 - spread * 3.0));\n            let v2 = saw_ar(freq * (1.0 - spread * 2.0));\n            let v3 = saw_ar(freq * (1.0 - spread));\n            let v4 = saw_ar(freq);\n            let v5 = saw_ar(freq * (1.0 + spread));\n            let v6 = saw_ar(freq * (1.0 + spread * 2.0));\n            let v7 = saw_ar(freq * (1.0 + spread * 3.0));\n\n            let stack = (v1 + v2 + v3 + v4 + v5 + v6 + v7) * 0.18;\n\n            // Bright filter\n            let filtered = lpf_ar(stack, 8000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/jupiter.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "jupiter_brass",
    "description": "Thick brass stab",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"jupiter_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .asr(0.02, 1.0, 0.12)\n                .gate(gate)\n                .build();\n\n            // Thick detuned oscillators\n            let v1 = saw_ar(freq * 0.995);\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * 1.005);\n\n            let mix = (v1 + v2 + v3) * 0.4;\n\n            // Brass filter sweep\n            let cutoff = 400.0 + filt_env * 4000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/jupiter.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "jupiter_bass",
    "description": "Deep punchy bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"jupiter_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n\n            // Two oscillators plus sub\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.002);\n            let sub = sin_osc_ar(freq * 0.5) * 0.5;\n\n            let mix = (saw1 + saw2) * 0.4 + sub;\n\n            // Punchy filter\n            let cutoff = 300.0 + filt_env * 2500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/jupiter.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "memorymoog_pad",
    "description": "Lush poly pad",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.45
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"memorymoog_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Six voice unison simulation\n            let detune = 0.003;\n            let osc1 = saw_ar(freq * (1.0 - detune * 2.0)) * 0.2;\n            let osc2 = saw_ar(freq * (1.0 - detune)) * 0.2;\n            let osc3 = saw_ar(freq) * 0.2;\n            let osc4 = saw_ar(freq * (1.0 + detune)) * 0.2;\n            let osc5 = saw_ar(freq * (1.0 + detune * 2.0)) * 0.2;\n            let sub = sin_osc_ar(freq * 0.5) * 0.15;\n\n            let mix = osc1 + osc2 + osc3 + osc4 + osc5 + sub;\n\n            // Warm Moog ladder filter\n            let filtered = lpf_ar(mix, 2800.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/memorymoog.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "memorymoog_brass",
    "description": "Poly brass section",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"memorymoog_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.1, 1.0, 0.25)\n                .gate(gate)\n                .build();\n\n            // Rich detuned oscillators\n            let osc1 = saw_ar(freq * 0.997);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.003);\n\n            let mix = (osc1 + osc2 + osc3) * 0.4;\n\n            let cutoff = 600.0 + filt_env * 3000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.65);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/memorymoog.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "memorymoog_lead",
    "description": "Fat poly lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"memorymoog_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.02, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // Three oscillators\n            let osc1 = saw_ar(freq);\n            let osc2 = saw_ar(freq * 1.004) * 0.8;\n            let osc3 = pulse_ar(freq * 2.0, 0.3) * 0.3;\n\n            let mix = (osc1 + osc2 + osc3) * 0.4;\n\n            let cutoff = 2000.0 + filt_env * 4000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.6);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/memorymoog.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "minimoog_bass",
    "description": "Classic fat bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "filter_freq",
        "default": 800
      },
      {
        "name": "resonance",
        "default": 0.3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"minimoog_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 800.0)\n        .param(\"resonance\", 0.3)\n        .body(|freq, amp, gate, filter_freq, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            // Three detuned oscillators (classic Moog)\n            let osc1 = saw_ar(freq);\n            let osc2 = saw_ar(freq * 0.995) * 0.8;  // Slightly detuned\n            let osc3 = saw_ar(freq * 0.5) * 0.6;   // Sub octave\n\n            let mix = (osc1 + osc2 + osc3) * 0.4;\n\n            // Ladder filter emulation (resonant lowpass)\n            let cutoff = filter_freq + filt_env * 2000.0;\n            let filtered = rlpf_ar(mix, cutoff, 1.0 - resonance * 0.9);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/minimoog.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "minimoog_lead",
    "description": "Screaming mono lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "filter_freq",
        "default": 2000
      },
      {
        "name": "resonance",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"minimoog_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 2000.0)\n        .param(\"resonance\", 0.4)\n        .body(|freq, amp, gate, filter_freq, resonance| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // Three oscillators - mix of saw and pulse\n            let osc1 = saw_ar(freq);\n            let osc2 = saw_ar(freq * 1.005);  // Detuned up\n            let osc3 = saw_ar(freq * 2.0) * 0.3; // Octave up\n\n            let mix = (osc1 + osc2 + osc3) * 0.4;\n\n            // Resonant filter sweep\n            let cutoff = filter_freq + filt_env * 4000.0;\n            let filtered = rlpf_ar(mix, cutoff, 1.0 - resonance * 0.85);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/minimoog.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "minimoog_pad",
    "description": "Warm analog pad",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"minimoog_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.5, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Warm detuned oscillators\n            let osc1 = saw_ar(freq * 0.998);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.002);\n            let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n            let mix = (osc1 + osc2 + osc3) * 0.3 + sub;\n\n            // Warm filtering\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/minimoog.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "ms20_bass",
    "description": "Aggressive filter bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "filter_freq",
        "default": 600
      },
      {
        "name": "resonance",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"ms20_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 600.0)\n        .param(\"resonance\", 0.5)\n        .body(|freq, amp, gate, filter_freq, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.02, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            // Dual oscillator - MS-20 style\n            let osc1 = saw_ar(freq);\n            let osc2 = pulse_ar(freq * 0.5, 0.4) * 0.7;\n\n            let mix = (osc1 + osc2) * 0.5;\n\n            // MS-20's aggressive high-pass then low-pass\n            let hp = hpf_ar(mix, 80.0);\n            let cutoff = filter_freq + filt_env * 1500.0;\n            let filtered = rlpf_ar(hp, cutoff, 1.0 - resonance * 0.95);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/ms20.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "ms20_lead",
    "description": "Screaming acid lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "filter_freq",
        "default": 1500
      },
      {
        "name": "resonance",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"ms20_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 1500.0)\n        .param(\"resonance\", 0.6)\n        .body(|freq, amp, gate, filter_freq, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // Ring mod style cross modulation\n            let osc1 = saw_ar(freq);\n            let osc2 = pulse_ar(freq * 1.002, 0.3);\n            let ring = osc1 * sin_osc_ar(freq * 2.0) * 0.3;\n\n            let mix = (osc1 + osc2 * 0.5 + ring) * 0.4;\n\n            let cutoff = filter_freq + filt_env * 3000.0;\n            let filtered = rlpf_ar(mix, cutoff, 1.0 - resonance * 0.9);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/ms20.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "ms20_sync",
    "description": "Oscillator sync sound",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "sync_ratio",
        "default": 2.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"ms20_sync\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"sync_ratio\", 2.5)\n        .body(|freq, amp, gate, sync_ratio| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simulated sync with multiple harmonics\n            let fund = saw_ar(freq) * 0.4;\n            let sync_freq = freq * sync_ratio;\n            let sync1 = saw_ar(sync_freq) * 0.3;\n            let sync2 = sin_osc_ar(sync_freq * 2.0) * 0.15;\n\n            let mix = fund + sync1 + sync2;\n            let filtered = lpf_ar(mix, 4000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/ms20.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "oberheim_pad",
    "description": "Ultra-lush pad",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"oberheim_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Two VCOs per voice, slightly detuned\n            let vco1a = saw_ar(freq * 0.996);\n            let vco1b = saw_ar(freq * 0.998);\n            let vco2a = saw_ar(freq * 1.002);\n            let vco2b = saw_ar(freq * 1.004);\n\n            let mix = (vco1a + vco1b + vco2a + vco2b) * 0.28;\n\n            // Warm SEM-style filter\n            let filtered = lpf_ar(mix, 2800.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/oberheim.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "oberheim_brass",
    "description": "The \"Jump\" brass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"oberheim_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .asr(0.015, 1.0, 0.12)\n                .gate(gate)\n                .build();\n\n            // Fat oscillators\n            let vco1 = saw_ar(freq * 0.998);\n            let vco2 = saw_ar(freq * 1.002);\n\n            let mix = (vco1 + vco2) * 0.5;\n\n            // Aggressive filter sweep\n            let cutoff = 300.0 + filt_env * 5000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.25);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/oberheim.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "oberheim_lead",
    "description": "Screaming lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"oberheim_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Two saw VCOs\n            let vco1 = saw_ar(freq);\n            let vco2 = saw_ar(freq * 1.008);\n\n            let mix = (vco1 + vco2) * 0.5;\n\n            // Bright resonant filter\n            let filtered = rlpf_ar(mix, 4000.0, 0.4);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/oberheim.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "oberheim_bass",
    "description": "Fat bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"oberheim_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.008, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.25)\n                .build();\n\n            // Fat oscillators with sub\n            let vco1 = saw_ar(freq);\n            let vco2 = saw_ar(freq * 1.003);\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let mix = (vco1 + vco2) * 0.4 + sub;\n\n            // Punchy filter\n            let cutoff = 250.0 + filt_env * 3000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.3);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/oberheim.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "odyssey_bass",
    "description": "Fat duophonic bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "filter_freq",
        "default": 700
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"odyssey_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 700.0)\n        .body(|freq, amp, gate, filter_freq| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .build();\n\n            // Dual oscillators with sync option\n            let osc1 = saw_ar(freq);\n            let osc2 = pulse_ar(freq * 0.5, 0.5) * 0.6;\n\n            let mix = (osc1 + osc2) * 0.5;\n\n            let cutoff = filter_freq + filt_env * 1800.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.55);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/odyssey.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "odyssey_lead",
    "description": "Biting mono lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "resonance",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"odyssey_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"resonance\", 0.5)\n        .body(|freq, amp, gate, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // Ring mod character\n            let osc1 = saw_ar(freq);\n            let osc2 = saw_ar(freq * 1.005);\n            let ring = osc1 * sin_osc_ar(freq * 1.5) * 0.2;\n\n            let mix = (osc1 + osc2) * 0.4 + ring;\n\n            let cutoff = 1200.0 + filt_env * 4000.0;\n            let filtered = rlpf_ar(mix, cutoff, 1.0 - resonance * 0.9);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/odyssey.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "odyssey_sh",
    "description": "Random stepped modulation",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.45
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "rate",
        "default": 8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"odyssey_sh\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .param(\"rate\", 8.0)\n        .body(|freq, amp, gate, rate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // S&H style random modulation\n            let sh = dust_ar(rate) * 100.0;\n            let mod_freq = freq + sh;\n\n            let osc1 = saw_ar(mod_freq);\n            let osc2 = pulse_ar(freq, 0.5) * 0.5;\n\n            let mix = (osc1 + osc2) * 0.45;\n\n            let filtered = rlpf_ar(mix, 2500.0, 0.6);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/odyssey.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "polysix_pad",
    "description": "Warm chorus pad",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.45
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"polysix_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Single oscillator with sub\n            let osc = saw_ar(freq);\n            let sub = pulse_ar(freq * 0.5, 0.5) * 0.3;\n\n            // Built-in ensemble effect simulation\n            let lfo1 = sin_osc_ar(0.5) * 0.003;\n            let lfo2 = sin_osc_ar(0.7) * 0.003;\n            let chorus1 = saw_ar(freq * (1.0 + lfo1)) * 0.3;\n            let chorus2 = saw_ar(freq * (1.0 + lfo2)) * 0.3;\n\n            let mix = osc * 0.4 + sub + chorus1 + chorus2;\n\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/polysix.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "polysix_strings",
    "description": "Classic string machine sound",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"polysix_strings\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.25, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Ensemble detuning\n            let lfo = sin_osc_ar(6.0) * 0.004;\n            let osc1 = saw_ar(freq * (0.998 + lfo));\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * (1.002 - lfo));\n\n            let mix = (osc1 + osc2 + osc3) * 0.35;\n\n            let filtered = lpf_ar(mix, 3500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/polysix.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "polysix_bass",
    "description": "Punchy poly bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.55
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"polysix_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            let osc = saw_ar(freq);\n            let sub = pulse_ar(freq * 0.5, 0.5) * 0.5;\n\n            let mix = (osc + sub) * 0.5;\n\n            let cutoff = 500.0 + filt_env * 1500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.6);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/polysix.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "ppg_pad",
    "description": "Digital wavetable pad",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.45
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "table_pos",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"ppg_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.45)\n        .param(\"gate\", 1.0)\n        .param(\"table_pos\", 0.5)\n        .body(|freq, amp, gate, table_pos| {\n            let env = envelope()\n                .asr(0.3, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simulated wavetable scanning with multiple waveforms\n            let saw_amt = table_pos;\n            let pulse_amt = 1.0 - table_pos;\n            let pw = table_pos * 0.4 + 0.1;\n\n            let osc1 = saw_ar(freq) * saw_amt;\n            let osc2 = pulse_ar(freq, pw) * pulse_amt;\n            let osc3 = sin_osc_ar(freq * 2.0) * 0.2;\n\n            let mix = (osc1 + osc2 + osc3) * 0.5;\n\n            // Digital-ish filtering\n            let filtered = lpf_ar(mix, 4000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/ppg_wave.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "ppg_lead",
    "description": "Digital metallic lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"ppg_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Metallic digital character\n            let osc1 = pulse_ar(freq, 0.3) * 0.4;\n            let osc2 = saw_ar(freq * 2.003) * 0.25;\n            let osc3 = sin_osc_ar(freq * 3.0) * 0.15;\n\n            let mix = osc1 + osc2 + osc3;\n\n            let filtered = lpf_ar(mix, 6000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/ppg_wave.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "ppg_bass",
    "description": "Digital bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.55
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"ppg_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .build();\n\n            // Wavetable-style with harmonics\n            let osc1 = saw_ar(freq) * 0.5;\n            let osc2 = pulse_ar(freq, 0.25) * 0.3;\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let mix = osc1 + osc2 + sub;\n\n            let cutoff = 600.0 + filt_env * 1500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.5);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/ppg_wave.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "pro_one_bass",
    "description": "Punchy mono bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "filter_freq",
        "default": 800
      },
      {
        "name": "resonance",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pro_one_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"filter_freq\", 800.0)\n        .param(\"resonance\", 0.4)\n        .body(|freq, amp, gate, filter_freq, resonance| {\n            let env = envelope()\n                .asr(0.005, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.005, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            // Dual oscillators\n            let osc1 = saw_ar(freq);\n            let osc2 = pulse_ar(freq * 0.5, 0.3) * 0.7;\n\n            let mix = (osc1 + osc2) * 0.5;\n\n            let cutoff = filter_freq + filt_env * 2000.0;\n            let filtered = rlpf_ar(mix, cutoff, 1.0 - resonance * 0.9);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/pro_one.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "pro_one_lead",
    "description": "Aggressive lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "pw",
        "default": 0.3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pro_one_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"pw\", 0.3)\n        .body(|freq, amp, gate, pw| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .asr(0.01, 1.0, 0.2)\n                .gate(gate)\n                .build();\n\n            // PWM lead\n            let pwm = sin_osc_ar(3.0) * 0.2 + pw;\n            let osc1 = pulse_ar(freq, pwm);\n            let osc2 = saw_ar(freq * 1.003) * 0.5;\n\n            let mix = (osc1 + osc2) * 0.45;\n\n            let cutoff = 1500.0 + filt_env * 3500.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.65);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/pro_one.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "pro_one_sync",
    "description": "Hard sync lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "sync_ratio",
        "default": 2
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pro_one_sync\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"sync_ratio\", 2.0)\n        .body(|freq, amp, gate, sync_ratio| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simulated hard sync\n            let master = saw_ar(freq);\n            let slave_freq = freq * sync_ratio;\n            let slave = saw_ar(slave_freq) * 0.6;\n            let harmonics = sin_osc_ar(slave_freq * 2.0) * 0.2;\n\n            let mix = (master + slave + harmonics) * 0.4;\n\n            let filtered = lpf_ar(mix, 5000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/pro_one.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "prophet_pad",
    "description": "Lush analog pad",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "spread",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"prophet_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"spread\", 0.5)\n        .body(|freq, amp, gate, spread| {\n            let env = envelope()\n                .asr(0.4, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Two oscillators with spread\n            let detune = spread * 0.01;\n            let osc_a = saw_ar(freq * (1.0 - detune));\n            let osc_b = saw_ar(freq * (1.0 + detune));\n\n            // Sub oscillator\n            let sub = sin_osc_ar(freq * 0.5) * 0.3;\n\n            let mix = (osc_a + osc_b) * 0.4 + sub;\n\n            // Warm lowpass\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/prophet.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "prophet_brass",
    "description": "Classic synth brass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"prophet_brass\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.06, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .asr(0.03, 1.0, 0.15)\n                .gate(gate)\n                .build();\n\n            // Two saw oscillators\n            let osc_a = saw_ar(freq);\n            let osc_b = saw_ar(freq * 1.005);\n\n            let mix = (osc_a + osc_b) * 0.5;\n\n            // Bright filter sweep\n            let cutoff = 500.0 + filt_env * 4000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/prophet.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "prophet_lead",
    "description": "Screaming lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "resonance",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"prophet_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"resonance\", 0.4)\n        .body(|freq, amp, gate, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Poly-mod style oscillator sync simulation\n            let osc_a = saw_ar(freq);\n            let osc_b = saw_ar(freq * 2.01); // Slight detune for richness\n\n            let mix = (osc_a + osc_b * 0.5) * 0.6;\n\n            // Resonant filter\n            let filtered = rlpf_ar(mix, 3000.0, 1.0 - resonance * 0.8);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/prophet.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "prophet_strings",
    "description": "Warm polysynth strings",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"prophet_strings\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.25, 1.0, 0.4)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Ensemble-style detuning\n            let v1 = saw_ar(freq * 0.997);\n            let v2 = saw_ar(freq * 0.999);\n            let v3 = saw_ar(freq * 1.001);\n            let v4 = saw_ar(freq * 1.003);\n\n            let voices = (v1 + v2 + v3 + v4) * 0.3;\n\n            // Warm filter\n            let filtered = lpf_ar(voices, 3000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/prophet.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "sh101_bass",
    "description": "Clean punchy bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "filter_env",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sh101_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"filter_env\", 0.6)\n        .body(|freq, amp, gate, filter_env| {\n            let env = envelope()\n                .asr(0.003, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            // Single VCO with sub\n            let saw = saw_ar(freq);\n            let sub = saw_ar(freq * 0.5) * 0.5;\n\n            let mix = saw * 0.6 + sub;\n\n            // 101 filter character\n            let cutoff = 300.0 + filt_env * filter_env * 3000.0;\n            let filtered = rlpf_ar(mix, cutoff, 0.35);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/sh101.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "sh101_lead",
    "description": "Classic mono lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "resonance",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sh101_lead\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"resonance\", 0.4)\n        .body(|freq, amp, gate, resonance| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Single oscillator\n            let saw = saw_ar(freq);\n\n            // Resonant filter\n            let filtered = rlpf_ar(saw, 3500.0, 1.0 - resonance * 0.8);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/sh101.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "sh101_sync",
    "description": "Hard sync lead",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "sync_ratio",
        "default": 2.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sh101_sync\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"sync_ratio\", 2.5)\n        .body(|freq, amp, gate, sync_ratio| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simulated sync with harmonic content\n            let master = saw_ar(freq);\n            let slave = saw_ar(freq * sync_ratio) * 0.4;\n            let sync_harmonic = sin_osc_ar(freq * sync_ratio) * 0.3;\n\n            let mix = master + slave + sync_harmonic;\n\n            // Bright filter\n            let filtered = lpf_ar(mix, 6000.0);\n\n            filtered * env * amp * 0.5\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/sh101.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "sh101_acid",
    "description": "For acid house",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "resonance",
        "default": 0.7
      },
      {
        "name": "env_mod",
        "default": 0.8
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sh101_acid\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"resonance\", 0.7)\n        .param(\"env_mod\", 0.8)\n        .body(|freq, amp, gate, resonance, env_mod| {\n            let env = envelope()\n                .asr(0.002, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Sharp filter envelope\n            let filt_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n\n            // Saw oscillator\n            let saw = saw_ar(freq);\n\n            // Squelchy acid filter\n            let cutoff = 200.0 + filt_env * env_mod * 4000.0;\n            let filtered = rlpf_ar(saw, cutoff, 1.0 - resonance * 0.9);\n\n            filtered * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/sh101.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "tb303_bass",
    "description": "Classic acid bass",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "cutoff",
        "default": 1000
      },
      {
        "name": "resonance",
        "default": 0.7
      },
      {
        "name": "env_mod",
        "default": 0.5
      },
      {
        "name": "decay",
        "default": 0.3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tb303_bass\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 1000.0)\n        .param(\"resonance\", 0.7)\n        .param(\"env_mod\", 0.5)\n        .param(\"decay\", 0.3)\n        .body(|freq, amp, gate, cutoff, resonance, env_mod, decay| {\n            let env = envelope()\n                .asr(0.003, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Filter envelope - key to 303 sound\n            // Use env_perc with base time of 1.0, then scale by decay parameter\n            let filt_env = envelope()\n                .perc(0.003, 1.0)\n                .time_scale(decay)\n                .build();\n\n            // Single saw oscillator\n            let osc = saw_ar(freq);\n\n            // Characteristic resonant filter\n            let mod_cutoff = cutoff + filt_env * env_mod * 8000.0;\n            let filtered = rlpf_ar(osc, mod_cutoff, 1.0 - resonance * 0.95);\n\n            // Slight overdrive\n            let driven = (filtered * 1.5).tanh() * 0.7;\n\n            driven * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/tb303.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "tb303_slide",
    "description": "Portamento acid line",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "cutoff",
        "default": 800
      },
      {
        "name": "resonance",
        "default": 0.75
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tb303_slide\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"cutoff\", 800.0)\n        .param(\"resonance\", 0.75)\n        .body(|freq, amp, gate, cutoff, resonance| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .perc(0.001, 0.2)\n                .build();\n\n            let osc = saw_ar(freq);\n\n            let mod_cutoff = cutoff + filt_env * 6000.0;\n            let filtered = rlpf_ar(osc, mod_cutoff, 1.0 - resonance * 0.97);\n\n            let driven = (filtered * 1.8).tanh() * 0.65;\n\n            driven * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/tb303.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "tb303_accent",
    "description": "Accented acid hit",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.7
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tb303_accent\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.7)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.06)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let filt_env = envelope()\n                .perc(0.001, 0.15)\n                .build();\n\n            let osc = saw_ar(freq);\n\n            // High resonance, big envelope sweep\n            let mod_cutoff = 400.0 + filt_env * 10000.0;\n            let filtered = rlpf_ar(osc, mod_cutoff, 0.08);\n\n            let driven = (filtered * 2.0).tanh() * 0.6;\n\n            driven * env * amp\n        })\n});",
    "category": "synths",
    "subcategory": "",
    "path": "synths/tb303.vibe",
    "categoryName": "Synths"
  },
  {
    "name": "texture_field",
    "description": "Genre: Ambient, Field Recording | Character: Field recording style ambient",
    "genre": "Ambient, Field Recording",
    "character": "Field recording style ambient",
    "params": [
      {
        "name": "amp",
        "default": 0.35
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"texture_field\", |builder| {\n    builder\n        .param(\"amp\", 0.35)\n        .body(|amp| {\n            // Very long sustain\n            let env = envelope()\n                .perc(2.0, 15.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Mix of noise colors\n            let pink = pink_noise_ar() * 0.5;\n            let brown = pink_noise_ar() * 0.3;\n            let white = white_noise_ar() * 0.2;\n\n            let noise_mix = pink + brown + white;\n\n            // Natural filtering\n            let filtered = rlpf_ar(noise_mix, 2500.0, 0.7);\n\n            // Gentle evolution\n            let filter_env = envelope()\n                .perc(4.0, 12.0)\n                .build();\n            let mod_cutoff = 1500.0 + (filter_env * 1500.0);\n\n            let evolved = lpf_ar(filtered, mod_cutoff);\n\n            evolved * env * amp\n        })\n});",
    "category": "textures",
    "subcategory": "ambient",
    "path": "textures/ambient/texture_field.vibe",
    "categoryName": "Textures",
    "subcategoryName": "Ambient"
  },
  {
    "name": "texture_granular",
    "description": "Genre: Ambient, Experimental | Character: Granular-style texture",
    "genre": "Ambient, Experimental",
    "character": "Granular-style texture",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"texture_granular\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .body(|freq, amp| {\n            // Long envelope\n            let env = envelope()\n                .perc(1.5, 9.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple detuned oscillators for grain-like character\n            let osc1 = saw_ar(freq * 0.983);\n            let osc2 = saw_ar(freq * 0.991);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.009);\n            let osc5 = saw_ar(freq * 1.017);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Heavy filtering for smoothness\n            let filtered = lpf_ar(mix, 1500.0);\n\n            // Additional resonant layer\n            let resonant = rlpf_ar(filtered, 2000.0, 0.6) * 0.5;\n\n            (filtered + resonant) * env * amp * 0.6\n        })\n});",
    "category": "textures",
    "subcategory": "ambient",
    "path": "textures/ambient/texture_granular.vibe",
    "categoryName": "Textures",
    "subcategoryName": "Ambient"
  },
  {
    "name": "texture_rain",
    "description": "Genre: Ambient, Nature | Character: Rain-like texture",
    "genre": "Ambient, Nature",
    "character": "Rain-like texture",
    "params": [
      {
        "name": "amp",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"texture_rain\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .body(|amp| {\n            // Long sustain\n            let env = envelope()\n                .perc(0.5, 10.0)\n                .cleanup_on_finish()\n                .build();\n\n            // White noise for rain character\n            let noise = white_noise_ar();\n\n            // Mid-range filtering\n            let filtered = rlpf_ar(noise, 3500.0, 0.6);\n\n            // High-pass to remove lows\n            let clean = hpf_ar(filtered, 400.0);\n\n            clean * env * amp * 0.7\n        })\n});",
    "category": "textures",
    "subcategory": "ambient",
    "path": "textures/ambient/texture_rain.vibe",
    "categoryName": "Textures",
    "subcategoryName": "Ambient"
  },
  {
    "name": "texture_space",
    "description": "Genre: Ambient, Sci-Fi | Character: Spacious, ethereal texture",
    "genre": "Ambient, Sci-Fi",
    "character": "Spacious, ethereal texture",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.35
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"texture_space\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.35)\n        .body(|freq, amp| {\n            // Very long envelope\n            let env = envelope()\n                .perc(2.0, 12.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple slow oscillators\n            let osc1 = sin_osc_ar(freq * 0.5);\n            let osc2 = sin_osc_ar(freq * 0.75);\n            let osc3 = sin_osc_ar(freq);\n            let osc4 = sin_osc_ar(freq * 1.5);\n\n            // Mix with harmonics\n            let mix = (osc1 * 0.3 + osc2 * 0.25 + osc3 * 0.25 + osc4 * 0.2);\n\n            // Evolving filter\n            let filter_env = envelope()\n                .perc(3.0, 10.0)\n                .build();\n            let mod_cutoff = 500.0 + (filter_env * 2500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "textures",
    "subcategory": "ambient",
    "path": "textures/ambient/texture_space.vibe",
    "categoryName": "Textures",
    "subcategoryName": "Ambient"
  },
  {
    "name": "texture_wind",
    "description": "Genre: Ambient, Field Recording | Character: Wind-like texture",
    "genre": "Ambient, Field Recording",
    "character": "Wind-like texture",
    "params": [
      {
        "name": "amp",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"texture_wind\", |builder| {\n    builder\n        .param(\"amp\", 0.4)\n        .body(|amp| {\n            // Long, sustained envelope\n            let env = envelope()\n                .perc(1.0, 8.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise for natural wind\n            let noise = pink_noise_ar();\n\n            // Slow filter modulation for movement\n            let filter_env = envelope()\n                .perc(2.0, 7.0)\n                .build();\n            let mod_cutoff = 800.0 + (filter_env * 2000.0);\n\n            let filtered = lpf_ar(noise, mod_cutoff);\n\n            // High-pass to remove rumble\n            let clean = hpf_ar(filtered, 150.0);\n\n            clean * env * amp\n        })\n});",
    "category": "textures",
    "subcategory": "ambient",
    "path": "textures/ambient/texture_wind.vibe",
    "categoryName": "Textures",
    "subcategoryName": "Ambient"
  },
  {
    "name": "drone_dark",
    "description": "Genre: Dark Ambient, Drone | Character: Dark, ominous drone",
    "genre": "Dark Ambient, Drone",
    "character": "Dark, ominous drone",
    "params": [
      {
        "name": "freq",
        "default": 55
      },
      {
        "name": "amp",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"drone_dark\", |builder| {\n    builder\n        .param(\"freq\", 55.0)\n        .param(\"amp\", 0.4)\n        .body(|freq, amp| {\n            // Very long sustain\n            let env = envelope()\n                .perc(3.0, 20.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Low, detuned oscillators\n            let osc1 = saw_ar(freq * 0.995);\n            let osc2 = saw_ar(freq);\n            let osc3 = saw_ar(freq * 1.005);\n            let osc4 = saw_ar(freq * 0.5);\n\n            let mix = (osc1 + osc2 + osc3) * 0.25 + (osc4 * 0.25);\n\n            // Dark filtering\n            let filtered = lpf_ar(mix, 600.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "textures",
    "subcategory": "drone",
    "path": "textures/drone/drone_dark.vibe",
    "categoryName": "Textures",
    "subcategoryName": "Drone"
  },
  {
    "name": "drone_evolving",
    "description": "Genre: Ambient, Drone | Character: Slowly evolving drone",
    "genre": "Ambient, Drone",
    "character": "Slowly evolving drone",
    "params": [
      {
        "name": "freq",
        "default": 82
      },
      {
        "name": "amp",
        "default": 0.35
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"drone_evolving\", |builder| {\n    builder\n        .param(\"freq\", 82.0)\n        .param(\"amp\", 0.35)\n        .body(|freq, amp| {\n            // Very long sustain\n            let env = envelope()\n                .perc(4.0, 25.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Wide detuning\n            let osc1 = saw_ar(freq * 0.980);\n            let osc2 = saw_ar(freq * 0.990);\n            let osc3 = saw_ar(freq);\n            let osc4 = saw_ar(freq * 1.010);\n            let osc5 = saw_ar(freq * 1.020);\n\n            let mix = (osc1 + osc2 + osc3 + osc4 + osc5) * 0.2;\n\n            // Slowly evolving filter\n            let filter_env = envelope()\n                .perc(8.0, 20.0)\n                .build();\n            let mod_cutoff = 400.0 + (filter_env * 2000.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            // Additional resonance layer\n            let resonant = rlpf_ar(filtered, mod_cutoff * 0.8, 0.5) * 0.5;\n\n            (filtered + resonant) * env * amp * 0.7\n        })\n});",
    "category": "textures",
    "subcategory": "drone",
    "path": "textures/drone/drone_evolving.vibe",
    "categoryName": "Textures",
    "subcategoryName": "Drone"
  },
  {
    "name": "drone_harmonic",
    "description": "Genre: Ambient, Drone | Character: Harmonic, spectral drone",
    "genre": "Ambient, Drone",
    "character": "Harmonic, spectral drone",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.35
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"drone_harmonic\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.35)\n        .body(|freq, amp| {\n            // Long sustain\n            let env = envelope()\n                .perc(2.5, 18.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Harmonic series\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.33;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.2;\n            let h6 = sin_osc_ar(freq * 6.0) * 0.16;\n\n            let mix = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Gentle filtering\n            let filtered = lpf_ar(mix, 2500.0);\n\n            filtered * env * amp * 0.5\n        })\n});",
    "category": "textures",
    "subcategory": "drone",
    "path": "textures/drone/drone_harmonic.vibe",
    "categoryName": "Textures",
    "subcategoryName": "Drone"
  },
  {
    "name": "drone_noise",
    "description": "Genre: Experimental, Noise | Character: Noise-based drone",
    "genre": "Experimental, Noise",
    "character": "Noise-based drone",
    "params": [
      {
        "name": "amp",
        "default": 0.35
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"drone_noise\", |builder| {\n    builder\n        .param(\"amp\", 0.35)\n        .body(|amp| {\n            // Long sustain\n            let env = envelope()\n                .perc(2.0, 15.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Pink noise base\n            let noise = pink_noise_ar();\n\n            // Multiple resonant filters for drone character\n            let res1 = rlpf_ar(noise, 200.0, 0.1) * 0.4;\n            let res2 = rlpf_ar(noise, 450.0, 0.15) * 0.3;\n            let res3 = rlpf_ar(noise, 800.0, 0.2) * 0.3;\n\n            let mix = res1 + res2 + res3;\n\n            // Evolving filtering\n            let filter_env = envelope()\n                .perc(4.0, 12.0)\n                .build();\n            let mod_cutoff = 1000.0 + (filter_env * 1500.0);\n\n            let filtered = lpf_ar(mix, mod_cutoff);\n\n            filtered * env * amp\n        })\n});",
    "category": "textures",
    "subcategory": "drone",
    "path": "textures/drone/drone_noise.vibe",
    "categoryName": "Textures",
    "subcategoryName": "Drone"
  },
  {
    "name": "drone_resonant",
    "description": "Genre: Ambient, Experimental | Character: Resonant, metallic drone",
    "genre": "Ambient, Experimental",
    "character": "Resonant, metallic drone",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.35
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"drone_resonant\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.35)\n        .body(|freq, amp| {\n            // Long sustain\n            let env = envelope()\n                .perc(2.5, 18.0)\n                .cleanup_on_finish()\n                .build();\n\n            // Sawtooth source\n            let osc = saw_ar(freq);\n\n            // Multiple resonant filters at different frequencies\n            let res1 = rlpf_ar(osc, freq * 2.0, 0.1) * 0.35;\n            let res2 = rlpf_ar(osc, freq * 3.0, 0.15) * 0.3;\n            let res3 = rlpf_ar(osc, freq * 5.0, 0.2) * 0.25;\n            let res4 = rlpf_ar(osc, freq * 7.0, 0.25) * 0.1;\n\n            let mix = res1 + res2 + res3 + res4;\n\n            // Overall filtering\n            let filtered = lpf_ar(mix, 3000.0);\n\n            filtered * env * amp\n        })\n});",
    "category": "textures",
    "subcategory": "drone",
    "path": "textures/drone/drone_resonant.vibe",
    "categoryName": "Textures",
    "subcategoryName": "Drone"
  },
  {
    "name": "click_high",
    "description": "Utility: Click track for timing reference",
    "genre": "",
    "character": "",
    "params": [],
    "type": "synthdef",
    "source": "// Utility: Click track for timing reference\n\n// Click high - Downbeat marker\ndefine_synthdef(\"click_high\")\n    .param(\"amp\", 0.6)\n    .body(|amp| {        let env = envelope()\n            .perc(0.001, 0.03)\n            .cleanup_on_finish()\n            .build();\n\n        sin_osc_ar(1500.0) * env * amp\n    });\n\n// Click low - Off-beat marker\ndefine_synthdef(\"click_low\")\n    .param(\"amp\", 0.5)\n    .body(|amp| {        let env = envelope()\n            .perc(0.001, 0.025)\n            .cleanup_on_finish()\n            .build();\n\n        sin_osc_ar(1000.0) * env * amp\n    });\n\n// Click wood - Natural sounding click\ndefine_synthdef(\"click_wood\")\n    .param(\"amp\", 0.55)\n    .body(|amp| {        let env = envelope()\n            .perc(0.001, 0.02)\n            .cleanup_on_finish()\n            .build();\n\n        let noise = hpf_ar(white_noise_ar(), 2000.0);\n        let body = sin_osc_ar(800.0) * 0.3;\n\n        (noise * 0.7 + body) * env * amp\n    });\n",
    "category": "utility",
    "subcategory": "",
    "path": "utility/click_track.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "lfo_sine",
    "description": "Sine LFO",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 1
      },
      {
        "name": "amp",
        "default": 1
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lfo_sine\", |builder| {\n    builder\n        .param(\"freq\", 1.0)\n        .param(\"amp\", 1.0)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.001)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            sin_osc_ar(freq) * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/lfo.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "lfo_triangle",
    "description": "Triangle LFO (approximated)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 1
      },
      {
        "name": "amp",
        "default": 1
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lfo_triangle\", |builder| {\n    builder\n        .param(\"freq\", 1.0)\n        .param(\"amp\", 1.0)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.001)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Use sine as approximation\n            let tri = sin_osc_ar(freq);\n            tri * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/lfo.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "lfo_saw",
    "description": "Sawtooth LFO",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 1
      },
      {
        "name": "amp",
        "default": 1
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lfo_saw\", |builder| {\n    builder\n        .param(\"freq\", 1.0)\n        .param(\"amp\", 1.0)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.001)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            saw_ar(freq) * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/lfo.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "lfo_random",
    "description": "Random/Sample & Hold LFO (stepped random)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 4
      },
      {
        "name": "amp",
        "default": 1
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"lfo_random\", |builder| {\n    builder\n        .param(\"freq\", 4.0)\n        .param(\"amp\", 1.0)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.001)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Use noise filtered for stepped random effect\n            let noise = white_noise_ar();\n            let stepped = lpf_ar(noise, freq);\n\n            stepped * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/lfo.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "metronome",
    "description": "Metronome Click",
    "genre": "",
    "character": "",
    "params": [],
    "type": "synthdef",
    "source": "// Metronome Click\n// Utility | Character: Sharp, precise click\n//\n// Simple metronome click for timing reference.\n\ndefine_synthdef(\"metronome\")\n    .param(\"freq\", 1000.0)\n    .param(\"amp\", 0.5)\n    .body(|freq, amp| {\n        // Very short click envelope\n        let env = envelope()\n            .perc(0.0001, 0.03)\n            .cleanup_on_finish()\n            .build();\n\n        // Sharp click tone\n        let click = sin_osc_ar(freq);\n\n        // High frequency transient for clarity\n        let tick_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let tick = sin_osc_ar(freq * 4.0) * tick_env;\n\n        (click + tick * 0.5) * env * amp\n    });\n\n// Accented metronome click (for downbeats)\ndefine_synthdef(\"metronome_accent\")\n    .param(\"freq\", 1500.0)\n    .param(\"amp\", 0.6)\n    .body(|freq, amp| {\n        // Short click envelope\n        let env = envelope()\n            .perc(0.0001, 0.04)\n            .cleanup_on_finish()\n            .build();\n\n        // Higher pitched accent\n        let click = sin_osc_ar(freq);\n        let click2 = sin_osc_ar(freq * 2.0) * 0.3;\n\n        (click + click2) * env * amp\n    });\n",
    "category": "utility",
    "subcategory": "",
    "path": "utility/metronome.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "white_noise_gen",
    "description": "White Noise (all frequencies, flat spectrum)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "amp",
        "default": 0.3
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"white_noise_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            white_noise_ar() * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/noise_generators.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "pink_noise_gen",
    "description": "Pink Noise (1/f spectrum, equal energy per octave)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "amp",
        "default": 0.3
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pink_noise_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Approximate pink noise by filtering white noise\n            let white = white_noise_ar();\n            let pink = lpf_ar(white, 10000.0);\n\n            pink * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/noise_generators.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "brown_noise_gen",
    "description": "Brown/Red Noise (1/f^2 spectrum, deeper)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "amp",
        "default": 0.3
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"brown_noise_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Heavy low pass for brown noise character\n            let white = white_noise_ar();\n            let brown = lpf_ar(lpf_ar(white, 800.0), 400.0);\n\n            brown * env * amp * 2.0\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/noise_generators.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "hiss_gen",
    "description": "High-passed Noise (hiss, bright)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "amp",
        "default": 0.2
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "freq",
        "default": 4000
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"hiss_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.2)\n        .param(\"gate\", 1.0)\n        .param(\"freq\", 4000.0) // High pass frequency\n        .body(|amp, gate, freq| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let white = white_noise_ar();\n            let hiss = hpf_ar(white, freq);\n\n            hiss * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/noise_generators.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "filtered_noise_gen",
    "description": "Filtered Noise (bandpass, focused)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "amp",
        "default": 0.3
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "freq",
        "default": 1000
      },
      {
        "name": "rq",
        "default": 0.2
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"filtered_noise_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .param(\"freq\", 1000.0) // Center frequency\n        .param(\"rq\", 0.2) // Resonance (lower = more resonant)\n        .body(|amp, gate, freq, rq| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            let white = white_noise_ar();\n            let filtered = rlpf_ar(white, freq, rq);\n\n            filtered * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/noise_generators.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "crackle_gen",
    "description": "Crackle (random impulses)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "amp",
        "default": 0.2
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "density",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"crackle_gen\", |builder| {\n    builder\n        .param(\"amp\", 0.2)\n        .param(\"gate\", 1.0)\n        .param(\"density\", 0.5) // Crackle density\n        .body(|amp, gate, density| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Use dust for random impulses\n            let impulses = dust_ar(10.0 + density * 100.0);\n            let crackle = hpf_ar(impulses, 1000.0);\n\n            crackle * env * amp * 3.0\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/noise_generators.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "noise_pink",
    "description": "Utility: Pure pink noise generator",
    "genre": "",
    "character": "",
    "params": [],
    "type": "synthdef",
    "source": "// Utility: Pure pink noise generator\ndefine_synthdef(\"noise_pink\")\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        pink_noise_ar() * env * amp\n    });\n",
    "category": "utility",
    "subcategory": "",
    "path": "utility/noise_pink.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "noise_white",
    "description": "Utility: Pure white noise generator",
    "genre": "",
    "character": "",
    "params": [],
    "type": "synthdef",
    "source": "// Utility: Pure white noise generator\ndefine_synthdef(\"noise_white\")\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        white_noise_ar() * env * amp\n    });\n",
    "category": "utility",
    "subcategory": "",
    "path": "utility/noise_white.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "sweep_tone",
    "description": "Utility: Oscilloscope calibration and test tones",
    "genre": "",
    "character": "",
    "params": [],
    "type": "synthdef",
    "source": "// Utility: Oscilloscope calibration and test tones\n\n// Sweep tone - Frequency sweep for testing\ndefine_synthdef(\"sweep_tone\")\n    .param(\"amp\", 0.4)\n    .param(\"gate\", 1.0)\n    .param(\"rate\", 0.5)\n    .body(|amp, gate, rate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // LFO sweeping from 100Hz to 5000Hz\n        let lfo = sin_osc_ar(rate) * 0.5 + 0.5;\n        let freq = 100.0 + lfo * 4900.0;\n\n        sin_osc_ar(freq) * env * amp\n    });\n\n// Square test - Square wave test tone\ndefine_synthdef(\"square_test\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.35)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        pulse_ar(freq, 0.5) * env * amp\n    });\n\n// Saw test - Sawtooth test tone\ndefine_synthdef(\"saw_test\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.35)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        saw_ar(freq) * env * amp\n    });\n\n// Triangle test - Triangle wave test tone\ndefine_synthdef(\"tri_test\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.4)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        lf_tri_ar(freq) * env * amp\n    });\n",
    "category": "utility",
    "subcategory": "",
    "path": "utility/oscilloscope_tones.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "silence",
    "description": "Utility: Silent placeholder for routing",
    "genre": "",
    "character": "",
    "params": [],
    "type": "synthdef",
    "source": "// Utility: Silent placeholder for routing\n\n// Silence - Output nothing (useful for bus routing setup)\ndefine_synthdef(\"silence\")\n    .param(\"amp\", 0.0)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.0, 1.0, 0.0)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        dc_ar(0.0) * env * amp\n    });\n",
    "category": "utility",
    "subcategory": "",
    "path": "utility/silence.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "test_sine",
    "description": "Pure sine wave test tone",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.3
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"test_sine\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.01)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            sin_osc_ar(freq) * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/test_tones.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "test_saw",
    "description": "Sawtooth test tone (rich harmonics)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.2
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"test_saw\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.2)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.01)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            saw_ar(freq) * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/test_tones.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "a440",
    "description": "A440 Reference tone",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "amp",
        "default": 0.3
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"a440\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.01)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            sin_osc_ar(440.0) * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/test_tones.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "test_1k",
    "description": "1kHz Reference tone (common audio test frequency)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "amp",
        "default": 0.3
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"test_1k\", |builder| {\n    builder\n        .param(\"amp\", 0.3)\n        .param(\"gate\", 1.0)\n        .body(|amp, gate| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.01)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            sin_osc_ar(1000.0) * env * amp\n        })\n});",
    "category": "utility",
    "subcategory": "",
    "path": "utility/test_tones.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "tuner_a440",
    "description": "Utility: Tuning reference tones",
    "genre": "",
    "character": "",
    "params": [],
    "type": "synthdef",
    "source": "// Utility: Tuning reference tones\n\n// A440 - Standard concert pitch\ndefine_synthdef(\"tuner_a440\")\n    .param(\"amp\", 0.3)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        sin_osc_ar(440.0) * env * amp\n    });\n\n// A432 - Alternative tuning reference\ndefine_synthdef(\"tuner_a432\")\n    .param(\"amp\", 0.3)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        sin_osc_ar(432.0) * env * amp\n    });\n\n// E Standard - Guitar low E\ndefine_synthdef(\"tuner_e_low\")\n    .param(\"amp\", 0.35)\n    .param(\"gate\", 1.0)\n    .body(|amp, gate| {\n        let env = envelope()\n            .asr(0.01, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // 82.41 Hz - Low E\n        sin_osc_ar(82.41) * env * amp\n    });\n",
    "category": "utility",
    "subcategory": "",
    "path": "utility/tuner.vibe",
    "categoryName": "Utility"
  },
  {
    "name": "choir_pad",
    "description": "with formant filtering for vocal character.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "spread",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"choir_pad\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"spread\", 0.5) // Stereo width and detune\n        .body(|freq, amp, gate, spread| {\n            // Slow attack for choir swell\n            let env = envelope()\n                .asr(0.8, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Multiple \"voices\" with slight detuning\n            let detune = 0.002 + spread * 0.006;\n            let v1 = saw_ar(freq * (1.0 - detune));\n            let v2 = saw_ar(freq);\n            let v3 = saw_ar(freq * (1.0 + detune));\n            let v4 = saw_ar(freq * (1.0 - detune * 2.0));\n            let v5 = saw_ar(freq * (1.0 + detune * 2.0));\n\n            // Octave doubling for richness\n            let octave = saw_ar(freq * 2.0) * 0.3;\n\n            let voices = (v1 + v2 + v3 + v4 + v5) * 0.25 + octave;\n\n            // Choir formant filtering (vowel blend)\n            let formant1 = rlpf_ar(voices, 600.0, 0.15);\n            let formant2 = rlpf_ar(voices, 1200.0, 0.1) * 0.5;\n            let formant3 = rlpf_ar(voices, 2400.0, 0.08) * 0.25;\n\n            let filtered = formant1 + formant2 + formant3;\n\n            // Subtle vibrato for life\n            let vib = sin_osc_ar(5.5) * 0.003;\n            let vibrato_mod = 1.0 + vib;\n\n            // Overall shaping\n            let shaped = lpf_ar(filtered, 4000.0);\n\n            shaped * env * amp * vibrato_mod\n        })\n});",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/choir_pad.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "formant_synth",
    "description": "Can produce \"aah\", \"eeh\", \"ooh\" type sounds.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "formant",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"formant_synth\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"formant\", 0.5) // 0=a, 0.5=e, 1.0=o\n        .body(|freq, amp, gate, formant| {\n            // Gate-controlled envelope\n            let env = envelope()\n                .asr(0.1, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Rich source oscillator with harmonics\n            let saw1 = saw_ar(freq);\n            let saw2 = saw_ar(freq * 1.003);\n            let pulse = saw_ar(freq * 0.5) * 0.5;\n            let source = (saw1 + saw2 + pulse) * 0.4;\n\n            // Formant frequencies for vowels\n            // A: 800, 1150, 2900 Hz\n            // E: 400, 1600, 2700 Hz\n            // O: 450, 800, 2830 Hz\n            let f1 = 400.0 + formant * 400.0;\n            let f2 = 800.0 + (1.0 - formant) * 800.0;\n            let f3 = 2700.0 + formant * 200.0;\n\n            // Apply resonant bandpass filters at formant frequencies\n            let bp1 = rlpf_ar(source, f1, 0.1) * 1.0;\n            let bp2 = rlpf_ar(source, f2, 0.1) * 0.7;\n            let bp3 = rlpf_ar(source, f3, 0.05) * 0.3;\n\n            let formants = bp1 + bp2 + bp3;\n\n            formants * env * amp\n        })\n});",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/formant_synth.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "vocal_aaah",
    "description": "\"Aaah\" choir voice",
    "genre": "Ambient, Cinematic",
    "character": "\"Aaah\" choir voice",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Ambient, Cinematic | Character: \"Aaah\" choir voice\ndefine_synthdef(\"vocal_aaah\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.008;\n\n        // Vocal source\n        let source = saw_ar(freq + vib) * 0.4;\n\n        // \"Aaah\" formants\n        let f1 = bpf_ar(source, 700.0, 0.12) * 0.5;\n        let f2 = bpf_ar(source, 1200.0, 0.15) * 0.3;\n        let f3 = bpf_ar(source, 2500.0, 0.2) * 0.15;\n\n        let sig = f1 + f2 + f3;\n\n        sig * env * amp\n    });\n",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/vocal_aaah.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "vocal_breathy",
    "description": "Breathy vocal texture",
    "genre": "Pop, R&B",
    "character": "Breathy vocal texture",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Pop, R&B | Character: Breathy vocal texture\ndefine_synthdef(\"vocal_breathy\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.15, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Soft vibrato\n        let vib = sin_osc_ar(4.5) * freq * 0.005;\n\n        // Pitched component\n        let pitched = saw_ar(freq + vib) * 0.25;\n\n        // Breath noise\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.0, 0.3) * 0.35;\n\n        // Formants\n        let mix = pitched + breath;\n        let f1 = bpf_ar(mix, 600.0, 0.12) * 0.4;\n        let f2 = bpf_ar(mix, 1200.0, 0.15) * 0.3;\n\n        let sig = f1 + f2;\n\n        sig * env * amp\n    });\n",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/vocal_breathy.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "vocal_chop",
    "description": "Perfect for vocal chop style leads.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "vowel",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"vocal_chop\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"vowel\", 0.5) // Vowel type\n        .body(|freq, amp, gate, vowel| {\n            // Short percussive envelope for chops\n            let env = envelope()\n                .asr(0.01, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Bright harmonically rich source\n            let saw = saw_ar(freq);\n            let pulse = saw_ar(freq * 1.001);\n            let source = (saw + pulse) * 0.5;\n\n            // Vowel formants (simplified)\n            let f1 = 300.0 + vowel * 500.0;\n            let f2 = 900.0 + (1.0 - vowel) * 700.0;\n\n            let formant1 = rlpf_ar(source, f1, 0.12);\n            let formant2 = rlpf_ar(source, f2, 0.1) * 0.6;\n\n            let vocal = formant1 + formant2;\n\n            // Slight pitch envelope for attack character\n            let pitch_env = envelope()\n                .perc(0.001, 0.05)\n                .build();\n            let pitched = sin_osc_ar(freq * (1.0 + pitch_env * 0.05)) * 0.1;\n\n            (vocal + pitched) * env * amp\n        })\n});",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/vocal_chop.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "vocal_eee",
    "description": "\"Eee\" vowel sound",
    "genre": "Pop, Electronic",
    "character": "\"Eee\" vowel sound",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Pop, Electronic | Character: \"Eee\" vowel sound\ndefine_synthdef(\"vocal_eee\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.15, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.008;\n\n        // Vocal source\n        let source = saw_ar(freq + vib) * 0.4;\n\n        // \"Eee\" formants (high front vowel)\n        let f1 = bpf_ar(source, 270.0, 0.08) * 0.35;\n        let f2 = bpf_ar(source, 2300.0, 0.15) * 0.45;\n        let f3 = bpf_ar(source, 3000.0, 0.2) * 0.15;\n\n        let sig = f1 + f2 + f3;\n\n        sig * env * amp\n    });\n",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/vocal_eee.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "vocal_falsetto",
    "description": "Light falsetto voice",
    "genre": "Soul, Pop",
    "character": "Light falsetto voice",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Soul, Pop | Character: Light falsetto voice\ndefine_synthdef(\"vocal_falsetto\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.45)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Light vibrato\n        let vib = sin_osc_ar(6.0) * freq * 0.01;\n\n        // Pure tone with slight breathiness\n        let pure = sin_osc_ar(freq + vib) * 0.5;\n        let breath = bpf_ar(pink_noise_ar(), freq * 3.0, 0.25) * 0.15;\n\n        // Light formants\n        let mix = pure + breath;\n        let f1 = bpf_ar(mix, 800.0, 0.15) * 0.35;\n        let f2 = bpf_ar(mix, 1800.0, 0.18) * 0.25;\n\n        let sig = f1 + f2 + pure * 0.3;\n\n        sig * env * amp\n    });\n",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/vocal_falsetto.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "vocal_mmm",
    "description": "Humming \"Mmm\" sound",
    "genre": "Ambient, Soul",
    "character": "Humming \"Mmm\" sound",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Ambient, Soul | Character: Humming \"Mmm\" sound\ndefine_synthdef(\"vocal_mmm\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.0) * freq * 0.006;\n\n        // Nasal resonance source\n        let source = saw_ar(freq + vib) * 0.35;\n\n        // Humming formants (nasal, closed mouth)\n        let f1 = bpf_ar(source, 250.0, 0.05) * 0.4;\n        let f2 = bpf_ar(source, 1000.0, 0.1) * 0.2;\n        let nasal = bpf_ar(source, 2500.0, 0.15) * 0.15;\n\n        let sig = f1 + f2 + nasal;\n\n        // Slight low pass for warmth\n        let filtered = lpf_ar(sig, 3000.0);\n\n        filtered * env * amp\n    });\n",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/vocal_mmm.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "vocal_oooh",
    "description": "\"Oooh\" choir voice",
    "genre": "Ambient, R&B",
    "character": "\"Oooh\" choir voice",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Ambient, R&B | Character: \"Oooh\" choir voice\ndefine_synthdef(\"vocal_oooh\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.2, 1.0, 0.25)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.008;\n\n        // Vocal source\n        let source = saw_ar(freq + vib) * 0.4;\n\n        // \"Oooh\" formants (lower formants)\n        let f1 = bpf_ar(source, 350.0, 0.1) * 0.5;\n        let f2 = bpf_ar(source, 700.0, 0.12) * 0.3;\n        let f3 = bpf_ar(source, 2200.0, 0.2) * 0.1;\n\n        let sig = f1 + f2 + f3;\n\n        sig * env * amp\n    });\n",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/vocal_oooh.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "vocal_operatic",
    "description": "Operatic voice",
    "genre": "Classical, Cinematic",
    "character": "Operatic voice",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Classical, Cinematic | Character: Operatic voice\ndefine_synthdef(\"vocal_operatic\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.25, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Strong vibrato\n        let vib = sin_osc_ar(6.0) * freq * 0.02;\n\n        // Rich harmonic source\n        let source = saw_ar(freq + vib) * 0.5;\n\n        // Operatic formants - strong singer's formant\n        let f1 = bpf_ar(source, 700.0, 0.1) * 0.35;\n        let f2 = bpf_ar(source, 1500.0, 0.12) * 0.3;\n        let f3 = bpf_ar(source, 2500.0, 0.15) * 0.25;\n        let singers_formant = bpf_ar(source, 3000.0, 0.1) * 0.35;\n\n        let sig = f1 + f2 + f3 + singers_formant;\n\n        sig * env * amp\n    });\n",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/vocal_operatic.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "vocal_robot",
    "description": "Robot voice effect",
    "genre": "Electronic, Experimental",
    "character": "Robot voice effect",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Electronic, Experimental | Character: Robot voice effect\ndefine_synthdef(\"vocal_robot\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.01)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Metallic carrier\n        let carrier = pulse_ar(freq, 0.5) * 0.3;\n\n        // Ring modulation for robot effect\n        let ring_freq = 200.0;\n        let ring = carrier * sin_osc_ar(ring_freq);\n\n        // Formant-like filtering\n        let f1 = bpf_ar(ring, 800.0, 0.2) * 0.5;\n        let f2 = bpf_ar(ring, 2000.0, 0.25) * 0.35;\n\n        let sig = f1 + f2;\n\n        sig * env * amp\n    });\n",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/vocal_robot.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "voice_drone",
    "description": "Dark, evolving voice-like drone with slow modulation.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "darkness",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"voice_drone\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"darkness\", 0.5) // Filter darkness\n        .body(|freq, amp, gate, darkness| {\n            // Very slow attack for drone\n            let env = envelope()\n                .asr(2.0, 1.0, 1.0)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep oscillator base\n            let osc1 = saw_ar(freq);\n            let osc2 = saw_ar(freq * 0.998);\n            let sub = sin_osc_ar(freq * 0.5) * 0.4;\n\n            let source = (osc1 + osc2) * 0.5 + sub;\n\n            // Slow modulating formant\n            let mod_speed = 0.1;\n            let formant_mod = sin_osc_ar(mod_speed) * 0.5 + 0.5;\n            let formant_freq = 300.0 + formant_mod * 400.0;\n\n            // Apply formant with modulation\n            let formant = rlpf_ar(source, formant_freq, 0.2);\n\n            // Darkness control\n            let cutoff = 2000.0 - darkness * 1500.0;\n            let dark = lpf_ar(formant, cutoff);\n\n            // Add breath noise\n            let breath_mod = sin_osc_ar(0.15) * 0.5 + 0.5;\n            let breath = white_noise_ar() * 0.02 * breath_mod;\n            let breath_filtered = lpf_ar(hpf_ar(breath, 1000.0), 4000.0);\n\n            (dark + breath_filtered) * env * amp\n        })\n});",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/voice_drone.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "whisper",
    "description": "Creates whisper-like textures with filtered noise.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "breathiness",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"whisper\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .param(\"breathiness\", 0.7) // Noise amount\n        .body(|freq, amp, gate, breathiness| {\n            // Soft envelope\n            let env = envelope()\n                .asr(0.1, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Mostly noise with hint of pitch\n            let noise = white_noise_ar();\n            let pitched = sin_osc_ar(freq) * 0.2;\n\n            // Formant filtering on noise for whisper character\n            let whisper_band1 = rlpf_ar(noise, freq * 2.0, 0.2);\n            let whisper_band2 = rlpf_ar(noise, freq * 4.0, 0.15) * 0.5;\n\n            let whisper = whisper_band1 + whisper_band2;\n\n            // Mix pitched and noise based on breathiness\n            let mix = pitched * (1.0 - breathiness) + whisper * breathiness;\n\n            // Shape the output\n            let shaped = lpf_ar(mix, 6000.0);\n\n            shaped * env * amp\n        })\n});",
    "category": "vocals",
    "subcategory": "",
    "path": "vocals/whisper.vibe",
    "categoryName": "Vocals"
  },
  {
    "name": "bassoon",
    "description": "The bassoon with its distinctive dark, reedy tone.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bassoon\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.06, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.0) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Complex harmonic structure\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.25;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.15;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Reed buzz\n            let reed = white_noise_ar() * 0.01;\n            let reed_filtered = lpf_ar(hpf_ar(reed, 800.0), 2500.0);\n\n            // Dark body resonance\n            let body = rlpf_ar(tone + reed_filtered, 1500.0, 0.3);\n\n            body * env * amp * 0.6\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/bassoon.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "contrabassoon",
    "description": "Contrabassoon",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"contrabassoon\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.1, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slow vibrato\n            let vib = sin_osc_ar(4.0) * 0.003 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Very dark harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.4;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.15;\n\n            let tone = h1 + h2 + h3 + h4 + h5;\n\n            // Very dark filtering\n            let body = lpf_ar(tone, 1200.0);\n\n            body * env * amp * 0.7\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/bassoon.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "clarinet",
    "description": "and bright upper register.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clarinet\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.0) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Clarinet has strong odd harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.6;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.3;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.15;\n            let h9 = sin_osc_ar(mod_freq * 9.0) * 0.08;\n\n            let tone = h1 + h3 + h5 + h7 + h9;\n\n            // Reed buzz (very subtle)\n            let reed_env = envelope()\n                .asr(0.01, 1.0, 0.05)\n                .gate(gate)\n                .build();\n            let reed = white_noise_ar() * reed_env * 0.02;\n            let reed_filtered = lpf_ar(hpf_ar(reed, 1000.0), 4000.0);\n\n            // Body resonance\n            let body = rlpf_ar(tone + reed_filtered, 2500.0, 0.35);\n\n            body * env * amp * 0.6\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/clarinet.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "bass_clarinet",
    "description": "Bass Clarinet",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 220
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bass_clarinet\", |builder| {\n    builder\n        .param(\"freq\", 220.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slow vibrato\n            let vib = sin_osc_ar(4.5) * 0.003 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Dark odd harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.25;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.1;\n\n            let tone = h1 + h3 + h5 + h7;\n\n            // Warm filtering\n            let body = lpf_ar(tone, 2000.0);\n\n            body * env * amp * 0.7\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/clarinet.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "flute",
    "description": "pure, silvery tone and breathy character.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 880
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "breath",
        "default": 0.3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"flute\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"breath\", 0.3)\n        .body(|freq, amp, gate, breath| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.5) * 0.006 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Pure tone with weak harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.2;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.05;\n\n            let tone = h1 + h2 + h3;\n\n            // Breath noise\n            let noise = white_noise_ar() * breath * 0.1;\n            let breath_filtered = lpf_ar(hpf_ar(noise, 2000.0), 8000.0);\n\n            let mix = tone + breath_filtered;\n\n            // Subtle body resonance\n            let body = rlpf_ar(mix, mod_freq * 2.0, 0.5);\n\n            body * env * amp * 0.7\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/flute.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "piccolo",
    "description": "Piccolo",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 1760
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"piccolo\", |builder| {\n    builder\n        .param(\"freq\", 1760.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(6.0) * 0.005 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Very pure, bright tone\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.15;\n\n            let tone = h1 + h2;\n\n            // Light breath\n            let noise = white_noise_ar() * 0.03;\n            let breath = hpf_ar(noise, 4000.0);\n\n            (tone + breath) * env * amp * 0.6\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/flute.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "oboe",
    "description": "and expressive vibrato.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"oboe\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.5) * 0.006 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Rich harmonic content\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.35;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.2;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.12;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Nasal formant (characteristic oboe resonance)\n            let nasal = rlpf_ar(tone, 1500.0, 0.25);\n            let bright = rlpf_ar(tone, 3500.0, 0.3) * 0.4;\n\n            let body = nasal + bright;\n\n            body * env * amp * 0.5\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/oboe.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "alto_sax",
    "description": "Alto Saxophone",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "growl",
        "default": "0.0"
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"alto_sax\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"growl\", 0.0) // Growl/subtone amount\n        .body(|freq, amp, gate, growl| {\n            let env = envelope()\n                .asr(0.03, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.5) * 0.008 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Saxophone harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.4;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.25;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.15;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.1;\n\n            let tone = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Growl (low frequency modulation)\n            let growl_mod = sin_osc_ar(30.0) * growl * 0.3 + 1.0;\n\n            // Bright sax formant\n            let body = rlpf_ar(tone * growl_mod, 2000.0, 0.3);\n            let bright = rlpf_ar(tone, 4000.0, 0.4) * 0.3;\n\n            (body + bright) * env * amp * 0.5\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/saxophone.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "tenor_sax",
    "description": "Tenor Saxophone",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 330
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tenor_sax\", |builder| {\n    builder\n        .param(\"freq\", 330.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(5.0) * 0.007 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Warmer than alto\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.55;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.12;\n\n            let tone = h1 + h2 + h3 + h4 + h5;\n\n            // Warm formant\n            let body = rlpf_ar(tone, 1800.0, 0.35);\n\n            body * env * amp * 0.6\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/saxophone.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "soprano_sax",
    "description": "Soprano Saxophone",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 660
      },
      {
        "name": "amp",
        "default": 0.4
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"soprano_sax\", |builder| {\n    builder\n        .param(\"freq\", 660.0)\n        .param(\"amp\", 0.4)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Vibrato\n            let vib = sin_osc_ar(6.0) * 0.006 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Brighter than alto\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.35;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.2;\n\n            let tone = h1 + h2 + h3 + h4;\n\n            // Bright formant\n            let body = rlpf_ar(tone, 2500.0, 0.3);\n\n            body * env * amp * 0.6\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/saxophone.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "bari_sax",
    "description": "Baritone Saxophone",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 165
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bari_sax\", |builder| {\n    builder\n        .param(\"freq\", 165.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.06, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slow vibrato\n            let vib = sin_osc_ar(4.5) * 0.005 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Full, dark harmonics\n            let h1 = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.1;\n\n            let tone = h1 + h2 + h3 + h4 + h5;\n\n            // Deep, warm formant\n            let body = rlpf_ar(tone, 1200.0, 0.35);\n\n            body * env * amp * 0.6\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/saxophone.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "clarinet_realistic",
    "description": "Realistic Clarinet with register breaks and chalumeau character",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 261.63
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "reed_stiffness",
        "default": 0.5
      },
      {
        "name": "embouchure",
        "default": 0.5
      },
      {
        "name": "breath",
        "default": 0.3
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"clarinet_realistic\", |builder| {\n    builder\n        .param(\"freq\", 261.63)    // Middle C default\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"reed_stiffness\", 0.5)   // Softer reed = warmer\n        .param(\"embouchure\", 0.5)       // Lip pressure\n        .param(\"breath\", 0.3)           // Breath noise amount\n        .body(|freq, amp, gate, reed_stiffness, embouchure, breath| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Delayed vibrato (starts after initial attack)\n            let vib_delay = envelope()\n                .perc(0.3, 5.0)\n                .build();\n            let vib_depth = 0.004 + (embouchure * 0.003);\n            let vib = sin_osc_ar(5.5) * vib_depth * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Clarinet's cylindrical bore produces strong odd harmonics\n            // The relative strength depends on register\n            let register_factor = freq / 261.63;  // Relative to middle C\n            let odd_emphasis = 1.0 / (1.0 + (register_factor * 0.3));\n\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.65 * odd_emphasis;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.4 * odd_emphasis;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.22 * odd_emphasis;\n            let h9 = sin_osc_ar(mod_freq * 9.0) * 0.12 * odd_emphasis;\n            let h11 = sin_osc_ar(mod_freq * 11.0) * 0.06 * odd_emphasis;\n\n            // Even harmonics (weaker, add warmth)\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.15 * reed_stiffness;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.08 * reed_stiffness;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h7 + h9 + h11;\n\n            // Reed buzz/chiff on attack\n            let chiff_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let chiff = white_noise_ar() * chiff_env * reed_stiffness * 0.15;\n            let chiff_filtered = bpf_ar(chiff, mod_freq * 3.0, 0.3);\n\n            // Continuous breath noise\n            let breath_noise = white_noise_ar() * breath * 0.08;\n            let breath_filtered = bpf_ar(breath_noise, mod_freq * 2.5, 0.5);\n\n            // Bore resonance formants\n            let f1 = rlpf_ar(harmonics, 1500.0, 0.4) * 0.7;\n            let f2 = rlpf_ar(harmonics, 2800.0, 0.35) * 0.3;\n\n            // Bell flare effect (brightens low notes)\n            let bell_effect = rlpf_ar(harmonics, 4000.0, 0.5) * 0.15 * (1.0 / register_factor);\n\n            let tone = f1 + f2 + bell_effect + chiff_filtered + breath_filtered;\n\n            // Remove subsonic content\n            let clean = hpf_ar(tone, 80.0);\n\n            clean * env * amp * 0.55\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/woodwinds_realistic.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "alto_sax_realistic",
    "description": "Realistic Alto Saxophone with growl and subtone capabilities",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 370
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "embouchure",
        "default": 0.5
      },
      {
        "name": "growl",
        "default": "0.0"
      },
      {
        "name": "subtone",
        "default": "0.0"
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"alto_sax_realistic\", |builder| {\n    builder\n        .param(\"freq\", 370.0)     // F#4 - comfortable alto range\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"embouchure\", 0.5)    // Affects timbre brightness\n        .param(\"growl\", 0.0)         // Throat growl amount\n        .param(\"subtone\", 0.0)       // Airy subtone amount\n        .body(|freq, amp, gate, embouchure, growl, subtone| {\n            let env = envelope()\n                .asr(0.025, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Jazz vibrato - wider and more expressive\n            let vib_delay = envelope()\n                .perc(0.2, 4.0)\n                .build();\n            let vib_depth = 0.006 + (embouchure * 0.004);\n            let vib_rate = 5.0 + (embouchure * 1.0);\n            let vib = sin_osc_ar(vib_rate) * vib_depth * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Saxophone's conical bore - full harmonic series\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.45;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.3;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.2;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.14;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.09;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.05;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Growl effect - vocal fold modulation\n            let growl_freq = 25.0 + (embouchure * 10.0);\n            let growl_mod = sin_osc_ar(growl_freq) * growl * 0.35 + 1.0;\n\n            // Subtone - breathy, airy quality\n            let sub_noise = pink_noise_ar() * subtone * 0.25;\n            let sub_filtered = bpf_ar(sub_noise, mod_freq, 0.3);\n\n            // Reed attack transient\n            let attack_env = envelope()\n                .perc(0.001, 0.015)\n                .build();\n            let attack_noise = white_noise_ar() * attack_env * 0.12;\n            let attack_filtered = bpf_ar(attack_noise, mod_freq * 4.0, 0.4);\n\n            // Sax body formants (characteristic of alto)\n            let f1 = rlpf_ar(harmonics * growl_mod, 650.0, 0.4) * 0.4;  // Low resonance\n            let f2 = rlpf_ar(harmonics * growl_mod, 1400.0, 0.35) * 0.35;  // Mid\n            let f3 = rlpf_ar(harmonics * growl_mod, 2800.0, 0.3) * 0.25 * embouchure;  // High brightness\n\n            // Bell resonance\n            let bell = rlpf_ar(harmonics, 4200.0, 0.5) * 0.12;\n\n            let tone = f1 + f2 + f3 + bell + sub_filtered + attack_filtered;\n\n            hpf_ar(tone, 100.0) * env * amp * 0.5\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/woodwinds_realistic.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "tenor_sax_realistic",
    "description": "warmer, bigger sound",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 277.18
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "warmth",
        "default": 0.6
      },
      {
        "name": "growl",
        "default": "0.0"
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tenor_sax_realistic\", |builder| {\n    builder\n        .param(\"freq\", 277.18)   // C#4\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"warmth\", 0.6)\n        .param(\"growl\", 0.0)\n        .body(|freq, amp, gate, warmth, growl| {\n            let env = envelope()\n                .asr(0.035, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slower, wider vibrato for tenor\n            let vib_delay = envelope()\n                .perc(0.25, 4.0)\n                .build();\n            let vib = sin_osc_ar(4.8) * 0.007 * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Richer harmonics for bigger sound\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.42;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.28;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.18;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.12;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.07;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Growl\n            let growl_mod = sin_osc_ar(22.0) * growl * 0.35 + 1.0;\n\n            // Tenor formants - lower than alto\n            let f1 = rlpf_ar(harmonics * growl_mod, 550.0, 0.4) * 0.45;\n            let f2 = rlpf_ar(harmonics * growl_mod, 1200.0, 0.35) * 0.35;\n            let f3 = rlpf_ar(harmonics * growl_mod, 2400.0, 0.35) * 0.2 * (1.0 - warmth * 0.5);\n\n            // Warmth control - adds low-mid body\n            let warm_res = rlpf_ar(harmonics, 400.0, 0.5) * warmth * 0.25;\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.001, 0.018)\n                .build();\n            let attack = bpf_ar(white_noise_ar() * attack_env * 0.1, mod_freq * 3.0, 0.4);\n\n            let tone = f1 + f2 + f3 + warm_res + attack;\n\n            hpf_ar(tone, 80.0) * env * amp * 0.55\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/woodwinds_realistic.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "flute_realistic",
    "description": "Realistic Flute with air jet modeling",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 523.25
      },
      {
        "name": "amp",
        "default": 0.55
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "breath",
        "default": 0.35
      },
      {
        "name": "air_speed",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"flute_realistic\", |builder| {\n    builder\n        .param(\"freq\", 523.25)   // C5\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .param(\"breath\", 0.35)      // Breath noise amount\n        .param(\"air_speed\", 0.5)    // Embouchure tightness\n        .body(|freq, amp, gate, breath, air_speed| {\n            let env = envelope()\n                .asr(0.06, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Flute vibrato - gentle, sine-like\n            let vib_delay = envelope()\n                .perc(0.4, 5.0)\n                .build();\n            let vib = sin_osc_ar(5.8) * 0.005 * vib_delay + 1.0;\n            let mod_freq = freq * vib;\n\n            // Flute has weak harmonics - mostly fundamental\n            // Higher air speed = more harmonics (brighter)\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.25 * air_speed;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.1 * air_speed;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.04 * air_speed;\n\n            let harmonics = h1 + h2 + h3 + h4;\n\n            // Air jet noise - characteristic of flute\n            let jet_noise = white_noise_ar() * breath;\n            let jet_filtered = bpf_ar(jet_noise, mod_freq * 2.0, 0.4) * 0.3;\n\n            // Edge tone noise (the hiss)\n            let edge_noise = hpf_ar(white_noise_ar() * breath * 0.15, 4000.0);\n\n            // Attack breath burst\n            let attack_env = envelope()\n                .perc(0.005, 0.04)\n                .build();\n            let attack_breath = white_noise_ar() * attack_env * breath * 0.4;\n            let attack_filtered = lpf_ar(attack_breath, 6000.0);\n\n            // Tube resonance\n            let resonance = rlpf_ar(harmonics, mod_freq * 2.0, 0.6) * 0.2;\n\n            let tone = harmonics + jet_filtered + edge_noise + attack_filtered + resonance;\n\n            // Clean, silvery character\n            let clean = lpf_ar(hpf_ar(tone, 150.0), 12000.0);\n\n            clean * env * amp * 0.55\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/woodwinds_realistic.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "oboe_realistic",
    "description": "nasal, penetrating",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.55
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "reed_pressure",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"oboe_realistic\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .param(\"reed_pressure\", 0.6)\n        .body(|freq, amp, gate, reed_pressure| {\n            let env = envelope()\n                .asr(0.03, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Oboe vibrato - subtle\n            let vib = sin_osc_ar(5.5) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Oboe has ALL harmonics, creating nasal quality\n            // Double reed produces rich spectrum\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.7;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.55;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.4;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.3;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.22;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.16;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.11;\n            let h9 = sin_osc_ar(mod_freq * 9.0) * 0.07;\n            let h10 = sin_osc_ar(mod_freq * 10.0) * 0.04;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8 + h9 + h10;\n\n            // Double reed \"crow\" on attack\n            let crow_env = envelope()\n                .perc(0.001, 0.01)\n                .build();\n            let crow = white_noise_ar() * crow_env * reed_pressure * 0.15;\n            let crow_filtered = bpf_ar(crow, mod_freq * 5.0, 0.3);\n\n            // Nasal formants characteristic of oboe\n            let f1 = rlpf_ar(harmonics, 1400.0, 0.25) * 0.4;  // Nasal peak\n            let f2 = rlpf_ar(harmonics, 2800.0, 0.3) * 0.35;\n            let f3 = rlpf_ar(harmonics, 4200.0, 0.35) * 0.25 * reed_pressure;\n\n            let tone = f1 + f2 + f3 + crow_filtered;\n\n            hpf_ar(tone, 200.0) * env * amp * 0.5\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/woodwinds_realistic.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "english_horn",
    "description": "deeper, more melancholic",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 311.13
      },
      {
        "name": "amp",
        "default": 0.55
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"english_horn\", |builder| {\n    builder\n        .param(\"freq\", 311.13)   // Eb4\n        .param(\"amp\", 0.55)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.04, 1.0, 0.1)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Gentle vibrato\n            let vib = sin_osc_ar(5.0) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Similar to oboe but darker\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.45;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.32;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.22;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.15;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.1;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7;\n\n            // Lower, darker formants\n            let f1 = rlpf_ar(harmonics, 1100.0, 0.3) * 0.45;\n            let f2 = rlpf_ar(harmonics, 2200.0, 0.35) * 0.35;\n            let f3 = rlpf_ar(harmonics, 3500.0, 0.4) * 0.2;\n\n            let tone = f1 + f2 + f3;\n\n            hpf_ar(tone, 150.0) * env * amp * 0.55\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/woodwinds_realistic.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "bassoon_realistic",
    "description": "rich, woody bass woodwind",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 130.81
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "reed_buzz",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"bassoon_realistic\", |builder| {\n    builder\n        .param(\"freq\", 130.81)   // C3\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .param(\"reed_buzz\", 0.4)\n        .body(|freq, amp, gate, reed_buzz| {\n            let env = envelope()\n                .asr(0.05, 1.0, 0.12)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Slow vibrato\n            let vib = sin_osc_ar(4.5) * 0.003 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Bassoon has rich harmonic spectrum\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.65;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.5;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.38;\n            let h5 = sin_osc_ar(mod_freq * 5.0) * 0.28;\n            let h6 = sin_osc_ar(mod_freq * 6.0) * 0.2;\n            let h7 = sin_osc_ar(mod_freq * 7.0) * 0.14;\n            let h8 = sin_osc_ar(mod_freq * 8.0) * 0.09;\n\n            let harmonics = h1 + h2 + h3 + h4 + h5 + h6 + h7 + h8;\n\n            // Reed buzz character\n            let buzz = white_noise_ar() * reed_buzz * 0.04;\n            let buzz_filtered = bpf_ar(buzz, mod_freq * 4.0, 0.4);\n\n            // Attack\n            let attack_env = envelope()\n                .perc(0.001, 0.025)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.08;\n\n            // Wooden body formants\n            let f1 = rlpf_ar(harmonics, 440.0, 0.4) * 0.4;\n            let f2 = rlpf_ar(harmonics, 1200.0, 0.35) * 0.35;\n            let f3 = rlpf_ar(harmonics, 2200.0, 0.35) * 0.25;\n\n            let tone = f1 + f2 + f3 + buzz_filtered + attack;\n\n            hpf_ar(tone, 60.0) * env * amp * 0.55\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/woodwinds_realistic.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "recorder",
    "description": "Medieval/Renaissance woodwind",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 523.25
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "breath",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"recorder\", |builder| {\n    builder\n        .param(\"freq\", 523.25)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"breath\", 0.4)\n        .body(|freq, amp, gate, breath| {\n            let env = envelope()\n                .asr(0.02, 1.0, 0.08)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Simple vibrato\n            let vib = sin_osc_ar(5.5) * 0.004 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Recorder - fairly pure with some harmonics\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.35;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.15;\n            let h4 = sin_osc_ar(mod_freq * 4.0) * 0.06;\n\n            let harmonics = h1 + h2 + h3 + h4;\n\n            // Breathy attack and sustain\n            let breath_noise = white_noise_ar() * breath * 0.12;\n            let breath_filtered = bpf_ar(breath_noise, mod_freq * 2.0, 0.5);\n\n            let tone = harmonics + breath_filtered;\n\n            hpf_ar(tone, 200.0) * env * amp * 0.55\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/woodwinds_realistic.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "pan_flute",
    "description": "breathy, ethereal",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "breath",
        "default": 0.5
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"pan_flute\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"breath\", 0.5)\n        .body(|freq, amp, gate, breath| {\n            let env = envelope()\n                .asr(0.08, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Gentle vibrato\n            let vib = sin_osc_ar(5.0) * 0.006 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Very pure - almost sine\n            let h1 = sin_osc_ar(mod_freq) * 1.0;\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.15;\n\n            let harmonics = h1 + h2;\n\n            // Lots of breath/wind noise\n            let breath_noise = white_noise_ar() * breath * 0.2;\n            let breath_filtered = lpf_ar(hpf_ar(breath_noise, 1000.0), 6000.0);\n\n            // Breathy attack\n            let attack_env = envelope()\n                .perc(0.01, 0.08)\n                .build();\n            let attack = white_noise_ar() * attack_env * breath * 0.3;\n\n            let tone = harmonics + breath_filtered + attack;\n\n            hpf_ar(tone, 150.0) * env * amp * 0.5\n        })\n});",
    "category": "woodwinds",
    "subcategory": "",
    "path": "woodwinds/woodwinds_realistic.vibe",
    "categoryName": "Woodwinds"
  },
  {
    "name": "accordion",
    "description": "Accordion/melodeon",
    "genre": "Folk, Tango, Zydeco",
    "character": "Accordion/melodeon",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Folk, Tango, Zydeco | Character: Accordion/melodeon\ndefine_synthdef(\"accordion\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.03, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Reed-like tone\n        let osc1 = pulse_ar(freq, 0.4) * 0.3;\n        let osc2 = pulse_ar(freq * 1.003, 0.45) * 0.25;\n\n        // Upper harmonics\n        let harm = sin_osc_ar(freq * 2.0) * 0.15;\n\n        let mix = osc1 + osc2 + harm;\n\n        // Bellows variation\n        let bellows = sin_osc_ar(0.3) * 0.1 + 0.9;\n\n        lpf_ar(mix, 4000.0) * bellows * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/accordion.vibe",
    "categoryName": "World"
  },
  {
    "name": "bagpipe",
    "description": "Scottish bagpipe chanter",
    "genre": "Celtic, Scottish",
    "character": "Scottish bagpipe chanter",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Celtic, Scottish | Character: Scottish bagpipe chanter\ndefine_synthdef(\"bagpipe\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.05, 1.0, 0.05)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright, reedy tone\n        let body = saw_ar(freq) * 0.3;\n        let harm1 = saw_ar(freq * 2.0) * 0.2;\n        let harm2 = saw_ar(freq * 3.0) * 0.15;\n\n        // Drone (constant)\n        let drone = sin_osc_ar(freq * 0.5) * 0.2;\n\n        let mix = body + harm1 + harm2 + drone;\n\n        // Nasal filtering\n        bpf_ar(mix, 1500.0, 0.3) * 2.0 * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/bagpipe.vibe",
    "categoryName": "World"
  },
  {
    "name": "balalaika",
    "description": "Triangular stringed instrument",
    "genre": "",
    "character": "Triangular stringed instrument",
    "params": [],
    "type": "synthdef",
    "source": "// Region: Russian | Character: Triangular stringed instrument\ndefine_synthdef(\"balalaika\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Plucked string excitation\n        let pluck_env = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let exciter = lpf_ar(white_noise_ar(), 3000.0) * pluck_env * 0.8;\n\n        // Bright triangular body resonance\n        let body1 = sin_osc_ar(freq) * 0.5;\n        let body2 = sin_osc_ar(freq * 2.0) * 0.3;\n        let body3 = sin_osc_ar(freq * 3.0) * 0.15;\n        let body4 = sin_osc_ar(freq * 4.0) * 0.08;\n\n        let sig = body1 + body2 + body3 + body4 + exciter;\n\n        // Bright character\n        let filtered = hpf_ar(sig, 200.0);\n\n        filtered * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/balalaika.vibe",
    "categoryName": "World"
  },
  {
    "name": "banjo",
    "description": "Bright, twangy plucked string",
    "genre": "",
    "character": "Bright, twangy plucked string",
    "params": [],
    "type": "synthdef",
    "source": "// Region: American | Character: Bright, twangy plucked string\ndefine_synthdef(\"banjo\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.08)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright plucked excitation\n        let pluck_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let exciter = hpf_ar(white_noise_ar(), 2000.0) * pluck_env * 0.5;\n\n        // Bright string resonance\n        let str1 = pulse_ar(freq, 0.4) * 0.4;\n        let str2 = sin_osc_ar(freq * 2.0) * 0.25;\n        let str3 = sin_osc_ar(freq * 3.0) * 0.15;\n        let str4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n        let sig = str1 + str2 + str3 + str4 + exciter;\n\n        // Drum head resonance - characteristic twang\n        let drum_res = bpf_ar(sig, 800.0, 0.2) * 0.4;\n        let output = sig + drum_res;\n\n        // Bright, cutting through\n        let filtered = hpf_ar(output, 300.0);\n\n        filtered * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/banjo.vibe",
    "categoryName": "World"
  },
  {
    "name": "bouzouki",
    "description": "Long-necked lute with metallic tone",
    "genre": "",
    "character": "Long-necked lute with metallic tone",
    "params": [],
    "type": "synthdef",
    "source": "// Region: Greek | Character: Long-necked lute with metallic tone\ndefine_synthdef(\"bouzouki\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Double string courses - slight detuning\n        let detune = 1.003;\n        let str1 = saw_ar(freq) * 0.3;\n        let str2 = saw_ar(freq * detune) * 0.3;\n\n        // Metallic overtones\n        let metal1 = sin_osc_ar(freq * 2.0) * 0.2;\n        let metal2 = sin_osc_ar(freq * 3.0) * 0.12;\n        let metal3 = sin_osc_ar(freq * 5.0) * 0.05;\n\n        let sig = str1 + str2 + metal1 + metal2 + metal3;\n\n        // Resonant metallic filter\n        let filtered = bpf_ar(sig, 2000.0, 0.3) + sig * 0.5;\n\n        filtered * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/bouzouki.vibe",
    "categoryName": "World"
  },
  {
    "name": "darbuka",
    "description": "Darbuka/doumbek hand drum",
    "genre": "Middle Eastern, Arabic",
    "character": "Darbuka/doumbek hand drum",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Middle Eastern, Arabic | Character: Darbuka/doumbek hand drum\ndefine_synthdef(\"darbuka\")\n    .param(\"freq\", 200.0)\n    .param(\"amp\", 0.8)\n    .param(\"type\", 0.0) // 0=doum, 0.5=tek, 1.0=ka\n    .body(|freq, amp, type_param| {\n        // Decay based on type\n        let decay = 0.3 - type_param * 0.2;\n        let amp_env = envelope()\n            .perc(0.001, 1.0)\n            .time_scale(decay)\n            .cleanup_on_finish()\n            .build();\n\n        // Pitch based on type\n        let pitch = freq * (1.0 + type_param * 2.0);\n\n        // Pitch envelope\n        let pitch_env = envelope()\n            .perc(0.001, 0.02)\n            .build();\n\n        // Body\n        let body = sin_osc_ar(pitch + pitch_env * pitch * (1.0 - type_param)) * (1.0 - type_param * 0.5);\n\n        // High slap for tek/ka\n        let slap = hpf_ar(white_noise_ar(), 3000.0 + type_param * 3000.0) * type_param * 0.4;\n\n        // Attack\n        let attack_env = envelope()\n            .perc(0.0001, 0.005)\n            .build();\n        let attack = white_noise_ar() * attack_env * 0.2;\n\n        (body + slap + attack) * amp_env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/darbuka.vibe",
    "categoryName": "World"
  },
  {
    "name": "didgeridoo",
    "description": "Deep drone instrument",
    "genre": "",
    "character": "Deep drone instrument",
    "params": [],
    "type": "synthdef",
    "source": "// Region: Australian | Character: Deep drone instrument\ndefine_synthdef(\"didgeridoo\")\n    .param(\"freq\", 55.0)\n    .param(\"amp\", 0.6)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Fundamental drone\n        let fundamental = saw_ar(freq) * 0.4;\n\n        // Overtones with slight variations\n        let lfo = sin_osc_ar(0.3) * 1.5;\n        let ot1 = saw_ar(freq * 2.0 + lfo) * 0.2;\n        let ot2 = pulse_ar(freq * 3.0, 0.3) * 0.1;\n\n        // Breath noise\n        let breath = lpf_ar(pink_noise_ar(), 300.0) * 0.15;\n\n        let sig = fundamental + ot1 + ot2 + breath;\n\n        // Resonant filter for tubular character\n        let filtered = rlpf_ar(sig, 200.0, 0.3);\n\n        filtered * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/didgeridoo.vibe",
    "categoryName": "World"
  },
  {
    "name": "djembe_bass",
    "description": "Djembe Bass (center hit)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 80
      },
      {
        "name": "amp",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"djembe_bass\", |builder| {\n    builder\n        .param(\"freq\", 80.0)\n        .param(\"amp\", 0.7)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.35)\n                .cleanup_on_finish()\n                .build();\n\n            // Deep body tone\n            let body = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.3;\n\n            let tone = body + h2;\n\n            // Soft attack\n            let attack_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.1;\n\n            (tone + lpf_ar(attack, 800.0)) * env * amp\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/djembe.vibe",
    "categoryName": "World"
  },
  {
    "name": "djembe_tone",
    "description": "Djembe Tone (edge hit)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 200
      },
      {
        "name": "amp",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"djembe_tone\", |builder| {\n    builder\n        .param(\"freq\", 200.0)\n        .param(\"amp\", 0.6)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.2)\n                .cleanup_on_finish()\n                .build();\n\n            // Mid-range tone\n            let tone = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.2) * 0.35; // Slightly inharmonic\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n\n            let mix = tone + h2 + h3;\n\n            // Edge attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.015)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.15;\n\n            (mix + hpf_ar(attack, 1500.0)) * env * amp\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/djembe.vibe",
    "categoryName": "World"
  },
  {
    "name": "djembe_slap",
    "description": "Djembe Slap (sharp rim hit)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 400
      },
      {
        "name": "amp",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"djembe_slap\", |builder| {\n    builder\n        .param(\"freq\", 400.0)\n        .param(\"amp\", 0.6)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.0001, 0.1)\n                .cleanup_on_finish()\n                .build();\n\n            // Sharp high tone\n            let tone = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n\n            let mix = tone + h2;\n\n            // Sharp attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.3;\n\n            (mix + hpf_ar(attack, 3000.0)) * env * amp\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/djembe.vibe",
    "categoryName": "World"
  },
  {
    "name": "erhu",
    "description": "Erhu - Chinese bowed string",
    "genre": "Chinese Traditional",
    "character": "Erhu - Chinese bowed string",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Chinese Traditional | Character: Erhu - Chinese bowed string\ndefine_synthdef(\"erhu\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.08, 1.0, 0.12)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Expressive vibrato\n        let vib = sin_osc_ar(6.0) * freq * 0.015;\n\n        // Bowed string harmonics\n        let h1 = sin_osc_ar(freq + vib) * 0.4;\n        let h2 = sin_osc_ar((freq + vib) * 2.0) * 0.25;\n        let h3 = sin_osc_ar((freq + vib) * 3.0) * 0.15;\n        let h4 = sin_osc_ar((freq + vib) * 4.0) * 0.08;\n\n        // Bow noise\n        let bow = bpf_ar(pink_noise_ar(), 2500.0, 0.5) * 0.1;\n\n        let sig = h1 + h2 + h3 + h4 + bow;\n\n        lpf_ar(sig, 5000.0) * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/erhu.vibe",
    "categoryName": "World"
  },
  {
    "name": "gamelan_gong",
    "description": "Gamelan Gong",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 110
      },
      {
        "name": "amp",
        "default": 0.6
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"gamelan_gong\", |builder| {\n    builder\n        .param(\"freq\", 110.0)\n        .param(\"amp\", 0.6)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.5)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Very long decay for gong\n            let decay_env = envelope()\n                .perc(0.001, 4.0)\n                .build();\n\n            // Complex inharmonic partials\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.3) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.1) * 0.35;\n            let h4 = sin_osc_ar(freq * 4.7) * 0.25;\n            let h5 = sin_osc_ar(freq * 6.2) * 0.15;\n\n            let gong = h1 + h2 + h3 + h4 + h5;\n\n            // Strike\n            let strike_env = envelope()\n                .perc(0.0001, 0.05)\n                .build();\n            let strike = white_noise_ar() * strike_env * 0.15;\n\n            (gong + lpf_ar(strike, 2000.0)) * env * decay_env * amp * 0.5\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/gamelan.vibe",
    "categoryName": "World"
  },
  {
    "name": "gamelan_metal",
    "description": "Gamelan Metallophone (Saron/Gender)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"gamelan_metal\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium decay\n            let decay_env = envelope()\n                .perc(0.001, 1.5)\n                .build();\n\n            // Metallic partials\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.8) * 0.3; // Inharmonic\n            let h4 = sin_osc_ar(freq * 5.1) * 0.2;\n\n            let metal = h1 + h2 + h3 + h4;\n\n            // Mallet strike\n            let strike_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let strike = sin_osc_ar(freq * 7.0) * strike_env * 0.15;\n\n            (metal + strike) * env * decay_env * amp * 0.5\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/gamelan.vibe",
    "categoryName": "World"
  },
  {
    "name": "hang_drum",
    "description": "Handpan with bell-like, ethereal tones",
    "genre": "",
    "character": "Handpan with bell-like, ethereal tones",
    "params": [],
    "type": "synthdef",
    "source": "// Region: Swiss | Character: Handpan with bell-like, ethereal tones\ndefine_synthdef(\"hang_drum\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.8)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bell-like attack\n        let attack_env = envelope()\n            .perc(0.001, 0.1)\n            .build();\n        let attack = sin_osc_ar(freq * 4.0) * attack_env * 0.3;\n\n        // Main tone with detuned partials\n        let main = sin_osc_ar(freq) * 0.5;\n        let partial1 = sin_osc_ar(freq * 2.01) * 0.25;\n        let partial2 = sin_osc_ar(freq * 3.0) * 0.15;\n        let partial3 = sin_osc_ar(freq * 4.02) * 0.1;\n\n        // Subtle beating for ethereal quality\n        let beat = sin_osc_ar(freq * 1.002) * 0.2;\n\n        let sig = main + partial1 + partial2 + partial3 + beat + attack;\n\n        sig * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/hang_drum.vibe",
    "categoryName": "World"
  },
  {
    "name": "kalimba",
    "description": "distinctive bright, resonant tone.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 880
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"kalimba\", |builder| {\n    builder\n        .param(\"freq\", 880.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium decay\n            let decay_env = envelope()\n                .perc(0.001, 0.8)\n                .build();\n\n            // Metallic tine sound\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.5;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 5.2) * 0.15; // Slightly inharmonic\n\n            let tine = h1 + h2 + h3 + h4;\n\n            // Pluck attack\n            let pluck_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let pluck = sin_osc_ar(freq * 8.0) * pluck_env * 0.2;\n\n            // Body resonance\n            let body = rlpf_ar(tine, 2500.0, 0.3);\n\n            (body + pluck) * env * decay_env * amp * 0.6\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/kalimba.vibe",
    "categoryName": "World"
  },
  {
    "name": "kora",
    "description": "Kora - African harp-like instrument",
    "genre": "West African",
    "character": "Kora - African harp-like instrument",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: West African | Character: Kora - African harp-like instrument\ndefine_synthdef(\"kora\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.65)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.003, 1.0, 0.2)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Bright, harp-like harmonics\n        let h1 = sin_osc_ar(freq) * 0.4;\n        let h2 = sin_osc_ar(freq * 2.0) * 0.28;\n        let h3 = sin_osc_ar(freq * 3.0) * 0.18;\n        let h4 = sin_osc_ar(freq * 4.0) * 0.1;\n\n        // Pluck attack\n        let pluck = envelope()\n            .perc(0.001, 0.02)\n            .build();\n        let attack = hpf_ar(white_noise_ar(), 3000.0) * pluck * 0.15;\n\n        let sig = h1 + h2 + h3 + h4 + attack;\n\n        sig * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/kora.vibe",
    "categoryName": "World"
  },
  {
    "name": "koto",
    "description": "its distinctive bright, resonant tone.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"koto\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay for pluck\n            let decay_env = envelope()\n                .perc(0.001, 1.2)\n                .build();\n\n            // String harmonics\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.25;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.15;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.1;\n\n            let string = h1 + h2 + h3 + h4 + h5;\n\n            // Pluck attack\n            let pluck_env = envelope()\n                .perc(0.0001, 0.015)\n                .build();\n            let pluck = white_noise_ar() * pluck_env * 0.15;\n\n            // Bridge resonance\n            let body = rlpf_ar(string, 3000.0, 0.25);\n\n            (body + pluck) * env * decay_env * amp * 0.6\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/koto.vibe",
    "categoryName": "World"
  },
  {
    "name": "mbira",
    "description": "Thumb piano with buzzing resonance",
    "genre": "",
    "character": "Thumb piano with buzzing resonance",
    "params": [],
    "type": "synthdef",
    "source": "// Region: Zimbabwe | Character: Thumb piano with buzzing resonance\ndefine_synthdef(\"mbira\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.3)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Metal tine pluck\n        let pluck_env = envelope()\n            .perc(0.001, 0.05)\n            .build();\n        let exciter = hpf_ar(white_noise_ar(), 3000.0) * pluck_env * 0.4;\n\n        // Main tone with inharmonic partials\n        let main = sin_osc_ar(freq) * 0.45;\n        let partial1 = sin_osc_ar(freq * 2.3) * 0.2;\n        let partial2 = sin_osc_ar(freq * 3.7) * 0.12;\n        let partial3 = sin_osc_ar(freq * 5.1) * 0.08;\n\n        // Characteristic buzz/rattle\n        let buzz = pulse_ar(freq * 0.5, 0.1) * 0.05;\n\n        let sig = main + partial1 + partial2 + partial3 + buzz + exciter;\n\n        sig * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/mbira.vibe",
    "categoryName": "World"
  },
  {
    "name": "ney",
    "description": "Ney flute - breathy and haunting",
    "genre": "Middle Eastern, Sufi",
    "character": "Ney flute - breathy and haunting",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Middle Eastern, Sufi | Character: Ney flute - breathy and haunting\ndefine_synthdef(\"ney\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.1, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Vibrato\n        let vib = sin_osc_ar(5.5) * freq * 0.012;\n\n        // Main tone with breath\n        let body = sin_osc_ar(freq + vib) * 0.5;\n        let harm = sin_osc_ar((freq + vib) * 2.0) * 0.15;\n\n        // Breath component\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.5, 0.6) * 0.25;\n\n        let sig = body + harm + breath;\n\n        sig * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/ney.vibe",
    "categoryName": "World"
  },
  {
    "name": "oud",
    "description": "Arabic oud - warm, plucked string",
    "genre": "Middle Eastern, Arabic",
    "character": "Arabic oud - warm, plucked string",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Middle Eastern, Arabic | Character: Arabic oud - warm, plucked string\ndefine_synthdef(\"oud\")\n    .param(\"freq\", 220.0)\n    .param(\"amp\", 0.7)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.005, 1.0, 0.15)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Rich harmonics from plucked string\n        let h1 = sin_osc_ar(freq) * 0.4;\n        let h2 = sin_osc_ar(freq * 2.0) * 0.25;\n        let h3 = sin_osc_ar(freq * 3.0) * 0.15;\n        let h4 = sin_osc_ar(freq * 4.0) * 0.08;\n        let h5 = sin_osc_ar(freq * 5.0) * 0.04;\n\n        // Pluck attack\n        let pluck = envelope()\n            .perc(0.001, 0.03)\n            .build();\n        let attack = bpf_ar(white_noise_ar(), 1500.0, 0.5) * pluck * 0.2;\n\n        let sig = h1 + h2 + h3 + h4 + h5 + attack;\n\n        lpf_ar(sig, 4000.0) * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/oud.vibe",
    "categoryName": "World"
  },
  {
    "name": "santoor",
    "description": "Hammered dulcimer with shimmering tone",
    "genre": "",
    "character": "Hammered dulcimer with shimmering tone",
    "params": [],
    "type": "synthdef",
    "source": "// Region: Persian/Indian | Character: Hammered dulcimer with shimmering tone\ndefine_synthdef(\"santoor\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.55)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.4)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Hammer strike\n        let strike_env = envelope()\n            .perc(0.001, 0.01)\n            .build();\n        let strike = hpf_ar(white_noise_ar(), 4000.0) * strike_env * 0.3;\n\n        // Multiple courses - slight detuning for shimmer\n        let str1 = sin_osc_ar(freq) * 0.35;\n        let str2 = sin_osc_ar(freq * 1.002) * 0.35;\n        let str3 = sin_osc_ar(freq * 0.998) * 0.35;\n\n        // Bright harmonics\n        let harm1 = sin_osc_ar(freq * 2.0) * 0.2;\n        let harm2 = sin_osc_ar(freq * 3.0) * 0.1;\n\n        let sig = str1 + str2 + str3 + harm1 + harm2 + strike;\n\n        sig * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/santoor.vibe",
    "categoryName": "World"
  },
  {
    "name": "shakuhachi",
    "description": "distinctive breathy, meditative sound.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "breath",
        "default": 0.4
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"shakuhachi\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"breath\", 0.4) // Breath noise amount\n        .body(|freq, amp, gate, breath| {\n            let env = envelope()\n                .asr(0.15, 1.0, 0.2)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Gentle vibrato\n            let vib = sin_osc_ar(5.0) * 0.008 + 1.0;\n            let mod_freq = freq * vib;\n\n            // Breathy tone\n            let tone = sin_osc_ar(mod_freq);\n            let h2 = sin_osc_ar(mod_freq * 2.0) * 0.3;\n            let h3 = sin_osc_ar(mod_freq * 3.0) * 0.1;\n\n            let flute = tone + h2 + h3;\n\n            // Breath noise\n            let noise = white_noise_ar() * breath * 0.15;\n            let breath_filtered = lpf_ar(hpf_ar(noise, 1000.0), 5000.0);\n\n            let mix = flute + breath_filtered;\n\n            // Body resonance\n            let body = rlpf_ar(mix, mod_freq * 2.0, 0.4);\n\n            body * env * amp * 0.7\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/shakuhachi.vibe",
    "categoryName": "World"
  },
  {
    "name": "sitar",
    "description": "buzzing resonance and sympathetic string harmonics.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      },
      {
        "name": "buzz",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"sitar\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .param(\"buzz\", 0.6) // Buzz/Jivari amount\n        .body(|freq, amp, gate, buzz| {\n            let env = envelope()\n                .asr(0.01, 1.0, 0.3)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Decay envelope for pluck\n            let decay_env = envelope()\n                .perc(0.001, 1.5)\n                .build();\n\n            // Main string\n            let fundamental = sin_osc_ar(freq);\n\n            // Harmonics (characteristic of sitar)\n            let h2 = sin_osc_ar(freq * 2.0) * 0.4;\n            let h3 = sin_osc_ar(freq * 3.0) * 0.3;\n            let h4 = sin_osc_ar(freq * 4.0) * 0.2;\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n\n            // Sympathetic strings (slightly detuned)\n            let symp1 = sin_osc_ar(freq * 2.01) * 0.1;\n            let symp2 = sin_osc_ar(freq * 3.02) * 0.08;\n\n            let strings = fundamental + h2 + h3 + h4 + h5 + symp1 + symp2;\n\n            // Buzz/Jivari effect (adds characteristic sitar buzz)\n            let buzz_osc = sin_osc_ar(freq * 0.5) * buzz * 0.1;\n            let buzzy = strings + buzz_osc;\n\n            // Resonant filtering for body\n            let body = rlpf_ar(buzzy, 2000.0, 0.3);\n\n            body * env * decay_env * amp * 0.6\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/sitar.vibe",
    "categoryName": "World"
  },
  {
    "name": "steel_drum",
    "description": "bright, metallic tone.",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 440
      },
      {
        "name": "amp",
        "default": 0.5
      },
      {
        "name": "gate",
        "default": 1
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"steel_drum\", |builder| {\n    builder\n        .param(\"freq\", 440.0)\n        .param(\"amp\", 0.5)\n        .param(\"gate\", 1.0)\n        .body(|freq, amp, gate| {\n            let env = envelope()\n                .asr(0.001, 1.0, 0.15)\n                .gate(gate)\n                .cleanup_on_finish()\n                .build();\n\n            // Medium decay\n            let decay_env = envelope()\n                .perc(0.001, 0.6)\n                .build();\n\n            // Metallic partials (slightly inharmonic for steel character)\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.0) * 0.6;\n            let h3 = sin_osc_ar(freq * 2.95) * 0.4; // Slightly flat\n            let h4 = sin_osc_ar(freq * 4.05) * 0.25; // Slightly sharp\n            let h5 = sin_osc_ar(freq * 5.0) * 0.15;\n            let h6 = sin_osc_ar(freq * 6.1) * 0.1;\n\n            let metal = h1 + h2 + h3 + h4 + h5 + h6;\n\n            // Mallet attack\n            let attack_env = envelope()\n                .perc(0.0001, 0.02)\n                .build();\n            let attack = sin_osc_ar(freq * 6.0) * attack_env * 0.2;\n\n            (metal + attack) * env * decay_env * amp * 0.5\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/steel_drum.vibe",
    "categoryName": "World"
  },
  {
    "name": "tabla_bayan",
    "description": "Tabla Bayan (bass drum)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 80
      },
      {
        "name": "amp",
        "default": 0.7
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tabla_bayan\", |builder| {\n    builder\n        .param(\"freq\", 80.0)\n        .param(\"amp\", 0.7)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.4)\n                .cleanup_on_finish()\n                .build();\n\n            // Pitch bend envelope\n            let pitch_env = envelope()\n                .perc(0.001, 0.1)\n                .build();\n            let freq_mod = freq + pitch_env * freq * 0.5;\n\n            // Body tone\n            let body = sin_osc_ar(freq_mod);\n            let h2 = sin_osc_ar(freq_mod * 2.0) * 0.3;\n\n            // Membrane sound\n            let membrane = body + h2;\n\n            // Add some thump\n            let thump_env = envelope()\n                .perc(0.001, 0.02)\n                .build();\n            let thump = white_noise_ar() * thump_env * 0.2;\n\n            (membrane + lpf_ar(thump, 500.0)) * env * amp\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/tabla.vibe",
    "categoryName": "World"
  },
  {
    "name": "tabla_dayan",
    "description": "Tabla Dayan (treble drum)",
    "genre": "",
    "character": "",
    "params": [
      {
        "name": "freq",
        "default": 300
      },
      {
        "name": "amp",
        "default": 0.6
      }
    ],
    "type": "synthdef",
    "source": "define_synthdef(\"tabla_dayan\", |builder| {\n    builder\n        .param(\"freq\", 300.0)\n        .param(\"amp\", 0.6)\n        .body(|freq, amp| {\n            let env = envelope()\n                .perc(0.001, 0.25)\n                .cleanup_on_finish()\n                .build();\n\n            // Characteristic tabla pitch\n            let h1 = sin_osc_ar(freq);\n            let h2 = sin_osc_ar(freq * 2.14) * 0.4; // Slightly inharmonic\n            let h3 = sin_osc_ar(freq * 3.0) * 0.2;\n\n            let tone = h1 + h2 + h3;\n\n            // Attack transient\n            let attack_env = envelope()\n                .perc(0.0001, 0.01)\n                .build();\n            let attack = white_noise_ar() * attack_env * 0.15;\n\n            (tone + hpf_ar(attack, 2000.0)) * env * amp\n        })\n});",
    "category": "world",
    "subcategory": "",
    "path": "world/tabla.vibe",
    "categoryName": "World"
  },
  {
    "name": "tin_whistle",
    "description": "Irish tin whistle",
    "genre": "Celtic, Irish",
    "character": "Irish tin whistle",
    "params": [],
    "type": "synthdef",
    "source": "// Genre: Celtic, Irish | Character: Irish tin whistle\ndefine_synthdef(\"tin_whistle\")\n    .param(\"freq\", 880.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.02, 1.0, 0.05)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Light vibrato\n        let vib = sin_osc_ar(5.0) * freq * 0.008;\n\n        // Pure tone with slight harmonics\n        let body = sin_osc_ar(freq + vib) * 0.6;\n        let harm = sin_osc_ar((freq + vib) * 2.0) * 0.15;\n\n        // Breath\n        let breath = bpf_ar(pink_noise_ar(), freq * 2.0, 0.6) * 0.15;\n\n        let sig = body + harm + breath;\n\n        sig * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/tin_whistle.vibe",
    "categoryName": "World"
  },
  {
    "name": "ukulele",
    "description": "Small, bright, cheerful plucked string",
    "genre": "",
    "character": "Small, bright, cheerful plucked string",
    "params": [],
    "type": "synthdef",
    "source": "// Region: Hawaiian | Character: Small, bright, cheerful plucked string\ndefine_synthdef(\"ukulele\")\n    .param(\"freq\", 440.0)\n    .param(\"amp\", 0.5)\n    .param(\"gate\", 1.0)\n    .body(|freq, amp, gate| {\n        let env = envelope()\n            .asr(0.001, 1.0, 0.1)\n            .gate(gate)\n            .cleanup_on_finish()\n            .build();\n\n        // Nylon string character - softer attack\n        let pluck_env = envelope()\n            .perc(0.002, 0.04)\n            .build();\n        let exciter = lpf_ar(pink_noise_ar(), 4000.0) * pluck_env * 0.3;\n\n        // Warm harmonics\n        let str1 = sin_osc_ar(freq) * 0.5;\n        let str2 = sin_osc_ar(freq * 2.0) * 0.25;\n        let str3 = sin_osc_ar(freq * 3.0) * 0.1;\n\n        let sig = str1 + str2 + str3 + exciter;\n\n        // Small body resonance - warm and bright\n        let body = bpf_ar(sig, 500.0, 0.2) * 0.3;\n        let output = sig + body;\n\n        output * env * amp\n    });\n",
    "category": "world",
    "subcategory": "",
    "path": "world/ukulele.vibe",
    "categoryName": "World"
  }
];

// Get subcategories for a category
export function getSubcategories(category) {
  const catData = stdlibData[category];
  if (!catData) return [];
  return Object.keys(catData.subcategories).sort();
}

export function StdlibDocs({ searchTerm = '', selectedCategory = 'all', expandedItem, onCardToggle }) {
  // Parse category/subcategory from selectedCategory (e.g., "Bass/Acid")
  const [mainCategory, selectedSubcategory] = selectedCategory.includes('/')
    ? selectedCategory.split('/')
    : [selectedCategory, null];

  // When searching, always search all categories
  const filteredCategories = (searchTerm || selectedCategory === 'all')
    ? stdlibCategories
    : stdlibCategories.filter(c => c === mainCategory);

  return (
    <div className="stdlib-docs">
      {filteredCategories.map(category => {
        const catData = stdlibData[category];

        // Filter items based on search
        const filterItems = (items) => {
          if (!searchTerm) return items;
          const term = searchTerm.toLowerCase();
          return items.filter(item =>
            item.name.toLowerCase().includes(term) ||
            (item.description && item.description.toLowerCase().includes(term)) ||
            (item.genre && item.genre.toLowerCase().includes(term))
          );
        };

        // If a subcategory is selected, only show items from that subcategory
        let filteredItems = [];
        let filteredSubs = {};
        let hasAnyResults = false;

        if (selectedSubcategory) {
          // Only show the selected subcategory
          const subItems = catData.subcategories[selectedSubcategory];
          if (subItems) {
            const filtered = filterItems(subItems);
            if (filtered.length > 0) {
              filteredSubs[selectedSubcategory] = filtered;
              hasAnyResults = true;
            }
          }
        } else {
          // Show all items in category
          filteredItems = filterItems(catData.items);
          hasAnyResults = filteredItems.length > 0;

          for (const [subName, subItems] of Object.entries(catData.subcategories)) {
            const filtered = filterItems(subItems);
            if (filtered.length > 0) {
              filteredSubs[subName] = filtered;
              hasAnyResults = true;
            }
          }
        }

        if (!hasAnyResults) return null;

        return (
          <div key={category} className="stdlib-category">
            <h3 className="stdlib-category__title">
              {selectedSubcategory ? category + ' / ' + selectedSubcategory : category}
            </h3>

            {/* Top-level items (no subcategory) */}
            {filteredItems.length > 0 && (
              <div className="stdlib-category__list">
                {filteredItems.map(item => (
                  <StdlibCard
                    key={item.name}
                    item={item}
                    isExpanded={expandedItem === item.name}
                    onToggle={() => onCardToggle(item.name)}
                  />
                ))}
              </div>
            )}

            {/* Subcategories */}
            {Object.entries(filteredSubs).map(([subName, items]) => (
              <div key={subName} className="stdlib-subcategory">
                {!selectedSubcategory && <h4 className="stdlib-subcategory__title">{subName}</h4>}
                <div className="stdlib-subcategory__list">
                  {items.map(item => (
                    <StdlibCard
                      key={item.name}
                      item={item}
                      isExpanded={expandedItem === item.name}
                      onToggle={() => onCardToggle(item.name)}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}

function StdlibCard({ item, isExpanded, onToggle }) {
  const [showUsage, setShowUsage] = React.useState(false);
  const [showSource, setShowSource] = React.useState(false);

  // Reset collapsible sections when card is collapsed
  React.useEffect(() => {
    if (!isExpanded) {
      setShowUsage(false);
      setShowSource(false);
    }
  }, [isExpanded]);

  // Generate usage example based on type
  const getUsageExample = () => {
    const importLine = 'import "stdlib/' + item.path + '";';

    if (item.type === 'fx') {
      // Effect usage example - use fx().synth().param().apply() syntax
      const paramCalls = item.params && item.params.length > 0
        ? item.params.map(p => '    .param("' + p.name + '", ' + p.default + ')').join('\n')
        : '    .param("mix", 0.3)';

      return importLine + '\n\n' +
        '// Add effect to group\n' +
        'fx("my_' + item.name.split('_')[0] + '")\n' +
        '    .synth("' + item.name + '")\n' +
        paramCalls + '\n' +
        '    .apply();';
    } else {
      // Synthdef usage example - include set_param for each parameter (except gate)
      const paramCalls = item.params && item.params.length > 0
        ? item.params
            .filter(p => p.name !== 'gate')
            .map(p => '    .set_param("' + p.name + '", ' + p.default + ')')
            .join('\n')
        : '';

      return importLine + '\n\n' +
        '// Create a voice\n' +
        'let v = voice("my_' + item.category + '")\n' +
        '    .synth("' + item.name + '")' + (paramCalls ? '\n' + paramCalls : '') + ';\n\n' +
        '// Trigger it\n' +
        'v.trigger();';
    }
  };

  return (
    <div className={`stdlib-card ${isExpanded ? 'stdlib-card--expanded' : ''}`} data-item-name={item.name}>
      <div className="stdlib-card__header" onClick={onToggle}>
        <div className="stdlib-card__title-row">
          <span className="stdlib-card__name">{item.name}</span>
          <span className={`stdlib-card__type stdlib-card__type--${item.type}`}>
            {item.type}
          </span>
        </div>
        {item.genre && <span className="stdlib-card__genre">{item.genre}</span>}
        <p className="stdlib-card__description">{item.description}</p>
        <span className="stdlib-card__expand-icon">{isExpanded ? '−' : '+'}</span>
      </div>

      {isExpanded && (
        <div className="stdlib-card__details">
          {/* Parameters - shown by default (gate parameter is filtered out) */}
          {item.params && item.params.filter(p => p.name !== 'gate').length > 0 && (
            <div className="stdlib-card__params-section">
              <h5>Parameters</h5>
              <table className="stdlib-card__params">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Default</th>
                  </tr>
                </thead>
                <tbody>
                  {item.params.filter(p => p.name !== 'gate').map(param => (
                    <tr key={param.name}>
                      <td className="stdlib-card__param-name">{param.name}</td>
                      <td className="stdlib-card__param-default">{param.default}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Usage - collapsed by default */}
          <div className="stdlib-card__collapsible-section">
            <button
              className="stdlib-card__section-toggle"
              onClick={(e) => { e.stopPropagation(); setShowUsage(!showUsage); }}
            >
              {showUsage ? '▾ Hide Usage' : '▸ View Usage'}
            </button>
            {showUsage && (
              <pre className="stdlib-card__code"><code>{highlightCode(getUsageExample())}</code></pre>
            )}
          </div>

          {/* Source - collapsed by default */}
          {item.source && (
            <div className="stdlib-card__collapsible-section">
              <button
                className="stdlib-card__section-toggle"
                onClick={(e) => { e.stopPropagation(); setShowSource(!showSource); }}
              >
                {showSource ? '▾ Hide Source' : '▸ View Source'}
              </button>
              {showSource && (
                <pre className="stdlib-card__code stdlib-card__code--source"><code>{highlightCode(item.source)}</code></pre>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default StdlibDocs;
